webpackJsonp([15],{

/***/ "++Vo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relatorio_vue__ = __webpack_require__("qWtj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114152d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Relatorio_vue__ = __webpack_require__("SQXM");
function injectStyle (ssrContext) {
  __webpack_require__("Upub")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-114152d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relatorio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114152d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Relatorio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+6jN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+8Yl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.fields.route}},[_c('div',{staticClass:"card-emendas bg form-group",style:({
      backgroundImage:
        'url(' + __webpack_require__("U9j/")("./" + (_vm.fields.icon)) + ')'
    })},[_c('div',{staticClass:"context"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.fields.nome))]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.fields.percentual + '%'})})]),_vm._v(" "),_c('span',{staticClass:"percentual-text"},[_vm._v(_vm._s(_vm.fields.percentual)+"% Concluído")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+FX6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/17.66bcb83.jpg";

/***/ }),

/***/ "+Mmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTablePublic_vue__ = __webpack_require__("lN6u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_470efc07_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTablePublic_vue__ = __webpack_require__("PO1H");
function injectStyle (ssrContext) {
  __webpack_require__("DcfH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-470efc07"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTablePublic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_470efc07_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTablePublic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+PuP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unidades_vue__ = __webpack_require__("lHdj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3995394c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unidades_vue__ = __webpack_require__("kBtK");
function injectStyle (ssrContext) {
  __webpack_require__("8/cP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3995394c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Unidades_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3995394c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Unidades_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+gXo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards-secretaria"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 secretarias"},_vm._l((_vm.secretarias),function(ref){
var isAutarquia = ref.isAutarquia;
var codigo = ref.codigo;
var nome = ref.nome;
return _c('div',{key:codigo,staticClass:"card-secretaria"},[_c('router-link',{attrs:{"to":{
            name: 'listar_dados_secretaria',
            query: isAutarquia ? { autarquias: codigo } : { secretarias: codigo }
          }}},[_c('div',{staticClass:"paragrafo"},[_c('p',{staticClass:"text-lg"},[_vm._v("\n              "+_vm._s(nome)+"\n            ")]),_vm._v(" "),(nome === 'Todas as Metas')?_c('div',[_c('img',{staticClass:"imgPMS",attrs:{"src":_vm.logo,"alt":'imagem representando todas as metas'}})]):_c('hr')])])],1)}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Dados por Secretaria Municipal")]),_vm._v(" "),_c('p',[_vm._v("\n        Você também pode visualizar os dados por secretaria. Basta acessá-los\n        pelos cards abaixo:\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+iMQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__ = __webpack_require__("vQyN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2656ab87_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__ = __webpack_require__("m3VM");
function injectStyle (ssrContext) {
  __webpack_require__("3H75")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2656ab87"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2656ab87_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+j0S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+jtw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_planogoverno_SideAcao_vue__ = __webpack_require__("WgxL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Datepicker__ = __webpack_require__("eOZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SelectFuncionario__ = __webpack_require__("JrGC");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'compromisso-acoes-edit',
    props: ['id'],
    inject: ["showConfirm"],
    components: {
        datepicker: __WEBPACK_IMPORTED_MODULE_7__components_common_Datepicker__["a" /* default */],
        SelectFuncionario: __WEBPACK_IMPORTED_MODULE_8__components_SelectFuncionario__["a" /* default */],
        SideAcao: __WEBPACK_IMPORTED_MODULE_5__components_planogoverno_SideAcao_vue__["a" /* default */]
    },
    data: function data() {
        return {
            listas: {
                secretarias: [],
                autarquias: [],
                ordensExistentes: []
            },
            compromisso: {},
            model: {
                id: null,
                compromisso_id: null,
                unidade: '',
                nome_unidade: '',
                sshd_responsavel: '',
                user_sshd: '',
                ordem: null,
                descritivo: '',
                data_estimada_inicio: null,
                data_inicio: null,
                data_estimada_conclusao: null,
                data_conclusao: null,
                status: '',
                justificativa_criacao: '',
                justificativa_rejeicao: ''
            },
            sideConfig: [{
                titulo: 'Confirmar Ordem',
                subtitulo: '',
                subtDetalhe: '',
                largura: 500,
                identidade: 'reordenar',
                abreProximo: false,
                aberto: false,
                data: null
            }]
        };
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getAcaoData();

                        case 2:
                            _this.loadUnidades();
                            _this.loadUser();

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    computed: {
        isUpdate: function isUpdate() {
            return this.model.hasOwnProperty('codigo');
        },
        isAdd: function isAdd() {
            return !this.isUpdate;
        },
        urlToSave: function urlToSave() {
            return this.isUpdate ? 'planogoverno/update' : 'planogoverno/add';
        }
    },
    methods: {
        saveSuccess: function saveSuccess(result) {
            this.$router.back();
            this.$toastr.s('A ação foi salva com sucesso.');
        },
        saveFail: function saveFail(result) {
            this.$toastr.e('Houve uma falha ao tentar salvar este item.');
        },
        getOrdensExistentes: function getOrdensExistentes() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, data, status;

                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.model.compromisso_id) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _context2.prev = 2;
                                _context2.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('planogoverno/compromisso-acao?compromisso_id=' + _this2.model.compromisso_id + '&all=true');

                            case 5:
                                _ref = _context2.sent;
                                data = _ref.data;
                                status = _ref.status;

                                if (status === 200) {
                                    _this2.listas.ordensExistentes = data.map(function (acao) {
                                        return {
                                            id: acao.id,
                                            ordem: acao.ordem
                                        };
                                    });
                                } else {
                                    _this2.$toastr.e('Erro ao carregar ordens existentes.');
                                }
                                _context2.next = 15;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2['catch'](2);

                                console.error('Erro ao buscar ordens existentes:', _context2.t0);
                                _this2.$toastr.e('Erro ao buscar ordens existentes.');

                            case 15:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 11]]);
            }))();
        },
        validar: function validar() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var isValid, campoComErro, msg, ordemNumerica, ordemExistes, painel;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this3.$validator.validateAll();

                            case 2:
                                isValid = _context3.sent;

                                if (isValid) {
                                    _context3.next = 9;
                                    break;
                                }

                                campoComErro = _this3.$validator.errors.items[0].field;


                                if (campoComErro === 'sshd_responsavel') {
                                    _this3.$refs.SelectFuncionario.$el.querySelector('input').focus();
                                } else {
                                    _this3.$refs[campoComErro].focus();
                                }

                                msg = _this3.$validator.errors.items[0].msg;

                                _this3.$toastr.e(msg);
                                return _context3.abrupt('return');

                            case 9:
                                ordemNumerica = parseInt(_this3.model.ordem, 10);
                                ordemExistes = _this3.listas.ordensExistentes.some(function (o) {
                                    return o.ordem === ordemNumerica && o.id !== _this3.model.id;
                                });


                                if (ordemExistes) {
                                    painel = _this3.sideConfig.find(function (p) {
                                        return p.identidade === 'reordenar';
                                    });

                                    painel.data = { ordem: _this3.model.ordem };
                                    _this3.$refs.side.$emit('abreModal', 'reordenar');
                                } else {
                                    _this3.save();
                                }

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        save: function save() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.$refs.side.$emit('fechaModal', 'reordenar');

                                if (!(_this4.compromisso.unidade_executora !== _this4.model.unidade)) {
                                    _context4.next = 6;
                                    break;
                                }

                                _this4.model.data_estimada_inicio = null;
                                _this4.model.data_estimada_conclusao = null;
                                _context4.next = 13;
                                break;

                            case 6:
                                _this4.model.justificativa_criacao = null;

                                if (_this4.validateDates()) {
                                    _context4.next = 9;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 9:

                                if (_this4.model.data_estimada_inicio) {
                                    _this4.model.data_estimada_inicio = _this4.formatDate(new Date(_this4.model.data_estimada_inicio));
                                }
                                if (_this4.model.data_estimada_conclusao) {
                                    _this4.model.data_estimada_conclusao = _this4.formatDate(new Date(_this4.model.data_estimada_conclusao));
                                }
                                if (_this4.model.data_inicio) {
                                    _this4.model.data_inicio = _this4.formatDate(new Date(_this4.model.data_estimada_inicio));
                                }
                                if (_this4.model.data_conclusao) {
                                    _this4.model.data_conclusao = _this4.formatDate(new Date(_this4.model.data_estimada_conclusao));
                                }

                            case 13:
                                _context4.prev = 13;
                                _context4.next = 16;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].put('planogoverno/compromisso-acao/' + _this4.model.id, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this4.model));

                            case 16:
                                response = _context4.sent;

                                if (!(response.status !== 200)) {
                                    _context4.next = 19;
                                    break;
                                }

                                return _context4.abrupt('return', _this4.saveFail());

                            case 19:
                                return _context4.abrupt('return', _this4.saveSuccess());

                            case 22:
                                _context4.prev = 22;
                                _context4.t0 = _context4['catch'](13);

                                console.error('Houve uma falha ao tentar alterar a ação: ', _context4.t0.response ? _context4.t0.response.data : _context4.t0.message);
                                return _context4.abrupt('return', _this4.saveFail());

                            case 26:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4, [[13, 22]]);
            }))();
        },
        validateDates: function validateDates() {
            if (this.model.data_estimada_inicio && this.model.data_estimada_conclusao) {
                var inicio = new Date(this.model.data_estimada_inicio);
                var termino = new Date(this.model.data_estimada_conclusao);
                if (termino < inicio) {
                    this.$toastr.e("A data prevista de conclusão não pode ser menor que a data de início");
                    return false;
                }
            }
            return true;
        },
        formatDate: function formatDate(date) {
            var year = date.getFullYear();
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var day = ('0' + date.getDate()).slice(-2);
            var hour = ('0' + date.getHours()).slice(-2);
            var minute = ('0' + date.getMinutes()).slice(-2);
            var second = ('0' + date.getSeconds()).slice(-2);

            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
        },
        getCompromissoData: function getCompromissoData() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var _ref2, data;

                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.prev = 0;
                                _context5.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('planogoverno/compromisso/' + _this5.model.compromisso_id);

                            case 3:
                                _ref2 = _context5.sent;
                                data = _ref2.data;

                                _this5.compromisso = data;
                                _context5.next = 12;
                                break;

                            case 8:
                                _context5.prev = 8;
                                _context5.t0 = _context5['catch'](0);

                                console.error("Erro ao buscar compromisso:", _context5.t0);
                                _this5.$toastr.e('Erro ao carregar os dados do compromisso.');

                            case 12:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5, [[0, 8]]);
            }))();
        },
        getAcaoData: function getAcaoData() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var _ref3, data, _data$data_estimada_c, _data$data_estimada_c2, dia, mes, ano, _data$data_estimada_i, _data$data_estimada_i2, _dia, _mes, _ano;

                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('planogoverno/compromisso-acao/' + _this6.id);

                            case 2:
                                _ref3 = _context6.sent;
                                data = _ref3.data;


                                if (data.data_estimada_conclusao) {
                                    _data$data_estimada_c = data.data_estimada_conclusao.split('/'), _data$data_estimada_c2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_data$data_estimada_c, 3), dia = _data$data_estimada_c2[0], mes = _data$data_estimada_c2[1], ano = _data$data_estimada_c2[2];

                                    data.data_estimada_conclusao = new Date(ano, mes - 1, dia);
                                }
                                if (data.data_estimada_inicio) {
                                    _data$data_estimada_i = data.data_estimada_inicio.split('/'), _data$data_estimada_i2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_data$data_estimada_i, 3), _dia = _data$data_estimada_i2[0], _mes = _data$data_estimada_i2[1], _ano = _data$data_estimada_i2[2];

                                    data.data_estimada_inicio = new Date(_ano, _mes - 1, _dia);
                                }

                                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this6.model, data);

                                _context6.next = 9;
                                return _this6.getCompromissoData();

                            case 9:
                                _context6.next = 11;
                                return _this6.getOrdensExistentes();

                            case 11:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },
        loadUnidades: function loadUnidades() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var _ref4, secretarias, _ref5, autarquias;

                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('listar-secretarias');

                            case 2:
                                _ref4 = _context7.sent;
                                secretarias = _ref4.data.data;
                                _context7.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('listar-autarquias');

                            case 6:
                                _ref5 = _context7.sent;
                                autarquias = _ref5.data.data;


                                _this7.listas.secretarias = secretarias;
                                _this7.listas.autarquias = autarquias;

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7);
            }))();
        },
        loadUser: function loadUser() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (_this8.$store.state.user.username) {
                                    _this8.model.user_sshd = _this8.$store.state.user.username;
                                } else {
                                    _this8.$toastr.e('Houve um erro ao tentar carregar o sshd do usuário!');
                                }

                            case 1:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this8);
            }))();
        }
    }
});

/***/ }),

/***/ "+rr4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+x5m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'painel',
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  data: function data() {
    return {
      dadosModerar: 0
    };
  },
  created: function created() {
    this.loadModeracao();
  },

  methods: {
    loadModeracao: function loadModeracao() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, status, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('moderacao?count=true');

              case 2:
                _ref = _context.sent;
                status = _ref.status;
                data = _ref.data;

                if (!(status !== 200)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', _this.$toastr.e('Não foi possivel carregar o total de moderações de dados!'));

              case 7:

                _this.dadosModerar = data;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),

/***/ "+y89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Meus Compromissos")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"api-url":"planogoverno/compromisso-profile","report-title":"Meus Compromissos","fields":_vm.fields,"initial-page":1,"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [(props.rowData.justificativa_cancelamento && props.rowData.status !== 'Cancelado')?_c('div',[_c('p',[_vm._v("Pedido de cancelamento pendente.")])]):_c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Informações","type":"button"},on:{"click":function($event){return _vm.info(props.rowData)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'info'}})],1),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ 
                                name: 'admin_planogoverno_details', 
                                params: { id: props.rowData.id }
                            }}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'search'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Homologar","type":"button","disabled":props.rowData.status !== 'Em andamento'
                                || props.rowData.status === 'Concluído'
                                || props.rowData.status === 'Cancelado'
                                || props.rowData.status === 'Rejeitada'},on:{"click":function($event){return _vm.homologar(props.rowData)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'check'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Cancelar","type":"button","disabled":props.rowData.status === 'Cancelado'
                                || props.rowData.status === 'Rejeitada' 
                                || props.rowData.status === 'Concluído'
                                || props.rowData.qtd_cancelamento === 3},on:{"click":function($event){return _vm.cancelar(props.rowData)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'times'}})],1)],1)]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font"},[_vm._v("Período")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.periodo),expression:"filtros.periodo"}],staticClass:"form-control select-selected",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "periodo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.periodos),function(value,index){return _c('option',{key:index,domProps:{"value":value}},[_vm._v("\n                                    "+_vm._s(value)+"\n                                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font"},[_vm._v("Status")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.status),expression:"filtros.status"}],staticClass:"form-control select-selected",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.status),function(value,index){return _c('option',{key:index,domProps:{"value":value}},[_vm._v("\n                                    "+_vm._s(value)+"\n                                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4",staticStyle:{"padding-top":"15px"}},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.$refs.vuetable.refresh()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                                Filtrar\n                            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.resetFiltros()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                                Limpar Filtros\n                            ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n                    ")],1)])],2)],1),_vm._v(" "),_c('SidePlanoGoverno',{ref:"side",attrs:{"navs":_vm.sideConfig},on:{"homologar":_vm.homologarCompromisso,"cancelar":_vm.cancelarCompromisso,"fechaModal":_vm.fecharSideModal}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+zAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("5qSO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b087fbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("5t6a");
function injectStyle (ssrContext) {
  __webpack_require__("KOBN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b087fbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b087fbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/+SG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "//wV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-5 pad-left-0 search-margin-left"},[_c('label',{staticClass:"custom-font",attrs:{"for":"usuario"}},[_vm._v("Pesquise por unidade ou nome")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termoPesquisa),expression:"termoPesquisa"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.termoPesquisa)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.consultar.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.termoPesquisa=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.consultar}},[_c('font-awesome-icon',{attrs:{"icon":'search'}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Perfis e unidades","fields":_vm.fields,"dados":_vm.acessos,"report-title":"Perfis e Unidades"},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('ul',[_c('li',[_c('span',{staticClass:"usuarios-titulo"},[_vm._v("Nome")]),_vm._v(" "),_c('span',{staticClass:"usuarios-titulo"},[_vm._v("Perfil")])]),_vm._v(" "),_vm._l((props.rowData.usuarios),function(user){return _c('li',[_c('span',{staticClass:"usuarios-dados"},[_vm._v(_vm._s(user.nome))]),_vm._v(" "),_c('span',{staticClass:"usuarios-dados"},[_vm._v(_vm._s(user.perfil))])])})],2)]}}])})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/29v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fields: Array
  },
  data: function data() {
    return {
      changedFields: {}
    };
  },

  computed: {
    normalizedFields: function normalizedFields() {
      var visibleFields = this.fields.map(function (field) {
        return !('visible' in field) || field.visible ? (field.visible = true, field) : (field.visible = false, field);
      });
      return visibleFields.map(function (field) {
        return !('showOnVisibilityMenu' in field) || field.showOnVisibilityMenu ? (field.showOnVisibilityMenu = true, field) : (field.showOnVisibilityMenu = false, field);
      });
    },
    fieldsToShowOnMenu: function fieldsToShowOnMenu() {
      if (!this.normalizedFields) return [];

      return this.normalizedFields ? this.normalizedFields.filter(function (field) {
        return field.showOnVisibilityMenu ? true : false;
      }) : [];
    }
  },
  methods: {
    changeVisibility: function changeVisibility(event) {
      var checked = !event.visible;
      var fieldName = event.name;

      this.changedFields = this.normalizedFields.map(function (field) {
        return field.hasOwnProperty('name') && field.name == fieldName ? (field.visible = checked, field) : field;
      });
      this.$emit('update:fields', this.changedFields);
      this.$events.emit('column-visibility:changed');
    }
  }
});

/***/ }),

/***/ "/2wR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.type)+" "+_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"min-height":"95px"}},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('nome') }]},[_c('label',{class:[
                'control-label',
                'custom-font',
                { 'is-danger': _vm.errors.has('nome') }
              ]},[_vm._v("Nome")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('nome') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome",staticClass:"form-control",attrs:{"name":"nome","placeholder":"Nome","maxlength":"255","type":"text"},domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                    'input-group-addon custom-input-group-addon-count',
                    { 'is-danger': _vm.errors.has('nome') }
                  ],domProps:{"textContent":_vm._s(255 - _vm.model.nome.length)}})]),_vm._v(" "),(_vm.errors.has('nome'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"nome"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                Preenchimento obrigatório!\n              ")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"min-height":"95px"}},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('descricao') }]},[_c('label',{class:[
                'control-label',
                'custom-font',
                { 'is-danger': _vm.errors.has('descricao') }
              ]},[_vm._v("Descrição")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('descricao') }],attrs:{"icon":'tags'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"descricao",staticClass:"form-control",attrs:{"rows":"3","name":"descricao","placeholder":"Descrição","maxlength":"255"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                    'input-group-addon custom-input-group-addon-count',
                    { 'is-danger': _vm.errors.has('descricao') }
                  ],domProps:{"textContent":_vm._s(255 - _vm.model.descricao.length)}})]),_vm._v(" "),(_vm.errors.has('descricao'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"descricao"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                Preenchimento obrigatório!")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('fonte') }]},[_c('label',{class:[
                'control-label',
                'custom-font',
                { 'is-danger': _vm.errors.has('fonte') }
              ]},[_vm._v("Fonte")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('fonte') }],attrs:{"icon":'envelope'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fonte),expression:"model.fonte"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"fonte",staticClass:"form-control",attrs:{"name":"fonte","placeholder":"Fonte","maxlength":"255","type":"text"},domProps:{"value":(_vm.model.fonte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "fonte", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                    'input-group-addon custom-input-group-addon-count',
                    { 'is-danger': _vm.errors.has('fonte') }
                  ],domProps:{"textContent":_vm._s(255 - _vm.model.fonte.length)}})]),_vm._v(" "),(_vm.errors.has('fonte'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"fonte"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                Preenchimento obrigatório!")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('div',{class:[
              'form-group',
              { 'has-error': _vm.errors.has('periodicidade') }
            ]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Periodicidade")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.periodicidade),expression:"model.periodicidade"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"periodicidade",staticClass:"form-control select-selected",attrs:{"name":"periodicidade"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "periodicidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.lista.periodicidades),function(p){return _c('option',{key:p.codigo,domProps:{"value":p.codigo}},[_vm._v("\n                  "+_vm._s(p.descricao)+"\n                ")])}),0)]),_vm._v(" "),(_vm.errors.has('periodicidade'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"periodicidade"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n              Preenchimento obrigatório!")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"custom-font"},[_vm._v("Tipo de valor do dado")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',{staticClass:"custom-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tipoValor),expression:"model.tipoValor"}],attrs:{"type":"radio","name":"tipovalor","value":"I","checked":""},domProps:{"checked":_vm._q(_vm.model.tipoValor,"I")},on:{"change":function($event){return _vm.$set(_vm.model, "tipoValor", "I")}}}),_vm._v("\n                Número inteiro\n              ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',{staticClass:"custom-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tipoValor),expression:"model.tipoValor"}],attrs:{"type":"radio","name":"tipovalor","value":"D"},domProps:{"checked":_vm._q(_vm.model.tipoValor,"D")},on:{"change":function($event){return _vm.$set(_vm.model, "tipoValor", "D")}}}),_vm._v("\n                Número decimal\n              ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',{staticClass:"custom-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tipoValor),expression:"model.tipoValor"}],attrs:{"type":"radio","name":"tipovalor","value":"T"},domProps:{"checked":_vm._q(_vm.model.tipoValor,"T")},on:{"change":function($event){return _vm.$set(_vm.model, "tipoValor", "T")}}}),_vm._v("\n                Texto\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Tags")]),_vm._v(" "),_c('div',{staticClass:"list-group"},_vm._l((_vm.lista.tags),function(t){return _c('a',{key:t.codigo,class:[
                'list-group-item col-md-3 custom-meta',
                { 'item-selected': t.selected }
              ],attrs:{"href":"javascript:void  (0)"},on:{"click":function($event){$event.preventDefault();return _vm.toogleshow(t)}}},[_c('font-awesome-icon',{attrs:{"icon":'tags'}}),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("\n                "+_vm._s(t.descricao)+"\n              ")])],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Secretarias")]),_vm._v(" "),_c('div',{staticClass:"list-group"},_vm._l((_vm.lista.secretarias),function(s){return _c('a',{key:s.codigo,class:[
                'list-group-item col-md-2 custom-meta',
                { 'item-selected': s.selected }
              ],attrs:{"href":"javascript:void  (0)"},on:{"click":function($event){$event.preventDefault();return _vm.toogleshow(s)}}},[_c('font-awesome-icon',{attrs:{"icon":'monument'}}),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("\n                "+_vm._s(s.sigla)+"\n              ")])],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Autarquias")]),_vm._v(" "),_c('div',{staticClass:"list-group"},_vm._l((_vm.lista.autarquias),function(a){return _c('a',{key:a.codigo,class:[
                'list-group-item col-md-3 custom-meta',
                { 'item-selected': a.selected }
              ],attrs:{"href":"javascript:void  (0)"},on:{"click":function($event){$event.preventDefault();return _vm.toogleshow(a)}}},[_c('font-awesome-icon',{attrs:{"icon":'monument'}}),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("\n                "+_vm._s(a.sigla)+"\n              ")])],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Eixos")]),_vm._v(" "),_c('div',{staticClass:"list-group"},_vm._l((_vm.lista.eixos),function(i){return _c('a',{key:i.id,class:[
                'list-group-item col-md-6 custom-meta',
                { 'item-selected': i.selected }
              ],attrs:{"href":"javascript:void  (0)"},on:{"click":function($event){$event.preventDefault();return _vm.toogleshow(i)}}},[_c('font-awesome-icon',{attrs:{"icon":'monument'}}),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("\n                "+_vm._s(i.descricao)+"\n              ")])],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Metas")]),_vm._v(" "),_c('div',{staticClass:"list-group"},_vm._l((_vm.lista.metas),function(i){return _c('a',{key:i.codigo,class:[
                'pad10 list-group-item col-md-2 custom-meta',
                { 'item-selected': i.selected }
              ],staticStyle:{"padding":"10px","text-align":"center"},attrs:{"href":"javascript:void  (0)"},on:{"click":function($event){$event.preventDefault();return _vm.toogleshow(i)}}},[_c('img',{staticStyle:{"max-width":"129px","max-height":"129px"},attrs:{"alt":i.titulo,"src":_vm.concatPathImage(i.imagem_url)}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Usuários")]),_vm._v(" "),_c('autocomplete',{attrs:{"id":"usuario","name":"usuario","classNameInput":"form-control","placeholder":"Localizar usuários","urlsource":"user/list/all","propsource":"data","item_key":"codigo","item_text":"username","onSetData":_vm.selecionarUsuario}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Usuários com permissão para registrar valores")]),_vm._v(" "),_c('div',{staticClass:"list-group well",staticStyle:{"overflow":"auto"}},_vm._l((_vm.lista.usuarios),function(u,index){return _c('div',{key:u.id,staticClass:"list-group-item col-md-4",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){$event.preventDefault();return _vm.toogleshow(u)}}},[_c('font-awesome-icon',{attrs:{"icon":'user'}}),_vm._v("\n              "+_vm._s(u.username)+" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted small"},[_c('em',[_vm._v(_vm._s(u.email))])]),_vm._v(" "),_c('button',{staticClass:"close",staticStyle:{"margin-top":"-10px"},attrs:{"type":"button","aria-hidden":"true"},on:{"click":function($event){$event.preventDefault();return _vm.removerUsuario(index)}}},[_vm._v("\n                ×\n              ")])],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"30px"}},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){$event.preventDefault();return _vm.salvar()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n            Salvar\n          ")],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/3wm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LogoPMS_old.4306d5a.svg";

/***/ }),

/***/ "/6fP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emendas_parlamentares; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__("3WfR");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__types__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__types__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__types__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__types__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("q8VL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("rU1H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("ASSw");





var emendas_parlamentares = {
  state: function state() {
    return {
      ano: new Date().getFullYear(),
      emendas: [],
      loading: false
    };
  },
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* getters */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* mutations */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */]
};

/***/ }),

/***/ "/7+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return materiais; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_materiais_padronizados__ = __webpack_require__("dRze");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_materiais_padronizados_Save__ = __webpack_require__("PCOT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_materiais_padronizados_medida__ = __webpack_require__("vVbp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_admin_materiais_padronizados_medida_Save__ = __webpack_require__("+zAa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_admin_materiais_padronizados_grupo__ = __webpack_require__("vwEd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_admin_materiais_padronizados_grupo_Save__ = __webpack_require__("pZly");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_admin_materiais_padronizados_subgrupo__ = __webpack_require__("NBO3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_admin_materiais_padronizados_subgrupo_Save__ = __webpack_require__("ETK1");









var materiais = [{
  name: 'user_material',
  path: 'material/list',
  component: __WEBPACK_IMPORTED_MODULE_0__views_admin_materiais_padronizados__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_material_save',
  path: 'material/save/:id?',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin_materiais_padronizados_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_material_medida',
  path: 'material/medida/list',
  component: __WEBPACK_IMPORTED_MODULE_2__views_admin_materiais_padronizados_medida__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_material_medida_save',
  path: 'material/medida/save/:id?',
  component: __WEBPACK_IMPORTED_MODULE_3__views_admin_materiais_padronizados_medida_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_material_grupo',
  path: 'material/grupo/list',
  component: __WEBPACK_IMPORTED_MODULE_4__views_admin_materiais_padronizados_grupo__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_material_grupo_save',
  path: 'material/grupo/save/:id?',
  component: __WEBPACK_IMPORTED_MODULE_5__views_admin_materiais_padronizados_grupo_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_material_subgrupo',
  path: 'material/subgrupo/list',
  component: __WEBPACK_IMPORTED_MODULE_6__views_admin_materiais_padronizados_subgrupo__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_material_subgrupo_save',
  path: 'material/subgrupo/save/:id?',
  component: __WEBPACK_IMPORTED_MODULE_7__views_admin_materiais_padronizados_subgrupo_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}];

/***/ }),

/***/ "/829":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/AuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('public-header',{attrs:{"title":'Meus Favoritos'}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n        Abaixo você encontra os seus dados favoritados.\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"container favoritos"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',[_vm._v("Favoritos")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.favoritos),function(favorito){return _c('div',{key:favorito.codigo,staticClass:"col-xs-12 col-md-6 linha-detalhe"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-9"},[_c('p',[_vm._v(_vm._s(favorito.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3 text-left"},[(_vm.permitirComparativo(favorito))?_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Comparar valores"},on:{"click":function($event){return _vm.adicionarComparativo(favorito.codigo, favorito.nome)}}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}})],1):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Listar valores","to":{
                name: 'public_detalhes',
                params: { id: favorito.codigo }
              }}},[_c('font-awesome-icon',{attrs:{"icon":'chart-bar'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.removerFavorito(favorito)}}},[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1)],1)])])})],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[(_vm.dados.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Dados")]),_vm._v(" "),_vm._l((_vm.dados),function(item,index){return _c('p',{key:index},[_vm._v("\n            "+_vm._s(item.nome)+" -\n            "),_c('font-awesome-icon',{style:({ color: _vm.cores[index] }),attrs:{"icon":'square'}}),_vm._v(" "),_c('a',{attrs:{"role":"button","title":"remover este item do comparativo"},on:{"click":function($event){return _vm.removerComparativo(index)}}},[_c('font-awesome-icon',{style:({ color: '#d9534f' }),attrs:{"icon":'trash-alt'}})],1)],1)}),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoGrafico),expression:"tipoGrafico"}],attrs:{"type":"radio","value":"bar","name":"radiograph","checked":""},domProps:{"checked":_vm._q(_vm.tipoGrafico,"bar")},on:{"change":function($event){_vm.tipoGrafico="bar"}}}),_vm._v("Gráfico de barras")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoGrafico),expression:"tipoGrafico"}],attrs:{"type":"radio","value":"line","name":"radiograph"},domProps:{"checked":_vm._q(_vm.tipoGrafico,"line")},on:{"change":function($event){_vm.tipoGrafico="line"}}}),_vm._v("Gráfico de linhas")])])],2),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.tipoGrafico === 'bar')?_c('bar-chart',{ref:"graph_barra",attrs:{"css-classes":'chart-container',"chart-data":_vm.dados_grafico,"gradiente":false,"options":{
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              dataset: {
                maxBarThickness: 50,
                backgroundColor: _vm.cores
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      suggestedMax: 50
                    }
                  }
                ]
              }
            }}}):_vm._e(),_vm._v(" "),(_vm.tipoGrafico === 'line')?_c('line-chart',{ref:"graph_linha",attrs:{"css-classes":'chart-container',"chart-data":_vm.dados_grafico,"gradiente":false,"coloredLine":true,"options":{
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              dataset: {
                maxBarThickness: 50,
                backgroundColor: _vm.cores
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      suggestedMax: 50
                    }
                  }
                ]
              },
              elements: {
                line: {
                  fill: false,
                  borderWidth: 4
                },
                point: {
                  radius: 5,
                  hoverRadius: 6
                }
              }
            }}}):_vm._e()],1)]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"mode":"in-out"}},[(_vm.dados.length > 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Comparativos")]),_vm._v(" "),_vm._l((_vm.dados),function(item,index){return _c('p',{key:index},[_vm._v("\n            "+_vm._s(item.nome)+" - "),_c('b',[_vm._v("Dado "+_vm._s(index + 1))]),_vm._v(" "),_c('a',{attrs:{"role":"button","title":"remover este item do comparativo"},on:{"click":function($event){return _vm.removerComparativo(index)}}},[_c('font-awesome-icon',{style:({ color: '#d9534f' }),attrs:{"icon":'trash-alt'}})],1)])}),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoComparativo),expression:"tipoComparativo"}],attrs:{"type":"radio","value":"soma","name":"radiocomparativo","checked":""},domProps:{"checked":_vm._q(_vm.tipoComparativo,"soma")},on:{"change":function($event){_vm.tipoComparativo="soma"}}}),_vm._v("Soma Simples (Dado 1 + Dado 2 + ... + Dado N)")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoComparativo),expression:"tipoComparativo"}],attrs:{"type":"radio","value":"mediaSimples","name":"radiocomparativo"},domProps:{"checked":_vm._q(_vm.tipoComparativo,"mediaSimples")},on:{"change":function($event){_vm.tipoComparativo="mediaSimples"}}}),_vm._v("Média Simples ((Dado 1 + Dado 2 + ... + Dado N) / N)")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoComparativo),expression:"tipoComparativo"}],attrs:{"type":"radio","value":"mediaAnual","name":"radiocomparativo"},domProps:{"checked":_vm._q(_vm.tipoComparativo,"mediaAnual")},on:{"change":function($event){_vm.tipoComparativo="mediaAnual"}}}),_vm._v("Média Anual ((Ano 1 + Ano 2 + ... + Ano N ) / N)")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoComparativo),expression:"tipoComparativo"}],attrs:{"type":"radio","value":"relacao","name":"radiocomparativo"},domProps:{"checked":_vm._q(_vm.tipoComparativo,"relacao")},on:{"change":function($event){_vm.tipoComparativo="relacao"}}}),_vm._v("Relação (Dado 1 / Dado 2)")])])],2),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('bar-chart',{ref:"grafico_comparativo",attrs:{"css-classes":'chart-container',"chart-data":_vm.dados_comparativos,"gradiente":false,"options":{
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              dataset: {
                maxBarThickness: 50,
                backgroundColor: _vm.cores
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true
                    }
                  }
                ]
              }
            }}})],1)]):_vm._e()])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Comparativos Disponíveis")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/End":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PublicHeader: __WEBPACK_IMPORTED_MODULE_1__components__["a" /* PublicHeader */], Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components__["b" /* Breadcrumb */], ListaCandidatosGeral: __WEBPACK_IMPORTED_MODULE_1__components__["g" /* ListaCandidatosGeral */] },
  created: function created() {
    var secao = this.$route.params.secao;


    if (!secao || !this.votos.length) {
      this.$router.push({ name: 'eleicao_conselho' });
    } else {
      this.secao = secao;
    }
  },
  data: function data() {
    return {
      isLoading: true,
      secao: 0,
      candidato: {
        total_votos: 0
      }
    };
  },

  methods: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])({
    candidatos: function candidatos(_ref) {
      var eleicoes_conselho = _ref.eleicoes_conselho;
      return eleicoes_conselho.candidatos;
    },
    votos: function votos(_ref2) {
      var eleicoes_conselho = _ref2.eleicoes_conselho;
      return eleicoes_conselho.votos;
    }
  }), {
    candidatosSecao: function candidatosSecao() {
      var _this = this;

      var finder = function finder(voto) {
        return voto.secoes_id === _this.dadosSecao.id;
      };
      var result = this.candidatos.map(function (candidato) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, candidato, {
          total_votos: (candidato.votos.find(finder) || { total_votos: 0 }).total_votos
        });
      });

      result.sort(function (a, b) {
        if (a.total_votos < b.total_votos) {
          return 1;
        }

        if (a.total_votos > b.total_votos) {
          return -1;
        }

        var dateA = new Date(a.data_nascimento);
        var dateB = new Date(b.data_nascimento);
        if (dateA > dateB) {
          return 1;
        }

        if (dateA < dateB) {
          return -1;
        }

        return 0;
      });

      return result.map(function (candidato, index) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, candidato, {
          posicao: index + 1
        });
      });
    },
    dadosSecao: function dadosSecao() {
      var _this2 = this;

      var finder = function finder(item) {
        return item.numero === _this2.secao;
      };

      var result = this.votos.find(finder);

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, result);
    },
    breadcrumb: function breadcrumb() {
      return [{
        label: 'Eleições - Conselho Tutelar',
        named_link: { name: 'eleicao_conselho' }
      }, {
        label: 'Se\xE7\xE3o ' + this.secao
      }];
    }
  })
});

/***/ }),

/***/ "/LCp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.exportCSV()}}},[_vm._v("\n  Exportar CSV \n  "),_c('font-awesome-icon',{attrs:{"icon":'file-csv'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/QpF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":"Listagem de dados"}},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        Abaixo você encontra a listagem de dados, baseada no filtro\n        selecionado.\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":[{ label: 'Lista de dados' }]}}),_vm._v(" "),(_vm.filtersAvailable.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('CardsFiltro',{attrs:{"title":'Filtros disponíveis',"metas":_vm.filtersAvailable},on:{"click":_vm.addFilter}})],1)]):_vm._e(),_vm._v(" "),(_vm.filtrosParametro.metas.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('CardsFiltro',{attrs:{"title":'Filtros ativos',"metas":_vm.activeFilterList},on:{"click":_vm.removeFilter}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"input-group filtro-pesquisa"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.termo_pesquisa.codigo),expression:"filtros.termo_pesquisa.codigo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Filtrar pesquisa..."},domProps:{"value":(_vm.filtros.termo_pesquisa.codigo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros.termo_pesquisa, "codigo", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.add('termo_pesquisa', _vm.filtros.termo_pesquisa)}}},[_c('font-awesome-icon',{attrs:{"icon":'search'}})],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"table-responsive"},[_c('data-table-public',{ref:"dt",attrs:{"has-auth":false,"title":"lista de dados","api-url":"listar-dados","show-empty":true,"fields":_vm.model.columns,"append-params":_vm.filtrosParametro},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return _vm._l((props.rowData.metas),function(meta){return _c('img',{key:("minimeta-" + (meta.codigo)),staticClass:"mini-meta",attrs:{"src":("" + _vm.imgUrl + (meta.imagem_url)),"title":meta.titulo,"data-toggle":'popover',"data-content":meta.objetivo,"data-placement":'top',"data-trigger":'hover',"alt":("imagem representando a meta " + (meta.titulo) + " para filtrar a lista")}})})}},{key:"icon",fn:function(props){return [_c('a',{attrs:{"role":"button"},on:{"click":function($event){return _vm.salvarFavorito(props.rowData.codigo)}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.classeFavoritos(props.rowData.codigo)}})],1)]}},{key:"rowrender",fn:function(props){return [_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Listar valores","to":{
                  name: 'public_detalhes',
                  params: { id: props.rowData.codigo }, 
                  query: { origem: 'dados' }
                }}},[_c('font-awesome-icon',{attrs:{"icon":'list-ol'}})],1),_vm._v(" "),(_vm.permitirComparativo(props.rowData))?_c('button',{class:['btn', _vm.classeSelecionados(props.rowData.codigo)],attrs:{"title":"Dado Comparativo","data-toggle":'popover',"data-content":_vm.getPopoverContent(props.rowData.codigo),"data-placement":'top',"data-trigger":'hover'},on:{"click":function($event){return _vm.toggleAddDado(props.rowData.codigo)}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.addDadoState[props.rowData.codigo] ? 'minus' : 'plus'}})],1):_vm._e()]}}])})],1)])])],1),_vm._v(" "),_c('FaixaComparacao',{attrs:{"idsArray":_vm.idsArray,"query":'dados'}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col col-xs-10"},[_c('h3',[_vm._v("Digite sua pesquisa")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col col-xs-10"},[_c('h3',[_vm._v("Lista de Dados")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/VVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('label',[_vm._v("Total de "+_vm._s(_vm.count)+" colaboradores nesta escala")])]),_vm._v(" "),_c('div',{staticClass:"employee-list"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-item"},[_c('pulse-loader'),_vm._v(" "),_c('h5',[_vm._v("carregando os colaboradores...")])],1)]):_vm._l((_vm.value),function(employee,index){return _c('EmployeeItem',{key:employee.id,attrs:{"employee-data":employee},on:{"updateItem":function (item) { return _vm.updateItem(item, index); },"clickClose":function () { return _vm.removeItem(index); }}})})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/ZcS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("IFOm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000e1ee7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GlxV");
function injectStyle (ssrContext) {
  __webpack_require__("VZDn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-000e1ee7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_000e1ee7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/f4+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  name: 'eixos',
  data: function data() {
    return {
      fields: [{
        name: 'EIX_DCEIXO',
        title: 'Nome',
        sortField: 'EIX_DCEIXO',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {},

  methods: {
    editar: function editar(data) {
      this.$router.push({
        name: 'admin_eixos_save',
        params: { id: data.EIX_IDEIXO, name: data.EIX_DCEIXO }
      });
    },
    excluir: function excluir(data) {
      var dt = this.$refs.vuetable;
      data.type = 'EIXO';

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].delete(data, function () {
            dt.refresh();
          }, function () {
            console.log('houve um error ao tentar excluir este item, por favor tente novamente mais tarde!');
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    consultar: function consultar() {
      this.$refs.vuetable.refresh();
    },
    limpar: function limpar() {
      this.EIX_DCEIXO = '';
      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'eixos',
        value: 1
      });
    }
  },
  computed: {
    filtros: function filtros() {
      var EIX_DCEIXO = this.EIX_DCEIXO;

      return {
        EIX_DCEIXO: EIX_DCEIXO
      };
    },

    pagina: {
      get: function get() {
        var eixos = this.$store.state.vuetableState.eixos;
        var pagina = eixos.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'eixos',
          value: value
        });
      }
    },
    EIX_DCEIXO: {
      get: function get() {
        var eixos = this.$store.state.vuetableState.eixos;
        var EIX_DCEIXO = eixos.filtros.EIX_DCEIXO;


        return EIX_DCEIXO;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'EIX_DCEIXO',
          collection: 'eixos',
          value: value
        });
        this.resetPageStore();
      }
    }
  }
});

/***/ }),

/***/ "/heK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Datepicker__ = __webpack_require__("eOZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_regular_svg_icons__ = __webpack_require__("Yu89");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_5__components_common_NoApiTable__["a" /* default */], Datepicker: __WEBPACK_IMPORTED_MODULE_6__components_common_Datepicker__["a" /* default */] },
  inject: ["showConfirm"],
  props: {
    id: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    title: {
      type: String,
      default: function _default() {
        return 'Listagem';
      }
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fullData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isCotas: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      dataBase: '',
      loading: {
        nomear: false,
        empossar: false,
        revogar: false,
        imprimir: false
      },
      hasAllCheckboxOnPage: false,
      lastPageSelected: 1,
      itens: [],
      fields: [{
        name: '__slot:input',
        title: '#',
        dataClass: 'text-center'
      }, {
        name: 'classificacao',
        title: 'Classificação',
        dataClass: 'text-center'
      }, {
        name: 'descricao',
        title: 'Cargo'
      }, {
        name: 'nome',
        title: 'Nome'
      }, {
        name: 'tipo_normal',
        title: 'Geral',
        titleClass: 'text-center',
        dataClass: 'text-center',
        callback: function callback(value) {
          return value === 1 ? 'Sim' : 'Não';
        }
      }, {
        name: 'tipo_pcd',
        title: 'PCD',
        titleClass: 'text-center',
        dataClass: 'text-center',
        callback: function callback(value) {
          return value === 1 ? 'Sim' : 'Não';
        }
      }, {
        name: 'tipo_cotas',
        title: 'Cotas',
        titleClass: 'text-center',
        dataClass: 'text-center',
        callback: function callback(value) {
          return value === 1 ? 'Sim' : 'Não';
        }
      }, {
        name: 'status',
        title: 'Status'
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }]
    };
  },
  mounted: function mounted() {
    this.setItens();
  },

  computed: {
    iconCheck: function iconCheck() {
      return __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_regular_svg_icons__["c" /* faSquare */];
    },
    iconChecked: function iconChecked() {
      return __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_regular_svg_icons__["d" /* faCheckSquare */];
    }
  },
  watch: {
    data: function data(val, oldVal) {
      this.setItens();
    }
  },
  methods: {
    nomear: function nomear(_ref) {
      var _this = this;

      var index = _ref.index,
          id = _ref.id,
          nome = _ref.nome;
      var requestDataInvalid = this.requestDataInvalid,
          dataBase = this.dataBase;


      if (requestDataInvalid()) return;

      var params = { id: id, data_nomeacao: dataBase.toISOString().split('T')[0] };
      var msgSuccess = nome + ' nomeado com sucesso';
      var msgError = 'Houve um erro ao tentar nomear ' + nome + ', tente novamente daqui alguns minutos.';

      this.showConfirm('Tem certeza que deseja nomear ' + nome, {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          return _this.sendRequestUpdate({
            index: index,
            params: params,
            msgSuccess: msgSuccess,
            msgError: msgError,
            type: 'nomear'
          });
        }
      });
    },
    empossar: function empossar(_ref2) {
      var _this2 = this;

      var index = _ref2.index,
          id = _ref2.id,
          nome = _ref2.nome;
      var requestDataInvalid = this.requestDataInvalid,
          dataBase = this.dataBase;


      if (requestDataInvalid()) return;

      var params = {
        id: id,
        data_empossado: dataBase.toISOString().split('T')[0]
      };
      var msgSuccess = nome + ' empossado com sucesso';
      var msgError = 'Houve um erro ao tentar empossar ' + nome + ', tente novamente daqui alguns minutos.';

      this.showConfirm('Tem certeza que deseja empossar ' + nome, {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          return _this2.sendRequestUpdate({
            index: index,
            params: params,
            msgSuccess: msgSuccess,
            msgError: msgError,
            type: 'empossar'
          });
        }
      });
    },
    revogar: function revogar(_ref3) {
      var _this3 = this;

      var index = _ref3.index,
          id = _ref3.id,
          nome = _ref3.nome;
      var requestDataInvalid = this.requestDataInvalid,
          dataBase = this.dataBase;


      if (requestDataInvalid()) return;

      var params = {
        id: id,
        data_revogacao: dataBase.toISOString().split('T')[0]
      };
      var msgSuccess = nome + ' revogado com sucesso';
      var msgError = 'Houve um erro ao tentar revogar ' + nome + ', tente novamente daqui alguns minutos.';

      this.showConfirm('Tem certeza que deseja revogar ' + nome, {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          return _this3.sendRequestUpdate({
            index: index,
            params: params,
            msgSuccess: msgSuccess,
            msgError: msgError,
            type: 'revogar'
          });
        }
      });
    },
    imprimirFichas: function imprimirFichas() {
      var edital_id = this.itens[0].edital_id;

      window.open(__WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].defaults.baseURL + 'habilitado/imprimir-fichas-cotas/' + edital_id, '_blank');
    },
    sendRequestUpdate: function sendRequestUpdate(_ref4) {
      var _this4 = this;

      var index = _ref4.index,
          params = _ref4.params,
          msgSuccess = _ref4.msgSuccess,
          msgError = _ref4.msgError,
          type = _ref4.type;

      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].put('habilitado/' + params.id, params).then(function () {
        _this4.itens[index].status = _this4.getStatus(type);
        _this4.$toastr.s(msgSuccess);
        _this4.toggleProcessingClickEvent(index);
      }).catch(function () {
        return _this4.$toastr.e(msgError);
      }).finally(function () {
        return _this4.toggleProcessingClickEvent(index);
      });
    },
    nomearSelecionados: function nomearSelecionados() {
      var nomes = this.filterItensSelected('Habilitado').map(function (_ref5) {
        var nome = _ref5.nome;
        return nome;
      });

      this.sendRequestUpdateMany({
        action: 'nomear',
        msgSuccess: 'Candidatos nomeados com sucesso',
        msgError: 'Houve um erro ao tentar nomear os candidatos selecionados, tente novamente daqui alguns minutos.',
        confirmTitle: nomes.length + ' candidatos aptos a nomea\xE7\xE3o, confirme para concluir?',
        confirmMsg: nomes.map(function (nome) {
          return '<p>' + nome + '</p>';
        }).join('')
      });
    },
    empossarSelecionados: function empossarSelecionados() {
      var nomes = this.filterItensSelected('Nomeado').map(function (_ref6) {
        var nome = _ref6.nome;
        return nome;
      });

      this.sendRequestUpdateMany({
        action: 'empossar',
        msgSuccess: 'Candidatos empossado com sucesso',
        msgError: 'Houve um erro ao tentar empossar os candidatos selecionados, tente novamente daqui alguns minutos.',
        confirmTitle: nomes.length + ' candidatos aptos a empossamento, confirme para concluir?',
        confirmMsg: nomes.map(function (nome) {
          return '<p>' + nome + '</p>';
        }).join('')
      });
    },
    revogarSelecionados: function revogarSelecionados() {
      var nomes = this.filterItensSelected('Nomeado').map(function (_ref7) {
        var nome = _ref7.nome;
        return nome;
      });

      this.sendRequestUpdateMany({
        action: 'revogar',
        msgSuccess: 'Candidatos revogados com sucesso',
        msgError: 'Houve ao tentar revogar os candidatos selecionados, tente novamente daqui alguns minutos.',
        confirmTitle: nomes.length + ' candidatos aptos a revoga\xE7\xE3o, confirme para concluir?',
        confirmMsg: nomes.map(function (nome) {
          return '<p>' + nome + '</p>';
        }).join('')
      });
    },
    sendRequestUpdateMany: function sendRequestUpdateMany(_ref8) {
      var _this5 = this;

      var action = _ref8.action,
          msgSuccess = _ref8.msgSuccess,
          msgError = _ref8.msgError,
          confirmTitle = _ref8.confirmTitle,
          confirmMsg = _ref8.confirmMsg;
      var requestDataInvalid = this.requestDataInvalid,
          getRequestParams = this.getRequestParams,
          updateStatusRowsSelected = this.updateStatusRowsSelected,
          toggleLoadingActionButton = this.toggleLoadingActionButton,
          showConfirm = this.showConfirm;


      if (requestDataInvalid()) return;

      var requestParams = getRequestParams(action);

      if (!requestParams) {
        this.$toastr.e('Não há candidatos habilitados selecionados!');
        return;
      }

      var success = function success() {
        toggleLoadingActionButton(action);
        __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].put('habilitados', requestParams).then(function () {
          updateStatusRowsSelected(_this5.getStatus(action));
          _this5.$toastr.s(msgSuccess);
        }).catch(function () {
          return _this5.$toastr.e(msgError);
        }).finally(function () {
          return toggleLoadingActionButton(action);
        });
      };

      showConfirm(confirmMsg, {
        title: confirmTitle,
        question: true,
        yes: success
      });
    },
    alternarTodosCheckboxNaPagina: function alternarTodosCheckboxNaPagina() {
      var statusCurrent = this.hasAllCheckboxOnPage;

      this.$refs.vuetable.tableData.forEach(function (item) {
        item.checked = !statusCurrent;
      });

      this.hasAllCheckboxOnPage = !statusCurrent;
    },
    getRequestParams: function getRequestParams(type) {
      var statusDescricao = '';
      var dataProperty = '';

      switch (type) {
        case 'nomear':
          statusDescricao = 'Habilitado';
          dataProperty = 'data_nomeacao';
          break;
        case 'empossar':
          statusDescricao = 'Nomeado';
          dataProperty = 'data_empossado';
          break;
        default:
          statusDescricao = 'Nomeado';
          dataProperty = 'data_revogacao';
          break;
      }

      var itens = this.itens,
          dataBase = this.dataBase;

      var ids = itens.filter(function (_ref9) {
        var checked = _ref9.checked,
            status = _ref9.status;
        return checked && status === statusDescricao;
      }).map(function (_ref10) {
        var id = _ref10.id;
        return id;
      });

      if (ids.length === 0) return null;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({
        ids: ids
      }, dataProperty, dataBase.toISOString().split('T')[0]);
    },
    filterItensSelected: function filterItensSelected(status) {
      return this.itens.filter(function (item) {
        return item.checked && item.status === status;
      });
    },
    setItens: function setItens() {
      var data = this.data,
          getStatus = this.getStatus;

      this.itens = data.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          index: index,
          checked: false,
          status: getStatus(item),
          processingClickEvent: false
        }, item);
      });
    },
    toggleProcessingClickEvent: function toggleProcessingClickEvent(index) {
      var item = this.itens[index];
      this.itens[index].processingClickEvent = !item.processingClickEvent;
    },
    toggleLoadingActionButton: function toggleLoadingActionButton(type) {
      this.loading[type] = !this.loading[type];
    },
    updateStatusRowsSelected: function updateStatusRowsSelected(statusNew) {
      var _this6 = this;

      var statusToSearch = 'Habilitado';

      if (['Empossado', 'Revogado'].find(function (i) {
        return i === statusNew;
      })) statusToSearch = 'Nomeado';

      var indexes = this.itens.filter(function (_ref12) {
        var checked = _ref12.checked,
            status = _ref12.status;
        return checked && status === statusToSearch;
      }).map(function (_ref13) {
        var index = _ref13.index;
        return index;
      });

      indexes.forEach(function (i) {
        _this6.itens[i].status = statusNew;
        _this6.itens[i].checked = false;
      });
    },
    checkOtherStatus: function checkOtherStatus(args) {
      var filter = function filter(item) {
        return item.cpf === args.cpf && item.data_nomeacao !== null && item.cargo_id === args.cargo_id;
      };

      var result = this.fullData.filter(filter);

      if (result.length) {
        var _result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(result, 1),
            first = _result[0];

        return 'Nomeado ' + (first.tipo_normal ? 'Geral' : first.tipo_pcd ? 'PCD' : 'Negro');
      }

      return 'Habilitado';
    },
    getStatus: function getStatus(args) {
      if ((typeof args === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(args)) === 'object') {
        if (args.data_empossado) {
          return 'Empossado';
        }

        if (args.data_revogacao) {
          return 'Revogado';
        }

        if (args.data_nomeacao) {
          return 'Nomeado';
        }

        return this.checkOtherStatus(args);
      }

      var status = '';

      switch (args) {
        case 'nomear':
          status = 'Nomeado';
          break;
        case 'empossar':
          status = 'Empossado';
          break;
        default:
          status = 'Revogado';
          break;
      }

      return status;
    },
    alternarLoadingActionButton: function alternarLoadingActionButton() {
      this.loadingActionButton = !this.loadingActionButton;
    },
    checkAllCheckboxOnPage: function checkAllCheckboxOnPage() {
      var tableData = this.$refs.vuetable.tableData;

      var countSelected = tableData.map(function (_ref14) {
        var checked = _ref14.checked;
        return +checked;
      }).reduce(function (acc, cur) {
        return acc + cur;
      });

      this.hasAllCheckboxOnPage = countSelected === tableData.length;
    },
    requestDataInvalid: function requestDataInvalid() {
      if (!this.dataBase) {
        this.$toastr.e('Selecione a data base para atualização');
        return true;
      }
      return false;
    }
  }
});

/***/ }),

/***/ "/jvO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_dados_user_UserBase__ = __webpack_require__("1NjD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__views_admin_dados_user_UserBase__["a" /* default */],
  data: function data() {
    return {
      type: 'DADOVALOR',
      params: { DAD_IDDADO: 0 },
      columns: [],
      model: {}
    };
  },

  components: { list: __WEBPACK_IMPORTED_MODULE_1__components_common_DataTable__["a" /* default */] },
  created: function created() {
    var me = this;
    var DAD_IDDADO = this.$router.history.current.params.DAD_IDDADO;

    this.params.DAD_IDDADO = DAD_IDDADO;

    __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('dado/get/' + DAD_IDDADO).then(function (_ref) {
      var data = _ref.data;

      me.model = data;
    }).catch(function (error) {
      console.log(error.response);
    });

    this.createColumns();
  },

  methods: {
    /**
     * [isEditavel permite edição apenas dos valores do ano atual e do anterior]
     * @param  [date]  data [a data do lançamento do dado]
     * @return Boolean      [retorna true para valor que pode ser editado e false para o contrario]
     */
    isEditavel: function isEditavel(data) {
      var anoAtual = new Date().getFullYear();
      var anoAnterior = anoAtual--;
      var ano = new Date(data.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3')).getFullYear();
      return ano === anoAtual || ano === anoAnterior;
    },
    createColumns: function createColumns() {
      this.columns = [{
        name: 'DVA_DTDADOVALOR',
        title: 'Data',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'USER',
        title: 'Usuário',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'VALOR',
        title: 'Valor',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }];
    },
    editar: function editar(dataParams, data) {
      this.$router.push({
        name: 'user_dado_valor_save',
        params: {
          DAD_IDDADO: dataParams.DAD_IDDADO,
          DVA_IDDADOVALOR: data.DVA_IDDADOVALOR
        }
      });
    }
  },
  updated: function updated() {
    window.jQuery('[data-toggle="popover"]').popover({});
  }
});

/***/ }),

/***/ "/ljc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form-message"}},[(_vm.message != null)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('span',{staticClass:"glyphicon glyphicon-info-sign",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.message)+"\n    ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/ocE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pdg"},[_c('public-header',{attrs:{"title":'Plano de Governo'}},[_c('div',{staticClass:"col-sm-6"},[_c('p',[_vm._v("\n        Aqui você encontra um resumo das metas do Plano de Governo da Administração Municipal a\n        serem executadas no período de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v("2021 a 2024")]),_vm._v(".\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        A atual administração possui um total de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.total))]),_vm._v("\n        metas e até a presente data,\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.concluidas))]),_vm._v("\n        estão concluídas,\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.emAndamento))]),_vm._v("\n        estão em andamento e\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.naoCumpridas))]),_vm._v("\n        não foram cumpridas.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Para mais detalhes,\n        "),_c('a',{attrs:{"href":"https://egov.santos.sp.gov.br/santosmapeada/Gestao/PlanoMunicipalGoverno/MapaPlanoMunicipalGoverno/#","target":"_blank"}},[_vm._v("\n          acesse o conteúdo completo aqui.\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"row"},[_c('doughnut',{staticStyle:{"max-width":"300px","floating":"none","margin":"0 auto"},attrs:{"chart-data":_vm.createChartData(_vm.metasPorStatus),"gradiente":false,"options":Object.assign({}, this.options,
            {legend: {
              labels: {
                fontColor: 'rgb(255, 255, 255)'
              }
            }})}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-offset-1 col-xs-11 margem-topo"},[_c('span',{staticClass:"destaque-header"},[_vm._v("EM ANDAMENTO:")]),_vm._v(" Meta iniciada e\n          ainda em andamento."),_c('br'),_vm._v(" "),_c('span',{staticClass:"destaque-header"},[_vm._v("CONCLUÍDA:")]),_vm._v(" Meta finalizada."),_c('br'),_vm._v(" "),_c('span',{staticClass:"destaque-header"},[_vm._v("NÃO CUMPRIDA:")]),_vm._v(" Meta não\n          finalizada.\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',{},[_vm._v("Plano de governo")])])]),_vm._v(" "),_c('div',{staticClass:"filtro-secretaria"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('v-select',{ref:"unidades",staticClass:"style-chooser",attrs:{"label":"unidaderesponsavel","placeholder":'Todas as secretarias',"options":_vm.secretarias,"selectOnTab":true},model:{value:(_vm.unidade),callback:function ($$v) {_vm.unidade=$$v},expression:"unidade"}})],1)]),_vm._v(" "),(_vm.unidade)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('doughnut',{staticStyle:{"max-width":"300px","margin":"10px auto"},attrs:{"chart-data":_vm.createChartData(_vm.metasSecretariaStatus),"gradiente":false,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("\n            "+_vm._s(this.unidade)+"\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.total))]),_vm._v("\n            metas\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.totalPorcentagem)+"%")]),_vm._v("\n            do total de compromissos/metas\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.concluidas))]),_vm._v("\n            metas(s) concluída(s)\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.emAndamento))]),_vm._v("\n            metas(s) em andamento\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.naoCumpridas))]),_vm._v("\n            metas(s) não cumprida(s)\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.naoIniciadas))]),_vm._v("\n            metas(s) não iniciada(s)\n          ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.link_externo,"target":"_blank"}},[_c('i',{staticClass:"fa fa-list"}),_vm._v(" Veja a lista completa aqui")])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mais-compromissos"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.secretariasTop6Metas),function(ref,index){
          var sigla = ref.sigla;
          var count = ref.count;
          var percentual = ref.percentual;
return _c('div',{key:index,staticClass:"col-sm-4 margem-bottom"},[_c('h4',[_vm._v("\n            "+_vm._s(_vm.entidadeBySigla(sigla))+"\n          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(count))]),_vm._v(" de um total de "),_c('b',[_vm._v(_vm._s(_vm.total))]),_vm._v(" metas\n          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(percentual)+"%")]),_vm._v(" do\n            total\n          ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"rank-concluido"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"hidden-xs"},[_vm._m(3),_vm._v(" "),_vm._l((_vm.rankingConcluidas.data),function(ref,index){
          var sigla = ref.sigla;
          var secretaria = ref.secretaria;
          var total = ref.total;
          var concluidas = ref.concluidas;
          var percentual = ref.percentual;
return _c('div',{key:index + '-' + sigla,class:[index % 2 === 0 ? '' : 'lista-impar', 'row lista-body']},[_c('div',{staticClass:"col-xs-12 col-sm-1"},[_vm._v("\n            "+_vm._s(index + 1)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-5"},[_vm._v("\n            "+_vm._s(secretaria)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(total)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(concluidas)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(percentual)+"%\n          ")])])}),_vm._v(" "),_c('div',{staticClass:"row lista-impar lista-header"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(_vm.rankingConcluidas.totalMetas)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(_vm.rankingConcluidas.totalConcluidas)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(_vm.rankingConcluidas.totalPercentual)+"%\n          ")])])],2),_vm._v(" "),_c('div',{staticClass:"row hidden-sm hidden-md hidden-lg"},_vm._l((_vm.rankingConcluidas.data),function(ref,index){
          var sigla = ref.sigla;
          var secretaria = ref.secretaria;
          var concluidas = ref.concluidas;
          var total = ref.total;
          var percentual = ref.percentual;
return _c('div',{key:sigla,staticClass:"col-sm-4 altura-card"},[_c('h4',[_vm._v(_vm._s(index + 1 + ' - ' + secretaria))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(concluidas))]),_vm._v(" de um total de "),_c('b',[_vm._v(_vm._s(total))])]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(percentual)+"%")]),_vm._v(" do total\n          ")])])}),0),_vm._v(" "),_c('div',{staticClass:"row margem-topo"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Downloads")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.DownloadJSON2CSV()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}}),_vm._v(" Exportar para CSV\n          ")],1)])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Informações por Secretaria")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Secretarias / Entidades com mais metas no total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Secretarias / Entidades com mais metas concluídas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row lista-impar lista-header"},[_c('div',{staticClass:"col-xs-12 col-sm-1"},[_vm._v("\n             \n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-5"},[_vm._v("\n            Unidade\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            Total de Metas\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            Concluídas\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            Percentual (%)\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-6 text-left"},[_c('strong',[_vm._v("Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/qz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("yVX/");



var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["b" /* LOAD_COMPROMISSOS */], function (state, payload) {
  state.compromissos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* PDG_TOGGLE_LOADING */], function (state) {
  state.loading = !state.loading;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["d" /* SET_COMPROMISSOS_SECRETARIA */], function (state, payload) {
  state.compromissosSecretaria = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(payload));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["c" /* SET_LOADING_SECRETARIA */], function (state, payload) {
  state.loadingSecretaria = payload;
}), _mutations);

/***/ }),

/***/ "/tvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common___ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_DataTablePublic__ = __webpack_require__("+Mmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ODS_ModalMovimentoInfo_vue__ = __webpack_require__("y/Ru");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { PublicHeader: __WEBPACK_IMPORTED_MODULE_0__components_common___["a" /* PublicHeader */], DataTablePublic: __WEBPACK_IMPORTED_MODULE_1__components_common_DataTablePublic__["a" /* default */], ModalMovimentoInfo: __WEBPACK_IMPORTED_MODULE_2__components_ODS_ModalMovimentoInfo_vue__["a" /* default */] },
    data: function data() {
        return {
            filtros: '',
            fields: [{ name: 'titulo', title: 'Título' }, { name: 'instituicao', title: 'Instituição' }, { name: 'inicio', title: 'Inicio' }, { name: 'encerramento', title: 'Encerramento', dataClass: 'nowrap' }, {
                name: '__slot:actions',
                title: 'Ações',
                titleClass: 'text-center col-md-1',
                dataClass: 'text-center'
            }]
        };
    },

    methods: {
        maisInformacoes: function maisInformacoes(data) {
            this.$refs.modalInfo.show({
                instituicao: data.instituicao,
                titulo: data.titulo,
                dataInicio: data.inicio,
                dataEncerramento: data.encerramento,
                local: data.local,
                descricao: data.descricao,
                totalParticipantes: data.total_participantes_esperado,
                tipo_acao: data.tipo_acao,
                bandeiras: data.bandeiras,
                link_instrucoes: data.link_instrucoes,
                link_fotos: data.link_fotos
            });
        }
    }
});

/***/ }),

/***/ "/vAg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-movimento-ods.da00735.jpg";

/***/ }),

/***/ "0058":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ESCALA_FUNCIONARIO; });
var SET_ESCALA_FUNCIONARIO = 'SET_ESCALA_FUNCIONARIO';

/***/ }),

/***/ "00kC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_strings__ = __webpack_require__("V99r");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_1__components_common_DataTable__["a" /* default */],
    TheMask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["TheMask"]
  },
  data: function data() {
    return {
      meses: __WEBPACK_IMPORTED_MODULE_4__utils_strings__["j" /* mesesExt */],
      beneficios: [],
      fields: [{
        name: 'data',
        title: 'Data',
        callback: function callback(value) {
          return new Date('' + value).toLocaleDateString();
        }
      }, {
        name: 'beneficiado',
        title: 'Nome'
      }, {
        name: 'beneficio.sigla',
        title: 'Benefício'
      }, {
        name: '__slot:icon',
        title: 'Período'
      }, {
        name: 'valor',
        title: 'Valor',
        titleClass: 'text-center',
        dataClass: 'text-right',
        callback: function callback(value) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_strings__["b" /* formatarMoeda */])(Number(value));
        }
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  computed: {
    filtros: function filtros() {
      var nome = this.nome,
          ano = this.ano,
          mes = this.mes,
          beneficio = this.beneficio;

      return {
        nome: nome,
        ano: ano,
        mes: mes,
        beneficio: beneficio
      };
    },

    pagina: {
      get: function get() {
        var assistenciaPagamentos = this.$store.state.vuetableState.assistenciaPagamentos;
        var pagina = assistenciaPagamentos.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'assitenciaPagamentos',
          value: value
        });
      }
    },
    nome: {
      get: function get() {
        var assistenciaPagamentos = this.$store.state.vuetableState.assistenciaPagamentos;
        var nome = assistenciaPagamentos.filtros.nome;

        return nome;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'assistenciaPagamentos',
          value: value
        });
        this.resetPageStore();
      }
    },
    ano: {
      get: function get() {
        var assistenciaPagamentos = this.$store.state.vuetableState.assistenciaPagamentos;
        var ano = assistenciaPagamentos.filtros.ano;

        return ano;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'ano',
          collection: 'assistenciaPagamentos',
          value: value
        });
        this.resetPageStore();
      }
    },
    mes: {
      get: function get() {
        var assistenciaPagamentos = this.$store.state.vuetableState.assistenciaPagamentos;
        var mes = assistenciaPagamentos.filtros.mes;

        return mes;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'mes',
          collection: 'assistenciaPagamentos',
          value: value
        });
        this.resetPageStore();
      }
    },
    beneficio: {
      get: function get() {
        var assistenciaPagamentos = this.$store.state.vuetableState.assistenciaPagamentos;
        var beneficio = assistenciaPagamentos.filtros.beneficio;

        return beneficio;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'beneficio',
          collection: 'assistenciaPagamentos',
          value: value
        });
        this.resetPageStore();
      }
    }
  },
  methods: {
    retornarPeriodo: function retornarPeriodo(props) {
      if (props.periodo_inicio && props.periodo_fim) {
        return 'de ' + new Date(props.periodo_inicio).toLocaleDateString() + '\n                \xE0 ' + new Date(props.periodo_fim).toLocaleDateString();
      }

      return '_________';
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      this.nome = '';
      this.mes = '';
      this.ano = '';
      this.beneficio = '';
      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'assistenciaPagamentos',
        value: 1
      });
    },
    excluir: function excluir(item) {
      var _this = this;

      var dt = this.$refs.vuetable;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('assistencia/pagamentos/excluir', item).then(function (response) {
            _this.$toastr.s(response.data.msg);
          }).catch(function (error) {
            var data = error.response.data;

            _this.$toastr.e('Houve um erro ao tentar excluir, atualize a página e tente novamente');
            console.log(data.msg);
          }).then(function () {
            dt.refresh();
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('/assistencia/listar-beneficios').then(function (_ref) {
      var data = _ref.data;

      _this2.beneficios = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));
    }).catch(function (error) {
      _this2.$toastr.e('Houve um erro no carregamento de benefícios. Atualize a página e tente novamente.');
      console.log(error);
    });
  }
});

/***/ }),

/***/ "01Zv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "07cc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  name: 'editais',
  data: function data() {
    return {
      fields: [{
        name: 'numero',
        title: 'Nº Edital',
        filterable: true
      }, {
        name: 'processo_numero',
        title: 'Nº Processo',
        sortField: 'processo_numero',
        filterable: true
      }, {
        name: 'publicado',
        title: 'Publicado',
        sortField: 'publicado',
        filterable: true,
        callback: function callback(value) {
          return value ? 'Sim' : 'Não';
        },

        titleClass: 'text-center',
        dataClass: 'text-center'
      }, {
        name: 'cargos_descricao',
        title: 'Cargos',
        callback: function callback(value) {
          var cargos = value[0];
          for (var index = 1; index < value.length; index++) {
            cargos += ', ' + value[index];
          }
          return cargos;
        }
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center',
        dataClass: 'text-center col-xs-3'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  methods: {
    editar: function editar(data) {
      this.$router.push({
        name: 'salvar_edital',
        params: data
      });
    },
    excluir: function excluir(data) {
      var _this = this;

      var dt = this.$refs.vuetable;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].delete('edital/' + data.id).then(function (response) {
            _this.$toastr.s('Edital excluído com sucesso');
            dt.refresh();
          }).catch(function (error) {
            _this.$toastr.e('Houve um erro ao excluir o edital, tente novamente e, se persistir o erro, entre em contato com o administrador.');
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este edital? Todos os dados anexados a ele (cargos e habilitados) também serão excluídos.', config);
    },

    // exportarEditalComArquivosAnexadosCSV(data) {
    //   var url = this.$root.$data.apiUrl + `exportareditalarquivosanexadoscsv/${data.id}`
    //   return url
    // },
    exportarEditalComArquivosAnexadosCSV: function exportarEditalComArquivosAnexadosCSV(data) {
      var _JSON$parse = JSON.parse(localStorage.getItem('daUser')),
          token = _JSON$parse.token;

      var url = this.$root.$data.apiUrl + ('exportareditalarquivosanexadoscsv/' + data.id + '?token=' + token);
      return url;
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      /**
       * Se não fizer desse jeito, um a um, não vai.
       * Passando um objeto completo, dá pau. Precisa limpar 2 vezes.
       * Full bugado.
       */
      this.numero = '';
      this.processo_numero = '';
      this.publicado = '';
      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'concursosEdital',
        value: 1
      });
    }
  },
  computed: {
    filtros: function filtros() {
      var numero = this.numero,
          processo_numero = this.processo_numero,
          publicado = this.publicado;

      return {
        numero: numero,
        processo_numero: processo_numero,
        publicado: publicado
      };
    },

    pagina: {
      get: function get() {
        var concursosEdital = this.$store.state.vuetableState.concursosEdital;
        var pagina = concursosEdital.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'concursosEdital',
          value: value
        });
      }
    },
    numero: {
      get: function get() {
        var concursosEdital = this.$store.state.vuetableState.concursosEdital;
        var numero = concursosEdital.filtros.numero;


        return numero;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'numero',
          collection: 'concursosEdital',
          value: value
        });
        this.resetPageStore();
      }
    },
    processo_numero: {
      get: function get() {
        var concursosEdital = this.$store.state.vuetableState.concursosEdital;
        var processo_numero = concursosEdital.filtros.processo_numero;


        return processo_numero;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'processo_numero',
          collection: 'concursosEdital',
          value: value
        });
        this.resetPageStore();
      }
    },
    publicado: {
      get: function get() {
        var concursosEdital = this.$store.state.vuetableState.concursosEdital;
        var publicado = concursosEdital.filtros.publicado;


        return publicado;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'publicado',
          collection: 'concursosEdital',
          value: value
        });
        this.resetPageStore();
      }
    }
  }
});

/***/ }),

/***/ "0Btv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return parseTimeToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatToDatabaseDate; });
/* unused harmony export padTo2Digits */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatTo2DigitsDate; });
// entrada: String, saida: String
var parseTimeToInt = function parseTimeToInt(_ref) {
  var entrada = _ref.entrada,
      saida = _ref.saida;

  return {
    entrada: entrada.length === 0 ? undefined : parseInt(entrada.replace(/\D/g, '')),
    saida: saida.length === 0 ? undefined : parseInt(saida.replace(/\D/g, ''))
  };
};

var formatToDatabaseDate = function formatToDatabaseDate(data) {
  return data.getFullYear() + '-' + (data.getMonth() + 1).toString().padStart(2, '0') + '-' + data.getDate().toString().padStart(2, '0');
};

var padTo2Digits = function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
};

var formatTo2DigitsDate = function formatTo2DigitsDate(date) {
  return padTo2Digits(date.getDate()) + '/' + padTo2Digits(date.getMonth() + 1) + '/' + date.getFullYear();
};

/***/ }),

/***/ "0FY8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__ = __webpack_require__("f+vX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0959db73_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4cTv");
function injectStyle (ssrContext) {
  __webpack_require__("cd/n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0959db73"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0959db73_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0YbL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Perfis e unidades","fields":_vm.fields,"dados":_vm.acessos,"report-title":"Perfis e Unidades"},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('ul',[_c('li',[_c('span',{staticClass:"usuarios-titulo"},[_vm._v("Nome")]),_vm._v(" "),_c('span',{staticClass:"usuarios-titulo"},[_vm._v("Perfil")])]),_vm._v(" "),_vm._l((props.rowData.usuarios),function(user){return _c('li',[_c('span',{staticClass:"usuarios-dados"},[_vm._v(_vm._s(user.nome))]),_vm._v(" "),_c('span',{staticClass:"usuarios-dados"},[_vm._v(_vm._s(user.perfil))])])})],2)]}}])})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0pqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manutencao-container"},[_c('div',{staticClass:"manutencao-conteudo"},[_c('font-awesome-icon',{staticClass:"manutencao-icone",attrs:{"icon":'wrench'}}),_vm._v(" "),_c('h1',[_vm._v("Estamos em Manutenção")]),_vm._v(" "),_c('p',[_vm._v("\n            Desculpe, esta área do site está temporariamente indisponível devido a manutenção. Estamos trabalhando para \n            resolver isso o mais rápido possível. Por favor, volte mais tarde.\n        ")]),_vm._v(" "),_c('p',[_vm._v("Agradecemos a sua compreensão.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":_vm.voltar}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n            Voltar\n        ")],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0tcp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":_vm.name}},[_c('span',{staticClass:"is-danger"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n      "+_vm._s(_vm.erro)+"\n    ")],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0w91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("GUOB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dabaa71_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("RMIT");
function injectStyle (ssrContext) {
  __webpack_require__("5Yti")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dabaa71"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dabaa71_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0wpa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesPorAno_vue__ = __webpack_require__("Ue5m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5652d2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesPorAno_vue__ = __webpack_require__("evUM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesPorAno_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5652d2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesPorAno_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0xDb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__strings__ = __webpack_require__("V99r");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__strings__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__strings__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__strings__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__strings__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__strings__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__strings__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__strings__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events__ = __webpack_require__("VwQt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__times__ = __webpack_require__("0Btv");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__times__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_3__times__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__csv__ = __webpack_require__("MbN/");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__csv__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions__ = __webpack_require__("9NIY");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__functions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__coordenadas_remedios__ = __webpack_require__("VyLF");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__coordenadas_remedios__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__coordenadas_remedios__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__coordenadas_remedios__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__["a"]; });










/***/ }),

/***/ "0zO0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("yVX/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");





var actions = {
  loadCompromissosAno: function loadCompromissosAno(store, payload) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* PDG_TOGGLE_LOADING */], true);

              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('/planodegoverno', {
                params: {
                  periodo: payload
                }
              });

            case 4:
              _ref = _context.sent;
              data = _ref.data;

              store.commit(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* LOAD_COMPROMISSOS */], data);
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](1);

              console.error('Erro ao carregar compromissos:', _context.t0);
              store.commit(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* LOAD_COMPROMISSOS */], []);

            case 13:
              _context.prev = 13;

              store.commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* PDG_TOGGLE_LOADING */], false);
              return _context.finish(13);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 9, 13, 16]]);
    }))();
  },
  loadCompromissosSecretaria: function loadCompromissosSecretaria(_ref2, payload) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _ref3, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_2__types__["c" /* SET_LOADING_SECRETARIA */], true);

              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('/planodegoverno', {
                params: {
                  periodo: payload.periodo,
                  unidade_executora: payload.secretariaId
                }
              });

            case 4:
              _ref3 = _context2.sent;
              data = _ref3.data;

              commit(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* SET_COMPROMISSOS_SECRETARIA */], data);
              _context2.next = 13;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](1);

              console.error('Erro ao carregar compromissos da secretaria:', _context2.t0);
              commit(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* SET_COMPROMISSOS_SECRETARIA */], []);

            case 13:
              _context2.prev = 13;

              commit(__WEBPACK_IMPORTED_MODULE_2__types__["c" /* SET_LOADING_SECRETARIA */], false);
              return _context2.finish(13);

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 9, 13, 16]]);
    }))();
  }
};

/***/ }),

/***/ "1/s7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__("bGai");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_3__components__["n" /* NoApiTable */], PreHabilitadoTable: __WEBPACK_IMPORTED_MODULE_3__components__["J" /* PreHabilitadoTable */] },
  data: function data() {
    return {
      error: {},
      import_file: '',
      loading: {
        file: false,
        data: false
      },
      edital: {},
      cargos: [],
      habilitados: [],
      fields: [{
        name: 'descricao',
        title: 'Descrição'
      }, {
        name: 'vagas',
        title: 'Vagas',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }, {
        name: 'vagas_pcd',
        title: 'Vagas PCD',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }, {
        name: 'vagas_cotas',
        title: 'Vagas Cotas',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }, {
        name: 'vagas_QP',
        title: 'Vagas QP',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }],
      fieldsPreHabilitados: [{
        name: 'classificacao',
        title: 'Classificação',
        dataClass: 'text-center'
      }, {
        name: 'inscricao',
        title: 'Inscrição'
      }, {
        name: 'cargo.descricao',
        title: 'Cargo'
      }, {
        name: 'nome',
        title: 'Nome'
      }, {
        name: 'negro',
        title: 'Negro',
        dataClass: 'text-center',
        callback: function callback(value) {
          return value === 1 ? 'Sim' : 'Não';
        }
      }, {
        name: 'deficiente',
        title: 'Deficiente',
        dataClass: 'text-center',
        callback: function callback(value) {
          return value === 1 ? 'Sim' : 'Não';
        }
      }, {
        name: 'avaliacao_status',
        title: 'Status'
      }, {
        name: 'data_avaliacao',
        title: 'Data Avaliação'
      }, {
        name: '__slot:actions',
        title: 'Excluir',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }]
    };
  },
  created: function created() {
    if (_.isEmpty(this.$route.params)) {
      this.$router.push({ name: 'editais' });
    } else {
      this.edital = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.params.edital);
      this.listarCargosEdital();
      this.listarHabilitadosEdital();
    }
  },

  methods: {
    urlArquivoBase: function urlArquivoBase() {
      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('prehabilitado/download-planilha-base', {
        responseType: 'arraybuffer'
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/csv' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'pre-habilitados-base.csv';
        link.click();
      });
    },
    excluir: function excluir(props) {
      var _this = this;

      var id = props.id,
          geral = props.geral,
          pcd = props.pcd,
          cotas = props.cotas;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].delete('prehabilitados/' + id, {
            params: { geral: geral, pcd: pcd, cotas: cotas, edital_id: _this.edital.id }
          }).then(function (response) {
            _this.$toastr.s('Candidato habilitado excluído com sucesso');
            _this.listarHabilitadosEdital();
          }).catch(function (error) {
            _this.$toastr.e('Houve um erro ao excluir o candidato habilitado, tente novamente e, se persistir o erro, entre em contato com o administrador.');
          });
        }
      };
      this.showConfirm('Deseja realmente excluir este candidato habilitado?', config);
    },
    onFileChange: function onFileChange(e) {
      this.import_file = e.target.files[0];
    },
    proceedAction: function proceedAction() {
      var _this2 = this;

      if (!this.import_file) {
        this.$toastr.e('Arquivo de importação não encontrado!');
        return;
      }
      this.handleLoading('file');

      var cargos = this.cargos.map(function (_ref) {
        var id = _ref.id,
            descricao = _ref.descricao;
        return { id: id, descricao: descricao };
      });

      var formData = new FormData();
      formData.append('edital_id', this.edital.id);
      formData.append('cargos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cargos));
      formData.append('import_file', this.import_file);

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('/prehabilitados', formData, {
        headers: { 'content-type': 'multipart/form-data' }
      }).then(function (response) {
        var msg = response.data.msg;

        _this2.$toastr.s(msg);
        _this2.listarHabilitadosEdital();
      }).catch(function (error) {
        var data = error.response.data;

        _this2.$toastr.e(data.msg);
        _this2.error = error.response.data;
        console.log('check error: ', _this2.error);
      }).finally(this.handleLoading('file'));
    },
    scrollToElement: function scrollToElement(refName) {
      var element = document.getElementById(refName);
      element.scrollIntoView({ behavior: 'smooth' });
    },
    listarCargosEdital: function listarCargosEdital() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('cargo', { params: { nr_edital: this.edital.numero } }).then(function (response) {
        var data = response.data;

        _this3.cargos = data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },

    filter: function filter(key) {
      return function (item) {
        return item[key] === 1;
      };
    },
    listarHabilitadosEdital: function listarHabilitadosEdital() {
      var _this4 = this;

      this.handleLoading('data');
      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('prehabilitados', { params: { edital_id: this.edital.id } }).then(function (response) {
        _this4.habilitados = response.data;
      }).catch(function (error) {
        return console.log(error.response);
      }).finally(this.handleLoading('data'));
    },
    handleLoading: function handleLoading(action) {
      this.loading[action] = !this.loading[action];
    }
  }
});

/***/ }),

/***/ "1D+Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1JgW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  name: 'dados',
  data: function data() {
    return {
      title: 'Dados',
      type: 'DADO',
      periodicidades: [],
      secretarias: [],
      autarquias: [],
      model: {
        columnID: 'codigo',
        columns: [{
          name: 'nome',
          title: 'Nome',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: '__slot:icon1',
          columnName: 'valorAno1',
          title: this.titleAnos().ano1,
          titleClass: 'text-center',
          dataClass: 'align-middle text-center'
        }, {
          name: '__slot:icon2',
          columnName: 'valorAno2',
          title: this.titleAnos().ano2,
          titleClass: 'text-center',
          dataClass: 'align-middle text-center'
        }, {
          name: '__slot:icon3',
          columnName: 'valorAno3',
          title: this.titleAnos().ano3,
          titleClass: 'text-center',
          dataClass: 'align-middle text-center'
        }, {
          name: '__slot:icon4',
          columnName: 'valorAno4',
          title: this.titleAnos().ano4,
          titleClass: 'text-center',
          dataClass: 'align-middle text-center'
        }, {
          name: 'periodicidade',
          title: 'Periodicidade',
          dataClass: 'align-middle col-md-1 text-center',
          filterable: true
        }, {
          name: 'fonte',
          title: 'Fonte',
          dataClass: 'truncate-text-70',
          filterable: true,
          callback: function callback(value) {
            return '<span style="cursor:default" title="' + value + '">' + value + '</span>';
          }
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-2',
          dataClass: 'text-center'
        }]
      }
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_1__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('listar-periodicidades').then(function (response) {
      if (response.status) {
        _this.periodicidades = response.data.data;
      }
    }).catch(function (e) {
      console.log(e);
      _this.$toastr.e('Houve uma falha ao tentar carregar o filtro periodicidades!');
    });

    __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('listar-secretarias-associadas').then(function (response) {
      if (response.status) {
        _this.secretarias = response.data.data;
      }
    }).catch(function (e) {
      console.log(e);
      _this.$toastr.e('Houve uma falha ao tentar carregar o filtro secretarias!');
    });

    __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('listar-autarquias-associadas').then(function (response) {
      if (response.status) {
        _this.autarquias = response.data.data;
      }
    }).catch(function (e) {
      console.log(e);
      _this.$toastr.e('Houve uma falha ao tentar carregar o filtro autarquias!');
    });
  },

  computed: {
    filtros: function filtros() {
      var nome = this.nome,
          fonte = this.fonte,
          periodicidade_codigo = this.periodicidade_codigo,
          secretaria_sigla = this.secretaria_sigla,
          autarquia_sigla = this.autarquia_sigla,
          status_values = this.status_values;

      return {
        nome: nome,
        fonte: fonte,
        periodicidade_codigo: periodicidade_codigo,
        secretaria_sigla: secretaria_sigla,
        autarquia_sigla: autarquia_sigla,
        status_values: status_values
      };
    },

    pagina: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var pagina = dados.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dados',
          value: value
        });
      }
    },
    nome: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var nome = dados.filtros.nome;


        return nome;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'dados',
          value: value
        });
        this.resetPageStore();
      }
    },
    fonte: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var fonte = dados.filtros.fonte;


        return fonte;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'fonte',
          collection: 'dados',
          value: value
        });
        this.resetPageStore();
      }
    },
    periodicidade_codigo: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var periodicidade_codigo = dados.filtros.periodicidade_codigo;


        return periodicidade_codigo;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'periodicidade_codigo',
          collection: 'dados',
          value: value
        });
        this.resetPageStore();
      }
    },
    secretaria_sigla: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var secretaria_sigla = dados.filtros.secretaria_sigla;


        return secretaria_sigla;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'secretaria_sigla',
          collection: 'dados',
          value: value
        });
        this.resetPageStore();
      }
    },
    autarquia_sigla: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var autarquia_sigla = dados.filtros.autarquia_sigla;


        return autarquia_sigla;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'autarquia_sigla',
          collection: 'dados',
          value: value
        });
        this.resetPageStore();
      }
    },
    status_values: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var status_values = dados.filtros.status_values;


        return status_values;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'status_values',
          collection: 'dados',
          value: value
        });
        this.resetPageStore();
      }
    }
  },
  methods: (_methods = {
    titleAnos: function titleAnos() {
      return {
        ano1: new Date().getFullYear() - 4,
        ano2: new Date().getFullYear() - 3,
        ano3: new Date().getFullYear() - 2,
        ano4: new Date().getFullYear() - 1
      };
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      this.nome = '';
      this.fonte = '';
      this.periodicidade_codigo = '*';
      this.secretaria_codigo = '';
      this.autarquia_codigo = '';
      this.status_values = '*';
      this.$refs.vuetable.refresh();
    },
    listValues: function listValues(data) {
      this.$router.push({
        name: 'admin_dado_valor_list',
        params: { DAD_IDDADO: data.codigo }
      });
    },
    editar: function editar(data) {
      this.$router.push({
        name: 'admin_dado_save',
        params: { id: data.codigo }
      });
    },
    excluir: function excluir(data) {
      var _this2 = this;

      data.type = this.type;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('dado/delete', data).then(function (response) {
            _this2.$toastr.s('Dado foi salvo com sucesso.');
            _this2.consultar();
          }).catch(function (e) {
            console.log(e);
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'consultar', function consultar() {
    this.$nextTick(function () {
      this.$refs.vuetable.refresh();
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'resetPageStore', function resetPageStore() {
    this.$store.commit('SET_FILTER_PAGE', {
      collection: 'dados',
      value: 1
    });
  }), _methods)
});

/***/ }),

/***/ "1KE0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Moderation_vue__ = __webpack_require__("iHhQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c80b9446_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Moderation_vue__ = __webpack_require__("9OSu");
function injectStyle (ssrContext) {
  __webpack_require__("i85P")
  __webpack_require__("OT/t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c80b9446"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Moderation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c80b9446_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Moderation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1M8D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeusCompromissos_vue__ = __webpack_require__("pSzi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3659a697_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeusCompromissos_vue__ = __webpack_require__("+y89");
function injectStyle (ssrContext) {
  __webpack_require__("KEBQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3659a697"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeusCompromissos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3659a697_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeusCompromissos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1NjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBase_vue__ = __webpack_require__("4JeW");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBase_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1VMN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__ = __webpack_require__("xk7p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0336d4fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("/ocE");
function injectStyle (ssrContext) {
  __webpack_require__("i2IB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0336d4fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0336d4fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1jqu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1neZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.3f500ca.jpg";

/***/ }),

/***/ "1rCw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1s5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      defaut: 'Titulo'
    },
    description: {
      type: String,
      defaut: 'Descrição'
    },
    url: {
      type: Object
    }
  }
});

/***/ }),

/***/ "1u0E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1wGp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1zm9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("0058");



var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_ESCALA_FUNCIONARIO */], function (state, payload) {
  if (Array.isArray(payload)) {
    state.funcionarios = payload;
  }
});

/***/ }),

/***/ "202F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "27/G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Replicate_vue__ = __webpack_require__("Rb84");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e75fe2f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Replicate_vue__ = __webpack_require__("mZdd");
function injectStyle (ssrContext) {
  __webpack_require__("TCuM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e75fe2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Replicate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e75fe2f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Replicate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "29pW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQMAAADCCAMAAAB6zFdcAAAAY1BMVEXa2tpVVVVSUlLf399LS0u3t7d4eHhOTk7i4uLl5eWzs7OFhYVqampHR0efn5/V1dVfX1/Ly8tcXFyLi4tlZWW9vb2RkZGYmJi1tbWtra1ubm7ExMR5eXleXl7R0dFCQkI6Ojr8r7BKAAACkklEQVR4nO3b3W6qQBhAUedHZxSBokgFrZ73f8pTFQQUmigmxo+9LmkgmR0YBoqTCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAo2DyYvYywbtH8xwfHfWruPTdo3mOj0L1Knr57tE8hwY0OKFB3cCFdggtoIHOpovnbRep/vwGLpqbASZLEQ3MoMPQYJQNjPftDaNrYCa7PD+0dhhbA5PMtLUqmzR2GVkDs1PuNOBw39g4tgZ7e1kWhnk9KYyrgdnpcmnsinqfkTXYuurxII2vW0fWYHNt0BiyvAZmG/jePeKv8mKwa8nzgV8es97zwkfHy2mgEsHzgdmGymb9Z0LmnNZ2tZG8PohPI7JRbwQ/XRfFd9L8u7QGPjovAML+COUDc4O0BpPV5a2QzdsR/rpzCGtgvst1oA7bEaZ/VJDVwBx+qoWgVptGhFgFpjeCrAZ+besXxbaOMA+sTeO+CKIamERrVUdY7artu9/loVsmPfOkrAZBfRqchuWqhdD+tER2raujQVKD+mmgejhMzxF8bsspIu+MIKrB7KaBcqvzJJDqaoroXDYIalA/GDciFAdjovoKsVnHYSQ1WN43ULYwh+ZEaff3CwU5DXze+Q9YG7QnSlsktxHkNLgM5Z6+2Wx/bu+RYhr4qONK6I5ye3sQ0yBW3adBVwS7aEWQ0sAkj3yOEbbeNI2zgbJrI+9d2oMNVDirH6EENXjse0SbXu+Rchror8es0l15GCkNfm8MjzocysPIafA8Glzexn98g3w+hJfQQM+CQVbq8xso7QZREhq8Ag1oQIMPb/D9b9BH+03hh/6eySSL6eu8ezRPMv51hq23AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAz/Af45zrw9rLF5wAAAABJRU5ErkJggg=="

/***/ }),

/***/ "2BDT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2HAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Importar Compromissos")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4"},[_c('label',{staticClass:"custom-font"},[_vm._v("Período")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.periodo),expression:"periodo"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.periodo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selecione o período")]),_vm._v(" "),_vm._l((_vm.periodos),function(p){return _c('option',{key:p,domProps:{"value":p}},[_vm._v(_vm._s(p))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-8"},[_c('label',{staticClass:"custom-font"},[_vm._v("Arquivo CSV")]),_vm._v(" "),_c('input',{ref:"file",staticClass:"form-control",attrs:{"type":"file","accept":".csv"},on:{"change":_vm.handleFile}})]),_vm._v(" "),(_vm.compromissosValidos.length)?_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Pré-visualização")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.compromissosValidos),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.unidade_executora))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.descritivo))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.responsavel_sshd))])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.compromissosInvalidos.length)?_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"alert alert-danger"},[_c('strong',[_vm._v("Atenção!")]),_vm._v(" Foram encontrados "+_vm._s(_vm.compromissosInvalidos.length)+" compromissos com unidades inválidas. Eles não serão importados. Por favor, corrija o arquivo e envie novamente.\n      ")]),_vm._v(" "),_c('h3',[_vm._v("Compromissos com Unidades Inválidas")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.compromissosInvalidos),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(item.unidade_executora)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"coluna-unidade-corrigida"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.nova_unidade_executora),expression:"item.nova_unidade_executora"}],staticClass:"form-control select-selected",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item, "nova_unidade_executora", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selecione a unidade")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Secretarias"}},_vm._l((_vm.listas.secretarias),function(s){return _c('option',{key:s.sigla,attrs:{"title":s.nome},domProps:{"value":s.sigla}},[_vm._v("\n                    "+_vm._s(s.sigla)+"\n                  ")])}),0),_vm._v(" "),_c('optgroup',{attrs:{"label":"Autarquias"}},_vm._l((_vm.listas.autarquias),function(a){return _c('option',{key:a.sigla,attrs:{"title":a.nome},domProps:{"value":a.sigla}},[_vm._v("\n                    "+_vm._s(a.sigla)+"\n                  ")])}),0)])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.descritivo))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.responsavel_sshd))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-default",attrs:{"title":"Confirmar Correção","disabled":!item.nova_unidade_executora},on:{"click":function($event){return _vm.corrigirUnidade(item, index)}}},[_c('font-awesome-icon',{attrs:{"icon":'check'}})],1)])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.compromissosValidos.length || _vm.compromissosInvalidos.length)?_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"btn btn-danger",attrs:{"disabled":!_vm.compromissosValidos.length && !_vm.compromissosInvalidos.length},on:{"click":_vm.reset}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}}),_vm._v(" LIMPAR\n        ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.compromissosInvalidos.length > 0 || !_vm.compromissosValidos.length},on:{"click":_vm.salvar}},[_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v(" IMPORTAR\n        ")],1)])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Unidade")]),_vm._v(" "),_c('th',[_vm._v("Compromisso")]),_vm._v(" "),_c('th',[_vm._v("Responsável")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Unidade Original")]),_vm._v(" "),_c('th',{staticClass:"coluna-unidade-corrigida"},[_vm._v("Unidade Corrigida")]),_vm._v(" "),_c('th',[_vm._v("Compromisso")]),_vm._v(" "),_c('th',[_vm._v("Responsável")]),_vm._v(" "),_c('th',[_vm._v("Ações")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2J0+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicHeader_vue__ = __webpack_require__("ysb3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bcb6ec0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicHeader_vue__ = __webpack_require__("NrIa");
function injectStyle (ssrContext) {
  __webpack_require__("c0bW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bcb6ec0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PublicHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bcb6ec0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PublicHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2OzP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ab3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          wrapperClass: 'ui right floated pagination menu',
          activeClass: 'active large',
          disabledClass: 'disabled',
          pageClass: 'item',
          linkClass: 'icon item',
          paginationClass: 'ui bottom attached segment grid',
          paginationInfoClass: 'left floated left aligned six wide column',
          dropdownClass: 'ui search dropdown',
          icons: {
            first: 'angle double left icon',
            prev: 'left chevron icon',
            next: 'right chevron icon',
            last: 'angle double right icon'
          }
        };
      }
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable-pagination:',
      tablePagination: null
    };
  },
  computed: {
    totalPage: function totalPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page;
    },
    isOnFirstPage: function isOnFirstPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === 1;
    },
    isOnLastPage: function isOnLastPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.tablePagination.last_page;
    },
    notEnoughPages: function notEnoughPages() {
      return this.totalPage < this.onEachSide * 2 + 4;
    },
    windowSize: function windowSize() {
      return this.onEachSide * 2 + 1;
    },
    windowStart: function windowStart() {
      if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
        return 1;
      } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
        return this.totalPage - this.onEachSide * 2;
      }

      return this.tablePagination.current_page - this.onEachSide;
    }
  },
  methods: {
    loadPage: function loadPage(page) {
      this.$emit(this.eventPrefix + 'change-page', page);
    },
    isCurrentPage: function isCurrentPage(page) {
      return page === this.tablePagination.current_page;
    },
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ "2fAx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2iX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__("N1oo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3517c3a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__("oOIW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3517c3a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2mV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user__ = __webpack_require__("LWU+");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__user__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__escalas__ = __webpack_require__("aXsH");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__escalas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pesquisa_aulas__ = __webpack_require__("LrGW");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__pesquisa_aulas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__receitas_despesas__ = __webpack_require__("EF99");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__receitas_despesas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuetableState__ = __webpack_require__("toeg");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__vuetableState__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emendas_parlamentares__ = __webpack_require__("/6fP");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__emendas_parlamentares__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eleicoes_conselho__ = __webpack_require__("y/xj");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__eleicoes_conselho__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plano_governo__ = __webpack_require__("S4SY");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__plano_governo__["a"]; });









/***/ }),

/***/ "3FI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MensagemErro_vue__ = __webpack_require__("xA6P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ff4c6f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MensagemErro_vue__ = __webpack_require__("0tcp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MensagemErro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ff4c6f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MensagemErro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3H75":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3HME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("KF8/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217c5426_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("bUcq");
function injectStyle (ssrContext) {
  __webpack_require__("dzCM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-217c5426"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217c5426_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Jfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("TQp1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a445fbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("x5FH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a445fbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3KOu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',{staticClass:"font-lg",attrs:{"for":_vm.id}},[_vm._v("\n      Nº do Cartão SUS\n    ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('the-mask',{ref:_vm.id,staticClass:"form-control",attrs:{"type":"text","placeholder":"Digite o nº do cartão SUS...","maxlength":"15","name":_vm.id,"id":_vm.id,"mask":'###############',"disabled":_vm.carregando},on:{"input":function($event){return _vm.$emit('input', _vm.propValue)}},model:{value:(_vm.propValue),callback:function ($$v) {_vm.propValue=$$v},expression:"propValue"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default btn-border",attrs:{"disabled":_vm.carregando},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Botão de pesquisa")]),_vm._v(" "),(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'search'}})],1)])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3R7G":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "3TAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputVagas_vue__ = __webpack_require__("o0wj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Datepicker__ = __webpack_require__("eOZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  components: { InputVagas: __WEBPACK_IMPORTED_MODULE_1__InputVagas_vue__["a" /* default */], DataTable: __WEBPACK_IMPORTED_MODULE_2__components_common_NoApiTable__["a" /* default */], Datepicker: __WEBPACK_IMPORTED_MODULE_3__components_common_Datepicker__["a" /* default */] },
  props: {
    edital: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      model: {
        data_publicacao: new Date(),
        pagina: 1
      },
      arquivosEdital: [],
      fields: [{
        name: 'descricao',
        title: 'Descrição'
      }, {
        name: 'data_publicacao',
        title: 'Data de Publicação',
        callback: function callback(value) {
          return new Date(value + ' 00:00').toLocaleDateString();
        }
      }, {
        name: 'pagina',
        title: 'Página de Publicação',
        callback: function callback(value) {
          return 'P\xE1gina ' + value;
        }
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center',
        dataClass: 'text-center col-xs-3'
      }],
      isLoading: false
    };
  },
  created: function created() {
    this.model.edital_id = this.edital.id;
    this.carregarArquivos();
  },

  methods: {
    toggleLoading: function toggleLoading() {
      this.isLoading = !this.isLoading;
    },
    selecionarArquivo: function selecionarArquivo(item) {
      var data_publicacao = item.data_publicacao;

      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
        data_publicacao: new Date(data_publicacao + ' 00:00')
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["o" /* scrollToElement */])('arquivos-edital');
    },
    salvar: function salvar() {
      var _this = this;

      this.toggleLoading();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.toggleLoading();
          _this.$toastr.e(_this.$validator.errors.items[0].msg);
          return;
        }

        var id = _this.model.id;


        if (id) {
          __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].put('arquivosEdital/' + id, _this.formatedModel).then(function (response) {
            var data = response.data;

            _this.$toastr.s(data.descricao + ' atualizado com sucesso.');
            _this.limparCampos();
          }).catch(function (error) {
            _this.$toastr.e('Houve um erro ao salvar o edital, verifique as informações e tente novamente.');
            console.log(error.response);
          }).finally(function () {
            _this.toggleLoading();
            _this.carregarArquivos();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('arquivosEdital', _this.formatedModel).then(function (response) {
            var data = response.data;

            _this.$toastr.s(data.descricao + ' inserido com sucesso.');
            _this.model.descricao = '';
            _this.model.pagina = '1';
          }).catch(function (error) {
            _this.$toastr.e('Houve um erro ao salvar o edital, verifique as informações e tente novamente.');
            console.log(error.response);
          }).finally(function () {
            _this.toggleLoading();
            _this.carregarArquivos();
          });
        }
      });
    },
    limparCampos: function limparCampos() {
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model, {
        descricao: '',
        pagina: '1',
        id: ''
      });
    },
    carregarArquivos: function carregarArquivos() {
      var _this2 = this;

      this.toggleLoading();
      var numero = this.edital.numero;

      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('arquivosEdital', { params: { nr_edital: numero } }).then(function (response) {
        var data = response.data;

        _this2.arquivosEdital = data;
      }).catch(function (error) {
        _this2.$toastr.e('Houve um erro ao carregar os arquivos. Atualize a página e tente novamente.');
        console.log(error.response);
      }).finally(this.toggleLoading);
    },
    excluir: function excluir(item) {
      var _this3 = this;

      var id = item.id,
          descricao = item.descricao;


      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          _this3.toggleLoading();
          __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].delete('arquivosEdital/' + id).then(function (response) {
            _this3.$toastr.s('Arquivo excluído com sucesso!');
            console.log(response.data);
            _this3.carregarArquivos();
          }).catch(function (error) {
            _this3.$toastr.e('Houve um problema ao excluir o item. Tente novamente');
            console.log(error.response);
          }).finally(_this3.toggleLoading);
        }
      };

      this.showConfirm('Deseja excluir o arquivo "' + descricao + '"', config);
    }
  },
  computed: {
    formatedModel: function formatedModel() {
      var _model = this.model,
          data_publicacao = _model.data_publicacao,
          pagina = _model.pagina;


      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model, {
        data_publicacao: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["m" /* formatToDatabaseDate */])(data_publicacao),
        pagina: parseInt(pagina)
      });
    }
  }
});

/***/ }),

/***/ "3VhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    metas: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      imgUrl: this.$root.$data.imgUrl
    };
  },

  methods: {
    triggerPopover: function triggerPopover() {
      window.jQuery('[data-toggle="popover"]').popover({});
    }
  },
  mounted: function mounted() {
    this.triggerPopover();
  },
  updated: function updated() {
    this.triggerPopover();
  }
});

/***/ }),

/***/ "3WfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_EMENDAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_EMENDAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_LOADING; });
var LOAD_EMENDAS = 'LOAD_EMENDAS';
var CLEAR_EMENDAS = 'CLEAR_EMENDAS';
var SET_YEAR = 'SET_YEAR';
var TOGGLE_LOADING = 'TOGGLE_LOADING';

/***/ }),

/***/ "3eTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"csvimport"},[_c('div',{staticClass:"panel panel-sm"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-xs-12",attrs:{"for":"csv_file"}},[_vm._v("CSV para importação")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('input',{staticClass:"form-control",attrs:{"type":"file","id":"csv_file","name":"csv_file","accept":".csv"},on:{"change":function($event){return _vm.loadCSV($event)}}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',[_vm._v("Importar CSV")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3p2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidePlanoGoverno_vue__ = __webpack_require__("Nkka");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb3b163c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidePlanoGoverno_vue__ = __webpack_require__("UXFX");
function injectStyle (ssrContext) {
  __webpack_require__("FV/j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb3b163c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidePlanoGoverno_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb3b163c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidePlanoGoverno_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3pzb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3uwM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3ytx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"candidato-wrapper"},[_c('router-link',{staticClass:"foto-wrapper",attrs:{"to":{ name: 'candidato_conselho', params: { candidato: _vm.candidato } }}},[_c('img',{staticClass:"foto-candidato",attrs:{"src":_vm.candidato.url_foto,"alt":"Foto do candidato"}})]),_vm._v(" "),_c('div',{staticClass:"dados-candidato"},[_c('p',[_vm._v("\n      "+_vm._s(_vm.candidato.posicao)+"º - "+_vm._s(_vm.candidato.nome)+" -\n      "+_vm._s(_vm.candidato.numero)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-success",style:({
          width: _vm.perc * 10 + '%'
        }),attrs:{"role":"progressbar","aria-valuenow":_vm.perc * 10,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',[_vm._v("\n          Votos: "+_vm._s(_vm.candidato.total_votos.toLocaleString())+" ( "+_vm._s(_vm.perc)+"% )\n        ")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3zzW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectReferenceDate_vue__ = __webpack_require__("XeOX");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb690c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectReferenceDate_vue__ = __webpack_require__("VRry");
function injectStyle (ssrContext) {
  __webpack_require__("2fAx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cb690c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectReferenceDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb690c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectReferenceDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "4D6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":_vm.nomeDaSecretaria}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n        A execução do Plano de Governo é uma tarefa complexa, dividida entre as\n        diferentes Secretarias Municipais. Cada secretaria é responsável por\n        colocar em prática os compromissos relacionados à sua área de atuação,\n        como Saúde, Educação, Segurança, entre outras.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Nesta página, você pode visualizar de forma focada todos os compromissos\n        e metas que estão sob a responsabilidade direta desta secretaria,\n        facilitando o acompanhamento e a fiscalização das ações setoriais.\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":[
      { label: 'Plano de Governo', link: '/planodegoverno' },
      { label: _vm.secretariaId, }
    ]}}),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',{staticClass:"text-lg"},[_vm._v("\n          Para o do período de\n          "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.anoPlano),expression:"anoPlano"}],attrs:{"name":"plano-governo-secretaria","id":"plano-governo-secretaria"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.anoPlano=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.fetchData]}},[_c('option',{attrs:{"value":"2025-2028"}},[_vm._v("2025-2028")]),_vm._v(" "),_c('option',{attrs:{"value":"2021-2024"}},[_vm._v("2021-2024")])]),_vm._v(", a \n          "),_c('ValorDestaque',{attrs:{"value":_vm.nomeDaSecretaria}}),_vm._v(" \n          é responsável por um total de\n          "),_c('ValorDestaque',{attrs:{"value":_vm.compromissos.length,"isLoading":_vm.isLoading}}),_vm._v(" compromissos.\n        ")],1),_vm._v(" "),(!_vm.isLoading && _vm.statusTexto)?_c('p',{staticClass:"text-lg"},[_vm._v("\n          "+_vm._s(_vm.statusTexto)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('PieChart',{attrs:{"chartData":_vm.chartData,"gradiente":false,"css-classes":'chartWrapper',"options":_vm.chartOptions}})],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"40px"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"margin-bottom":"20px"}},[_c('div',{staticClass:"filtro-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termoPesquisa),expression:"termoPesquisa"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Pesquisar por descritivo ou status..."},domProps:{"value":(_vm.termoPesquisa)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.pesquisar.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.termoPesquisa=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.pesquisar}},[_vm._v("Pesquisar")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"table-wrapper"},[_c('data-table-public',{ref:"compromissosTable",attrs:{"has-auth":false,"title":"Lista de Compromissos","api-url":"planodegoverno/compromissos","fields":_vm.model.columns,"append-params":_vm.filtrosDataTable,"show-empty":true},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_c('span',{class:['status-tag', _vm.getStatusClass(props.rowData.status)]},[_vm._v(_vm._s(props.rowData.status))])]}},{key:"rowrender",fn:function(props){return [(props.rowData.acoes && props.rowData.acoes.length > 0)?_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.abrirSidePanel(props.rowData.acoes)}}},[_vm._v("\n                Ver Ações\n              ")]):_c('span')]}}])})],1)])])],1),_vm._v(" "),_c('div',{class:['side-panel-overlay', { 'is-open': _vm.isSidePanelOpen }],on:{"click":_vm.fecharSidePanel}},[_c('div',{staticClass:"side-panel-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('button',{staticClass:"side-panel-close",on:{"click":_vm.fecharSidePanel}},[_vm._v("×")]),_vm._v(" "),_c('h3',[_vm._v("Ações do compromisso")]),_vm._v(" "),_c('div',{staticClass:"side-panel-body"},[(_vm.sidePanelChartData)?_c('div',{staticClass:"modal-chart-container"},[_c('PieChart',{attrs:{"chartData":_vm.sidePanelChartData,"options":_vm.sideChartOptions,"height":150}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filtro-wrapper filtro-modal"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termoPesquisaAcoes),expression:"termoPesquisaAcoes"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Pesquisar por descritivo ou status..."},domProps:{"value":(_vm.termoPesquisaAcoes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.termoPesquisaAcoes=$event.target.value}}})]),_vm._v(" "),(_vm.acoesFiltradas && _vm.acoesFiltradas.length > 0)?_c('div',{staticClass:"acoes-list"},_vm._l((_vm.acoesFiltradas),function(acao){return _c('div',{key:acao.id,staticClass:"acao-item"},[_c('div',{staticClass:"acao-info"},[_c('p',{staticClass:"acao-descricao"},[_vm._v(_vm._s(acao.descritivo))]),_vm._v(" "),_c('p',{staticClass:"acao-unidade"},[_c('strong',[_vm._v("Unidade:")]),_vm._v(" "+_vm._s(acao.nome_unidade))])]),_vm._v(" "),_c('div',{staticClass:"acao-status"},[_c('span',{class:['status-tag', _vm.getStatusClass(acao.status)]},[_vm._v(_vm._s(acao.status))])])])}),0):_c('div',[_c('p',[_vm._v("Nenhuma ação encontrada.")])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Resumo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Compromissos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Dd7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},[(_vm.showOptionEmpty)?_c('option',{attrs:{"value":""}},[_vm._v("Nenhum")]):_vm._e(),_vm._v(" "),_vm._l((_vm.options),function(item,index){return _c('option',{key:index,domProps:{"value":item.value}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4JeW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  methods: {
    concatPathImage: function concatPathImage(file) {
      return this.$root.$data.imgUrl + file + '?' + new Date().getTime();
    }
  }
});

/***/ }),

/***/ "4Nwh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_TITLE; });
var DEFAULT_TITLE = 'Dados Abertos';

/***/ }),

/***/ "4SMn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Eixos")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Listagem de Eixos","api-url":"eixos/list","report-title":"Eixos","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'eixos',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"EIX_DCEIXO_filter"}},[_vm._v("Descrição")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.EIX_DCEIXO),expression:"EIX_DCEIXO"}],staticClass:"form-control",attrs:{"type":"text","name":"DAD_DCNOME_filter"},domProps:{"value":(_vm.EIX_DCEIXO)},on:{"input":function($event){if($event.target.composing){ return; }_vm.EIX_DCEIXO=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'admin_eixos_save' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4TJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__ = __webpack_require__("2ab3");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4agJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4atV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeCell_vue__ = __webpack_require__("MnWY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9d219d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeCell_vue__ = __webpack_require__("M53D");
function injectStyle (ssrContext) {
  __webpack_require__("ap9C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9d219d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeCell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9d219d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeCell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4cTv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pdg"},[_c('public-header',{attrs:{"title":'Planos Municipais'}},[_c('div',{staticClass:"col-sm-6"},[_c('p',[_vm._v("\n        Aqui você encontra um resumo das METAS da Administração Municipal a\n        serem executadas no período de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v("2021 a 2024")]),_vm._v(".\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        A atual administração possui um total de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.totais.metas))]),_vm._v("\n        metas, divididas entre os\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.totais.planogoverno.total))]),_vm._v("\n        compromissos do\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v("PLANO DE GOVERNO")]),_vm._v(" registrado na\n        Justiça Eleitoral e as\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.totais.prioridade.total)+" PRIORIDADES DE GESTÃO")]),_vm._v("\n        elencadas pelas secretarias e entidades da administração indireta para\n        os próximos 4 anos.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Dos compromissos do\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v("PLANO DE GOVERNO")]),_vm._v(", até a presente\n        data,\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.totais.planogoverno.concluido))]),_vm._v("\n        estão concluídos,\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.totais.planogoverno.emAndamento))]),_vm._v("\n        estão em andamento e\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.totais.planogoverno.naoConcluido))]),_vm._v("\n        não foram cumpridos.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Das "),_c('span',{staticClass:"destaque-header"},[_vm._v("PRIORIDADES DE GESTÃO")]),_vm._v(", até a\n        presente data,\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.totais.prioridade.concluido))]),_vm._v("\n        estão concluídas,\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.totais.prioridade.emAndamento))]),_vm._v("\n        estão em andamento e\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.totais.prioridade.naoConcluido))]),_vm._v("\n        não foram cumpridas.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Para mais detalhes,\n        "),_c('a',{attrs:{"href":"https://egov.santos.sp.gov.br/santosmapeada/Gestao/PlanoMunicipalGoverno/MapaPlanoMunicipalGoverno/#","target":"_blank"}},[_vm._v("\n          acesse o conteúdo completo aqui.\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"row"},[_c('doughnut',{style:('max-width: 300px; floating: none; margin: 0 auto'),attrs:{"chart-data":_vm.doughnutHeader,"gradiente":false,"options":Object.assign({}, this.options,
            {legend: {
              labels: {
                fontColor: 'rgb(255, 255, 255)'
              }
            }})}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-offset-1 col-xs-11 margem-topo"},[_c('span',{staticClass:"destaque-header"},[_vm._v("EM ANDAMENTO:")]),_vm._v(" Meta iniciada e\n          ainda em andamento."),_c('br'),_vm._v(" "),_c('span',{staticClass:"destaque-header"},[_vm._v("CONCLUÍDA:")]),_vm._v(" Meta finalizada."),_c('br'),_vm._v(" "),_c('span',{staticClass:"destaque-header"},[_vm._v("NÃO CUMPRIDA:")]),_vm._v(" Meta não\n          finalizada.\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',{},[_vm._v("Metas")])])]),_vm._v(" "),_c('div',{staticClass:"filtro-plano"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('v-select',{ref:"tipoPlano",staticClass:"style-chooser",attrs:{"placeholder":'Todos os tipos de plano',"reduce":function (tipo) { return tipo.codigo; },"options":_vm.tiposPlano,"label":"nome","selectOnTab":true},on:{"input":function($event){return _vm.getTipoPlanoData()}},model:{value:(_vm.tipoPlanoCodigo),callback:function ($$v) {_vm.tipoPlanoCodigo=$$v},expression:"tipoPlanoCodigo"}})],1)]),_vm._v(" "),(_vm.tipoPlanoCodigo)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('doughnut',{style:('max-width: 300px; margin: 10px auto'),attrs:{"chart-data":_vm.doughnutTipoPlano,"gradiente":false,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("\n            "+_vm._s(_vm.tipoPlanoData.nome)+"\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.tipoPlanoData.total))]),_vm._v("\n            "+_vm._s(_vm.texto[_vm.tipoPlanoCodigo].geral)+"\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.tipoPlanoData.concluidoPorcentagem)+"%")]),_vm._v("\n            de "+_vm._s(_vm.texto[_vm.tipoPlanoCodigo].concluido)+"\n          ")]),_vm._v(" "),(_vm.tipoPlanoData.concluido)?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.tipoPlanoData.concluido))]),_vm._v("\n            "+_vm._s(_vm.texto[_vm.tipoPlanoCodigo].concluido)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.tipoPlanoData.emAndamento)?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.tipoPlanoData.emAndamento))]),_vm._v("\n            "+_vm._s(_vm.texto[_vm.tipoPlanoCodigo].andamento)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.tipoPlanoData.naoConcluido)?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.tipoPlanoData.naoConcluido))]),_vm._v("\n            "+_vm._s(_vm.texto[_vm.tipoPlanoCodigo].naoConcluido)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.tipoPlanoData.indefinido)?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.tipoPlanoData.indefinido))]),_vm._v("\n            "+_vm._s(_vm.texto[_vm.tipoPlanoCodigo].analise)+"\n          ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"filtro-secretaria"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('v-select',{ref:"unidades",staticClass:"style-chooser",attrs:{"label":"unidaderesponsavel","placeholder":'Todas as secretarias',"options":_vm.secretarias,"selectOnTab":true},on:{"input":function($event){return _vm.consultar()}},model:{value:(_vm.unidade),callback:function ($$v) {_vm.unidade=$$v},expression:"unidade"}})],1)]),_vm._v(" "),(_vm.unidade)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('doughnut',{staticStyle:{"max-width":"300px","margin":"10px auto"},attrs:{"chart-data":_vm.doughnutContent,"gradiente":false,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("\n            "+_vm._s(this.unidade.unidaderesponsavel)+"\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.model.totalSecretaria))]),_vm._v("\n            "+_vm._s(_vm.texto[_vm.tipoPlanoCodigo].geral)+"\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(((_vm.model.totalSecretaria / _vm.model.total) * 100).toFixed(2))+"%")]),_vm._v("\n            do total de compromissos/metas\n          ")]),_vm._v(" "),(_vm.model.por_status_secretaria['CONCLUÍDA'])?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.model.por_status_secretaria['CONCLUÍDA']))]),_vm._v("\n            "+_vm._s(_vm.texto.todos.concluido)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.model.por_status_secretaria['EM ANDAMENTO'])?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.model.por_status_secretaria['EM ANDAMENTO']))]),_vm._v("\n            "+_vm._s(_vm.texto.todos.andamento)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.model.por_status_secretaria['NÃO CUMPRIDA'])?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.model.por_status_secretaria['NÃO CUMPRIDA']))]),_vm._v("\n            "+_vm._s(_vm.texto.todos.naoConcluido)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.model.por_status_secretaria['NÃO INICIADA'])?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.model.por_status_secretaria['NÃO INICIADA']))]),_vm._v("\n            "+_vm._s(_vm.texto.todos.analise)+"\n          ")]):_vm._e(),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.link_externo,"target":"_blank"}},[_c('i',{staticClass:"fa fa-list"}),_vm._v(" Veja a lista completa aqui")])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mais-compromissos"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.model.rank_compromissos),function(item){return _c('div',{key:item.rn,staticClass:"col-sm-4 margem-bottom"},[_c('h4',[_vm._v("\n            "+_vm._s(_vm.entidadeBySigla(item.unidaderesponsavel))+"\n          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(item.total))]),_vm._v(" de um total de "),_c('b',[_vm._v(_vm._s(_vm.model.total))])]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(((item.total / _vm.model.total) * 100).toFixed(2))+"%")]),_vm._v(" do\n            total\n          ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"rank-concluido"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"hidden-xs"},[_vm._m(4),_vm._v(" "),_vm._l((_vm.rankingConcluidas),function(item,index){return _c('div',{key:index + '-' + item.unidade,class:[index % 2 === 0 ? '' : 'lista-impar', 'row lista-body']},[_c('div',{staticClass:"col-xs-12 col-sm-1"},[_vm._v("\n            "+_vm._s(index + 1)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-5"},[_vm._v("\n            "+_vm._s(_vm.entidadeBySigla(item.unidade))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(item.total)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(item.concluidas)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(((item.concluidas / item.total) * 100).toFixed(2))+"%\n          ")])])}),_vm._v(" "),_c('div',{staticClass:"row lista-impar lista-header"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(_vm.totais.metas)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(_vm.totais.planogoverno.concluido + _vm.totais.prioridade.concluido)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s((
                ((_vm.totais.planogoverno.concluido +
                  _vm.totais.prioridade.concluido) /
                  _vm.totais.metas) *
                100
              ).toFixed(2) + '%')+"\n          ")])])],2),_vm._v(" "),_c('div',{staticClass:"row hidden-sm hidden-md hidden-lg"},_vm._l((_vm.rankingConcluidas),function(ref,index){
              var unidade = ref.unidade;
              var concluidas = ref.concluidas;
              var total = ref.total;
return _c('div',{key:unidade,staticClass:"col-sm-4 altura-card"},[_c('h4',[_vm._v(_vm._s(index + 1 + ' - ' + _vm.entidadeBySigla(unidade)))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(concluidas))]),_vm._v(" de um total de "),_c('b',[_vm._v(_vm._s(total))])]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(((concluidas / total) * 100).toFixed(2))+"%")]),_vm._v(" do total\n          ")])])}),0),_vm._v(" "),_c('div',{staticClass:"row margem-topo"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Downloads")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.DownloadJSON2CSV()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}}),_vm._v(" Exportar para CSV\n          ")],1)])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Informações por tipo de meta")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Informações por Secretaria")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Secretarias / Entidades com mais metas no total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Secretarias / Entidades com mais metas concluídas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row lista-impar lista-header"},[_c('div',{staticClass:"col-xs-12 col-sm-1"},[_vm._v("\n             \n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-5"},[_vm._v("\n            Unidade\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            Total de Metas\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            Concluídas\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            Percentual (%)\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-6 text-center"},[_c('strong',[_vm._v("Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4e97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_dados_user_UserBase__ = __webpack_require__("1NjD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_2__views_admin_dados_user_UserBase__["a" /* default */],
  data: function data() {
    return {
      title: 'Dados',
      type: 'DADO',
      model: {
        columnID: 'codigo',
        columns: []
      },
      periodicidades: []
    };
  },

  components: { list: __WEBPACK_IMPORTED_MODULE_3__components_common_DataTable__["a" /* default */] },
  created: function created() {
    this.createColumns();
    this.loadPeriodicidades();
  },

  methods: {
    createColumns: function createColumns() {
      this.model.columns = [{
        name: 'nome',
        title: 'Nome',
        dataClass: 'align-middle'
      }].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.createColumnsYearStatusValue()), [{
        name: 'periodicidade',
        title: 'Periodicidade',
        dataClass: 'align-middle col-md-1 text-center'
      }, {
        name: 'fonte',
        title: 'Fonte',
        dataClass: 'align-middle'
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]);
    },
    createColumnsYearStatusValue: function createColumnsYearStatusValue() {
      var columns = [];
      var propertiesDefault = {
        titleClass: 'text-center',
        dataClass: 'align-middle text-center'
      };

      for (var index = 0; index < 4; index++) {
        columns.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          name: '__slot:icon' + (index + 1),
          columnName: 'hasValorAno' + (index + 1),
          title: '' + (new Date().getFullYear() - (4 - index))
        }, propertiesDefault));
      }

      return columns;
    },
    loadPeriodicidades: function loadPeriodicidades() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('listar-periodicidades').then(function (response) {
        return _this.periodicidades = response.data.data;
      }).catch(function (error) {
        return console.log(error);
      });
    },
    consultar: function consultar() {
      this.$refs.vuetable.refresh();
    },
    limpar: function limpar() {
      this.nome = '';
      this.fonte = '';
      this.periodicidade_codigo = '*';
      this.status_values = '*';
      this.$refs.vuetable.refresh();
    }
  },
  computed: {
    filtros: function filtros() {
      var nome = this.nome,
          fonte = this.fonte,
          periodicidade_codigo = this.periodicidade_codigo,
          status_values = this.status_values;

      return {
        nome: nome,
        fonte: fonte,
        periodicidade_codigo: periodicidade_codigo,
        status_values: status_values
      };
    },

    pagina: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var pagina = dados.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dados',
          value: value
        });
      }
    },
    nome: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var nome = dados.filtros.nome;


        return nome;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'dados',
          value: value
        });
      }
    },
    fonte: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var fonte = dados.filtros.fonte;


        return fonte;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'fonte',
          collection: 'dados',
          value: value
        });
      }
    },
    periodicidade_codigo: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var periodicidade_codigo = dados.filtros.periodicidade_codigo;


        return periodicidade_codigo;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'periodicidade_codigo',
          collection: 'dados',
          value: value
        });
      }
    },
    status_values: {
      get: function get() {
        var dados = this.$store.state.vuetableState.dados;
        var status_values = dados.filtros.status_values;


        return status_values;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'status_values',
          collection: 'dados',
          value: value
        });
      }
    }
  }
});

/***/ }),

/***/ "4piF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin__ = __webpack_require__("x0vE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_painel__ = __webpack_require__("DZFG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_admin_relatorio__ = __webpack_require__("TtC/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__admin_assistencia__ = __webpack_require__("k2k2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__admin_concursos__ = __webpack_require__("lNFX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__admin_dados__ = __webpack_require__("wlNL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__admin_eixos__ = __webpack_require__("n/ii");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__admin_escalas__ = __webpack_require__("mz2l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__admin_materiais__ = __webpack_require__("/7+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__admin_metas__ = __webpack_require__("QLW5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__admin_planoGoverno__ = __webpack_require__("PNKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__admin_emendasParlamentares__ = __webpack_require__("CztK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__admin_tags__ = __webpack_require__("p69W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__admin_user__ = __webpack_require__("vC4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__admin_ods__ = __webpack_require__("n0p4");


















var routes = [{
  path: '/admin',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin__["a" /* default */],
  children: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_admin_painel__["a" /* default */],
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  }, {
    path: 'painel',
    component: __WEBPACK_IMPORTED_MODULE_2__views_admin_painel__["a" /* default */],
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  }, {
    name: 'admin_relatorio',
    path: 'relatorio',
    component: __WEBPACK_IMPORTED_MODULE_3__views_admin_relatorio__["a" /* default */],
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__admin_assistencia__["a" /* assistencia */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__admin_concursos__["a" /* concursos */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__admin_dados__["a" /* dados */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__admin_eixos__["a" /* eixos */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__admin_escalas__["a" /* escalas */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__admin_materiais__["a" /* materiais */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__admin_metas__["a" /* metas */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__admin_planoGoverno__["a" /* planoGoverno */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__admin_emendasParlamentares__["a" /* emendasParlamentares */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__admin_tags__["a" /* tags */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__admin_user__["a" /* users */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__admin_ods__["a" /* ods */]))
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "4u8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Select__ = __webpack_require__("MGJx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_events__ = __webpack_require__("VwQt");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Select: __WEBPACK_IMPORTED_MODULE_1__components_common_Select__["a" /* default */]
  },
  directives: {
    mask: __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__["mask"]
  },
  props: {
    value: {
      type: Object
    }
  },
  created: function created() {
    this.entrada = this.value.entrada;
    this.saida = this.value.saida;
  },
  data: function data() {
    return {
      timeList: [{ label: '08h - 18h', value: '08h00|18h00' }, { label: '07h - 13h', value: '07h00|13h00' }, { label: '12h - 18h', value: '12h00|18h00' }, { label: '07h - 19h', value: '07h00|19h00' }, { label: '19h - 07h', value: '19h00|07h00' }, { label: 'Outros', value: 'outros' }],
      time: '',
      entrada: '',
      saida: '',
      inputDisable: true
    };
  },

  watch: {
    time: function time(value) {
      this.inputDisable = value !== 'outros';

      if (value.length === 0 || !this.inputDisable) {
        this.resetTime();
        return;
      }

      if (this.inputDisable) {
        var _value$split = value.split('|'),
            _value$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_value$split, 2),
            entrada = _value$split2[0],
            saida = _value$split2[1];

        this.setTime({ entrada: entrada, saida: saida });
      }
    },

    value: {
      handler: function handler(value) {
        var entrada = value.entrada,
            saida = value.saida;

        if (entrada === '' && saida === '') {
          this.time = '';
        } else if (entrada === '' || saida === '') {
          this.time = 'outros';
        } else {
          var _value = entrada + '|' + saida;
          var timeListValues = this.timeList.map(function (t) {
            return t.value;
          });

          if (timeListValues.includes(_value)) {
            this.time = _value;
          } else {
            this.time = 'outros';
          }
        }
      },

      deep: true
    }
  },
  methods: {
    setTime: function setTime(_ref) {
      var entrada = _ref.entrada,
          saida = _ref.saida;

      this.entrada = this.formatTime(entrada);
      this.saida = this.formatTime(saida);
      this.update();
    },
    formatTime: function formatTime(time) {
      if (time.length === 0) {
        return time;
      }

      if (time.length === 2) {
        return time + 'h00';
      }

      return time;
    },
    clearTime: function clearTime() {
      this.resetTime();
      this.update();
    },
    resetTime: function resetTime() {
      this.entrada = this.saida = '';
    },
    update: function update() {
      this.entrada = this.formatTime(this.entrada);
      this.saida = this.formatTime(this.saida);

      var entrada = this.entrada,
          saida = this.saida;


      if (entrada.length > 0 || saida.length > 0) {
        this.$emit('input', { entrada: entrada, saida: saida });
      }
    },

    keydownFormatTime: __WEBPACK_IMPORTED_MODULE_3__utils_events__["a" /* keydownFormatTime */]
  }
});

/***/ }),

/***/ "4uWV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//@ts-nocheck
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    metas: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      imgUrl: this.$root.$data.imgUrl,
      logo: __webpack_require__("wOM0")
    };
  }
});

/***/ }),

/***/ "4vaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_NoApiTable__ = __webpack_require__("Vp40");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_3__components_common_NoApiTable__["a" /* default */] },
  data: function data() {
    return {
      error: {},
      import_file: '',
      isLoading: false,
      edital: {},
      cargos: [],
      habilitados: [],
      habilitados_pcd: [],
      habilitados_cotas: [],
      fields: [{
        name: 'descricao',
        title: 'Descrição'
      }, {
        name: 'vagas',
        title: 'Vagas',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }, {
        name: 'vagas_pcd',
        title: 'Vagas PCD',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }, {
        name: 'vagas_cotas',
        title: 'Vagas Negros',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }, {
        name: 'vagas_QP',
        title: 'Vagas QP',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }],
      fields_habilitados: [{
        name: 'classificacao',
        title: 'Classificação',
        dataClass: 'text-right'
      }, {
        name: 'descricao',
        title: 'Cargo'
      }, {
        name: 'nome',
        title: 'Nome'
      }, {
        name: 'tipo_normal',
        title: 'Geral',
        titleClass: 'text-center',
        dataClass: 'text-center',
        callback: function callback(value) {
          return value === 1 ? 'Sim' : 'Não';
        }
      }, {
        name: 'tipo_pcd',
        title: 'PCD',
        titleClass: 'text-center',
        dataClass: 'text-center',
        callback: function callback(value) {
          return value === 1 ? 'Sim' : 'Não';
        }
      }, {
        name: 'tipo_cotas',
        title: 'Negro',
        titleClass: 'text-center',
        dataClass: 'text-center',
        callback: function callback(value) {
          return value === 1 ? 'Sim' : 'Não';
        }
      }, {
        name: '__slot:actions',
        title: 'Excluir',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }]
    };
  },
  created: function created() {
    if (_.isEmpty(this.$route.params)) {
      this.$router.push({ name: 'editais' });
    } else {
      this.edital = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$route.params.edital);
      this.listarCargosEdital();
      this.listarHabilitadosEdital();
    }
  },

  methods: {
    baixarPlanilhaBase: function baixarPlanilhaBase() {
      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('habilitado/download-planilha-base', {
        responseType: 'arraybuffer'
      }).then(function (response) {
        var blob = new Blob([response.data], { type: 'application/csv' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'planilha-base.csv';
        link.click();
      });
    },
    excluir: function excluir(props) {
      var _this = this;

      var id = props.id,
          geral = props.geral,
          pcd = props.pcd,
          cotas = props.cotas;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].delete('habilitado/' + id, {
            params: { geral: geral, pcd: pcd, cotas: cotas, edital_id: _this.edital.id }
          }).then(function (response) {
            _this.$toastr.s('Candidato habilitado excluído com sucesso');
            _this.listarHabilitadosEdital();
          }).catch(function (error) {
            _this.$toastr.e('Houve um erro ao excluir o candidato habilitado, tente novamente e, se persistir o erro, entre em contato com o administrador.');
          });
        }
      };
      this.showConfirm('Deseja realmente excluir este candidato habilitado?', config);
    },
    onFileChange: function onFileChange(e) {
      this.import_file = e.target.files[0];
    },
    proceedAction: function proceedAction() {
      var _this2 = this;

      if (!this.import_file) {
        this.$toastr.e('Arquivo de importação não encontrado!');
        return;
      }
      this.handleLoading();
      var formData = new FormData();
      formData.append('import_file', this.import_file);
      formData.append('cargos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.cargos));

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('/habilitado', formData, {
        headers: { 'content-type': 'multipart/form-data' }
      }).then(function (response) {
        var msg = response.data.msg;

        _this2.$toastr.s(msg);
        _this2.listarHabilitadosEdital();
      }).catch(function (error) {
        var data = error.response.data;

        _this2.$toastr.e(data.message);
        _this2.error = error.response.data;
        console.log('check error: ', _this2.error);
      }).finally(this.handleLoading);
    },
    scrollToElement: function scrollToElement(refName) {
      var element = document.getElementById(refName);
      element.scrollIntoView({ behavior: 'smooth' });
    },
    listarCargosEdital: function listarCargosEdital() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('cargo', { params: { nr_edital: this.edital.numero } }).then(function (response) {
        var data = response.data;

        _this3.cargos = data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },

    filter: function filter(key) {
      return function (item) {
        return item[key] === 1;
      };
    },
    listarHabilitadosEdital: function listarHabilitadosEdital() {
      var _this4 = this;

      this.handleLoading();
      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('habilitado', { params: { edital_id: this.edital.id } }).then(function (response) {
        var data = response.data;

        _this4.habilitados = data.filter(_this4.filter('tipo_normal'));
        _this4.habilitados_pcd = data.filter(_this4.filter('tipo_pcd'));
        _this4.habilitados_cotas = data.filter(_this4.filter('tipo_cotas'));
      }).catch(function (error) {
        return console.log(error.response);
      }).finally(this.handleLoading);
    },
    handleLoading: function handleLoading() {
      this.isLoading = !this.isLoading;
    }
  }
});

/***/ }),

/***/ "4woO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"flex-container"},[_c('SelectScaleType',{attrs:{"disabled":_vm.referencia === null},model:{value:(_vm.scaleType),callback:function ($$v) {_vm.scaleType=$$v},expression:"scaleType"}})],1),_vm._v(" "),_c('SelectTime',{attrs:{"disabled":_vm.referencia === null},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1),_vm._v(" "),_c('ul',{staticClass:"body"},[_vm._l((_vm.weekdayOrdered),function(item,index){return _c('li',{key:index,class:['cel header', {
        'avaliable': item.avaliable,
        'active': item.active,
        'selected': item.selected
      }],on:{"click":function($event){return _vm.activeCellByWeekday(item)}}},[_vm._v("\n      "+_vm._s(item.label)+"\n    ")])}),_vm._v(" "),_vm._l((_vm.cels),function(cel){return _c('li',{key:cel.key,class:[
        'cel',
        cel.isAvaliable ? 'avaliable' : '',
        cel.active ? 'active' : '',
        cel.selected ? 'selected' : ''
      ],on:{"click":function($event){return _vm.selectDay(cel)}}},[_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(cel.day)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"content"},_vm._l((cel.times),function(time,index){return _c('TimeCell',{directives:[{name:"show",rawName:"v-show",value:(cel.active),expression:"cel.active"}],key:index,attrs:{"time":time}})}),1)])})],2),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"controls"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.daySelected.isEmpty),expression:"daySelected.isEmpty"}],staticClass:"info"},[_vm._v("Selecione algum dia para visualizar os períodos")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.daySelected.isEmpty),expression:"!daySelected.isEmpty"}]},[_c('label',{staticClass:"control-label"},[_vm._v("Dia: "+_vm._s(_vm.daySelected.day))]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Períodos")]),_vm._v(" "),_c('div',{staticClass:"times"},_vm._l((_vm.daySelected.times),function(item,index){return _c('TimeSpan',{key:item.entrada + item.saida,attrs:{"time":item,"click":function () { return _vm.removeTime(index); }}})}),1),_vm._v(" "),_c('SelectTime',{model:{value:(_vm.daySelected.timeToAdd),callback:function ($$v) {_vm.$set(_vm.daySelected, "timeToAdd", $$v)},expression:"daySelected.timeToAdd"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"button"},on:{"click":_vm.addTime}},[_vm._v("\n          Adicionar Período\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"status"},[_c('span',[_vm._v("Total de dias ativos: "+_vm._s(_vm.totalDaysActive))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "57pT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("00kC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11fe7be8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Vzbx");
function injectStyle (ssrContext) {
  __webpack_require__("5avL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11fe7be8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11fe7be8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5B48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Select__ = __webpack_require__("MGJx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_events__ = __webpack_require__("VwQt");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Select: __WEBPACK_IMPORTED_MODULE_1__components_common_Select__["a" /* default */]
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  created: function created() {
    this.entrada = this.value.entrada;
    this.saida = this.value.saida;
  },
  data: function data() {
    return {
      timeList: [{ label: '08h - 18h', value: '08:00|18:00' }, { label: '07h - 13h', value: '07:00|13:00' }, { label: '07h - 16h', value: '07:00|16:00' }, { label: '12h - 18h', value: '12:00|18:00' }, { label: '13h - 19h', value: '13:00|19:00' }, { label: '07h - 19h', value: '07:00|19:00' }, { label: '19h - 07h', value: '19:00|07:00' }, { label: 'Outros', value: 'outros' }],
      time: '',
      entrada: '00:00',
      saida: '00:00',
      inputDisable: true
    };
  },

  watch: {
    time: function time(value) {
      this.inputDisable = value !== 'outros';

      if (value === 'outros') {
        this.timeInfocus();
      }

      if (value.length === 0 || !this.inputDisable) {
        this.resetTime();
        return;
      }

      if (this.inputDisable) {
        var _value$split = value.split('|'),
            _value$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_value$split, 2),
            entrada = _value$split2[0],
            saida = _value$split2[1];

        this.setTime({ entrada: entrada, saida: saida });
      }
    },

    value: {
      handler: function handler(value) {
        var entrada = value.entrada,
            saida = value.saida;

        if (entrada === '' && saida === '') {
          this.time = '';
        } else if (entrada === '' || saida === '') {
          this.time = 'outros';
        } else {
          var _value = entrada + '|' + saida;
          var timeListValues = this.timeList.map(function (t) {
            return t.value;
          });

          if (timeListValues.includes(_value)) {
            this.time = _value;
          } else {
            this.time = 'outros';
          }
        }
      },

      deep: true
    }
  },
  methods: {
    setTime: function setTime(_ref) {
      var entrada = _ref.entrada,
          saida = _ref.saida;

      this.entrada = entrada;
      this.saida = saida;
      this.update();
    },
    clearTime: function clearTime() {
      this.resetTime();
      this.update();
    },
    resetTime: function resetTime() {
      this.entrada = this.saida = '';
    },
    update: function update() {
      var entrada = this.entrada,
          saida = this.saida;

      if (entrada.length > 0 || saida.length > 0) {
        this.$emit('input', { entrada: entrada, saida: saida });
      }
    },
    timeInfocus: function timeInfocus() {
      var _this = this;

      setTimeout(function () {
        return _this.$refs.entrada.focus();
      }, 200);
    },

    lockIfValueIsNull: __WEBPACK_IMPORTED_MODULE_2__utils_events__["b" /* lockIfValueIsNull */]
  }
});

/***/ }),

/***/ "5BkO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Painel")]),_vm._v(" "),_c('section',{staticClass:"col-lg-12"},[(_vm.dadosModerar > 0)?_c('article',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('header',[_c('font-awesome-icon',{staticClass:"fa-2x",staticStyle:{"color":"white"},attrs:{"icon":'list-alt'}})],1),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.dadosModerar))]),_vm._v(" "),_c('p',[_vm._v("Total de dados para moderar")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/dado/moderacao"}},[_c('span',[_vm._v("detalhes aqui")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":'arrow-right'}})],1)],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5BtY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_RECEITAS_PROPRIAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DETALHAMENTO_DESPESAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_GRUPO_DESPESAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_FUNCAO_SUBFUNCAO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_ADIANTAMENTOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_DESPESAS_DETALHADAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ANO_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TOGGLE_LOADING; });
var SET_RECEITAS_PROPRIAS = 'SET_RECEITAS_PROPRIAS';
var SET_DETALHAMENTO_DESPESAS = 'SET_DETALHAMENTO_DESPESAS';
var SET_GRUPO_DESPESAS = 'SET_GRUPO_DESPESAS';
var SET_FUNCAO_SUBFUNCAO = 'SET_FUNCAO_SUBFUNCAO';
var SET_ADIANTAMENTOS = 'SET_ADIANTAMENTOS';
var SET_DESPESAS_DETALHADAS = 'SET_DESPESAS_DETALHADAS';
var SET_ANO_BASE = 'SET_ANO_BASE';
var TOGGLE_LOADING = 'TOGGLE_LOADING';

/***/ }),

/***/ "5L+s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_planogoverno_SidePlanoGoverno_vue__ = __webpack_require__("3p2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { list: __WEBPACK_IMPORTED_MODULE_2__components_common_DataTable__["a" /* default */], SidePlanoGoverno: __WEBPACK_IMPORTED_MODULE_3__components_planogoverno_SidePlanoGoverno_vue__["a" /* default */] },
    data: function data() {
        return {
            fields: [{
                name: 'periodo',
                title: 'Período',
                filterable: true,
                titleClass: 'text-center text-nowrap',
                dataClass: 'text-center text-nowrap'
            }, {
                name: 'descritivo',
                title: 'Compromisso',
                filterable: true
            }, {
                name: '__slot:actions',
                title: 'Ações',
                titleClass: 'text-center col-md-3',
                dataClass: 'text-center'
            }],
            filtros: {
                periodo: ''
            },
            periodos: ['2021-2024', '2025-2028'],
            sideConfig: [{
                titulo: 'Cancelar',
                subtitulo: '',
                subtDetalhe: '',
                largura: 900,
                identidade: 'cancelar',
                abreProximo: false,
                aberto: false,
                data: null
            }]
        };
    },

    methods: {
        cancelar: function cancelar(compromisso) {
            this.sideConfig[0].data = compromisso;
            this.sideConfig[0].subtitulo = compromisso.descritivo;

            this.$refs.side.$emit('abreModal', this.sideConfig[0].identidade);
        },
        cancelarAcoes: function cancelarAcoes(compromisso) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var acoes;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                acoes = compromisso.acoes || [];


                                if (acoes && Array.isArray(acoes)) {
                                    acoes.forEach(function () {
                                        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(acao) {
                                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                                while (1) {
                                                    switch (_context.prev = _context.next) {
                                                        case 0:
                                                            if (!(acao.status !== 'Cancelado' || acao.status !== 'Rejeitada')) {
                                                                _context.next = 9;
                                                                break;
                                                            }

                                                            _context.prev = 1;
                                                            _context.next = 4;
                                                            return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].put('planogoverno/compromisso-acao/' + acao.id, {
                                                                justificativa_rejeicao: 'Compromisso cancelado',
                                                                status: 'Cancelada'
                                                            });

                                                        case 4:
                                                            _context.next = 9;
                                                            break;

                                                        case 6:
                                                            _context.prev = 6;
                                                            _context.t0 = _context['catch'](1);

                                                            console.error('Erro ao cancelar a a\xE7\xE3o com ID ' + acao.id + ':', _context.t0);

                                                        case 9:
                                                        case 'end':
                                                            return _context.stop();
                                                    }
                                                }
                                            }, _callee, _this, [[1, 6]]);
                                        }));

                                        return function (_x) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }());
                                }

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        aceitarRequisicao: function aceitarRequisicao(compromisso) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _ref2, status;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return _this2.cancelarAcoes(compromisso);

                            case 3:
                                _context3.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].put('planogoverno/compromisso/' + compromisso.id, { status: 'Cancelado' });

                            case 5:
                                _ref2 = _context3.sent;
                                status = _ref2.status;

                                if (!(status !== 200)) {
                                    _context3.next = 9;
                                    break;
                                }

                                return _context3.abrupt('return', _this2.$toastr.e('Erro ao cancelar o compromisso.'));

                            case 9:

                                _this2.$refs.vuetable.refresh();
                                _this2.$toastr.s('Compromisso cancelado com sucesso.');
                                _this2.$refs.side.$emit('fechaModal', _this2.sideConfig[0].identidade);
                                _context3.next = 18;
                                break;

                            case 14:
                                _context3.prev = 14;
                                _context3.t0 = _context3['catch'](0);

                                console.error('Erro ao aceitar a requisição de cancelamento:', _context3.t0);
                                _this2.$toastr.e('Ocorreu um erro no processo de cancelamento.');

                            case 18:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2, [[0, 14]]);
            }))();
        },
        rejeitarRequisicao: function rejeitarRequisicao(compromissoId) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var _ref3, status;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;
                                _context4.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].put('planogoverno/compromisso/' + compromissoId, { justificativa_cancelamento: null });

                            case 3:
                                _ref3 = _context4.sent;
                                status = _ref3.status;

                                if (!(status !== 200)) {
                                    _context4.next = 7;
                                    break;
                                }

                                return _context4.abrupt('return', _this3.$toastr.e('Erro ao rejeitar a solicitação.'));

                            case 7:

                                _this3.$refs.vuetable.refresh();
                                _this3.$toastr.s('Solicitação de cancelamento rejeitada com sucesso.');
                                _this3.$refs.side.$emit('fechaModal', _this3.sideConfig[0].identidade);
                                _context4.next = 16;
                                break;

                            case 12:
                                _context4.prev = 12;
                                _context4.t0 = _context4['catch'](0);

                                console.error('Erro ao rejeitar o cancelamento:', _context4.t0);
                                _this3.$toastr.e('Erro ao rejeitar a solicitação.');

                            case 16:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this3, [[0, 12]]);
            }))();
        },
        resetFiltros: function resetFiltros() {
            this.filtros.periodo = '';
            this.filtros.status = '';
        }
    }
});

/***/ }),

/***/ "5Os7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoCompromissos_vue__ = __webpack_require__("5L+s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c086b33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoCompromissos_vue__ = __webpack_require__("JJxc");
function injectStyle (ssrContext) {
  __webpack_require__("BTPm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c086b33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoCompromissos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c086b33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoCompromissos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Yti":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5avL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5hKR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5hm6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common___ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_colors_js__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Card__ = __webpack_require__("9i0h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PublicHeader: __WEBPACK_IMPORTED_MODULE_2__components_common___["a" /* PublicHeader */], BarChart: __WEBPACK_IMPORTED_MODULE_2__components_common___["d" /* BarChart */], Card: __WEBPACK_IMPORTED_MODULE_4__Card__["a" /* default */], AnoBase: __WEBPACK_IMPORTED_MODULE_2__components_common___["j" /* AnoBase */] },
  data: function data() {
    return {
      cores: [],
      graficos_base: { labels: [], datasets: [{ label: '', data: [] }] }
    };
  },
  created: function created() {
    this.cores = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__utils_colors_js__["a" /* default */].coresHexa));
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },

  methods: {
    filtrarPorCodigo: function filtrarPorCodigo(codigo) {
      var receitas_proprias = this.$store.state.receitas_despesas.receitas_proprias;


      var filterByID = function filterByID(obj) {
        if ('cd_plano_conta_rel' in obj && obj.cd_plano_conta_rel === codigo) {
          return true;
        } else {
          return false;
        }
      };

      var receitasAtual = receitas_proprias.filter(filterByID);

      if (receitasAtual.length === 0) return false;else return {
        atual: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, receitasAtual[0])
      };
    },
    getDataCards: function getDataCards() {
      var receitaID = this.receitaID,
          hasLinks = this.hasLinks;

      var contas = this.getSubContas(receitaID);
      var datacards = [];

      contas.atual.forEach(function (contaAtual) {
        var codigo = contaAtual.cd_plano_conta_rel,
            title = contaAtual.ds_plano_conta,
            vl_total = contaAtual.vl_total,
            vl_atualizado = contaAtual.vl_atualizado,
            vl_total_f = contaAtual.vl_total_f,
            vl_atualizado_f = contaAtual.vl_atualizado_f;


        var percentual = vl_atualizado_f > 0 ? (vl_total_f / vl_atualizado_f * 100).toFixed(0) : '---';

        var data = [{ label: 'Previsão Anual', value: vl_atualizado }, { label: 'Arrecadado', value: vl_total }, {
          label: 'Percentual',
          value: 'Arrecadado aproximadamente ' + percentual + '% da previs\xE3o'
        }];

        var item = { codigo: codigo, title: title, data: data };

        if (hasLinks(contaAtual)) item.link = '/receitas/detalhes/' + codigo + '/';

        datacards.push(item);
      });

      return datacards;
    },
    getSubContas: function getSubContas(codigo) {
      var receitas_proprias = this.$store.state.receitas_despesas.receitas_proprias;

      var nivelAtual = codigo.split('.').length;
      var atual = [];

      var contaProximoNivel = receitas_proprias.find(function (_ref) {
        var cd_plano_conta_rel = _ref.cd_plano_conta_rel,
            nivel = _ref.nivel;
        return cd_plano_conta_rel.indexOf(codigo) === 0 && nivel > nivelAtual;
      });

      if (contaProximoNivel) {
        var proximoNivel = contaProximoNivel.nivel;

        atual = receitas_proprias.filter(function (_ref2) {
          var cd_plano_conta_rel = _ref2.cd_plano_conta_rel,
              nivel = _ref2.nivel;
          return cd_plano_conta_rel.indexOf(codigo) === 0 && nivel === proximoNivel;
        });
      }

      return { atual: atual };
    },
    hasLinks: function hasLinks(conta) {
      var receitas_proprias = this.$store.state.receitas_despesas.receitas_proprias;
      var codigo = conta.cd_plano_conta_rel;

      var nivelAtual = codigo.split('.').length;

      var _receitas_proprias$fi = receitas_proprias.filter(function (_ref3) {
        var cd_plano_conta_rel = _ref3.cd_plano_conta_rel,
            nivel = _ref3.nivel;
        return cd_plano_conta_rel.indexOf(codigo) === 0 && nivel > nivelAtual;
      }),
          contasAtualCount = _receitas_proprias$fi.length;

      return contasAtualCount > 0;
    },
    getContaCodigoAnterior: function getContaCodigoAnterior(codigo) {
      var array = String(codigo).split('.');
      var receita = undefined;

      do {
        array.pop();
        var codigoAnterior = array.join('.');
        receita = this.getReceita(codigoAnterior);
      } while (receita === undefined && array.length > 1);

      return receita ? receita.cd_plano_conta_rel : false;
    },
    getReceita: function getReceita(codigo) {
      var receitas_proprias = this.$store.state.receitas_despesas.receitas_proprias;

      var receita = receitas_proprias.find(function (item) {
        return item.cd_plano_conta_rel === codigo;
      });

      return receita;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({
    anoAtual: function anoAtual(state) {
      return state.receitas_despesas.ano_base;
    }
  }), {
    retornaMesComparativo: function retornaMesComparativo() {
      var data = new Date();
      if (this.anoAtual !== data.getFullYear()) {
        return new Date(this.anoAtual, 11, 31).toLocaleString('default', { month: 'long' });
      }

      return data.toLocaleString('default', { month: 'long' });
    },
    receitaID: function receitaID() {
      return String(this.$route.params.id);
    },
    title: function title() {
      var getReceita = this.getReceita,
          receitaID = this.receitaID;

      var receita = getReceita(receitaID);

      return receita ? receita.ds_plano_conta : 'Ops este código de receita não foi encontrado!';
    },
    breadcrumbLinks: function breadcrumbLinks() {
      var getContaCodigoAnterior = this.getContaCodigoAnterior,
          receitaID = this.receitaID;

      var linksDefault = [{ descricao: 'Início', url: '/' }, { descricao: 'Receitas e Despesas', url: '/receitas_despesas' }, { descricao: 'Receitas', url: '/receitas' }];

      var codigo = receitaID;

      if (codigo.length === 1) return linksDefault;

      var links = [];

      do {
        var codigoAnterior = getContaCodigoAnterior(codigo);
        var receitaAnterior = this.getReceita(codigoAnterior);

        if (receitaAnterior) {
          var _getReceita = this.getReceita(codigoAnterior),
              descricao = _getReceita.ds_plano_conta;

          var url = '/receitas/detalhes/' + codigoAnterior + '/';

          links.push({ descricao: descricao, url: url });
        }

        codigo = codigoAnterior;
      } while (codigo.length > 1);

      return [].concat(linksDefault, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(links.reverse()));
    },
    dataCards: function dataCards() {
      return this.getDataCards();
    },
    graficoHeader: function graficoHeader() {
      var receitaID = this.receitaID,
          filtrarPorCodigo = this.filtrarPorCodigo;

      var labels = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
      var dados = filtrarPorCodigo(receitaID);
      var data = [];

      for (var index = 0; index < labels.length; index++) {
        var element = labels[index].toLowerCase();
        data.push(dados.atual['vl_' + element + '_f']);
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.graficos_base, {
        labels: labels,
        datasets: [{
          label: 'Receita Mensal - ' + this.anoAtual,
          backgroundColor: this.cores[0],
          data: data
        }]
      });
    }
  })
});

/***/ }),

/***/ "5qSO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mp-medida-save',
  data: function data() {
    return {
      label: 'Adicionar',
      apiUrl: 'material/medida',
      model: {
        nome: ''
      },
      carregando: false
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  methods: {
    toogleLoading: function toogleLoading() {
      this.carregando = !this.carregando;
    },
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Este item foi salvo com sucesso.');
      this.$router.push({ name: 'user_material_medida' });
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
      this.toogleLoading();
    },
    save: function save() {
      var _this = this;

      this.toogleLoading();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.$refs[_this.$validator.errors.items[0].field].focus();
          _this.$toastr.e(_this.$validator.errors.items[0].msg);
          return;
        }

        __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].post(_this.apiUrl, _this.model).then(_this.saveSuccess).catch(_this.saveFail);
      });
    }
  }
});

/***/ }),

/***/ "5rA9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return remedios; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_public_remedios__ = __webpack_require__("Ki+E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_public_remedios_Unidades__ = __webpack_require__("+PuP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_public_remedios_DetalheUnidade__ = __webpack_require__("wCRM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const__ = __webpack_require__("4Nwh");





var remedios = [{
  name: 'remedio',
  path: '/remedio-facil',
  component: __WEBPACK_IMPORTED_MODULE_0__views_public_remedios__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_3__const__["a" /* DEFAULT_TITLE */] + ' | Rem\xE9dio F\xE1cil'
  }
}, {
  name: 'unidades-remedio',
  path: '/remedio-facil/unidades/:principio',
  component: __WEBPACK_IMPORTED_MODULE_1__views_public_remedios_Unidades__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_3__const__["a" /* DEFAULT_TITLE */] + ' | Unidades com rem\xE9dio'
  }
}, {
  name: 'detalhe-unidade',
  path: '/remedio-facil/unidade/:detalhes',
  component: __WEBPACK_IMPORTED_MODULE_2__views_public_remedios_DetalheUnidade__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_3__const__["a" /* DEFAULT_TITLE */] + ' | Lista de rem\xE9dios por unidade'
  }
}];

/***/ }),

/***/ "5t1y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cargos"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('input-vagas',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['custom-font', { 'is-danger': _vm.errors.has('cargos') }],attrs:{"cssClass":'col-xs-12',"label":'Descrição do Cargo',"name":'cargos',"error":_vm.errors.has('cargos') ? _vm.errors.first('cargos') : ''},model:{value:(_vm.model.descricao),callback:function ($$v) {_vm.$set(_vm.model, "descricao", $$v)},expression:"model.descricao"}}),_vm._v(" "),_c('input-vagas',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],class:['custom-font', { 'is-danger': _vm.errors.has('total') }],attrs:{"label":'Total de Vagas',"name":'total',"error":_vm.errors.has('total') ? _vm.errors.first('total') : ''},model:{value:(_vm.model.vagas),callback:function ($$v) {_vm.$set(_vm.model, "vagas", $$v)},expression:"model.vagas"}}),_vm._v(" "),_c('input-vagas',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],class:['custom-font', { 'is-danger': _vm.errors.has('vagas_pcd') }],attrs:{"label":'Vagas PCD',"name":'vagas_pcd',"error":_vm.errors.has('vagas_pcd') ? _vm.errors.first('vagas_pcd') : ''},model:{value:(_vm.model.vagas_pcd),callback:function ($$v) {_vm.$set(_vm.model, "vagas_pcd", $$v)},expression:"model.vagas_pcd"}}),_vm._v(" "),_c('input-vagas',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],class:['custom-font', { 'is-danger': _vm.errors.has('vagas_cotas') }],attrs:{"label":'Vagas Cotas',"name":'vagas_cotas',"error":_vm.errors.has('vagas_cotas') ? _vm.errors.first('vagas_cotas') : ''},model:{value:(_vm.model.vagas_cotas),callback:function ($$v) {_vm.$set(_vm.model, "vagas_cotas", $$v)},expression:"model.vagas_cotas"}}),_vm._v(" "),_c('input-vagas',{directives:[{name:"validate",rawName:"v-validate",value:('numeric'),expression:"'numeric'"}],class:['custom-font', { 'is-danger': _vm.errors.has('vagas_qp') }],attrs:{"label":'Vagas QP',"name":'vagas_qp',"error":_vm.errors.has('vagas_qp') ? _vm.errors.first('vagas_qp') : ''},model:{value:(_vm.model.vagas_QP),callback:function ($$v) {_vm.$set(_vm.model, "vagas_QP", $$v)},expression:"model.vagas_QP"}}),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12 col-sm-6 col-md-3"},[_c('label',{staticClass:"custom-font"},[_vm._v("Homologação")]),_vm._v(" "),_c('datepicker',{ref:"data_homologacao",attrs:{"name":"data_homologacao"},model:{value:(_vm.model.data_homologacao),callback:function ($$v) {_vm.$set(_vm.model, "data_homologacao", $$v)},expression:"model.data_homologacao"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12 col-sm-6 col-md-3"},[_c('label',{staticClass:"custom-font"},[_vm._v("Validade")]),_vm._v(" "),_c('datepicker',{ref:"data_validade",attrs:{"name":"data_validade"},model:{value:(_vm.model.data_validade),callback:function ($$v) {_vm.$set(_vm.model, "data_validade", $$v)},expression:"model.data_validade"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 form-group"},[_c('label',{staticClass:"custom-font"},[_vm._v("Observação")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.observacao_validade),expression:"model.observacao_validade"}],staticClass:"form-control",domProps:{"value":(_vm.model.observacao_validade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "observacao_validade", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 form-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.salvar()}}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":_vm.model.id ? 'save' : 'plus'}}),_vm._v("\n        "+_vm._s(_vm.model.id ? 'Salvar' : 'Adicionar')+"\n      ")],1),_vm._v(" "),(_vm.model.id)?_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.homologarTodos()}}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n        Homologar Todos\n      ")],1):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table',{ref:"vuetable",attrs:{"dados":_vm.cargos,"fields":_vm.fields,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.selecionarCargo(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Editar")])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir")])],1)]}}])})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{staticClass:"custom-subtitle"},[_vm._v("Cadastro de Cargos")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5t6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.label)+" Medida")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('form',{attrs:{"role":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('fieldset',[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('nome') }]},[_c('label',{class:[
                  'col-xs-12',
                  'control-label',
                  'custom-font',
                  { 'is-danger': _vm.errors.has('nome') }
                ]},[_vm._v("Nome da Medida")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 inputGroupContainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('nome') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome",class:[
                      'form-control',
                      { 'is-danger': _vm.errors.has('nome') }
                    ],attrs:{"name":"nome","maxlength":"50","placeholder":"Nome","type":"text"},domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': _vm.errors.has('nome') }
                    ],domProps:{"textContent":_vm._s(50 - _vm.model.nome.length)}})]),_vm._v(" "),(_vm.errors.has('nome'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"nome"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('nome'))+"\n                ")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n                  Salvar\n                ")],1)])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6+O2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.dado.nome))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4 col-md-3"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('data') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Data")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'calendar-alt'}})],1),_vm._v(" "),_c('datepicker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"data",attrs:{"name":"data"},model:{value:(_vm.model.data),callback:function ($$v) {_vm.$set(_vm.model, "data", $$v)},expression:"model.data"}})],1),_vm._v(" "),(_vm.errors.has('data'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"data"}},[_vm._v(_vm._s(_vm.errors.first('data')))]):_vm._e()])]),_vm._v(" "),_c('div',{class:['col-xs-12', { 'col-sm-4 col-md-3': !_vm.isValueTexto() }]},[_c('div',{class:[
            'form-group',
            {
              'has-error': _vm.errors.has(_vm.isValueTexto() ? 'resposta' : 'valor')
            }
          ]},[_c('label',{staticClass:"control-label custom-font",domProps:{"textContent":_vm._s(_vm.isValueTexto() ? 'Resposta' : 'Valor')}}),_vm._v(" "),(_vm.isValueInteiro() || _vm.isValueDecimal())?_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'money-bill'}})],1),_vm._v(" "),(_vm.isValueInteiro())?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.value),expression:"model.value"},{name:"validate",rawName:"v-validate",value:({
                  required: true,
                  regex: /^[\+|\-]?[0-9]+$/
                }),expression:"{\n                  required: true,\n                  regex: /^[\\+|\\-]?[0-9]+$/\n                }"}],ref:"inteiro",staticClass:"form-control",attrs:{"name":"valor","type":"text"},domProps:{"value":(_vm.model.value)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "value", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.isValueDecimal())?_c('money',_vm._b({directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"decimal",staticClass:"form-control",attrs:{"name":"valor"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save()}},model:{value:(_vm.model.value),callback:function ($$v) {_vm.$set(_vm.model, "value", $$v)},expression:"model.value"}},'money',_vm.configMoney(),false)):_vm._e()],1),_vm._v(" "),(_vm.errors.has('valor'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"valor"}},[_vm._v(_vm._s(_vm.errors.first('valor')))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isValueTexto())?_c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.value),expression:"model.value"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"resposta",staticClass:"form-control",attrs:{"name":"resposta","rows":"7","placeholder":"Digite aqui sua resposta..."},domProps:{"value":(_vm.model.value)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "value", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('resposta'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"resposta"}},[_vm._v(_vm._s(_vm.errors.first('resposta'))+"\n            ")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Observação")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.observacao),expression:"model.observacao"}],ref:"observacao",staticClass:"form-control",attrs:{"rows":"7","name":"observacao","placeholder":"Digite aqui sua observação..."},domProps:{"value":(_vm.model.observacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "observacao", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"30px"}},[_c('div',[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n              Salvar\n            ")],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "63id":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("/heK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555f49d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("7uuu");
function injectStyle (ssrContext) {
  __webpack_require__("7Ry1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-555f49d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555f49d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6DEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("OpFw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecc86316_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("DMGv");
function injectStyle (ssrContext) {
  __webpack_require__("S43H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecc86316_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6F2v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6IHv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_dist_vuex_common_js__ = __webpack_require__("9xAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_dist_vuex_common_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_dist_vuex_common_js__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_1__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components__["b" /* Breadcrumb */],
    SelectAnoEmendas: __WEBPACK_IMPORTED_MODULE_1__components__["p" /* SelectAnoEmendas */],
    ValorDestaqueHeader: __WEBPACK_IMPORTED_MODULE_1__components__["q" /* ValorDestaqueHeader */]
  },
  data: function data() {
    return {
      breadcrumb: [{
        label: 'Emendas Parlamentares'
      }]
    };
  },

  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_3__utils__["e" /* formatarMoeda */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])({
    emendas: function emendas(state) {
      return state.emendas_parlamentares.emendas;
    },
    loading: function loading(state) {
      return state.emendas_parlamentares.loading;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_dist_vuex_common_js__["mapGetters"])(['quantidadeEmendas', 'valorTotalEmendas', 'quantidadeVereadores', 'saldoTotal', 'valorTotalUtilizado']))
});

/***/ }),

/***/ "6JGi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("1JgW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48f66099_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("nOv1");
function injectStyle (ssrContext) {
  __webpack_require__("fBmq")
  __webpack_require__("fApd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48f66099"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48f66099_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6K9S":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./LogoPMS.svg": "tz3W",
	"./LogoPMS_old.svg": "/3wm",
	"./brasao-cor-branco-vertical.svg": "wOM0",
	"./conecte-sus.svg": "c/cq",
	"./ico-assistencia.svg": "9+xg",
	"./ico-azul.svg": "iDa5",
	"./ico-compras.svg": "kzZg",
	"./ico-comunicacao.svg": "Glix",
	"./ico-cultura.svg": "pdY+",
	"./ico-default.svg": "6ig6",
	"./ico-educacao.svg": "TeJu",
	"./ico-esporte.svg": "8m+r",
	"./ico-financas.svg": "R+m3",
	"./ico-gestao.svg": "lFPT",
	"./ico-governo.svg": "k82x",
	"./ico-imovel.svg": "G2dL",
	"./ico-manutencao.svg": "adyD",
	"./ico-meioambiente.svg": "uC+7",
	"./ico-ouvidoria.svg": "GIS3",
	"./ico-porto.svg": "Ffni",
	"./ico-saude.svg": "yZwr",
	"./ico-seguranca.svg": "M9oD",
	"./ico-servico-servicospublicos.svg": "V7DC",
	"./ico-servidor.svg": "jDDP",
	"./ico-turismo.svg": "8bzg",
	"./ico-urbanismo.svg": "MEYP",
	"./ico-verde.svg": "i1A9",
	"./ico-vermelho.svg": "3R7G"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6K9S";

/***/ }),

/***/ "6QmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArquivosEdital_vue__ = __webpack_require__("3TAq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f0a164e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArquivosEdital_vue__ = __webpack_require__("H9Tw");
function injectStyle (ssrContext) {
  __webpack_require__("N0hf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f0a164e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArquivosEdital_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f0a164e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArquivosEdital_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6SM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remedios"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"container imagens-logo"},[_c('div',{staticClass:"col-xs-12"},[_c('img',{staticClass:"img-logo-remedio",attrs:{"src":__webpack_require__("nkjI"),"alt":"Uma representação de um remédio com um símbolo positivo"}})])]),_vm._v(" "),_c('PublicHeader',{attrs:{"title":"Remédio Fácil","showTitle":false}},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-5"},[_c('p',{staticClass:"subheader"},[_vm._v("\n          Encontre os medicamentos da Relação Municipal de Medicamentos -\n          REMUME, disponíveis em uma das Policlínicas, CAPSs e AMBESPs do\n          município de Santos.\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":[{ label: 'Remédio Fácil' }]}}),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"input-group form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termoBusca),expression:"termoBusca"},{name:"validate",rawName:"v-validate",value:('required|min:3'),expression:"'required|min:3'"}],ref:"descricao",class:[
                'form-control',
                'input-pesquisar',
                { 'is-danger': _vm.errors.has('descricao') }
              ],attrs:{"type":"text","name":"descricao","id":"descricao","placeholder":"Ex.: Paracetamol, dipirona, losartan...."},domProps:{"value":(_vm.termoBusca)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.consultar()},"input":function($event){if($event.target.composing){ return; }_vm.termoBusca=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default btn-pesquisar",attrs:{"type":"button","title":"Pesquisar","disabled":_vm.carregando},on:{"click":function($event){return _vm.consultar()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"alt":"Ícone giratório representando a espera de carregamento","spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'search',"alt":"Ícone de uma lupa representando a ação de pesquisar"}})],1)])]),_vm._v(" "),(_vm.remedios.length)?_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.limparConsulta()}}},[_c('font-awesome-icon',{attrs:{"icon":'times'}}),_vm._v(" Limpar\n          ")],1):_vm._e(),_vm._v(" "),(_vm.errors.has('descricao'))?_c('small',{},[_c('span',{staticClass:"is-danger"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v(" \n              "+_vm._s(_vm.getErrors.descricao)+"\n            ")],1)]):_vm._e()])]),_vm._v(" "),(_vm.retornoVazio)?_c('div',{staticClass:"row"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.remedios),function(remedio){return _c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3"},[_c('router-link',{attrs:{"to":{
              name: 'unidades-remedio',
              params: { principio: remedio.principio_ativo, remedio: remedio }
            }}},[_c('div',{staticClass:"card card-remedios"},[_vm._v("\n              "+_vm._s(remedio.principio_ativo)+"\n              "),(remedio.portaria === '344/98')?_c('span',[_vm._v("\n                Medicamento Controlado - Portaria 344/98\n              ")]):_vm._e(),_vm._v(" "),(remedio.portaria === '471/2021')?_c('span',[_vm._v("\n                Medicamento Antimicrobiano - RDC 471/2021\n              ")]):_vm._e()])])],1)}),0),_vm._v(" "),_vm._m(2)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n            Pesquise pelo nome genérico / princípio ativo do medicamento\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('p',{staticClass:"text-center"},[_vm._v("\n            Nenhum resultado encontrado para o critério de busca.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n            Orientações para prescrição e dispensação de medicamentos da\n            Relação Municipal de Medicamentos - REMUME\n          ")]),_vm._v(" "),_c('ol',{staticClass:"font-lg"},[_c('li',[_vm._v("\n              Serão aceitas receitas em nome de munícipes e provenientes de\n              Unidades de Saúde pertencentes ao Sistema Único de Saúde (SUS)\n              ou conveniadas a rede municipal; (Portaria SMS 27/2023)\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n              A dispensação de medicamentos nas Unidades do SUS sob gestão\n              Municipal deverá ocorrer mediante a apresentação dos seguintes\n              documentos: receita impressa do munícipe e documento com foto do\n              responsável pela retirada; excetua-se a esta regra as\n              prescrições com assinatura digital para as quais não é\n              obrigatória a apresentação da receita impressa; (Portaria SMS\n              27/2023)\n              "),_c('ol',{staticClass:"alpha"},[_c('li',[_vm._v("\n                  Em caso de retirada de Medicamentos por pessoas entre 16 e\n                  18 anos em que a receita não seja do responsável pela\n                  retirada, deverá ser apresentado também um documento com\n                  foto do paciente.\n                ")])])]),_vm._v(" "),_c('li',[_vm._v("\n              Caso o medicamento seja de Uso Contínuo, deve constar tal\n              informação na Receita;\n              "),_c('ol',{staticClass:"alpha"},[_c('li',[_vm._v("\n                  Medicamentos de Uso Contínuo serão fornecidos para períodos\n                  de 30 dias, sendo a validade da receita de 6 meses. Exceto\n                  para os Medicamentos controlados da Portaria 344/98;\n                ")])])]),_vm._v(" "),_c('li',[_vm._v("\n              Medicamentos da Portaria 344/98 devem ser prescritos em duas\n              vias (via da farmácia e via do usuário) e a receita tem validade\n              de 30 dias\n              "),_c('ol',{staticClass:"alpha"},[_c('li',[_vm._v("\n                  Medicamentos da Lista A - necessitam de notificação de\n                  receita A + prescrição em duas vias;\n                ")]),_vm._v(" "),_c('li',[_vm._v("\n                  Medicamentos da Lista B - necessitam de notificação de\n                  receita B + prescrição em duas vias;\n                ")])])]),_vm._v(" "),_c('li',[_vm._v("\n              Antimicrobianos pertencentes a RDC 471/2021 devem ser prescritos\n              em duas vias (via da farmácia e via do usuário), sendo a\n              validade da receita de 10 dias.\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n              Pacientes insulinodependentes ficam vinculados a sua unidade de\n              origem para a retirada de insumos e Insulinas\n            ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6SaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("T/5l");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6617c946_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("9t06");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6617c946_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6bWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListaFilaEspera_vue__ = __webpack_require__("D1IN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f6501a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListaFilaEspera_vue__ = __webpack_require__("8L5u");
function injectStyle (ssrContext) {
  __webpack_require__("WDd6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5f6501a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListaFilaEspera_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5f6501a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListaFilaEspera_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6hxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    detalhes: {
      type: Object,
      required: true
    },
    valores: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      meses: __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* mesesAbr */]
    };
  },

  methods: {
    formatValue: function formatValue(value) {
      var val = value;
      switch (this.detalhes.dado.tipo) {
        case 'D':
          val = (value / 1).toFixed(2).replace('.', ',');
          val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          break;
        case 'I':
          val = (value / 1).toFixed(0);
          val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          break;
      }

      return val;
    } /*
      Retorna um objeto contendo os anos como propriedades e
      cada propriedade contém um array de 12 posições representando os meses.
      Ex: { 2019: [1,2,3,4,5,6,7,8,9,10,11,12], 2020: [1,2,3,4,5,6,7,8,9,10,11,12] }
      */
    ,
    retornarObjetoMensal: function retornarObjetoMensal() {
      var dados = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.valores));
      var year_base = {};
      var value_base = new Array(12).fill(0);

      for (var index = 0; index < dados.length; index++) {
        var element = dados[index];
        var data = new Date(dados[index].data);
        var ano = data.getFullYear();
        var mes = data.getMonth();

        if (!year_base[ano]) {
          year_base[ano] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(value_base));
        }

        year_base[ano].splice(mes, 1, element.valor);
      }

      return year_base;
    }
  },
  computed: {
    dados_tabela: function dados_tabela() {
      var dados_mensal = this.retornarObjetoMensal();
      var anos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dados_mensal);
      var retorno = {
        header: ['Ano'].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.meses)),
        body: []
      };

      for (var index = 0; index < anos.length; index++) {
        var ano = anos[index];
        retorno.body.push([ano].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(dados_mensal[ano])));
      }

      return retorno;
    }
  }
});

/***/ }),

/***/ "6iLB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ig6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "6qvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_escalas_js__ = __webpack_require__("s4g1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d32f517_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("zTH1");
function injectStyle (ssrContext) {
  __webpack_require__("dLWi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d32f517"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_escalas_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d32f517_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6st+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("l9ae");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f02bd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("VByn");
function injectStyle (ssrContext) {
  __webpack_require__("w4jo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72f02bd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72f02bd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6yB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListaPrestacoes_vue__ = __webpack_require__("ZdZn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd26439_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListaPrestacoes_vue__ = __webpack_require__("CVOO");
function injectStyle (ssrContext) {
  __webpack_require__("Ud3u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dd26439"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListaPrestacoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd26439_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListaPrestacoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6yGG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7/wm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.6edd015.jpg";

/***/ }),

/***/ "72VV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideEmendas_vue__ = __webpack_require__("d+S1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a87188a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideEmendas_vue__ = __webpack_require__("9hZB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideEmendas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a87188a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideEmendas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "76x5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common___ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_DoughnutChart__ = __webpack_require__("xVH2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Card__ = __webpack_require__("9i0h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'despesas',
  components: { PublicHeader: __WEBPACK_IMPORTED_MODULE_2__components_common___["a" /* PublicHeader */], Doughnut: __WEBPACK_IMPORTED_MODULE_3__components_common_DoughnutChart__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_2__components_common___["f" /* LineChart2 */], Card: __WEBPACK_IMPORTED_MODULE_5__Card__["a" /* default */], AnoBase: __WEBPACK_IMPORTED_MODULE_2__components_common___["j" /* AnoBase */] },
  data: function data() {
    return {
      tipo_operacao: 'ue',
      graficos_base: {
        labels: [],
        datasets: [{ label: '', backgroundColor: [], data: [] }]
      },
      graficoOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Previsão de Gastos / Empenho / Liquidação / Pagamento',
          fontColor: '#C1D1C1'
        },
        legend: {
          display: true,
          labels: {
            fontColor: '#C1D1C1'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              suggestedMax: 50,
              fontColor: '#C1D1C1',
              callback: function callback(value, index, values) {
                return value.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL'
                });
              }
            }
          }],
          xAxes: [{
            maxBarThickness: 50,
            ticks: {
              fontColor: '#C1D1C1'
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function label(tooltip, dataset) {
              var xLabel = dataset.datasets[tooltip.datasetIndex].label;
              var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              });
              return xLabel + ': ' + yLabel;
            }
          }
        }
      },
      secretaria: [{
        original: '01.10 - EXECUTIVO',
        resumido: 'EXECUTIVO',
        img: 'ico-servidor.svg'
      }, {
        original: '01.12 - SECRETARIA DE FINANCAS',
        resumido: 'FINANÇAS',
        img: 'ico-financas.svg'
      }, {
        original: '01.13 - SECRETARIA DE GESTAO',
        resumido: 'GESTÃO',
        img: 'ico-gestao.svg'
      }, {
        original: '01.14 - SECRETARIA DE EDUCAÇÃO',
        resumido: 'EDUCAÇÃO',
        img: 'ico-educacao.svg'
      }, {
        original: '01.15 - SECRETARIA DE SAÚDE',
        resumido: 'SAÚDE',
        img: 'ico-saude.svg'
      }, {
        original: '01.17 - SECRETARIA DE INFRAESTRUTURA E EDIFIC',
        resumido: 'INFRAESTRUTURA',
        img: 'ico-manutencao.svg'
      }, {
        original: '01.18 - SECRETARIA DE TURISMO',
        resumido: 'TURISMO',
        img: 'ico-turismo.svg'
      }, {
        original: '01.18 - SECRETARIA DE EMPREENDEDORISMO, ECONOMIA CRIATIVA E TURISMO',
        resumido: 'EMPREENDEDORISMO E TURISMO',
        img: 'ico-turismo.svg'
      }, {
        original: '01.19 - SECRETARIA DE ESPORTES',
        resumido: 'ESPORTES',
        img: 'ico-esporte.svg'
      }, {
        original: '01.20 - SECRETARIA DE CULTURA',
        resumido: 'CULTURA',
        img: 'ico-cultura.svg'
      }, {
        original: '01.21 - SECRETARIA DE DESENVOLVIMENTO URBANO',
        resumido: 'DESENVOLVIMENTO URBANO',
        img: 'ico-urbanismo.svg'
      }, {
        original: '01.23 - SECRETARIA DE MEIO AMBIENTE',
        resumido: 'MEIO AMBIENTE',
        img: 'ico-meioambiente.svg'
      }, {
        original: '01.24 - PROCURADORIA GERAL DO MUNICIPIO',
        resumido: 'PROCURADORIA',
        img: 'ico-servidor.svg'
      }, {
        original: '01.27 - SECRETARIA DE SEGURANÇA',
        resumido: 'SEGURANÇA',
        img: 'ico-seguranca.svg'
      }, {
        original: '01.29 - SECRETARIA DE SERVICOS PUBLICOS',
        resumido: 'SERVIÇOS PÚBLICOS',
        img: 'ico-servico-servicospublicos.svg'
      }, {
        original: '01.35 - SECRETARIA MUNICIPAL DE GOVERNO',
        resumido: 'GOVERNO',
        img: 'ico-governo.svg'
      }, {
        original: '01.37 - OUVIDORIA, TRANSPARENCIA E CONTROLE',
        resumido: 'OUVIDORIA',
        img: 'ico-ouvidoria.svg'
      }, {
        original: '01.39 - SECRETARIA MUN. DE ASSUNTOS PORTUÁRIOS, INDÚSTRIA E COMÉRCIO',
        resumido: 'PORTO, INDÚSTRIA E COMÉRCIO',
        img: 'ico-porto.svg'
      }, {
        original: '01.39 - SECRETARIA MUN. DE ASSUNTOS PORTUÁRIOS E PROJETOS ESPECIAIS',
        resumido: 'PORTO E PROJETOS ESPECIAIS',
        img: 'ico-porto.svg'
      }, {
        original: '01.40 - SECRETARIA MUNICIPAL DE DESENVOLVIMENTO SOCIAL',
        resumido: 'DESENVOLVIMENTO SOCIAL',
        img: 'ico-assistencia.svg'
      }, {
        original: '01.41 - SECRETARIA DE COMUNICAÇÃO SOCIAL E RELAÇÕES INSTITUCIONAIS',
        resumido: 'COMUNICAÇÃO SOCIAL',
        img: 'ico-comunicacao.svg'
      }, {
        original: '01.42 - SECRETARIA MUNICIPAL DE PLANEJAMENTO E INOVAÇÃO',
        resumido: 'PLANEJAMENTO',
        img: 'ico-gestao.svg'
      }, {
        original: '01.49 - ENCARGOS GERAIS DO MUNICÍPIO',
        resumido: 'ENCARGOS GERAIS',
        img: 'ico-financas.svg'
      }, {
        original: '04 - Administração',
        resumido: 'Administração',
        img: 'ico-servidor.svg'
      }, {
        original: '06 - Segurança Pública',
        resumido: 'Segurança Pública',
        img: 'ico-seguranca.svg'
      }, {
        original: '08 - Assistência Social',
        resumido: 'Assistência Social',
        img: 'ico-assistencia.svg'
      }, { original: '10 - Saúde', resumido: 'Saúde', img: 'ico-saude.svg' }, {
        original: '12 - Educação',
        resumido: 'Educação',
        img: 'ico-educacao.svg'
      }, {
        original: '13 - Cultura',
        resumido: 'Cultura',
        img: 'ico-cultura.svg'
      }, {
        original: '14 - Direitos da Cidadania',
        resumido: 'Direitos da Cidadania',
        img: 'ico-default.svg'
      }, {
        original: '15 - Urbanismo',
        resumido: 'Urbanismo',
        img: 'ico-urbanismo.svg'
      }, {
        original: '16 - Habitação',
        resumido: 'Habitação',
        img: 'ico-imovel.svg'
      }, {
        original: '17 - Saneamento',
        resumido: 'Saneamento',
        img: 'ico-financas.svg'
      }, {
        original: '18 - Gestão Ambiental',
        resumido: 'Gestão Ambiental',
        img: 'ico-servico-servicospublicos.svg'
      }, {
        original: '23 - Comércio e Serviços',
        resumido: 'Comércio e Serviços',
        img: 'ico-compras.svg'
      }, {
        original: '27 - Desporto e Lazer',
        resumido: 'Desporto e Lazer',
        img: 'ico-esporte.svg'
      }, {
        original: '28 - Encargos especiais',
        resumido: 'Encargos especiais',
        img: 'ico-financas.svg'
      }, {
        original: '99 - Reserva de Contingência',
        resumido: 'Reserva de Contingência',
        img: 'ico-governo.svg'
      }]
    };
  },

  methods: {
    retornaAtualPorKey: function retornaAtualPorKey(key) {
      var detalhamento_despesas = this.$store.state.receitas_despesas.detalhamento_despesas;


      var reducer = function reducer(acumulador, atual) {
        return acumulador + atual[key];
      };

      var resultAtual = detalhamento_despesas.reduce(reducer, 0);

      return resultAtual;
    },
    retornaSomaPorKey: function retornaSomaPorKey(key) {
      var detalhamento_despesas = this.$store.state.receitas_despesas.detalhamento_despesas;


      var reducer = function reducer(acumulador, atual) {
        return acumulador + atual[key];
      };

      var resultAtual = detalhamento_despesas.reduce(reducer, 0);

      return {
        atual: this.formatarMoeda(resultAtual)
      };
    },
    retornaSomaPorNatureza: function retornaSomaPorNatureza() {
      var detalhamento_despesas = this.$store.state.receitas_despesas.detalhamento_despesas;


      var reducer = function reducer(acumulador, atual) {
        if (atual.natureza in acumulador) {
          acumulador[atual.natureza].vl_previsto += atual.vl_previsto;
          acumulador[atual.natureza].vl_total_emp += atual.vl_total_emp;
          acumulador[atual.natureza].vl_total_liq += atual.vl_total_liq;
          acumulador[atual.natureza].vl_total_pag += atual.vl_total_pag;
        } else {
          acumulador[atual.natureza] = {
            vl_previsto: atual.vl_previsto,
            vl_total_emp: atual.vl_total_emp,
            vl_total_liq: atual.vl_total_liq,
            vl_total_pag: atual.vl_total_pag
          };
        }

        return acumulador;
      };

      return detalhamento_despesas.reduce(reducer, {});
    },
    formatarMoeda: function formatarMoeda(val) {
      return val.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({
    anoAtual: function anoAtual(state) {
      return state.receitas_despesas.ano_base;
    }
  }), {
    mes_base: function mes_base() {
      var data = new Date();
      if (this.anoAtual !== data.getFullYear()) {
        var val = new Date(this.anoAtual, 11, 31);
        return {
          nome: val.toLocaleString('default', { month: 'long' }),
          valor: val.getMonth()
        };
      }

      return {
        nome: data.toLocaleString('default', { month: 'long' }),
        valor: data.getMonth()
      };
    },
    listaCards: function listaCards() {
      var _this = this;

      var grupo_despesas = [];
      switch (this.tipo_operacao) {
        case 'ue':
          grupo_despesas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.receitas_despesas.grupo_despesas));
          break;
        case 'fs':
          grupo_despesas = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.receitas_despesas.funcao_subfuncao));
          break;
      }

      var nivelUm = function nivelUm(obj) {
        if ('nivel' in obj && obj.nivel === '1') {
          return true;
        }

        return false;
      };

      var filtrado = grupo_despesas.filter(nivelUm);

      var mapper = function mapper(obj) {
        var resumido = function resumido(element) {
          return element.original === obj.descricao;
        };

        var item = _this.secretaria.find(resumido);

        if (item === undefined) {
          return {
            nome: obj.descricao,
            vl_previsto: _this.formatarMoeda(Number(obj.vl_previsto)),
            ico: 'ico-governo.svg',
            descricao: obj.descricao,
            chave: obj.chave
          };
        }

        return {
          nome: item.resumido,
          vl_previsto: _this.formatarMoeda(Number(obj.vl_previsto)),
          ico: item.img,
          descricao: obj.descricao,
          chave: obj.chave
        };
      };

      return filtrado.map(mapper);
    },
    despesaAnualPrevista: function despesaAnualPrevista() {
      return this.retornaSomaPorKey('vl_previsto');
    },
    despesaAnualEmpenhada: function despesaAnualEmpenhada() {
      return this.retornaSomaPorKey('vl_total_emp');
    },
    despesaAnualLiquidada: function despesaAnualLiquidada() {
      return this.retornaSomaPorKey('vl_total_liq');
    },
    despesaAnualPaga: function despesaAnualPaga() {
      return this.retornaSomaPorKey('vl_total_pag');
    },
    graficoDespesaLinha: function graficoDespesaLinha() {
      var dataPrevisto = Array(12).fill(this.retornaAtualPorKey('vl_previsto'));
      var labels = [];
      var dataEmpenhado = [],
          dataLiquidado = [],
          dataPago = [];
      var emp = 0,
          liq = 0,
          pag = 0;

      for (var index = 0; index <= this.mes_base.valor; index++) {
        labels.push(new Date(this.anoAtual, index, 1).toLocaleString('default', { month: 'short' }).substr(0, 3));
      }

      for (var _index = 0; _index < labels.length; _index++) {
        var element = labels[_index];
        emp += this.retornaAtualPorKey('vl_' + element.toLowerCase() + '_emp');
        liq += this.retornaAtualPorKey('vl_' + element.toLowerCase() + '_liq');
        pag += this.retornaAtualPorKey('vl_' + element.toLowerCase() + '_pag');
        dataEmpenhado.push(emp);
        dataLiquidado.push(liq);
        dataPago.push(pag);
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.graficos_base, {
        labels: labels,
        datasets: [{
          data: dataPago,
          label: 'Pago',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__["a" /* default */].coresRGB[0]
        }, {
          data: dataLiquidado,
          label: 'Liquidado',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__["a" /* default */].coresRGB[6]
        }, {
          data: dataEmpenhado,
          label: 'Empenhado',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__["a" /* default */].coresRGB[2]
        }, {
          data: dataPrevisto,
          label: 'Previsão de Gastos',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__["a" /* default */].coresRGB[1]
        }]
      });
    }
  })
});

/***/ }),

/***/ "7Bwy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7ERm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel panel-success shadow"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n      Orientações para retirada de "+_vm._s(_vm.remedio.principio_ativo)+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('p',{staticClass:"font-lg orientacao",domProps:{"innerHTML":_vm._s(_vm.getDescricaoOrientacao(_vm.remedio))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7F3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__ = __webpack_require__("4TJE");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__["a" /* default */]]
});

/***/ }),

/***/ "7IRF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_NoApiTable__ = __webpack_require__("Vp40");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Gestão de acesso',
      termoPesquisa: '',
      acessos: [],
      loadingScales: false,
      fields: [{
        name: 'unidade',
        title: 'Unidade',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Usuários com acesso',
        titleClass: 'text-left',
        filterable: true
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_4__components_common_NoApiTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    this.loadAcessos();
  },

  methods: {
    consultar: function consultar() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var acessos, filtersAcesso;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchAcessos();

              case 2:
                acessos = _context.sent;
                filtersAcesso = acessos.filter(function (_ref) {
                  var unidade = _ref.unidade,
                      usuarios = _ref.usuarios;

                  var unidadeMatch = unidade.toLowerCase().indexOf(_this.termoPesquisa.toLowerCase()) > -1;
                  var usuariosMatch = usuarios.filter(function (_ref2) {
                    var nome = _ref2.nome;

                    return nome.toLowerCase().indexOf(_this.termoPesquisa.toLowerCase()) > -1;
                  }).length > 0;
                  return unidadeMatch || usuariosMatch;
                });

                _this.acessos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(filtersAcesso));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadAcessos: function loadAcessos() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var acessos;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.fetchAcessos();

              case 2:
                acessos = _context2.sent;

                _this2.setAcessos(acessos);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchAcessos: function fetchAcessos() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref3, acessos;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loadingScales = true;

                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('escala/listar-gestao-unidades-usuario');

              case 3:
                _ref3 = _context3.sent;
                acessos = _ref3.data;


                _this3.loadingScales = false;

                return _context3.abrupt('return', acessos);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    setAcessos: function setAcessos(acessos) {
      this.acessos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(acessos));
    }
  }
});

/***/ }),

/***/ "7NBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaixaComparacao_vue__ = __webpack_require__("fa7C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d63ff3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaixaComparacao_vue__ = __webpack_require__("x/tY");
function injectStyle (ssrContext) {
  __webpack_require__("llwE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d63ff3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaixaComparacao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d63ff3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaixaComparacao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Ry1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7SRS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFixedHeader)?_c('div',[_c('div',{staticClass:"vuetable-head-wrapper"},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableHeaderClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{key:fieldIndex,class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){return _vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{key:fieldIndex,class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{key:fieldIndex,class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{key:fieldIndex,class:['vuetable-th-sequence', field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass || ''],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}})]]:_vm._e()]}),_vm._v(" "),(_vm.scrollVisible)?_c('th',{staticClass:"vuetable-gutter-col",style:({width: _vm.scrollBarWidth})}):_vm._e()],2)])])]),_vm._v(" "),_c('div',{staticClass:"vuetable-body-wrapper",style:({height: _vm.tableHeight})},[_c('table',{class:['vuetable', _vm.css.tableClass, _vm.css.tableBodyClass]},[_c('colgroup',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[_c('col',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass],style:({width: field.width}),attrs:{"id":'_col_' + field.name}})]:_vm._e()]})],2),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,itemIndex){return [_c('tr',{key:itemIndex,class:_vm.onRowClass(item, itemIndex),attrs:{"item-index":itemIndex,"render":_vm.onRowChanged(item)},on:{"click":function($event){return _vm.onRowClicked(item, $event)},"dblclick":function($event){return _vm.onRowDoubleClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{key:fieldIndex,class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(itemIndex))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{key:fieldIndex,class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{key:fieldIndex,class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){return _vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{key:fieldIndex,class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":itemIndex,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{key:fieldIndex,class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{"rowData":item,"rowIndex":itemIndex,"rowField":field.sortField})],2):_vm._e()]:[_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.renderNormalField(field, item))},on:{"click":function($event){return _vm.onCellClicked(item, field, $event)},"dblclick":function($event){return _vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){return _vm.onCellRightClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[_c('transition',{key:itemIndex,attrs:{"name":_vm.detailRowTransition}},[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){return _vm.onDetailRowClick(item, $event)}}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":itemIndex}})],1)]):_vm._e()])]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{key:i,staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?_c('td',{key:fieldIndex},[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])])]):_c('table',{class:['vuetable', _vm.css.tableClass]},[_c('thead',[_c('tr',[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__checkbox')?_c('th',{key:fieldIndex,class:['vuetable-th-checkbox-'+_vm.trackBy, field.titleClass],style:({width: field.width})},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkCheckboxesState(field.name)},on:{"change":function($event){return _vm.toggleAllCheckboxes(field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__component')?_c('th',{key:fieldIndex,class:['vuetable-th-component-'+_vm.trackBy, field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__slot')?_c('th',{key:fieldIndex,class:['vuetable-th-slot-'+_vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {'sortable': _vm.isSortable(field)}],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__sequence')?_c('th',{key:fieldIndex,class:['vuetable-th-sequence', field.titleClass || '', _vm.sortClass(field)],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e(),_vm._v(" "),(_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot']))?_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass || '', _vm.sortClass(field)],style:({width: field.width}),domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))}}):_vm._e()]:[_c('th',{key:fieldIndex,class:['vuetable-th-'+field.name, field.titleClass, _vm.sortClass(field),  {'sortable': _vm.isSortable(field)}],style:({width: field.width}),attrs:{"id":'_' + field.name},domProps:{"innerHTML":_vm._s(_vm.renderTitle(field))},on:{"click":function($event){return _vm.orderBy(field, $event)}}})]]:_vm._e()]})],2)]),_vm._v(" "),_c('tbody',{staticClass:"vuetable-body"},[_vm._l((_vm.tableData),function(item,itemIndex){return [_c('tr',{key:itemIndex,class:_vm.onRowClass(item, itemIndex),attrs:{"item-index":itemIndex,"render":_vm.onRowChanged(item)},on:{"dblclick":function($event){return _vm.onRowDoubleClicked(item, $event)},"click":function($event){return _vm.onRowClicked(item, $event)}}},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?[(_vm.isSpecialField(field.name))?[(_vm.extractName(field.name) == '__sequence')?_c('td',{key:fieldIndex,class:['vuetable-sequence', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderSequence(itemIndex))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__handle')?_c('td',{key:fieldIndex,class:['vuetable-handle', field.dataClass],domProps:{"innerHTML":_vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))}}):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) == '__checkbox')?_c('td',{key:fieldIndex,class:['vuetable-checkboxes', field.dataClass]},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.rowSelected(item, field.name)},on:{"change":function($event){return _vm.toggleCheckbox(item, field.name, $event)}}})]):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__component')?_c('td',{key:fieldIndex,class:['vuetable-component', field.dataClass]},[_c(_vm.extractArgs(field.name),{tag:"component",attrs:{"row-data":item,"row-index":itemIndex,"row-field":field.sortField}})],1):_vm._e(),_vm._v(" "),(_vm.extractName(field.name) === '__slot')?_c('td',{key:fieldIndex,class:['vuetable-slot', field.dataClass]},[_vm._t(_vm.extractArgs(field.name),null,{"rowData":item,"rowIndex":itemIndex,"rowField":field.sortField})],2):_vm._e()]:[(_vm.hasCallback(field))?_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.callCallback(field, item))},on:{"click":function($event){return _vm.onCellClicked(item, field, $event)},"dblclick":function($event){return _vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){return _vm.onCellRightClicked(item, field, $event)}}}):_c('td',{key:fieldIndex,class:field.dataClass,domProps:{"innerHTML":_vm._s(_vm.getObjectValue(item, field.name, ''))},on:{"click":function($event){return _vm.onCellClicked(item, field, $event)},"dblclick":function($event){return _vm.onCellDoubleClicked(item, field, $event)},"contextmenu":function($event){return _vm.onCellRightClicked(item, field, $event)}}})]]:_vm._e()]})],2),_vm._v(" "),(_vm.useDetailRow)?[_c('transition',{key:itemIndex,attrs:{"name":_vm.detailRowTransition}},[(_vm.isVisibleDetailRow(item[_vm.trackBy]))?_c('tr',{class:[_vm.css.detailRowClass],on:{"click":function($event){return _vm.onDetailRowClick(item, $event)}}},[_c('td',{attrs:{"colspan":_vm.countVisibleFields}},[_c(_vm.detailRowComponent,{tag:"component",attrs:{"row-data":item,"row-index":itemIndex}})],1)]):_vm._e()])]:_vm._e()]}),_vm._v(" "),(_vm.displayEmptyDataRow)?[_c('tr',[_c('td',{staticClass:"vuetable-empty-result",attrs:{"colspan":_vm.countVisibleFields},domProps:{"innerHTML":_vm._s(_vm.noDataTemplate)}})])]:_vm._e(),_vm._v(" "),(_vm.lessThanMinRows)?_vm._l((_vm.blankRows),function(i){return _c('tr',{key:i,staticClass:"blank-row"},[_vm._l((_vm.tableFields),function(field,fieldIndex){return [(field.visible)?_c('td',{key:fieldIndex},[_vm._v(" ")]):_vm._e()]})],2)}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7UFl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Uir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_dados_user_UserBase__ = __webpack_require__("1NjD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Datepicker__ = __webpack_require__("eOZt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0__views_admin_dados_user_UserBase__["a" /* default */],
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_2__components_common_Datepicker__["a" /* default */] },
  data: function data() {
    return {
      carregando: false,
      dado: {
        codigo: 0,
        nome: '',
        tipoValor: '',
        periodicidade: ''
      },
      model: {
        id: '',
        data: '',
        value: '',
        observacao: ''
      }
    };
  },
  beforecreate: function beforecreate() {
    if (!this.$store.state.islogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.loadDado();

    if (this.isUpdated()) this.loadValue();
  },
  mounted: function mounted() {
    var _this = this;

    var r = this.$refs;
    if (this.isUpdated()) {
      setTimeout(function () {
        if (_this.isValueInteiro() || _this.isValueDecimal()) {
          if (_this.isValueInteiro()) {
            r.inteiro.focus();
          } else {
            r.decimal.$el.focus();
          }
        } else {
          r.resposta.focus();
        }
      }, 500);
    } else {
      setTimeout(function () {
        _this.setDateDefault();
      }, 500);
    }
  },

  methods: {
    handleLoading: function handleLoading() {
      this.carregando = !this.carregando;
    },
    loadDado: function loadDado() {
      var me = this;
      var params = me.$router.history.current.params;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('dado/get/' + params.DAD_IDDADO, null).then(function (r) {
        if (r.status) {
          me.dado.codigo = r.data.codigo;
          me.dado.nome = r.data.nome;
          me.dado.tipoValor = r.data.tipoValor;
          me.dado.periodicidade = r.data.periodicidade.descricao;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    loadValue: function loadValue() {
      var me = this;
      var params = me.$router.history.current.params;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('dado/valor/get', { DVA_IDDADOVALOR: params.DVA_IDDADOVALOR }).then(function (response) {
        var d = response.data.data;
        me.model.id = d.DVA_IDDADOVALOR;
        me.model.data = new Date(d.DVA_DTDADOVALOR);

        me.dado.codigo = d.dado.DAD_IDDADO;
        me.dado.tipoValor = d.dado.DAD_CDTIPOVALOR;

        if (me.isValueInteiro() || me.isValueDecimal()) {
          me.model.value = me.isValueInteiro() ? parseInt(d.DVA_VLDADOVALOR) : parseFloat(d.DVA_VLDADOVALOR);
        } else {
          me.model.value = d.DVA_DLDADOVALOR;
        }
        me.model.observacao = d.DVA_DLOBSERVACAO;
      }).catch(function (e) {
        console.log(e);
      });
    },
    isUpdated: function isUpdated() {
      return this.$router.history.current.params.hasOwnProperty('DVA_IDDADOVALOR') && this.$router.history.current.params.DVA_IDDADOVALOR;
    },
    isValueInteiro: function isValueInteiro() {
      if (this.dado.tipoValor) {
        return this.dado.tipoValor === 'I';
      }
      return false;
    },
    isValueDecimal: function isValueDecimal() {
      if (this.dado.tipoValor) {
        return this.dado.tipoValor === 'D';
      }
      return false;
    },
    isValueTexto: function isValueTexto() {
      if (this.dado.tipoValor) {
        return this.dado.tipoValor === 'T';
      }
      return false;
    },
    getValueDefault: function getValueDefault() {
      return this.isValueInteiro() || this.isValueDecimal() ? 0 : '';
    },
    setDateDefault: function setDateDefault() {
      var now = new Date();
      var month = void 0,
          periodoNumber = void 0;

      if (this.dado.periodicidade.toLowerCase() === 'anual') this.model.data = new Date(now.getFullYear() - 1, 11, 31);else {
        switch (this.dado.periodicidade.toLowerCase()) {
          case 'semestral':
            periodoNumber = 6;
            break;
          case 'quadrimestral':
            periodoNumber = 4;
            break;
          case 'trimestral':
            periodoNumber = 3;
            break;
          case 'bimestral':
            periodoNumber = 2;
            break;
          case 'mensal':
            periodoNumber = 1;
            break;
        }

        var periodoAtual = periodoNumber > 1 ? Math.floor((now.getMonth() + 1) / periodoNumber) : now.getMonth();

        if (periodoAtual === 0) this.model.data = new Date(now.getFullYear() - 1, 11, 31);else {
          month = periodoNumber * periodoAtual;
          var date = new Date(now.getFullYear(), month, 1);
          date.setDate(date.getDate() - 1);
          this.model.data = date;
        }
      }
    },
    configMoney: function configMoney() {
      return {
        decimal: ',',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      };
    },
    saveSuccess: function saveSuccess(response) {
      this.$toastr.s('Valor foi salvo com sucesso.');
      this.$router.push('/admin/user/dado/list');
    },
    saveFail: function saveFail(error) {
      var data = error.response.data;

      if (data.msg) {
        this.$toastr.e(data.msg);
      } else {
        this.$toastr.e('Houve uma falha ao tentar salvar este item, Tente novamente daqui alguns minutos!');
      }
    },
    save: function save() {
      var _this2 = this;

      var me = this;
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          var element = me.$refs[_this2.$validator.errors.items[0].field];

          element.$el ? element.$el.focus() : element.focus();
          me.$toastr.e(_this2.$validator.errors.items[0].msg);
          return;
        }

        _this2.handleLoading();
        __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('dado/valor/save', _this2.payload).then(_this2.saveSuccess).catch(_this2.saveFail).finally(_this2.handleLoading);
      });
    }
  },
  computed: {
    dateFormat: function dateFormat() {
      return this.model.data.getFullYear() + '-' + (this.model.data.getMonth() + 1) + '-' + this.model.data.getDate();
    },
    payload: function payload() {
      var m = {
        DAD_IDDADO: this.dado.codigo,
        DVA_DTDADOVALOR: this.dateFormat,
        DVA_DLOBSERVACAO: this.model.observacao
      };

      if (this.isUpdated()) {
        m.DVA_IDDADOVALOR = this.model.id;
      }

      if (this.isValueInteiro() || this.isValueDecimal()) {
        m.DVA_VLDADOVALOR = this.model.value;
      } else {
        m.DVA_DLDADOVALOR = this.model.value;
      }

      return m;
    }
  },
  watch: {
    model: {
      value: function value(val, old) {
        if (this.isValueInteiro()) {
          if (isNaN(val) && val !== '-') {
            this.model.value = old;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ "7YzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row materiais"},[_c('public-header',{attrs:{"title":'Materiais padronizados'}},[_c('div',{staticClass:"col-sm-7 col-lg-6"},[_c('label',{attrs:{"for":"nome"}},[_vm._v("Por Nome / Descrição")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.filters.pesquisa),expression:"model.filters.pesquisa"}],staticClass:"form-control",attrs:{"name":"nome","type":"text","placeholder":"Digite sua pesquisa..."},domProps:{"value":(_vm.model.filters.pesquisa)},on:{"keyup":function($event){return _vm.consultar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.filters, "pesquisa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-lg-3"},[_c('label',{attrs:{"for":"medida"}},[_vm._v("Por medida")]),_vm._v(" "),_c('v-select',{ref:"medidas",staticClass:"style-chooser",attrs:{"reduce":function (medida) { return medida.codigo; },"label":"nome","placeholder":'Selecione a medida...',"options":_vm.model.lista_medidas,"selectOnTab":true},on:{"input":function($event){return _vm.consultar()}},model:{value:(_vm.model.filters.medida),callback:function ($$v) {_vm.$set(_vm.model.filters, "medida", $$v)},expression:"model.filters.medida"}},[_c('template',{slot:"no-options"},[_vm._v("\n          Medida não encontrada...\n        ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5 col-lg-4"},[_c('label',{attrs:{"for":"medida"}},[_vm._v("Por Grupo")]),_vm._v(" "),_c('v-select',{ref:"grupos",staticClass:"style-chooser",attrs:{"reduce":function (grupo) { return grupo.codigo; },"label":"nome","placeholder":'Selecione o grupo...',"options":_vm.model.lista_grupos,"selectOnTab":true},on:{"input":function($event){return _vm.consultar(true)}},model:{value:(_vm.model.filters.grupo),callback:function ($$v) {_vm.$set(_vm.model.filters, "grupo", $$v)},expression:"model.filters.grupo"}},[_c('template',{slot:"no-options"},[_vm._v("\n          Grupo não encontrada...\n        ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-5"},[_c('label',{attrs:{"for":"medida"}},[_vm._v("Por Subgrupo")]),_vm._v(" "),_c('v-select',{ref:"subgrupos",staticClass:"style-chooser",attrs:{"reduce":function (subgrupo) { return subgrupo.codigo; },"label":"nome","placeholder":'Selecione o subgrupo...',"options":_vm.model.lista_subgrupos,"selectOnTab":true},on:{"input":function($event){return _vm.consultar()}},model:{value:(_vm.model.filters.subgrupo),callback:function ($$v) {_vm.$set(_vm.model.filters, "subgrupo", $$v)},expression:"model.filters.subgrupo"}},[_c('template',{slot:"no-options"},[_vm._v("\n          Subgrupo não encontrada...\n        ")])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',{},[_vm._v("Materiais padronizados")])])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12 scroll"},[_c('data-table-public',{ref:"dt",attrs:{"has-auth":false,"title":"lista de materiais","api-url":"materiais/lista-material","show-empty":true,"fields":_vm.model.columns,"appendParams":_vm.model.filters}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('a',{staticClass:"btn btn-default",attrs:{"role":"button","href":_vm.exportar(),"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":'file-export'}}),_vm._v(" Exportar\n        ")],1)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Lista de Materiais")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7d86":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7j7X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Array,
      required: true
    },
    checkboxs: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      valueList: []
    };
  },

  methods: {
    isChecked: function isChecked(value) {
      return this.valueList.indexOf(value) > -1;
    },
    changeValues: function changeValues(value, _ref) {
      var target = _ref.target;

      if (target.checked) {
        this.valueList.push(value);
      } else {
        this.valueList = this.valueList.filter(function (v) {
          return v !== value;
        });
      }
    },
    emitValues: function emitValues() {
      this.$emit('input', [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.valueList)));
    }
  }
});

/***/ }),

/***/ "7qQ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7qwS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Associate_vue__ = __webpack_require__("mRqr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49917688_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Associate_vue__ = __webpack_require__("xFXY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Associate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49917688_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Associate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7rxZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Datepicker__ = __webpack_require__("eOZt");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_3__components_common_Datepicker__["a" /* default */] },
  data: function data() {
    return {
      item: {},
      carregando: false,
      dtpagamento: null,
      cd_beneficios_periodo: [1, 5, 7],
      beneficios: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },

  methods: {
    handleLoading: function handleLoading() {
      this.carregando = !this.carregando;
    },
    salvar: function salvar() {
      var _this = this;

      this.handleLoading();

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('assistencia/pagamentos/salvar', [this.item]).then(function (_ref) {
        var data = _ref.data;

        _this.$toastr.s(data.msg);
        _this.$router.push('/admin/assistencia/pagamentos');
      }).catch(function (_ref2) {
        var response = _ref2.response;

        _this.$toastr.e(response.data.msg);
      }).then(function () {
        _this.handleLoading();
      });
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    if (!this.$route.params.item) {
      this.$router.push('/admin/assistencia/pagamentos');
      return;
    }

    __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('/assistencia/listar-beneficios').then(function (_ref3) {
      var data = _ref3.data;

      _this2.beneficios = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));
    }).catch(function (error) {
      _this2.$toastr.e('Houve um erro no carregamento de benefícios. Atualize a página e tente novamente.');
      console.log(error);
    });
  },
  created: function created() {
    this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.params.item);
  }
});

/***/ }),

/***/ "7uuu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"row",attrs:{"id":_vm.id}},[_c('header',{staticClass:"col-xs-12"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('main',{staticClass:"col-xs-12"},[_c('data-table',{ref:"vuetable",attrs:{"title":_vm.title,"dados":_vm.itens,"fields":_vm.fields,"carregando":false,"per_page":10},on:{"vuetable-pagination:change-page":_vm.checkAllCheckboxOnPage},scopedSlots:_vm._u([{key:"column_input",fn:function(props){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.rowData.checked),expression:"props.rowData.checked"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(props.rowData.checked)?_vm._i(props.rowData.checked,null)>-1:(props.rowData.checked)},on:{"change":function($event){var $$a=props.rowData.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(props.rowData, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(props.rowData, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(props.rowData, "checked", $$c)}}}})]}},{key:"rowrender",fn:function(props){return [(props.rowData.status === 'Habilitado')?_c('button',{staticClass:"btn btn-success",attrs:{"title":"Nomear Candidato","disabled":props.rowData.processingClickEvent},on:{"click":function($event){return _vm.nomear(props.rowData)}}},[(props.rowData.processingClickEvent)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'check'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Nomear Candidato")])],1):_c('div',[(props.rowData.status === 'Nomeado')?_c('button',{staticClass:"btn btn-success",attrs:{"title":"Empossar Candidato","disabled":props.rowData.processingClickEvent},on:{"click":function($event){return _vm.empossar(props.rowData)}}},[(props.rowData.processingClickEvent)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'check-double'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Empossar Candidato")])],1):_vm._e(),_vm._v(" "),(props.rowData.status === 'Nomeado')?_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Revogar Candidato","disabled":props.rowData.processingClickEvent},on:{"click":function($event){return _vm.revogar(props.rowData)}}},[(props.rowData.processingClickEvent)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'times'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Revogar Candidato")])],1):_vm._e()])]}}])},[_c('template',{slot:"header-actions"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3",staticStyle:{"padding-left":"0"}},[_c('label',[_vm._v("Data Base")]),_vm._v(" "),_c('datepicker',{ref:"data_base",attrs:{"name":"data_base"},model:{value:(_vm.dataBase),callback:function ($$v) {_vm.dataBase=$$v},expression:"dataBase"}})],1),_vm._v(" "),_c('div',{staticClass:"container-action col-xs-12 col-sm-6 col-md-9",staticStyle:{"padding-left":"0"}},[_c('label',[_vm._v("Ações")]),_vm._v(" "),_c('div',{staticClass:"button-group"},[_c('a',{attrs:{"title":"Selecionar todos os candidatos"},on:{"click":_vm.alternarTodosCheckboxNaPagina}},[(_vm.hasAllCheckboxOnPage)?_c('font-awesome-icon',{attrs:{"icon":_vm.iconChecked,"size":"2x"}}):_c('font-awesome-icon',{attrs:{"icon":_vm.iconCheck,"size":"2x"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-xs",attrs:{"title":"Nomear Candidato","disabled":!Boolean(_vm.dataBase) || _vm.loading.nomear},on:{"click":_vm.nomearSelecionados}},[(_vm.loading.nomear)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'check'}}),_vm._v("\n              Nomear\n              "),_c('span',{staticClass:"sr-only"},[_vm._v("Nomear Candidato")])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-xs",attrs:{"title":"Empossar Candidato","disabled":!Boolean(_vm.dataBase) || _vm.loading.empossar},on:{"click":_vm.empossarSelecionados}},[(_vm.loading.empossar)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'check-double'}}),_vm._v("\n              Empossar\n              "),_c('span',{staticClass:"sr-only"},[_vm._v("Empossar Candidato")])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-xs",attrs:{"title":"Revogar Candidato","disabled":!Boolean(_vm.dataBase) || _vm.loading.revogar},on:{"click":_vm.revogarSelecionados}},[(_vm.loading.revogar)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'times'}}),_vm._v("\n              Revogar\n              "),_c('span',{staticClass:"sr-only"},[_vm._v("Revogar Candidato")])],1),_vm._v(" "),(_vm.isCotas)?_c('button',{staticClass:"btn btn-success btn-xs",attrs:{"title":"Imprimir fichas","disabled":!_vm.itens.length},on:{"click":_vm.imprimirFichas}},[(_vm.loading.imprimir)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'print'}}),_vm._v("\n              Imprimir fichas\n              "),_c('span',{staticClass:"sr-only"},[_vm._v("Imprimir fichas")])],1):_vm._e()])])])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7wt9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beneficios"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h2',{staticClass:"page-header"},[_vm._v("Inserir Benefícios")])])]),_vm._v(" "),_c('div',{staticClass:"row margem-bottom"},[_c('div',{staticClass:"col-xs-12"},[_c('upload',{attrs:{"separador":';'},on:{"loadCSV":_vm.loadCSV}})],1)]),_vm._v(" "),(_vm.model.body.length)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('data-table',{attrs:{"dados":_vm.model.body,"fields":_vm.fields},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_vm._v("\n          "+_vm._s(("de " + (props.rowData.INICIO || '-----') + " à " + (props.rowData.FIM ||
              '-----')))+"\n        ")]}}],null,false,2194164021)})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 margem-bottom"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){return _vm.salvar()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n        Salvar\n      ")],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Pré Visualização")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8/cP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "84Lw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.3027e00.jpg";

/***/ }),

/***/ "8Fy5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-scale-container"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de escala")]),_vm._v(" "),_c('Select',{attrs:{"options":_vm.scaleList},model:{value:(_vm.scale),callback:function ($$v) {_vm.scale=$$v},expression:"scale"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8L5u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.title)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Lista de espera - "+_vm._s(_vm.title))])])]):_vm._e(),_vm._v(" "),(_vm.carregando)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 datatable-spinner text-center"},[_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}})],1)]):_vm._e(),_vm._v(" "),(!_vm.carregando && _vm.items.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('DataTable',{attrs:{"fields":_vm.fields,"slots":['gravidade'],"dados":_vm.dados,"carregando":_vm.carregando},scopedSlots:_vm._u([{key:"gravidade",fn:function(props){return [_c('div',{class:[_vm.getGravidadeClass(props.rowData.gravidade), 'gravidade']},[_vm._v("\n            "+_vm._s(props.rowData.gravidade)+"\n          ")])]}}],null,false,1012893212)},[_c('template',{slot:"header-actions"},[_c('ExportCSV',{attrs:{"dados":_vm.dados,"tipo":'espera'}})],1),_vm._v(" "),_c('ExportCSV',{attrs:{"dados":_vm.dados}})],2)],1)]):_vm._e(),_vm._v(" "),(!_vm.carregando && !_vm.items.length)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 nenhum-item"},[_c('p',[_vm._v("Nenhum item encontrado")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Luf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detalhes_vue__ = __webpack_require__("fizg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c3dde8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detalhes_vue__ = __webpack_require__("Pzp/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detalhes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52c3dde8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detalhes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Pjl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationInfoMixin_vue__ = __webpack_require__("cbZW");




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationInfoMixin_vue__["a" /* default */]]
});

/***/ }),

/***/ "8SCe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8bzg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "8eyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{ 'has-error': _vm.hasErro }},[_c('label',{staticClass:"control-label custom-font"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'user'}})],1),_vm._v(" "),_c('div',{staticClass:"autocomplete-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"},{name:"validate",rawName:"v-validate",value:({ required: _vm.isRequired }),expression:"{ required: isRequired }"}],ref:"input",staticClass:"form-control",attrs:{"type":"text","name":"sshd_responsavel","autocomplete":"off"},domProps:{"value":(_vm.query)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.query=$event.target.value},_vm.onInput],"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.navegar(1)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.navegar(-1)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.selecionarAtual.apply(null, arguments)}]}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.showResults),expression:"showResults"}],staticClass:"result-list"},_vm._l((_vm.resultados),function(item,index){return _c('li',{key:((item.sshd) + "-" + index),class:[
                            'result-list-item', 
                            { 'ativo': index === _vm.selectedIndex }
                        ],on:{"click":function($event){return _vm.selecionar(item)}}},[_vm._v("\n                        "+_vm._s(item.nome)+" ("+_vm._s(item.sshd)+")\n                    ")])}),0)])]),_vm._v(" "),(_vm.hasErro)?_c('small',{staticClass:"help-block"},[_vm._v("\n            Preenchimento obrigatório!\n        ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8gNu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectScaleType_vue__ = __webpack_require__("iMpk");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e86e8c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectScaleType_vue__ = __webpack_require__("8Fy5");
function injectStyle (ssrContext) {
  __webpack_require__("jOZS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e86e8c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectScaleType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e86e8c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectScaleType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "8m+r":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTVweCIgaGVpZ2h0PSI2MHB4IiB2aWV3Qm94PSIwIDAgNTUgNjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjYgKDY3NDkxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY28tcXVhZHJhPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMS4wMDAwMDAsIC03MzYuMDAwMDAwKSIgc3Ryb2tlLXdpZHRoPSIzIj4KICAgICAgICAgICAgPGcgaWQ9Imljby1xdWFkcmEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyLjAwMDAwMCwgNzM4LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTMyLjI5MTcsMy44NDUzIEw0OS40MjM3LDQxLjg0NDMiIGlkPSJTdHJva2UtMjUxIiBzdHJva2U9IiMxNDQ3N0MiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik01Mi4zODE2LDQwLjUxMDMgTDE4Ljk1MTYsNTUuNTgyMyBDMTguMDE2Niw1Ni4wMDQzIDE2LjkxNjYsNTUuNTg3MyAxNi40OTQ2LDU0LjY1MzMgTDAuNzcyNiwxOS43ODAzIEMwLjM1MTYsMTguODQ0MyAwLjc2NzYsMTcuNzQ0MyAxLjcwMTYsMTcuMzIzMyBMNDAuNzIyNiwwLjEyOTMiIGlkPSJTdHJva2UtMjUzIiBzdHJva2U9IiM2N0I0NTAiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik00MC45MTc3LDE1LjUyMTEgQzM5Ljg5MjcsMTUuNTIyMSAzOC44NTA3LDE1LjczNjEgMzcuODU0NywxNi4xODUxIEMzNC4wNzk3LDE3Ljg4NzEgMzIuMzk4NywyMi4zMjgxIDM0LjEwMTcsMjYuMTAyMSBDMzUuODAyNywyOS44NzgxIDQwLjI0MzcsMzEuNTU5MSA0NC4wMTg3LDI5Ljg1NzEgQzQ2Ljg0OTcsMjguNTgxMSA0OC41MDM3LDI1Ljc2MzEgNDguNDM1NywyMi44NDIxIiBpZD0iU3Ryb2tlLTI1NSIgc3Ryb2tlPSIjMTQ0NzdDIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlN0cm9rZS0yNTciIHN0cm9rZT0iIzY3QjQ1MCIgcG9pbnRzPSI1LjgzNTcgMzEuMDA5NCAxOC42Nzg3IDI1LjA2NjQgMjQuNjU5NyAzOC4zMzE0IDExLjcyMDcgNDQuMDYzNCI+PC9wb2x5bGluZT4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjA2NTIsMTcuNzk1NSBDMTEuNDY1MiwxMy4xMDY1IDIzLjU2ODIsMTcuODk4NSAyOC4zMjAyLDI4LjQzOTUgQzMzLjA3MjIsMzguOTc5NSAyOC41NDMyLDUxLjA1NjUgMTguMTQ0Miw1NS43NDQ1IiBpZD0iU3Ryb2tlLTI1OSIgc3Ryb2tlPSIjMTQ0NzdDIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjEuNzUzNiw4LjQ4NTkgTDIyLjgyMjYsMTAuODU1OSIgaWQ9IlN0cm9rZS0yNjEiIHN0cm9rZT0iIzY3QjQ1MCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTM3LjYyOTYsNDMuNjk4OCBMMzguNjk4Niw0Ni4wNjg4IiBpZD0iU3Ryb2tlLTI2MyIgc3Ryb2tlPSIjNjdCNDUwIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTMuMDk1NCwyNC4xNzgzIEwxNC4zMTc0LDI2Ljg4NzMiIGlkPSJTdHJva2UtMjY1IiBzdHJva2U9IiM2N0I0NTAiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjY5NDEsMjYuMTYxNyBMOS45MTUxLDI4Ljg3MDciIGlkPSJTdHJva2UtMjY3IiBzdHJva2U9IiM2N0I0NTAiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xNi4wMjEyLDQyLjQxNDYgTDE3LjI0MjIsNDUuMTIyNiIgaWQ9IlN0cm9rZS0yNjkiIHN0cm9rZT0iIzY3QjQ1MCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTIwLjMwNDQsNDAuNTEwMyBMMjEuNTI1NCw0My4yMTgzIiBpZD0iU3Ryb2tlLTI3MSIgc3Ryb2tlPSIjNjdCNDUwIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTQuNTQzNywzNC45MTk1IEMxMi44MTU3LDMxLjA4NzUgMTQuNTIyNywyNi41ODA1IDE4LjM1NDcsMjQuODUzNSBDMjIuMTg2NywyMy4xMjQ1IDI2LjY5MjcsMjQuODMwNSAyOC40MjE3LDI4LjY2MjUgQzMwLjE0ODcsMzIuNDk1NSAyOC40NDI3LDM3LjAwMjUgMjQuNjEwNywzOC43MzA1IEMyMC43Nzg3LDQwLjQ1NzUgMTYuMjcyNywzOC43NTI1IDE0LjU0MzcsMzQuOTE5NSBaIiBpZD0iU3Ryb2tlLTI3MyIgc3Ryb2tlPSIjNjdCNDUwIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "8wmi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "form-message",
  props: {
    message: String
  }
});

/***/ }),

/***/ "8zfL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),(_vm.carregando)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 font-lg"},[_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.items),function(item,index){return _c('div',{key:("proc-" + (item[_vm.chave]) + "-" + index)},[_c('div',{staticClass:"col-xs-12 fields"},[_c('h4',[_vm._v(_vm._s(item[_vm.chave]))]),_vm._v(" "),_c('div',{staticClass:"font-lg margem-bottom"},[_c('div',[_c('label',[_vm._v("Posição:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.posicao))]),_vm._v("\n            -\n            "),_c('label',[_vm._v("Gravidade:")]),_vm._v(" "),_c('span',{class:['gravidade', _vm.getGravidadeClass(item.gravidade)]},[_vm._v(_vm._s(item.gravidade))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Data da Solicitação:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatTo2DigitsDate(new Date(item.dtsolicitacao))))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Tempo médio de agendamento (dias):")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.media_espera))])])])])])}),0),_vm._v(" "),(!_vm.carregando && !_vm.items.length)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('p',{staticClass:"font-lg"},[_vm._v("Nenhum item encontrado")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9+xg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "90oK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eleicaoConselho; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_public_eleicao_conselho__ = __webpack_require__("/ZcS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_public_eleicao_conselho_DetalheCandidato__ = __webpack_require__("sELz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_public_eleicao_conselho_DetalheSecao__ = __webpack_require__("bzbO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const__ = __webpack_require__("4Nwh");





var eleicaoConselho = [{
  path: '/eleicao-conselho',
  name: 'eleicao_conselho',
  component: __WEBPACK_IMPORTED_MODULE_0__views_public_eleicao_conselho__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_3__const__["a" /* DEFAULT_TITLE */] + ' | Elei\xE7\xE3o Conselho Tutelar'
  }
}, {
  path: '/eleicao-conselho/candidato',
  name: 'candidato_conselho',
  component: __WEBPACK_IMPORTED_MODULE_1__views_public_eleicao_conselho_DetalheCandidato__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_3__const__["a" /* DEFAULT_TITLE */] + ' | Elei\xE7\xE3o Por Candidato'
  }
}, {
  path: '/eleicao-conselho/secao/:secao',
  name: 'secao_conselho',
  component: __WEBPACK_IMPORTED_MODULE_2__views_public_eleicao_conselho_DetalheSecao__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_3__const__["a" /* DEFAULT_TITLE */] + ' | Elei\xE7\xE3o Por Se\xE7\xE3o'
  }
}];

/***/ }),

/***/ "944m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-reference-container"},[_c('label',{staticClass:"control-label"},[_vm._v("Mês de Referência")]),_vm._v(" "),_c('Select',{attrs:{"showOptionEmpty":false,"options":_vm.references},on:{"input":_vm.update},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Gsj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"modal fade",attrs:{"id":"modal_login","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"login-panel panel panel-success"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('form',{attrs:{"role":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.login()}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.username),expression:"model.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"username",class:[
                'form-control',
                { 'is-danger': _vm.errors.has('username') }
              ],attrs:{"name":"username","type":"text","placeholder":"Usuário","disabled":""},domProps:{"value":(_vm.model.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('username')),expression:"errors.has('username')"}],staticClass:"is-danger"},[_c('i',{staticClass:"fa fa-warning"}),_vm._v("\n              O campo usuário é obrigatório\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"password",class:[
                'form-control',
                { 'is-danger': _vm.errors.has('password') }
              ],attrs:{"placeholder":"Senha","name":"password","type":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"is-danger"},[_c('i',{staticClass:"fa fa-warning"}),_vm._v("\n              O campo senha é obrigatório\n            ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.usuarioExterno),expression:"model.usuarioExterno"}],ref:"usuarioExterno",attrs:{"type":"checkbox","name":"usuarioExterno"},domProps:{"checked":Array.isArray(_vm.model.usuarioExterno)?_vm._i(_vm.model.usuarioExterno,null)>-1:(_vm.model.usuarioExterno)},on:{"change":function($event){var $$a=_vm.model.usuarioExterno,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "usuarioExterno", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "usuarioExterno", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "usuarioExterno", $$c)}}}}),_vm._v("Usuário externo\n            ")])]),_vm._v(" "),_c('router-link',{attrs:{"to":'/login'}},[_c('span',{staticClass:"alterar-usuario",on:{"click":function($event){return _vm.hide()}}},[_vm._v("Alterar Usuário")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-block botao-acessar",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"submit","disabled":_vm.requestPendente}},[_vm._v("\n            Acessar\n          ")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Dados Abertos - Admin")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9ICf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineChart2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_colors__ = __webpack_require__("ZAg2");


var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp;


var LineChart2 = {
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Line */],
  mixins: [reactiveProp],
  data: function data() {
    return {
      colors: __WEBPACK_IMPORTED_MODULE_1__utils_colors__["a" /* default */].cores
    };
  },

  props: {
    options: {
      type: Object
    },
    gradiente: {
      type: Boolean,
      default: true
    },
    coloredLine: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.$refs.canvas) {
      for (var index = 0; index < this.chartData.datasets.length; index++) {
        if (!this.chartData.datasets[index].backgroundColor) {
          this.chartData.datasets[index].backgroundColor = this.montarCor(this.colors[index]);
        } else {
          if (this.gradiente) {
            this.chartData.datasets[index].backgroundColor = this.gradient(this.chartData.datasets[index].backgroundColor);
          }
        }

        if (this.coloredLine) {
          this.chartData.datasets[index].borderColor = this.montarCor(this.colors[index]);
        }
      }

      Chart.plugins.register({
        id: 'paddingBelowLegends',
        beforeInit: function beforeInit(chart, options) {
          chart.legend.afterFit = function () {
            this.height = this.height + 15;
          };
        }
      });

      this.renderChart(this.chartData, this.options);
      this.htmlLegend = this.generateLegend();
    }
  },

  methods: {
    montarCor: function montarCor(cor) {
      if (this.gradiente) {
        return this.gradient(cor);
      } else {
        return 'rgb(' + cor + ')';
      }
    },
    gradient: function gradient(color) {
      var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);

      gradient.addColorStop(0.4, 'rgba(' + color + ', 1)');
      gradient.addColorStop(0.7, 'rgba(' + color + ', 0.8)');
      gradient.addColorStop(1, 'rgba(' + color + ', 0.6)');

      return gradient;
    }
  },
  watch: {
    chartData: function chartData() {
      for (var index = 0; index < this.$data._chart.data.datasets.length; index++) {
        if (!this.$data._chart.data.datasets[index].backgroundColor) {
          this.$data._chart.data.datasets[index].backgroundColor = this.montarCor(this.colors[index]);
        } else {
          if (this.gradiente) {
            this.$data._chart.data.datasets[index].backgroundColor = this.gradient(this.$data._chart.data.datasets[index].backgroundColor);
          }
        }

        if (this.coloredLine) {
          this.$data._chart.data.datasets[index].borderColor = this.montarCor(this.colors[index]);
        }
      }

      this.$data._chart.update();
    }
  }
};

/***/ }),

/***/ "9IrP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_c('div',{staticClass:"row receitas"},[_c('public-header',{attrs:{"title":'Receita Resumida'}},[_c('ano-base'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('p',[_vm._v("\n          Aqui você encontra um resumo das receitas recebidas pela Prefeitura\n          Municipal de Santos.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          A Prefeitura Municipal de Santos, no ano de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.anoAtual))]),_vm._v("\n          até o mês de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.retornaMesComparativo))]),_vm._v(", arrecadou um total de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v("\n            "+_vm._s(((_vm.formatarMoeda(_vm.receitaAtual)) + " (" + ((_vm.receitaAtual / _vm.orcamentoAtual * 100).toFixed(2).replace('.', ',')) + "%)"))+"\n          ")]),_vm._v("\n          de um orçamento estimado para este ano de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.formatarMoeda(_vm.orcamentoAtual)))]),_vm._v(".\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Dentre os maiores valores arrecadados, em relação ao total,\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(((_vm.filtrarPorCodigo('Impostos, Taxas e Contribuições de Melhoria').atual.vl_total) + " (" + ((_vm.filtrarPorCodigo('Impostos, Taxas e Contribuições de Melhoria').atual.vl_total_f / (_vm.receitaAtual || 1) * 100).toFixed(2).replace('.', ',')) + "%)")))]),_vm._v("\n          são provenientes de impostos, taxas e contribuições de melhoria e\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(((_vm.filtrarPorCodigo('Transferência Correntes').atual.vl_total) + "  (" + ((_vm.filtrarPorCodigo('Transferência Correntes').atual.vl_total_f / (_vm.receitaAtual || 1) * 100).toFixed(2).replace('.', ',')) + "%)")))]),_vm._v("\n          são provenientes de transferências correntes.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p',[_c('bar-chart',{ref:"receita_mensal",attrs:{"chart-data":_vm.graficoHeader,"gradiente":false,"coloredLine":true,"options":{
              responsive: true,
              maintainAspectRatio: false,
              title: {
                display: true,
                text: 'Acompanhamento de receitas',
                fontColor: '#C1D1C1'
              },
              legend: {
                display: true,
                labels: {
                  fontColor: '#C1D1C1',
                },
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      suggestedMax: 50,
                      fontColor: '#C1D1C1',
                      callback: function (value, index, values) {
                        return value.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                        })
                      },
                    },
                  } ],
                xAxes: [
                  {
                    maxBarThickness: 50,
                    ticks: {
                      fontColor: '#C1D1C1',
                    },
                  } ],
              },
              tooltips: {
                callbacks: {
                  label: function (tooltip, dataset) {
                    var xLabel = dataset.datasets[tooltip.datasetIndex].label
                    var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                    return xLabel + ': ' + yLabel
                  },
                },
              },
            }}})],1)])])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":'/receitas_despesas'}},[_vm._v("Receitas e Despesas")])],1),_vm._v(" "),_c('li',{},[_vm._v("Receitas")])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('card',{attrs:{"data":_vm.listaCards}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-center"},[_c('h2',[_vm._v("Para mais detalhes")]),_vm._v(" "),_c('div',{staticClass:"button-group"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"tag":"button","to":{ name: 'receitas_detalhes', params: { id: 1 } }}},[_vm._v("Receitas correntes")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"tag":"button","to":{ name: 'receitas_detalhes', params: { id: 2 } }}},[_vm._v("Receitas de capital")])],1)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-item"},[_c('span',{staticClass:"spinner",staticStyle:{"font-size":"3em"}},[_c('i',{staticClass:"fa fa-spinner fa-spin"})]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Olá, é a sua primeira vez aqui? "),_c('br'),_vm._v(" Por favor aguarde, estamos carregando as informações de receitas para você.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Arrecadações em Destaque")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9MyI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n    Voltar\n  ")],1),_vm._v(" "),_c('Container',{attrs:{"title":"Adicionar Escala"}},[_c('SelectReferencia',{model:{value:(_vm.referencia),callback:function ($$v) {_vm.referencia=$$v},expression:"referencia"}}),_vm._v(" "),_c('SelectUOR',{attrs:{"referencia":_vm.referencia},model:{value:(_vm.uor),callback:function ($$v) {_vm.uor=$$v},expression:"uor"}}),_vm._v(" "),_c('Calendar',{attrs:{"referencia":_vm.referencia,"disabled":_vm.hasEmployeesSelected},model:{value:(_vm.scaleDefault),callback:function ($$v) {_vm.scaleDefault=$$v},expression:"scaleDefault"}}),_vm._v(" "),_c('div',{staticClass:"colaborador-wrapper"},[_c('EmployeeReplicate',{attrs:{"disabled":_vm.scaleDefaultIsEmpty,"uor":_vm.uor_sigla},on:{"changeStatusLoading":_vm.changeStatusLoading},model:{value:(_vm.employeesSelected),callback:function ($$v) {_vm.employeesSelected=$$v},expression:"employeesSelected"}}),_vm._v(" "),_c('EmployeeSearch',{attrs:{"disabled":_vm.scaleDefaultIsEmpty},model:{value:(_vm.employeesSelected),callback:function ($$v) {_vm.employeesSelected=$$v},expression:"employeesSelected"}})],1),_vm._v(" "),_c('EmployeeList',{attrs:{"loading":_vm.statusLoading},model:{value:(_vm.employeesSelected),callback:function ($$v) {_vm.employeesSelected=$$v},expression:"employeesSelected"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{class:[
        'control-label',
        'custom-font',
        { 'is-danger': _vm.errors.has('observacao') }
      ]},[_vm._v("Observação")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.observacao),expression:"observacao"}],ref:"observacao",staticClass:"form-control",attrs:{"rows":"4","placeholder":"Observação","maxlength":"500"},domProps:{"value":(_vm.observacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.observacao=$event.target.value}}}),_vm._v(" "),_c('div',{class:[
            'input-group-addon custom-input-group-addon-count',
            { 'is-danger': _vm.errors.has('observacao') }
          ],domProps:{"textContent":_vm._s(500 - _vm.observacao.length)}})])])]),_vm._v(" "),_c('footer',[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.statusLoading},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[(_vm.statusLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n        Salvar\n      ")],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9NIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scrollToElement; });
var scrollToElement = function scrollToElement(refName) {
  setTimeout(function () {
    var element = document.getElementById(refName);
    element.scrollIntoView({ behavior: 'smooth' });
  }, 200);
};

/***/ }),

/***/ "9OSu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("\n      Moderação de valores dos dados\n    ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('list',{ref:"listModeration",attrs:{"show-empty":true,"title":'Valores para moderar',"reportTitle":"Moderação de dados","api-url":"moderacao","fields":_vm.listModeration.columns,"initial-page":_vm.listModeration_pagina,"pageCollection":'listModeration'},scopedSlots:_vm._u([{key:"custom",fn:function(props){return [(props.rowData.dado_tipo === 'T')?_c('span',[_c('a',{attrs:{"href":"javascript:void()","title":"Visualize a resposta"},on:{"click":function($event){return _vm.showModal(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'file-alt',"size":"2x"}})],1)]):_c('span',[_vm._v("\n              "+_vm._s(props.rowData.valor_numerico_anterior)+"\n            ")])]}},{key:"custom_2",fn:function(props){return [(props.rowData.dado_tipo === 'T')?_c('span',[_c('a',{attrs:{"href":"javascript:void()","title":"Visualize a resposta"},on:{"click":function($event){return _vm.showModal(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'file-alt',"size":"2x"}})],1)]):_c('span',[_vm._v("\n              "+_vm._s(props.rowData.valor_numerico_atual)+"\n            ")])]}},{key:"rowrender",fn:function(props){return [_c('div',{staticClass:"button-wrapper"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Lista de valores","to":{
                  name: 'admin_dado_valor_list',
                  params: { DAD_IDDADO: props.rowData.DAD_IDDADO }
                }}},[_c('font-awesome-icon',{attrs:{"icon":'list-ol'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Aprovar","type":"button"},on:{"click":function($event){return _vm.aprovar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'check'}})],1)],1)]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('list',{ref:"listApproved",attrs:{"show-empty":true,"title":'Valores aprovados nos ultimos 30 dias',"reportTitle":"Aprovados","api-url":"moderacao?last_approved=30","fields":_vm.listApproved.columns,"initial-page":_vm.listApproved_pagina,"pageCollection":'listApproved'},scopedSlots:_vm._u([{key:"custom",fn:function(props){return [(props.rowData.dado_tipo === 'T')?_c('span',[_c('a',{attrs:{"href":"javascript:void()","title":"Visualize a resposta"},on:{"click":function($event){return _vm.showModal(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'file-alt',"size":"2x"}})],1)]):_c('span',[_vm._v("\n              "+_vm._s(props.rowData.valor_atual)+"\n            ")])]}},{key:"rowrender",fn:function(props){return [_c('div',{staticClass:"button-unique"},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Reprovar","type":"button"},on:{"click":function($event){return _vm.reprovar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'times'}})],1)])]}}])})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Phz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_colors__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BarChart__ = __webpack_require__("yd/Z");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GraficoConsumo',
  components: { BarChart: __WEBPACK_IMPORTED_MODULE_5__common_BarChart__["a" /* BarChart */] },
  props: {
    title: {
      type: String,
      required: true
    },
    reference: {
      type: String,
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    keyValue: {
      type: String,
      required: true
    },
    money: {
      type: Boolean,
      default: false
    },
    unidades: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return { unidadeFiltro: null };
  },

  methods: {
    getLabel: function getLabel(option) {
      return option.nome + ' - ' + option.sigla;
    },
    getChartOptions: function getChartOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { money: false };

      var base = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              suggestedMax: 20,
              callback: function callback(value) {
                return options.money ? value.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL'
                }) : value.toLocaleString();
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function label(tooltip, dataset) {
              var xLabel = dataset.datasets[tooltip.datasetIndex].label;
              var yLabel = options.money ? tooltip.yLabel.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              }) : tooltip.yLabel.toLocaleString();
              return xLabel + ': ' + yLabel;
            }
          }
        }
      };

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, base);
    },
    getValoresGrafico: function getValoresGrafico(_ref) {
      var lista = _ref.lista,
          keyValue = _ref.keyValue;

      var dados = new Array(12).fill(0);
      var objetosDataset = {};
      var datasets = [];

      lista.forEach(function (element) {
        var ano = element['ano_ref'];
        var mes = parseInt(element['mes_ref']) - 1;
        var valor = parseFloat(element[keyValue]);

        if (objetosDataset.hasOwnProperty(ano)) {
          _.first(objetosDataset[ano]).data[mes] += valor;
          return;
        }

        var novoDado = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(dados));
        novoDado[mes] = valor;

        objetosDataset[ano] = [{ label: ano, data: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(novoDado)), backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors__["a" /* default */].coresHexa }];
      });

      var anos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(objetosDataset);

      anos.forEach(function (element) {
        datasets = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(datasets), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(objetosDataset[element]));
      });

      return { labels: __WEBPACK_IMPORTED_MODULE_3__utils__["c" /* mesesAbr */], datasets: datasets };
    }
  },
  computed: {
    chartData: function chartData() {
      var _this = this;

      var values = this.values;

      if (this.unidadeFiltro) {
        var filter = function filter(item) {
          return item.codigo_secretaria === parseInt(_this.unidadeFiltro.id);
        };

        values = values.filter(filter);
      }

      return this.getValoresGrafico({
        lista: values,
        keyValue: this.keyValue
      });
    }
  }
});

/***/ }),

/***/ "9fKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9hZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SideModal',{attrs:{"sides":_vm.navs}},[_c('template',{slot:'emenda'},[(_vm.emenda.id)?_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.emenda.descricao)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Vereador")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.emenda.vereador.nome)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Nº do Processo")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.emenda.numero_processo)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[(_vm.emenda.processos_pagamento.length)?_c('label',[_vm._v("\n            Processos de Pagamento\n          ")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.getProcessosPagamento(_vm.emenda.processos_pagamento))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[(_vm.emenda.resumo_utilizacao)?_c('label',[_vm._v("Utilização")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.emenda.resumo_utilizacao)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Valor")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.formatarMoeda(Number(_vm.emenda.valor)))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Saldo")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.formatarMoeda(Number(_vm.emenda.saldo)))+"\n          ")])])])]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9i0h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("uEig");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ad68ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("TZBS");
function injectStyle (ssrContext) {
  __webpack_require__("ZmJt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02ad68ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ad68ed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9l6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Import_vue__ = __webpack_require__("igL+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bef2b45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Import_vue__ = __webpack_require__("vm0W");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Import_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bef2b45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Import_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9mlN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("4uWV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ff36afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("oMxw");
function injectStyle (ssrContext) {
  __webpack_require__("u+tz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ff36afa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ff36afa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9pAA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9t06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vereadores"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary margem-topo",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.label)+" Vereador")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('fieldset',[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('nome') }]},[_c('label',{class:[
                  'col-xs-12',
                  'control-label',
                  'primary',
                  { 'is-danger': _vm.errors.has('nome') }
                ]},[_vm._v("\n                Nome do vereador\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 inputGroupContainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('nome') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome",class:[
                      'form-control',
                      { 'is-danger': _vm.errors.has('nome') }
                    ],attrs:{"name":"nome","maxlength":"80","placeholder":"Nome do vereador","type":"text"},domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                      'input-group-addon',
                      { 'is-danger': _vm.errors.has('nome') }
                    ],domProps:{"textContent":_vm._s(80 - _vm.model.nome.length)}})]),_vm._v(" "),(_vm.errors.has('nome'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"nome"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('nome'))+"\n                ")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){return _vm.save()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n                  Salvar\n                ")],1)])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9tfk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    secretarias: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      imgUrl: this.$root.$data.imgUrl,
      logo: __webpack_require__("wOM0")
    };
  }
});

/***/ }),

/***/ "9ym8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
var mutations = {
  SET_FILTER_FIELD: function SET_FILTER_FIELD(state, payload) {
    state[payload.collection].filtros[payload.field] = payload.value;
  },
  SET_FILTER_PAGE: function SET_FILTER_PAGE(state, payload) {
    state[payload.collection].pagina = payload.value;
  }
};

/***/ }),

/***/ "A11D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");


//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dados: {
      type: Array,
      required: true
    },
    tipo: {
      validator: function validator(value) {
        return ['agendados', 'espera'].includes(value);
      },

      required: true
    }
  },
  methods: {
    exportCSV: function exportCSV() {
      switch (this.tipo) {
        case 'agendados':
          return this.exportAgendadosToCSV(this.dados);
        case 'espera':
          return this.exportEsperaToCSV(this.dados);
        default:
          return console.log('opção inválida');
      }
    },
    exportEsperaToCSV: function exportEsperaToCSV(data) {
      var headers = {
        posicao: 'Posição',
        cns: 'Nº Cartão SUS',
        gravidade: 'Gravidade',
        dtsolicitacao: 'Data Solicitação',
        especialidade: 'Especialidade',
        media_espera: 'Média de Espera (Dias)'
      };

      var items = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.map(function (item) {
        return {
          posicao: item.posicao,
          cns: item.cns,
          gravidade: item.gravidade,
          dtsolicitacao: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* formatTo2DigitsDate */])(new Date(item.dtsolicitacao)),
          especialidade: item.especialidade,
          media_espera: item.media_espera
        };
      })));

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* exportCSVFile */])(headers, items, 'lista_espera');
    },
    exportAgendadosToCSV: function exportAgendadosToCSV(data) {
      var _data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(data, 1),
          first = _data[0];

      var headers = {
        cns: 'Nº Cartão SUS',
        gravidade: 'Gravidade',
        dtsolicitacao: 'Data Solicitação',
        dtagendamento: 'Data Agendamento',
        espec_exame: first.especialidade ? 'Especialidade' : 'Exame',
        unidade_destino: 'Unidade',
        endereco: 'Endereço'
      };

      var items = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.map(function (item) {
        return {
          cns: item.cns,
          gravidade: item.gravidade,
          dtsolicitacao: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* formatTo2DigitsDate */])(new Date(item.dtsolicitacao)),
          dtagendamento: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* formatTo2DigitsDate */])(new Date(item.dtagendamento)),
          espec_exame: item.especialidade || item.exame,
          unidade_destino: item.unidade_destino,
          endereco: item.endereco
        };
      })));

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* exportCSVFile */])(headers, items, 'lista_agendados');
    }
  }
});

/***/ }),

/***/ "AHzu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ASSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


var reducer = function reducer(key) {
  return function (acum, emenda) {
    return acum += Number(emenda[key]);
  };
};

var getters = {
  quantidadeEmendas: function quantidadeEmendas(_ref) {
    var emendas = _ref.emendas;
    return emendas.length;
  },
  valorTotalEmendas: function valorTotalEmendas(_ref2) {
    var emendas = _ref2.emendas;

    return emendas.reduce(reducer('valor'), 0);
  },
  quantidadeVereadores: function quantidadeVereadores(_ref3) {
    var emendas = _ref3.emendas;

    var unique = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(emendas.map(function (item) {
      return item.vereador_id;
    }))));
    return unique.length;
  },
  saldoTotal: function saldoTotal(_ref4) {
    var emendas = _ref4.emendas;

    return emendas.reduce(reducer('saldo'), 0);
  },
  valorTotalUtilizado: function valorTotalUtilizado(_, getters) {
    return getters.valorTotalEmendas - getters.saldoTotal;
  },
  emendasPorSecretaria: function emendasPorSecretaria(_ref5) {
    var emendas = _ref5.emendas;
    return function (secretaria) {
      var filter = function filter(item) {
        return item.nome_orgao === secretaria;
      };

      return emendas.filter(filter);
    };
  },
  valorTotalPorSecretaria: function valorTotalPorSecretaria(_, getters) {
    return function (secretaria) {
      var emendasPorSecretaria = getters.emendasPorSecretaria(secretaria);

      return emendasPorSecretaria.reduce(reducer('valor'), 0);
    };
  },
  saldoTotalPorSecretaria: function saldoTotalPorSecretaria(_, getters) {
    return function (secretaria) {
      var emendasPorSecretaria = getters.emendasPorSecretaria(secretaria);

      return emendasPorSecretaria.reduce(reducer('saldo'), 0);
    };
  },
  secretariasComEmendas: function secretariasComEmendas(_ref6) {
    var emendas = _ref6.emendas;

    var secretarias = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(emendas.map(function (emenda) {
      return emenda.nome_orgao;
    }))));

    return secretarias;
  },
  vereadoresComEmendas: function vereadoresComEmendas(_ref7) {
    var emendas = _ref7.emendas;

    var vereadores = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(emendas.map(function (emenda) {
      return emenda.vereador.nome;
    }))));

    return vereadores;
  }
};

/***/ }),

/***/ "AUiK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Aaei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("f/CB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ddda8da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4woO");
function injectStyle (ssrContext) {
  __webpack_require__("1rCw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ddda8da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ddda8da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ak+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var columnCustom = [{ name: '__slot:column', title: 'Tipo Candidato' }];

var columnsDefault = [{ name: 'classificacao', title: 'Classificação' }, { name: 'nome', title: 'Nome' }, {
  name: 'data_habilitado',
  title: 'Data Habilitação',
  titleClass: 'text-center',
  dataClass: 'text-center'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'acompanhamento_detalhes_cargo',
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_0__components_common_NoApiTable__["a" /* default */]
  },
  data: function data() {
    return {
      fields: {
        habilitados: [].concat(columnsDefault),
        nomeados: [].concat(columnCustom, columnsDefault, [{
          name: 'data_nomeacao',
          title: 'Data Nomeação',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }]),
        empossados: [].concat(columnCustom, columnsDefault, [{
          name: 'data_nomeacao',
          title: 'Data Nomeação',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }, {
          name: 'data_empossado',
          title: 'Data Empossado',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }]),
        revogados: [].concat(columnCustom, columnsDefault, [{
          name: 'data_nomeacao',
          title: 'Data Nomeação',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }, {
          name: 'data_revogacao',
          title: 'Data Revogação',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }])
      },
      cargo: {
        id: 0,
        data_homologacao: '',
        data_validade: '',
        descricao: '',
        edital: { id: 0, numero: '' },
        ultima_nomeacao: '',
        vagas: 0,
        vagas_QP: 0,
        vagas_cotas: 0,
        vagas_pcd: 0
      },
      habilitados: [],
      isLoading: false,
      params: { edital_id: 0, cargo_id: 0 }
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.params = this.$router.history.current.params;

    this.carregarCargo();
    this.carregarHabilitados();
  },

  computed: {
    userPerfil: function userPerfil() {
      var perfis = this.$store.state.user.perfis;


      if (perfis && perfis.includes('admin') || perfis.includes('concursos-admin')) return 'admin';else return 'default';
    },
    habilitadosNormal: function habilitadosNormal() {
      return this.habilitados.filter(function (item) {
        return item.tipo_pcd === 0;
      });
    },
    habilitadosPCD: function habilitadosPCD() {
      return this.habilitados.filter(function (item) {
        return item.tipo_pcd === 1;
      });
    },
    nomeados: function nomeados() {
      return this.habilitados.filter(function (item) {
        return item.data_nomeacao && !item.data_empossado && !item.data_revogacao;
      });
    },
    empossados: function empossados() {
      return this.habilitados.filter(function (item) {
        return !!item.data_empossado;
      });
    },
    revogados: function revogados() {
      return this.habilitados.filter(function (item) {
        return !!item.data_revogacao;
      });
    }
  },
  methods: {
    retornarTipoCandidato: function retornarTipoCandidato(_ref) {
      var tipo_pcd = _ref.tipo_pcd,
          tipo_cotas = _ref.tipo_cotas;

      if (tipo_pcd) {
        return 'PCD';
      }

      if (tipo_cotas) {
        return 'Cotas';
      }

      return 'Geral';
    },
    carregarCargo: function carregarCargo() {
      var _this = this;

      var toogleLoading = this.toogleLoading;
      var cargo_id = this.params.cargo_id;


      toogleLoading();

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('cargo/' + cargo_id).then(function (response) {
        return _this.cargo = response.data;
      }).catch(function (error) {
        return console.log(error.response);
      }).then(toogleLoading);
    },
    carregarHabilitados: function carregarHabilitados() {
      var _this2 = this;

      var toogleLoading = this.toogleLoading,
          params = this.params;


      toogleLoading();

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('habilitado', { params: params }).then(function (response) {
        return _this2.habilitados = response.data;
      }).catch(function (error) {
        return console.log(error.response);
      }).then(toogleLoading);
    },
    toogleLoading: function toogleLoading() {
      this.isLoading = !this.isLoading;
    },

    scrollToElement: __WEBPACK_IMPORTED_MODULE_2__utils__["o" /* scrollToElement */]
  }
});

/***/ }),

/***/ "Amox":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"materiais-padronizados"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.label)+" Material Padronizado")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('form',{attrs:{"role":"form","id":"tag_form"},on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('fieldset',[_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:[
                'form-group',
                { 'has-error': _vm.errors.has('grupo_codigo') }
              ]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Grupo")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.grupo_codigo),expression:"model.grupo_codigo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"grupo_codigo",staticClass:"form-control select-selected",attrs:{"name":"grupo_codigo"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "grupo_codigo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.loadSubgrupos]}},_vm._l((_vm.grupos),function(p){return _c('option',{key:p.codigo,domProps:{"value":p.codigo}},[_vm._v("\n                    "+_vm._s(p.nome)+"\n                  ")])}),0)]),_vm._v(" "),(_vm.errors.has('grupo_codigo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"grupo_codigo"}},[_vm._v("Preenchimento obrigatório!")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:[
                'form-group',
                { 'has-error': _vm.errors.has('subgrupo_codigo') }
              ]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Subgrupo")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.subgrupo_codigo),expression:"model.subgrupo_codigo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"subgrupo_codigo",staticClass:"form-control select-selected",attrs:{"name":"subgrupo_codigo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "subgrupo_codigo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.subgrupos),function(p){return _c('option',{key:p.codigo,domProps:{"value":p.codigo}},[_vm._v("\n                    "+_vm._s(p.nome)+"\n                  ")])}),0)]),_vm._v(" "),(_vm.errors.has('subgrupo_codigo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"subgrupo_codigo"}},[_vm._v("Preenchimento obrigatório!")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:[
                'form-group',
                { 'has-error': _vm.errors.has('medida_codigo') }
              ]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Medida")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.medida_codigo),expression:"model.medida_codigo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"medida_codigo",staticClass:"form-control select-selected",attrs:{"name":"medida_codigo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "medida_codigo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.medidas),function(p){return _c('option',{key:p.codigo,domProps:{"value":p.codigo}},[_vm._v("\n                    "+_vm._s(p.nome)+"\n                  ")])}),0)]),_vm._v(" "),(_vm.errors.has('medida_codigo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"medida_codigo"}},[_vm._v("Preenchimento obrigatório!")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:[
                'form-group',
                { 'has-error': _vm.errors.has('referencia') }
              ]},[_c('label',{class:[
                  'control-label',
                  'custom-font',
                  { 'is-danger': _vm.errors.has('referencia') }
                ]},[_vm._v("Referência")]),_vm._v(" "),_c('div',{staticClass:"inputGroupContainer"},[_c('div',{staticClass:"input-group"},[_c('span',{class:[
                      'input-group-addon',
                      { 'is-danger': _vm.errors.has('referencia') }
                    ]},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('referencia') }],attrs:{"icon":'tags'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.referencia),expression:"model.referencia"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"referencia",class:[
                      'form-control',
                      { 'is-danger': _vm.errors.has('referencia') }
                    ],attrs:{"name":"referencia","maxlength":"13","placeholder":"Referência","type":"text"},domProps:{"value":(_vm.model.referencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "referencia", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': _vm.errors.has('referencia') }
                    ],domProps:{"textContent":_vm._s(13 - _vm.model.referencia.length)}})]),_vm._v(" "),(_vm.errors.has('referencia'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"referencia"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('referencia'))+"\n                ")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('nome') }]},[_c('label',{class:[
                  'control-label',
                  'custom-font',
                  { 'is-danger': _vm.errors.has('nome') }
                ]},[_vm._v("Nome")]),_vm._v(" "),_c('div',{staticClass:"inputGroupContainer"},[_c('div',{staticClass:"input-group"},[_c('span',{class:[
                      'input-group-addon',
                      { 'is-danger': _vm.errors.has('nome') }
                    ]},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('nome') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome",class:[
                      'form-control',
                      'custom-input',
                      { 'is-danger': _vm.errors.has('nome') }
                    ],attrs:{"name":"nome","maxlength":"100","placeholder":"Nome","type":"text"},domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': _vm.errors.has('nome') }
                    ],domProps:{"textContent":_vm._s(100 - _vm.model.nome.length)}})]),_vm._v(" "),(_vm.errors.has('nome'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"nome"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('nome'))+"\n                ")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{class:[
                'form-group',
                { 'has-error': _vm.errors.has('descricao') }
              ]},[_c('label',{class:[
                  'control-label',
                  'custom-font',
                  { 'is-danger': _vm.errors.has('descricao') }
                ]},[_vm._v("Descrição")]),_vm._v(" "),_c('div',{staticClass:"inputGroupContainer"},[_c('div',{staticClass:"input-group"},[_c('span',{class:[
                      'input-group-addon',
                      { 'is-danger': _vm.errors.has('descricao') }
                    ]},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('descricao') }],attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"descricao",class:[
                      'form-control',
                      { 'is-danger': _vm.errors.has('descricao') }
                    ],attrs:{"name":"descricao","maxlength":"1000","placeholder":"Informe a descrição do material...","rows":"10"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': _vm.errors.has('descricao') }
                    ],domProps:{"textContent":_vm._s(1000 - _vm.model.descricao.length)}})]),_vm._v(" "),(_vm.errors.has('descricao'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"descricao"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('descricao'))+"\n                ")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n                  Salvar\n                ")],1)])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ApCf":
/***/ (function(module, exports) {

module.exports = {"_from":"weekstart@^1.0.0","_id":"weekstart@1.1.0","_inBundle":false,"_integrity":"sha512-ZO3I7c7J9nwGN1PZKZeBYAsuwWEsCOZi5T68cQoVNYrzrpp5Br0Bgi0OF4l8kH/Ez7nKfxa5mSsXjsgris3+qg==","_location":"/weekstart","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"weekstart@^1.0.0","name":"weekstart","escapedName":"weekstart","rawSpec":"^1.0.0","saveSpec":null,"fetchSpec":"^1.0.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/weekstart/-/weekstart-1.1.0.tgz","_shasum":"af642eb10dc24b1af9d4dcc0415056edc087b897","_spec":"weekstart@^1.0.0","_where":"/home/gitlab-runner/builds/6c4bbb72/0/otc/dadosabertos/frontend","author":{"name":"Denis Sikuler"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"bundleDependencies":false,"deprecated":false,"description":"Library to get first day of week.","devDependencies":{"@babel/preset-env":"^7.13.10","eslint":"^7.22.0","eslint-config-guard":"^2.0.1","ink-docstrap":"1.3.2","jest":"^26.6.3","jsdoc":"^3.6.6","jsdoc-file":"^1.0.1","microbundle":"0.4.4","version-bump-prompt":"^6.1.0"},"files":["dist","full.js","full.d.ts","index.d.ts","src","History.md"],"homepage":"https://github.com/gamtiq/weekstart","keywords":["week","start","first","day","locale","country","region"],"license":"MIT","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","name":"weekstart","repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"scripts":{"all":"npm run check-all && npm run doc && npm run build","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.js","lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","test":"jest"},"types":"./index.d.ts","umd:main":"dist/main.js","version":"1.1.0"}

/***/ }),

/***/ "Asmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("XCQu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0729094_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("haG+");
function injectStyle (ssrContext) {
  __webpack_require__("fIhQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c0729094"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0729094_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AxvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressoGeral_vue__ = __webpack_require__("zIB3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_785b57b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressoGeral_vue__ = __webpack_require__("EgXX");
function injectStyle (ssrContext) {
  __webpack_require__("202F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-785b57b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressoGeral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_785b57b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressoGeral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Az5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"help-block"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n  "+_vm._s(_vm.message)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B+DO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-lg"},[_c('label',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.type === 'single')?_c('span',[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.type === 'list')?_c('ul',{attrs:{"id":"eixos"}},_vm._l((_vm.list),function(item){return _c('li',{key:item.codigo},[_vm._v("\n        "+_vm._s(item.descricao)+"\n      ")])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B3Jd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_colors__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common___ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__("bGai");










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'selecionados',
    components: {
        PublicHeader: __WEBPACK_IMPORTED_MODULE_6__components_common___["a" /* PublicHeader */],
        Breadcrumb: __WEBPACK_IMPORTED_MODULE_7__components__["b" /* Breadcrumb */],
        BarChart: __WEBPACK_IMPORTED_MODULE_6__components_common___["d" /* BarChart */],
        LineChart: __WEBPACK_IMPORTED_MODULE_6__components_common___["f" /* LineChart2 */]
    },
    data: function data() {
        return {
            selecionados: [],
            dados: [],
            comparativos: [],
            cores: __WEBPACK_IMPORTED_MODULE_5__utils_colors__["a" /* default */].coresHexa,
            tipoGrafico: 'bar',
            tipoComparativo: 'soma'
        };
    },

    methods: {
        toDate: function toDate(dateStr) {
            var _dateStr$split = dateStr.split("/"),
                _dateStr$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_dateStr$split, 3),
                day = _dateStr$split2[0],
                month = _dateStr$split2[1],
                year = _dateStr$split2[2];

            return new Date(year, month - 1, day);
        },
        adicionarComparativo: function adicionarComparativo(id, nome) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_4__request__["b" /* default */].get('selecionados/valores/' + id, function (response) {
                var datas = response.datas,
                    valores = response.valores;


                _this.dados.push({
                    'codigo': id,
                    'nome': nome,
                    'valores': valores,
                    'datas': datas
                });

                var aux = {};
                for (var index = 0; index < datas.length; index++) {
                    var data_dado = _this.toDate(datas[index]);
                    aux[data_dado.getFullYear()] = valores[index];
                }

                _this.comparativos.push(aux);
            }, function (response) {
                _this.$toastr.e(response);
            });
        },
        removerComparativo: function removerComparativo(item) {
            this.dados.splice(item, 1);
            this.comparativos.splice(item, 1);
        },
        permitirComparativo: function permitirComparativo(selecionado) {
            if (selecionado.tipo === 'T' || this.dados.findIndex(function (val) {
                return val.codigo === selecionado.codigo;
            }) > -1 || this.dados.length > 4) {
                return false;
            }

            return true;
        },
        retornaSoma: function retornaSoma(grafico) {
            var result = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.comparativos));
            var anos = grafico.labels;

            grafico.datasets.push({
                label: 'Soma Simples',
                backgroundColor: '#de1a1a',
                data: []
            });

            result = result.reduce(function (acumulador, atual) {
                var res = {};
                for (var index = 0; index < anos.length; index++) {
                    res[anos[index]] = (parseFloat(acumulador[anos[index]]) || 0) + (parseFloat(atual[anos[index]]) || 0);
                }

                return res;
            });

            for (var index = 0; index < anos.length; index++) {
                grafico.datasets[0].data.push(result[anos[index]]);
            }

            return grafico;
        },
        retornaMediaSimples: function retornaMediaSimples(grafico) {
            var _this2 = this;

            var result = this.retornaSoma(grafico);
            result.datasets[0].label = 'Média simples';
            result.datasets[0].data = result.datasets[0].data.map(function (valor) {
                return valor / _this2.comparativos.length;
            });

            return result;
        },
        retornaMediaAnual: function retornaMediaAnual(grafico) {
            var base = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.comparativos));
            var result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, grafico, {
                labels: ['Média Anual']
            });

            for (var index = 0; index < base.length; index++) {
                var anos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(base[index]);
                var acumulador = 0;

                for (var subindex = 0; subindex < anos.length; subindex++) {
                    acumulador += parseFloat(base[index][anos[subindex]]) || 0;
                }

                result.datasets.push({
                    label: 'Dado ' + (index + 1),
                    data: [acumulador / anos.length]
                });
            }

            return result;
        },
        retornaRelacao: function retornaRelacao(grafico) {
            var result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, grafico);
            var anos = result.labels;
            var base = [];

            for (var index = 0; index < 2; index++) {
                base.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.comparativos[index]));
            }

            var relacao = base.reduce(function (acumulador, atual) {
                var res = [];
                for (var _index = 0; _index < anos.length; _index++) {
                    res.push((parseFloat(acumulador[anos[_index]]) || 0) / (parseFloat(atual[anos[_index]]) || 1));
                }

                return res;
            });

            result.datasets.push({
                label: 'Relação Dado 1 / Dado 2',
                data: relacao
            });

            return result;
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        var ids = this.$route.params.ids;

        if (ids) {
            var idsArray = ids.split(',');

            var queryString = idsArray.map(function (id, index) {
                return index + '=' + id;
            }).join('&');

            __WEBPACK_IMPORTED_MODULE_4__request__["b" /* default */].get('selecionados?' + queryString, function (response) {
                _this3.selecionados = response;
            }, function (response) {
                console.log(response);
            });
        } else {
            console.error('Parâmetros da URL não encontrados');
        }
    },

    computed: {
        labels_grafico: function labels_grafico() {
            var _this4 = this;

            var base = [2014];
            var periodicidade = this.selecionados[this.selecionados.findIndex(function (val) {
                return val.codigo === _this4.dados[0].codigo;
            })].periodicidade;

            if (periodicidade === 6) {
                var data = new Date();
                while (base[base.length - 1] < data.getFullYear() - 1) {
                    base.push(base[base.length - 1] + 1);
                }
            }

            return base;
        },
        dados_grafico: function dados_grafico() {
            var anos = this.labels_grafico;
            var dados = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.comparativos));
            var base = {
                labels: this.labels_grafico,
                datasets: []
            };

            for (var index = 0; index < dados.length; index++) {
                base.datasets.push({
                    label: '',
                    data: []
                });

                for (var subindex = 0; subindex < anos.length; subindex++) {
                    base.datasets[index].data.push(dados[index][anos[subindex]]);
                }
            }

            return base;
        },
        dados_comparativos: function dados_comparativos() {
            var grafico = {
                labels: this.labels_grafico,
                datasets: []
            };

            switch (this.tipoComparativo) {
                case 'soma':
                    return this.retornaSoma(grafico);
                case 'mediaSimples':
                    return this.retornaMediaSimples(grafico);
                case 'mediaAnual':
                    return this.retornaMediaAnual(grafico);
                case 'relacao':
                    return this.retornaRelacao(grafico);
                default:
                    return grafico;
            }
        },
        breadcrumblinks: function breadcrumblinks() {
            var baseRoute = this.$route.query.origem === 'dados-secretaria' ? '/listar/dados-secretaria' : '/listar/dados';

            return [{ label: 'Listagem', link: baseRoute }, { label: 'Comparar dados' }];
        }
    }
});

/***/ }),

/***/ "BCwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("unm1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c703ee2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Ng2V");
function injectStyle (ssrContext) {
  __webpack_require__("+j0S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c703ee2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c703ee2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BOqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__ = __webpack_require__("7F3e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_371f944c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__ = __webpack_require__("lmlf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_371f944c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BRYr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BTPm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bb7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-time-container"},[_c('div',{staticClass:"select-time-row"},[_c('div',{staticClass:"select-time-control"},[_c('label',{staticClass:"control-label"},[_vm._v("Horário")]),_vm._v(" "),_c('Select',{attrs:{"options":_vm.timeList},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)]),_vm._v(" "),_c('div',{staticClass:"select-time-row"},[_c('div',{staticClass:"select-time-control"},[_c('label',{staticClass:"control-label"},[_vm._v("Entrada")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.entrada),expression:"entrada"},{name:"mask",rawName:"v-mask",value:('##h##'),expression:"'##h##'"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.inputDisable,"spellcheck":"false"},domProps:{"value":(_vm.entrada)},on:{"keydown":_vm.keydownFormatTime,"change":_vm.update,"input":function($event){if($event.target.composing){ return; }_vm.entrada=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"select-time-control"},[_c('label',{staticClass:"control-label"},[_vm._v("Saida")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saida),expression:"saida"},{name:"mask",rawName:"v-mask",value:('##h##'),expression:"'##h##'"}],staticClass:"form-control",attrs:{"disabled":_vm.inputDisable,"spellcheck":"false"},domProps:{"value":(_vm.saida)},on:{"keydown":_vm.keydownFormatTime,"change":_vm.update,"input":function($event){if($event.target.composing){ return; }_vm.saida=$event.target.value}}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bgom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Select__ = __webpack_require__("MGJx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Select: __WEBPACK_IMPORTED_MODULE_0__components_common_Select__["a" /* default */]
  },
  props: {
    value: {
      type: String
    },
    referencia: {
      type: String,
      required: true
    }
  },
  created: function created() {
    if (this.referencia) this.loadAndSetUors();
  },
  data: function data() {
    return {
      uors: [{
        label: 'Selecione a unidade de saúde',
        value: null
      }],
      uor: null
    };
  },

  watch: {
    value: function value(_value) {
      this.uor = _value;
    },
    referencia: function referencia(value) {
      if (value) this.loadAndSetUors();else this.reset();
    }
  },
  methods: {
    loadAndSetUors: function loadAndSetUors() {
      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('escala/listar-unidade-usuario-disponivel-escala?referencia=' + this.referencia).then(this.setUors).catch(function (e) {
        console.log(e);
      });
    },
    setUors: function setUors(_ref) {
      var data = _ref.data;

      if (data.length === 0) {
        this.uors = [{ label: 'Não há nenhuma unidade disponivel para lançamento nesta referência!', value: null }];
        this.uor = null;
        this.$toastr.w('As escalas com está referência devem estar em analise!');
        return;
      } else {
        this.uors = data.map(function (_ref2) {
          var uor_sigla = _ref2.uor_sigla,
              uor_nome = _ref2.uor_nome;

          return {
            value: uor_sigla + '|' + uor_nome,
            label: uor_sigla + ' | ' + uor_nome
          };
        });

        this.uor = this.uors[0].value;
        this.update();
      }
    },
    update: function update() {
      this.$emit('input', this.uor);
    },
    reset: function reset() {
      this.uors = [{
        label: 'Selecione a unidade de saúde',
        value: null
      }];
      this.uor = null;
    }
  }
});

/***/ }),

/***/ "Bnh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ZGVt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ae8ebe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("eIf4");
function injectStyle (ssrContext) {
  __webpack_require__("UsLt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25ae8ebe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ae8ebe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BrMx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"compromisso-header"},[_c('h1',{staticClass:"titulo-compromisso"},[_vm._v("\n        "+_vm._s(_vm.model.periodo)+" "+_vm._s(_vm.model.descritivo)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"descricao-status"},[_c('div'),_vm._v(" "),_c('span',{staticClass:"label-status",class:_vm.statusClass(_vm.model.status)},[_vm._v("\n          "+_vm._s(_vm.model.status)+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"info-sub"},[_c('strong',[_vm._v("Unidade:")]),_vm._v(" "+_vm._s(_vm.model.unidade_executora))]),_vm._v(" "),(_vm.model.responsavel)?_c('p',{staticClass:"info-sub"},[_c('strong',[_vm._v("Responsável:")]),_vm._v(" "+_vm._s(_vm.model.responsavel.nome)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Ações vinculadas ao compromisso","api-url":("planogoverno/compromisso-acao?compromisso_id=" + _vm.id),"report-title":"Ações do compromisso","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'compromissoDetails',"append-params":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Informações","type":"button"},on:{"click":function($event){return _vm.detalhar(props.rowData)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'info'}})],1),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Editar","to":{
                  name: 'admin_planogoverno_acao_edit',
                  params: { id: props.rowData.id }
                }}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","title":"Deletar"},on:{"click":function($event){return _vm.deleteAcao(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}})],1)],1)]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-2"},[_c('label',{staticClass:"custom-font",attrs:{"for":"unidade_filter"}},[_vm._v("Unidades")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.unidade),expression:"unidade"}],ref:"unidade_filter",staticClass:"form-control select-selected",attrs:{"name":"unidade_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.unidade=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":""}},[_vm._v("Todas")]),_vm._v(" "),_vm._l((_vm.unidadesDisponiveis),function(unidade){return _c('option',{key:unidade,domProps:{"value":unidade}},[_vm._v("\n                      "+_vm._s(unidade)+"\n                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('label',{staticClass:"custom-font",attrs:{"for":"descritivo_filter"}},[_vm._v("Descritivo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.descritivo),expression:"descritivo"}],ref:"descritivo_filter",staticClass:"form-control",attrs:{"type":"text","name":"descritivo_filter","placeholder":"Buscar por descrição"},domProps:{"value":(_vm.descritivo)},on:{"change":_vm.consultar,"input":function($event){if($event.target.composing){ return; }_vm.descritivo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('label',{staticClass:"custom-font",attrs:{"for":"status-filter"}},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],ref:"status_filter",staticClass:"form-control select-selected",attrs:{"name":"status_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("\n                      Todos\n                    ")]),_vm._v(" "),_vm._l((_vm.listas.status),function(status){return _c('option',{key:status,domProps:{"value":status}},[_vm._v("\n                      "+_vm._s(status)+"\n                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'admin_planogoverno_acao_save', params: { id: this.id } },"disabled":_vm.model.status === 'Cancelado' || _vm.model.status === 'Concluído'}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" Adicionar\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)]),_vm._v(" "),_c('SideAcao',{ref:"side",attrs:{"navs":_vm.sideConfig},on:{"deletar":_vm.confirmarDelete}}),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left"}}),_vm._v(" Voltar\n    ")],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Brul":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C4HD":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.jpg": "YTMB",
	"./10.jpg": "7/wm",
	"./11.jpg": "hQn3",
	"./12.jpg": "u3WT",
	"./13.jpg": "Juz5",
	"./14.jpg": "WKXi",
	"./15.jpg": "Hi7N",
	"./16.jpg": "pEvt",
	"./17.jpg": "+FX6",
	"./2.jpg": "84Lw",
	"./3.jpg": "Wzr1",
	"./4.jpg": "VINc",
	"./5.jpg": "1neZ",
	"./6.jpg": "mbtb",
	"./7.jpg": "CUx3",
	"./8.jpg": "LrMQ",
	"./9.jpg": "GAy2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "C4HD";

/***/ }),

/***/ "C9Vx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_DoughnutChart_js__ = __webpack_require__("xVH2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_colors_js__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_entidades_js__ = __webpack_require__("Sr7P");












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PDM',
  components: {
    doughnut: __WEBPACK_IMPORTED_MODULE_6__components_common_DoughnutChart_js__["a" /* default */],
    PublicHeader: __WEBPACK_IMPORTED_MODULE_9__components_common__["a" /* PublicHeader */]
  },
  data: function data() {
    return {
      metas: [],
      unidade: '',
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: true
        },
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            formatter: function formatter(value, ctx) {
              var sum = 0;
              var dataArr = ctx.chart.data.datasets[0].data;
              dataArr.map(function (data) {
                sum += data;
              });
              var percentage = (value * 100 / sum).toFixed(2) + '%';
              return percentage;
            },
            color: ['#000', '#FFF', '#000', '#FFF', '#FFF', '#FFF', '#000']
          }
        }
      }
    };
  },
  created: function created() {
    this.loadMetas();
  },

  computed: {
    total: function total() {
      return this.metas.length;
    },
    concluidas: function concluidas() {
      var concluidas = this.metas.filter(function (i) {
        return i.tipostatusplano === 'CONCLUÍDA';
      });
      return concluidas.length;
    },
    emAndamento: function emAndamento() {
      var emAndamento = this.metas.filter(function (i) {
        return i.tipostatusplano === 'EM ANDAMENTO';
      });
      return emAndamento.length;
    },
    naoCumpridas: function naoCumpridas() {
      var naoCumpridas = this.metas.filter(function (i) {
        return i.tipostatusplano === 'NÃO CUMPRIDA';
      });
      return naoCumpridas.length;
    },
    metasPorStatus: function metasPorStatus() {
      var _this = this;

      var status = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(this.metas.map(function (m) {
        return m.tipostatusplano;
      }))));
      var result = status.map(function (status) {
        return { status: status, total: _this.metas.filter(function (m) {
            return m.tipostatusplano === status;
          }).length };
      });

      return result;
    },
    metasSecretariaStatus: function metasSecretariaStatus() {
      if (unidade) return [];

      var metas = this.metas,
          unidade = this.unidade;

      var metasSecretaria = metas.filter(function (m) {
        return m.unidaderesponsavel === unidade;
      });

      var status = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(metasSecretaria.map(function (m) {
        return m.tipostatusplano;
      }))));
      var result = status.map(function (status) {
        return { status: status, total: metasSecretaria.filter(function (m) {
            return m.tipostatusplano === status;
          }).length };
      });

      return result;
    },
    secretarias: function secretarias() {
      var data = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(this.metas.map(function (m) {
        return m.unidaderesponsavel;
      }))));
      data.sort();

      this.unidade = data[0];

      return data;
    },
    secretariaSumario: function secretariaSumario() {
      var _this2 = this;

      var data = {
        total: 0,
        totalPorcentagem: 0,
        concluidas: 0,
        emAndamento: 0,
        naoCumpridas: 0,
        naoIniciadas: 0
      };

      if (!this.unidade) return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data);

      var metasSecretaria = this.metas.filter(function (m) {
        return m.unidaderesponsavel === _this2.unidade;
      });

      data.total = metasSecretaria.length;
      data.totalPorcentagem = (data.total / this.metas.length * 100).toFixed(2);
      data.concluidas = metasSecretaria.filter(function (i) {
        return i.tipostatusplano === 'CONCLUÍDA';
      }).length;
      data.emAndamento = metasSecretaria.filter(function (i) {
        return i.tipostatusplano === 'EM ANDAMENTO';
      }).length;
      data.naoCumpridas = metasSecretaria.filter(function (i) {
        return i.tipostatusplano === 'NÃO CUMPRIDA';
      }).length;
      data.naoIniciadas = metasSecretaria.filter(function (i) {
        return i.tipostatusplano === 'NÃO INFORMADA';
      }).length;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data);
    },
    secretariasTop6Metas: function secretariasTop6Metas() {
      var metasPorSecretaria = Object.groupBy(this.metas, function (_ref) {
        var unidaderesponsavel = _ref.unidaderesponsavel;
        return unidaderesponsavel;
      });
      var ranking = [];

      for (var sigla in metasPorSecretaria) {
        var count = metasPorSecretaria[sigla].length;

        var percentual = (count / this.metas.length * 100).toFixed(2);
        ranking.push({ sigla: sigla, count: count, percentual: percentual });
      }

      ranking.sort(function (a, b) {
        return b.total - a.total;
      });

      return ranking.slice(0, 6);
    },
    rankingConcluidas: function rankingConcluidas() {
      var metas = this.metas,
          entidadeBySigla = this.entidadeBySigla;

      var metasAgrupdasSecretaria = Object.groupBy(metas, function (_ref2) {
        var unidaderesponsavel = _ref2.unidaderesponsavel;
        return unidaderesponsavel;
      });
      var data = [];
      var totalMetas = 0;
      var totalConcluidas = 0;

      for (var sigla in metasAgrupdasSecretaria) {
        var metasSecretaria = metasAgrupdasSecretaria[sigla];
        var metasSecretariaConcluidas = metasSecretaria.filter(function (m) {
          return m.tipostatusplano === 'CONCLUÍDA';
        });

        var total = metasSecretaria.length;
        var concluidas = metasSecretariaConcluidas.length;

        var percentual = (concluidas / total * 100).toFixed(2);

        data.push({ sigla: sigla, secretaria: entidadeBySigla(sigla), total: total, concluidas: concluidas, percentual: percentual });

        totalMetas += total;
        totalConcluidas += concluidas;
      }

      data.sort(function (a, b) {
        return b.percentual - a.percentual;
      });

      return {
        data: data,
        totalMetas: totalMetas,
        totalConcluidas: totalConcluidas,
        totalPercentual: (totalConcluidas / totalMetas * 100).toFixed(2)
      };
    },
    link_externo: function link_externo() {
      return 'https://egov.santos.sp.gov.br/santosmapeada/Gestao/PlanoMunicipalGoverno/MapaPlanoMunicipalGoverno/montarMapaPlanoMunicipalGoverno/' + this.unidade.iduorre;
    }
  },
  methods: {
    loadMetas: function loadMetas() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref3, status, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get('sigsantos/planometas');

              case 2:
                _ref3 = _context.sent;
                status = _ref3.status;
                data = _ref3.data;

                if (!(status != 200)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', _this3.$toastr.e('Houve um problema ao tentar carregar as metas, tente novamente daqui alguns minutos!'));

              case 7:

                _this3.metas = data;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    createChartData: function createChartData(dados) {
      return {
        labels: [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(dados.map(function (_ref4) {
          var status = _ref4.status;
          return status;
        }))),
        datasets: [{
          data: [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(dados.map(function (_ref5) {
            var total = _ref5.total;
            return total;
          }))),
          backgroundColor: __WEBPACK_IMPORTED_MODULE_7__utils_colors_js__["a" /* default */].coresRGB,
          borderWidth: 0
        }]
      };
    },
    DownloadJSON2CSV: function DownloadJSON2CSV() {
      var headers = {
        indice: ' - ',
        sigla: 'Sigla',
        secretaria: 'Unidade',
        total: 'Total de Metas',
        concluidas: 'Concluídas',
        percentual: 'Percentual (%)'
      };

      var _rankingConcluidas = this.rankingConcluidas,
          data = _rankingConcluidas.data,
          total = _rankingConcluidas.totalMetas,
          concluidas = _rankingConcluidas.totalConcluidas,
          percentual = _rankingConcluidas.totalPercentual;

      var footers = { indice: '', sigla: '', secretaria: 'TOTAL', total: total, concluidas: concluidas, percentual: percentual.replace('.', ',') };

      var items = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(data.map(function (_ref6, index) {
        var sigla = _ref6.sigla,
            secretaria = _ref6.secretaria,
            total = _ref6.total,
            concluidas = _ref6.concluidas,
            percentual = _ref6.percentual;
        return {
          indice: index + 1,
          sigla: sigla,
          secretaria: secretaria,
          total: total,
          concluidas: concluidas,
          percentual: percentual.replace('.', ',')
        };
      })));

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* exportCSVFile */])(headers, [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(items), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(footers)), 'ranking_conclusao');
    },

    entidadeBySigla: __WEBPACK_IMPORTED_MODULE_10__utils_entidades_js__["a" /* entidadeBySigla */]
  }
});

/***/ }),

/***/ "CG7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_public__ = __webpack_require__("upps");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_public_painel__ = __webpack_require__("Asmk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_public_assistencia__ = __webpack_require__("axda");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_public_assistencia_Detalhes__ = __webpack_require__("8Luf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_public_dados__ = __webpack_require__("eFiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_public_dados_PorSecretaria__ = __webpack_require__("nBdW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_public_dados_details__ = __webpack_require__("+iMQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_public_dados_compare__ = __webpack_require__("Qiie");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_public_escalas__ = __webpack_require__("6qvE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_public_educacao_dashboard__ = __webpack_require__("pN11");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_public_educacao_detalhes__ = __webpack_require__("xugx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_public_planos_municipal__ = __webpack_require__("0FY8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_public_pdm__ = __webpack_require__("mMgo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_public_pdg__ = __webpack_require__("1VMN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_public_favoritos__ = __webpack_require__("sgek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_public_pesquisa__ = __webpack_require__("VdjV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_public_materiais__ = __webpack_require__("GqrO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_public_divida_ativa__ = __webpack_require__("Cwl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_public_manutencao__ = __webpack_require__("DEIR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__public___ = __webpack_require__("GTN5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__const__ = __webpack_require__("4Nwh");
























var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__views_public__["a" /* default */],
  children: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_public_painel__["a" /* default */]
  }, {
    path: '/pesquisa/volta_aulas',
    name: 'volta_aulas',
    component: __WEBPACK_IMPORTED_MODULE_16__views_public_pesquisa__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Pesquisa volta as aulas'
    }
  }, {
    path: '/assistencia',
    name: 'beneficios_auxilios',
    component: __WEBPACK_IMPORTED_MODULE_3__views_public_assistencia__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Benef\xEDcios Assistenciais'
    }
  }, {
    path: '/assistencia/detalhes/:sigla',
    name: 'beneficios_detalhes',
    component: __WEBPACK_IMPORTED_MODULE_4__views_public_assistencia_Detalhes__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Beneficiados por programa'
    }
  }, {
    path: '/favoritos',
    name: 'favoritos',
    component: __WEBPACK_IMPORTED_MODULE_15__views_public_favoritos__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Favoritos'
    }
  }, {
    name: 'public_detalhes',
    path: '/detalhes/:id',
    component: __WEBPACK_IMPORTED_MODULE_7__views_public_dados_details__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Detalhes do dado'
    }
  }, {
    name: 'public_comparar',
    path: '/comparar/:ids',
    component: __WEBPACK_IMPORTED_MODULE_8__views_public_dados_compare__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Comparar dados'
    }
  }, {
    path: '/listar/dados',
    name: 'listar_dados',
    component: __WEBPACK_IMPORTED_MODULE_5__views_public_dados__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Lista de dados'
    }
  }, {
    path: '/listar/dados-secretaria',
    name: 'listar_dados_secretaria',
    component: __WEBPACK_IMPORTED_MODULE_6__views_public_dados_PorSecretaria__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Lista de dados por Secretaria'
    }
  }, {
    path: '/escalas',
    name: 'escalas',
    component: __WEBPACK_IMPORTED_MODULE_9__views_public_escalas__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Escalas de Plant\xE3o'
    }
  },
  // {
  //   path: '/educacao',
  //   name: 'educacao',
  //   component: Escolas,
  //   meta: {
  //     title: `${DEFAULT_TITLE} | Educação Transparente`
  //   }
  // },
  // {
  //   name: 'dados_escola',
  //   path: '/educacao/detalhes',
  //   component: DetalhesEscolas,
  //   meta: {
  //     title: `${DEFAULT_TITLE} | Detalhes por escola`
  //   }
  // },
  {
    name: 'planosmunicipal',
    path: '/planosmunicipal',
    component: __WEBPACK_IMPORTED_MODULE_12__views_public_planos_municipal__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Planos Municipal'
    }
  }, {
    name: 'planometas',
    path: '/planometas',
    component: __WEBPACK_IMPORTED_MODULE_13__views_public_pdm__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Plano de Metas'
    }
  }, {
    name: 'planogoverno',
    path: '/planogoverno',
    component: __WEBPACK_IMPORTED_MODULE_14__views_public_pdg__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Plano de Governo'
    }
  }, {
    path: '/materiais',
    name: 'materiais',
    component: __WEBPACK_IMPORTED_MODULE_17__views_public_materiais__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Materiais Padronizados'
    }
  }, {
    path: '/divida-ativa',
    name: 'divida-ativa',
    component: __WEBPACK_IMPORTED_MODULE_18__views_public_divida_ativa__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | D\xEDvida Ativa'
    }
  }, {
    path: '/manutencao',
    name: 'manutencao',
    component: __WEBPACK_IMPORTED_MODULE_19__views_public_manutencao__["a" /* default */],
    meta: {
      title: __WEBPACK_IMPORTED_MODULE_21__const__["a" /* DEFAULT_TITLE */] + ' | Em Manuten\xE7\xE3o'
    }
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__public___["a" /* receitasDespesas */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__public___["b" /* concursos */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__public___["c" /* prestacoes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__public___["d" /* consumo */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__public___["e" /* remedios */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__public___["f" /* procedimentosSaude */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__public___["g" /* emendasParlamentares */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__public___["h" /* eleicaoConselho */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__public___["i" /* movimentosODS */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__public___["j" /* planoDeGoverno */]))
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "CNAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return procedimentosSaude; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_public_procedimentos_saude__ = __webpack_require__("zY2p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_public_procedimentos_saude_PorEspecialidade__ = __webpack_require__("qhpI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_public_procedimentos_saude_PorExame__ = __webpack_require__("KZIV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_public_procedimentos_saude_PorCartaoSUS__ = __webpack_require__("cA2U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const__ = __webpack_require__("4Nwh");






var procedimentosSaude = [{
  path: '/minhasaude',
  name: 'procedimentos_saude',
  component: __WEBPACK_IMPORTED_MODULE_0__views_public_procedimentos_saude__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_4__const__["a" /* DEFAULT_TITLE */] + ' | Minha Sa\xFAde'
  }
}, {
  path: '/minhasaude/por-especialidade/:especialidade',
  name: 'procedimentos_por_especialidade',
  component: __WEBPACK_IMPORTED_MODULE_1__views_public_procedimentos_saude_PorEspecialidade__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_4__const__["a" /* DEFAULT_TITLE */] + ' | Lista por Especialidade'
  }
}, {
  path: '/minhasaude/por-exame/:exame',
  name: 'procedimentos_por_exame',
  component: __WEBPACK_IMPORTED_MODULE_2__views_public_procedimentos_saude_PorExame__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_4__const__["a" /* DEFAULT_TITLE */] + ' | Lista por Exame'
  }
}, {
  path: '/minhasaude/por-cartao/:cartao',
  name: 'procedimentos_por_cartao',
  component: __WEBPACK_IMPORTED_MODULE_3__views_public_procedimentos_saude_PorCartaoSUS__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_4__const__["a" /* DEFAULT_TITLE */] + ' | Meu Cart\xE3o SUS'
  }
}];

/***/ }),

/***/ "COst":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardsPortais_vue__ = __webpack_require__("kEG3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_174de0f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardsPortais_vue__ = __webpack_require__("O87q");
function injectStyle (ssrContext) {
  __webpack_require__("Rz9N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-174de0f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardsPortais_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_174de0f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardsPortais_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CUx3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.82b241e.jpg";

/***/ }),

/***/ "CVOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.prestacoes.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('ul',_vm._l((_vm.prestacoes),function(prest,index){return _c('li',{key:("pres-" + index)},[(_vm.statusHomologada(prest))?_c('router-link',{attrs:{"to":{
            name: 'prestacao_detalhe',
            params: { codigo: prest.codigo, prestacao: prest, entidade: _vm.entidade }
          }}},[_vm._v("\n          "+_vm._s(((prest.objeto_parceria) + " - Vigência (de " + (new Date(
              ((prest.inicio_periodo) + " 00:00")
            ).toLocaleDateString()) + " até " + (new Date(
              ((prest.fim_periodo) + " 00:00")
            ).toLocaleDateString()) + ")"))+"\n        ")]):_c('span',[_vm._v("\n          "+_vm._s(((prest.objeto_parceria) + " - Vigência (de " + (new Date(
              ((prest.inicio_periodo) + " 00:00")
            ).toLocaleDateString()) + " até " + (new Date(
              ((prest.fim_periodo) + " 00:00")
            ).toLocaleDateString()) + ") - "))+"\n          "),_c('span',{staticClass:"status"},[_vm._v("\n            Em "+_vm._s(prest.status_prestacao.descricao.toLowerCase())+"\n          ")])])],1)}),0)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CWdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("KThS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2c9cda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("M2Hz");
function injectStyle (ssrContext) {
  __webpack_require__("dJ9v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af2c9cda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af2c9cda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CiCH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remanejamento"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h2',{staticClass:"page-header"},[_vm._v("Remanejar emenda")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-3"},[_c('p',[_c('span',{staticClass:"font-lg"},[_c('b',[_vm._v("Número:")]),_vm._v(" "+_vm._s(_vm.numero)+" / "+_vm._s(_vm.ano)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-3"},[_c('p',[_c('span',{staticClass:"font-lg"},[_c('b',[_vm._v("Valor:")]),_vm._v(" "+_vm._s(_vm.formatarMoeda(_vm.valor || 0))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('p',[_c('span',{staticClass:"font-lg"},[_c('b',[_vm._v("Vereador:")]),_vm._v(" "+_vm._s(_vm.vereador.nome)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('span',{staticClass:"font-lg"},[_c('b',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(_vm.descricao)+" ")])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-3"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('numero') }]},[_c('label',{staticClass:"control-label",attrs:{"for":"numero"}},[_vm._v("\n          Emenda nº\n        ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("\n            Nº\n            ")]),_vm._v(" "),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],ref:"numero",staticClass:"form-control",attrs:{"id":"numero","name":"numero","mask":'####',"data-vv-as":"Emenda nº","disabled":"disabled"},model:{value:(_vm.model.numero),callback:function ($$v) {_vm.$set(_vm.model, "numero", $$v)},expression:"model.numero"}})],1),_vm._v(" "),(_vm.errors.has('numero'))?_c('input-error-message',{attrs:{"message":_vm.errors.first('numero')}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-4"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('valor') }]},[_c('label',{staticClass:"control-label",attrs:{"for":"valor"}},[_vm._v("\n          Valor a remanejar\n        ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'money-bill'}})],1),_vm._v(" "),_c('money',_vm._b({directives:[{name:"validate",rawName:"v-validate",value:('required|min_value:0.01'),expression:"'required|min_value:0.01'"}],ref:"valor",staticClass:"form-control",attrs:{"id":"valor","name":"valor"},model:{value:(_vm.model.valor),callback:function ($$v) {_vm.$set(_vm.model, "valor", $$v)},expression:"model.valor"}},'money',{
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              precision: 2,
              masked: false
            },false))],1),_vm._v(" "),(_vm.errors.has('valor'))?_c('input-error-message',{attrs:{"message":_vm.errors.first('valor')}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"sigla_orgao"}},[_vm._v("Sigla do órgão")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'landmark'}})],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.sigla_orgao),expression:"model.sigla_orgao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"sigla_orgao",staticClass:"form-control select-selected",attrs:{"id":"sigla_orgao","name":"sigla_orgao"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "sigla_orgao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.loadNomeSecretaria]}},_vm._l((_vm.orgaos),function(orgao){return _c('option',{key:orgao.id},[_vm._v("\n              "+_vm._s(orgao.sigla)+"\n            ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-9"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary",attrs:{"for":"nome_orgao"}},[_vm._v("Nome do orgão")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'signature'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome_orgao),expression:"model.nome_orgao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome_orgao",staticClass:"form-control",attrs:{"id":"nome_orgao","name":"nome_orgao","type":"text","disabled":""},domProps:{"value":(_vm.model.nome_orgao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome_orgao", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('descricao') }]},[_c('label',{staticClass:"control-label",attrs:{"for":"descricao"}},[_vm._v("Descrição")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'tags'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"descricao",staticClass:"form-control",attrs:{"id":"descricao","name":"descricao","rows":"3","data-vv-as":"descrição","placeholder":"Descrição","maxlength":"500"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("\n            "+_vm._s(500 - _vm.model.descricao.length)+"\n          ")])]),_vm._v(" "),(_vm.errors.has('descricao'))?_c('input-error-message',{attrs:{"message":_vm.errors.first('descricao')}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('observacao') }]},[_c('label',{staticClass:"control-label",attrs:{"for":"observacao"}},[_vm._v("Observação")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'tags'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.observacao),expression:"model.observacao"}],ref:"observacao",staticClass:"form-control",attrs:{"id":"observacao","name":"observacao","rows":"3","placeholder":"Observação","maxlength":"2000"},domProps:{"value":(_vm.model.observacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "observacao", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"},[_vm._v("\n            "+_vm._s(2000 - _vm.model.observacao.length)+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('termo_busca') }]},[_c('label',{staticClass:"control-label",attrs:{"for":"termo_busca"}},[_vm._v("Termo de busca")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'search'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.termo_busca),expression:"model.termo_busca"}],ref:"termo_busca",staticClass:"form-control",attrs:{"id":"termo_busca","name":"termo_busca","placeholder":"Termos de busca","maxlength":"100","type":"text"},domProps:{"value":(_vm.model.termo_busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "termo_busca", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"},[_vm._v("\n            "+_vm._s(100 - _vm.model.termo_busca.length)+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.remanejar()}}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n         Remanejar emenda\n      ")],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Dados da Emenda")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Nova Emenda")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CqCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MinhasAcoes_vue__ = __webpack_require__("kKoq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f88da2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MinhasAcoes_vue__ = __webpack_require__("Uv37");
function injectStyle (ssrContext) {
  __webpack_require__("vTiM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77f88da2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MinhasAcoes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f88da2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MinhasAcoes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CqLP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cvqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return movimentosODS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_public_movimentos_ods__ = __webpack_require__("d2cg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__("4Nwh");



var movimentosODS = [{
  name: 'movimentos_ods',
  path: '/movimentos-ods',
  component: __WEBPACK_IMPORTED_MODULE_0__views_public_movimentos_ods__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_1__const__["a" /* DEFAULT_TITLE */] + ' | Movimentos ODS'
  }
}];

/***/ }),

/***/ "Cwl0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ng9I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66688aef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Qq6E");
function injectStyle (ssrContext) {
  __webpack_require__("aUfs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66688aef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66688aef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CyOM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CztK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emendasParlamentares; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_emendas_parlamentares_emendas__ = __webpack_require__("QQYU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_emendas_parlamentares_vereadores__ = __webpack_require__("eZ4i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_emendas_parlamentares_vereadores_Save__ = __webpack_require__("6SaB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_admin_emendas_parlamentares_emendas_Save__ = __webpack_require__("ISk+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_admin_emendas_parlamentares_processos_pagamento__ = __webpack_require__("q0Ye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_admin_emendas_parlamentares_processos_pagamento_Save__ = __webpack_require__("LZZb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_admin_emendas_parlamentares_emendas_ListProcessosPagamento__ = __webpack_require__("qI0e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_admin_emendas_parlamentares_emendas_Remanejamento__ = __webpack_require__("e20T");









var emendasParlamentares = [{
  name: 'user_emendasparlamentares',
  path: 'emenda/list',
  component: __WEBPACK_IMPORTED_MODULE_0__views_admin_emendas_parlamentares_emendas__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_vereadores',
  path: 'vereador/list',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin_emendas_parlamentares_vereadores__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_processospagamento',
  path: 'processospagamento/list',
  component: __WEBPACK_IMPORTED_MODULE_4__views_admin_emendas_parlamentares_processos_pagamento__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_salvar_emenda',
  path: 'emenda/save/:id?',
  component: __WEBPACK_IMPORTED_MODULE_3__views_admin_emendas_parlamentares_emendas_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_salvar_vereador',
  path: 'vereador/save/:id?',
  component: __WEBPACK_IMPORTED_MODULE_2__views_admin_emendas_parlamentares_vereadores_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_salvar_processospagamento',
  path: 'processospagamento/save/:id?',
  component: __WEBPACK_IMPORTED_MODULE_5__views_admin_emendas_parlamentares_processos_pagamento_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_list_emenda_processos',
  path: 'emenda/list/:id?/processos',
  component: __WEBPACK_IMPORTED_MODULE_6__views_admin_emendas_parlamentares_emendas_ListProcessosPagamento__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_remanejamento',
  path: 'emenda/remanejamento',
  component: __WEBPACK_IMPORTED_MODULE_7__views_admin_emendas_parlamentares_emendas_Remanejamento__["a" /* default */],
  props: true,
  meta: {
    requiresAuth: true,
    userAuth: true,
    title: 'Remanejamento'
  }
}];

/***/ }),

/***/ "D1IN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datatableFields__ = __webpack_require__("MtQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExportCSV__ = __webpack_require__("lknt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_1__common__["e" /* NoApiTable */],
    ExportCSV: __WEBPACK_IMPORTED_MODULE_2__ExportCSV__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    chave: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fields: __WEBPACK_IMPORTED_MODULE_0__datatableFields__["a" /* fields */]
    };
  },

  methods: {
    getGravidadeClass: __WEBPACK_IMPORTED_MODULE_0__datatableFields__["b" /* getGravidadeClass */]
  },
  computed: {
    dados: function dados() {
      return this.items;
    }
  }
});

/***/ }),

/***/ "D5X7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('font-awesome-icon',{class:_vm.header ? 'destaque-header' : 'destaque',attrs:{"icon":'spinner',"spin":""}}):_c('span',{class:_vm.header ? 'destaque-header' : 'destaque'},[_vm._v("\n  "+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DEIR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("MLpl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fffb4b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("0pqH");
function injectStyle (ssrContext) {
  __webpack_require__("/+SG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fffb4b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fffb4b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DMGv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":"Plano de Governo"}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n        Um plano de governo é um documento elaborado por um(a) candidato(a) a\n        um cargo do Poder Executivo — como presidente, governador ou prefeito\n        — no qual são apresentadas suas propostas, metas e diretrizes para a\n        gestão pública durante o mandato, caso seja eleito(a).\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        No Brasil, candidatos(as) são obrigados a registrar um plano de\n        governo ao se candidatar a cargos executivos. Esse plano é\n        disponibilizado pela Justiça Eleitoral, geralmente no site do TSE\n        (Tribunal Superior Eleitoral).\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":[{ label: ("Plano de Governo - " + _vm.anoPlano) }]}}),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-5 col-md-4"},[_c('p',{staticClass:"text-lg"},[_vm._v("\n          Nos anos de\n          "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.anoPlano),expression:"anoPlano"}],attrs:{"name":"plano-governo","id":"plano-governo"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.anoPlano=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.loadCompromissosPorAno]}},[_c('option',{attrs:{"value":"2025-2028"}},[_vm._v("2025-2028")]),_vm._v(" "),_c('option',{attrs:{"value":"2021-2024"}},[_vm._v("2021-2024")])]),_vm._v("\n          , o Prefeito Municipal de Santos apresentou a Justiça Eleitoral um\n          total de\n          "),_c('ValorDestaque',{attrs:{"value":_vm.compromissos.length,"isLoading":_vm.isLoading}}),_vm._v("\n          metas para o seu Plano de Goveno.\n        ")],1),_vm._v(" "),_c('p',{staticClass:"text-lg"},[_vm._v("\n          Os compromissos estão distribuidos entre\n          "),_c('ValorDestaque',{attrs:{"value":((_vm.getTotalCompromissosPorSecretaria.length) + " entidades / unidades")}}),_vm._v("\n          municipais, podendo-se destacar:\n        ")],1),_vm._v(" "),_c('ul',_vm._l((_vm.top5SecretariasCompromissos),function(item){return _c('li',{key:item.sigla},[_c('ValorDestaque',{attrs:{"value":((item.nome) + ":")}}),_vm._v(_vm._s(item.total)+"\n          ")],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-7 col-md-8"},[_c('BarChart',{attrs:{"chartData":_vm.chartData,"gradiente":false,"css-classes":'chartWrapper',"options":_vm.chartOptions}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),(_vm.resumoStatus.length > 0)?_c('div',{staticClass:"col-xs-12 col-sm-5"},[_c('p',{staticClass:"text-lg"},[_vm._v("\n          Destes compromissos,\n          "),_vm._l((_vm.resumoStatus),function(item,index){return _c('span',{key:index},[_c('ValorDestaque',{attrs:{"value":item.total,"isLoading":_vm.isLoading}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.texto)}}),_vm._v(" "),(index < _vm.resumoStatus.length - 2)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(" "),(index === _vm.resumoStatus.length - 2)?_c('span',[_vm._v(" e ")]):_vm._e()],1)}),_vm._v(".\n        ")],2)]):_vm._e(),_vm._v(" "),(_vm.resumoStatus.length > 0)?_c('div',{staticClass:"col-xs-12 col-sm-7"},[_c('PieChart',{attrs:{"chartData":_vm.statusChartData,"gradiente":false,"css-classes":'chartWrapper',"options":_vm.statusChartOptions}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.getSecretariasComResumo),function(secretaria){return _c('div',{key:("card-" + (secretaria.sigla)),staticClass:"col-xs-12 col-sm-4 col-md-3"},[_c('CardInstitucional',{attrs:{"item":Object.assign({}, secretaria,
            {route: { name: 'planoporsecretaria', params: { secretaria: secretaria.sigla } }}),"value":'teste'}})],1)})],2),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"40px"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"margin-bottom":"20px"}},[_c('div',{staticClass:"filtro-wrapper"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termoPesquisa),expression:"termoPesquisa"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Pesquisar por descritivo ou status..."},domProps:{"value":(_vm.termoPesquisa)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.pesquisar.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.termoPesquisa=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.pesquisar}},[_vm._v("Pesquisar")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"table-wrapper"},[_c('data-table-public',{ref:"compromissoTable",attrs:{"has-auth":false,"title":"Lista de Compromissos","api-url":"planodegoverno/compromissos","fields":_vm.model.columns,"append-params":_vm.filtrosDataTable,"show-empty":true},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_c('span',{class:['status-tag', _vm.getStatusClass(props.rowData.status)]},[_vm._v(_vm._s(props.rowData.status))])]}},{key:"rowrender",fn:function(props){return [(props.rowData.acoes && props.rowData.acoes.length > 0)?_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.abrirSidePanel(props.rowData.acoes)}}},[_vm._v("\n                Ver Ações\n              ")]):_c('span')]}}])})],1)])])],1),_vm._v(" "),_c('div',{class:['side-panel-overlay', { 'is-open': _vm.isSidePanelOpen }],on:{"click":_vm.fecharSidePanel}},[_c('div',{staticClass:"side-panel-content",on:{"click":function($event){$event.stopPropagation();}}},[_c('button',{staticClass:"side-panel-close",on:{"click":_vm.fecharSidePanel}},[_vm._v("×")]),_vm._v(" "),_c('h3',[_vm._v("Ações do compromisso")]),_vm._v(" "),_c('div',{staticClass:"side-panel-body"},[(_vm.sidePanelChartData)?_c('div',{staticClass:"modal-chart-container"},[_c('PieChart',{attrs:{"chartData":_vm.sidePanelChartData,"options":_vm.sideChartOptions,"height":150}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filtro-wrapper filtro-modal"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termoPesquisaAcoes),expression:"termoPesquisaAcoes"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Pesquisar por descritivo ou status..."},domProps:{"value":(_vm.termoPesquisaAcoes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.termoPesquisaAcoes=$event.target.value}}})]),_vm._v(" "),(_vm.acoesFiltradas && _vm.acoesFiltradas.length > 0)?_c('div',{staticClass:"acoes-list"},_vm._l((_vm.acoesFiltradas),function(acao){return _c('div',{key:acao.id,staticClass:"acao-item"},[_c('div',{staticClass:"acao-info"},[_c('p',{staticClass:"acao-descricao"},[_vm._v(_vm._s(acao.descritivo))]),_vm._v(" "),_c('p',{staticClass:"acao-unidade"},[_c('strong',[_vm._v("Unidade:")]),_vm._v(" "+_vm._s(acao.nome_unidade))])]),_vm._v(" "),_c('div',{staticClass:"acao-status"},[_c('span',{class:['status-tag', _vm.getStatusClass(acao.status)]},[_vm._v(_vm._s(acao.status))])])])}),0):_c('div',[_c('p',[_vm._v("Nenhuma ação encontrada.")])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Resumo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Status")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Secretarias")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Compromissos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DTf4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_dist_vuex_common_js__ = __webpack_require__("9xAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_dist_vuex_common_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_dist_vuex_common_js__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ano: new Date().getFullYear(),
      options: []
    };
  },
  created: function created() {
    var ano_atual = this.ano;
    for (var index = 2024; index <= ano_atual; index++) {
      this.options.push(index);
    }

    if (this.ano_emenda) {
      this.ano = this.ano_emenda;
    }

    if (!this.quantidadeEmendas) {
      this.fetchEmendasAno();
    }
  },

  methods: {
    fetchEmendasAno: function fetchEmendasAno() {
      this.$store.dispatch('getEmendasAno', { ano: this.ano });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_dist_vuex_common_js__["mapState"])({
    ano_emenda: function ano_emenda(state) {
      return state.emendas_parlamentares.ano;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_dist_vuex_common_js__["mapGetters"])(['quantidadeEmendas']))
});

/***/ }),

/***/ "DXFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrarSenha_vue__ = __webpack_require__("Gu+R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eaa26c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrarSenha_vue__ = __webpack_require__("MnBG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegistrarSenha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eaa26c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegistrarSenha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DXsn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DZFG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("+x5m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5772d8fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("5BkO");
function injectStyle (ssrContext) {
  __webpack_require__("gVmU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5772d8fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5772d8fb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DbjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Employee_ScaleControl__ = __webpack_require__("GEwK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showAlert'],
  components: { EmployeeItemScaleControl: __WEBPACK_IMPORTED_MODULE_3__components_Employee_ScaleControl__["a" /* default */] },
  props: {
    employeeData: Object
  },
  created: function created() {
    var _employeeData = this.employeeData,
        nome = _employeeData.nome,
        cargo = _employeeData.cargo,
        scale = _employeeData.scale,
        sshd = _employeeData.sshd,
        id = _employeeData.id;

    this.nome = nome;
    this.cargo = cargo;
    this.scale = scale;
    this.sshd = sshd;
    this.colaborador_id = id;
  },
  mounted: function mounted() {
    this.verificaEscalaEhAtualizaItem();
  },
  data: function data() {
    return {
      colaborador_id: '',
      sshd: '',
      nome: '',
      cargo: '',
      scale: [],
      scaleStatus: 'validating',
      scaleConflitos: []
    };
  },

  methods: {
    verificaEscalaEhAtualizaItem: function verificaEscalaEhAtualizaItem() {
      var _this = this;

      var colaborador_id = this.colaborador_id,
          scale = this.scale;


      var timeList = {};
      scale.filter(function (_ref) {
        var active = _ref.active,
            times = _ref.times;
        return active && times.length > 0;
      }).forEach(function (_ref2) {
        var date = _ref2.date,
            times = _ref2.times;

        times.forEach(function (_ref3) {
          var entrada = _ref3.entrada,
              saida = _ref3.saida;

          var timeKey = entrada + '-' + saida;
          var data = date.toLocaleDateString('pt-BR', {
            month: '2-digit',
            day: '2-digit'
          });
          if (timeList.hasOwnProperty(timeKey)) {
            timeList[timeKey].datas.push(data);
          } else {
            timeList[timeKey] = {
              entrada: entrada,
              saida: saida,
              datas: [data]
            };
          }
        });
      });

      var _scale = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(scale, 1),
          referencia = _scale[0].referencia;

      var horarios_datas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(timeList).map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, timeList[key]);
      });

      this.scaleStatus = 'validating';

      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('escala/check', { referencia: referencia, colaborador_id: colaborador_id, horarios_datas: horarios_datas }).then(function (response) {
        if (Array.isArray(response.data)) {
          _this.scaleConflitos = response.data;
          _this.scaleStatus = 'invalid';
        } else {
          _this.scaleStatus = 'valid';
        }

        _this.update(scale);
      }).catch(function (error) {
        console.log(error);
        _this.scaleStatus = 'error';
      });
    },
    update: function update(scale) {
      var scaleStatus = this.scaleStatus;

      this.$emit('updateItem', { scaleStatus: scaleStatus, scale: scale });
    },
    show: function show() {
      var htmlContent = this.scaleConflitos.map(function (_ref4) {
        var data = _ref4.data,
            uor = _ref4.uor,
            timeAlocado = _ref4.timeAlocado,
            timeConflitante = _ref4.timeConflitante;

        return '<strong>' + data + '</strong> alocado na <strong>' + uor + ' as ' + timeAlocado + '</strong>, o hor\xE1rio conflitante \xE9 <strong>' + timeConflitante + '</strong>';
      });

      this.showAlert({
        title: 'Alerta',
        description: 'Segue abaixo os conflitos informando os horários e as unidades que o mesmo já está alocado.',
        content: htmlContent
      });
    }
  }
});

/***/ }),

/***/ "DcfH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DfAy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Diqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */]
  },
  data: function data() {
    return {
      fields: [{
        name: 'sigla',
        title: 'Benefício'
      }, {
        name: 'nome',
        title: 'Nome'
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  methods: {
    excluir: function excluir(item) {
      var _this = this;

      var dt = this.$refs.vuetable;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('assistencia/beneficios/excluir', item).then(function (response) {
            _this.$toastr.s(response.data.msg);
          }).catch(function (error) {
            var data = error.response.data;

            _this.$toastr.e('Houve um erro ao tentar excluir, atualize a página e tente novamente');
            console.log(data.msg);
          }).finally(function () {
            dt.refresh();
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    }
  },
  computed: {
    pagina: {
      get: function get() {
        var beneficiosAssistenciais = this.$store.state.vuetableState.beneficiosAssistenciais;
        var pagina = beneficiosAssistenciais.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'beneficiosAssistenciais',
          value: value
        });
      }
    }
  }
});

/***/ }),

/***/ "Dtw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__("vAZe");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Chart: __WEBPACK_IMPORTED_MODULE_3__common__["f" /* LineChart2 */],
    BarChart: __WEBPACK_IMPORTED_MODULE_3__common__["d" /* BarChart */]
  },
  props: {
    detalhes: {
      type: Object,
      required: true
    },
    valores: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      chartUrl: 'detalhes/valores/' + this.$route.params.id,
      meses: __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* mesesAbr */],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        elements: {
          point: {
            radius: 4,
            hoverRadius: 8
          }
        }
      }
    };
  },

  methods: {
    retornarObjetoMensal: function retornarObjetoMensal() {
      var dados = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.valores));
      var year_base = {};
      var value_base = new Array(12).fill(0);

      for (var index = 0; index < dados.length; index++) {
        var element = dados[index];
        var data = new Date(dados[index].data);
        var ano = data.getFullYear();
        var mes = data.getMonth();

        if (!year_base[ano]) {
          year_base[ano] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(value_base));
        }

        year_base[ano].splice(mes, 1, element.valor);
      }

      return year_base;
    },
    retornarGraficoMensal: function retornarGraficoMensal(base) {
      var year_base = this.retornarObjetoMensal();
      var anos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(year_base);

      for (var index = 0; index < anos.length; index++) {
        var ano = anos[index];
        base.datasets.push({
          label: ano,
          backgroundColor: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* colors */].coresHexa[index],
          data: year_base[ano]
        });
      }

      base.labels = this.meses;
      this.chartOptions.legend.display = true;

      return base;
    },
    retornarGraficoAnual: function retornarGraficoAnual(base) {
      var dados = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.valores));
      base.datasets.push({
        label: 'Valores por ano',
        data: [],
        pointBackgroundColor: 'white',
        pointBorderWidth: 1,
        pointBorderColor: '#000',
        pointHoverBackgroundColor: '#FFF'
      });

      for (var index = 0; index < dados.length; index++) {
        var data = new Date(dados[index].data).getFullYear();
        base.labels.push(data);
        base.datasets[0].data.push(dados[index].valor);
      }

      return base;
    }
  },
  computed: {
    dados_grafico: function dados_grafico() {
      var grafico = {
        labels: [],
        datasets: []
      };

      switch (this.detalhes.dado.periodicidade) {
        case 1:
          return this.retornarGraficoMensal(grafico);
        case 6:
          return this.retornarGraficoAnual(grafico);
        default:
          return grafico;
      }
    }
  }
});

/***/ }),

/***/ "DvDe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DvK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E0MG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beneficios"},[_c('div',{staticClass:"row"},[_c('public-header',{attrs:{"title":'Benefícios Assistenciais'}},[_c('ano-base'),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n          A\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v("Prefeitura Municipal de Santos")]),_vm._v(",\n          através da\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v("Secretaria de Desenvolvimento Social")]),_vm._v(", no ano de "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.ano_base))]),_vm._v(", repassou um valor total de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.formatarMoeda(_vm.totalAno.valor)))]),_vm._v("\n          em benefícios assistenciais para a sua população.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Cerca de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.totalAno.total.toLocaleString()))]),_vm._v("\n          pagamentos de benefícios foram repassados através dos diversos\n          programas Municipais, Estaduais e Federais, entre eles o\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v("\n            Programa Nossa Família - PNF ("+_vm._s(_vm.pnf.total.toLocaleString())+"\n            benefícios, totalizando\n            "+_vm._s(_vm.formatarMoeda(Number(_vm.pnf.valor)))+")")]),_vm._v(", o\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v("Programa Ação Jovem ("+_vm._s(_vm.acao_jovem.total.toLocaleString())+"\n            benefícios, totalizando\n            "+_vm._s(_vm.formatarMoeda(Number(_vm.acao_jovem.valor)))+")")]),_vm._v("\n          e o\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v("Programa de Transferência de Renda - Auxílio Brasil ("+_vm._s(_vm.bolsa_familia.total.toLocaleString())+"\n            benefícios, totalizando\n            "+_vm._s(_vm.formatarMoeda(Number(_vm.bolsa_familia.valor)))+")")]),_vm._v(".\n        ")]),_vm._v(" "),_c('h3',[_vm._v("Secretaria de Desenvolvimento Social")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"destaque-header"},[_vm._v("\n            Tel.: "),_c('a',{attrs:{"href":"tel:+551332131499"}},[_vm._v("(13) 3213-1499")]),_c('br'),_vm._v("\n            Email:\n            "),_c('a',{attrs:{"href":"mailto:seds@santos.sp.gov.br"}},[_vm._v("seds@santos.sp.gov.br")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('bar-chart',{ref:"beneficios_mensais",attrs:{"chart-data":_vm.graficoHeader,"gradiente":false,"coloredLine":true,"options":{
            responsive: true,
            maintainAspectRatio: false,
            title: {
              display: true,
              text: 'Benefícios Mensais',
              fontColor: '#C1D1C1'
            },
            legend: {
              display: true,
              labels: {
                fontColor: '#C1D1C1'
              }
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    suggestedMax: 50,
                    fontColor: '#C1D1C1',
                    callback: function(value, index, values) {
                      return value.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                    }
                  }
                }
              ],
              xAxes: [
                {
                  maxBarThickness: 50,
                  ticks: {
                    fontColor: '#C1D1C1'
                  }
                }
              ]
            },
            tooltips: {
              callbacks: {
                label: function(tooltip, dataset) {
                  var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL'
                  })
                  return 'Valor: ' + yLabel
                }
              }
            }
          }}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',{},[_vm._v("Benefícios Assistenciais")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),(!_vm.carregando)?_c('transition-group',{staticClass:"row",attrs:{"name":"fade","tag":"div"}},_vm._l((_vm.beneficios),function(item){return _c('div',{key:item.codigo,staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('card-lg',{attrs:{"title":item.sigla,"description":item.nome,"url":{
            name: 'beneficios_detalhes',
            params: {
              sigla: item.sigla,
              item: item
            }
          }}})],1)}),0):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Saiba mais sobre os benefícios")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E4px":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EF99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receitas_despesas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__("Zn3k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("YIRx");



var data_base = function data_base() {
  var mes_passado = new Date();
  mes_passado.setMonth(mes_passado.getMonth() - 1);
  return mes_passado.getFullYear();
};

var receitas_despesas = {
  state: function state() {
    return {
      ano_base: data_base(),
      loading: false,
      receitas_proprias: [],
      detalhamento_despesas: [],
      grupo_despesas: [],
      funcao_subfuncao: [],
      adiantamentos: [],
      despesas_detalhadas: []
    };
  },
  getters: {
    isLoading: function isLoading(state) {
      return state.loading;
    }
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["a" /* mutations */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actions */]
};

/***/ }),

/***/ "EGzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectReferencia_vue__ = __webpack_require__("JB/+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35aa49d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectReferencia_vue__ = __webpack_require__("944m");
function injectStyle (ssrContext) {
  __webpack_require__("Ot2a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35aa49d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectReferencia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35aa49d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectReferencia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EIPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_InputModal__ = __webpack_require__("bjbF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'escalas-pendentes',
  inject: ["showConfirm"],
  data: function data() {
    return {
      type: 'Pendencias',
      datatable: {
        columnID: 'id',
        columns: [{
          name: 'uor_sigla',
          title: 'Unidade',
          dataClass: 'align-middle',
          width: '50px'
        }, {
          name: 'referencia_label',
          title: 'Competência',
          titleClass: 'text-center',
          dataClass: 'align-middle text-center'
        }, {
          name: 'total_colaboradores',
          title: 'Total de Colaboradores',
          titleClass: 'text-center',
          dataClass: 'align-middle text-center'
        }, {
          name: 'observacao',
          title: 'Observação',
          dataClass: 'align-middle text-reduce',
          callback: function callback(text) {
            return '<span title="' + text + '">' + (text || 'Nenhuma') + '</span>';
          }
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center',
          dataClass: 'align-middle text-center',
          width: '110px'
        }]
      },
      pendencias: [],
      isLoading: false
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_2__components_common_NoApiTable__["a" /* default */],
    inputModal: __WEBPACK_IMPORTED_MODULE_3__components_common_InputModal__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.loadPendencias();
  },

  methods: {
    enviarAnalise: function enviarAnalise(data) {
      var _this = this;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var uor_sigla, referencia, _ref2, status;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    uor_sigla = data.uor_sigla, referencia = data.referencia;
                    _context.next = 3;
                    return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('escala/analisar', { uor_sigla: uor_sigla, referencia: referencia });

                  case 3:
                    _ref2 = _context.sent;
                    status = _ref2.status;


                    if (status === 200) {
                      _this.$toastr.s('Escala foi enviada para análise!');
                      _this.loadPendencias();
                    } else {
                      _this.$toastr.e('Houve uma falha ao tentar enviar a escala para análise, favor tentar daqui alguns minutos!');
                      console.log(error);
                    }

                  case 6:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function yes() {
            return _ref.apply(this, arguments);
          };
        }()
      };
      this.showConfirm('Deseja realmente enviar está escala para análise?', config);
    },
    atualizarObservacao: function atualizarObservacao(data) {
      var me = this;
      var requestSalvarObservacao = function requestSalvarObservacao(observacao) {
        var id = data.id;


        __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('escala/observacao', { id: id, observacao: observacao }).then(function () {
          me.$refs.inputModal.hide();
          me.$toastr.s('A observação da Escala foi atualizada!');
          me.loadPendencias();
        }).catch(function (error) {
          me.$toastr.e('Houve uma falha ao tentar atualizar a observação da escala, favor tentar daqui alguns minutos!');
          console.log(error);
        });
      };

      this.$refs.inputModal.show({ value: data.observacao, fnOk: requestSalvarObservacao });
    },
    loadPendencias: function loadPendencias() {
      var _this2 = this;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('escala/listar-pendentes').then(function (response) {
        _this2.pendencias = response.data;
        _this2.isLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this2.isLoading = false;
      });
    }
  }
});

/***/ }),

/***/ "ESfv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Diqf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3909e6a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("z2KP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3909e6a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ETK1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("ScH8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86db98a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("IRgX");
function injectStyle (ssrContext) {
  __webpack_require__("Gsa0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86db98a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86db98a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EYYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Emendas Parlamentares")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Lista de emendas parlamentares","report-title":"Emendas Parlamentares","initial-page":_vm.pagina,"api-url":"emenda","fields":_vm.fields,"pageCollection":'emendasParlamentares',"append-params":_vm.filtros,"slots":_vm.slots},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Lista de processos de pagamento","type":"button"},on:{"click":function($event){return _vm.listarProcessos(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'list-ol'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Botão Excluir")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Remanejar","type":"button"},on:{"click":function($event){return _vm.remajenar(props.rowData)}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Botão de Remanejar")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"exchange-alt"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Anexos","type":"button"},on:{"click":function($event){return _vm.exibirAnexos(props.rowData)}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Botão de exibir anexos")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"file-alt"}})],1)])]}},{key:"descricao",fn:function(props){return [(props.rowData.descricao.length < 100)?_c('span',[_vm._v(_vm._s(props.rowData.descricao))]):_c('span',[_vm._v(_vm._s(props.rowData.descricao.substring(0, 100) + '...'))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":'search'},on:{"click":function($event){return _vm.showModal('Descrição', props.rowData.descricao)}}})]}},{key:"saldo",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.getSaldo(props.rowData))+"\n          ")]}},{key:"resumo_utilizacao",fn:function(props){return [(
                props.rowData.resumo_utilizacao
                  ? props.rowData.resumo_utilizacao.length < 25
                  : ''
              )?_c('span',[_vm._v(_vm._s(props.rowData.resumo_utilizacao))]):(
                props.rowData.resumo_utilizacao
                  ? props.rowData.resumo_utilizacao.length > 25
                  : ''
              )?_c('span',[_vm._v(_vm._s(props.rowData.resumo_utilizacao.substring(0, 25) + '...'))]):_c('span',[_vm._v("\n              Nenhum resumo de utilização registrado.\n            ")]),_vm._v(" "),_c('font-awesome-icon',{staticClass:"fa-w-18",attrs:{"icon":'search'},on:{"click":function($event){return _vm.showModal(
                  'Resumo de utilização',
                  props.rowData.resumo_utilizacao
                )}}}),_vm._v(" "),_c('font-awesome-icon',{staticClass:"fa-search fa-w-18",attrs:{"icon":'edit'},on:{"click":function($event){_vm.getEmendaDados(props.rowData)
                _vm.openResumoModal()}}})]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse in",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"primary",attrs:{"for":"numero_filter"}},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numero),expression:"numero"}],staticClass:"form-control",attrs:{"type":"text","name":"numero_filter"},domProps:{"value":(_vm.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"primary",attrs:{"for":"ano_filter"}},[_vm._v("Ano")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ano),expression:"ano"}],staticClass:"form-control",attrs:{"type":"text","name":"ano_filter"},domProps:{"value":(_vm.ano)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ano=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"primary",attrs:{"for":"vereador_filter"}},[_vm._v("Vereador")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.vereador),expression:"vereador"}],staticClass:"form-control select-selected",attrs:{"name":"vereador_filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.vereador=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.vereadores),function(vereador){return _c('option',{key:vereador.id,domProps:{"value":vereador.id}},[_vm._v("\n                    "+_vm._s(vereador.nome.toUpperCase())+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"primary",attrs:{"for":"sigla_orgao_filter"}},[_vm._v("Sigla Orgão")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sigla_orgao),expression:"sigla_orgao"}],staticClass:"form-control select-selected",attrs:{"name":"sigla_orgao_filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sigla_orgao=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.orgaos),function(orgao){return _c('option',[_vm._v("\n                    "+_vm._s(orgao.sigla)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"primary",attrs:{"for":"processo_filter"}},[_vm._v("Processo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numero_processo),expression:"numero_processo"}],staticClass:"form-control",attrs:{"type":"text","name":"processo_filter"},domProps:{"value":(_vm.numero_processo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numero_processo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"primary",attrs:{"for":"descricao_filter"}},[_vm._v("Descrição")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.descricao),expression:"descricao"}],staticClass:"form-control",attrs:{"type":"text","name":"descricao_filter"},domProps:{"value":(_vm.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descricao=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"primary",attrs:{"for":"resumo_utilizacao_filter"}},[_vm._v("Resumo da utilização")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.resumo_utilizacao),expression:"resumo_utilizacao"}],staticClass:"form-control",attrs:{"type":"text","name":"resumo_utilizacao_filter"},domProps:{"value":(_vm.resumo_utilizacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.resumo_utilizacao=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"primary",attrs:{"for":"processos_pagamento_filter"}},[_vm._v("Processo de pagamento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.processos_pagamento),expression:"processos_pagamento"}],staticClass:"form-control select-selected",attrs:{"type":"text","name":"processos_pagamento_filter"},domProps:{"value":(_vm.processos_pagamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.processos_pagamento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'user_salvar_emenda' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v("\n              Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal_resumo_utilizacao","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("\n                  Editar resumo de utilização da emenda número\n                  "+_vm._s(_vm.numero_emenda_selecionado)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('textarea',{staticClass:"form-control",attrs:{"id":"textAreaResumo","rows":"8"},on:{"input":function($event){return _vm.updateResumoModal($event.target.value)}}},[_vm._v(_vm._s(_vm.resumo_utilizacao_selecionado))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal","disabled":_vm.desativado},on:{"click":function($event){return _vm.saveResumoModal()}}},[_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n                  Salvar\n                ")],1)])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal_anexos","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("\n                  Anexos da emenda "+_vm._s(_vm.emenda_anexos.numero)+" /\n                  "+_vm._s(_vm.emenda_anexos.ano)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('PDFImport',{ref:"upload",on:{"loadFile":_vm.setFile}}),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.arquivo_upload.length},on:{"click":function($event){return _vm.uploadFile()}}},[_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n                      Gravar arquivo\n                    ")],1)],1)]),_vm._v(" "),(_vm.lista_anexos.length)?_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.lista_anexos),function(anexo){return _c('div',{key:'anexo-' + anexo.id,staticClass:"col-xs-12 table table-striped"},[_c('a',{attrs:{"role":"button"},on:{"click":function($event){return _vm.downloadFile(anexo)}}},[_vm._v("\n                      "+_vm._s(anexo.nome)+"\n                    ")]),_vm._v("\n                    -\n                    "),_c('span',{staticClass:"is-danger",attrs:{"role":"button","title":"excluir"},on:{"click":function($event){return _vm.mensagemExclusao(anexo)}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Botão de excluir anexo")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"trash-alt","alt":"Imagem de uma lixeira usada para representar exclusão"}})],1)])})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.cleanFile()}}},[_c('font-awesome-icon',{attrs:{"icon":'times'}}),_vm._v("\n                  Fechar\n                ")],1)])])])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Fechar"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Fechar"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Lista de arquivos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EYnv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EeL1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EgXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"candidato-wrapper"},[_c('router-link',{staticClass:"foto-wrapper",attrs:{"to":{ name: 'candidato_conselho', params: { candidato: _vm.candidato } }}},[_c('img',{staticClass:"foto-candidato",attrs:{"src":_vm.candidato.url_foto,"alt":"Foto do candidato"}})]),_vm._v(" "),_c('div',{staticClass:"dados-candidato"},[_c('p',[_vm._v("\n      "+_vm._s(_vm.candidato.posicao)+"º - "+_vm._s(_vm.candidato.nome)+" -\n      "+_vm._s(_vm.candidato.numero)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-success",style:({
          width: _vm.perc * 10 + '%'
        }),attrs:{"role":"progressbar","aria-valuenow":_vm.perc * 10,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',[_vm._v("\n          Votos: "+_vm._s(_vm.candidato.total_votos.toLocaleString())+" ( "+_vm._s(_vm.perc)+"% )\n        ")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EnF0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ErQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":'Listagem de ' + _vm.title,"reportTitle":"Dados","api-url":"dado/listbyuserauth","fields":_vm.model.columns,"initial-page":_vm.pagina,"pageCollection":'dados',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"ano1",fn:function(props){return [_c('div',{},[_c('span',[(props.rowData.hasValorAno1)?_c('font-awesome-icon',{staticStyle:{"color":"green"},attrs:{"icon":'check'}}):_c('font-awesome-icon',{staticStyle:{"color":"red"},attrs:{"icon":'minus'}})],1)])]}},{key:"ano2",fn:function(props){return [_c('div',{},[_c('span',[(props.rowData.hasValorAno2)?_c('font-awesome-icon',{staticStyle:{"color":"green"},attrs:{"icon":'check'}}):_c('font-awesome-icon',{staticStyle:{"color":"red"},attrs:{"icon":'minus'}})],1)])]}},{key:"ano3",fn:function(props){return [_c('div',{},[_c('span',[(props.rowData.hasValorAno3)?_c('font-awesome-icon',{staticStyle:{"color":"green"},attrs:{"icon":'check'}}):_c('font-awesome-icon',{staticStyle:{"color":"red"},attrs:{"icon":'minus'}})],1)])]}},{key:"ano4",fn:function(props){return [_c('div',{},[_c('span',[(props.rowData.hasValorAno4)?_c('font-awesome-icon',{staticStyle:{"color":"green"},attrs:{"icon":'check'}}):_c('font-awesome-icon',{staticStyle:{"color":"red"},attrs:{"icon":'minus'}})],1)])]}},{key:"rowrender",fn:function(props){return [_c('div',{},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Listar valores","to":{
                    name: 'user_dado_valor_list',
                    params: { DAD_IDDADO: props.rowData.codigo },
                  }}},[_c('font-awesome-icon',{attrs:{"icon":'chart-bar'}})],1)],1)]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"custom-font",attrs:{"for":"nome_filter"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nome),expression:"nome"}],staticClass:"form-control",attrs:{"type":"text","name":"nome_filter"},domProps:{"value":(_vm.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"DAD_DLFONTE_filter"}},[_vm._v("Fonte")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fonte),expression:"fonte"}],staticClass:"form-control",attrs:{"type":"text","name":"DAD_DLFONTE_filter"},domProps:{"value":(_vm.fonte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fonte=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"periodicidade_codigo_filter"}},[_vm._v("Periodicidade")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.periodicidade_codigo),expression:"periodicidade_codigo"}],staticClass:"form-control select-selected",attrs:{"name":"periodicidade_codigo_filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.periodicidade_codigo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"*"}},[_vm._v("Todas")]),_vm._v(" "),_vm._l((_vm.periodicidades),function(i){return _c('option',{key:i.codigo,domProps:{"value":i.codigo}},[_vm._v("\n                      "+_vm._s(i.descricao)+"\n                    ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"status_values_filter"}},[_vm._v("Status de Preenchimento")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status_values),expression:"status_values"}],staticClass:"form-control select-selected",attrs:{"name":"status_values_filter"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status_values=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"*"}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"completo"}},[_vm._v("Completo")]),_vm._v(" "),_c('option',{attrs:{"value":"pendente_ultimoano"}},[_vm._v("\n                      Ultimo ano pendente\n                    ")]),_vm._v(" "),_c('option',{attrs:{"value":"pendente_anos_anteriores"}},[_vm._v("\n                      Anos anteriores pendente\n                    ")]),_vm._v(" "),_c('option',{attrs:{"value":"nenhum"}},[_vm._v("Sem lançamentos")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                    Filtrar\n                  ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                    Limpar Filtros\n                  ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                Filtros\n              ")],1)])],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Eudy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdfimport"},[_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-xs-12"},[_c('label',{staticClass:"control-label",attrs:{"for":"pdf_file"}},[_vm._v("Anexos (PDF)")]),_vm._v(" "),_c('input',{ref:"pdf_file",staticClass:"form-control",attrs:{"id":"pdf_file","type":"file","name":"pdf_file","accept":"application/pdf"},on:{"change":_vm.loadPDF}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F+B4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-9"},[_c('div',{staticClass:"form-group"},[_c('v-select',{attrs:{"placeholder":_vm.escalaLabel,"options":_vm.escalas,"reduce":function (u) { return u.codigo; },"selectOnTab":true},on:{"input":_vm.loadEscala},model:{value:(_vm.escalaId),callback:function ($$v) {_vm.escalaId=$$v},expression:"escalaId"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"disabled":_vm.acaoIndisponivel,"title":"Devolver para a seção corrigir!"},on:{"click":function($event){$event.preventDefault();return _vm.devolver.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":'undo'}}),_vm._v("\n              Devolver\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"disabled":_vm.acaoIndisponivel,"title":"Publicar no portal"},on:{"click":function($event){$event.preventDefault();return _vm.publicar.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":'file-import'}}),_vm._v("\n              Publicar\n            ")],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('data-table-public',{ref:"escalas",attrs:{"title":"lista de dados","has-auth":false,"api-mode":false,"data":_vm.escalaItens,"show-empty":true,"fields":_vm.datatable.columns},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_c('section',_vm._l((props.rowData
                .periodos),function(ref,index){
                var entrada = ref.entrada;
                var saida = ref.saida;
                var dias = ref.dias;
return _c('article',{key:index},[_c('label',[(entrada !== '')?_c('div',[_vm._v("\n                    "+_vm._s(entrada)+"\n                  ")]):_c('div',[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1),_vm._v(" "),(entrada !== '' && saida !== '')?_c('div',[_vm._v("-")]):_vm._e(),_vm._v(" "),(saida !== '')?_c('div',[_vm._v("\n                    "+_vm._s(saida)+"\n                  ")]):_c('div',[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1)]),_vm._v(" "),_vm._l((dias),function(dia,index){return _c('span',{key:index},[_vm._v("\n                  "+_vm._s(dia)+"\n                ")])})],2)}),0)]}}])}),_vm._v(" "),_c('footer',[_c('label',[_vm._v("Observação")]),_vm._v(" "),_c('div',{staticClass:"well"},[_vm._v("\n            "+_vm._s(_vm.observacao)+"\n          ")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F+Dw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    candidato: { type: Object, required: true },
    perc: { type: String, required: true }
  }
});

/***/ }),

/***/ "F+KH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F9jO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detalhes_vue__ = __webpack_require__("5hm6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf49726_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detalhes_vue__ = __webpack_require__("dGG0");
function injectStyle (ssrContext) {
  __webpack_require__("xCIE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bf49726"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detalhes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf49726_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detalhes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FBte":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__ = __webpack_require__("t1vn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3680f456_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__("WcJJ");
function injectStyle (ssrContext) {
  __webpack_require__("SDQR")
  __webpack_require__("m82R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3680f456"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3680f456_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FCqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TheMask: __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__["TheMask"]
  },
  name: 'user-save',
  data: function data() {
    return {
      isUpdate: false,
      listaPerfil: [],
      SSHD: '',
      carregando: false,
      data_expiracao: '',
      data_expiracao_campo: '',
      responsavel_username: '',
      model: {
        username: '',
        USU_NMUSUARIO: '',
        USU_DCEMAIL: '',
        USU_DCORIGEM: ''
      }
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.loadPerfis();
  },
  setup: function setup() {
    var checkedProfiles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vue__["ref"])([]);

    return {
      checkedProfiles: checkedProfiles
    };
  },
  mounted: function mounted() {
    this.$refs.usuario.focus();
    this.responsavel_username = this.$store.state.user.username;
  },

  computed: {
    perfisChecked: function perfisChecked() {
      var _this = this;

      return this.listaPerfil.filter(function (perfil) {
        return perfil.checked;
      }).map(function (_ref) {
        var PER_IDPERFIL = _ref.PER_IDPERFIL,
            PER_CDPERFIL = _ref.PER_CDPERFIL;

        var data_expiracao = PER_CDPERFIL === 'temporario' ? _this.data_expiracao : null;

        return {
          PER_IDPERFIL: PER_IDPERFIL,
          data_expiracao: data_expiracao,
          reponsaveL_username: _this.responsavel_username
        };
      });
    }
  },
  methods: {
    formatarDataExpiracao: function formatarDataExpiracao() {
      var day = this.data_expiracao_campo.slice(0, 2);
      var month = this.data_expiracao_campo.slice(2, 4);
      var year = this.data_expiracao_campo.slice(4, 8);

      var hours = this.data_expiracao_campo.slice(8, 10);
      var minutes = this.data_expiracao_campo.slice(10, 12);
      var seconds = this.data_expiracao_campo.slice(12, 14);

      if (this.data_expiracao_campo !== '') {
        this.data_expiracao = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
      }
    },
    getUserBySSHD: function getUserBySSHD() {
      var _this2 = this;

      this.toogleLoading();

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('user/getsshd', { sshd: this.SSHD }).then(function (response) {
        var data = response.data;


        if (data.status == false) {
          _this2.$toastr.e(data.msg);
          return;
        }

        _this2.model.username = data.data.iun;
        _this2.model.USU_NMUSUARIO = data.data.nome;
        _this2.model.USU_DCEMAIL = data.data.email_corporativo;

        if (_this2.USU_DCEMAIL) _this2.$refs.email.focus();

        _this2.toogleLoading();
      }).catch(function (e) {
        console.log(e);
        _this2.$toastr.e('Houve um erro ao tentar realizar a pesquisa, tente novamente em alguns minutos!');
        _this2.toogleLoading();
      });
    },
    loadPerfis: function loadPerfis() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('user/perfis').then(function (response) {
        var fetchedPerfis = response.data.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
            checked: false
          });
        });

        var desiredOrder = ['admin', 'default', 'gestor', 'operador', 'pdg-master', 'pdg-gestor', 'pdg-user', 'sms-admin', 'sms-gest', 'sms-user', 'mp-user', 'assistencia', 'concursos-admin', 'concursos-default', 'emendas-default', 'eleicao-conselho', 'temporario'];

        _this3.listaPerfil = fetchedPerfis.sort(function (a, b) {
          var nameA = a.PER_CDPERFIL.toLowerCase();
          var nameB = b.PER_CDPERFIL.toLowerCase();

          var indexA = desiredOrder.indexOf(nameA);
          var indexB = desiredOrder.indexOf(nameB);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
          }

          if (indexA !== -1) {
            return -1;
          }

          if (indexB !== -1) {
            return 1;
          }

          return nameA.localeCompare(nameB);
        });

        _this3.checkIsUpdateAndSetUserDataByRouteParams();
      });
    },
    checkIsUpdateAndSetUserDataByRouteParams: function checkIsUpdateAndSetUserDataByRouteParams() {
      var _this4 = this;

      var params = this.$router.history.current.params;

      if (params.hasOwnProperty('data')) {
        this.isUpdate = true;
        this.model = params.data;

        var perfisId = params.data.perfis.map(function (_ref2) {
          var PER_IDPERFIL = _ref2.PER_IDPERFIL;
          return PER_IDPERFIL;
        });
        this.checkedProfiles = perfisId;

        perfisId.forEach(function (id) {
          var index = _this4.listaPerfil.findIndex(function (item) {
            return item.PER_IDPERFIL === id;
          });
          if (index > -1) {
            _this4.listaPerfil[index].checked = true;
          }
        });
      }
    },
    save: function save() {
      var _this5 = this;

      this.formatarDataExpiracao();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this5.$refs[_this5.$validator.errors.items[0].field].focus();
          _this5.$toastr.e(_this5.$validator.errors.items[0].msg);
          return;
        }

        var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.model, {
          perfis: _this5.perfisChecked
        });

        __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('user/save', payload).then(_this5.saveSuccess).catch(_this5.saveFail);
      });
    },
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Usuário salvo com sucesso.');
      this.$router.push('/admin/users/list');
    },
    saveFail: function saveFail(result) {
      this.$toastr.e(result);
    },
    toogleLoading: function toogleLoading() {
      this.carregando = !this.carregando;
    }
  }
});

/***/ }),

/***/ "FDGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Materiais Padronizados")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Listagem de Materiais Padronizados","api-url":"material","report-title":"Materiais Padronizados","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'materiaisPadronizados',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"nome_filter"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nome),expression:"nome"}],staticClass:"form-control",attrs:{"type":"text","name":"nome_filter"},domProps:{"value":(_vm.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('label',{staticClass:"custom-font",attrs:{"for":"descricao_filter"}},[_vm._v("Descrição")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.descricao),expression:"descricao"}],staticClass:"form-control",attrs:{"type":"text","name":"descricao_filter"},domProps:{"value":(_vm.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descricao=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"medida_filter"}},[_vm._v("Medida")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.medida),expression:"medida"}],staticClass:"form-control select-selected",attrs:{"name":"medida_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.medida=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":""}},[_vm._v("Todas")]),_vm._v(" "),_vm._l((_vm.medidas),function(i){return _c('option',{key:i.codigo,domProps:{"value":i.codigo}},[_vm._v("\n                    "+_vm._s(i.nome)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"subgrupo_filter"}},[_vm._v("SubGrupo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.subgrupo),expression:"subgrupo"}],staticClass:"form-control select-selected",attrs:{"name":"subgrupo_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.subgrupo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.subgrupos),function(i){return _c('option',{key:i.codigo,domProps:{"value":i.codigo}},[_vm._v("\n                    "+_vm._s(i.nome)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"grupo_filter"}},[_vm._v("Grupo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.grupo),expression:"grupo"}],staticClass:"form-control select-selected",attrs:{"name":"grupo_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.grupo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.grupos),function(i){return _c('option',{key:i.codigo,domProps:{"value":i.codigo}},[_vm._v("\n                    "+_vm._s(i.nome)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'user_material_save' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FIhL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValorDestaqueHeader_vue__ = __webpack_require__("df1z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0069432c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValorDestaqueHeader_vue__ = __webpack_require__("eEu7");
function injectStyle (ssrContext) {
  __webpack_require__("X+GA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0069432c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValorDestaqueHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0069432c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValorDestaqueHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FMx0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__("ZTpT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55371cd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__("WiHl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55371cd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FNw0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesPorVereador_vue__ = __webpack_require__("ioH+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ba1c364_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesPorVereador_vue__ = __webpack_require__("sSSv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesPorVereador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ba1c364_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesPorVereador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FOTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

/* harmony default export */ __webpack_exports__["a"] = ({
  getMessage: function getMessage(field, args) {
    return 'O valor não confere com o campo ' + args[1];
  },
  validate: function validate(value, _ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
        fieldValue = _ref2[0];

    return value === fieldValue;
  }
});

/***/ }),

/***/ "FQTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"cabecalho"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('h2',[_vm._v(_vm._s(this.model.nomeconhecido))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.model.nome))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.model.logradouro)+", "+_vm._s(this.model.numero)+" - "+_vm._s(this.model.bairro))]),_vm._v(" "),_c('p',[_vm._v("Telefone: "+_vm._s(this.model.telefone))]),_vm._v(" "),_c('p',[_vm._v("Horário de funcionamento: "+_vm._s(this.model.horario))]),_vm._v(" "),_c('p',[_vm._v("Email: "),_c('a',{attrs:{"href":'mailto:' + this.model.email}},[_vm._v(_vm._s(this.model.email))])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('side-bar',{attrs:{"sides":_vm.navs}},[_c('template',{slot:_vm.navs[0].identidade},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v(_vm._s(_vm.funcionarios.selecionado))]),_vm._v(" "),_vm._l((this.funcionarios.por_cargo[_vm.funcionarios.selecionado]),function(fun,i){return _c('div',{key:fun.codigojornada},[_c('div',{class:[i % 2 == 0 ? '': 'lista-impar', 'row']},[_c('div',{staticClass:"col-xs-12 col-sm-8"},[(i == 0)?_c('label',[_vm._v("Nome")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(fun.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2"},[(i == 0)?_c('label',[_vm._v("Carga Horária")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(fun.cargahoraria)+" horas")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2"},[(i == 0)?_c('label',[_vm._v("Período")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(fun.turno))])])])])})],2)])])],2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":'/educacao'}},[_vm._v("Escolas")])],1),_vm._v(" "),_c('li',{},[_vm._v(_vm._s(_vm.model.nomeconhecido))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Alunos")]),_vm._v(" "),_c('h3',{staticClass:"subtitulo"},[_vm._v(_vm._s(this.alunos.totalAlunos)+" alunos, divididos...")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h4',[_vm._v("Por curso")]),_vm._v(" "),_c('bar-chart',{ref:"por_curso",attrs:{"css-classes":'chart-container',"chart-data":_vm.alunos.por_curso,"options":{
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    suggestedMax: 50
                  }
                }],
                xAxes: [{
                  maxBarThickness: 50,
                }]
              }
            }}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h4',[_vm._v("Por período")]),_vm._v(" "),_c('bar-chart',{ref:"por_periodo",attrs:{"css-classes":'chart-container',"chart-data":_vm.alunos.por_periodo,"options":{
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    suggestedMax: 50
                  }
                }],
                xAxes: [{
                  maxBarThickness: 50,
                }]
              }
            }}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Por classe")]),_vm._v(" "),_c('bar-chart',{ref:"por_turma",attrs:{"css-classes":'chart-container graficoGrande',"chart-data":_vm.alunos.por_turma,"options":{
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                    suggestedMax: 50
                  }
                }],
                xAxes: [{
                  maxBarThickness: 50,
                }]
              }
            }}}),_vm._v(" "),_c('div',{staticClass:"col-sm-4 destaque text-center margem-bottom"},[_c('span',{staticClass:"destaque"},[_vm._v("CAPACIDADE: "+_vm._s(_vm.totalVagas))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 destaque text-center margem-bottom"},[_c('span',{staticClass:"destaque"},[_vm._v("MATRICULADOS: "+_vm._s(_vm.alunos.totalAlunos))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 destaque text-center margem-bottom"},[_c('span',{staticClass:"destaque"},[_vm._v("VAGAS DISPONÍVEIS: "+_vm._s(_vm.vagasExcedentes))])]),_vm._v(" "),_vm._m(0)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("\n            Funcionários\n          ")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.funcionarios.totalFuncionarios)+" funcionários, sendo:")]),_vm._v(" "),_vm._l((_vm.funcionarios.por_cargo),function(i){return _c('div',{key:i[0].cargo,staticClass:"col-sm-4"},[_c('a',{staticClass:"funcionario",attrs:{"role":"button","data-fun":i[0].cargo},on:{"click":function($event){return _vm.abrir(_vm.navs[0].identidade, i[0].cargo)}}},[_c('div',{staticClass:"bloco"},[_c('div',{staticClass:"row header text-center"},[_vm._v("\n                  "+_vm._s(i[0].cargo)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"row body text-center"},[_vm._v("\n                  "+_vm._s(i.length)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"row footer"})])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Cardápio da Merenda")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":'https://www.santos.sp.gov.br/?q=institucional/cardapio-escolar',"target":"_blank"}},[_vm._v("Clique aqui para visualizar o cardápio das escolas")])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),(_vm.ideb[this.$route.query.escola])?_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("IDEB")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":'http://idebescola.inep.gov.br/ideb/escola/dadosEscola/' + _vm.ideb[this.$route.query.escola],"target":"_blank"}},[_vm._v("Índice de desenvolvimento da educação básica")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Localização da unidade")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":'https://egov.santos.sp.gov.br/santosmapeada/Planejamento/UnidadeOrganizacional/MapaUnidadeOrganizacional/montarMapaUnidadeOrganizacional/' + this.$route.query.escola,"target":"_blank"}},[_vm._v("Clique Aqui para visualizar o mapa")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Zeladoria na unidade")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":'https://egov.santos.sp.gov.br/santosmapeada/ServicosPublicos/Servicos/MapaServicoExecutadoUor/montarMapaServicoExecutadoUor/' + this.$route.query.escola,"target":"_blank"}},[_vm._v("Clique aqui para visualizar as manutenções na unidade")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Consumo na unidade")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":'https://egov.santos.sp.gov.br/gastosdeconsumo/Dashboard/Dashboard/principal/2907/' + this.$route.query.escola,"target":"_blank"}},[_vm._v("Clique aqui para ver o consumo na unidade")])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Observação: ")]),_vm._v("O número de alunos por classe tem como base a capacidade física da sala, a demanda da região e o Regimento Escolar no Ensino Fundamental e, na Educação Infantil, ainda é considerada a proporção educador/aluno. Não havendo necessidade em relação à demanda, a Seduc não atinge a capacidade máxima do Regimento Escolar para abertura das classes.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Mais informações")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Aprendizado dos alunos: Santos - QEdu")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"https://www.qedu.org.br/cidade/2309-santos/aprendizado","target":"_blank"}},[_vm._v("https://www.qedu.org.br/cidade/2309-santos/aprendizado")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Censo Escolar")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":"http://inep.gov.br/censo-escolar","target":"_blank"}},[_vm._v("http://inep.gov.br/censo-escolar")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FV/j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FW/n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ffni":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "FiMJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LogoPMS.0effeb8.png";

/***/ }),

/***/ "FsUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnoBase_vue__ = __webpack_require__("lJN9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1fe2738_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnoBase_vue__ = __webpack_require__("GRX2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnoBase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1fe2738_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnoBase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ft+B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FzUi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G2dL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "GAf2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GAy2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.db2e167.jpg";

/***/ }),

/***/ "GEwK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScaleControl_vue__ = __webpack_require__("X4tR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c94a91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScaleControl_vue__ = __webpack_require__("z4Gh");
function injectStyle (ssrContext) {
  __webpack_require__("mxon")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76c94a91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScaleControl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c94a91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScaleControl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GIS3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjZweCIgaGVpZ2h0PSI2NnB4IiB2aWV3Qm94PSIwIDAgNjYgNjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjYgKDY3NDkxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pYy1vdXZpZG9yaWE8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIyMS4wMDAwMDAsIC0xOS4wMDAwMDApIiBzdHJva2Utd2lkdGg9IjMiPgogICAgICAgICAgICA8ZyBpZD0iaWMtb3V2aWRvcmlhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjIuMDAwMDAwLCAyMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik02MC4yMjU3LDQ1LjEwNjkgQzYyLjI2MTcsNDAuODA5OSA2My4zNDM3LDM1Ljk4MDkgNjMuMjA0NywzMC45MDE5IEM2Mi43Mzc3LDEzLjY0OTkgNDguMzcxNywwLjA0MzkgMzEuMTIwNywwLjUxMTkgQzEzLjg2ODcsMC45ODA5IDAuMjYxNywxNS4zNDU5IDAuNzI5NywzMi41OTc5IEMxLjE5ODcsNDkuODQ5OSAxNS41NjM3LDYzLjQ1NTkgMzIuODE1Nyw2Mi45ODc5IEMzNi42NTQ3LDYyLjg4MzkgNDAuMzEyNyw2Mi4wOTA5IDQzLjY3NTcsNjAuNzMxOSBDNDYuNTQ1Nyw1OS41NzE5IDQ5LjIwMTcsNTcuOTk5OSA1MS41Njk3LDU2LjA4ODkiIGlkPSJTdHJva2UtMTE0IiBzdHJva2U9IiMxNDQ3N0MiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik01Ni41NjU1LDUxLjAyNTMgQzU2Ljc2MjUsNTAuNzc0MyA1Ni45NTY1LDUwLjUyMDMgNTcuMTQ1NSw1MC4yNjIzIiBpZD0iU3Ryb2tlLTExNiIgc3Ryb2tlPSIjMTQ0NzdDIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iU3Ryb2tlLTExOCIgc3Ryb2tlPSIjNjdCNDUwIiBwb2ludHM9IjQ5LjI5NyA0MS4yMjA2IDM5LjE5OSA1MS42MjA2IDM5LjE5OSA0MS4yMjA2IDE0LjYzOCA0MS4yMjA2IDE0LjYzOCAxNy41Njk2IDQ5LjI5NyAxNy41Njk2Ij48L3BvbHlnb24+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "GRX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-6 col-sm-3 col-md-2"},[_c('label',{attrs:{"for":""}},[_vm._v("\n    Ano Base\n  ")]),_vm._v(" "),_c('v-select',{staticClass:"style-chooser",attrs:{"options":_vm.retornaListaAnos(),"clearable":false,"disabled":_vm.isLoading,"loading":_vm.isLoading},model:{value:(_vm.ano_base),callback:function ($$v) {_vm.ano_base=$$v},expression:"ano_base"}},[_c('template',{slot:"no-options"},[_vm._v("\n      Selecione um ano válido...\n    ")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GTN5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__prestacao__ = __webpack_require__("ye37");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__prestacao__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__concursos__ = __webpack_require__("z1vu");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__concursos__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__receitasDespesas__ = __webpack_require__("m6QU");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__receitasDespesas__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__consumo__ = __webpack_require__("Xdwg");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__consumo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__remedios__ = __webpack_require__("5rA9");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__remedios__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emendasParlamentares__ = __webpack_require__("jCfh");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__emendasParlamentares__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__procedimentosSaude__ = __webpack_require__("CNAU");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__procedimentosSaude__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__eleicaoConselho__ = __webpack_require__("90oK");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__eleicaoConselho__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__movimentosODS__ = __webpack_require__("Cvqw");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__movimentosODS__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__planoDeGoverno__ = __webpack_require__("yRrB");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__planoDeGoverno__["a"]; });











/***/ }),

/***/ "GUOB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Datepicker__ = __webpack_require__("eOZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_regular_svg_icons__ = __webpack_require__("Yu89");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_3__components_common_NoApiTable__["a" /* default */], Datepicker: __WEBPACK_IMPORTED_MODULE_4__components_common_Datepicker__["a" /* default */] },
  props: {
    id: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    title: {
      type: String,
      default: function _default() {
        return 'Listagem';
      }
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    carregando: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      dataBase: '',
      loading: {
        atualizarDataAvaliacao: false,
        imprimir: false,
        excluir: false
      },
      hasAllCheckboxOnPage: false,
      lastPageSelected: 1,
      itens: [],
      fields: [{
        name: '__slot:input',
        title: '#',
        dataClass: 'text-center'
      }, {
        name: 'classificacao',
        title: 'Classificação',
        dataClass: 'text-center'
      }, {
        name: 'inscricao',
        title: 'Inscrição',
        dataClass: 'text-center'
      }, {
        name: 'cargo.descricao',
        title: 'Cargo'
      }, {
        name: 'nome',
        title: 'Nome'
      }, {
        name: 'negro',
        title: 'Negro',
        dataClass: 'text-center',
        callback: function callback(value) {
          return value === 1 ? 'Sim' : 'Não';
        }
      }, {
        name: 'deficiente',
        title: 'Deficiente',
        dataClass: 'text-center',
        callback: function callback(value) {
          return value === 1 ? 'Sim' : 'Não';
        }
      }, {
        name: 'avaliacao_status',
        title: 'Status',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }, {
        name: 'data_avaliacao',
        title: 'Data Avaliação'
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }]
    };
  },
  mounted: function mounted() {
    this.setItens();
  },

  computed: {
    iconCheck: function iconCheck() {
      return __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_regular_svg_icons__["c" /* faSquare */];
    },
    iconChecked: function iconChecked() {
      return __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_regular_svg_icons__["d" /* faCheckSquare */];
    },
    allItensUnchecked: function allItensUnchecked() {
      return this.itens.filter(function (item) {
        return item.checked;
      }).length === 0;
    }
  },
  watch: {
    data: function data(val, oldVal) {
      this.setItens();
    }
  },
  methods: {
    imprimirFichas: function imprimirFichas() {
      var _$first = _.first(this.itens),
          edital_id = _$first.edital_id;

      window.open("https://egov.santos.sp.gov.br/dadosabertos/backend/" + 'prehabilitado/imprimir-fichas-cotas/' + edital_id, '_blank');
    },
    ausentar: function ausentar(_ref) {
      var id = _ref.id,
          index = _ref.index,
          nome = _ref.nome;
      var showConfirm = this.showConfirm,
          sendRequestUpdate = this.sendRequestUpdate;

      var title = 'Confirmar ausência';
      var msg = 'Tem certeza que deseja <b>ausentar</b> ' + nome;
      var status = 'AUSENTE';
      var params = { id: id, data: { avaliacao_status: status } };
      var msgSuccess = nome + ' est\xE1 como AUSENTE';
      var msgError = 'N\xE3o foi possivel ausentar ' + nome + ', por favor tente daqui alguns minutos!';
      var success = function success() {
        return sendRequestUpdate({
          index: index,
          action: 'ausentar',
          params: params,
          msgSuccess: msgSuccess,
          msgError: msgError,
          status: status
        });
      };

      showConfirm({ title: title, msg: msg, success: success });
    },
    reprovar: function reprovar(_ref2) {
      var id = _ref2.id,
          index = _ref2.index,
          nome = _ref2.nome;
      var showConfirm = this.showConfirm,
          sendRequestUpdate = this.sendRequestUpdate;

      var title = 'Confirmar reprovação';
      var msg = 'Tem certeza que deseja <b>reprovar</b> ' + nome;
      var status = 'REPROVADO';
      var params = { id: id, data: { avaliacao_status: status } };
      var msgSuccess = nome + ' est\xE1 como REPROVADO';
      var msgError = 'N\xE3o foi possivel reprovar ' + nome + ', por favor tente daqui alguns minutos!';
      var success = function success() {
        return sendRequestUpdate({
          index: index,
          action: 'ausentar',
          params: params,
          msgSuccess: msgSuccess,
          msgError: msgError,
          status: status
        });
      };

      showConfirm({ title: title, msg: msg, success: success });
    },
    excluir: function excluir(_ref3) {
      var id = _ref3.id,
          index = _ref3.index,
          nome = _ref3.nome;
      var showConfirm = this.showConfirm,
          sendRequestDelete = this.sendRequestDelete;

      var title = 'Confirmar exclusão';
      var msg = 'Tem certeza que deseja <b>excluir</b> ' + nome;
      var params = { id: id };
      var msgSuccess = nome + ' excluido com sucesso.';
      var msgError = 'N\xE3o foi possivel excluir ' + nome + ', por favor tente daqui alguns minutos!';
      var success = function success() {
        return sendRequestDelete({ index: index, params: params, msgSuccess: msgSuccess, msgError: msgError });
      };

      showConfirm({ title: title, msg: msg, success: success });
    },
    sendRequestUpdate: function sendRequestUpdate(_ref4) {
      var _this = this;

      var index = _ref4.index,
          action = _ref4.action,
          params = _ref4.params,
          msgSuccess = _ref4.msgSuccess,
          msgError = _ref4.msgError,
          status = _ref4.status;
      var toggleProcessingClickEvent = this.toggleProcessingClickEvent;

      var url = 'prehabilitados/' + params.id;
      var onCatch = function onCatch() {
        return _this.$toastr.e(msgError);
      };
      var onFinally = function onFinally() {
        return toggleProcessingClickEvent(index, action);
      };

      toggleProcessingClickEvent(index, action);

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].put(url, params).then(function () {
        _this.itens[index].avaliacao_status = status;
        _this.$toastr.s(msgSuccess);
      }).catch(onCatch).finally(onFinally);
    },
    sendRequestDelete: function sendRequestDelete(_ref5) {
      var _this2 = this;

      var index = _ref5.index,
          params = _ref5.params,
          msgSuccess = _ref5.msgSuccess,
          msgError = _ref5.msgError;
      var toggleProcessingClickEvent = this.toggleProcessingClickEvent;

      var url = 'prehabilitados/' + params.id;
      var onCatch = function onCatch() {
        toggleProcessingClickEvent(index, 'excluir');
        _this2.$toastr.e(msgError);
      };

      toggleProcessingClickEvent(index, 'excluir');

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].delete(url).then(function () {
        toggleProcessingClickEvent(index, 'excluir');
        _this2.itens = _this2.itens.filter(function (item) {
          return item.id != params.id;
        });
        _this2.$toastr.s(msgSuccess);
      }).catch(onCatch);
    },
    atualizarDataAvaliacaoSelecionados: function atualizarDataAvaliacaoSelecionados() {
      var _this3 = this;

      var itens = this.itens,
          toggleLoadingActionButton = this.toggleLoadingActionButton,
          updateStatusRowsSelected = this.updateStatusRowsSelected,
          resetAllCheckbox = this.resetAllCheckbox;

      var id = itens.filter(function (item) {
        return item.checked;
      }).map(function (item) {
        return item.id;
      }).join(',');
      var params = {
        data: {
          data_avaliacao: this.dataBase.toJSON().split('T')[0]
        }
      };

      toggleLoadingActionButton('atualizarDataAvaliacao');

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].put('prehabilitados/' + id, params).then(function () {
        updateStatusRowsSelected({
          data_avaliacao: _this3.dataBase.toLocaleDateString()
        });
        resetAllCheckbox();
        _this3.$toastr.s('Datas de avaliação atualizadas com sucesso.');
      }).catch(function () {
        return _this3.$toastr.e(msgError);
      }).finally(function () {
        return _this3.toggleLoadingActionButton('atualizarDataAvaliacao');
      });
    },
    excluirSelecionados: function excluirSelecionados() {
      var _this4 = this;

      var showConfirm = this.showConfirm,
          itens = this.itens,
          toggleLoadingActionButton = this.toggleLoadingActionButton,
          alternarTodosCheckboxNaPagina = this.alternarTodosCheckboxNaPagina;

      var preHabilitadoSelecionados = itens.filter(function (item) {
        return item.checked;
      }).map(function (_ref6) {
        var id = _ref6.id,
            nome = _ref6.nome;
        return { id: id, nome: nome };
      });
      var success = function success() {
        var ids = preHabilitadoSelecionados.map(function (_ref7) {
          var id = _ref7.id;
          return id;
        }).join(',');
        toggleLoadingActionButton('excluir');

        __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].delete('prehabilitados/' + ids).then(function () {
          _this4.itens = _this4.itens.filter(function (item) {
            return !ids.includes(item.id);
          });
          alternarTodosCheckboxNaPagina();
          _this4.$toastr.s(preHabilitadoSelecionados.length + ' registros foram excluidos com sucesso.');
        }).catch(function () {
          return _this4.$toastr.e('N\xE3o foi possivel excluir os itens selecionados, por favor tente daqui alguns minutos!');
        }).finally(function () {
          return toggleLoadingActionButton('excluir');
        });
      };

      showConfirm({
        title: 'Confirmar exclusão',
        msg: preHabilitadoSelecionados.map(function (_ref8) {
          var nome = _ref8.nome;
          return '<p>' + nome + '</p>';
        }).join(''),
        success: success
      });
    },
    alternarTodosCheckboxNaPagina: function alternarTodosCheckboxNaPagina() {
      var statusCurrent = this.hasAllCheckboxOnPage;

      this.$refs.vuetable.tableData.forEach(function (item) {
        item.checked = !statusCurrent;
      });

      this.hasAllCheckboxOnPage = !statusCurrent;
    },
    showConfirm: function showConfirm(_ref9) {
      var title = _ref9.title,
          msg = _ref9.msg,
          success = _ref9.success;
      var modal = this.$router.app.$refs.modal;

      modal.confirm(msg, { title: title, question: true, yes: success });
    },
    setItens: function setItens() {
      var data = this.data;

      this.itens = data.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          index: index,
          checked: false,
          processingClickEvent: {
            ausentar: false,
            reprovar: false,
            excluir: false
          }
        }, item);
      });
    },
    toggleProcessingClickEvent: function toggleProcessingClickEvent(index, action) {
      var item = this.itens[index];
      this.itens[index].processingClickEvent[action] = !item.processingClickEvent[action];
    },
    toggleLoadingActionButton: function toggleLoadingActionButton(action) {
      this.loading[action] = !this.loading[action];
    },
    updateStatusRowsSelected: function updateStatusRowsSelected(keyValue) {
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(keyValue);
      var value = keyValue[key];

      this.itens.filter(function (item) {
        return item.checked;
      }).forEach(function (item) {
        return item[key] = value;
      });
    },
    checkAllCheckboxOnPage: function checkAllCheckboxOnPage() {
      var tableData = this.$refs.vuetable.tableData;

      var countSelected = tableData.map(function (_ref10) {
        var checked = _ref10.checked;
        return +checked;
      }).reduce(function (acc, cur) {
        return acc + cur;
      });

      this.hasAllCheckboxOnPage = countSelected === tableData.length;
    },
    resetAllCheckbox: function resetAllCheckbox() {
      this.itens.filter(function (item) {
        return item.checked;
      }).forEach(function (item) {
        return item.checked = false;
      });
    }
  }
});

/***/ }),

/***/ "GX8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormMessage_vue__ = __webpack_require__("8wmi");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2f2542_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormMessage_vue__ = __webpack_require__("/ljc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f2f2542_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "GXEe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gav6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ggm1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EstatisticaTotalAgendamentos_vue__ = __webpack_require__("VPee");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef64e44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EstatisticaTotalAgendamentos_vue__ = __webpack_require__("lFKq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EstatisticaTotalAgendamentos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef64e44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EstatisticaTotalAgendamentos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GhZd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group"},[_vm._t("actions")],2),_vm._v(" "),_c('div',{staticClass:"ajuste-overflow"},[_c('header',[_c('div',[_vm._t("header-actions")],2),_vm._v(" "),_c('div',[_c('vuetable-length-change',{staticClass:"custom-api-table-font",attrs:{"per-page":_vm.perPage,"options":[10, 20, 30, 50, 100, 200, 300, 'Todos']},on:{"updatePerPage":_vm.updatePerPage}})],1)]),_vm._v(" "),_c('vue-table',{ref:"vuetable",staticClass:"custom-api-table-font",attrs:{"api-mode":false,"fields":_vm.fields,"data-total":_vm.dataCount,"data-manager":_vm.dataManager,"pagination-path":"pagination","per-page":_vm.perPage,"css":_vm.css.table,"no-data-template":_vm.carregando ? 'Carregando Informações' : 'Nenhum item encontrado!'},on:{"vuetable:pagination-data":_vm.onPaginationData,"vuetable:row-clicked":_vm.onRowClicked},scopedSlots:_vm._u([{key:"input",fn:function(props){return [_vm._t("column_input",null,{"rowData":props.rowData})]}},{key:"column",fn:function(props){return [_vm._t("columncustom",null,{"rowData":props.rowData})]}},_vm._l((_vm.slots),function(item){return {key:item,fn:function(props){return [_vm._t(item,null,{"rowData":props.rowData,"rowIndex":props.rowIndex})]}}}),{key:"actions",fn:function(props){return [_vm._t("rowrender",null,{"rowData":props.rowData})]}}],null,true)})],1),_vm._v(" "),_c('pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"icons":_vm.css.icons},on:{"vuetable-pagination:change-page":_vm.onChangePage}}),_vm._v(" "),_c('pagination-info',{ref:"paginationInfo",staticClass:"pull-left custom-api-table-font",attrs:{"css":_vm.css.paginationInfo,"info-template":"Registro(s) {from} ao {to} de um total de {total}","no-data-template":"Nenhum registro"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Glix":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "GlxV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eleicao-conselho"},[_c('div',{staticClass:"row"},[_c('public-header',{attrs:{"title":'Eleições - Conselho Tutelar'}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n          Aqui você encontra os resultados compilados das eleições do conselho\n          tutelar do Município de Santos.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          No pleito de "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.ano_pleito))]),_vm._v(",\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.total_candidatos))]),_vm._v("\n          candidatos disputaram a eleição, com um total de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.votos_totais.total_nominais.toLocaleString()))]),_vm._v("\n          votos nominais,\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.votos_totais.total_brancos.toLocaleString()))]),_vm._v("\n          em branco e\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.votos_totais.total_nulos.toLocaleString()))]),_vm._v("\n          votos nulos, totalizando\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.votos_totais.total_geral.toLocaleString()))]),_vm._v("\n          votos válidos.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Veja abaixo o ranking dos candidatos titulares e suplentes e\n          selecione o candidato desejado para mais informações.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{staticClass:"chart-wrapper"},[_c('BarChart',{staticClass:"chart-size",attrs:{"gradiente":false,"chart-data":_vm.chartData,"options":_vm.chartOptions}})],1)])])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":[{ label: 'Eleições - Conselho Tutelar' }]}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('ListaCandidatos',{attrs:{"title":'Titulares',"lista":_vm.candidatosTitulares,"totalVotos":_vm.votos_totais.total_nominais}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('ListaCandidatos',{attrs:{"title":'Suplentes',"lista":_vm.candidatosSuplentes,"totalVotos":_vm.votos_totais.total_nominais}})],1)]),_vm._v(" "),_c('ListaCandidatosGeral',{attrs:{"listaCandidatos":_vm.listaCandidatos,"votosNominaisTotais":_vm.votos_totais.total_nominais}}),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("Clique abaixo para baixar a planilha com o resultado geral.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.exportarCSVCandidatos()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-csv'}}),_vm._v("\n          Candidatos\n        ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.exportarCSV()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-csv'}}),_vm._v("\n          Votos\n        ")],1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n          Baixar Resultado\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GmTN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GohC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GqrO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_materiais_js__ = __webpack_require__("pEtG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc94b0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("7YzD");
function injectStyle (ssrContext) {
  __webpack_require__("E4px")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_materiais_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc94b0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gsa0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gu+R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'registrarSenha',
  data: function data() {
    return {
      user: '',
      model: {
        password: '',
        confirm: '',
        usu_token_first_access: ''
      }
    };
  },
  mounted: function mounted() {
    if (!this.$route.query.hasOwnProperty('token')) {
      this.$toastr.e('Link invalido, solicite um novo link de cadastro de senha!');
      return;
    }
    this.user = this.$route.query.user;
    this.model.usu_token_first_access = this.$route.query.token;
  },

  methods: {
    salvarSenha: function salvarSenha() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.$refs[_this.$validator.errors.items[0].field].focus();
          _this.$toastr.e('Verifique os campos obrigatórios estão preenchidos ou se a senhas conferem!');
          return;
        }
      });
      __WEBPACK_IMPORTED_MODULE_0__request__["b" /* default */].post('user/registerpassword', this.model, this.saveSuccess, this.saveFail);
    },
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Sua senha foi salva com sucesso.');
      this.$router.push({ name: 'login_user', params: { user: this.user } });
    },
    saveFail: function saveFail(result) {
      this.$toastr.e(result);
    }
  }
});

/***/ }),

/***/ "GvjO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_image_default_png__ = __webpack_require__("29pW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_image_default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_image_default_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'meta-save',
  data: function data() {
    return {
      carregando: false,
      image: __WEBPACK_IMPORTED_MODULE_1__assets_image_default_png___default.a,
      hasInserted: true,
      model: {
        MET_NRNUMERO: 1,
        MET_DCTITULO: '',
        MET_DLOBJETIVO: '',
        MET_DLLINK: '',
        fileImagem: ''
      }
    };
  },
  created: function created() {
    this.$upload.new('logo', {
      startOnSelect: false,
      extensions: ['jpeg', 'jpg', 'png', 'gif'],
      onSelect: function onSelect(files) {
        var me = this;
        var m = this.model;
        files[0].preview(function (file) {
          me.image = file.raw;
          m.fileImagem = file.raw;
        });
      }
    });
  },
  mounted: function mounted() {
    var params = this.$router.history.current.params;
    if (params.hasOwnProperty('MET_IDMETA')) {
      var me = this;

      __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].post('meta/get', { MET_IDMETA: params.MET_IDMETA }).then(function (result) {
        if (result.status) {
          me.model = result.data;
          me.image = me.$root.$data.imgUrl + result.data.MET_DLURLIMAGEM + '?' + new Date().getTime();
          me.model.fileImagem = '';
          me.hasInserted = false;
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },

  methods: {
    saveSuccess: function saveSuccess(result) {
      this.$router.push('list');
      this.$toastr.s('Sua meta foi salva com sucesso.');
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
    },
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.$refs[_this.$validator.errors.items[0].field].focus();
          _this.$toastr.e(_this.$validator.errors.items[0].msg);
          return;
        }
      });

      if (this.hasInserted && this.model.fileImagem.length === 0) {
        this.$toastr.e('Logotipo é obrigatório!');
      }

      __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].post('meta/save', this.model).then(this.saveSuccess).catch(this.saveFail);
    }
  }
});

/***/ }),

/***/ "H/Tp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_planogoverno_SideAcao_vue__ = __webpack_require__("WgxL");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'compromisso-details',
  props: ['id'],
  components: { list: __WEBPACK_IMPORTED_MODULE_6__components_common_DataTable__["a" /* default */], SideAcao: __WEBPACK_IMPORTED_MODULE_7__components_planogoverno_SideAcao_vue__["a" /* default */] },
  data: function data() {
    return {
      model: {
        id: null,
        descritivo: '',
        unidade_executora: '',
        periodo: '',
        user_sshd: '',
        responsavel_sshd: '',
        data_conclusao: '',
        status: ''
      },
      fields: [{
        name: 'ordem',
        title: 'Ordem',
        sortField: 'ordem',
        titleClass: 'text-center',
        dataClass: 'align-middle text-center',
        filterable: true
      }, {
        name: 'unidade',
        title: 'Unidade',
        sortField: 'unidade',
        filterable: true
      }, {
        name: 'descritivo',
        title: 'Descritivo',
        sortField: 'descritivo',
        dataClass: 'align-middle truncate-multiline',
        filterable: true,
        callback: function callback(value) {
          if (!value) return '';
          return value.length > 150 ? value.substring(0, 97) + '...' : value;
        }
      }, {
        name: 'data_estimada_inicio',
        title: 'Inicia',
        sortField: 'data_estimada_inicio',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        filterable: true
      }, {
        name: 'data_estimada_conclusao',
        title: 'Finaliza',
        sortField: 'data_estimada_conclusao',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        filterable: true
      }, {
        name: 'status',
        title: 'Status',
        sortField: 'status',
        titleClass: 'text-center text-nowrap',
        dataClass: 'text-center text-nowrap',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }],
      sideConfig: [{
        titulo: 'Detalhes',
        subtitulo: '',
        subtDetalhe: '',
        largura: 600,
        identidade: 'detalhes',
        abreProximo: false,
        aberto: false,
        data: null
      }, {
        titulo: 'Excluir',
        subtitulo: '',
        subtDetalhe: '',
        largura: 600,
        identidade: 'deletar',
        abreProximo: false,
        aberto: false,
        data: null
      }],
      listas: {
        status: ['Não Iniciado', 'Em andamento', 'Concluído', 'Cancelada', 'Rejeitada']
      },
      unidadesDisponiveis: [],
      responsaveisCache: {}
    };
  },
  created: function created() {
    this.carregarDetalhes();
    this.carregarOpcoesUnidades();
  },

  computed: {
    filtros: function filtros() {
      return {
        descritivo: this.descritivo,
        unidade: this.unidade,
        status: this.status
      };
    },

    pagina: {
      get: function get() {
        var compromissoDetails = this.$store.state.vuetableState.compromissoDetails;
        var pagina = compromissoDetails.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'compromissoDetails',
          value: value
        });
      }
    },
    unidade: {
      get: function get() {
        return this.$store.state.vuetableState.compromissoDetails.filtros.unidade || '';
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'unidade',
          collection: 'compromissoDetails',
          value: value
        });
        this.resetPageStore();
      }
    },
    descritivo: {
      get: function get() {
        return this.$store.state.vuetableState.compromissoDetails.filtros.descritivo || '';
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'descritivo',
          collection: 'compromissoDetails',
          value: value
        });
        this.resetPageStore();
      }
    },
    status: {
      get: function get() {
        return this.$store.state.vuetableState.compromissoDetails.filtros.status || '';
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'status',
          collection: 'compromissoDetails',
          value: value
        });
        this.resetPageStore();
      }
    }
  },
  methods: {
    carregarDetalhes: function carregarDetalhes() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get('planogoverno/compromisso/' + _this.id);

              case 2:
                _ref = _context.sent;
                data = _ref.data;


                _this.model = data;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    carregarOpcoesUnidades: function carregarOpcoesUnidades() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, todasAsAcoes, unidades;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get('planogoverno/compromisso-acao?compromisso_id=' + _this2.id);

              case 3:
                _ref2 = _context2.sent;
                todasAsAcoes = _ref2.data.data;


                if (todasAsAcoes && todasAsAcoes.length) {
                  unidades = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(todasAsAcoes.map(function (acao) {
                    return acao.unidade;
                  }));

                  _this2.unidadesDisponiveis = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(unidades).sort();
                }
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.error("Erro ao carregar opções de unidades para o filtro: ", _context2.t0);
                _this2.$toastr.e('Não foi possível carregar as opções de filtro de unidade.');

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    },
    detalhar: function detalhar(acao) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var nomeReponsavel, dadosCompletos;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.sideConfig[0].subtitulo = acao.descritivo;
                _this3.sideConfig[0].data = acao;
                _this3.$refs.side.$emit('abreModal', 'detalhes');

                _context3.next = 5;
                return _this3.obterNomeResponsavel(acao.sshd_responsavel);

              case 5:
                nomeReponsavel = _context3.sent;
                dadosCompletos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, acao, {
                  nome_responsavel: nomeReponsavel
                });


                _this3.sideConfig[0].data = dadosCompletos;

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    deleteAcao: function deleteAcao(acao) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.sideConfig[1].subtitulo = acao.descritivo;
                _this4.sideConfig[1].data = acao;
                _this4.$refs.side.$emit('abreModal', 'deletar');

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    confirmarDelete: function confirmarDelete(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].delete('planogoverno/compromisso-acao/' + id);

              case 3:
                _this5.$refs.vuetable.refresh();
                _this5.$toastr.s('Ação excluída com sucesso.');
                _this5.$refs.side.$emit('fechaModal', 'deletar');
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](0);

                console.error("Erro ao excluir a ação: ", _context5.t0);

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 8]]);
      }))();
    },
    formatarData: function formatarData(data) {
      if (!data) return '-';
      return new Date(data).toLocaleDateString('pt-BR');
    },
    statusClass: function statusClass(status) {
      switch (status) {
        case 'Não Iniciado':
          return 'label-nao-iniciado';
        case 'Em andamento':
          return 'label-em-andamento';
        case 'Concluído':
          return 'label-concluido';
        case 'Cancelado':
          return 'label-cancelado';
        default:
          return 'label-nao-iniciado';
      }
    },
    consultar: function consultar() {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      this.unidade = '';
      this.descritivo = '';
      this.status = '';

      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'compromissoDetails',
        value: 1
      });
    }
  }
});

/***/ }),

/***/ "H1vy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H6LR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressoGeral_vue__ = __webpack_require__("AxvQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ProgressoGeral: __WEBPACK_IMPORTED_MODULE_0__ProgressoGeral_vue__["a" /* default */] },
  props: {
    title: {
      type: String,
      default: 'Resultado Geral'
    },
    listaCandidatos: {
      type: Array,
      required: true
    },
    votosNominaisTotais: {
      type: Number,
      required: true
    }
  }
});

/***/ }),

/***/ "H9Tw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"arquivos-edital"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('input-vagas',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['custom-font', { 'is-danger': _vm.errors.has('descricao') }],attrs:{"cssClass":'col-xs-12',"label":'Descrição do Arquivo',"name":'descricao',"error":_vm.errors.has('descricao') ? _vm.errors.first('descricao') : ''},model:{value:(_vm.model.descricao),callback:function ($$v) {_vm.$set(_vm.model, "descricao", $$v)},expression:"model.descricao"}}),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12 col-sm-6 col-md-3"},[_c('label',{class:[
          'custom-font',
          { 'is-danger': _vm.errors.has('data_publicacao') }
        ]},[_vm._v("Data de Publicação")]),_vm._v(" "),_c('datepicker',{ref:"data_publicacao",attrs:{"name":"data_publicacao"},model:{value:(_vm.model.data_publicacao),callback:function ($$v) {_vm.$set(_vm.model, "data_publicacao", $$v)},expression:"model.data_publicacao"}})],1),_vm._v(" "),_c('input-vagas',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],class:['custom-font', { 'is-danger': _vm.errors.has('pagina') }],attrs:{"label":'Página da Publicação',"name":'pagina',"error":_vm.errors.has('pagina') ? _vm.errors.first('pagina') : ''},model:{value:(_vm.model.pagina),callback:function ($$v) {_vm.$set(_vm.model, "pagina", $$v)},expression:"model.pagina"}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 form-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.salvar()}}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":_vm.model.id ? 'save' : 'plus'}}),_vm._v("\n        "+_vm._s(_vm.model.id ? 'Salvar' : 'Adicionar')+"\n      ")],1)])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table',{ref:"vuetable",attrs:{"dados":_vm.arquivosEdital,"fields":_vm.fields,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.selecionarArquivo(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Editar")])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir Arquivo"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}})],1)]}}])})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{staticClass:"custom-subtitle"},[_vm._v("Arquivos do Edital")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HDmn":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "HOck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HfSY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hi7N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/15.0705f3f.jpg";

/***/ }),

/***/ "HiLe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SelectFuncionario__ = __webpack_require__("JrGC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_planogoverno_SidePlanoGoverno_vue__ = __webpack_require__("3p2T");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { list: __WEBPACK_IMPORTED_MODULE_3__components_common_DataTable__["a" /* default */], SelectFuncionario: __WEBPACK_IMPORTED_MODULE_2__components_SelectFuncionario__["a" /* default */], SidePlanoGoverno: __WEBPACK_IMPORTED_MODULE_5__components_planogoverno_SidePlanoGoverno_vue__["a" /* default */] },
    data: function data() {
        return {
            fields: [{
                name: 'periodo',
                title: 'Período',
                filterable: true,
                titleClass: 'text-center text-nowrap',
                dataClass: 'text-center text-nowrap'
            }, {
                name: 'unidade_executora',
                title: 'Unidade',
                filterable: true,
                titleClass: 'text-center text-nowrap',
                dataClass: 'text-center text-nowrap'
            }, {
                name: 'descritivo',
                title: 'Compromisso',
                filterable: true
            }, {
                name: 'responsavel_sshd',
                title: 'Responsável',
                filterable: true,
                titleClass: 'text-center text-nowrap',
                dataClass: 'text-center text-nowrap'
            }, {
                name: '__slot:actions',
                title: 'Ações',
                titleClass: 'text-center col-md-3',
                dataClass: 'text-center'
            }],
            sideConfig: [{
                titulo: 'Editar',
                subtitulo: '',
                subtDetalhe: '',
                largura: 900,
                identidade: 'editar',
                abreProximo: false,
                aberto: false,
                data: null
            }],
            listas: {
                secretarias: [],
                autarquias: [],
                periodos: ['2021-2024', '2025-2028']
            },
            modal: {
                visivel: false,
                compromisso: null,
                novoResponsavel: ''
            }
        };
    },

    computed: {
        filtros: function filtros() {
            return {
                periodo: this.periodo,
                unidade_executora: this.unidade_executora,
                descritivo: this.descritivo,
                responsavel: this.responsavel
            };
        },

        pagina: {
            get: function get() {
                var compromissoDetails = this.$store.state.vuetableState.compromissoDetails;
                var pagina = compromissoDetails.pagina;

                return pagina;
            },
            set: function set(value) {
                this.$store.commit('SET_FILTER_PAGE', {
                    collection: 'compromissoDetails',
                    value: value
                });
            }
        },
        periodo: {
            get: function get() {
                return this.$store.state.vuetableState.compromissoDetails.filtros.periodo || '';
            },
            set: function set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'periodo',
                    collection: 'compromissoDetails',
                    value: value
                });
                this.resetPageStore();
            }
        },
        unidade_executora: {
            get: function get() {
                return this.$store.state.vuetableState.compromissoDetails.filtros.unidade_executora || '';
            },
            set: function set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'unidade_executora',
                    collection: 'compromissoDetails',
                    value: value
                });
                this.resetPageStore();
            }
        },
        descritivo: {
            get: function get() {
                return this.$store.state.vuetableState.compromissoDetails.filtros.descritivo || '';
            },
            set: function set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'descritivo',
                    collection: 'compromissoDetails',
                    value: value
                });
                this.resetPageStore();
            }
        },
        responsavel: {
            get: function get() {
                return this.$store.state.vuetableState.compromissoDetails.filtros.responsavel || '';
            },
            set: function set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'responsavel',
                    collection: 'compromissoDetails',
                    value: value
                });
                this.resetPageStore();
            }
        }
    },
    created: function created() {
        this.loadUnidades();
    },

    methods: {
        loadUnidades: function loadUnidades() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, secretarias, _ref2, autarquias;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('listar-secretarias');

                            case 3:
                                _ref = _context.sent;
                                secretarias = _ref.data.data;
                                _context.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('listar-autarquias');

                            case 7:
                                _ref2 = _context.sent;
                                autarquias = _ref2.data.data;

                                _this.listas.secretarias = secretarias;
                                _this.listas.autarquias = autarquias;
                                _context.next = 16;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](0);

                                _this.$toastr.e('Erro ao carregar unidades.');

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[0, 13]]);
            }))();
        },
        editar: function editar(compromisso) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var painel;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                painel = _this2.sideConfig.find(function (p) {
                                    return p.identidade === 'editar';
                                });


                                painel.subtitulo = compromisso.descritivo;
                                painel.data = compromisso;
                                _this2.$refs.side.$emit('abreModal', painel.identidade);

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        salvarEdicao: function salvarEdicao(compromissoEditado) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var payload;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                payload = {
                                    descritivo: compromissoEditado.descritivo,
                                    responsavel_sshd: compromissoEditado.responsavel_sshd,
                                    user_sshd: _this3.$store.state.user.username
                                };
                                _context3.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].put('planogoverno/compromisso/' + compromissoEditado.id, payload);

                            case 4:

                                _this3.$toastr.s('Compromisso atualizado com sucesso!');
                                _this3.$refs.vuetable.refresh();
                                _this3.$refs.side.$emit('fechaModal', 'editar');
                                _context3.next = 13;
                                break;

                            case 9:
                                _context3.prev = 9;
                                _context3.t0 = _context3['catch'](0);

                                console.error('Erro ao salvar edição:', _context3.t0);
                                _this3.$toastr.e('Erro ao salvar edição.');

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[0, 9]]);
            }))();
        },
        handleFecharModal: function handleFecharModal(identidade) {
            this.$refs.side.$emit('fechaModal', identidade);
        },
        consultar: function consultar() {
            this.$refs.vuetable.refresh();
        },
        limpar: function limpar() {
            var _this4 = this;

            this.periodo = '';
            this.unidade_executora = '';
            this.descritivo = '';
            this.responsavel = '';

            this.$nextTick(function () {
                _this4.$refs.vuetable.refresh();
            });
        },
        resetPageStore: function resetPageStore() {
            this.$store.commit('SET_FILTER_PAGE', {
                collection: 'compromissoDetails',
                value: 1
            });
        }
    }
});

/***/ }),

/***/ "Hr5u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hubs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I9gH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IFOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("0xDb");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_3__components__["a" /* PublicHeader */],
    BarChart: __WEBPACK_IMPORTED_MODULE_3__components__["e" /* BarChart */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components__["b" /* Breadcrumb */],
    ListaCandidatos: __WEBPACK_IMPORTED_MODULE_3__components__["h" /* ListaCandidatos */],
    ListaCandidatosGeral: __WEBPACK_IMPORTED_MODULE_3__components__["g" /* ListaCandidatosGeral */]
  },
  data: function data() {
    return {
      isLoading: true,
      ano_pleito: 2023,
      baseChart: {
        labels: ['Nominais', 'Brancos', 'Nulos'],
        datasets: [{ label: '', data: [] }]
      },
      chartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: true,
          labels: {
            fontColor: '#C1D1C1'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              suggestedMax: 50,
              fontColor: '#C1D1C1',
              callback: function callback(value, index, values) {
                return value.toLocaleString();
              }
            }
          }],
          xAxes: [{
            maxBarThickness: 50,
            ticks: {
              fontColor: '#C1D1C1'
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function label(tooltip, dataset) {
              var xLabel = dataset.datasets[tooltip.datasetIndex].label;
              var yLabel = tooltip.yLabel.toLocaleString();
              return xLabel + ': ' + yLabel;
            }
          }
        }
      }
    };
  },
  created: function created() {
    this.$store.dispatch('loadCandidatos');
    this.$store.dispatch('loadVotos');
  },

  methods: {
    reducer: function reducer(key) {
      return function (acum, atual) {
        return acum += Number(atual[key]) || 0;
      };
    },
    mountCSVHeader: function mountCSVHeader() {
      var headers = ['numero_secao', 'data_abertura', 'data_fechamento', 'aptos', 'compareceram', 'total_nominais', 'total_brancos', 'total_nulos', 'total_votos'];

      var candidatos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.candidatos)).sort(function (candidatoA, candidatoB) {
        if (candidatoA.numero < candidatoB.numero) {
          return -1;
        }

        if (candidatoA.numero > candidatoB.numero) {
          return 1;
        }

        return 0;
      }).map(function (candidato) {
        return candidato.numero;
      });

      candidatos.forEach(function (numero) {
        headers.push(numero);
      });

      headers.push('unidade', 'endereco');

      return headers;
    },
    mountCSVLines: function mountCSVLines(headers) {
      var linhas = [];

      this.votos.forEach(function (secao) {
        var voto = [];

        headers.forEach(function (header) {
          if (header === 'total_votos') {
            voto.push(secao['total_nominais'] + secao['total_brancos'] + secao['total_nulos']);
            return;
          }

          if (typeof header === 'number') {
            var _secao$votos$find = secao.votos.find(function (voto) {
              return voto.candidato.numero === header;
            }),
                total_votos = _secao$votos$find.total_votos;

            voto.push(total_votos);
            return;
          }

          if (header === 'numero_secao') {
            voto.push(secao['numero']);
          } else {
            voto.push(secao[header] || 0);
          }
        });

        linhas.push(voto);
      });

      return linhas;
    },
    exportarCSV: function exportarCSV() {
      var headers = this.mountCSVHeader();
      var votos = this.mountCSVLines(headers);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* exportCSVFile */])(headers, votos, 'pleito');
    },
    exportarCSVCandidatos: function exportarCSVCandidatos() {
      var headers = ['numero', 'nome', 'total_votos', 'posicao'];
      var exportArray = [];

      var candidatos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.candidatos)).sort(function (candidatoA, candidatoB) {
        if (candidatoA.numero < candidatoB.numero) {
          return -1;
        }

        if (candidatoA.numero > candidatoB.numero) {
          return 1;
        }

        return 0;
      });

      candidatos.forEach(function (candidato) {
        var line = [];
        headers.forEach(function (header) {
          line.push(candidato[header]);
        });
        exportArray.push(line);
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* exportCSVFile */])(headers, exportArray, 'candidatos');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])({
    votos: function votos(_ref) {
      var eleicoes_conselho = _ref.eleicoes_conselho;
      return eleicoes_conselho.votos;
    },
    candidatos: function candidatos(_ref2) {
      var eleicoes_conselho = _ref2.eleicoes_conselho;
      return eleicoes_conselho.candidatos;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapGetters */])({
    votos_totais: 'votosTotais'
  }), {
    listaCandidatos: function listaCandidatos() {
      return this.candidatos;
    },
    total_candidatos: function total_candidatos() {
      return this.candidatos.length;
    },
    candidatosTitulares: function candidatosTitulares() {
      return this.candidatos.slice(0, 15);
    },
    candidatosSuplentes: function candidatosSuplentes() {
      return this.candidatos.slice(15, 30);
    },
    chartData: function chartData() {
      var datasets = [{
        label: this.ano_pleito,
        data: [this.votos_totais.total_nominais, this.votos_totais.total_brancos, this.votos_totais.total_nulos],
        backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* colors */].coresHexa[0]
      }];

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.baseChart, {
        datasets: datasets
      });
    }
  })
});

/***/ }),

/***/ "IGK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LineChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");




var LineChart = {
  extends: __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["a" /* Line */],
  data: function data() {
    return {
      chartData: {
        labels: [],
        datasets: [{}]
      }
    };
  },

  props: ['url', 'options'],
  mounted: function mounted() {
    var _this = this;

    if (this.$refs.canvas) {
      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get(this.url).then(function (r) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(r).length > 0) {
          _this.chartData = r;
        }

        var gradient = _this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);

        gradient.addColorStop(0, 'rgba(210, 230, 139, 0.5)');
        gradient.addColorStop(0.5, 'rgba(210, 230, 139, 0.25)');
        gradient.addColorStop(1, 'rgba(210, 230, 139, 0)');

        _this.chartData.datasets[0].label = 'Valores';
        _this.chartData.datasets[0].borderColor = '#A1BE4D';
        _this.chartData.datasets[0].pointBackgroundColor = 'white';
        _this.chartData.datasets[0].borderWidth = 1;
        _this.chartData.datasets[0].pointRadius = 4;
        _this.chartData.datasets[0].pointHoverRadius = 8;
        _this.chartData.datasets[0].pointBorderWidth = 1;
        _this.chartData.datasets[0].pointBorderColor = 'black';
        _this.chartData.datasets[0].backgroundColor = gradient;

        _this.renderChart(_this.chartData, _this.options);
      }).catch(function (e) {
        console.log(e);
      });
    }
  }
};

/***/ }),

/***/ "INat":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    separador: {
      type: String,
      default: ';'
    }
  },
  data: function data() {
    return {
      channel_name: '',
      channel_fields: [],
      channel_entries: [],
      parse_header: [],
      parse_csv: [],
      sortOrders: {},
      sortKey: ''
    };
  },

  filters: {
    capitalize: function capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  methods: {
    sortBy: function sortBy(key) {
      var vm = this;
      vm.sortKey = key;
      vm.sortOrders[key] = vm.sortOrders[key] * -1;
    },
    csvJSON: function csvJSON(csv) {
      var vm = this;
      var lines = csv.split(/\r\n|\n|\r/);
      var result = [];
      var headers = lines[0].split(vm.separador);
      vm.parse_header = lines[0].split(vm.separador);
      lines[0].split(vm.separador).forEach(function (key) {
        vm.sortOrders[key] = 1;
      });

      lines.map(function (line, indexLine) {
        if (indexLine < 1) return; // Jump header line

        var obj = {};
        var currentline = line.split(vm.separador);

        headers.map(function (header, indexHeader) {
          obj[header] = currentline[indexHeader];
        });

        result.push(obj);
      });

      result.pop(); // remove the last item because undefined values

      return result; // JavaScript object
    },
    csvJSON2: function csvJSON2(csv) {
      // Nova Logica
      var separador = this.separador;
      // 1 - quebrar o CSV em linhas

      var lines = csv.split(/\r\n|\n|\r/);
      // 2 - obter os headers da primeira linha
      var headers = lines[0].split(separador);
      // 3 - obter o count dos headers
      var countHeaders = headers.length;
      // 4 - splitar o CSV original com o separador e obter o count do separador
      var pattern = new RegExp(separador + '|\r\n|\n|\r');
      var csvSplit = csv.split(pattern);
      var countCSV = csvSplit.length;
      // 5 - iniciar um for a partir do count do headers e fechar o for menor que o count do separador
      var itens = [];
      for (var itemIndex = countHeaders; itemIndex < countCSV; itemIndex++) {
        // 6 - dentro do for iniciar outro for a partir do 0 e fechar menor que count do header
        var item = {};
        for (var valueIndex = 0; valueIndex < countHeaders; valueIndex++) {
          // 7 - dentro do for criar um indice que será a index for anterior + index do for atual
          var indice = itemIndex + valueIndex;
          // 8 - uso o index desse for para obter o key e uso o indice criado com o CSV quebrado pelo separador para obter o value
          var key = headers[valueIndex];
          var value = csvSplit[indice];
          // 9 - adiciono esse key e value em um objeto
          item[key] = value;
        }
        // 10 - fora do for adiciono o objeto dentro do array de resultados
        itens.push(item);
      }
      // 11 - ao finalizar o ultimo for retorno o array de resultados
      return itens;
    },
    loadCSV: function loadCSV(e) {
      var vm = this;
      if (window.FileReader) {
        var reader = new FileReader();
        var retorno = this.returnCSV;
        reader.readAsText(e.target.files[0]);
        // Handle errors load
        reader.onload = function (event) {
          var csv = event.target.result;
          //vm.parse_csv = vm.csvJSON(csv)
          vm.parse_csv = vm.csvJSON(csv);
          retorno();
        };
        reader.onerror = function (evt) {
          if (evt.target.error.name == "NotReadableError") {
            alert("Não foi possível ler o arquivo!");
          }
        };
      } else {
        alert('Esta função não é suportada por este navegador!');
      }
    },
    returnCSV: function returnCSV() {
      this.$emit('loadCSV', { header: this.parse_header, body: this.parse_csv });
    }
  }
});

/***/ }),

/***/ "IRgX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.label)+" Subgrupo")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('form',{attrs:{"role":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.save()}}},[_c('fieldset',[_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:[
                  'form-group',
                  { 'has-error': _vm.errors.has('grupo_codigo') }
                ]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Grupo")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.grupo_codigo),expression:"model.grupo_codigo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"grupo_codigo",staticClass:"form-control select-selected",attrs:{"name":"grupo_codigo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "grupo_codigo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.grupos),function(p){return _c('option',{key:p.codigo,domProps:{"value":p.codigo}},[_vm._v("\n                      "+_vm._s(p.nome)+"\n                    ")])}),0)]),_vm._v(" "),(_vm.errors.has('grupo_codigo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"grupo_codigo"}},[_vm._v("Preenchimento obrigatório!")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('nome') }]},[_c('label',{class:[
                    'control-label',
                    'custom-font',
                    { 'is-danger': _vm.errors.has('nome') }
                  ]},[_vm._v("Nome do Subgrupo")]),_vm._v(" "),_c('div',{staticClass:"inputGroupContainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('nome') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome",class:[
                        'form-control',
                        { 'is-danger': _vm.errors.has('nome') }
                      ],attrs:{"name":"nome","maxlength":"50","placeholder":"Nome","type":"text"},domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                        'input-group-addon custom-input-group-addon-count',
                        { 'is-danger': _vm.errors.has('nome') }
                      ],domProps:{"textContent":_vm._s(50 - _vm.model.nome.length)}})]),_vm._v(" "),(_vm.errors.has('nome'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"nome"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                    "+_vm._s(_vm.errors.first('nome'))+"\n                  ")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"23px"}},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n                  Salvar\n                ")],1)])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ISk+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("irGX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10b52e14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("SEVD");
function injectStyle (ssrContext) {
  __webpack_require__("1jqu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10b52e14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10b52e14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ISmE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v("\n      Cadastrar Compromisso\n    ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('periodo') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Período")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'calendar-alt'}})],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.periodo),expression:"model.periodo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"periodo",staticClass:"form-control select-selected",attrs:{"name":"periodo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "periodo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Selecione o período")]),_vm._v(" "),_vm._l((_vm.listas.periodos),function(p){return _c('option',{key:p,domProps:{"value":p}},[_vm._v("\n                    "+_vm._s(p)+"\n                  ")])})],2)]),_vm._v(" "),(_vm.errors.has('periodo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"periodo"}},[_vm._v("Preenchimento obrigatório!\n              ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('unidade_executora') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Unidade")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'sitemap'}})],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.unidade_executora),expression:"model.unidade_executora"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"unidade_executora",staticClass:"form-control select-selected",attrs:{"name":"unidade_executora"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "unidade_executora", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selecione a unidade")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Secretarias"}},_vm._l((_vm.listas.secretarias),function(s){return _c('option',{key:s.sigla,attrs:{"title":s.nome},domProps:{"value":s.sigla}},[_vm._v("\n                      "+_vm._s(s.sigla)+"\n                    ")])}),0),_vm._v(" "),_c('optgroup',{attrs:{"label":"Autarquias"}},_vm._l((_vm.listas.autarquias),function(a){return _c('option',{key:a.sigla,attrs:{"title":a.nome},domProps:{"value":a.sigla}},[_vm._v("\n                      "+_vm._s(a.sigla)+"\n                    ")])}),0)])]),_vm._v(" "),(_vm.errors.has('unidade_executora'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"unidade_executora"}},[_vm._v("Preenchimento obrigatório!\n              ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('SelectFuncionario',{attrs:{"label":'Funcionário Responsável',"name":'responsavel_sshd',"placeholder":'Pesquise pelo nome ou SSHD',"is-required":true},model:{value:(_vm.model.responsavel_sshd),callback:function ($$v) {_vm.$set(_vm.model, "responsavel_sshd", $$v)},expression:"model.responsavel_sshd"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('titulo') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Título")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'tags'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.titulo),expression:"model.titulo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"titulo",staticClass:"form-control",attrs:{"type":"text","name":"titulo","placeholder":"Título","maxlength":"255"},domProps:{"value":(_vm.model.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "titulo", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(255 - _vm.model.titulo.length)}})]),_vm._v(" "),(_vm.errors.has('titulo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"titulo"}},[_vm._v("Preenchimento obrigatório!\n              ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('descricao') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Descrição")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'comment'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"descricao",staticClass:"form-control",attrs:{"name":"descricao","placeholder":"Descreva o compromisso...","maxlength":"1000","rows":"8"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(1000 - _vm.model.descricao.length)}})]),_vm._v(" "),(_vm.errors.has('descricao'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"descricao"}},[_vm._v("Preenchimento obrigatório!\n              ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 margem-bottom"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'user_planogoverno' }}},[_c('font-awesome-icon',{class:'fa-long-arrow-alt-left-white',attrs:{"icon":'long-arrow-alt-left'}}),_vm._v(" Voltar\n          ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.save()}}},[_c('font-awesome-icon',{class:'fa-save-white',attrs:{"icon":'save'}}),_vm._v(" Salvar\n          ")],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules__ = __webpack_require__("2mV7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__("ukYY");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  initialized: false,
  isLogged: !!localStorage.getItem('daUser')
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: "production" !== 'production',
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
    key: 'dados_abertos',
    paths: ['isLogged', 'user', 'receitas_despesas.receitas_proprias'],
    storage: window.localStorage
  })],
  state: state,
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* mutations */],
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* actions */],
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_3__modules__["a" /* user */],
    escala: __WEBPACK_IMPORTED_MODULE_3__modules__["b" /* escala */],
    pesquisa: __WEBPACK_IMPORTED_MODULE_3__modules__["c" /* pesquisa */],
    receitas_despesas: __WEBPACK_IMPORTED_MODULE_3__modules__["d" /* receitas_despesas */],
    vuetableState: __WEBPACK_IMPORTED_MODULE_3__modules__["e" /* vuetableState */],
    emendas_parlamentares: __WEBPACK_IMPORTED_MODULE_3__modules__["f" /* emendas_parlamentares */],
    eleicoes_conselho: __WEBPACK_IMPORTED_MODULE_3__modules__["g" /* eleicoes_conselho */],
    plano_governo: __WEBPACK_IMPORTED_MODULE_3__modules__["h" /* plano_governo */]
  }
}));

/***/ }),

/***/ "IeSM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__request__ = __webpack_require__("OOvn");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'remanejamento',
  components: { InputErrorMessage: __WEBPACK_IMPORTED_MODULE_4__components__["l" /* InputErrorMessage */], TheMask: __WEBPACK_IMPORTED_MODULE_6_vue_the_mask__["TheMask"] },
  props: {
    ano: {
      type: String
    },
    descricao: {
      type: String
    },
    id: {
      type: Number
    },
    nome_orgao: {
      type: String
    },
    numero: {
      type: Number
    },
    numero_processo: {
      type: String
    },
    observacao: {
      type: String
    },
    processos_pagamento: {
      type: Array
    },
    resumo_utilizacao: {
      type: String
    },
    saldo: {
      type: Number
    },
    sigla_orgao: {
      type: String
    },
    termo_busca: {
      type: String
    },
    valor: {
      type: String
    },
    vereador: {
      type: Object,
      default: function _default() {
        return { nome: '' };
      }
    },
    vereador_id: {
      type: Number
    }
  },
  data: function data() {
    return {
      isLoading: false,
      model: {
        id: null,
        valor: this.saldo,
        numero: this.numero,
        nome_orgao: this.nome_orgao,
        sigla_orgao: this.sigla_orgao,
        descricao: '',
        observacao: '',
        termo_busca: '',
        resumo_utilizacao: '',
        id_emenda_origem: this.id
      },
      orgaos: []
    };
  },
  beforeCreate: function beforeCreate() {
    var id = this.$route.params.id;

    if (!id) {
      this.$router.push({ name: 'user_emendasparlamentares' });
    }
  },
  created: function created() {
    this.loadSecretarias();
  },

  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_5__utils__["e" /* formatarMoeda */],
    toggleLoading: function toggleLoading() {
      this.isLoading = !this.isLoading;
    },
    loadSecretarias: function loadSecretarias() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__request__["a" /* request */].get('unidade-organizacional/secretarias');

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                _this.orgaos = data;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                _this.$toastr.e('Houve um erro ao carregar as secretarias. Atualize a página e tente novamente');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    loadNomeSecretaria: function loadNomeSecretaria() {
      var _this2 = this;

      var finder = function finder(secretaria) {
        return secretaria.sigla === _this2.model.sigla_orgao;
      };
      var orgao = this.orgaos.find(finder);
      this.model.nome_orgao = orgao.nome;
    },
    remanejar: function remanejar() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var isValid, _ref2, data, _error$response, _data, status, msg, _errors$items, error;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.saldo - _this3.model.valor < 0)) {
                  _context2.next = 4;
                  break;
                }

                _this3.$toastr.e('Saldo insuficiente para remanejamento da emenda. Saldo atual: ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["e" /* formatarMoeda */])(_this3.saldo));
                _this3.$refs.valor.$el.focus();
                return _context2.abrupt('return');

              case 4:
                _context2.next = 6;
                return _this3.$validator.validateAll();

              case 6:
                isValid = _context2.sent;

                if (!isValid) {
                  _context2.next = 33;
                  break;
                }

                _this3.toggleLoading();
                _context2.prev = 9;
                _context2.next = 12;
                return __WEBPACK_IMPORTED_MODULE_7__request__["a" /* request */].post('emendas/remajenar', _this3.formValues);

              case 12:
                _ref2 = _context2.sent;
                data = _ref2.data;


                _this3.$toastr.s('Remanejamento efetuado com sucesso.');
                return _context2.abrupt('return', _this3.$router.push({ name: 'user_emendasparlamentares' }));

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2['catch'](9);
                _error$response = _context2.t0.response, _data = _error$response.data, status = _error$response.status;
                msg = '';
                _context2.t1 = status;
                _context2.next = _context2.t1 === 422 ? 25 : 27;
                break;

              case 25:
                msg = _data;
                return _context2.abrupt('break', 29);

              case 27:
                msg = 'Houve um erro ao efetuar o remanejamento. Tente novamente.';
                return _context2.abrupt('break', 29);

              case 29:
                return _context2.abrupt('return', _this3.$toastr.e(msg));

              case 30:
                _context2.prev = 30;

                _this3.toggleLoading();
                return _context2.finish(30);

              case 33:
                _errors$items = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_this3.errors.items, 1), error = _errors$items[0];

                _this3.setInputFocus(_this3.$refs[error.field]);

                return _context2.abrupt('return', _this3.$toastr.e(error.msg));

              case 36:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[9, 18, 30, 33]]);
      }))();
    },
    setInputFocus: function setInputFocus(element) {
      if (element instanceof HTMLElement) {
        element.focus();
      } else {
        element.$el.focus();
      }
    }
  },
  computed: {
    formValues: function formValues() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        id_origin: this.id
      }, this.$props, this.model);
    }
  }
});

/***/ }),

/***/ "IhWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_img_ods_logo_movimento_ods_logo_jpg__ = __webpack_require__("xuae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_css_img_ods_logo_movimento_ods_logo_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_css_img_ods_logo_movimento_ods_logo_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ModalMovimentoInfo',
    data: function data() {
        return {
            content: {
                instituicao: '',
                titulo: '',
                dataInicio: '',
                dataEncerramento: '',
                local: '',
                descricao: '',
                tipo_acao: '',
                totalParticipantes: 0,
                bandeiras: '',
                link_instrucoes: '',
                link_fotos: '',
                email: ''
            },
            logoODS: __WEBPACK_IMPORTED_MODULE_0__assets_css_img_ods_logo_movimento_ods_logo_jpg___default.a
        };
    },

    methods: {
        show: function show(content) {
            this.setContents(content);
            window.jQuery('#modal_movimento_info').modal('show');
        },
        setContents: function setContents(content) {
            this.content = content;
        },
        close: function close() {
            window.jQuery('#modal_movimento_info').modal('hide');
        },
        listBandeirasInfo: function listBandeirasInfo(bandeiras) {
            var _this = this;

            var array = bandeiras.toLowerCase() === 'todas' ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17] : bandeiras.split(/\D+/);

            return array.map(function (b) {
                return _this.getBandeiraInfo(b);
            });
        },
        getBandeiraInfo: function getBandeiraInfo(bandeira) {
            return {
                img: this.getBandeiraImg(bandeira),
                titulo: this.getBandeiraTitulo(bandeira)
            };
        },
        getBandeiraImg: function getBandeiraImg(bandeira) {
            return __webpack_require__("C4HD")("./" + bandeira + '.jpg');
        },
        getBandeiraTitulo: function getBandeiraTitulo(bandeira) {
            var titulos = ['1. Erradicação da pobreza', '2. Fome zero e agricultura sustentável', '3. Saúde e Bem-Estar', '4. Educação de qualidade', '5. Igualdade de género', '6. Água potável e saneamento', '7. Energia limpa e acessível', '8. Trabalho decente e crescimento económico', '9. Indústria, inovação e infraestrutura', '10. Redução das desigualdades', '11. Cidades e comunidades sustentáveis', '12. Consumo e produção responsáveis', '13. Ação contra a mudança global do clima', '14. Vida na água', '15. Vida terrestre', '16. Paz, justiça e instituições eficazes', '17. Parcerias e meios de implementação'];

            return titulos[Number(bandeira) - 1];
        }
    }
});

/***/ }),

/***/ "IjOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("y/xj");


var _mutations;



var INITIAL_STATE = [];
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1____["b" /* LOAD_CANDIDATOS */], function (state, payload) {
  state.candidatos = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1____["c" /* LOAD_VOTOS */], function (state, payload) {
  state.votos = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1____["d" /* RESET_ELEICOES */], function (state) {
  state.candidatos = INITIAL_STATE;
  state.votos = INITIAL_STATE;
}), _mutations);

/***/ }),

/***/ "IpL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Vincular unidades ao usuário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"custom-font"},[_vm._v("Selecione o usuário")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('v-select',{attrs:{"label":"nome","reduce":function (u) { return u.username; },"placeholder":_vm.users.length === 0
                  ? 'CARREGANDO A LISTA DE USUÁRIOS...'
                  : 'PESQUISE O NOME DO USUÁRIO AQUI...',"options":_vm.users,"selectOnTab":true},on:{"input":_vm.refreshLists},model:{value:(_vm.filters.sshd),callback:function ($$v) {_vm.$set(_vm.filters, "sshd", $$v)},expression:"filters.sshd"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('list',{ref:"listUnidadesVinculadas",attrs:{"show-empty":true,"show-print-button":false,"show-column-visibility-button":false,"load-on-start":false,"api-url":"escala/listar-unidade-vinculadas-sshd","title":"Unidades vinculadas","fields":_vm.columns,"appendParams":_vm.filters,"initial-page":_vm.paginaUnidadesVinculadas,"pageCollection":'escalasVincularUnidadeUsuario'},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Desassociar"},on:{"click":function($event){return _vm.desvincular(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'minus'}})],1)])]}}])},[_vm._v("\n          >\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('list',{ref:"listUnidadesDisponiveis",attrs:{"show-empty":true,"load-on-start":false,"show-print-button":false,"show-column-visibility-button":false,"api-url":"escala/listar-unidade-disponiveis-sshd","title":"Unidades disponíveis para vínculo","fields":_vm.columns,"appendParams":_vm.filters,"initial-page":_vm.paginaUnidadesDisponiveis,"pageCollection":'escalasVincularUnidadeUsuario'},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-success",attrs:{"title":"Associar","type":"button"},on:{"click":function($event){return _vm.vincular(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{attrs:{"id":"associar-filtros"}},[_c('div',{staticClass:"col-xs-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.filter),expression:"filters.filter"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Filtre aqui a unidade"},domProps:{"value":(_vm.filters.filter)},on:{"keyup":_vm.pesquisarUnidades,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "filter", $event.target.value)}}})])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J7Oz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-value container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 page-header"},[_c('div',{staticClass:"col-xs-12 col-sm-10"},[_c('h2',{staticClass:"small"},[_vm._v("\n              "+_vm._s(_vm.model.nome)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2"},[_c('ul',{attrs:{"id":"bandeiras"}},_vm._l((_vm.model.metas),function(i){return _c('li',{key:i.codigo},[_c('a',{attrs:{"href":i.link,"target":"_blank","title":i.titulo,"data-toggle":"popover","data-placement":"bottom","data-trigger":"hover","data-content":i.objetivo}},[_c('img',{attrs:{"src":_vm.concatPathImage(i.imagem_url)}})])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"reportTitle":_vm.model.DAD_DCNOME + '-valores',"append-params":_vm.params,"api-url":"dado/valor/list","title":"Listagem de valores","fields":_vm.columns,"pageCollection":'userValues'},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(_vm.params, props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1)])]}}])},[_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{
                  name: 'user_dado_valor_save',
                  params: {
                    DAD_IDDADO: _vm.params.DAD_IDDADO
                  }
                }}},[_c('font-awesome-icon',{attrs:{"icon":'pen-square'}}),_vm._v("\n                Adicionar valor\n              ")],1)],1)],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JA75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_DoughnutChart_js__ = __webpack_require__("xVH2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_colors_js__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common___ = __webpack_require__("vAZe");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    doughnut: __WEBPACK_IMPORTED_MODULE_4__components_common_DoughnutChart_js__["a" /* default */],
    PublicHeader: __WEBPACK_IMPORTED_MODULE_6__components_common___["a" /* PublicHeader */]
  },
  name: 'volta_aulas',
  data: function data() {
    return {
      escola: '',
      lista_escolas: [],
      informacoes: [],
      cores: [],
      baseModelo: { labels: [], datasets: [{ label: '', backgroundColor: [], data: [] }] },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            formatter: function formatter(value, ctx) {
              var sum = 0;
              var dataArr = ctx.chart.data.datasets[0].data;
              dataArr.map(function (data) {
                sum += data;
              });
              var percentage = (value * 100 / sum).toFixed(2) + "%";
              return percentage;
            },
            color: ['#000', '#FFF', '#000', '#FFF', '#FFF', '#FFF', '#000']
          }
        }
      }
    };
  },
  created: function created() {
    var pesquisa = this.$store.state.pesquisa;

    this.lista_escolas = pesquisa.escolas;
    this.cores = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__utils_colors_js__["a" /* default */].coresRGB));
    this.carregarCampos();
  },

  methods: {
    carregarCampos: function carregarCampos() {
      var _this = this;

      this.$store.dispatch('carregarEscolas').then(function () {
        var pesquisa = _this.$store.state.pesquisa;

        _this.lista_escolas = pesquisa.escolas;
      }).catch(function (e) {
        return console.log(e);
      });
    },
    listarDados: function listarDados() {
      var _this2 = this;

      this.$http.get('pesquisa/retorno-atividades-escolares/listar-dados/' + this.escola).then(function (response) {
        _this2.informacoes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    geraGraficoPorEntrevistado: function geraGraficoPorEntrevistado(responsavel, chave) {
      var informacoes = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.informacoes));
      var base = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.baseModelo);

      if (!Array.isArray(responsavel)) {
        responsavel = [responsavel];
      }

      if (informacoes.length) {
        var group = informacoes.filter(function (item) {
          return responsavel.indexOf(item['1. Você é']) > -1;
        }).reduce(function (acumulador, atual) {
          var result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, acumulador);
          var indice = atual[chave];
          result[indice] = result[indice] || 0;
          result[indice]++;
          return result;
        }, {});

        var chaves = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(group);
        var dados = [];

        for (var index = 0; index < chaves.length; index++) {
          dados.push(group[chaves[index]]);
        }

        base = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, base, {
          labels: chaves,
          datasets: [{
            backgroundColor: this.cores,
            data: dados
          }]
        });
      }

      return base;
    }
  },
  computed: {
    retornoResultadoGeral: function retornoResultadoGeral() {
      var informacoes = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.informacoes));
      var base = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.baseModelo);
      var array_base = ['7.b De acordo com a resolução n.61 do Governo do Estado de SP, as unidades escolares de educação básica poderão oferecer atividades presenciais de reforço e recuperação de aprendizagem, acolhimento emocional, orientação de estudos e tutoria, atividades esportivas e culturais, para um número reduzido de alunos e horas de permanência na escola, a partir de setembro. Diante disso, você pai/responsável autorizaria o seu filho a frequentar presencialmente a escola em setembro?', '6.c De acordo com a resolução n.61 do Governo do Estado de SP, as unidades escolares de educação básica poderão oferecer atividades presenciais de reforço e recuperação de aprendizagem, acolhimento emocional, orientação de estudos e tutoria, atividades esportivas e culturais, para um número reduzido de alunos e horas de permanência na escola, a partir de setembro. Diante disso, você profissional da educação se sente seguro em frequentar presencialmente a escola em setembro?'];
      var alunos_maiores = '7.a Aluno/estudante Maior de 18 anos, em relação à COVID-19, quando você retornaria às aulas presenciais?';
      var imediatamente = 'Imediatamente';
      var sim = 'Sim';

      if (informacoes.length) {
        var group = informacoes.reduce(function (acumulador, atual) {
          if (atual[array_base[0]] === sim || atual[array_base[1]] === sim) {
            acumulador.sim++;
          } else if (atual[alunos_maiores] === imediatamente) {
            acumulador.sim++;
          } else {
            acumulador.nao++;
          }

          return acumulador;
        }, { sim: 0, nao: 0 });

        var percentual = (group.sim / (group.sim + group.nao) * 100).toFixed(2);

        base = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, base, {
          labels: ['Sim', 'N\xE3o'],
          datasets: [{
            backgroundColor: this.cores,
            data: [group.sim, group.nao]
          }]
        });
      }

      return base;
    },
    retornoAlunoMaior: function retornoAlunoMaior() {
      return this.geraGraficoPorEntrevistado('Aluno/estudante maior de 18 anos', '7.a Aluno/estudante Maior de 18 anos, em relação à COVID-19, quando você retornaria às aulas presenciais?');
    },
    retornoPaiAluno: function retornoPaiAluno() {
      return this.geraGraficoPorEntrevistado('Pai/responsável por aluno menor de 18 anos', '9.b Pai e/ou responsável, em relação à COVID-19, quando você autorizaria o seu filho a retornar às aulas presenciais?');
    },
    retornoSetembroPai: function retornoSetembroPai() {
      return this.geraGraficoPorEntrevistado('Pai/responsável por aluno menor de 18 anos', '7.b De acordo com a resolução n.61 do Governo do Estado de SP, as unidades escolares de educação básica poderão oferecer atividades presenciais de reforço e recuperação de aprendizagem, acolhimento emocional, orientação de estudos e tutoria, atividades esportivas e culturais, para um número reduzido de alunos e horas de permanência na escola, a partir de setembro. Diante disso, você pai/responsável autorizaria o seu filho a frequentar presencialmente a escola em setembro?');
    },
    retornoOutubroPai: function retornoOutubroPai() {
      return this.geraGraficoPorEntrevistado('Pai/responsável por aluno menor de 18 anos', '8.b Sobre o retorno às aulas presenciais, previsto para outubro, você pai/responsável autorizaria o seu filho a frequentar presencialmente a escola?');
    },
    retornoProfissionalEducacao: function retornoProfissionalEducacao() {
      return this.geraGraficoPorEntrevistado(['Professor', 'Gestor, funcionário ou profissional ligado à educação'], '8.c Profissional da educação, em relação à COVID-19, quando você retornaria às aulas presenciais?');
    },
    retornoProfissionalSetembro: function retornoProfissionalSetembro() {
      return this.geraGraficoPorEntrevistado(['Professor', 'Gestor, funcionário ou profissional ligado à educação'], '6.c De acordo com a resolução n.61 do Governo do Estado de SP, as unidades escolares de educação básica poderão oferecer atividades presenciais de reforço e recuperação de aprendizagem, acolhimento emocional, orientação de estudos e tutoria, atividades esportivas e culturais, para um número reduzido de alunos e horas de permanência na escola, a partir de setembro. Diante disso, você profissional da educação se sente seguro em frequentar presencialmente a escola em setembro?');
    },
    retornoProfissionalOutubro: function retornoProfissionalOutubro() {
      return this.geraGraficoPorEntrevistado(['Professor', 'Gestor, funcionário ou profissional ligado à educação'], '7.c Sobre o retorno às aulas presenciais, previsto para outubro, você profissional da educação se sente seguro para frequentar presencialmente a escola?');
    }
  }
});

/***/ }),

/***/ "JB/+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Select__ = __webpack_require__("MGJx");
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Select: __WEBPACK_IMPORTED_MODULE_0__components_common_Select__["a" /* default */]
  },
  props: {
    value: {
      type: String
    }
  },
  created: function created() {
    this.generateReferences();
    if (this.value.length === 6) this.reference = this.value;
  },
  data: function data() {
    return {
      references: [],
      reference: null
    };
  },

  watch: {
    reference: function reference(value) {
      if (value) this.update();
    }
  },
  methods: {
    update: function update() {
      this.$emit('input', this.reference);
    },
    generateReferences: function generateReferences() {
      var currentYear = new Date().getFullYear();
      var currentMonth = new Date().getMonth();
      var labelOptions = { month: 'long', year: 'numeric' };
      var valueOptions = { month: '2-digit' };

      this.references.push({ label: "Selecione o mês de referência", value: null });

      for (var index = 0; index < 12; index++) {
        var date = new Date(currentYear, index, 1);
        var label = date.toLocaleString('pt-br', labelOptions);
        var value = '' + currentYear + date.toLocaleString('pt-BR', valueOptions);

        this.references.push({ label: label, value: value });
      }

      if (currentMonth === 11) {
        var nextYear = currentYear + 1;
        var _date = new Date(nextYear, 0, 1);
        var _label = _date.toLocaleString('pt-br', labelOptions);
        var _value = '' + nextYear + _date.toLocaleString('pt-BR', valueOptions);

        this.references.push({ label: _label, value: _value });
      }
    }
  }
});

/***/ }),

/***/ "JJxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Gestão de Compromissos")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"api-url":"planogoverno/compromisso/pendentes-cancelamento","report-title":"Meus Compromissos","fields":_vm.fields,"initial-page":1,"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Aceitar","type":"button"},on:{"click":function($event){return _vm.cancelar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font"},[_vm._v("Período")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.periodo),expression:"filtros.periodo"}],staticClass:"form-control select-selected",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "periodo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.periodos),function(value,index){return _c('option',{key:index,domProps:{"value":value}},[_vm._v("\n                                    "+_vm._s(value)+"\n                                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-4",staticStyle:{"padding-top":"15px"}},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.$refs.vuetable.refresh()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                                Filtrar\n                            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.resetFiltros()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                                Limpar Filtros\n                            ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n                    ")],1)])],2)],1),_vm._v(" "),_c('SidePlanoGoverno',{ref:"side",attrs:{"navs":_vm.sideConfig},on:{"aceitarRequisicao":_vm.aceitarRequisicao,"rejeitarRequisicao":_vm.rejeitarRequisicao}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JLTk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JNFZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header margem-titulo"},[_vm._v("Adicionar Usuário")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('form',{attrs:{"role":"form","id":"user_form"},on:{"submit":function($event){$event.preventDefault();return _vm.save()}}},[_c('fieldset',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-3 pad-right-0"},[_c('label',{class:[
                    'custom-font',
                    { 'is-danger': _vm.errors.has('usuario') }
                  ],attrs:{"for":"usuario"}},[_vm._v("Usuário")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.username),expression:"model.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"usuario",class:[
                      'form-control',
                      { 'is-danger': _vm.errors.has('usuario') }
                    ],attrs:{"name":"usuario","placeholder":"Usuário","type":"text"},domProps:{"value":(_vm.model.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"custom-font input-group-addon remove-background-color-border",staticStyle:{"background-color":"transparent","border-width":"0px"}},[_vm._v("Ou")])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('usuario')),expression:"errors.has('usuario')"}],staticClass:"is-danger"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('usuario'))+"\n                ")],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-3 pad-left-0"},[_c('label',{staticClass:"custom-font",attrs:{"for":"usuario"}},[_vm._v("SSHD")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.SSHD),expression:"SSHD"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.SSHD)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getUserBySSHD.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.SSHD=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",attrs:{"title":"Pesquisar o SSHD","type":"button"},on:{"click":_vm.getUserBySSHD}},[_c('font-awesome-icon',{attrs:{"icon":'search'}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{class:['form-group col-md-6']},[_c('label',{class:[
                    'custom-font',
                    { 'is-danger': _vm.errors.has('nome') }
                  ],attrs:{"for":"nome"}},[_vm._v("Nome do usuário")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.USU_NMUSUARIO),expression:"model.USU_NMUSUARIO"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome",class:[
                    'form-control',
                    { 'is-danger': _vm.errors.has('nome') }
                  ],attrs:{"name":"nome","placeholder":"Nome do usuário","type":"text"},domProps:{"value":(_vm.model.USU_NMUSUARIO)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "USU_NMUSUARIO", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('nome')),expression:"errors.has('nome')"}],staticClass:"is-danger"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('nome'))+"\n                ")],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{class:['form-group col-md-6']},[_c('label',{class:[
                    'custom-font',
                    { 'is-danger': _vm.errors.has('email') }
                  ],attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.USU_DCEMAIL),expression:"model.USU_DCEMAIL"},{name:"validate",rawName:"v-validate",value:('email'),expression:"'email'"}],ref:"email",class:[
                    'form-control',
                    { 'is-danger': _vm.errors.has('email') }
                  ],attrs:{"name":"email","placeholder":"email@santos.sp.gov.br","type":"text"},domProps:{"value":(_vm.model.USU_DCEMAIL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "USU_DCEMAIL", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"is-danger"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('email'))+"\n                ")],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{staticClass:"custom-font",attrs:{"for":"origem"}},[_vm._v("Origem (Somente para usuário externo)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.USU_DCORIGEM),expression:"model.USU_DCORIGEM"}],ref:"origem",staticClass:"form-control",attrs:{"name":"origem","placeholder":"Origem Ex: nome da organização","type":"text"},domProps:{"value":(_vm.model.USU_DCORIGEM)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "USU_DCORIGEM", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"panel panel-default"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body"},_vm._l((_vm.listaPerfil),function(perfil){return _c('div',{key:perfil.PER_IDPERFIL,staticClass:"form-group col-md-12"},[_c('label',[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedProfiles),expression:"checkedProfiles"}],attrs:{"type":"checkbox","name":"perfil"},domProps:{"value":perfil.PER_IDPERFIL,"checked":perfil.checked,"checked":Array.isArray(_vm.checkedProfiles)?_vm._i(_vm.checkedProfiles,perfil.PER_IDPERFIL)>-1:(_vm.checkedProfiles)},on:{"input":function (event) { return (perfil.checked = event.target.checked); },"change":function($event){var $$a=_vm.checkedProfiles,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=perfil.PER_IDPERFIL,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedProfiles=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedProfiles=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedProfiles=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(perfil.PER_DCPERFIL))])])]),_vm._v(" "),(perfil.PER_CDPERFIL.trim().toLowerCase() === 'temporario')?_c('div',[_c('div',{class:[
                            { 'has-error': _vm.errors.has('data_expiracao') }
                          ]},[_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[
                                    {
                                      'is-danger': _vm.errors.has(
                                        'data_expiracao_campo'
                                      )
                                    }
                                  ],attrs:{"icon":'calendar'}})],1),_vm._v(" "),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate.immediate",value:(
                                  'required_if:temporaryIsChecked'
                                ),expression:"\n                                  'required_if:temporaryIsChecked'\n                                ",modifiers:{"immediate":true}}],ref:"data_expiracao_campo",refInFor:true,staticClass:"form-control",attrs:{"name":"data_expiracao_campo","placeholder":"Data de expiração","maxlength":"20","mask":'##/##/####, ##:##:##',"type":"text","disabled":!_vm.checkedProfiles.includes(13)},model:{value:(_vm.data_expiracao_campo),callback:function ($$v) {_vm.data_expiracao_campo=$$v},expression:"data_expiracao_campo"}}),_vm._v(" "),_c('div',{class:[
                                  'input-group-addon custom-input-group-addon-count',
                                  {
                                    'is-danger': _vm.errors.has(
                                      'data_expiracao_campo'
                                    )
                                  }
                                ],domProps:{"textContent":_vm._s(14 - _vm.data_expiracao_campo.length)}})],1)])])]):_vm._e()])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n                  Salvar\n                ")],1)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('b',[_vm._v("Perfil")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JQ9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      required: true
    },
    header: {
      default: false
    }
  }
});

/***/ }),

/***/ "Jdug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("0xDb");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_4__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components__["b" /* Breadcrumb */],
    CriterioRemedio: __WEBPACK_IMPORTED_MODULE_4__components__["s" /* CriterioRemedio */],
    OpenMap: __WEBPACK_IMPORTED_MODULE_4__components__["t" /* OpenMap */]
  },
  beforeCreate: function beforeCreate() {
    var _$route$params = this.$route.params,
        remedio = _$route$params.remedio,
        detalhes = _$route$params.detalhes;

    if (!remedio && !detalhes) {
      this.$router.push('/aqui-tem-remedio');
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _$route$params2, remedio, unidade, detalhes, unidadesComRemedio;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _$route$params2 = _this.$route.params, remedio = _$route$params2.remedio, unidade = _$route$params2.unidade, detalhes = _$route$params2.detalhes, unidadesComRemedio = _$route$params2.unidadesComRemedio;


              if (unidade) {
                _this.unidade = unidade;
              } else {
                _this.unidade.unidade_saude = detalhes.replace(/\(-\)/g, '.');
              }

              _this.unidadesComRemedio = unidadesComRemedio || [];

              _this.getPosicaoMapa();

              _this.remedio = remedio || {};
              _context.next = 7;
              return _this.getRemediosUnidade();

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      carregando: {
        infoAtendimento: false,
        listaMedicamentos: false
      },
      remedio: {},
      unidade: {
        email: '',
        apelido: '',
        endereco_completo: '',
        telefone: '',
        observacao: ''
      },
      // informacoesUnidade: {},
      disponiveisUnidade: [],
      unidadesComRemedio: [],
      termoFiltro: '',
      coordenadas: {},
      zoom: 16,
      pins: [],
      icon: undefined,
      popupPoint: undefined
    };
  },

  methods: {
    capitalizeEachWord: __WEBPACK_IMPORTED_MODULE_6__utils__["f" /* capitalizeEachWord */],
    getPosicaoMapa: function getPosicaoMapa() {
      var _this2 = this;

      var _latLong = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["g" /* latLong */])(this.unidade.unidade_saude),
          lat = _latLong.lat,
          lng = _latLong.lng,
          nome = _latLong.nome;

      if (this.unidadesComRemedio.length) {
        var nomesUnidades = this.unidadesComRemedio.map(function (unidade, index) {
          return {
            unidade_saude: unidade.unidade_saude,
            disponivel: Number(unidade.saldo) > 0
          };
        });

        this.pins = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["h" /* latLongGroup */])(nomesUnidades);
      } else {
        var foreach = function foreach(_ref) {
          var lat = _ref.lat,
              lng = _ref.lng,
              title = _ref.nome;

          _this2.pins.push({
            position: {
              lat: lat,
              lng: lng
            },
            title: title
          });
        };

        __WEBPACK_IMPORTED_MODULE_6__utils__["i" /* COORDENADAS */].forEach(foreach);
      }

      this.coordenadas = { lat: lat, lon: lng };

      if (nome === 'santos-default') this.zoom = 10;
    },
    isUnavailable: function isUnavailable(remedio) {
      var disponibilidade = Number(remedio.saldo) === 0;
      return disponibilidade;
    },
    getDescricaoOrientacao: function getDescricaoOrientacao(remedio) {
      return __WEBPACK_IMPORTED_MODULE_4__components__["s" /* CriterioRemedio */].methods.getDescricaoOrientacao(remedio);
    },
    toggleLoading: function toggleLoading(key) {
      this.carregando[key] = !this.carregando[key];
    },
    getRemediosUnidade: function getRemediosUnidade() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.toggleLoading('listaMedicamentos');
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get('remedios/unidades/disponiveis', {
                  params: {
                    unidade_saude: _this3.unidade.unidade_saude
                  }
                }).then(function (response) {
                  var data = response.data;

                  _this3.disponiveisUnidade = data;

                  if (!_this3.unidade.email) {
                    var _data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(data, 1),
                        first = _data[0];

                    _this3.unidade.email = first.email;
                    _this3.unidade.bairro = first.bairro;
                    _this3.unidade.endereco_completo = first.endereco_completo;
                    _this3.unidade.endereco_nr = first.endereco_nr;
                    _this3.unidade.telefone = first.telefone;
                    _this3.unidade.apelido = first.apelido;
                    _this3.unidade.observacao = first.observacao;
                  }
                }).catch(function (error) {
                  console.log(error.response);
                }).finally(function () {
                  return _this3.toggleLoading('listaMedicamentos');
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },
  computed: {
    breadcrumb: function breadcrumb() {
      var links = [{ label: 'Remédio Fácil', link: '/remedio-facil' }];

      if (this.remedio.principio_ativo) {
        links.push({
          label: this.remedio.principio_ativo,
          named_link: {
            name: 'unidades-remedio',
            params: {
              principio: this.remedio.principio_ativo,
              remedio: this.remedio
            }
          }
        });
      }

      links.push({ label: this.unidade.unidade_saude });

      return links;
    },
    nomeUnidade: function nomeUnidade() {
      return this.unidade.apelido || this.unidade.unidade_saude;
    },
    infoEmail: function infoEmail() {
      var email = this.unidade.email;
      return email ? email.toLowerCase() : '----------';
    },
    infoTelefone: function infoTelefone() {
      return this.unidade.telefone || '----------';
    },
    infoUnidade: function infoUnidade() {
      return this.unidade.observacao ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["j" /* capitalize */])(this.unidade.observacao.toLowerCase()) : '----------';
    },
    infoEndereco: function infoEndereco() {
      return this.unidade.endereco_completo ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["f" /* capitalizeEachWord */])(this.unidade.endereco_completo.toLowerCase()) : '----------';
    },
    disponiveisUnidadeFiltered: function disponiveisUnidadeFiltered() {
      var _this4 = this;

      var filter = function filter(item) {
        return item.principio_ativo.toLowerCase().includes(_this4.termoFiltro.toLowerCase());
      };
      return this.disponiveisUnidade.filter(filter);
    }
  }
});

/***/ }),

/***/ "Jh32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'users',
  inject: ["showConfirm"],
  data: function data() {
    return {
      fields: [{
        name: 'username',
        sortField: 'username',
        title: 'Usuário',
        dataClass: 'align-left',
        filterable: true
      }, {
        name: 'USU_DCEMAIL',
        sortField: 'USU_DCEMAIL',
        title: 'Email',
        dataClass: 'align-left',
        filterable: true
      }, {
        name: 'USU_NMUSUARIO',
        sortField: 'USU_NMUSUARIO',
        title: 'Nome',
        dataClass: 'align-left',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_1__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  computed: {
    filtros: function filtros() {
      var filtros = this.$store.state.vuetableState.usuarios.filtros;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filtros);
    },

    pagina: {
      get: function get() {
        var usuarios = this.$store.state.vuetableState.usuarios;
        var pagina = usuarios.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'usuarios',
          value: value
        });
      }
    },
    username: {
      get: function get() {
        var usuarios = this.$store.state.vuetableState.usuarios;
        var username = usuarios.filtros.username;

        return username;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'username',
          collection: 'usuarios',
          value: value
        });
      }
    },
    USU_DCEMAIL: {
      get: function get() {
        var usuarios = this.$store.state.vuetableState.usuarios;
        var USU_DCEMAIL = usuarios.filtros.USU_DCEMAIL;

        return USU_DCEMAIL;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'USU_DCEMAIL',
          collection: 'usuarios',
          value: value
        });
      }
    },
    USU_NMUSUARIO: {
      get: function get() {
        var usuarios = this.$store.state.vuetableState.usuarios;
        var USU_NMUSUARIO = usuarios.filtros.USU_NMUSUARIO;

        return USU_NMUSUARIO;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'USU_NMUSUARIO',
          collection: 'usuarios',
          value: value
        });
      }
    }
  },
  methods: {
    editar: function editar(data) {
      this.$router.push({
        name: 'admin_users_save',
        params: {
          data: data
        }
      });
    },
    excluir: function excluir(data) {
      var dt = this.$refs.vuetable;
      data.type = 'USER';

      var x = data;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_2__request__["b" /* default */].delete(x, function () {
            dt.refresh();
          }, function () {
            console.log('houve um error ao tentar excluir este item, por favor tente novamente mais tarde!');
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      this.username = '';
      this.USU_DCEMAIL = '';
      this.USU_NMUSUARIO = '';
      this.$refs.vuetable.refresh();
    }
  }
});

/***/ }),

/***/ "JkKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    perPage: [Number],
    options: {
      type: Array,
      default: function _default() {
        return [10, 25, 50, 100, 'Todos'];
      }
    }
  }
});

/***/ }),

/***/ "Jn6W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JrGC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectFuncionario_vue__ = __webpack_require__("T/Qv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a76eeb3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectFuncionario_vue__ = __webpack_require__("8eyM");
function injectStyle (ssrContext) {
  __webpack_require__("H1vy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a76eeb3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectFuncionario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a76eeb3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectFuncionario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Juz5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/13.0d5cc74.jpg";

/***/ }),

/***/ "Jwkc":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ "K9io":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Vereadores")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Lista de vereadores","report-title":"Vereadores","initial-page":_vm.pagina,"api-url":"vereador","fields":_vm.fields,"pageCollection":'vereadores',"append-params":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"primary",attrs:{"for":"nome_filter"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nome),expression:"nome"}],staticClass:"form-control",attrs:{"type":"text","name":"nome_filter"},domProps:{"value":(_vm.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'user_salvar_vereador' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v("\n              Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KEBQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KF8/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tag-save',
  data: function data() {
    return {
      model: {
        TAG_DCTAG: ''
      }
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var params = this.$router.history.current.params;
    if (params.hasOwnProperty('id')) {
      this.model.TAG_IDTAG = params.id;
      this.model.TAG_DCTAG = params.name;
    }
    this.$refs.tag.focus();
  },

  methods: {
    saveSuccess: function saveSuccess(result) {
      this.model.TAG_DCTAG = '';
      this.$toastr.s('Sua tag foi salva com sucesso.');
      this.$router.push('list');
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
    },
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.$refs[_this.$validator.errors.items[0].field].focus();
          _this.$toastr.e(_this.$validator.errors.items[0].msg);
          return;
        }

        __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].post('tags/save', _this.model).then(_this.saveSuccess).catch(_this.saveFail);
      });
    }
  }
});

/***/ }),

/***/ "KIXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-group', _vm.cssClass]},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),((_vm.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],ref:_vm.name,class:['form-control', { 'is-danger': _vm.error.length > 0 }],attrs:{"name":_vm.name,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.inputVal)?_vm._i(_vm.inputVal,null)>-1:(_vm.inputVal)},on:{"change":function($event){var $$a=_vm.inputVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inputVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inputVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inputVal=$$c}}}}):((_vm.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],ref:_vm.name,class:['form-control', { 'is-danger': _vm.error.length > 0 }],attrs:{"name":_vm.name,"type":"radio"},domProps:{"checked":_vm._q(_vm.inputVal,null)},on:{"change":function($event){_vm.inputVal=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],ref:_vm.name,class:['form-control', { 'is-danger': _vm.error.length > 0 }],attrs:{"name":_vm.name,"type":_vm.type},domProps:{"value":(_vm.inputVal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputVal=$event.target.value}}}),_vm._v(" "),_c('message',{attrs:{"name":_vm.name,"show":_vm.error.length > 0,"erro":_vm.error}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KOBN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KPqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Publicar_vue__ = __webpack_require__("LTYA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c740ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Publicar_vue__ = __webpack_require__("F+B4");
function injectStyle (ssrContext) {
  __webpack_require__("WgM/")
  __webpack_require__("BRYr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03c740ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Publicar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c740ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Publicar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KRwM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Import_vue__ = __webpack_require__("pApq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0319401a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Import_vue__ = __webpack_require__("kkWO");
function injectStyle (ssrContext) {
  __webpack_require__("k/S7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Import_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0319401a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Import_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KThS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Datepicker__ = __webpack_require__("eOZt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dados-valor-save',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_1__components_common_Datepicker__["a" /* default */] },
  data: function data() {
    return {
      carregando: false,
      title: 'valor',
      dadoTipo: '',
      dadoNome: 'Carregando o nome do dado...',
      dadoPeriodicidade: '',
      modelData: '',
      modelValue: '',
      modelId: '',
      modelDadoId: '',
      modelObservacao: ''
    };
  },

  computed: {
    type: function type() {
      return this.isUpdate ? 'Editar' : 'Adicionar';
    },
    dateFormat: function dateFormat() {
      if (!this.modelData) return null;
      return this.modelData.getFullYear() + '-' + (this.modelData.getMonth() + 1) + '-' + this.modelData.getDate();
    },
    model: function model() {
      var m = {
        DAD_IDDADO: this.modelDadoId,
        DVA_DTDADOVALOR: this.dateFormat,
        DVA_DLOBSERVACAO: this.modelObservacao,
        DVA_IDDADOVALOR: this.modelId
      };

      if (this.isValueInteiro || this.isValueDecimal) {
        m.DVA_VLDADOVALOR = this.modelValue;
      } else {
        m.DVA_DLDADOVALOR = this.modelValue;
      }

      return m;
    },
    isUpdate: function isUpdate() {
      return !!this.$router.currentRoute.params.DVA_IDDADOVALOR;
    },
    isValueInteiro: function isValueInteiro() {
      if (this.dadoTipo) {
        return this.dadoTipo === 'I';
      }
      return false;
    },
    isValueDecimal: function isValueDecimal() {
      if (this.dadoTipo) {
        return this.dadoTipo === 'D';
      }
      return false;
    },
    isValueTexto: function isValueTexto() {
      if (this.dadoTipo) {
        return this.dadoTipo === 'T';
      }
      return false;
    }
  },
  watch: {
    modelValue: function modelValue(val, old) {
      if (this.isValueInteiro) {
        if (isNaN(val) && val !== '-') {
          this.modelValue = old;
        }
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.loadDado();

    if (this.isUpdate) {
      this.loadValue();
    }
  },
  mounted: function mounted() {
    var _this = this;

    var r = this.$refs;
    if (this.isUpdate) {
      setTimeout(function () {
        if (_this.isValueDecimal || _this.isValueInteiro) {
          if (_this.isValueDecimal) {
            r.valor.$el.focus();
          } else {
            r.valor.focus();
          }
        } else {
          r.resposta.focus();
        }
      }, 500);
    }
  },

  methods: {
    handleLoading: function handleLoading() {
      this.carregando = !this.carregando;
    },
    loadDado: function loadDado() {
      var _this2 = this;

      var DAD_IDDADO = this.$router.currentRoute.params.DAD_IDDADO;

      this.handleLoading();
      __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].get('dado/get/' + DAD_IDDADO).then(function (response) {
        return _this2.setDado(response.data);
      }).catch(function (error) {
        return console.log(error);
      }).finally(this.handleLoading);
    },
    setDado: function setDado(_ref) {
      var codigo = _ref.codigo,
          tipoValor = _ref.tipoValor,
          nome = _ref.nome,
          periodicidade = _ref.periodicidade;

      this.modelDadoId = codigo;
      this.dadoTipo = tipoValor;
      this.dadoNome = nome;
      this.dadoPeriodicidade = periodicidade.descricao;

      if (!this.isUpdate) this.setDateDefault();
    },
    setDateDefault: function setDateDefault() {
      var now = new Date();
      var month = void 0,
          periodoNumber = void 0;

      if (this.dadoPeriodicidade.toLowerCase() === 'anual') this.modelData = new Date(now.getFullYear() - 1, 11, 31);else {
        switch (this.dadoPeriodicidade.toLowerCase()) {
          case 'semestral':
            periodoNumber = 6;
            break;
          case 'quadrimestral':
            periodoNumber = 4;
            break;
          case 'trimestral':
            periodoNumber = 3;
            break;
          case 'bimestral':
            periodoNumber = 2;
            break;
          case 'mensal':
            periodoNumber = 1;
            break;
        }

        var periodoAtual = periodoNumber > 1 ? Math.floor((now.getMonth() + 1) / periodoNumber) : now.getMonth();

        if (periodoAtual === 0) this.modelData = new Date(now.getFullYear() - 1, 11, 31);else {
          month = periodoNumber * periodoAtual;
          var date = new Date(now.getFullYear(), month, 1);
          date.setDate(date.getDate() - 1);
          this.modelData = date;
        }
      }
    },
    loadValue: function loadValue() {
      var _this3 = this;

      var DVA_IDDADOVALOR = this.$router.history.current.params.DVA_IDDADOVALOR;

      this.handleLoading();
      __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].post('dado/valor/get', { DVA_IDDADOVALOR: DVA_IDDADOVALOR }).then(function (_ref2) {
        var data = _ref2.data;

        _this3.setValue(data.data);
      }).catch(function (error) {
        // console.log(error.response)
        _this3.$toastr.e('Houve um erro no carregamento das informações, tente novamente.');
      }).finally(this.handleLoading);
    },
    setValue: function setValue(data) {
      var DVA_IDDADOVALOR = data.DVA_IDDADOVALOR,
          DVA_DTDADOVALOR = data.DVA_DTDADOVALOR,
          DVA_VLDADOVALOR = data.DVA_VLDADOVALOR,
          DVA_DLDADOVALOR = data.DVA_DLDADOVALOR,
          DVA_DLOBSERVACAO = data.DVA_DLOBSERVACAO,
          dado = data.dado;


      this.modelId = DVA_IDDADOVALOR;
      this.modelData = new Date(DVA_DTDADOVALOR);

      this.modelDadoId = dado.DAD_IDDADO;
      this.dadoTipo = dado.DAD_CDTIPOVALOR;
      this.dadoNome = dado.DAD_DCNOME;

      if (this.dadoTipo === 'D' || this.dadoTipo === 'I') {
        this.modelValue = this.dadoTipo ? parseInt(DVA_VLDADOVALOR) : parseFloat(DVA_VLDADOVALOR);
      } else {
        this.modelValue = DVA_DLDADOVALOR;
      }
      this.modelObservacao = DVA_DLOBSERVACAO === null ? '' : DVA_DLOBSERVACAO;
    },
    getValueDefault: function getValueDefault() {
      return this.isValueInteiro || this.isValueDecimal ? 0 : '';
    },
    saveSuccess: function saveSuccess(result) {
      var $toastr = this.$toastr,
          $router = this.$router;
      var DAD_IDDADO = this.$router.currentRoute.params.DAD_IDDADO;


      $toastr.s('Valor foi salvo com sucesso.');

      $router.push({
        name: 'admin_dado_valor_list',
        params: { DAD_IDDADO: DAD_IDDADO }
      });
    },
    saveFail: function saveFail(_ref3) {
      var response = _ref3.response;

      // this.$toastr.e(
      //   'Houve uma falha ao tentar salvar este item, Tente novamente daqui alguns minutos!'
      // )
      this.$toastr.e(response.data.msg);
    },
    save: function save() {
      var _this4 = this;

      var $validator = this.$validator,
          $refs = this.$refs,
          $toastr = this.$toastr,
          model = this.model,
          saveSuccess = this.saveSuccess,
          saveFail = this.saveFail;


      $validator.validateAll().then(function (result) {
        if (!result) {
          $refs[$validator.errors.items[0].field].focus();
          $toastr.e($validator.errors.items[0].msg);
          return;
        }

        _this4.handleLoading();
        __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].post('dado/valor/save', model).then(saveSuccess).catch(saveFail).finally(_this4.handleLoading);
      });
    },
    concatPathImage: function concatPathImage(file) {
      return this.$root.$data.imgUrl + file + '?' + new Date().getTime();
    },
    configMoney: function configMoney() {
      return {
        decimal: ',',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      };
    },
    setFocus: function setFocus(input) {
      this.$refs[input].focus();
    }
  }
});

/***/ }),

/***/ "KWRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  name: 'dados-valor',
  data: function data() {
    return {
      type: 'DADOVALOR',
      params: { DAD_IDDADO: 0 },
      columns: [{
        name: 'DVA_DTDADOVALOR',
        sortField: 'DVA_DTDADOVALOR',
        title: 'Data',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'USER',
        sortField: 'USER',
        title: 'Usuário',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'VALOR',
        sortField: 'VALOR',
        title: 'Valor',
        dataClass: 'align-middle',
        filterable: true,
        callback: function callback(value) {
          return isNaN(value) ? value : new Intl.NumberFormat('pt-br', {
            minimumFractionDigits: 2
          }).format(value);
        }
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }],
      model: {
        DAD_DCNOME: '',
        DAD_DSDADO: '',
        DAD_DLFONTE: '',
        metas: []
      }
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    var me = this;
    me.params = me.$router.history.current.params;

    __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('dado/get/' + me.params.DAD_IDDADO).then(function (response) {
      me.model = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    excluir: function excluir(data) {
      var _this = this;

      var dt = this.$refs.vuetable;
      data.type = this.type;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('dado/valor/delete', data).then(function () {
            _this.$toastr.s('Valor excluído com sucesso!');
            dt.refresh();
          }).catch(function (error) {
            console.log(error.response);
            _this.$toastr.e('Houve um error ao tentar excluir este item, por favor tente novamente mais tarde.');
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    concatPathImage: function concatPathImage(file) {
      return this.$root.$data.imgUrl + file + '?' + new Date().getTime();
    }
  },
  updated: function updated() {
    window.jQuery('[data-toggle="popover"]').popover({});
  }
});

/***/ }),

/***/ "KZIV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PorExame_vue__ = __webpack_require__("LE/y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c02f890_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PorExame_vue__ = __webpack_require__("tR7Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PorExame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c02f890_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PorExame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ka5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Subgrupos")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Listagem de Subgrupos","api-url":_vm.apiUrl,"report-title":"Subgrupos","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'subgrupos',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"nome_filter"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nome),expression:"nome"}],staticClass:"form-control",attrs:{"type":"text","name":"nome_filter"},domProps:{"value":(_vm.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"grupo_filter"}},[_vm._v("Grupo")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.grupo_codigo),expression:"grupo_codigo"}],ref:"grupo_codigo",staticClass:"form-control select-selected",attrs:{"name":"grupo_codigo"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.grupo_codigo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":""}},[_vm._v("Todas")]),_vm._v(" "),_vm._l((_vm.grupos),function(p){return _c('option',{key:p.codigo,domProps:{"value":p.codigo}},[_vm._v("\n                      "+_vm._s(p.nome)+"\n                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'user_material_subgrupo_save' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v("\n              Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KfTt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ki+E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("yaaI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262ab87b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("6SM7");
function injectStyle (ssrContext) {
  __webpack_require__("bRzK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-262ab87b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262ab87b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ki62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("0xDb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      default: {
        namedRoute: '#',
        nome: 'titulo',
        icon: 'ico-servidor.svg',
        valor: 0
      }
    };
  },

  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_1__utils__["e" /* formatarMoeda */]
  },
  computed: {
    fields: function fields() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.default, this.item);
    }
  }
});

/***/ }),

/***/ "KmBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kro4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KyBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListaCandidatos_vue__ = __webpack_require__("tjMu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f08cc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListaCandidatos_vue__ = __webpack_require__("fxU9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListaCandidatos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f08cc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListaCandidatos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L+8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_papaparse__ = __webpack_require__("afOB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__request__ = __webpack_require__("OOvn");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'compromisso-importar',
  data: function data() {
    return {
      periodo: '',
      periodos: ['2025-2028'],
      compromissosValidos: [],
      compromissosInvalidos: [],
      listas: {
        secretarias: [],
        autarquias: []
      }
    };
  },
  created: function created() {
    this.loadUnidades();
  },

  methods: {
    loadUnidades: function loadUnidades() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, secretarias, _ref2, autarquias;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('listar-secretarias');

              case 3:
                _ref = _context.sent;
                secretarias = _ref.data.data;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('listar-autarquias');

              case 7:
                _ref2 = _context.sent;
                autarquias = _ref2.data.data;


                _this.listas.secretarias = secretarias;
                _this.listas.autarquias = autarquias;
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                _this.$toastr.e('Erro ao carregar unidades. Verifique sua conexão e tente novamente.');

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 13]]);
      }))();
    },
    extrairUnidades: function extrairUnidades(comp) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var uniqueUnidades, _ref3, data, status, unidadesMap;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (comp.length) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                uniqueUnidades = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(comp.map(function (item) {
                  return item.unidade_executora;
                }))));
                _context2.prev = 3;
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('unidade-organizacional/siglas', {
                  params: { siglas: uniqueUnidades }
                });

              case 6:
                _ref3 = _context2.sent;
                data = _ref3.data;
                status = _ref3.status;

                if (!(status !== 200)) {
                  _context2.next = 12;
                  break;
                }

                _this2.$toastr.e('Não foi possível validar as unidades do servidor.');
                return _context2.abrupt('return');

              case 12:
                unidadesMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(data.map(function (unidade) {
                  return [unidade.sigla, unidade.nome];
                }));


                comp.forEach(function (compromisso) {
                  if (unidadesMap.has(compromisso.unidade_executora)) {
                    compromisso.nome_unidade_executora = unidadesMap.get(compromisso.unidade_executora);
                    _this2.compromissosValidos.push(compromisso);
                  } else {
                    compromisso.nova_unidade_executora = '';
                    _this2.compromissosInvalidos.push(compromisso);
                  }
                });
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](3);

                console.error('Falha ao buscar unidades:', _context2.t0);
                _this2.$toastr.e('Erro ao buscar unidades. Verifique sua conexão e tente novamente.');

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[3, 16]]);
      }))();
    },
    handleFile: function handleFile(event) {
      var _this3 = this;

      var file = event.target.files[0];
      if (!file) return;

      this.reset();

      __WEBPACK_IMPORTED_MODULE_5_papaparse___default.a.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: function complete(result) {
          var compromissosDoArquivo = result.data.map(function (row) {
            return {
              unidade_executora: row['unidade'],
              descritivo: row['compromisso'],
              responsavel_sshd: row['responsavel']
            };
          });
          _this3.extrairUnidades(compromissosDoArquivo);
        }
      });
    },
    corrigirUnidade: function corrigirUnidade(item, index) {
      var novaSigla = item.nova_unidade_executora;
      var todasUnidades = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.listas.secretarias), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.listas.autarquias));
      var unidadeSelecionada = todasUnidades.find(function (u) {
        return u.sigla === novaSigla;
      });

      if (unidadeSelecionada) {
        item.unidade_executora = novaSigla;
        item.nome_unidade_executora = unidadeSelecionada.nome;

        delete item.nova_unidade_executora;

        this.compromissosValidos.push(item);
        this.compromissosInvalidos.splice(index, 1);

        this.$toastr.s('Unidade corrigida com sucesso.');
      }
    },
    reset: function reset() {

      if (this.$refs.file) {
        this.$refs.file.value = '';
      }

      this.compromissosValidos = [];
      this.compromissosInvalidos = [];
    },
    salvar: function salvar() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var periodo, compromissos, _ref4, status;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!_this4.periodo || !_this4.compromissosValidos.length)) {
                  _context3.next = 3;
                  break;
                }

                _this4.$toastr.e('Selecione o período e carregue um arquivo válido.');
                return _context3.abrupt('return');

              case 3:
                periodo = _this4.periodo;
                compromissos = _this4.compromissosValidos;
                _context3.next = 7;
                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].post('planogoverno/compromisso', { periodo: periodo, compromissos: compromissos });

              case 7:
                _ref4 = _context3.sent;
                status = _ref4.status;

                if (!(status != 201)) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt('return', _this4.$toastr.e('Houve um problema na importação dos compromissos, tente novamente daqui a pouco!'));

              case 11:

                _this4.$toastr.s('Compromissos importados com sucesso.');
                _this4.reset();

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  }
});

/***/ }),

/***/ "L+UB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginModal',
  data: function data() {
    return {
      model: {
        username: '',
        password: '',
        usuarioExterno: false
      },
      refresh: false,
      requestPendente: false,
      usernameNoEdit: ""
    };
  },
  mounted: function mounted() {
    var params = this.$route.params;
    if (params.errorMsg) {
      this.$toastr.e(params.errorMsg);
    }
  },

  computed: {
    control: function control() {
      return window.jQuery('#modal_login');
    },
    payload: function payload() {
      var username = this.usernameNoEdit;
      var password = this.model.password;


      return { username: username, password: password };
    }
  },
  methods: {
    login: function login() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        _this.requestPendente = true;
        if (!result) {
          _this.requestPendente = false;
          _this.$refs[_this.$validator.errors.items[0].field].focus();
          _this.$toastr.e('Verifique os campos obrigatórios');
          return;
        }
        _this.$store.dispatch('tryLogin', _this.payload).then(function (response) {
          _this.requestPendente = false;
          _this.$toastr.s('Login efetuado com sucesso.');
          _this.hide();
          if (_this.refresh) {
            _this.$router.go(0);
          }
        }).catch(function (_ref) {
          var data = _ref.data;

          _this.requestPendente = false;
          _this.errorMsg = Array.isArray(data) ? data[0] : data;
          _this.model.password = '';
          _this.$toastr.e(_this.errorMsg);
          _this.$refs.password.focus();
        });
      });
    },
    show: function show() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.model.username = this.$store.state.user.username;
      this.usernameNoEdit = this.model.username;
      this.control.modal('show');
      this.refresh = refresh;
    },
    hide: function hide() {
      this.control.modal('hide');
    },
    esconder: function esconder() {
      router.app.$refs.loginModal.hide();
    }
  }
});

/***/ }),

/***/ "L8FY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LE/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("bGai");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ProcedimentosSaude: __WEBPACK_IMPORTED_MODULE_0__components__["k" /* ProcedimentosSaude */] },
  data: function data() {
    return {
      exame: '',
      urls: {
        espera: 'procedimentos-saude/lista-exames',
        agendados: 'procedimentos-saude/lista-exames-agendados'
      }
    };
  },
  created: function created() {
    var exame = this.$route.params.exame;

    this.exame = exame;
  },

  computed: {
    breadcrumb: function breadcrumb() {
      return [{
        label: 'Minha Saúde',
        named_link: { name: 'procedimentos_saude' }
      }, {
        label: this.exame
      }];
    }
  }
});

/***/ }),

/***/ "LTYA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_DataTablePublic__ = __webpack_require__("+Mmc");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ["showConfirm"],
  data: function data() {
    return {
      title: 'Publicar escalas',
      datatable: {
        columnID: 'id',
        columns: [{
          name: 'colaborador_nome',
          title: 'Colaboradores',
          dataClass: 'align-middle text-capitalize',
          filterable: true
        }, {
          name: 'colaborador_cargo',
          title: 'Cargo',
          dataClass: 'align-middle text-capitalize',
          filterable: true
        }, {
          name: 'plantao_total',
          title: 'Qtde Plantoes',
          titleClass: 'text-center',
          dataClass: 'align-middle text-center'
        }, {
          name: '__slot:column',
          title: 'Horários | Dias'
        }]
      },
      escalaLabel: "Selecione a escala",
      escalaId: null,
      escalas: [],
      escalaItens: [],
      observacao: null
    };
  },

  components: {
    DataTablePublic: __WEBPACK_IMPORTED_MODULE_1__components_common_DataTablePublic__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.loadEscalas();
  },

  computed: {
    acaoIndisponivel: function acaoIndisponivel() {
      return this.escalaId === null;
    }
  },
  methods: {
    loadEscalas: function loadEscalas() {
      var _this = this;

      this.uorLabel = 'Carregando as escalas...';

      __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].get('escala/listar-escala-publicacao').then(function (_ref) {
        var data = _ref.data;

        _this.escalas = data.map(function (_ref2) {
          var codigo = _ref2.id,
              uor_sigla = _ref2.uor_sigla,
              referencia_descricao = _ref2.referencia_descricao;

          return { codigo: codigo, label: referencia_descricao + ' | ' + uor_sigla };
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    loadEscala: function loadEscala() {
      var _this2 = this;

      var escalaId = this.escalaId;

      if (escalaId == null) {
        this.escalas = [];
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].post('escala/listar-disponiveis-publicacao', { id: escalaId }).then(function (response) {
        _this2.escalaItens = response.data;
        _this2.loadObservacao();
      }).catch(function (e) {
        console.log(e);
      });
    },
    loadObservacao: function loadObservacao() {
      var _this3 = this;

      this.observacao = "Carregando...";

      __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].get('escala/observacao?id=' + this.escalaId).then(function (response) {
        _this3.observacao = response.data;
      }).catch(function (e) {
        console.log(e);
      });
    },
    publicar: function publicar() {
      this.alert({
        url: 'escala/publicar',
        successMessage: 'Escala foi publicada com sucesso!',
        errorMessage: 'Houve uma falha ao tentar publicar a escala, Tente novamente daqui alguns minutos!',
        confirmMessage: 'Deseja realmente publicar está escala?'
      });
    },
    devolver: function devolver() {
      this.alert({
        url: 'escala/devolver',
        successMessage: 'Escala foi devolvida com sucesso!',
        errorMessage: 'Houve uma falha ao tentar devolver a escala, Tente novamente daqui alguns minutos!',
        confirmMessage: 'Deseja realmente devolver está escala?'
      });
    },
    alert: function alert(_ref3) {
      var _this4 = this;

      var url = _ref3.url,
          successMessage = _ref3.successMessage,
          errorMessage = _ref3.errorMessage,
          confirmMessage = _ref3.confirmMessage;

      if (this.escalaId === null) return;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].post(url, { id: _this4.escalaId }).then(function () {
            _this4.$toastr.s(successMessage);
            _this4.reset();
          }).catch(function (error) {
            _this4.escala = null;
            _this4.$toastr.e(errorMessage);
            _this4.escalas = [];
            console.log(error.response);
          });
        }
      };
      this.showConfirm(confirmMessage, config);
    },
    reset: function reset() {
      this.escalaId = null, this.observacao = null;
      this.escalaItens = [];
      this.loadEscalas();
    }
  }
});

/***/ }),

/***/ "LWU+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return user; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__("VKxC");


var user = {
  state: function state() {
    return {};
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["a" /* default */],
  actions: {}
};

/***/ }),

/***/ "LXnX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cargos_vue__ = __webpack_require__("zA1L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_659e6e84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cargos_vue__ = __webpack_require__("5t1y");
function injectStyle (ssrContext) {
  __webpack_require__("m0wa")
  __webpack_require__("lGBC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-659e6e84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cargos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_659e6e84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cargos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LYAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.entradaIsEmpty)?_c('div',[_c('i',{staticClass:"fa fa-arrow-circle-right fa-lg",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(_vm.time.entrada))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),(_vm.saidaIsEmpty)?_c('div',[_c('i',{staticClass:"fa fa-arrow-circle-right fa-lg",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(_vm.time.saida))]),_vm._v(" "),_c('button',{on:{"click":_vm.click}},[_vm._v("\n    ×\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LZ76":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SelectFuncionario__ = __webpack_require__("JrGC");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'plano-governo-save',
  inject: ["showConfirm"],
  components: {
    SelectFuncionario: __WEBPACK_IMPORTED_MODULE_4__components_SelectFuncionario__["a" /* default */]
  },
  data: function data() {
    return {
      listas: {
        secretarias: [],
        autarquias: [],
        metas: [],
        status: ['Não Iniciado', 'Em andamento', 'Concluído', 'Cancelado'],
        periodos: ['2017-2020', '2021-2024', '2025-2028'],
        funcionarios: []
      },
      model: {
        titulo: '',
        descricao: '',
        periodo: '',
        unidade_executora: '',
        responsavel_sshd: ''
      },
      datetime: '?' + new Date().getTime()
    };
  },
  created: function created() {
    this.loadUnidades();
    this.loadFuncionarios();
  },
  mounted: function mounted() {
    this.$refs.periodo.focus();
  },

  computed: {
    isUpdate: function isUpdate() {
      return this.model.hasOwnProperty('codigo');
    },
    isAdd: function isAdd() {
      return !this.isUpdate;
    },
    urlToSave: function urlToSave() {
      return this.isUpdate ? 'planogoverno/update' : 'planogoverno/add';
    },
    selecionaMetas: function selecionaMetas() {
      return this.listas.metas.filter(function (i) {
        return i.selected;
      }).map(function (i) {
        return i.codigo;
      });
    }
  },
  methods: {
    toogleshow: function toogleshow(e) {
      e.selected = !e.selected;
    },
    saveSuccess: function saveSuccess(result) {
      this.$router.push({ name: 'user_planogoverno' });
      this.$toastr.s('O plano de governo foi salvo com sucesso.');
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
    },
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(result) {
          var campoComErro, msg, response;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (result) {
                    _context.next = 7;
                    break;
                  }

                  campoComErro = _this.$validator.errors.items[0].field;

                  // se for o select personalizado, foca o input interno dele

                  if (campoComErro === 'responsavel_sshd') {
                    _this.$refs.selectFuncionario.$el.querySelector('input').focus();
                  } else {
                    _this.$refs[campoComErro].focus();
                  }

                  msg = _this.$validator.errors.items[0].msg;

                  if (campoComErro === 'descricao') {
                    msg = msg.replace('descricao', 'Descrição');
                  }

                  _this.$toastr.e(msg);
                  return _context.abrupt('return');

                case 7:
                  _context.next = 9;
                  return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].post('planogoverno/compromisso', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.model));

                case 9:
                  response = _context.sent;

                  if (!(response.status != 201)) {
                    _context.next = 12;
                    break;
                  }

                  return _context.abrupt('return', _this.saveFail());

                case 12:
                  return _context.abrupt('return', _this.saveSuccess());

                case 13:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    concatPathImage: function concatPathImage(file) {
      return this.$root.$data.imgUrl + file + this.datetime;
    },
    loadFuncionarios: function loadFuncionarios() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, data, status;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('funcionario');

              case 2:
                _ref2 = _context2.sent;
                data = _ref2.data;
                status = _ref2.status;

                if (!(status != 200)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', _this2.$toastr.e('Houve um erro ao tentar carregar os funcionários!'));

              case 7:

                _this2.listas.funcionarios = data;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadUnidades: function loadUnidades() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref3, secretarias, _ref4, autarquias;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('listar-secretarias');

              case 2:
                _ref3 = _context3.sent;
                secretarias = _ref3.data.data;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('listar-autarquias');

              case 6:
                _ref4 = _context3.sent;
                autarquias = _ref4.data.data;


                _this3.listas.secretarias = secretarias;
                _this3.listas.autarquias = autarquias;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),

/***/ "LZZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("sLGZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b340b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("Z1Zy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15b340b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LjSF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    total: {
      type: Number,
      required: true
    },
    value: {
      type: Number
    }
  },
  data: function data() {
    return {
      qtPaginas: Math.ceil(this.total / 100),
      test: this.total / 100
    };
  },

  methods: {
    firstPage: function firstPage() {
      this.inputVal = 1;
    },
    lastPage: function lastPage() {
      this.inputVal = this.qtPaginas;
    },
    prevPage: function prevPage() {
      this.inputVal -= 1;
    },
    nextPage: function nextPage() {
      this.inputVal += 1;
    }
  },
  computed: {
    options: function options() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(this.qtPaginas).keys()).map(function (item) {
        return item + 1;
      });
    },

    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  }
});

/***/ }),

/***/ "Llmj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LrGW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pesquisa; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__("MhY8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("Ux1m");



var pesquisa = {
  state: function state() {
    return {};
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["a" /* mutations */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actions */]
};

/***/ }),

/***/ "LrMQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.1080e5a.jpg";

/***/ }),

/***/ "LyRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{attrs:{"id":"menu"}},[_c('nav',{staticClass:"navbar navbar-default navbar-static-top",attrs:{"role":"navigation"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"small left"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',[_vm._v("Dados Abertos")])])],1)]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid",attrs:{"id":"conteudo"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_vm._v(" "),_c('footer',[_c('rodape')],1),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"small right"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"https://www.santos.sp.gov.br/"}},[_c('img',{attrs:{"src":__webpack_require__("tz3W"),"height":"40","alt":"Logo Prefeitura Municipal de Santos"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('noscript',[_c('p',[_vm._v("Este site requer JavaScript para funcionar corretamente. Por favor, ative-o nas configurações do seu navegador.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M2Hz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v("\n      "+_vm._s(_vm.dadoNome)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('data') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Data")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'calendar'}})],1),_vm._v(" "),_c('datepicker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"data",attrs:{"name":"data"},model:{value:(_vm.modelData),callback:function ($$v) {_vm.modelData=$$v},expression:"modelData"}})],1),_vm._v(" "),(_vm.errors.has('data'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"data"}},[_vm._v(_vm._s(_vm.errors.first('data')))]):_vm._e()])])])]),_vm._v(" "),(_vm.isValueInteiro || _vm.isValueDecimal)?_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('valor') }]},[_c('label',{staticClass:"control-label"},[_vm._v("Valor")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'chart-bar'}})],1),_vm._v(" "),(_vm.isValueInteiro)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelValue),expression:"modelValue"},{name:"validate",rawName:"v-validate",value:({
                    required: true,
                    regex: /^[\+|\-]?[0-9]+$/
                  }),expression:"{\n                    required: true,\n                    regex: /^[\\+|\\-]?[0-9]+$/\n                  }"}],ref:"valor",staticClass:"form-control",attrs:{"name":"valor","type":"text"},domProps:{"value":(_vm.modelValue)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save()},"input":function($event){if($event.target.composing){ return; }_vm.modelValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.isValueDecimal)?_c('money',_vm._b({directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"valor",staticClass:"form-control",attrs:{"name":"valor"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save()}},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},'money',_vm.configMoney(),false)):_vm._e()],1),_vm._v(" "),(_vm.errors.has('valor'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"valor"}},[_vm._v(_vm._s(_vm.errors.first('valor')))]):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.isValueTexto)?_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('resposta') }]},[_c('label',{staticClass:"control-label"},[_vm._v("Resposta")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelValue),expression:"modelValue"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"resposta",staticClass:"form-control",attrs:{"name":"resposta","rows":"7"},domProps:{"value":(_vm.modelValue)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save()},"input":function($event){if($event.target.composing){ return; }_vm.modelValue=$event.target.value}}}),_vm._v(" "),(_vm.errors.has('resposta'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"resposta"}},[_vm._v(_vm._s(_vm.errors.first('resposta')))]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Observação")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.modelObservacao),expression:"modelObservacao"}],ref:"observacao",staticClass:"form-control",attrs:{"rows":"7","name":"observacao","placeholder":"Digite aqui sua observação..."},domProps:{"value":(_vm.modelObservacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.modelObservacao=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"30px"}},[_c('div',[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n              Salvar\n            ")],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M53D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.entradaIsEmpty)?_c('div',[_c('i',{staticClass:"fa fa-arrow-circle-right fa-lg",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(_vm.time.entrada))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),(_vm.saidaIsEmpty)?_c('div',[_c('i',{staticClass:"fa fa-arrow-circle-right fa-lg",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(_vm.time.saida))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M6vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePaginationInfo__ = __webpack_require__("nLhK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VuetableLengthChange_vue__ = __webpack_require__("NUQ6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueTable: __WEBPACK_IMPORTED_MODULE_0_vuetable_2_src_components_Vuetable__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    PaginationInfo: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePaginationInfo__["a" /* default */],
    VuetableLengthChange: __WEBPACK_IMPORTED_MODULE_3__VuetableLengthChange_vue__["a" /* default */]
  },
  props: {
    dados: {
      type: Array,
      required: true
    },
    slots: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fields: {
      type: Array,
      required: true
    },
    per_page: {
      type: Number,
      default: 10
    },
    carregando: {
      type: Boolean,
      default: true
    },
    onRowClicked: {
      type: Function,
      default: function _default() {
        return;
      }
    },
    onPaginationChangePage: {
      type: Function,
      default: function _default() {
        return;
      }
    }
  },
  data: function data() {
    return {
      localData: [],
      dataCount: 0,
      css: {
        table: {
          tableClass: 'table table-striped table-hover',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          loadingClass: 'fa fa-spinner fa-spin'
        },
        pagination: {
          wrapperClass: 'pagination pull-right',
          activeClass: 'btn-primary',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: 'glyphicon glyphicon-step-backward',
            prev: 'glyphicon glyphicon-chevron-left',
            next: 'glyphicon glyphicon-chevron-right',
            last: 'glyphicon glyphicon-step-forward'
          }
        }
      },
      perPage: 0
    };
  },

  watch: {
    dados: function dados(newVal, oldVal) {
      this.localData = newVal;
      this.$refs.vuetable.refresh();
    }
  },
  created: function created() {
    this.localData = this.dados;
    this.dataCount = this.localData.length;
    this.perPage = this.per_page;
  },
  mounted: function mounted() {
    this.$refs.vuetable.setData(this.localData);
    this.$refs.vuetable.refresh();

    this.tablePagination = this.$refs.vuetable.tablePagination;
  },

  computed: {
    tableData: function tableData() {
      return this.$refs.vuetable.tableData;
    }
  },
  methods: {
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
      this.$emit('vuetable-pagination:change-page');
    },
    dataManager: function dataManager(sortOrder, pagination) {
      var data = this.localData;

      // account for search filter
      if (this.searchFor) {
        // the text should be case insensitive
        var txt = new RegExp(this.searchFor, 'i');

        // search on name, email, and nickname
        data = _.filter(data, function (item) {
          return item.name.search(txt) >= 0 || item.email.search(txt) >= 0 || item.nickname.search(txt) >= 0;
        });
      }

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        data = _.orderBy(data, sortOrder[0].sortField, sortOrder[0].direction);
      }

      // since the filter might affect the total number of records
      // we can ask Vuetable to recalculate the pagination for us
      // by calling makePagination(). this will make VuetablePagination
      // work just like in API mode
      pagination = this.$refs.vuetable.makePagination(data.length);

      // if you don't want to use pagination component, you can just
      // return the data array
      return {
        pagination: pagination,
        data: _.slice(data, pagination.from - 1, pagination.to)
      };
    },
    updatePerPage: function updatePerPage(value) {
      var _this = this;

      this.perPage = value === 0 ? this.dados.length : value;
      this.$nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebd4068_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("uQen");
function injectStyle (ssrContext) {
  __webpack_require__("aLQB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebd4068_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9oD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "MEYP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "MGJx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__ = __webpack_require__("PcZr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa7b67e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__ = __webpack_require__("4Dd7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa7b67e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MI1d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_AutoComplete__ = __webpack_require__("cQ3+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dado-save',
  components: { autocomplete: __WEBPACK_IMPORTED_MODULE_3__components_common_AutoComplete__["a" /* default */] },
  data: function data() {
    return {
      type: 'Adicionar',
      title: 'dados',
      carregando: false,
      model: {
        nome: '',
        descricao: '',
        fonte: '',
        tipoValor: 'I',
        periodicidade: 1,
        usuarios: []
      },
      lista: {
        tags: [],
        secretarias: [],
        autarquias: [],
        eixos: [],
        metas: [],
        usuarios: [],
        periodicidades: []
      }
    };
  },
  beforecreate: function beforecreate() {
    if (!this.$store.state.islogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var _this = this;

    var parametrosRecebido = this.$router.history.current.params;
    var ehAtualizacao = parametrosRecebido.hasOwnProperty('id');

    if (ehAtualizacao) {
      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('dado/get/' + parametrosRecebido.id).then(function (_ref) {
        var data = _ref.data;
        var periodicidade = data.periodicidade;


        if (data) {
          _this.model = data;
          _this.model.periodicidade = periodicidade.codigo;
          _this.carregarListas(ehAtualizacao);

          if (ehAtualizacao) {
            _this.type = 'Editar';
            _this.listaAdicionarItens('usuarios', _this.model.usuarios);
            _this.listaSelecionarItens('usuarios', 'codigo');
          }
        }
      }).catch(function (error) {
        console.log(error);
      }).finally(function (response) {});
    } else {
      this.carregarListas(ehAtualizacao);
      this.$refs.nome.focus();
    }

    this.$refs.nome.focus();
  },

  computed: {
    listaErros: function listaErros() {
      var _this2 = this;

      var listasStatus = {};
      var tipos = ['tags', 'secretarias', 'eixos', 'metas'];
      var status = false;
      var primeiro = '';

      tipos.forEach(function (tipo) {
        listasStatus[tipo] = _this2.listaNaoHaItemSelecionado(tipo);
        if (!status) status = listasStatus[tipo];
        if (listasStatus[tipo] && primeiro.length === 0) primeiro = tipo;
      });

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ status: status, primeiro: primeiro }, listasStatus);
    },
    parametroDado: function parametroDado() {
      var _this3 = this;

      var dado = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.model);

      var selecionados = function selecionados(i) {
        return i.selected;
      };
      var codigos = function codigos(i) {
        return i.codigo;
      };

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.lista).forEach(function (listaKey) {
        if (listaKey === 'secretarias' || listaKey === 'autarquias') {
          dado[listaKey] = _this3.lista[listaKey].filter(selecionados);
        } else {
          dado[listaKey] = _this3.lista[listaKey].filter(selecionados).map(codigos);
        }
      });

      delete dado.periodicidades;

      return dado;
    }
  },
  methods: {
    toogleshow: function toogleshow(e) {
      e.selected = !e.selected;
    },
    carregarListas: function carregarListas(selecionaItens) {
      this.carregarLista('listar-tags', 'tags', 'codigo', selecionaItens);
      this.carregarLista('listar-secretarias', 'secretarias', 'sigla', selecionaItens);
      this.carregarLista('listar-autarquias', 'autarquias', 'sigla', selecionaItens);
      this.carregarLista('listar-eixos', 'eixos', 'codigo', selecionaItens);
      this.carregarLista('listar-metas', 'metas', 'codigo', selecionaItens);
      this.carregarLista('listar-periodicidades', 'periodicidades', 'codigo', selecionaItens);
    },
    carregarLista: function carregarLista(url, listaKey, itemKey, selecionaItens) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get(url).then(function (r) {
        if (r.data.data.length === 0) return;
        _this4.listaAdicionarItens(listaKey, r.data.data);
        if (selecionaItens) _this4.listaSelecionarItens(listaKey, itemKey);
      }).catch(function (r) {
        console.log(r.response);
      });
    },
    listaAdicionarItens: function listaAdicionarItens(key, valores, callback) {
      if (!this.lista.hasOwnProperty(key)) return;
      this.lista[key] = valores.map(function (i) {
        i.selected = false;
        return i;
      });
      if (callback) callback();
    },
    listaSelecionarItens: function listaSelecionarItens(listaKey, itemKey) {
      if (!this.lista.hasOwnProperty(listaKey) || !this.model.hasOwnProperty(listaKey)) return;

      var itensSelecionados = this.model[listaKey].map(function (item) {
        return item[itemKey];
      });

      this.lista[listaKey].forEach(function (item) {
        item.selected = itensSelecionados.indexOf(item[itemKey]) > -1;
      });

      this.$forceUpdate();
    },
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Dado foi salvo com sucesso.');
      this.$router.push({ name: 'dados_list' });
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item, Tente novamente daqui alguns minutos!');
    },
    salvar: function salvar() {
      var _this5 = this;

      var me = this;
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          me.$refs[_this5.$validator.errors.items[0].field].focus();
          me.$toastr.e(_this5.$validator.errors.items[0].msg);
          return;
        }

        __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('dado/save', _this5.parametroDado).then(_this5.saveSuccess).catch(_this5.saveFail);
      });
    },
    listaNotificacaoErro: function listaNotificacaoErro() {
      this.$toastr.e('Selecione uma ou mais ' + this.listaErros.primeiro + '!');
    },
    listaNaoHaItemSelecionado: function listaNaoHaItemSelecionado(listaKey) {
      return this.lista[listaKey].filter(function (i) {
        return i.selected === true;
      }).length === 0;
    },
    selecionarUsuario: function selecionarUsuario(u) {
      if (this.usuarioSelecionado(u)) return;
      u.index = this.lista.usuarios.length;
      u.selected = true;
      this.lista.usuarios.push(u);
    },
    usuarioSelecionado: function usuarioSelecionado(u) {
      return !!this.lista.usuarios.find(function (i) {
        return i.codigo === u.codigo;
      });
    },
    removerUsuario: function removerUsuario(index) {
      this.lista.usuarios.splice(index, 1);
    },
    concatPathImage: function concatPathImage(file) {
      return this.$root.$data.imgUrl + file + '?' + new Date().getTime();
    }
  }
});

/***/ }),

/***/ "MLpl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Manutencao',
    methods: {
        voltar: function voltar() {
            this.$router.back();
        }
    }
});

/***/ }),

/***/ "MOpE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"control-label"},[_vm._v("Unidade de Saúde")]),_vm._v(" "),_c('Select',{attrs:{"showOptionEmpty":false,"options":_vm.uors},on:{"input":_vm.update},model:{value:(_vm.uor),callback:function ($$v) {_vm.uor=$$v},expression:"uor"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MWZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v("Adicionar Eixos")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('form',{attrs:{"role":"form","id":"tag_form"},on:{"submit":function($event){$event.preventDefault();return _vm.save()}}},[_c('fieldset',[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('eixo') }]},[_c('label',{class:[
                  'col-xs-12',
                  'control-label',
                  'custom-font',
                  { 'is-danger': _vm.errors.has('eixo') }
                ]},[_vm._v("Nome do eixo")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-8 inputGroupContainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('eixo') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.EIX_DCEIXO),expression:"model.EIX_DCEIXO"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"eixo",class:[
                      'form-control',
                      { 'is-danger': _vm.errors.has('eixo') }
                    ],attrs:{"name":"eixo","maxlength":"250","placeholder":"Eixo","type":"text"},domProps:{"value":(_vm.model.EIX_DCEIXO)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "EIX_DCEIXO", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': _vm.errors.has('eixo') }
                    ],domProps:{"textContent":_vm._s(250 - _vm.model.EIX_DCEIXO.length)}})]),_vm._v(" "),(_vm.errors.has('eixo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"eixo"}},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('eixo') }],attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('eixo'))+"\n                ")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){$event.preventDefault();return _vm.save()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n                  Salvar\n                ")],1)])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MbN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exportCSVFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


function convertToCSV(objArray) {
    var array = (typeof objArray === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(objArray)) != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';';

            line += array[i][index];
        }

        str += line + '\r\n';
    }

    return str;
}

var exportCSVFile = function exportCSVFile(headers, items, fileTitle) {
    if (headers) {
        items.unshift(headers);
    }

    // Convert Object to JSON
    var jsonObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(items);

    var csv = convertToCSV(jsonObject);

    var exportedFilenmae = fileTitle + '.csv' || 'export.csv';

    var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};

/***/ }),

/***/ "Mfeo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("FCqH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_603a6bee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("JNFZ");
function injectStyle (ssrContext) {
  __webpack_require__("Hr5u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-603a6bee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_603a6bee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MhY8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("XBKu");




var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* LOAD_ESCOLAS */], function (state, payload) {
  var resposta = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, { escolas: payload });
  state = resposta;
});

/***/ }),

/***/ "MnBG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-offset-4 col-md-4 col-md-offset-4"},[_c('div',{staticClass:"login-panel panel panel-default"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('form',{attrs:{"role":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.salvarSenha()}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Usuário")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"placeholder":_vm.user,"type":"text","disabled":""}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"password",class:['form-control', { 'is-danger': _vm.errors.has('password') }],attrs:{"placeholder":"Senha","name":"password","type":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"is-danger"},[_c('i',{staticClass:"fa fa-warning"}),_vm._v("\n                                  "+_vm._s(_vm.errors.first('password'))+"\n\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Confirmar Senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.confirm),expression:"model.confirm"},{name:"validate",rawName:"v-validate",value:({ required:true, equals: [_vm.model.password, 'Senha'] }),expression:"{ required:true, equals: [model.password, 'Senha'] }"}],ref:"confirmarSenha",class:['form-control', { 'is-danger': _vm.errors.has('confirmarSenha') }],attrs:{"placeholder":"Confirmar senha","name":"confirmarSenha","type":"password"},domProps:{"value":(_vm.model.confirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "confirm", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('confirmarSenha')),expression:"errors.has('confirmarSenha')"}],staticClass:"is-danger"},[_c('i',{staticClass:"fa fa-warning"}),_vm._v("\n                                  "+_vm._s(_vm.errors.first('confirmarSenha'))+"\n                                ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-block",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"submit"}},[_vm._v("Salvar senha")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading",staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("Dados Abertos")]),_vm._v(" "),_c('h3',{staticClass:"panel-title"},[_vm._v("\n                      Registre sua nova senha\n                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MnWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    time: {
      type: Object
    }
  },
  computed: {
    entradaIsEmpty: function entradaIsEmpty() {
      return this.time.entrada === '';
    },
    saidaIsEmpty: function saidaIsEmpty() {
      return this.time.saida === '';
    }
  }
});

/***/ }),

/***/ "MtQW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fieldsAgendados; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getGravidadeClass;
/* harmony export (immutable) */ __webpack_exports__["c"] = getProximidadeData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_times__ = __webpack_require__("0Btv");


var fields = [{
  name: 'posicao',
  title: 'Posição',
  titleClass: 'text-center',
  dataClass: 'text-center'
}, {
  name: 'cns',
  title: 'Nº Cartão SUS',
  titleClass: 'text-center',
  dataClass: 'text-center'
}, {
  name: '__slot:gravidade',
  title: 'Gravidade',
  titleClass: 'text-center',
  dataClass: 'text-center'
  // {
  //   name: 'dtsolicitacao',
  //   title: 'Data Solicitação',
  //   titleClass: 'text-center',
  //   dataClass: 'text-center',
  //   callback: value => {
  //     if (value) {
  //       const date = new Date(value)

  //       return formatTo2DigitsDate(date)
  //     }

  //     return value
  //   }
  // }
}];

var fieldsAgendados = [{
  name: 'cns',
  title: 'Nº Cartão SUS',
  titleClass: 'text-center',
  dataClass: 'text-center'
}, {
  name: '__slot:gravidade',
  title: 'Gravidade',
  titleClass: 'text-center',
  dataClass: 'text-center'
},
// {
//   name: 'dtsolicitacao',
//   title: 'Data Solicitação',
//   dataClass: 'text-center',
//   titleClass: 'text-center',
//   callback: value => {
//     if (value) {
//       const date = new Date(value)

//       return formatTo2DigitsDate(date)
//     }

//     return '-----'
//   }
// },
{
  name: '__slot:agendado',
  title: 'Data Agendamento',
  titleClass: 'text-center',
  dataClass: 'text-center'
},
// {
//   name: 'dtatendimento',
//   title: 'Data atendimento',
//   dataClass: 'text-center',
//   titleClass: 'text-center',
//   callback: value => {
//     if (value) {
//       const date = new Date(value)

//       return formatTo2DigitsDate(date)
//     }

//     return '-----'
//   }
// },
// {
//   name: 'situacao',
//   title: 'Situação'
// },
{
  name: 'unidade_destino',
  title: 'Unidade'
}, {
  name: 'endereco',
  title: 'Endereço'
}];

function getGravidadeClass(gravidade) {
  switch (gravidade) {
    case 'Emergência':
      return 'bg-danger';
    case 'Urgência':
      return 'bg-warning';
    case 'Normal':
      return 'bg-success';
    default:
      return 'bg-warning';
  }
}

function getProximidadeData(dtagendamento) {
  var atual = new Date();
  var agendado = new Date(dtagendamento);
  atual.setHours(0, 0, 0, 0);

  if (atual > agendado) {
    return;
  }

  var dias = (agendado - atual) / (1000 * 60 * 60 * 24);

  switch (true) {
    case dias > 30:
      return 'bg-success';
    case dias > 7:
      return 'bg-warning';
    default:
      return 'bg-danger';
  }
}

/***/ }),

/***/ "N0hf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N1oo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Modal',
  data: function data() {
    return {
      message: 'mensagem',
      config: {
        title: 'titulo'
      }
    };
  },

  methods: {
    confirm: function confirm(message) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.message = message;
      this.config = config;
      this.config.title = config.title ? config.title : 'Alerta';
      this.config.labelYes = config.labelYes ? config.labelYes : 'Sim';
      this.config.labelNo = config.labelNo ? config.labelNo : 'Não';
      this.config.labelOk = config.labelOk ? config.labelOk : 'OK';
      this.config.question = !!config.question;

      window.jQuery('#modal').modal('show');
    },
    yes: function yes() {
      window.jQuery('#modal').modal('hide');
      if (this.config.yes) {
        this.config.yes();
      }
    },
    no: function no() {
      if (this.config.no) {
        this.config.no();
      }
    },
    close: function close() {
      if (this.config.close) {
        this.config.close();
      }
    }
  }
});

/***/ }),

/***/ "N7jy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal_movimento_info","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('header',[_c('div',{staticClass:"header"},[_c('img',{staticClass:"logo-ods",attrs:{"src":_vm.logoODS}}),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.content.instituicao))])]),_vm._v(" "),_c('div',{staticClass:"subheader"},[_c('h2',[_vm._v(_vm._s(_vm.content.titulo))]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container-date"},[_c('font-awesome-icon',{staticClass:"label-color",attrs:{"icon":['far', 'calendar-alt'],"size":"lg"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.content.dataInicio)+" - "+_vm._s(_vm.content.dataEncerramento))])],1),_vm._v(" "),_c('div',{staticClass:"container-local"},[_c('font-awesome-icon',{staticClass:"label-color",attrs:{"icon":['fas', 'map-marker-alt'],"size":"lg"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.content.local))])],1)])])]),_vm._v(" "),_c('main',{style:({ height: 'auto' })},[_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.content.descricao))]),_vm._v(" "),_c('p',[_c('span',[_vm._v("Número de participantes: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.content.totalParticipantes))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("Tipo de ação: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.content.tipo_acao))])]),_vm._v(" "),_c('section',{staticClass:"flags"},[_c('p',[_vm._v("Bandeiras")]),_vm._v(" "),_c('div',_vm._l((_vm.listBandeirasInfo(_vm.content.bandeiras)),function(ref){
var titulo = ref.titulo;
var img = ref.img;
return _c('img',{attrs:{"src":img,"title":titulo,"alt":titulo}})}),0)]),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.content.link_instrucoes),expression:"content.link_instrucoes"}],staticClass:"instruction"},[_c('p',[_vm._v("Como participar?")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":_vm.content.link_instrucoes}},[_vm._v(_vm._s(_vm.content.link_instrucoes))])])]),_vm._v(" "),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.content.link_fotos),expression:"content.link_fotos"}],staticClass:"instruction"},[_c('p',[_vm._v("Acesse aqui algumas fotos")]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":_vm.content.link_fotos}},[_vm._v(_vm._s(_vm.content.link_fotos))])])])]),_vm._v(" "),_c('footer',[_c('button',{on:{"click":_vm.close}},[_vm._v("Sair")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N9rg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */],
    TheMask: __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__["TheMask"]
  },
  inject: ["showConfirm"],
  data: function data() {
    return {
      fields: [{
        name: 'criado_em',
        title: 'Data'
      }, {
        name: 'instituicao',
        title: 'Instituição'
      }, {
        name: 'titulo',
        title: 'Titulo'
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  methods: {
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'movimentosODS',
        value: 1
      });
    },
    excluir: function excluir(_ref) {
      var _this = this;

      var id = _ref.id;

      var dt = this.$refs.vuetable;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].delete('ods/movimentos/' + id).then(function () {
            _this.$toastr.s('Item removido com sucesso.');
          }).catch(function (error) {
            var data = error.response.data;

            _this.$toastr.e('Houve um erro ao tentar excluir, atualize a página e tente novamente');
            console.log(data.msg);
          }).then(function () {
            dt.refresh();
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    }
  }
});

/***/ }),

/***/ "NBO3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("tAay");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_113d671d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Ka5B");
function injectStyle (ssrContext) {
  __webpack_require__("enHs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-113d671d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_113d671d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NH9r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAlert_vue__ = __webpack_require__("uxyW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3897e118_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAlert_vue__ = __webpack_require__("aJoW");
function injectStyle (ssrContext) {
  __webpack_require__("yxmf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3897e118"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3897e118_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_custom_css__ = __webpack_require__("x9ll");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_style_css__ = __webpack_require__("VaBq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_header_css__ = __webpack_require__("Wov6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_footer_css__ = __webpack_require__("HOck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_css_footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_css_footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_toastr__ = __webpack_require__("fGLG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_PulseLoader_vue__ = __webpack_require__("YzIw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate_dist_locale_pt_BR__ = __webpack_require__("RAMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate_dist_locale_pt_BR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vee_validate_dist_locale_pt_BR__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__validators_equals__ = __webpack_require__("FOTZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__websanova_vue_upload__ = __webpack_require__("KYL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__websanova_vue_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__websanova_vue_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_v_money__ = __webpack_require__("9VIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_v_money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__env_json__ = __webpack_require__("ufme");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__env_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__env_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_datetime__ = __webpack_require__("QEVx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select__ = __webpack_require__("T1ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_chart_js__ = __webpack_require__("ikxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_chartjs_plugin_datalabels__ = __webpack_require__("cNRp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_chartjs_plugin_datalabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__ = __webpack_require__("suTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_select_dist_vue_select_css__ = __webpack_require__("R870");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__fortawesome_free_regular_svg_icons__ = __webpack_require__("Yu89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue2_leaflet__ = __webpack_require__("iI18");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_leaflet_dist_leaflet_css__ = __webpack_require__("EYnv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_leaflet_dist_leaflet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_gtag__ = __webpack_require__("Z3T5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_router_admin__ = __webpack_require__("4piF");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// import VueResource from 'vue-resource'






















__WEBPACK_IMPORTED_MODULE_21_chart_js___default.a.plugins.unregister(__WEBPACK_IMPORTED_MODULE_22_chartjs_plugin_datalabels___default.a);

// You need a specific loader for CSS files



// font awesome 5



// importação de icons regulares




__WEBPACK_IMPORTED_MODULE_25__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["a" /* faAddressCard */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["b" /* faBalanceScale */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["c" /* faCalendar */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["d" /* faCalendarAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["e" /* faCalendarCheck */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["f" /* faCalendarTimes */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["g" /* faCheck */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["h" /* faCheckCircle */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["i" /* faCheckDouble */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["j" /* faClipboardList */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["k" /* faCross */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["l" /* faCube */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["m" /* faEdit */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["n" /* faEraser */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["o" /* faExclamationTriangle */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["p" /* faFileAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["q" /* faFileDownload */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["r" /* faFileExport */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["s" /* faFilter */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["t" /* faHandHoldingHeart */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["u" /* faList */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["v" /* faMoneyBill */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["w" /* faTachometerAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["x" /* faTags */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["y" /* faThLarge */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["z" /* faPencilAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["A" /* faPrint */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["B" /* faPlus */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["C" /* faRemoveFormat */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["D" /* faSave */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["E" /* faSearch */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["F" /* faSitemap */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["G" /* faSpinner */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["H" /* faTimes */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["I" /* faTimesCircle */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["J" /* faUsers */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["K" /* faTrashAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["L" /* faChartLine */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["M" /* faUserCheck */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["N" /* faBullhorn */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["O" /* faUserTimes */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["P" /* faSquare */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["Q" /* faCheckSquare */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["R" /* faUpload */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["S" /* faMinusCircle */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["T" /* faIdCard */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["U" /* faComment */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["V" /* faEnvelope */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["W" /* faMonument */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["X" /* faUser */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["Y" /* faExternalLinkAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["Z" /* faSortNumericUpAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_0" /* faMinus */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_1" /* faTrash */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_2" /* faListOl */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_3" /* faCaretDown */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_4" /* faArrowAltCircleRight */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_5" /* faLongArrowAltLeft */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_6" /* faArrowUp */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_7" /* faChartBar */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_8" /* faPenSquare */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_9" /* faPaperPlane */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_10" /* faColumns */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_11" /* faCircle */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_12" /* faFilePdf */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_13" /* faFileCsv */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_14" /* faFileExcel */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_15" /* faDownload */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_16" /* faArrowLeft */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_17" /* faSignOutAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_18" /* faUserTag */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_19" /* faGavel */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_20" /* faUserTie */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_21" /* faClock */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_22" /* faFileImport */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_23" /* faUndo */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_24" /* faChevronLeft */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_25" /* faChevronRight */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_26" /* faLandmark */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_27" /* faMoneyCheckAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_28" /* faSyncAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_29" /* faSignature */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_30" /* faExchangeAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_31" /* faStar */], __WEBPACK_IMPORTED_MODULE_27__fortawesome_free_regular_svg_icons__["a" /* faStar */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_32" /* faFlagCheckered */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_33" /* faRunning */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_34" /* faInfo */], __WEBPACK_IMPORTED_MODULE_27__fortawesome_free_regular_svg_icons__["b" /* faCalendarAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_35" /* faMapMarkerAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_36" /* faListAlt */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_37" /* faArrowRight */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_38" /* faUserEdit */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_39" /* faBan */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_40" /* faHourglassStart */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_41" /* faAngleDoubleLeft */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_42" /* faAngleDoubleRight */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_43" /* faEye */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_44" /* faFont */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_45" /* faAdjust */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_46" /* faArrowsAltV */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_47" /* faArrowsAltH */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_48" /* faAlignJustify */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_49" /* faWrench */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_50" /* faFolder */], __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__["_51" /* faFolderOpen */]);

/**
 * Início das importações das bibliotecas do leaftlet
 */



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('l-map', __WEBPACK_IMPORTED_MODULE_29_vue2_leaflet__["a" /* LMap */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('l-tile-layer', __WEBPACK_IMPORTED_MODULE_29_vue2_leaflet__["b" /* LTileLayer */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('l-marker', __WEBPACK_IMPORTED_MODULE_29_vue2_leaflet__["c" /* LMarker */]);



delete __WEBPACK_IMPORTED_MODULE_31_leaflet__["Icon"].Default.prototype._getIconUrl;
__WEBPACK_IMPORTED_MODULE_31_leaflet__["Icon"].Default.mergeOptions({
  iconRetinaUrl: __webpack_require__("qXhe"),
  iconUrl: __webpack_require__("TJ5S"),
  shadowUrl: __webpack_require__("wkq0")
});

/**
 * Fim das importações do leaflet
 */

/**
 * Configuração do Analytics
 */




if (true) {
  var excludedRoutes = __WEBPACK_IMPORTED_MODULE_33__src_router_admin__["a" /* default */][0].children.map(function (route) {
    return route.path === '/' ? '/admin' : '/admin/' + route.path;
  });

  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32_vue_gtag__["a" /* default */], {
    pageTrackerExcludedRoutes: excludedRoutes,
    config: { id: 'G-FK0KE8705Z' }
  }, __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);
}

/**
 * Fim do Analytics
 */

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_28__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_datetime___default.a);

window.jQuery = __webpack_require__("7t+N"); // << import jquery global
__webpack_require__("gNGx");
__webpack_require__("2BDT");

// Vue.use(VueResource)
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_toastr___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__websanova_vue_upload___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_v_money___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* default */], {
  fieldsBagName: 'formFields',
  dictionary: {
    pt_BR: {
      custom: {
        text: {
          required: 'O campo é obrigatório!'
        },
        password: {
          required: 'O campo é obrigatório!'
        },
        confirmarSenha: {
          required: 'O campo é obrigatório!'
        }
      }
    }
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('pulse-loader', __WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_PulseLoader_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_19_vue_select___default.a);

__WEBPACK_IMPORTED_MODULE_13_vee_validate__["b" /* Validator */].extend('equals', __WEBPACK_IMPORTED_MODULE_14__validators_equals__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_13_vee_validate__["b" /* Validator */].localize('pt_BR', __WEBPACK_IMPORTED_MODULE_12_vee_validate_dist_locale_pt_BR___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_20_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_17__env_json___default.a.apiUrl;

__WEBPACK_IMPORTED_MODULE_20_axios___default.a.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  // You can even test for a response code
  // and try a new request before rejecting the promise
  if (error.response.status === 401) {
    if (!__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.initialized) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('LOGOUT_USER');
      return __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        name: 'Login',
        params: { errorMsg: 'Sessão Expirada!' }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].app.$toastr.e('Seu token expirou faça o login novamente!');
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].app.$refs.loginModal.show();
      //store.commit('LOGOUT_USER')
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_20_axios___default.a;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  data: __WEBPACK_IMPORTED_MODULE_17__env_json___default.a,
  template: '<div><App/></div>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NL3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classNameWrapper},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user),expression:"user"}],ref:"input",class:_vm.classNameInput,attrs:{"type":"text","id":_vm.id,"name":_vm.name,"placeholder":_vm.placeholder,"autocomplete":"off"},domProps:{"value":(_vm.user)},on:{"keyup":[function($event){return _vm.onKeyup($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.setData()}],"input":function($event){if($event.target.composing){ return; }_vm.user=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList()),expression:"showList()"}],staticClass:"autocomplete-items"},_vm._l((_vm.list),function(data){return _c('div',{key:data[_vm.item_key]},[_c('div',{class:[{ 'active': data.actived }]},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){$event.preventDefault();return _vm.setData(data)}}},[_vm._v(" "+_vm._s(data[_vm.item_text])+" ")])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NUQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuetableLengthChange_vue__ = __webpack_require__("JkKq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86d88852_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuetableLengthChange_vue__ = __webpack_require__("if7j");
function injectStyle (ssrContext) {
  __webpack_require__("OAoN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-86d88852"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VuetableLengthChange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86d88852_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VuetableLengthChange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NcFF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common___ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_strings__ = __webpack_require__("V99r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PublicHeader: __WEBPACK_IMPORTED_MODULE_2__components_common___["a" /* PublicHeader */], BarChart: __WEBPACK_IMPORTED_MODULE_2__components_common___["d" /* BarChart */], CardLg: __WEBPACK_IMPORTED_MODULE_2__components_common___["l" /* CardLG */], AnoBase: __WEBPACK_IMPORTED_MODULE_2__components_common___["j" /* AnoBase */] },
  data: function data() {
    return {
      carregando: true,
      grafico_base: { labels: [], datasets: [{ label: '', data: [] }] },
      total_ano: [],
      total_mes: [],
      beneficios: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    var ano = this.ano_base;

    __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('/assistencia/listar-beneficios').then(function (response) {
      var data = response.data;

      _this.beneficios = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));
    }).catch(function (error) {
      var data = error.response.data;

      _this.$toastr.e('Houve um erro ao carregar a lista de benefícios. Atualize a página e, caso o problema persista, contate o administrador.');
      console.log(data.msg);
    });

    this.retornarPagamentosAno(ano);
    this.retornarPagamentosMes(ano);
  },

  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_3__utils_strings__["b" /* formatarMoeda */],
    retornarPorSigla: function retornarPorSigla(sigla) {
      var filter = function filter(item) {
        return item.beneficio === sigla;
      };

      var result = this.total_ano.filter(filter);

      if (result.length) {
        return _.first(result);
      }

      return { total: 0, valor: 0 };
    },
    retornarPagamentosAno: function retornarPagamentosAno(ano) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('/assistencia/pagamentos-ano/' + ano).then(function (response) {
        var data = response.data;

        _this2.total_ano = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));
      }).catch(function (error) {
        var data = error.response.data;

        _this2.$toastr.e('Houve um erro ao carregar os totais por ano. Atualize a página e, caso o problema persista, contate o administrador no email do rodapé.');
        console.log(data.msg);
      }).then(function () {
        _this2.carregando = false;
      });
    },
    retornarPagamentosMes: function retornarPagamentosMes(ano) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('/assistencia/pagamentos-mes/' + ano).then(function (response) {
        var data = response.data;

        _this3.total_mes = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));
      }).catch(function (error) {
        var data = error.response.data;

        _this3.$toastr.e('Houve um erro ao carregar os totais por mês. Atualize a página e, caso o problema persista, contate o administrador no email do rodapé.');
        console.log(data.msg);
      }).then(function () {
        _this3.carregando = false;
      });
    }
  },
  watch: {
    ano_base: function ano_base(newValue /*, oldValue*/) {
      this.retornarPagamentosAno(newValue);
      this.retornarPagamentosMes(newValue);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({
    ano_base: function ano_base(state) {
      return state.receitas_despesas.ano_base;
    }
  }), {
    pnf: function pnf() {
      return this.retornarPorSigla('PNF');
    },
    acao_jovem: function acao_jovem() {
      return this.retornarPorSigla('ACAO JOVEM');
    },
    bolsa_familia: function bolsa_familia() {
      return this.retornarPorSigla('AUXILIO BRASIL');
    },
    graficoHeader: function graficoHeader() {
      var labels = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["a" /* mesesAbr */]));
      var data = Array(12).fill(0);

      this.total_mes.forEach(function (element) {
        data[element.mes - 1] = element.valor;
      });

      var datasets = [{
        label: this.ano_base,
        data: data
      }];

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.grafico_base, {
        labels: labels,
        datasets: datasets
      });
    },
    totalAno: function totalAno() {
      var reducer = function reducer(acum, atual) {
        acum.valor += Number(atual.valor);
        acum.total += Number(atual.total);
        return acum;
      };

      return this.total_ano.reduce(reducer, { valor: 0, total: 0 });
    }
  })
});

/***/ }),

/***/ "Ng2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 content"},[_c('data-table',{ref:"escalas",attrs:{"title":"lista de dados","has-auth":false,"api-mode":false,"dados":_vm.lista.escalas,"show-empty":true,"fields":_vm.datatable.columns,"carregando":_vm.lista.carregando},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_c('section',_vm._l((props.rowData.periodos),function(ref,index){
var entrada = ref.entrada;
var saida = ref.saida;
var dias = ref.dias;
return _c('article',{key:index},[_c('label',[(entrada !== '')?_c('div',[_vm._v("\n                    "+_vm._s(entrada)+"\n                  ")]):_c('div',[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1),_vm._v(" "),(entrada !== '' && saida !== '')?_c('div',[_vm._v("-")]):_vm._e(),_vm._v(" "),(saida !== '')?_c('div',[_vm._v("\n                    "+_vm._s(saida)+"\n                  ")]):_c('div',[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1)]),_vm._v(" "),_vm._l((dias),function(dia,index){return _c('span',{key:index},[_vm._v("\n                  "+_vm._s(dia)+"\n                ")])})],2)}),0)]}},{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}}])},[_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":"add"}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NgUq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_DataTablePublic__ = __webpack_require__("+Mmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_strings__ = __webpack_require__("V99r");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dados_index',
  components: {
    DataTablePublic: __WEBPACK_IMPORTED_MODULE_4__components_common_DataTablePublic__["a" /* default */],
    PublicHeader: __WEBPACK_IMPORTED_MODULE_5__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_5__components__["b" /* Breadcrumb */],
    CardsFiltro: __WEBPACK_IMPORTED_MODULE_5__components__["A" /* CardsFiltro */],
    FaixaComparacao: __WEBPACK_IMPORTED_MODULE_5__components__["z" /* FaixaComparacao */]
  },
  data: function data() {
    return {
      imgUrl: this.$root.$data.imgUrl,
      title: 'Dados',
      filtros: {
        tags: [],
        secretarias: [],
        autarquias: [],
        eixos: [],
        metas: [],
        termo_pesquisa: {
          codigo: '',
          ativo: true
        }
      },
      model: {
        columnID: 'DAD_IDDADO',
        columns: [{
          name: 'nome',
          title: 'Nome',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: 'fonte',
          title: 'Fonte',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: '__slot:icon',
          title: 'Favoritos',
          titleClass: 'text-center',
          dataClass: 'align-middle text-center'
        }, {
          name: '__slot:column',
          title: 'Metas ODS',
          titleClass: 'text-center',
          dataClass: 'align-middle text-center'
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }]
      },
      filtrosParametro: this.$router.history.current.query,
      addDadoState: {}
    };
  },
  created: function created() {
    this.formatFiltroParam();
  },
  beforeMount: function beforeMount() {
    this.loadFiltros();
  },

  computed: {
    idsArray: function idsArray() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.addDadoState).filter(function (codigo) {
        return _this.addDadoState[codigo];
      });
    },
    hasFilterEnable: function hasFilterEnable() {
      var me = this;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(me.filtros).find(function (tipo) {
        return me.hasFilterEnableOf(tipo);
      }) !== undefined;
    },
    hasFilterDisable: function hasFilterDisable() {
      var me = this;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(me.filtros).find(function (tipo) {
        return me.hasFilterDisableOf(tipo);
      }) !== undefined;
    },
    activeFilterList: function activeFilterList() {
      var _this2 = this;

      if (this.filtrosParametro.metas.length) {
        var filter = function filter(item) {
          return _this2.filtrosParametro.metas.includes(item.codigo);
        };

        return this.filtros.metas.filter(filter);
      }

      return [];
    },
    filtersAvailable: function filtersAvailable() {
      var _this3 = this;

      if (this.filtrosParametro.metas.length) {
        var filter = function filter(item) {
          return !_this3.filtrosParametro.metas.includes(item.codigo);
        };

        return this.filtros.metas.filter(filter);
      }

      return this.filtros.metas;
    },
    selectedCount: function selectedCount() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.addDadoState).filter(function (value) {
        return value;
      }).length;
    }
  },
  methods: {
    retornarAtivos: function retornarAtivos(array) {
      var retorno = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(array)).filter(function (item) {
        return item.ativo === true;
      });

      return retorno;
    },
    permitirComparativo: function permitirComparativo(item) {
      if (item.tipoValor === 'T') {
        return false;
      }

      return true;
    },
    salvarFavorito: function salvarFavorito(codigo) {
      var objeto = JSON.parse(localStorage.getItem('pmsdadosabertos'));

      if (objeto) {
        var index = objeto.favoritos.indexOf(codigo);
        if (index === -1) {
          objeto.favoritos.push(codigo);
        } else {
          objeto.favoritos.splice(index, 1);
        }
      } else {
        objeto = { favoritos: [codigo] };
      }

      localStorage.setItem('pmsdadosabertos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(objeto));
      this.$refs.dt.refresh();
      this.$toastr.s('Favoritos salvos com sucesso.');
    },
    classeFavoritos: function classeFavoritos(codigo) {
      var objeto = JSON.parse(localStorage.getItem('pmsdadosabertos'));

      if (objeto && objeto.favoritos.indexOf(codigo) > -1) {
        return ['fas', 'star'];
      }

      return ['far', 'star'];
    },
    classeSelecionados: function classeSelecionados(codigo) {
      return this.addDadoState[codigo] ? ['btn-remove'] : ['btn-add'];
    },
    formatFiltroParam: function formatFiltroParam() {
      var _this4 = this;

      if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.filtrosParametro).length) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.filtrosParametro).forEach(function (k) {
          if (!Array.isArray(_this4.filtrosParametro[k])) {
            _this4.filtrosParametro[k] = [parseInt(_this4.filtrosParametro[k]) || _this4.filtrosParametro[k]];
          } else {
            _this4.filtrosParametro[k] = _this4.filtrosParametro[k];
          }
        });

        return;
      }

      this.filtrosParametro = { metas: [] };
    },
    clearFiltros: function clearFiltros() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.filtros).forEach(function (tipo) {
        _this5.filtros[tipo] = [];
      });
    },
    loadFiltros: function loadFiltros() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_6__request__["b" /* default */].get('listar-filtros',
      // 'listar-filtros?' + formatObjectToQueryString(this.filtrosParametro),
      function (response) {
        _this6.clearFiltros();
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(response).forEach(function (tipo) {
          _this6.filtroAddRange(tipo, response[tipo]);
        });
      }, function (response) {
        console.log(response);
      });
    },
    add: function add(tipo, filtro) {
      var _this7 = this;

      if (tipo !== 'termo_pesquisa') {
        filtro.ativo = true;
      } else {
        this.filtrosParametro[tipo] = null;
      }

      if (this.filtrosParametro[tipo]) {
        this.filtrosParametro[tipo].push(filtro.codigo);
      } else {
        this.filtrosParametro[tipo] = [filtro.codigo];
      }

      window.history.pushState(null, null, '?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_strings__["i" /* formatObjectToQueryString */])(this.filtrosParametro));
      this.$nextTick(function () {
        _this7.loadFiltros();
        _this7.$refs.dt.refresh();
      });
    },
    remove: function remove(tipo, filtro) {
      var _this8 = this;

      if (Array.isArray(filtro)) {
        delete this.filtrosParametro[tipo];
        filtro.forEach(function (i) {
          i.ativo = false;
        });
      } else {
        var index = this.filtrosParametro[tipo].indexOf(filtro.codigo);
        this.filtrosParametro[tipo].splice(index, 1);
        filtro.ativo = false;
      }

      if (this.hasfiltrosParametro()) {
        window.history.pushState(null, null, '?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_strings__["i" /* formatObjectToQueryString */])(this.filtrosParametro));
      } else {
        window.history.pushState(null, null, window.location.href.split('?').shift());
      }

      this.$nextTick(function () {
        _this8.loadFiltros();
        _this8.$refs.dt.refresh();
      });
    },
    hasfiltrosParametro: function hasfiltrosParametro() {
      var keys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.filtrosParametro);
      var foundFilter = false;
      var c = 0;
      while (!foundFilter && c < keys.length) {
        foundFilter = this.filtrosParametro[keys[c++]].length > 0;
      }
      return foundFilter;
    },
    isActiveFilter: function isActiveFilter(tipo, codigo) {
      return this.filtrosParametro.hasOwnProperty(tipo) && this.filtrosParametro[tipo].find(function (i) {
        return i === codigo;
      }) !== undefined;
    },
    filtroAddRange: function filtroAddRange(tipo, filtros) {
      var _this9 = this;

      filtros.forEach(function (i) {
        i.ativo = _this9.isActiveFilter(tipo, i.codigo);
        _this9.filtros[tipo].push(i);
        if (tipo === 'secretarias') {
          i.descricao = i.sigla;
        }
      });
    },
    hasFilterDisableOf: function hasFilterDisableOf(tipo) {
      if (Array.isArray(this.filtros[tipo])) {
        return this.filtros[tipo].filter(function (i) {
          return !i.ativo;
        }).length > 0;
      }
    },
    hasFilterEnableOf: function hasFilterEnableOf(tipo) {
      if (Array.isArray(this.filtros[tipo])) {
        return this.filtros[tipo].filter(function (i) {
          return i.ativo;
        }).length > 0;
      }
    },
    addFilter: function addFilter(value) {
      var codigo = value.codigo;

      this.filtrosParametro.metas.push(codigo);
      this.$refs.dt.refresh();
    },
    removeFilter: function removeFilter(value) {
      var codigo = value.codigo;

      var filter = function filter(item) {
        return item !== codigo;
      };
      this.filtrosParametro.metas = this.filtrosParametro.metas.filter(filter);
      this.$refs.dt.refresh();
    },
    toggleAddDado: function toggleAddDado(codigo) {
      if (this.addDadoState[codigo] === undefined) {
        this.$set(this.addDadoState, codigo, true);
      } else {
        this.addDadoState[codigo] = !this.addDadoState[codigo];
      }
    },
    getPopoverContent: function getPopoverContent(codigo) {
      return this.addDadoState[codigo] ? 'Clique para remover o dado da comparação' : 'Clique para adicionar o dado para comparação';
    }
  }
});

/***/ }),

/***/ "NkcH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nkka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SelectFuncionario__ = __webpack_require__("JrGC");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SidePlanoGoverno',
  components: { SideModal: __WEBPACK_IMPORTED_MODULE_3__common__["g" /* SideModal */], SelectFuncionario: __WEBPACK_IMPORTED_MODULE_4__components_SelectFuncionario__["a" /* default */] },
  props: {
    navs: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      justificativa: '',
      sshd_responsavel: '',
      novoDescritivo: ''
    };
  },

  computed: {
    homologarData: function homologarData() {
      var _navs$ = this.navs[0],
          identidade = _navs$.identidade,
          data = _navs$.data;


      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ identidade: identidade }, data);
    },
    infoData: function infoData() {
      var infoNav = this.navs.find(function (n) {
        return n.identidade === 'info';
      });

      if (!infoNav || !infoNav.data) {
        return { identidade: 'info', sumario: [] };
      }

      var data = infoNav.data;

      var acoes = data.acoes || [];

      var statusUnicos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(acoes.map(function (a) {
        return a.status;
      }))));
      var sumario = statusUnicos.map(function (s) {
        var total = acoes.filter(function (a) {
          return a.status === s;
        }).length;
        return { status: s, total: total };
      });

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ identidade: infoNav.identidade }, data, { sumario: sumario });
    },
    pedidoCancelamentoData: function pedidoCancelamentoData() {
      var cancelarNav = this.navs.find(function (n) {
        return n.identidade === 'pedido-cancelamento';
      });
      if (cancelarNav && cancelarNav.data) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ identidade: cancelarNav.identidade }, cancelarNav.data);
      }
      return { identidade: 'pedido-cancelamento' };
    },
    cancelarData: function cancelarData() {
      var cancelarNav = this.navs.find(function (n) {
        return n.identidade === 'cancelar';
      });
      if (cancelarNav && cancelarNav.data) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ identidade: cancelarNav.identidade }, cancelarNav.data);
      }
      return { identidade: 'cancelar' };
    },
    editarData: function editarData() {
      var editarNav = this.navs.find(function (n) {
        return n.identidade === 'editar';
      });
      return editarNav ? editarNav.data : null;
    }
  },
  watch: {
    editarData: {
      handler: function handler(newData) {
        this.resetarFormulario();
      },

      immediate: true,
      deep: true
    }
  },
  methods: {
    resetarFormulario: function resetarFormulario() {
      if (this.editarData) {
        this.sshd_responsavel = this.editarData.responsavel_sshd || '';
        this.novoDescritivo = this.editarData.descritivo || '';
      }
    },
    salvarEdicao: function salvarEdicao() {
      if (!this.novoDescritivo.trim()) {
        this.$toastr.e('O descritivo não pode estar vazio.');
        return;
      }
      if (!this.sshd_responsavel) {
        this.$toastr.e('É necessário selecionar um responsável.');
        return;
      }

      var dadosParaSalvar = {
        id: this.editarData.id,
        descritivo: this.novoDescritivo,
        responsavel_sshd: this.sshd_responsavel
      };
      this.$emit('salvar-edicao', dadosParaSalvar);
    },
    cancelarEdicao: function cancelarEdicao() {
      this.resetarFormulario();
      this.$emit('fechaModal', 'editar');
    }
  }
});

/***/ }),

/***/ "Nn/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeSpan_vue__ = __webpack_require__("pueA");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_838ba9aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeSpan_vue__ = __webpack_require__("Zbiu");
function injectStyle (ssrContext) {
  __webpack_require__("jzC+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-838ba9aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeSpan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_838ba9aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeSpan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "NpjO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detalhes-por-area"},[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":_vm.secretaria}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n          A "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.secretaria}}),_vm._v(" recebeu, no ano de\n          "),_c('SelectAnoEmendas'),_vm._v(" , um total de\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.valorTotalSecretaria),"isLoading":_vm.loading}}),_vm._v("\n          em emendas parlamentares.\n        ")],1),_vm._v(" "),_c('p',[_vm._v("\n          Do total,\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.utilizadosComPercentual,"isLoading":_vm.loading}}),_vm._v("\n          foram utilizados, restando um saldo de\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.saldoComPercentual,"isLoading":_vm.loading}}),_vm._v("\n          .\n        ")],1)])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.descricao),expression:"filtros.descricao"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Digite o nome do vereador ou descrição...","aria-placeholder":"Digite o nome do vereador ou descrição..."},domProps:{"value":(_vm.filtros.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "descricao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-right"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.downloadToCSV()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}}),_vm._v(" Exportar para CSV\n          ")],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('DataTable',{attrs:{"dados":_vm.emendasDaSecretaria,"fields":_vm.dataFields},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Exibir detalhes","type":"button"},on:{"click":function($event){return _vm.showDetails(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'search'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Exibir detalhes")])],1)]}}])})],1)])],1)]),_vm._v(" "),_c('SideEmendas',{ref:"side-emendas",attrs:{"emenda":_vm.emendaSelecionada,"navs":_vm.navs}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n            Lista de emendas\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NrIa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[(_vm.showTitle)?_c('h1',{staticClass:"mega"},[_vm._v(_vm._s(_vm.title))]):_c('div',[_vm._v(" ")])]),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NtCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Tags")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Listagem de Tags","api-url":"tags/list","report-title":"Tags","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'tags',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"DAD_DCNOME_filter"}},[_vm._v("Descrição")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.TAG_DCTAG),expression:"TAG_DCTAG"}],staticClass:"form-control",attrs:{"type":"text","name":"DAD_DCNOME_filter"},domProps:{"value":(_vm.TAG_DCTAG)},on:{"input":function($event){if($event.target.composing){ return; }_vm.TAG_DCTAG=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'admin_tags_save' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O64i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmendasPorArea_vue__ = __webpack_require__("o7ck");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a9a76fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmendasPorArea_vue__ = __webpack_require__("wofJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmendasPorArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a9a76fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmendasPorArea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O7VY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O87q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards-portais"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.portais),function(portal,index){return _c('div',{key:("portal-" + index),staticClass:"col-xs-12 col-md-4"},[_c('router-link',{staticClass:"card-portal",attrs:{"to":{ name: portal.nome_rota }}},[_c('strong',{staticClass:"text-xl"},[_vm._v("\n          "+_vm._s(portal.titulo)+"\n        ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(portal.descricao))])])],1)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("\n        Portais de transparência\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Aqui você encontra os portais de transparência disponíveis para\n        consulta. Você pode acompanhar os concursos públicos vigentes,\n        consultar disponibilidade de remédios, entre outras informações,\n        selecionando os cards abaixo:\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OAoN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OOvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return request; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var request = __WEBPACK_IMPORTED_MODULE_7_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].apiUrl
});

request.interceptors.request.use(function (req) {
  var daUser = localStorage.getItem('daUser');

  if (daUser) {
    var _JSON$parse = JSON.parse(daUser),
        token = _JSON$parse.token;

    req.headers['Authorization'] = token;
  }

  return req;
});

request.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  // You can even test for a response code
  // and try a new request before rejecting the promise

  var response = error.response;


  if (response && response.status === 401) {
    if (!__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.initialized) {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('LOGOUT_USER');
      return __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({
        name: 'Login',
        params: { errorMsg: 'Sessão Expirada!' }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app.$toastr.e('Seu token expirado ou inválido faça o login novamente!');
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app.$refs.loginModal.show();
    }
  }

  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.reject(error);
});



// URL and endpoint constants
var DELETE_URL = {
  TAG: 'tags/delete',
  EIXO: 'eixos/delete',
  USER: 'user/delete',
  META: 'meta/delete',
  DADO: 'dado/delete',
  DADOVALOR: 'dado/valor/delete',
  PLANOGOVERNO: 'planogoverno/delete',
  COMPROMISSOACOES: 'planogoverno/compromisso/acao/delete'
};

var API_URL = __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].apiUrl;

/* harmony default export */ __webpack_exports__["b"] = ({
  apiUrlRoot: API_URL,
  apiHeaderAuthorization: function apiHeaderAuthorization() {
    var daUser = localStorage.getItem('daUser');

    if (daUser) {
      var _JSON$parse2 = JSON.parse(daUser),
          token = _JSON$parse2.token;

      return {
        Authorization: token
      };
    }

    return "";
  },
  request: function request(method, url, fnSuccess, fnError, putToken, params, headers) {
    var uri = API_URL + url;
    var http = new XMLHttpRequest();
    var me = this;
    http.open(method, uri);

    if (headers) {
      me.setHeaders(headers, http);
    }

    if (putToken) {
      var data = localStorage.getItem('daUser');
      if (data) {
        http.setRequestHeader('Authorization', JSON.parse(data).token);
      }
    }

    http.onreadystatechange = function () {
      try {
        if (this.readyState !== 4) return;

        var status = http.status;

        if ([200, 204].includes(status)) {
          fnSuccess(me.getResponseJson(this));
        } else {
          throw new Error('requisição com erro!');
        }
      } catch (e) {
        me.filterFail(me.getResponseJson(this), fnError);
      }
    };

    if (params) {
      http.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      http.send(me.formatParams(params));
      return;
    }

    http.send();
  },
  authenticate: function authenticate(credencial, fnSuccess, fnError) {
    this.post('auth/login', credencial, function (response) {
      localStorage.setItem('daUser', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(response));
      // store.commit('LOGIN_USER')
      fnSuccess(response);
    }, fnError);
  },
  get: function get(url, fnSuccess, fnError) {
    this.request('GET', url, fnSuccess, fnError, true);
  },
  post: function post(url, data, fnSuccess, fnError) {
    this.request('POST', url, fnSuccess, fnError, true, data);
  },
  formatParams: function formatParams(obj, prefix) {
    var str = [];
    var p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + '[' + p + ']' : p;
        var v = obj[p];
        str.push(v !== null && (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(v)) === 'object' ? this.formatParams(v, k) : encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
    }
    return str.join('&');
  },
  setHeaders: function setHeaders(headers, http) {
    for (var i = 0; i < headers.length; i++) {
      http.setRequestHeader(headers[i].key, headers[i].value);
    }
  },
  filterFail: function filterFail(response, fnFailClient) {
    fnFailClient = typeof fnFailClient === 'function' ? fnFailClient : function () {};
    if (response) {
      if (response.hasOwnProperty('tokenIsExpired')) {
        localStorage.daUser = '';
        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app.$refs.loginModal.show();
        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('LOGOUT_USER');
        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'Login', params: { errorMsg: 'Sessão Expirada!' } });
        return;
      }
      if (response.hasOwnProperty('tokenInvalid')) {
        localStorage.daUser = '';
        __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('LOGOUT_USER');
        __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({
          name: 'Login',
          params: { errorMsg: 'Usuário ou senha inválidos!' }
        });
        return;
      }
    }
    fnFailClient(response);
  },
  delete: function _delete(model, fnSuccess, fnError) {
    var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(model)[0];
    var value = model[key];
    var data = '{"' + key + '": ' + value + '}';
    this.post(DELETE_URL[model.type], JSON.parse(data), fnSuccess, fnError);
  },
  getResponseJson: function getResponseJson(http) {
    var response = '';

    if (http.responseText.length > 0) response = JSON.parse(http.response);

    return response;
  },

  ws: {
    request: function request(method, url, data, fnSuccess, fnError) {
      var uri = API_URL + url;
      var http = new XMLHttpRequest();
      var me = this;
      http.open(method, uri);
      http.setRequestHeader('Content-Type', 'application/json');

      http.onreadystatechange = function () {
        if (http.readyState === 4) {
          var resp = JSON.parse(http.response);
          if (http.status === 200) {
            fnSuccess(resp);
          } else {
            me.filterFail(resp, fnError);
          }
        }
      };
      http.send(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));
    },
    secretarias: function secretarias(data, fnSuccess, fnError) {
      this.request('GET', 'ExibirPorId', data, fnSuccess, fnError);
    }
  }
});

/***/ }),

/***/ "OSaL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OT/t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OX0H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Odph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Usuários")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Listagem de Usuários","api-url":"user/list","report-title":"Usuários","fields":_vm.fields,"appendParams":_vm.filtros,"initial-page":_vm.pagina,"pageCollection":'usuarios'},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-md-2 col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"username_filter"}},[_vm._v("Usuário")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control",attrs:{"type":"text","name":"username_filter"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-sm-8"},[_c('label',{staticClass:"custom-font",attrs:{"for":"USU_DCEMAIL_filter"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.USU_DCEMAIL),expression:"USU_DCEMAIL"}],staticClass:"form-control",attrs:{"type":"text","name":"USU_DCEMAIL_filter"},domProps:{"value":(_vm.USU_DCEMAIL)},on:{"input":function($event){if($event.target.composing){ return; }_vm.USU_DCEMAIL=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5 col-sm-12"},[_c('label',{staticClass:"custom-font",attrs:{"for":"USU_NMUSUARIO_filter"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.USU_NMUSUARIO),expression:"USU_NMUSUARIO"}],staticClass:"form-control",attrs:{"type":"text","name":"USU_NMUSUARIO_filter"},domProps:{"value":(_vm.USU_NMUSUARIO)},on:{"input":function($event){if($event.target.composing){ return; }_vm.USU_NMUSUARIO=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'admin_users_save' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OlJP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__side_modal_vue__ = __webpack_require__("jDVi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SideHome',

  props: {
    sides: {
      required: true,
      type: Array,
      default: [{
        titulo: 'Título',
        subtitulo: '',
        subtDetalhe: '',
        largura: 600,
        identidade: '',
        abreProximo: false,
        aberto: false
      }]
    }
  },
  data: function data() {
    return {
      largMinima: 0
    };
  },

  components: {
    'side-modal': __WEBPACK_IMPORTED_MODULE_0__side_modal_vue__["a" /* default */]
  },
  methods: {
    minima: function minima(larg) {
      this.larguraMinima = larg + 50;
    },
    comparaSidesAbre: function comparaSidesAbre(side) {
      var _this = this;

      var largMinima = side.largura;
      var largAtual = 0;

      this.sides.reverse();
      this.sides.forEach(function (item) {
        largAtual = document.querySelector('#' + item.identidade).clientWidth;
        if (item.aberto && largAtual <= largMinima) {
          largMinima += 50;
          var prop = { id: item.identidade, larg: largMinima };
          _this.$emit('mostraMais', prop);
        }
      });
      this.sides.reverse();
    },
    comparaSidesFecha: function comparaSidesFecha(side) {
      var _this2 = this;

      var largAtual = 0;
      var largResult = 0;

      var abertos = this.sides.filter(function (item) {
        return item.aberto === true;
      });
      abertos.reverse();

      if (abertos.lenght > 0) {
        this.$emit('escondeMais', abertos[0]);
        abertos.splice(0, 1);
      }

      // this.$emit('escondeMais', abertos[0])
      // abertos.splice(0, 1)

      abertos.forEach(function (item) {
        largAtual = document.querySelector('#' + item.identidade).clientWidth;

        if (item.largura !== largAtual && item.largura < largAtual) {
          _this2.largMinima > item.largura ? largResult = _this2.largMinima : largResult = item.largura;
          var prop = { id: item.identidade, larg: largResult };
          _this2.$emit('escondeMais', prop);
        } else {
          _this2.largMinima = item.largura + 50;
        }
      });
    },
    abreSide: function abreSide(side) {
      var index = this.sides.indexOf(side);
      if (index > 0) {
        this.comparaSidesAbre(side);
      }
      side.aberto = true;
      this.$emit('mostra', side.identidade);
    },
    fechaSide: function fechaSide(side) {
      this.$emit('esconde', side);
      this.fechaFromChild(side);
    },
    fechaFromChild: function fechaFromChild(side) {
      side.aberto = false;
      var index = this.sides.indexOf(side);
      if (index > 0) {
        this.comparaSidesFecha(side);
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.sides.forEach(function (side) {
      if (window.innerWidth < side.largura) side.largura = window.innerWidth;
    });
    this.$parent.$on('abreModal', function (identidade) {
      var index = _this3.sides.findIndex(function (item) {
        return item.identidade === identidade;
      });
      _this3.abreSide(_this3.sides[index]);
    });
    this.$parent.$on('fechaModal', function (identidade) {
      var index = _this3.sides.findIndex(function (item) {
        return item.identidade === identidade;
      });
      _this3.fechaSide(_this3.sides[index]);
    });
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "OlTv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OpFw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_colors__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_DataTablePublic__ = __webpack_require__("+Mmc");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_4__components__["a" /* PublicHeader */],
    ValorDestaque: __WEBPACK_IMPORTED_MODULE_4__components__["c" /* ValorDestaque */],
    BarChart: __WEBPACK_IMPORTED_MODULE_4__components__["e" /* BarChart */],
    PieChart: __WEBPACK_IMPORTED_MODULE_4__components__["d" /* PieChart */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components__["b" /* Breadcrumb */],
    CardInstitucional: __WEBPACK_IMPORTED_MODULE_4__components__["f" /* CardInstitucional */],
    DataTablePublic: __WEBPACK_IMPORTED_MODULE_6__components_common_DataTablePublic__["a" /* default */]
  },
  data: function data() {
    return {
      anoPlano: '2025-2028',
      totalMetas: 0,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      statusChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom'
        },
        tooltips: {
          callbacks: {
            label: function label(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var total = dataset.data.reduce(function (acc, val) {
                return acc + val;
              }, 0);
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = (currentValue / total * 100).toFixed(1) + '%';
              var label = data.labels[tooltipItem.index] || '';
              return label + ': ' + currentValue + ' (' + percentage + ')';
            }
          }
        },
        plugins: {
          datalabels: {
            color: function color(context) {
              var backgroundColor = context.dataset.backgroundColor[context.dataIndex];

              if (backgroundColor === '#222222' || backgroundColor === '#AD68A0' || backgroundColor === '#5C8A95') {
                return '#FFFFFF';
              }
            },
            font: {
              weight: 'bold'
            }
          }
        }
      },
      termoPesquisa: '',
      termoPesquisaAcoes: '',
      isSidePanelOpen: false,
      acoesSidePanel: [],
      sidePanelChartData: null,
      model: {
        columns: [{
          name: 'descritivo',
          title: 'Descritivo',
          dataClass: 'align-middle'
        }, {
          name: '__slot:column',
          title: 'Status',
          titleClass: 'text-center',
          dataClass: 'text-center align-middle'
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center',
          dataClass: 'text-center align-middle'
        }]
      },
      sideChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'right'
        },
        tooltips: {
          callbacks: {
            label: function label(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var total = dataset.data.reduce(function (acc, val) {
                return acc + val;
              }, 0);
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = (currentValue / total * 100).toFixed(1) + '%';
              var label = data.labels[tooltipItem.index] || '';
              return label + ': ' + currentValue + ' (' + percentage + ')';
            }
          }
        },
        plugins: {
          datalabels: {
            color: function color(context) {
              var backgroundColor = context.dataset.backgroundColor[context.dataIndex];

              if (backgroundColor === '#222222' || backgroundColor === '#AD68A0' || backgroundColor === '#5C8A95') {
                return '#FFFFFF';
              }
            },
            font: {
              weight: 'bold'
            }
          }
        }
      }
    };
  },
  created: function created() {
    this.loadCompromissosPorAno();
  },

  methods: {
    loadCompromissosPorAno: function loadCompromissosPorAno() {
      var _this = this;

      this.$store.dispatch('plano_governo/loadCompromissosAno', this.anoPlano);

      this.$nextTick(function () {
        if (_this.$refs.compromissoTable) {
          _this.$refs.compromissoTable.refresh();
        }
      });
    },
    pesquisar: function pesquisar() {
      this.$refs.compromissoTable.refresh();
    },
    getStatusClass: function getStatusClass(status) {
      if (!status) return '';
      var statusSemAcentos = status.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      var statusNormalized = statusSemAcentos.toLowerCase().replace(/\s+/g, '-');
      return 'status-' + statusNormalized;
    },
    abrirSidePanel: function abrirSidePanel(acoes) {
      var counts = acoes.reduce(function (acc, acao) {
        var status = acao.status || 'Não Informado';
        acc[status] = (acc[status] || 0) + 1;
        return acc;
      }, {});

      this.sidePanelChartData = {
        labels: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(counts),
        datasets: [{
          data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(counts),
          backgroundColor: __WEBPACK_IMPORTED_MODULE_5__utils_colors__["a" /* default */].coresHexa,
          color: '#FFF'
        }]
      };

      this.acoesSidePanel = acoes;
      this.isSidePanelOpen = true;
    },
    fecharSidePanel: function fecharSidePanel() {
      var _this2 = this;

      this.isSidePanelOpen = false;
      setTimeout(function () {
        _this2.acoesSidePanel = [];
        _this2.sidePanelChartData = null;
        _this2.termoPesquisaAcoes = '';
      }, 300);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    compromissos: function compromissos(_ref) {
      var plano_governo = _ref.plano_governo;
      return plano_governo.compromissos;
    },
    isLoading: function isLoading(_ref2) {
      var plano_governo = _ref2.plano_governo;
      return plano_governo.loading;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapGetters */])('plano_governo', ['getSecretarias', 'getTotalCompromissosPorSecretaria', 'getTotalCompromissosPorStatus', 'getSecretariasComResumo']), {
    top5SecretariasCompromissos: function top5SecretariasCompromissos() {
      return this.getTotalCompromissosPorSecretaria.slice(0, 5);
    },
    resumoStatus: function resumoStatus() {
      return this.getTotalCompromissosPorStatus.filter(function (item) {
        return item.total > 0;
      }).map(function (item) {
        var singular = item.total === 1;
        var texto = '';

        switch (item.status) {
          case 'Concluído':
            texto = singular ? 'está <strong>concluído</strong>' : 'estão <strong>concluídos</strong>';
            break;
          case 'Em andamento':
            texto = singular ? 'está <strong>em andamento</strong>' : 'estão <strong>em andamento</strong>';
            break;
          case 'Não Iniciado':
            texto = singular ? 'não foi <strong>iniciado</strong>' : 'não foram <strong>iniciados</strong>';
            break;
          case 'Cancelado':
            texto = singular ? 'foi <strong>cancelado</strong>' : 'foram <strong>cancelados</strong>';
            break;
        }
        return { total: item.total, texto: texto };
      });
    },
    chartData: function chartData() {
      var secretarias = this.getTotalCompromissosPorSecretaria.map(function (item) {
        return item.sigla;
      });
      var valores = this.getTotalCompromissosPorSecretaria.map(function (item) {
        return item.total;
      });

      return {
        labels: secretarias,
        datasets: [{
          data: valores,
          label: 'Unidades',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_5__utils_colors__["a" /* default */].coresHexa,
          color: '#FFF'
        }]
      };
    },
    statusChartData: function statusChartData() {
      var label = this.getTotalCompromissosPorStatus.map(function (item) {
        return item.status;
      });
      var valores = this.getTotalCompromissosPorStatus.map(function (item) {
        return item.total;
      });

      return {
        labels: label,
        datasets: [{
          data: valores,
          label: 'Status',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_5__utils_colors__["a" /* default */].coresHexa,
          color: '#FFF'
        }]
      };
    },
    filtrosDataTable: function filtrosDataTable() {
      var filtros = {
        periodo: this.anoPlano
      };

      if (this.termoPesquisa) {
        filtros.pesquisa = this.termoPesquisa;
      }

      return filtros;
    },
    acoesFiltradas: function acoesFiltradas() {
      if (!this.acoesSidePanel || this.acoesSidePanel.length === 0) {
        return [];
      }
      if (!this.termoPesquisaAcoes) {
        return this.acoesSidePanel;
      }
      var termo = this.termoPesquisaAcoes.toLowerCase();
      return this.acoesSidePanel.filter(function (acao) {
        var descritivo = acao.descritivo ? acao.descritivo.toLowerCase() : '';
        var status = acao.status ? acao.status.toLowerCase() : '';
        var nomeUnidade = acao.nome_unidade ? acao.nome_unidade.toLowerCase() : '';
        return descritivo.includes(termo) || status.includes(termo) || nomeUnidade.includes(termo);
      });
    }
  })
});

/***/ }),

/***/ "Ot2a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P/0t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P3He":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P4Ur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLG_vue__ = __webpack_require__("1s5Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19babd93_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardLG_vue__ = __webpack_require__("zXfg");
function injectStyle (ssrContext) {
  __webpack_require__("a9qp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19babd93"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLG_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19babd93_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardLG_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PCOT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("kHjm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f92f0ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("Amox");
function injectStyle (ssrContext) {
  __webpack_require__("Ft+B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f92f0ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f92f0ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PNKD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return planoGoverno; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_plano_governo__ = __webpack_require__("eKWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_plano_governo_Details__ = __webpack_require__("n9qF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_plano_governo_Edit__ = __webpack_require__("ncxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_admin_plano_governo_Save__ = __webpack_require__("q9aI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_admin_plano_governo_compromisso_Importar__ = __webpack_require__("tBvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_admin_plano_governo_compromisso_EditarResponsaveis__ = __webpack_require__("qNDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_admin_plano_governo_compromisso_MeusCompromissos__ = __webpack_require__("1M8D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_admin_plano_governo_compromisso_GestaoCompromissos__ = __webpack_require__("5Os7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_admin_plano_governo_acao_Save__ = __webpack_require__("b3FG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_admin_plano_governo_acao_Edit__ = __webpack_require__("vWku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_admin_plano_governo_acao_MinhasAcoes__ = __webpack_require__("CqCt");












var planoGoverno = [{
  name: 'admin_planogoverno',
  path: 'planogoverno/',
  component: __WEBPACK_IMPORTED_MODULE_0__views_admin_plano_governo__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_planogoverno_details',
  path: 'planogoverno/details/:id',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin_plano_governo_Details__["a" /* default */],
  props: true,
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_planogoverno_edit',
  path: 'planogoverno/edit/:id',
  component: __WEBPACK_IMPORTED_MODULE_2__views_admin_plano_governo_Edit__["a" /* default */],
  props: true,
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_planogoverno_save',
  path: 'planogoverno/save/',
  component: __WEBPACK_IMPORTED_MODULE_3__views_admin_plano_governo_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_planogoverno_compromisso_import',
  path: 'planogoverno/compromisso/importar',
  component: __WEBPACK_IMPORTED_MODULE_4__views_admin_plano_governo_compromisso_Importar__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_planogoverno_compromisso_editar',
  path: 'planogoverno/compromisso/editar',
  component: __WEBPACK_IMPORTED_MODULE_5__views_admin_plano_governo_compromisso_EditarResponsaveis__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_planogoverno_meus_compromissos',
  path: 'planogoverno/compromisso',
  component: __WEBPACK_IMPORTED_MODULE_6__views_admin_plano_governo_compromisso_MeusCompromissos__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_planogoverno_acao_save',
  path: 'planogoverno/compromisso/acao/save/:id',
  props: true,
  component: __WEBPACK_IMPORTED_MODULE_8__views_admin_plano_governo_acao_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_planogoverno_acao_edit',
  path: 'planogoverno/compromisso/acao/edit/:id',
  props: true,
  component: __WEBPACK_IMPORTED_MODULE_9__views_admin_plano_governo_acao_Edit__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_planogoverno_minhas_acoes',
  path: 'planogoverno/acao',
  component: __WEBPACK_IMPORTED_MODULE_10__views_admin_plano_governo_acao_MinhasAcoes__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_planogoverno_gestao_compromissos',
  path: 'planogoverno/gestao-compromisso',
  component: __WEBPACK_IMPORTED_MODULE_7__views_admin_plano_governo_compromisso_GestaoCompromissos__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}];

/***/ }),

/***/ "PO1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vuetable',{ref:"vuetable",attrs:{"api-url":_vm.restUrl,"api-mode":_vm.apiMode,"fields":_vm.fields,"css":_vm.css.table,"data-path":_vm.dataPath,"data":_vm.data,"http-options":_vm.auth,"pagination-path":_vm.paginationPath,"per-page":_vm.itemsPerPage,"append-params":_vm.params,"sort-order":_vm.sortOrder,"muti-sort":_vm.multiSort,"multi-sort-key":_vm.multiSortKey,"no-data-template":"Nenhum registro encontrado."},on:{"vuetable:loading":function($event){_vm.carregando = true},"vuetable:loaded":function($event){_vm.carregando = false},"vuetable:pagination-data":_vm.onPaginationData,"vuetable:load-success":_vm.onSuccess,"vuetable:load-error":_vm.onError},scopedSlots:_vm._u([{key:"icon",fn:function(props){return [_vm._t("icon",null,{"rowData":props.rowData})]}},{key:"column",fn:function(props){return [_vm._t("columncustom",null,{"rowData":props.rowData})]}},{key:"actions",fn:function(props){return [_vm._t("rowrender",null,{"rowData":props.rowData})]}}],null,true)},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('template',{slot:"noDataTemplate"},[_c('pulse-loader',{attrs:{"loading":_vm.carregando}})],1)],2),_vm._v(" "),_c('pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"icons":_vm.css.icons},on:{"vuetable-pagination:change-page":_vm.onChangePage}}),_vm._v(" "),_c('pagination-info',{directives:[{name:"show",rawName:"v-show",value:(_vm.paginationInfoShow),expression:"paginationInfoShow"}],ref:"paginationInfo",staticClass:"pull-left",attrs:{"css":_vm.css.paginationInfo,"info-template":"Registro(s) {from} ao {to} de um total de {total}","no-data-template":""}}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PbIO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreHabilitados_vue__ = __webpack_require__("1/s7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fe4a8e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreHabilitados_vue__ = __webpack_require__("VhEU");
function injectStyle (ssrContext) {
  __webpack_require__("QFKt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fe4a8e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreHabilitados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fe4a8e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreHabilitados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PcZr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: null,
      required: true
    },
    options: {
      type: Array
    },
    showOptionEmpty: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),

/***/ "PeW4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pine":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("xSGT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315ff350_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Z0Eb");
function injectStyle (ssrContext) {
  __webpack_require__("k4YG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-315ff350"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315ff350_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PmNd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Select__ = __webpack_require__("MGJx");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Select: __WEBPACK_IMPORTED_MODULE_0__components_common_Select__["a" /* default */]
  },
  props: {
    value: [String],
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      scaleList: [{ label: 'Administrativo', value: 'adm' }, { label: 'Plantão Impar', value: 'impar' }, { label: 'Plantão Par', value: 'par' }, { label: 'Personalizado', value: '*' }],
      scale: ''
    };
  },

  watch: {
    scale: function scale(value) {
      this.update(value);
    },
    value: function value(_value) {
      this.scale = _value;
    }
  },
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),

/***/ "Pmya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},_vm._l((_vm.sides),function(side){return _c('side-modal',{key:side.identidade,attrs:{"tit":side.titulo,"subtit":side.subtitulo,"subtDetl":side.subtDetalhe,"larg":side.largura,"id":side.identidade,"abreMaisUm":side.abreProximo,"aberto":side.aberto},on:{"fechou":function($event){return _vm.fechaFromChild(side)},"abreFromChild":function($event){_vm.abreSide(_vm.sides[_vm.sides.indexOf(side) + 1])},"largura":_vm.minima}},[_vm._t(side.identidade)],2)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PoxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emendasGeral__ = __webpack_require__("uHUi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_dist_vuex_common_js__ = __webpack_require__("9xAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_dist_vuex_common_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_dist_vuex_common_js__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_4__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components__["b" /* Breadcrumb */],
    DataTable: __WEBPACK_IMPORTED_MODULE_4__components__["n" /* NoApiTable */],
    SideEmendas: __WEBPACK_IMPORTED_MODULE_4__components__["o" /* SideEmendas */],
    SelectAnoEmendas: __WEBPACK_IMPORTED_MODULE_4__components__["p" /* SelectAnoEmendas */],
    ValorDestaqueHeader: __WEBPACK_IMPORTED_MODULE_4__components__["q" /* ValorDestaqueHeader */]
  },
  data: function data() {
    return {
      secretaria: 'Secretaria selecionada',
      emendaSelecionada: {},
      breadcrumb: [],
      navs: __WEBPACK_IMPORTED_MODULE_6__emendasGeral__["a" /* navs */],
      dataFields: __WEBPACK_IMPORTED_MODULE_6__emendasGeral__["b" /* dataFields */],
      filtros: {
        descricao: ''
      }
    };
  },
  created: function created() {
    var secretaria = this.$route.params.secretaria;

    this.secretaria = secretaria;

    this.fillBreadcrumb();
  },

  methods: {
    showDetails: function showDetails(emenda) {
      var _navs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(this.navs, 1),
          nav = _navs[0];

      nav.titulo = 'Detalhes da emenda';
      nav.subtitulo = 'Emenda n\xBA ' + emenda.numero + ' / ' + emenda.ano;
      nav.subtDetalhe = emenda.nome_orgao;
      this.emendaSelecionada = emenda;

      this.$refs['side-emendas'].$emit('abreModal', nav.identidade);
    },
    getPercent: function getPercent(parte, todo) {
      if (todo) {
        return (parte / todo * 100).toLocaleString(undefined, {
          maximumFractionDigits: 1
        });
      }

      return '0';
    },
    fillBreadcrumb: function fillBreadcrumb() {
      this.breadcrumb = [{
        label: 'Emendas Parlamentares',
        named_link: { name: 'emendas_parlamentares' }
      }, {
        label: 'Emendas Por Secretaria',
        named_link: { name: 'emendas_por_area' }
      }, {
        label: this.secretaria
      }];
    },

    formatarMoeda: __WEBPACK_IMPORTED_MODULE_5__utils__["e" /* formatarMoeda */],
    downloadToCSV: function downloadToCSV() {
      var headers = {
        numero: 'Emenda nº',
        vereador: 'Vereador',
        secretaria: 'Secretaria',
        descricao: 'Descrição',
        valor: 'Valor',
        saldo: 'Saldo'
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* exportCSVFile */])(headers, [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.emendasDaSecretaria.map(function (item) {
        return {
          numero: item.numero,
          vereador: item.vereador.nome,
          secretaria: item.nome_orgao,
          descricao: item.descricao,
          valor: Number(item.valor).toFixed(2).replace('.', ','),
          saldo: Number(item.saldo).toFixed(2).replace('.', ',')
        };
      }))), 'emendas');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    emendas: function emendas(state) {
      return state.emendas_parlamentares.emendas;
    },
    loading: function loading(state) {
      return state.emendas_parlamentares.loading;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex_dist_vuex_common_js__["mapGetters"])(['emendasPorSecretaria', 'valorTotalPorSecretaria', 'saldoTotalPorSecretaria']), {
    utilizadosComPercentual: function utilizadosComPercentual() {
      var percentual = this.getPercent(this.valorTotalUtilizado, this.valorTotalSecretaria);

      return this.formatarMoeda(this.valorTotalUtilizado) + ' (' + percentual + ' %)';
    },
    saldoComPercentual: function saldoComPercentual() {
      var percentual = this.getPercent(this.saldoTotalSecretaria, this.valorTotalSecretaria);

      return this.formatarMoeda(this.saldoTotalSecretaria) + ' (' + percentual.toLocaleString() + ' %)';
    },
    emendasDaSecretaria: function emendasDaSecretaria() {
      var _this = this;

      var emendasSecretaria = this.emendasPorSecretaria(this.secretaria);

      if (this.filtros.descricao) {
        var filter = function filter(item) {
          var vereador = item.vereador,
              descricao = item.descricao;


          var termo = _this.filtros.descricao.toUpperCase();
          return vereador.nome.toUpperCase().includes(termo) || descricao.toUpperCase().includes(termo);
        };

        return emendasSecretaria.filter(filter);
      }

      return emendasSecretaria;
    },
    valorTotalSecretaria: function valorTotalSecretaria() {
      return this.valorTotalPorSecretaria(this.secretaria);
    },
    saldoTotalSecretaria: function saldoTotalSecretaria() {
      return this.saldoTotalPorSecretaria(this.secretaria);
    },
    valorTotalUtilizado: function valorTotalUtilizado() {
      return this.valorTotalSecretaria - this.saldoTotalSecretaria;
    }
  })
});

/***/ }),

/***/ "Pzp/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detalhes-beneficios"},[_c('div',{staticClass:"row"},[_c('public-header',{attrs:{"title":_vm.beneficio.nome}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.descricao_limpa)}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('bar-chart',{ref:"beneficios_mensais",attrs:{"chart-data":_vm.graficoHeader,"gradiente":false,"coloredLine":true,"options":{
            responsive: true,
            maintainAspectRatio: false,
            title: {
              display: true,
              text: 'Benefícios Mensais',
              fontColor: '#C1D1C1'
            },
            legend: {
              display: true,
              labels: {
                fontColor: '#C1D1C1',
              },
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    suggestedMax: 50,
                    fontColor: '#C1D1C1',
                    callback: function (value, index, values) {
                      return value.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })
                    },
                  },
                } ],
              xAxes: [
                {
                  maxBarThickness: 50,
                  ticks: {
                    fontColor: '#C1D1C1',
                  },
                } ],
            },
            tooltips: {
              callbacks: {
                label: function (tooltip, dataset) {
                  var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                  return 'Valor: ' + yLabel
                },
              },
            },
          }}}),_vm._v(" "),_c('p',[_vm._v("Total de benefícios: "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s((_vm.total_ano.total).toLocaleString()))])]),_vm._v(" "),_c('p',[_vm._v("Valor total: "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.formatarMoeda(Number(_vm.total_ano.valor))))])])],1)])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":'/assistencia'}},[_vm._v("Benefícios Assistenciais")])],1),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.beneficio.nome))])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-sm-4"},[_c('label',[_vm._v("Mês de referência")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.mes),expression:"filtros.mes"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "mes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.atualizaGrid()}]}},[_c('option',{attrs:{"value":""}},[_vm._v("-- Selecione --")]),_vm._v(" "),_vm._l((_vm.meses),function(mes,index){return _c('option',{key:mes,domProps:{"value":index + 1}},[_vm._v("\n            "+_vm._s(mes)+"\n          ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('label',[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.nome),expression:"filtros.nome"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Digite o nome que deseja filtrar..."},domProps:{"value":(_vm.filtros.nome)},on:{"change":function($event){return _vm.atualizaGrid()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "nome", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table',{ref:"dt",attrs:{"has-auth":false,"api-url":"assistencia/pagamentos/listar","show-empty":true,"fields":_vm.fields,"append-params":_vm.filtros},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.retornarPeriodo(props.rowData))+"\n          ")]}}])})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Lista de Beneficiados")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q7mu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QALr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("4e97");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28dc670e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("ErQj");
function injectStyle (ssrContext) {
  __webpack_require__("rc/t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28dc670e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28dc670e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QB41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common___ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_side_modal__ = __webpack_require__("fc38");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dados_escola',
  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_3__components_common___["d" /* BarChart */],
    SideBar: __WEBPACK_IMPORTED_MODULE_4__components_common_side_modal__["a" /* default */]
  },
  data: function data() {
    return {
      model: {},
      alunos: {
        totalAlunos: 0,
        vagasAlunos: [],
        por_curso: { labels: [], datasets: [{ label: '', data: [] }] },
        por_turma: { labels: [], datasets: [{ label: '', data: [] }] },
        por_periodo: { labels: [], datasets: [{ label: '', data: [] }] }
      },
      navs: [{
        titulo: 'Funcionários',
        subtitulo: '',
        subtDetalhe: '',
        largura: 900,
        identidade: 'funcionarios',
        abreProximo: true,
        aberto: false
      }],
      navs2: [{
        titulo: 'Localização',
        subtitulo: '',
        subtDetalhe: '',
        largura: 900,
        identidade: 'sigsantos',
        abreProximo: true,
        aberto: false
      }],
      funcionarios: {
        totalFuncionarios: 0,
        por_cargo: [],
        selecionado: ''
      },
      ideb: {
        '272': '35069607',
        '221': '35075668',
        '227': '35203828',
        '267': '35056145',
        '264': '35056236',
        '268': '35203804',
        '266': '35056108',
        '832': '35390872',
        '233': '35056170',
        '262': '35194864',
        '218': '35203836',
        '228': '35078924',
        '229': '35076843',
        '237': '35207093',
        '1495': '35429983',
        '269': '35056121',
        '224': '35089977'
      }
    };
  },

  methods: {
    dadosGrafico: function dadosGrafico(array, label, subitem, sublabel) {
      var base = { labels: [], datasets: [{ label: label, data: [] }] };
      var sub = { label: sublabel, data: [] };
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(array);
      base.labels = keys;

      for (var index = 0; index < keys.length; index++) {
        base.datasets[0].data.push(array[keys[index]].length);

        if (subitem !== undefined) {
          sub.data.push(array[keys[index]][0][subitem]);
        }
      }

      if (subitem !== undefined) {
        base.datasets.push(sub);
      }
      return base;
    },
    abrir: function abrir(identidade, id) {
      this.$emit('abreModal', identidade);
      this.funcionarios.selecionado = this.funcionarios.por_cargo[id][0].cargo;
    },
    abrirMapa: function abrirMapa(identidade) {
      this.$emit('abreModal', identidade);
    }
  },
  computed: {
    totalVagas: function totalVagas() {
      var total = 0;

      for (var key in this.alunos.vagasAlunos) {
        if (this.alunos.vagasAlunos.hasOwnProperty(key)) {
          total += parseInt(this.alunos.vagasAlunos[key][0].vagas);
        }
      }

      return total;
    },
    capacidadeMaxima: function capacidadeMaxima() {
      var total = 0;

      for (var key in this.alunos.vagasAlunos) {
        if (this.alunos.vagasAlunos.hasOwnProperty(key)) {
          total += parseInt(this.alunos.vagasAlunos[key][0].quantidademaxima);
        }
      }

      return total;
    },
    vagasExcedentes: function vagasExcedentes() {
      return this.totalVagas - this.alunos.totalAlunos;
    },
    vagasPorCurso: function vagasPorCurso() {
      var _this = this;

      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.alunos.vagasAlunos);
      var capacidadeCurso = { porcurso: {}, porperiodo: {} };
      var sub = {
        porcurso: { label: 'Capacidade', data: [] },
        porperiodo: { label: 'Capacidade', data: [] }
      };
      var aux = 0;

      keys.forEach(function (key) {
        if (capacidadeCurso.porcurso[_this.alunos.vagasAlunos[key][0].curso] === undefined) {
          capacidadeCurso.porcurso[_this.alunos.vagasAlunos[key][0].curso] = 0;
        }

        if (capacidadeCurso.porperiodo[_this.alunos.vagasAlunos[key][0].periodo] === undefined) {
          capacidadeCurso.porperiodo[_this.alunos.vagasAlunos[key][0].periodo] = 0;
        }

        aux = parseInt(_this.alunos.vagasAlunos[key][0].vagas);
        capacidadeCurso.porcurso[_this.alunos.vagasAlunos[key][0].curso] += aux;
        capacidadeCurso.porperiodo[_this.alunos.vagasAlunos[key][0].periodo] += aux;
      });

      sub.porcurso.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(capacidadeCurso.porcurso);
      sub.porperiodo.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(capacidadeCurso.porperiodo);

      return sub;
    }
  },
  beforeMount: function beforeMount() {
    window.scrollTo(0, 0);
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('educacao/listarEscolas?codigo=' + this.$route.query.escola).then(function (response) {
      var data = response.data;

      _this2.model = data.data;
    }).catch(function (e) {
      console.log(e);
    });

    __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('educacao/alunos/' + this.$route.query.escola).then(function (response) {
      var data = response.data;

      _this2.alunos.totalAlunos = data.data.totalAlunos;
      _this2.alunos.vagasAlunos = data.data.porTurma;

      _this2.alunos.por_curso = _this2.dadosGrafico(data.data.porCurso, 'Alunos');
      _this2.alunos.por_curso.datasets.push(_this2.vagasPorCurso.porcurso);

      _this2.alunos.por_periodo = _this2.dadosGrafico(data.data.porPeriodo, 'Alunos');
      _this2.alunos.por_periodo.datasets.push(_this2.vagasPorCurso.porperiodo);

      _this2.alunos.por_turma = _this2.dadosGrafico(data.data.porTurma, 'Alunos', 'vagas', 'Capacidade');
    }).catch(function (e) {
      console.log(e);
    });

    __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('educacao/funcionarios/' + this.$route.query.escola).then(function (response) {
      var data = response.data;

      _this2.funcionarios.totalFuncionarios = data.data.totalFuncionarios;
      _this2.funcionarios.por_cargo = data.data.porCargo;
    }).catch(function (e) {
      console.log(e);
    });
  }
});

/***/ }),

/***/ "QFKt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QFkB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QKAJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("\n            Cadastrar Ação\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12"},[_c('SelectFuncionario',{ref:"SelectFuncionario",attrs:{"label":'Funcionário Responsável',"name":'sshd_responsavel',"placeholder":'Pesquise pelo nome ou SSHD',"is-required":true},model:{value:(_vm.model.sshd_responsavel),callback:function ($$v) {_vm.$set(_vm.model, "sshd_responsavel", $$v)},expression:"model.sshd_responsavel"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error' : _vm.errors.has('ordem') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Ordem")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'list-ol'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ordem),expression:"model.ordem"},{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],ref:"ordem",staticClass:"form-control",attrs:{"type":"number","min":"1","placeholder":"Ordem da ação","name":"ordem"},domProps:{"value":(_vm.model.ordem)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ordem", $event.target.value)}}})])]),_vm._v(" "),(_vm.errors.has('ordem'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"ordem"}},[_vm._v("\n                            Preenchimento obrigatório!\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('unidade') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Unidade")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'sitemap'}})],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.unidade),expression:"model.unidade"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"unidade",staticClass:"form-control select-selected",attrs:{"name":"unidade"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "unidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selecione a unidade")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Secretarias"}},_vm._l((_vm.listas.secretarias),function(s){return _c('option',{key:s.sigla,attrs:{"title":s.nome},domProps:{"value":s.sigla}},[_vm._v("\n                                            "+_vm._s(s.sigla)+"\n                                        ")])}),0),_vm._v(" "),_c('optgroup',{attrs:{"label":"Autarquias"}},_vm._l((_vm.listas.autarquias),function(a){return _c('option',{key:a.sigla,attrs:{"title":a.nome},domProps:{"value":a.sigla}},[_vm._v("\n                                            "+_vm._s(a.sigla)+"\n                                        ")])}),0)])])]),_vm._v(" "),(_vm.errors.has('unidade'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"unidade"}},[_vm._v("\n                            Preenchimento obrigatório!\n                        ")]):_vm._e()])]),_vm._v(" "),(_vm.compromisso.unidade_executora === _vm.model.unidade)?_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Data de início estimada")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'calendar-alt'}})],1),_vm._v(" "),_c('datepicker',{model:{value:(_vm.model.data_estimada_inicio),callback:function ($$v) {_vm.$set(_vm.model, "data_estimada_inicio", $$v)},expression:"model.data_estimada_inicio"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Data de conclusão estimada")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'calendar-alt'}})],1),_vm._v(" "),_c('datepicker',{model:{value:(_vm.model.data_estimada_conclusao),callback:function ($$v) {_vm.$set(_vm.model, "data_estimada_conclusao", $$v)},expression:"model.data_estimada_conclusao"}})],1)])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('descritivo') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Descritivo")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'comment'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descritivo),expression:"model.descritivo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"descritivo",staticClass:"form-control",attrs:{"placeholder":"Descreva a ação...","maxlength":"1000","name":"descritivo","rows":"8"},domProps:{"value":(_vm.model.descritivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descritivo", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(1000 - _vm.model.descritivo.length)}})])]),_vm._v(" "),(_vm.errors.has('descritivo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"descritivo"}},[_vm._v("\n                            Preenchimento obrigatório!\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.unidade !== _vm.compromisso.unidade_executora),expression:"model.unidade !== compromisso.unidade_executora"}],staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('justificativa_criacao') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Justificativa de Criação")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'comment'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.justificativa_criacao),expression:"model.justificativa_criacao"},{name:"validate",rawName:"v-validate",value:({ required: _vm.model.unidade !== _vm.compromisso.unidade_executora }),expression:"{ required: model.unidade !== compromisso.unidade_executora }"}],ref:"justificativa_criacao",staticClass:"form-control",attrs:{"placeholder":"Justifique a criação da ação...","maxlength":"1000","name":"justificativa_criacao","rows":"8"},domProps:{"value":(_vm.model.justificativa_criacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "justificativa_criacao", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(1000 - _vm.model.justificativa_criacao.length)}})])]),_vm._v(" "),(_vm.errors.has('justificativa_criacao'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"justificativa_criacao"}},[_vm._v("\n                            Preenchimento obrigatório!\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 margem-bottom"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{class:'fa-long-arrow-alt-left-white',attrs:{"icon":'long-arrow-alt-left'}}),_vm._v(" Voltar\n                    ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.validar()}}},[_c('font-awesome-icon',{class:'fa-save-white',attrs:{"icon":'save'}}),_vm._v(" Salvar\n                    ")],1)])])]),_vm._v(" "),_c('SideAcao',{ref:"side",attrs:{"navs":_vm.sideConfig},on:{"confirmarReordenacao":function($event){return _vm.save()}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QLW5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return metas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_metas__ = __webpack_require__("Pine");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_metas_Save__ = __webpack_require__("Xnd0");



var metas = [{
  path: 'metas/list',
  component: __WEBPACK_IMPORTED_MODULE_0__views_admin_metas__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}, {
  name: 'admin_metas_save',
  path: 'metas/save/:id?',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin_metas_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}];

/***/ }),

/***/ "QMQn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QMwt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detalhe-unidade"},[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":_vm.nomeUnidade}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_c('span',{staticClass:"label"},[_vm._v("Endereço:")]),_vm._v("\n          "+_vm._s(_vm.infoEndereco)+"\n        ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v("Telefone:")]),_vm._v("\n          "+_vm._s(_vm.infoTelefone)+"\n        ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"label"},[_vm._v("Atendimento:")]),_vm._v("\n          "+_vm._s(_vm.infoUnidade)+"\n        ")])]),_vm._v(" "),(_vm.coordenadas.lat)?_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('OpenMap',{attrs:{"latitute":_vm.coordenadas.lat,"longitude":_vm.coordenadas.lon,"zoom":_vm.zoom,"pins":_vm.pins,"icon":_vm.icon,"popupPoint":_vm.popupPoint}})],1):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),(_vm.remedio.principio_ativo)?_c('div',{staticClass:"row"},[(_vm.remedio.orientacao)?_c('div',{staticClass:"col-xs-12 form-group"},[_c('CriterioRemedio',{attrs:{"remedio":_vm.remedio}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',{staticClass:"font-lg"},[_vm._v("\n            Além do item\n            "),_c('span',{staticClass:"destaque"},[_vm._v("\n              "+_vm._s(_vm.remedio.principio_ativo)+"\n            ")]),_vm._v("\n            , veja outros itens disponíveis nesta unidade.\n          ")])])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.carregando.listaMedicamentos)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-center"},[_c('font-awesome-icon',{attrs:{"icon":'spinner',"size":"3x","spin":""}})],1)]):_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('Label',[_vm._v("Pesquisar na lista")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termoFiltro),expression:"termoFiltro"}],ref:"filtro-medicamentos",staticClass:"form-control input-pesquisar",attrs:{"type":"tex","placeholder":"Digite sua busca..."},domProps:{"value":(_vm.termoFiltro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.termoFiltro=$event.target.value}}})],1)]),_vm._v(" "),(!_vm.carregando.listaMedicamentos)?_c('div',{staticClass:"row"},_vm._l((_vm.disponiveisUnidadeFiltered),function(medicamento,index){return _c('div',{key:((medicamento.principio_ativo) + "-" + (medicamento.id_princ_ativo) + "-" + (medicamento.cota)),staticClass:"col-xs-12"},[_c('div',{class:[
              index % 2 === 0 ? 'background-dark' : 'background-light',
              'font-lg',
              'padding-table',
              _vm.isUnavailable(medicamento) ? 'indisponivel' : ''
            ]},[_c('p',{class:[
                'table-remedio',
                medicamento.orientacao ? 'espacamento' : ''
              ]},[_c('router-link',{attrs:{"to":{
                  name: 'unidades-remedio',
                  params: {
                    principio: medicamento.principio_ativo
                  }
                }}},[_vm._v("\n                "+_vm._s(medicamento.principio_ativo)+"\n              ")]),_vm._v(" "),(_vm.isUnavailable(medicamento))?_c('span',[_vm._v("\n                - Indisponível no momento\n              ")]):_vm._e()],1),_vm._v(" "),(medicamento.portaria === '344/98')?_c('p',{staticClass:"table-remedio orientacao"},[_vm._v("\n              Medicamento Controlado - Portaria 344/98\n            ")]):_vm._e(),_vm._v(" "),(medicamento.portaria === '471/2021')?_c('p',{staticClass:"table-remedio orientacao"},[_vm._v("\n              Medicamento Antimicrobiano - RDC 471/2021\n            ")]):_vm._e(),_vm._v(" "),(medicamento.orientacao)?_c('p',{staticClass:"table-remedio orientacao espacamento",domProps:{"innerHTML":_vm._s(_vm.getDescricaoOrientacao(medicamento))}}):_vm._e()])])}),0):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n            Lista de medicamentos da unidade\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QQYU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Z1i1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89ec5820_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("EYYY");
function injectStyle (ssrContext) {
  __webpack_require__("FW/n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-89ec5820"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89ec5820_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QZPo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QZjH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graficos_vue__ = __webpack_require__("Dtw2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3847a269_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Graficos_vue__ = __webpack_require__("tYv3");
function injectStyle (ssrContext) {
  __webpack_require__("gp6J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3847a269"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graficos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3847a269_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Graficos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qiie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_compare_vue__ = __webpack_require__("B3Jd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0727f79c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_compare_vue__ = __webpack_require__("m437");
function injectStyle (ssrContext) {
  __webpack_require__("L8FY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_compare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0727f79c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_compare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env_json__ = __webpack_require__("ufme");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__env_json__);


/* harmony default export */ __webpack_exports__["a"] = ({
  sistema: {
    nome: 'Dados Abertos',
    sigla: 'dadosabertos',
    descricao: 'Sistema para exibição de dados abertos'
  },
  apiUrl: __WEBPACK_IMPORTED_MODULE_0__env_json___default.a.apiUrl,
  imgUrl: __WEBPACK_IMPORTED_MODULE_0__env_json___default.a.imgUrl
});

/***/ }),

/***/ "Qq6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":"Dívida Ativa"}},[_c('div',{staticClass:"col-xs-12 col-sm-8 col-lg-6"},[_c('p',[_vm._v("\n          Aqui você encontra a lista de devedores cadastrados junto à Dívida\n          Ativa do Município de Santos.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Você pode efetuar a consulta por página, ou digitando um nome para a\n          busca.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          O quadro indicará o nome do contribuínte bem como a origem e o valor\n          da dívida.\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('main',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":[{ label: 'Dívida Ativa' }]}}),_vm._v(" "),_c('div',{staticClass:"row margem-bottom"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n            Lista de Devedores\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.downloadPaginaDividaAtiva()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}}),_vm._v(" Exportar para CSV\n          ")],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('label',{attrs:{"for":"filtro"}},[_vm._v("Filtrar por nome")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nome),expression:"nome"}],staticClass:"form-control",attrs:{"type":"text","id":"filtro"},domProps:{"value":(_vm.nome)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.filterByName()},"input":function($event){if($event.target.composing){ return; }_vm.nome=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.filterByName()}}},[_c('font-awesome-icon',{attrs:{"icon":'search'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Filtrar nome")])],1)])])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-center loading"},[_vm._v("\n          Carregando "),_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}})],1)]):_c('div',[(_vm.total === 0)?_c('div',[_c('div',{staticClass:"col-xs-12 text-center loading"},[_vm._v("\n            Nenhum item encontrado!\n          ")])]):_c('div',[_c('Paginacao',{attrs:{"total":_vm.total},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._l((_vm.devedores),function(devedor,index){return _c('div',{key:(index + "-devedor"),class:['row linha', index % 2 === 0 ? 'even' : '']},[_c('div',{staticClass:"col-xs-12 col-sm-5"},[_vm._v("\n              "+_vm._s(devedor.NMCONTRIBUINTE)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-5"},[_vm._v("\n              "+_vm._s(devedor.QTDIVIDA)+" dívida(s) de \""+_vm._s(devedor.DLCOBRANCA)+"\"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n              "+_vm._s(_vm.formatarMoeda(devedor.VLACUMULADO))+"\n            ")])])}),_vm._v(" "),_c('Paginacao',{attrs:{"total":_vm.total},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],2)])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row linha-header"},[_c('div',{staticClass:"col-xs-12 col-sm-5"},[_c('span',[_vm._v("Contribuinte")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-5"},[_c('span',[_vm._v("Cobrança")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_c('span',[_vm._v("Valor da Dívida")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QzpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__("zS3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");




var loadByKey = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(url) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('eleicoes-conselho/' + url);

          case 3:
            response = _context.sent;
            return _context.abrupt('return', response.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);

            console.log(_context.t0);
            return _context.abrupt('return', []);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));

  return function loadByKey(_x) {
    return _ref.apply(this, arguments);
  };
}();




function sortCandidatos(data) {
  return data.sort(function (a, b) {
    if (a.total_votos < b.total_votos) {
      return 1;
    }

    if (a.total_votos > b.total_votos) {
      return -1;
    }

    var dateA = new Date(a.data_nascimento);
    var dateB = new Date(b.data_nascimento);
    if (dateA > dateB) {
      return 1;
    }

    if (dateA < dateB) {
      return -1;
    }

    return 0;
  });
}

var actions = {
  loadCandidatos: function loadCandidatos(store) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var data, reducer, candidatos;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return loadByKey('candidatos');

            case 2:
              data = _context2.sent;

              reducer = function reducer(acum, atual) {
                return acum += Number(atual.total_votos);
              };

              candidatos = sortCandidatos(data.map(function (candidato) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, candidato, {
                  total_votos: candidato.votos.reduce(reducer, 0)
                });
              }));


              store.commit(__WEBPACK_IMPORTED_MODULE_3__types__["a" /* LOAD_CANDIDATOS */], candidatos.map(function (candidato, index) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, candidato, {
                  posicao: index + 1
                });
              }));

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  loadVotos: function loadVotos(store) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return loadByKey('votos');

            case 2:
              data = _context3.sent;

              store.commit(__WEBPACK_IMPORTED_MODULE_3__types__["b" /* LOAD_VOTOS */], data);

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  }
};

var getters = {
  votosTotais: function votosTotais(state) {
    var reducer = function reducer(key) {
      return function (acum, atual) {
        return acum += Number(atual[key]) || 0;
      };
    };

    var total_nominais = state.votos.reduce(reducer('total_nominais'), 0);
    var total_brancos = state.votos.reduce(reducer('total_brancos'), 0);
    var total_nulos = state.votos.reduce(reducer('total_nulos'), 0);

    return {
      total_nominais: total_nominais,
      total_brancos: total_brancos,
      total_nulos: total_nulos,
      total_geral: total_nominais + total_brancos + total_nulos
    };
  }
};

/***/ }),

/***/ "QzpN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("7rxZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7e5d54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("cklB");
function injectStyle (ssrContext) {
  __webpack_require__("eTq4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f7e5d54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7e5d54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R+m3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "R7GV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_DataTablePublic__ = __webpack_require__("+Mmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_colors__ = __webpack_require__("ZAg2");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PorSecretaria',
  components: {
    DataTablePublic: __WEBPACK_IMPORTED_MODULE_4__components_common_DataTablePublic__["a" /* default */],
    PublicHeader: __WEBPACK_IMPORTED_MODULE_5__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_5__components__["b" /* Breadcrumb */],
    ValorDestaque: __WEBPACK_IMPORTED_MODULE_5__components__["c" /* ValorDestaque */],
    PieChart: __WEBPACK_IMPORTED_MODULE_5__components__["d" /* PieChart */]
  },
  data: function data() {
    return {
      anoPlano: '2025-2028',
      termoPesquisa: '',
      termoPesquisaAcoes: '',

      isSidePanelOpen: false,
      acoesSidePanel: [],
      sidePanelChartData: null,

      model: {
        columns: [{
          name: 'descritivo',
          title: 'Descritivo',
          dataClass: 'align-middle'
        }, {
          name: '__slot:column',
          title: 'Status',
          titleClass: 'text-center',
          dataClass: 'text-center align-middle'
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center',
          dataClass: 'text-center align-middle'
        }]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom'
        },
        tooltips: {
          callbacks: {
            label: function label(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var total = dataset.data.reduce(function (acc, val) {
                return acc + val;
              }, 0);
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = (currentValue / total * 100).toFixed(1) + '%';
              var label = data.labels[tooltipItem.index] || '';
              return label + ': ' + currentValue + ' (' + percentage + ')';
            }
          }
        },
        plugins: {
          datalabels: {
            color: function color(context) {
              var backgroundColor = context.dataset.backgroundColor[context.dataIndex];

              if (backgroundColor === '#222222' || backgroundColor === '#AD68A0' || backgroundColor === '#5C8A95') {
                return '#FFFFFF';
              }
            },
            font: {
              weight: 'bold'
            }
          }
        }
      },
      sideChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'right'
        },
        tooltips: {
          callbacks: {
            label: function label(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var total = dataset.data.reduce(function (acc, val) {
                return acc + val;
              }, 0);
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = (currentValue / total * 100).toFixed(1) + '%';
              var label = data.labels[tooltipItem.index] || '';
              return label + ': ' + currentValue + ' (' + percentage + ')';
            }
          }
        },
        plugins: {
          datalabels: {
            color: function color(context) {
              var backgroundColor = context.dataset.backgroundColor[context.dataIndex];

              if (backgroundColor === '#222222' || backgroundColor === '#AD68A0' || backgroundColor === '#5C8A95') {
                return '#FFFFFF';
              }
            },
            font: {
              weight: 'bold'
            }
          }
        }
      }
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    anoPlano: function anoPlano() {
      this.fetchData();
    },
    secretariaId: function secretariaId() {
      this.fetchData();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('plano_governo', ['loadCompromissosSecretaria']), {
    fetchData: function fetchData() {
      var _this = this;

      if (!this.secretariaId) return;

      this.loadCompromissosSecretaria({
        periodo: this.anoPlano,
        secretariaId: this.secretariaId
      });

      this.$nextTick(function () {
        if (_this.$refs.compromissosTable) {
          _this.$refs.compromissosTable.refresh();
        }
      });
    },
    pesquisar: function pesquisar() {
      this.$refs.compromissosTable.refresh();
    },
    getStatusClass: function getStatusClass(status) {
      if (!status) return '';

      var statusSemAcentos = status.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      var statusNormalized = statusSemAcentos.toLowerCase().replace(/\s+/g, '-');

      return 'status-' + statusNormalized;
    },
    abrirSidePanel: function abrirSidePanel(acoes) {
      var counts = acoes.reduce(function (acc, acao) {
        var status = acao.status || 'Não Informado';
        acc[status] = (acc[status] || 0) + 1;
        return acc;
      }, {});

      this.sidePanelChartData = {
        labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(counts),
        datasets: [{
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(counts),
          backgroundColor: __WEBPACK_IMPORTED_MODULE_6__utils_colors__["a" /* default */].coresHexa,
          color: '#FFF'
        }]
      };

      this.acoesSidePanel = acoes;
      this.isSidePanelOpen = true;
    },
    fecharSidePanel: function fecharSidePanel() {
      var _this2 = this;

      this.isSidePanelOpen = false;

      setTimeout(function () {
        _this2.acoesSidePanel = [];
        _this2.sidePanelChartData = null;
        _this2.termoPesquisaAcoes = '';
      }, 300);
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])('plano_governo', {
    compromissos: 'compromissosSecretaria',
    isLoading: 'loadingSecretaria'
  }), {
    secretariaId: function secretariaId() {
      return this.$route.params.secretaria;
    },
    filtrosDataTable: function filtrosDataTable() {
      var filtros = {
        unidade_executora: this.secretariaId,
        periodo: this.anoPlano
      };

      if (this.termoPesquisa) {
        filtros.pesquisa = this.termoPesquisa;
      }

      return filtros;
    },
    nomeDaSecretaria: function nomeDaSecretaria() {
      if (this.compromissos && this.compromissos.length > 0) {
        return this.compromissos[0].nome_unidade_executora;
      }
      return this.secretariaId;
    },
    statusCounts: function statusCounts() {
      if (!this.compromissos || this.compromissos.length === 0) {
        return {};
      }

      return this.compromissos.reduce(function (acc, compromisso) {
        var status = compromisso.status || 'Não Informado';
        acc[status] = (acc[status] || 0) + 1;
        return acc;
      }, {});
    },
    statusTexto: function statusTexto() {
      var counts = this.statusCounts;

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(counts).length === 0) {
        return '';
      }

      var ordemStatus = ['Não Iniciado', 'Em andamento', 'Concluído', 'Cancelado'];
      var frases = [];

      ordemStatus.forEach(function (status) {
        var count = counts[status] || 0;

        if (count > 0) {
          if (status === 'Não Iniciado') {
            if (count > 1) {
              frases.push(count + ' n\xE3o foram iniciados');
            } else {
              frases.push(count + ' n\xE3o foi iniciado');
            }
          }

          if (status === 'Em andamento') {
            if (count > 1) {
              frases.push(count + ' est\xE3o em andamento');
            } else {
              frases.push(count + ' est\xE1 em andamento');
            }
          }

          if (status === 'Concluído') {
            if (count > 1) {
              frases.push(count + ' foram conclu\xEDdos');
            } else {
              frases.push(count + ' foi conclu\xEDdo');
            }
          }

          if (status === 'Cancelado') {
            if (count > 1) {
              frases.push(count + ' foram cancelados');
            } else {
              frases.push(count + ' foi cancelado');
            }
          }
        }
      });

      if (frases.length === 0) {
        return '';
      } else if (frases.length === 1) {
        return 'Deste total, ' + frases[0] + '.';
      } else if (frases.length === 2) {
        return 'Deste total, ' + frases[0] + ' e ' + frases[1] + '.';
      } else {
        var last = frases.pop();
        return 'Deste total, ' + frases.join(', ') + ', e ' + last + '.';
      }
    },
    chartData: function chartData() {
      var counts = this.statusCounts;

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(counts).length === 0) {
        return { labels: [], datasets: [] };
      }

      var labels = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(counts);
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(counts);

      return {
        labels: labels,
        datasets: [{
          data: data,
          label: 'Status dos Compromissos',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_6__utils_colors__["a" /* default */].coresHexa,
          color: '#FFF'
        }]
      };
    },
    acoesFiltradas: function acoesFiltradas() {
      if (!this.acoesSidePanel || this.acoesSidePanel.length === 0) {
        return [];
      }

      if (!this.termoPesquisaAcoes) {
        return this.acoesSidePanel;
      }

      var termo = this.termoPesquisaAcoes.toLowerCase();

      return this.acoesSidePanel.filter(function (acao) {
        var descritivo = acao.descritivo ? acao.descritivo.toLowerCase() : '';
        var status = acao.status ? acao.status.toLowerCase() : '';
        var unidae = acao.unidae ? acao.unidae.toLowerCase() : '';
        var nomeUnidade = acao.nome_unidade ? acao.nome_unidade.toLowerCase() : '';

        return descritivo.includes(termo) || status.includes(termo) || unidae.includes(termo) || nomeUnidade.includes(termo);
      });
    }
  })
});

/***/ }),

/***/ "R870":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RBHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("c7SH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9df65d36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("nWxH");
function injectStyle (ssrContext) {
  __webpack_require__("+rr4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9df65d36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9df65d36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RGWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: function _default() {
        return 'Titulo';
      }
    }
  }
});

/***/ }),

/***/ "RM09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'materiais-padronizados',
  inject: ["showConfirm"],
  data: function data() {
    return {
      fields: [{
        name: 'nome',
        title: 'Nome',
        sortField: 'nome',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'descricao',
        title: 'Descrição',
        sortField: 'descricao',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'medida.nome',
        title: 'Medida',
        sortField: 'medida.nome',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }],
      medidas: [],
      subgrupos: [],
      grupos: []
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var me = this;
    __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('materiais/lista-medidas').then(function (resp) {
      if (resp.length === 0) return;
      me.medidas = resp.data;
    }).catch(function (resp) {
      console.log(resp);
    });

    __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('materiais/listar-subgrupos').then(function (resp) {
      if (resp.length === 0) return;
      me.subgrupos = resp.data;
    }).catch(function (resp) {
      console.log(resp);
    });

    __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('materiais/listar-grupos').then(function (resp) {
      if (resp.length === 0) return;
      me.grupos = resp.data;
    }).catch(function (resp) {
      console.log(resp);
    });
  },

  computed: {
    filtros: function filtros() {
      var nome = this.nome,
          descricao = this.descricao,
          medida = this.medida,
          subgrupo = this.subgrupo,
          grupo = this.grupo;

      return {
        nome: nome,
        descricao: descricao,
        medida: medida,
        subgrupo: subgrupo,
        grupo: grupo
      };
    },

    pagina: {
      get: function get() {
        var materiaisPadronizados = this.$store.state.vuetableState.materiaisPadronizados;
        var pagina = materiaisPadronizados.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'materiaisPadronizados',
          value: value
        });
      }
    },
    nome: {
      get: function get() {
        var materiaisPadronizados = this.$store.state.vuetableState.materiaisPadronizados;
        var nome = materiaisPadronizados.filtros.nome;


        return nome;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'materiaisPadronizados',
          value: value
        });
        this.resetPageStore();
      }
    },
    descricao: {
      get: function get() {
        var materiaisPadronizados = this.$store.state.vuetableState.materiaisPadronizados;
        var descricao = materiaisPadronizados.filtros.descricao;


        return descricao;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'descricao',
          collection: 'materiaisPadronizados',
          value: value
        });
        this.resetPageStore();
      }
    },
    medida: {
      get: function get() {
        var materiaisPadronizados = this.$store.state.vuetableState.materiaisPadronizados;
        var medida = materiaisPadronizados.filtros.medida;


        return medida;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'medida',
          collection: 'materiaisPadronizados',
          value: value
        });
        this.resetPageStore();
      }
    },
    subgrupo: {
      get: function get() {
        var materiaisPadronizados = this.$store.state.vuetableState.materiaisPadronizados;
        var subgrupo = materiaisPadronizados.filtros.subgrupo;


        return subgrupo;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'subgrupo',
          collection: 'materiaisPadronizados',
          value: value
        });
        this.resetPageStore();
      }
    },
    grupo: {
      get: function get() {
        var materiaisPadronizados = this.$store.state.vuetableState.materiaisPadronizados;
        var grupo = materiaisPadronizados.filtros.grupo;


        return grupo;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'grupo',
          collection: 'materiaisPadronizados',
          value: value
        });
        this.resetPageStore();
      }
    }
  },
  methods: {
    editar: function editar(data) {
      var id = data.codigo;

      this.$router.push({ name: 'user_material_save', params: { id: id } });
    },
    excluir: function excluir(data) {
      var me = this;
      var id = data.codigo;


      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].delete('material/' + id).then(function (resp) {
            me.consultar();
            me.$toastr.s('Item removido com sucesso');
          }).catch(function (error) {
            me.$toastr.e('Houve uma falha ao tentar remover este item, por favor tente novamente mais tarde!');
            console.log(error);
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      this.nome = '';
      this.descricao = '';
      this.medida = '';
      this.subgrupo = '';
      this.grupo = '';

      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'materiaisPadronizados',
        value: 1
      });
    }
  }
});

/***/ }),

/***/ "RMIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"row",attrs:{"id":_vm.id}},[_c('header',{staticClass:"col-xs-12"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('main',{staticClass:"col-xs-12"},[_c('data-table',{ref:"vuetable",attrs:{"title":_vm.title,"dados":_vm.itens,"fields":_vm.fields,"carregando":_vm.carregando,"per_page":10},on:{"vuetable-pagination:change-page":_vm.checkAllCheckboxOnPage},scopedSlots:_vm._u([{key:"column_input",fn:function(props){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.rowData.checked),expression:"props.rowData.checked"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(props.rowData.checked)?_vm._i(props.rowData.checked,null)>-1:(props.rowData.checked)},on:{"change":function($event){var $$a=props.rowData.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(props.rowData, "checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(props.rowData, "checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(props.rowData, "checked", $$c)}}}})]}},{key:"rowrender",fn:function(props){return [_c('div',{staticClass:"button-group-row"},[_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Ausentar"},on:{"click":function($event){return _vm.ausentar(props.rowData)}}},[(props.rowData.processingClickEvent.ausentar)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'minus-circle'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir")])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Reprovar","disabled":_vm.loading.reprovar},on:{"click":function($event){return _vm.reprovar(props.rowData)}}},[(props.rowData.processingClickEvent.reprovar)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'user-times'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir")])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir","disabled":_vm.loading.excluir},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[(props.rowData.processingClickEvent.excluir)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir")])],1)])]}}])},[_c('template',{slot:"header-actions"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3",staticStyle:{"padding-left":"0"}},[_c('label',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("Data Base")]),_vm._v(" "),_c('datepicker',{ref:"data_base",attrs:{"name":"data_base"},model:{value:(_vm.dataBase),callback:function ($$v) {_vm.dataBase=$$v},expression:"dataBase"}})],1),_vm._v(" "),_c('div',{staticClass:"container-action col-xs-12 col-sm-6 col-md-9",staticStyle:{"padding-left":"0"}},[_c('label',[_vm._v("Ações")]),_vm._v(" "),_c('div',{staticClass:"button-group"},[_c('button',{staticClass:"btn btn-action btn-success btn-lg",attrs:{"title":"Selecionar todos os candidatos"},on:{"click":_vm.alternarTodosCheckboxNaPagina}},[(_vm.hasAllCheckboxOnPage)?_c('font-awesome-icon',{attrs:{"icon":_vm.iconChecked,"size":"1x"}}):_c('font-awesome-icon',{attrs:{"icon":_vm.iconCheck,"size":"1x"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-action btn-success btn-lg",attrs:{"title":"Atualizar data de avaliação","disabled":!Boolean(_vm.dataBase) ||
                  _vm.allItensUnchecked ||
                  _vm.loading.atualizarDataAvaliacao},on:{"click":_vm.atualizarDataAvaliacaoSelecionados}},[(_vm.loading.atualizarDataAvaliacao)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'calendar-check'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Atualizar Data de Avaliação")])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-action btn-success btn-lg",attrs:{"title":"Excluir","disabled":_vm.allItensUnchecked || _vm.loading.excluir},on:{"click":_vm.excluirSelecionados}},[(_vm.loading.excluir)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir")])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-action btn-success btn-lg",attrs:{"title":"Imprimir fichas","disabled":!_vm.itens.length},on:{"click":_vm.imprimirFichas}},[(_vm.loading.imprimir)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'print'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Imprimir fichas")])],1)])])])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rb84":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Select__ = __webpack_require__("MGJx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_strings__ = __webpack_require__("V99r");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Select: __WEBPACK_IMPORTED_MODULE_2__components_common_Select__["a" /* default */]
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    uor: {
      type: String,
      required: true
    },
    value: Array
  },
  data: function data() {
    return {
      employeesSelected: [],
      reference: 0,
      replicableReferences: [],
      desactive: true
    };
  },

  watch: {
    uor: function uor() {
      if (this.uor) this.loadReplicableReferences();
    },
    employeesSelected: function employeesSelected(value) {
      this.update();
    },
    disabled: function disabled(value) {
      this.desactive = value;
    }
  },
  methods: {
    loadReplicableReferences: function loadReplicableReferences() {
      var _this = this;

      this.showMessage('Carregando...');

      __WEBPACK_IMPORTED_MODULE_3__request__["b" /* default */].get('escala/listar-referencias-replicaveis?uor_sigla=' + this.uor, function (response) {
        return _this.setReplicableReferences(response);
      }, function (error) {
        return console.log(error);
      });
    },
    showMessage: function showMessage(message) {
      this.replicableReferences = [{ label: message, value: 0 }];
      this.setReference(0);
    },
    setReplicableReferences: function setReplicableReferences(data) {
      var _this2 = this;

      if (data && Array.isArray(data)) {
        this.replicableReferences = data.map(function (item) {
          return _this2.createReferenceOption(item);
        });
      }

      var _replicableReferences = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(this.replicableReferences, 1),
          selectedItem = _replicableReferences[0];

      if (selectedItem) this.setReference(selectedItem.value);else this.showMessage('Não há escalas anteriores');
    },
    setReference: function setReference(value) {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.toggleDesactive(value === 0);
        _this3.reference = value;
      });
    },
    toggleDesactive: function toggleDesactive(value) {
      if (this.disabled) {
        this.desactive = true;
      } else {
        this.desactive = value;
      }
    },
    createReferenceOption: function createReferenceOption(reference) {
      var value = parseInt(reference);
      var year = reference.substr(0, 4);
      var month = parseInt(reference.substr(-2)) - 1;
      var date = new Date(year, month, 1);
      var label = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_strings__["d" /* capitalize */])(date.toLocaleString('pt-br', { month: 'long', year: 'numeric' }));

      return { value: value, label: label };
    },
    loadEmployees: function loadEmployees() {
      var _this4 = this;

      var uor = this.uor,
          reference = this.reference,
          setEmployees = this.setEmployees,
          emitStatusLoading = this.emitStatusLoading;

      if (reference === 0) return;

      emitStatusLoading(true);
      this.employeesSelected = [];

      __WEBPACK_IMPORTED_MODULE_3__request__["b" /* default */].get('escala/replicar-funcionarios?uor_sigla=' + uor + '&referencia=' + reference, function (response) {
        return setEmployees(response);
      }, function (error) {
        emitStatusLoading(false);
        _this4.$toastr.e('Houve uma falha ao tentar replicar os funcionários, Tente novamente daqui alguns minutos!');
        console.log(error);
      });
    },
    emitStatusLoading: function emitStatusLoading(value) {
      this.$emit('changeStatusLoading', value);
    },
    setEmployees: function setEmployees(data) {
      if (data && Array.isArray(data)) {
        this.employeesSelected = data;
      }

      this.emitStatusLoading(false);
    },
    update: function update() {
      this.$emit('input', [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.employeesSelected)));
    }
  }
});

/***/ }),

/***/ "Rfwc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RxW9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_VuetablePaginationInfo__ = __webpack_require__("nLhK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_FilterBar__ = __webpack_require__("Z2MM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_vuetable2_column_visibility__ = __webpack_require__("zu7y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_PrintTable__ = __webpack_require__("lr95");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_events__ = __webpack_require__("EZrF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("IcnI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'data-table',
  components: {
    vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__["a" /* default */],
    printTable: __WEBPACK_IMPORTED_MODULE_7__components_common_PrintTable__["a" /* default */],
    pagination: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__["a" /* default */],
    paginationInfo: __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_VuetablePaginationInfo__["a" /* default */],
    filterBar: __WEBPACK_IMPORTED_MODULE_5__components_common_FilterBar__["a" /* default */],
    columnVisibility: __WEBPACK_IMPORTED_MODULE_6__components_vuetable2_column_visibility__["a" /* default */]
  },
  data: function data() {
    return {
      fieldsDefinition: this.fields,
      totalRows: 0,
      carregando: false
    };
  },

  props: {
    hasAuth: {
      type: Boolean,
      default: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    slots: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    refresh: {
      type: Function,
      default: function _default() {
        this.$refs.vuetable.refresh();
      }
    },
    useFilter: {
      type: Boolean,
      default: true
    },
    title: String,
    reportTitle: String,
    apiUrl: String,
    apiMode: {
      type: Boolean,
      default: true
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    showPrintButton: {
      type: Boolean,
      default: true
    },
    showColumnVisibilityButton: {
      type: Boolean,
      default: true
    },
    reference: String,
    appendParams: Object,
    fields: Array,
    multiSort: {
      type: Boolean,
      default: true
    },
    multiSortKey: {
      type: String,
      default: 'ctrl'
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    data: {
      type: Array,
      required: false
    },
    paginationPath: {
      type: String,
      default: ''
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          table: {
            tableClass: 'table table-striped table-hover',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down'
          },
          pagination: {
            wrapperClass: 'pagination pull-right',
            activeClass: 'btn-primary',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: 'glyphicon glyphicon-step-backward',
              prev: 'glyphicon glyphicon-chevron-left',
              next: 'glyphicon glyphicon-chevron-right',
              last: 'glyphicon glyphicon-step-forward'
            }
          }
        };
      }
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    initialPage: {
      type: Number,
      default: 1
    },
    pageCollection: {
      type: String,
      required: false
    }
  },
  computed: {
    restUrl: function restUrl() {
      return __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].apiUrlRoot + this.apiUrl;
    },
    auth: function auth() {
      if (this.hasAuth) {
        return { headers: __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].apiHeaderAuthorization() };
      } else {
        return {};
      }
    },
    params: function params() {
      return this.appendParams;
    }
  },
  methods: {
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      if (this.pageCollection && isNaN(page)) {
        var pagina = this.$store.state.vuetableState[this.pageCollection].pagina;

        pagina = page === 'next' ? pagina + 1 : pagina - 1;
        page = pagina;
      }

      if (this.pageCollection) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: this.pageCollection,
          value: page
        });
      }

      this.$refs.vuetable.changePage(page);
    },
    onSuccess: function onSuccess(response) {
      this.$emit('load-sucesso', response);
      if (this.dataPath) {
        this.totalRows = response.data[this.dataPath].length;
      } else {
        this.totalRows = response.data.length;
      }
    },
    onError: function onError(_ref) {
      var _ref$response = _ref.response,
          status = _ref$response.status,
          data = _ref$response.data;

      switch (status) {
        case 401:
          if (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.initialized) {
            __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].app.$toastr.e('Seu token expirou faça o login novamente!');
            __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].app.$refs.loginModal.show(true);
          } else {
            __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('LOGOUT_USER');
            __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push({
              name: 'Login',
              params: { errorMsg: data.msg }
            });
          }
          break;

        case 400:
          if (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.initialized) {
            __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].app.$toastr.e('Seu token expirou faça o login novamente!');
            __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].app.$refs.loginModal.show(true);
          } else {
            __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('LOGOUT_USER');
            __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */].push({
              name: 'Login',
              params: { errorMsg: data.msg }
            });
          }
          break;
      }
    },
    onFilterSet: function onFilterSet(filterParams) {
      var _this = this;

      var filterText = filterParams[0];
      var fieldName = filterParams[1];

      if (!filterText || !fieldName) return;

      this.appendParams[fieldName] = filterText;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    },
    onFilterReset: function onFilterReset(fieldName) {
      var _this2 = this;

      this.appendParams[fieldName] = '';
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
        return _this2.$refs.vuetable.refresh();
      });
    },
    onColumnVisibilityChanged: function onColumnVisibilityChanged() {
      this.$refs.vuetable.normalizeFields();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$events.$on('filter-set', function (e) {
      return _this3.onFilterSet(e);
    });
    this.$events.$on('filter-reset', function (e) {
      return _this3.onFilterReset(e);
    });
    this.$events.$on('column-visibility:changed', function (e) {
      return _this3.onColumnVisibilityChanged(e);
    });
  }
});

/***/ }),

/***/ "Rz9N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S43H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4SY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return plano_governo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("0zO0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__("f0y4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__("/qz2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__("yVX/");
/* unused harmony namespace reexport */





var plano_governo = {
  namespaced: true,
  state: function state() {
    return {
      loading: false,
      compromissos: [],
      loadingSecretaria: false,
      compromissosSecretaria: []
    };
  },
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* getters */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* actions */]
};

/***/ }),

/***/ "SDQR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SEVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emendas-parlamentares"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.label)+" Emenda")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('numero') }]},[_c('label',{class:[
              'control-label',
              'primary',
              { 'is-danger': _vm.errors.has('numero') }
            ]},[_vm._v("Número da emenda")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('numero') }],attrs:{"icon":'sort-numeric-up-alt'}})],1),_vm._v(" "),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"numero",staticClass:"form-control",attrs:{"name":"numero","data-vv-as":"número da emenda","placeholder":"Número da emenda","maxlength":"4","mask":'####',"type":"text"},model:{value:(_vm.model.numero),callback:function ($$v) {_vm.$set(_vm.model, "numero", $$v)},expression:"model.numero"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('ano') }]},[_c('label',{class:[
              'control-label',
              'primary',
              { 'is-danger': _vm.errors.has('ano') }
            ]},[_vm._v("Ano")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('ano') }],attrs:{"icon":'calendar'}})],1),_vm._v(" "),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"ano",staticClass:"form-control",attrs:{"name":"ano","placeholder":"Ano","maxlength":"4","mask":'####',"type":"text"},model:{value:(_vm.model.ano),callback:function ($$v) {_vm.$set(_vm.model, "ano", $$v)},expression:"model.ano"}}),_vm._v(" "),_c('div',{class:[
                  'input-group-addon custom-input-group-addon-count',
                  { 'is-danger': _vm.errors.has('ano') }
                ],domProps:{"textContent":_vm._s(4 - _vm.model.ano.length)}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:[
            'form-group',
            { 'has-error': _vm.errors.has('numero_processo') }
          ]},[_c('label',{class:[
              'control-label',
              'primary',
              { 'is-danger': _vm.errors.has('numero_processo') }
            ]},[_vm._v("\n            Número do processo\n          ")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('numero_processo') }],attrs:{"icon":'sync-alt'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.numero_processo),expression:"model.numero_processo"},{name:"validate",rawName:"v-validate",value:('required|min:9'),expression:"'required|min:9'"}],ref:"numero_processo",staticClass:"form-control",attrs:{"name":"numero_processo","data-vv-as":"número do processo","placeholder":"Número do processo com formato","maxlength":"15","type":"text"},domProps:{"value":(_vm.model.numero_processo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "numero_processo", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('valor') }]},[_c('label',{class:[
              'control-label',
              'primary',
              { 'is-danger': _vm.errors.has('valor') }
            ]},[_vm._v("Valor")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('valor') }],attrs:{"icon":'money-bill'}})],1),_vm._v(" "),_c('money',_vm._b({directives:[{name:"validate",rawName:"v-validate",value:('required|min_value:1.00'),expression:"'required|min_value:1.00'"}],ref:"valor",staticClass:"form-control",attrs:{"name":"valor","placeholder":"Valor da emenda","maxlength":"22","type":"text"},model:{value:(_vm.model.valor),callback:function ($$v) {_vm.$set(_vm.model, "valor", $$v)},expression:"model.valor"}},'money',_vm.money,false))],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('vereador_id') }]},[_c('label',{staticClass:"control-label primary"},[_vm._v("Vereador")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.vereador_id),expression:"model.vereador_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"vereador_id",staticClass:"form-control select-selected",attrs:{"name":"vereador_id","data-vv-as":"vereador"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "vereador_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.vereadores),function(vereador){return _c('option',{key:("vereador-" + (vereador.id)),domProps:{"value":vereador.id}},[_vm._v("\n                "+_vm._s(vereador.nome)+"\n              ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('sigla_orgao') }]},[_c('label',{staticClass:"control-label primary"},[_vm._v("Sigla do orgão")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.sigla_orgao),expression:"model.sigla_orgao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"sigla_orgao",staticClass:"form-control select-selected",attrs:{"name":"sigla_orgao","data-vv-as":"sigla do orgão"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "sigla_orgao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.loadNomeOrgao]}},_vm._l((_vm.orgaos),function(orgao){return _c('option',{key:orgao.id},[_vm._v("\n                "+_vm._s(orgao.sigla)+"\n              ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"primary"},[_vm._v("Nome do orgão")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'signature'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome_orgao),expression:"model.nome_orgao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome_orgoa",staticClass:"form-control",attrs:{"name":"nome_orgao","data-vv-as":"nome do orgão","placeholder":"Seleciona uma sigla","type":"text","disabled":""},domProps:{"value":(_vm.model.nome_orgao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome_orgao", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('label',{staticClass:"block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hasEntidade),expression:"hasEntidade"}],attrs:{"type":"radio","checked":"checked"},domProps:{"value":true,"checked":_vm._q(_vm.hasEntidade,true)},on:{"change":function($event){_vm.hasEntidade=true}}}),_vm._v("\n            Sim\n          ")]),_vm._v(" "),_c('label',{staticClass:"block"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hasEntidade),expression:"hasEntidade"}],attrs:{"type":"radio","checked":"checked"},domProps:{"value":false,"checked":_vm._q(_vm.hasEntidade,false)},on:{"click":_vm.limparEntidade,"change":function($event){_vm.hasEntidade=false}}}),_vm._v("\n            Não\n          ")])])]),_vm._v(" "),(_vm.hasEntidade)?_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:[
            'form-group',
            { 'has-error': _vm.errors.has('nome_entidade') }
          ]},[_c('label',{staticClass:"control-label"},[_vm._v("\n            Nome da entidade\n          ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'signature'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome_entidade),expression:"model.nome_entidade"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome_entidade",staticClass:"form-control",attrs:{"name":"nome_entidade","data-vv-as":"nome da entidade","placeholder":"Nome da entidade","type":"text"},domProps:{"value":(_vm.model.nome_entidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome_entidade", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"min-height":"95px"}},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('descricao') }]},[_c('label',{class:[
              'control-label',
              'primary',
              { 'is-danger': _vm.errors.has('descricao') }
            ]},[_vm._v("Descrição")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('descricao') }],attrs:{"icon":'tags'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"descricao",staticClass:"form-control",attrs:{"rows":"3","name":"descricao","data-vv-as":"descrição","placeholder":"Descrição","maxlength":"500"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                  'input-group-addon custom-input-group-addon-count',
                  { 'is-danger': _vm.errors.has('descricao') }
                ],domProps:{"textContent":_vm._s(500 - _vm.model.descricao.length)}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"min-height":"95px"}},[_c('div',{class:[
            'form-group',
            { 'has-error': _vm.errors.has('resumo_utilizacao') }
          ]},[_c('label',{class:[
              'control-label',
              'primary',
              { 'is-danger': _vm.errors.has('resumo_utilizacao') }
            ]},[_vm._v("Resumo de utilização")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.resumo_utilizacao),expression:"model.resumo_utilizacao"}],ref:"resumo_utilizacao",staticClass:"form-control",attrs:{"rows":"3","name":"resumo_utilizacao","data-vv-as":"resumo de utilização","placeholder":"Resumo de utilização","maxlength":"2000"},domProps:{"value":(_vm.model.resumo_utilizacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "resumo_utilizacao", $event.target.value)}}}),_vm._v(" "),(
                  _vm.model.resumo_utilizacao
                    ? _vm.model.resumo_utilizacao.length > 0
                    : ''
                )?_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(2000 - _vm.model.resumo_utilizacao.length)}}):_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(2000)}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"min-height":"95px"}},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('observacao') }]},[_c('label',{class:[
              'control-label',
              'primary',
              { 'is-danger': _vm.errors.has('observacao') }
            ]},[_vm._v("Observação")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.observacao),expression:"model.observacao"}],ref:"observacao",staticClass:"form-control",attrs:{"rows":"3","name":"observacao","data-vv-as":"observação","placeholder":"Observação","maxlength":"2000"},domProps:{"value":(_vm.model.observacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "observacao", $event.target.value)}}}),_vm._v(" "),(_vm.model.observacao ? _vm.model.observacao.length > 0 : '')?_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(2000 - _vm.model.observacao.length)}}):_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(2000)}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('termo_busca') }]},[_c('label',{class:[
              'control-label',
              'primary',
              { 'is-danger': _vm.errors.has('termo_busca') }
            ]},[_vm._v("Termo de busca")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('termo_busca') }],attrs:{"icon":'search'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.termo_busca),expression:"model.termo_busca"}],ref:"termo_busca",staticClass:"form-control",attrs:{"name":"termo_busca","data-vv-as":"termo de busca","placeholder":"Termo de busca","maxlength":"100","type":"text"},domProps:{"value":(_vm.model.termo_busca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "termo_busca", $event.target.value)}}}),_vm._v(" "),(_vm.model.termo_busca ? _vm.model.termo_busca.length > 0 : '')?_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(100 - _vm.model.termo_busca.length)}}):_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(100)}})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"30px"}},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){return _vm.save()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n          Salvar\n        ")],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v("Emenda destinada a entidade?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SL9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beneficios"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table',{ref:"vuetable",attrs:{"show-empty":true,"title":"Listagem","api-url":"ods/movimentos","fields":_vm.fields,"initial-page":1,"data-path":'',"showPrintButton":false},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}})],1)])]}}])},[_c('template',{staticClass:"form-group",slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":'/admin/ods/movimentos/import'}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Importar\n          ")],1)],1)],2)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',{staticClass:"page-header"},[_vm._v("Movimentos ODS")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SLoD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-value container-fluid"},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 page-header"},[_c('div',{staticClass:"col-xs-12 col-sm-10"},[_c('h2',{staticClass:"small"},[_vm._v("\n              "+_vm._s(_vm.model.nome)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2"},[_c('ul',{attrs:{"id":"bandeiras"}},_vm._l((_vm.model.metas),function(i){return _c('li',{key:i.codigo},[_c('a',{attrs:{"href":i.link,"target":"_blank","title":i.titulo,"data-toggle":"popover","data-placement":"bottom","data-trigger":"hover","data-content":i.objetivo}},[_c('img',{attrs:{"src":_vm.concatPathImage(i.imagem_url)}})])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"reportTitle":_vm.model.DAD_DCNOME + '-valores',"append-params":_vm.params,"api-url":"dado/valor/list","title":"Listagem de valores","fields":_vm.columns,"pageCollection":'adminValues'},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{
                    name: 'admin_dado_valor_save',
                    params: {
                      DAD_IDDADO: _vm.params.DAD_IDDADO,
                      DVA_IDDADOVALOR: props.rowData.DVA_IDDADOVALOR
                    }
                  }}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)],1)]}}])},[_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{
                  name: 'admin_dado_valor_save',
                  DAD_IDDADO: _vm.params.DAD_IDDADO
                }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar valor\n              ")],1)],1)],2)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SQXM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"custom-font"},[_vm._v("Mês de Referência")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('v-select',{attrs:{"options":_vm.referencias,"reduce":function (option) { return option.value; },"selectOnTab":true},on:{"input":_vm.loadScales},model:{value:(_vm.params.referencia),callback:function ($$v) {_vm.$set(_vm.params, "referencia", $$v)},expression:"params.referencia"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"custom-font"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('v-select',{attrs:{"options":_vm.status,"reduce":function (option) { return option.value; },"selectOnTab":true},on:{"input":_vm.loadScales},model:{value:(_vm.params.status),callback:function ($$v) {_vm.$set(_vm.params, "status", $$v)},expression:"params.status"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('data-table',{ref:"escalas",attrs:{"title":"lista de dados","has-auth":false,"api-mode":false,"dados":_vm.scales,"show-empty":true,"fields":_vm.datatable.columns,"carregando":_vm.loadingScales,"per_page":20}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SSAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("aoa/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc52363_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("UAyp");
function injectStyle (ssrContext) {
  __webpack_require__("7UFl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bc52363"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc52363_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Salf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Medidas")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Listagem de Medidas","api-url":_vm.apiUrl,"report-title":"Medidas","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'medidas',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"nome_filter"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nome),expression:"nome"}],staticClass:"form-control",attrs:{"type":"text","name":"nome_filter"},domProps:{"value":(_vm.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v(" Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'user_material_medida_save' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ScH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mp-subgrupo-save',
  data: function data() {
    return {
      label: 'Adicionar',
      apiUrl: 'material/subgrupo',
      grupos: [],
      model: {
        nome: ''
      },
      carregando: false
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    this.loadGrupos();
  },

  methods: {
    loadGrupos: function loadGrupos() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('materiais/listar-grupos');

              case 2:
                response = _context.sent;

                _this.grupos = response.data;
                _this.model.grupo_codigo = _this.grupos[0].codigo;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toogleLoading: function toogleLoading() {
      this.carregando = !this.carregando;
    },
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Este item foi salvo com sucesso.');
      this.$router.push({ name: 'user_material_subgrupo' });
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
      console.log(result.response);
      this.toogleLoading();
    },
    save: function save() {
      var _this2 = this;

      this.toogleLoading();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this2.$refs[_this2.$validator.errors.items[0].field].focus();
          _this2.$toastr.e(_this2.$validator.errors.items[0].msg);
          return;
        }

        __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post(_this2.apiUrl, _this2.model).then(_this2.saveSuccess).catch(_this2.saveFail);
      });
    }
  }
});

/***/ }),

/***/ "SoQP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EstatisticaTempoMedio_vue__ = __webpack_require__("WH8E");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6304f3f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EstatisticaTempoMedio_vue__ = __webpack_require__("gqFd");
function injectStyle (ssrContext) {
  __webpack_require__("VSlJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6304f3f3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EstatisticaTempoMedio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6304f3f3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EstatisticaTempoMedio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Sr7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export secretarias */
/* unused harmony export autarquias */
/* unused harmony export entidades */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return entidadeBySigla; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

var secretariasData = [{
  sigla: 'SAPIC',
  nome: 'Assuntos Portuários, Indústria e Comércio'
}, {
  sigla: 'SAPDC',
  nome: 'Assuntos Portuários e Desenvolvimento da Região Central'
}, {
  sigla: 'SAPDRC',
  nome: 'Assuntos Portuários e Desenvolvimento da Região Central'
}, {
  sigla: 'SEAS',
  nome: 'Assistência Social'
}, {
  sigla: 'SECID',
  nome: 'Defesa da Cidadania'
}, {
  sigla: 'SECOM',
  nome: 'Comunicação'
}, {
  sigla: 'SECOR',
  nome: 'Comunicação e Resultados'
}, {
  sigla: 'SECULT',
  nome: 'Cultura'
}, {
  sigla: 'SEDES',
  nome: 'Desenvolvimento Econômico e Inovação'
}, {
  sigla: 'SEDUC',
  nome: 'Educação'
}, {
  sigla: 'SEDS',
  nome: 'Desenvolvimento Social'
}, {
  sigla: 'SEDURB',
  nome: 'Desenvolvimento Urbano'
}, {
  sigla: 'SEECTUR',
  nome: 'Empreendedorismo, Economia Criativa e Turismo'
}, {
  sigla: 'SEFIN',
  nome: 'Finanças'
}, {
  sigla: 'SEGES',
  nome: 'Gestão'
}, {
  sigla: 'SERIC',
  nome: 'Relações Institucionais e Cidadania'
}, {
  sigla: 'SESERP',
  nome: 'Serviços Públicos'
}, {
  sigla: 'SETUR',
  nome: 'Turismo'
}, {
  sigla: 'GPM',
  nome: 'Gabinete do Prefeito'
}, {
  sigla: 'GVP',
  nome: 'Gabinete do Vice-Prefeito'
}, {
  sigla: 'SEGOV',
  nome: 'Governo'
}, {
  sigla: 'SEMAM',
  nome: 'Meio Ambiente'
}, {
  sigla: 'SMS',
  nome: 'Saúde'
}, {
  sigla: 'SIEDI',
  nome: 'Infraestrutura e Edificações'
}, {
  sigla: 'OC',
  nome: 'Ouvidoria e Controle'
}, {
  sigla: 'OTC',
  nome: 'Ouvidoria Transparência e Controle'
}, {
  sigla: 'OPM',
  nome: 'Ouvidoria Pública'
}, {
  sigla: 'SEPORT',
  nome: 'Assuntos Portuários'
}, {
  sigla: 'SEMES',
  nome: 'Esportes'
}, {
  sigla: 'PGM',
  nome: 'Procuradoria'
}, {
  sigla: 'SECC',
  nome: 'Comunicação e Economia Criativa'
}, {
  sigla: 'SESEG',
  nome: 'Segurança'
}, {
  sigla: 'SEPLAN',
  nome: 'Planejamento e Inovação'
}, {
  sigla: 'SEPORT-RC',
  nome: 'Assuntos Portuários e Desenvolvimento da Região Central'
}, {
  sigla: 'SEOBE',
  nome: 'Obras e Edificações'
}, {
  sigla: 'SEINFRA',
  nome: 'Infraestrutura e Serviços Públicos'
}, {
  sigla: 'SEMULHER',
  nome: 'Mulher, Cidadania, Diversidade e Direitos Humanos'
}, {
  sigla: 'SEPORTE',
  nome: 'Assuntos Portuários e Emprego'
}, {
  sigla: 'GAB-GPM',
  nome: 'Gabinete do Prefeito'
}, {
  sigla: 'SEPREF',
  nome: 'Prefeituras Regionais'
}, {
  sigla: 'SAES',
  nome: 'Assuntos Estratégicos, Legislativos e Metropolitanos'
}];

var autarquiasData = [{
  sigla: 'FAMS-AP',
  nome: 'Fundação Arquivo e Memória'
}, {
  sigla: 'FPTS',
  nome: 'Fundação Parque Tecnológico'
}, {
  sigla: 'FUPES',
  nome: 'Fundação Pró-Esporte'
}, {
  sigla: 'CAPEP-SAUDE',
  nome: 'Caixa Beneficente dos Funcionários Municipais'
}, {
  sigla: 'CET',
  nome: 'Companhia de Engenharia de Tráfego de Santos'
}, {
  sigla: 'COHAB',
  nome: 'Companhia de Habitação da Baixada Santista'
}, {
  sigla: 'IPREV',
  nome: 'Instituto de Previdência Social dos Servidores Públicos Municipais de Santos'
}, {
  sigla: 'PRODESAN',
  nome: 'Progresso e Desenvolvimento de Santos S/A'
}];

function sortData(data) {
  data.sort(function (a, b) {
    return a.sigla > b.sigla;
  });
  return data;
}

var secretarias = function secretarias() {
  return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sortData(secretariasData)));
};

var autarquias = function autarquias() {
  return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sortData(autarquiasData)));
};

var entidades = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sortData(secretariasData)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sortData(autarquiasData)));

var entidadeBySigla = function entidadeBySigla(sigla) {
  var found = entidades.find(function (i) {
    return i.sigla === sigla;
  });

  if (!found) return sigla;

  return found ? found.nome : null;
};

/***/ }),

/***/ "Sw8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PublicHeader: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* PublicHeader */], Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components__["b" /* Breadcrumb */], CardFilaEspera: __WEBPACK_IMPORTED_MODULE_2__components__["i" /* CardFilaEspera */], ListaFilaAgendados: __WEBPACK_IMPORTED_MODULE_2__components__["j" /* ListaFilaAgendados */] },
  data: function data() {
    return {
      carregando: {
        especialidades: false,
        exames: false,
        especialidadesAgendados: false,
        examesAgendados: false,
        mediaespecialidades: false,
        mediaexames: false
      },
      especialidades: [],
      exames: [],
      mediaEspera: {
        exames: [],
        especialidades: []
      },
      especialidadesAgendados: [],
      examesAgendados: [],
      cartao: '',
      breadcrumb: [{
        label: 'Minha Saúde',
        named_link: { name: 'procedimentos_saude' }
      }, {
        label: ''
      }],
      urls: {
        especialidadesEspera: 'procedimentos-saude/lista-especialidades',
        especialidadesAgendados: 'procedimentos-saude/lista-especialidades-agendados',
        examesEspera: 'procedimentos-saude/lista-exames',
        examesAgendados: 'procedimentos-saude/lista-exames-agendados'
      },
      dataAtual: new Date().setHours(0, 0, 0, 0)
    };
  },
  created: function created() {
    var cartao = this.$route.params.cartao;


    if (!cartao) {
      return this.$router.push({ name: 'procedimentos_saude' });
    }

    this.cartao = cartao;
    this.breadcrumb[1].label = 'N\xBA SUS: ' + cartao;

    this.getLista(this.urls.especialidadesEspera, 'especialidades');
    this.getLista(this.urls.examesEspera, 'exames');
    this.getLista(this.urls.especialidadesAgendados, 'especialidadesAgendados');
    this.getLista(this.urls.examesAgendados, 'examesAgendados');
  },

  methods: {
    toggleLoading: function toggleLoading(key) {
      this.carregando[key] = !this.carregando[key];
    },
    getLista: function getLista(url, key) {
      var _this = this;

      this.toggleLoading(key);
      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get(url, {
        params: {
          cartao: this.cartao,
          order: 'desc'
        }
      }).then(function (response) {
        var data = response.data;


        _this[key] = data;
      }).catch(function (error) {
        console.log(error.response);
        _this.$toastr.e('Houve um errro ao carregar a lista. Atualize a página e tente novamente');
      }).finally(function () {
        return _this.toggleLoading(key);
      });
    },
    checkIfDateLowerThanNow: function checkIfDateLowerThanNow(date) {
      var dataAgendada = new Date(date);
      return dataAgendada < this.dataAtual;
    },
    getTempoMediaEspera: function getTempoMediaEspera(key, lista) {
      var _this2 = this;

      if (lista.length) {
        this.toggleLoading('media' + key);
        __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('procedimentos-saude/' + key + '/media-dias', {
          params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, lista)
        }).then(function (response) {
          var data = response.data;

          _this2.mediaEspera[key] = data;
        }).catch(function (error) {
          _this2.$toastr.e('Houve um erro ao calcular o tempo médio para agendamento. Tente novamente mais tarde');
        }).finally(function () {
          _this2.toggleLoading('media' + key);
        });
      }
    }
  },
  watch: {
    exames: function exames(newValue) {
      var exames = newValue.map(function (item) {
        return item.exame;
      });

      this.getTempoMediaEspera('exames', exames);
    },
    especialidades: function especialidades(newValue) {
      var especialidades = newValue.map(function (item) {
        return item.especialidade;
      });

      this.getTempoMediaEspera('especialidades', especialidades);
    }
  },
  computed: {
    listaEspecialidades: function listaEspecialidades() {
      var _this3 = this;

      return this.especialidades.map(function (item) {
        var media_espera = _this3.mediaEspera.especialidades.find(function (subitem) {
          return subitem.especialidade === item.especialidade;
        });

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          media_espera: media_espera ? Number(media_espera.media).toFixed() : 0
        });
      });
    },
    listaExames: function listaExames() {
      var _this4 = this;

      return this.exames.map(function (item) {
        var media_espera = _this4.mediaEspera.exames.find(function (subitem) {
          return subitem.exame === item.exame;
        });

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          media_espera: media_espera ? Number(media_espera.media).toFixed() : 0
        });
      });
    },
    listaEspecialidadesAgendadas: function listaEspecialidadesAgendadas() {
      var _this5 = this;

      var filter = function filter(item) {
        return !_this5.checkIfDateLowerThanNow(item.dtagendamento);
      };

      return this.especialidadesAgendados.filter(filter);
    },
    listaEspecialidadesConcluidas: function listaEspecialidadesConcluidas() {
      var _this6 = this;

      var filter = function filter(item) {
        return _this6.checkIfDateLowerThanNow(item.dtagendamento);
      };

      return this.especialidadesAgendados.filter(filter);
    },
    listaExamesAgendados: function listaExamesAgendados() {
      var _this7 = this;

      var filter = function filter(item) {
        return !_this7.checkIfDateLowerThanNow(item.dtagendamento);
      };

      return this.examesAgendados.filter(filter);
    },
    listaExamesConcluidos: function listaExamesConcluidos() {
      var _this8 = this;

      var filter = function filter(item) {
        return _this8.checkIfDateLowerThanNow(item.dtagendamento);
      };

      return this.examesAgendados.filter(filter);
    }
  }
});

/***/ }),

/***/ "Sy/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),_vm._l((_vm.listaCandidatos),function(candidato){return _c('div',{key:("pornumero-" + (candidato.numero)),staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('ProgressoGeral',{attrs:{"candidato":candidato,"perc":((candidato.total_votos / _vm.votosNominaisTotais) * 100).toFixed(2)}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T/5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vereador-save',
  data: function data() {
    return {
      label: 'Adicionar',
      model: {
        id: '',
        nome: ''
      },
      carregando: false
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var id = this.$route.params.id;

    if (id) {
      this.label = 'Editar';
      this.loadModel(id);
    }
  },

  methods: {
    loadModel: function loadModel(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('vereador/' + id);

              case 2:
                response = _context.sent;

                _this.model = response.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toogleLoading: function toogleLoading() {
      this.carregando = !this.carregando;
    },
    saveSuccess: function saveSuccess() {
      this.$toastr.s('Vereador salvo com sucesso.');
      this.$router.push({ name: 'user_vereadores' });
    },
    saveFail: function saveFail(error) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
      console.log(error.response);
      this.toogleLoading();
    },
    save: function save() {
      var _this2 = this;

      this.toogleLoading();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this2.$refs[_this2.$validator.errors.items[0].field].focus();
          _this2.$toastr.e(_this2.$validator.errors.items[0].msg);
          _this2.toogleLoading();
          return;
        }
        if (_this2.model.codigo) {
          __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].put('vereador/' + _this2.model.codigo, _this2.model).then(_this2.saveSuccess).catch(_this2.saveFail);
        } else {
          __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('vereador', _this2.model).then(_this2.saveSuccess).catch(_this2.saveFail);
        }
      });
    }
  }
});

/***/ }),

/***/ "T/Qv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SelectFuncionario',
    inject: ['$validator'],
    props: {
        value: String,
        label: {
            type: String,
            default: 'Funcionário'
        },
        placeholder: String,
        name: {
            type: String,
            required: true
        },
        isRequired: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            query: null,
            resultados: [],
            delay: null,
            selectedIndex: -1,
            error: false
        };
    },

    watch: {
        value: {
            handler: function handler(val) {
                if (!val) {
                    this.query = '';
                } else {
                    this.atualizarQueryComFuncionario(val);
                }
            },

            immediate: true
        }
    },
    computed: {
        hasErro: function hasErro() {
            return this.$validator.errors.has(this.name);
        },
        showResults: function showResults() {
            return this.resultados.length > 0;
        }
    },
    methods: {
        atualizarQueryComFuncionario: function atualizarQueryComFuncionario(sshd) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].get('/funcionario?search=' + sshd).then(function (response) {
                var funcionario = response.data.find(function (f) {
                    return f.sshd.toUpperCase() === sshd.toUpperCase();
                });
                if (funcionario) {
                    _this.query = funcionario.sshd + ' - ' + funcionario.nome;
                } else {
                    _this.query = sshd;
                }
            }).catch(function (error) {
                console.error("Erro ao buscar funcionário: ", error);
                _this.query = sshd;
            });
        },
        buscarFuncionarios: function buscarFuncionarios() {
            var _this2 = this;

            clearTimeout(this.delay);

            if (!this.query || this.query.length < 2) {
                this.resultados = [];
                return;
            }

            // delay do fetch para não bater a API a cada tecla
            this.delay = setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].get('/funcionario?search=' + _this2.query).then(function (response) {
                    _this2.resultados = response.data;
                    _this2.selectedIndex = 0;
                }).catch(function () {
                    _this2.resultados = [];
                    _this2.selectedIndex = -1;
                });
            }, 300);
        },
        selecionar: function selecionar(item) {
            this.query = item.sshd + ' - ' + item.nome;
            this.mostrarLista = false;
            this.resultados = [];
            this.$emit('input', item.sshd);

            // this.$validator.validate(this.name);
        },
        selecionarAtual: function selecionarAtual() {
            if (this.resultados.length > 0 && this.selectedIndex >= 0) {
                this.selecionar(this.resultados[this.selectedIndex]);
            }
        },
        navegar: function navegar(direcao) {
            var _this3 = this;

            if (!this.resultados.length) return;

            this.selectedIndex += direcao;

            // loop no topo e fim da lista
            if (this.selectedIndex < 0) {
                this.selectedIndex = this.resultados.length - 1;
            } else if (this.selectedIndex >= this.resultados.length) {
                this.selectedIndex = 0;
            }

            this.$nextTick(function () {
                var ref = _this3.$refs['item-' + _this3.selectedIndex];
                if (ref && ref[0]) {
                    ref[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });
                }
            });
        },
        onInput: function onInput() {
            this.buscarFuncionarios();
            this.$emit('input', ''); // limpa o v-model se estiver digitando
        },
        focus: function focus() {
            this.$refs.input.focus();
        }
    }
});

/***/ }),

/***/ "T0+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("JQ9S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_381bdab3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("D5X7");
function injectStyle (ssrContext) {
  __webpack_require__("TJcf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-381bdab3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_381bdab3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T8tZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TCuM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TJ5S":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII="

/***/ }),

/***/ "TJ7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('section',{staticClass:"controls"},[_c('div',{staticClass:"col-xs-12 col-lg-6"},[_c('div',{staticClass:"form-group"},[_c('v-select',{attrs:{"loading":_vm.loading.unidade,"disabled":_vm.loading.unidade,"label":"nome","placeholder":_vm.unidadeLabel,"options":_vm.uors,"reduce":function (u) { return u.uor_sigla; },"selectOnTab":true},on:{"input":_vm.loadReferencias},scopedSlots:_vm._u([{key:"spinner",fn:function(ref){
var loading = ref.loading;
return [(loading)?_c('div',{staticClass:"vs__spinner",staticStyle:{"border-left-color":"rgba(93, 197, 150, 0.71)"}},[_vm._v("\n                      The .vs__spinner class will hide the text for me.\n                    ")]):_vm._e()]}}]),model:{value:(_vm.uor),callback:function ($$v) {_vm.uor=$$v},expression:"uor"}},[_c('options',[_vm._v("Nenhum selecionado")]),_vm._v(" "),_vm._v(" "),_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Desculpe, não há nenhum item.")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-6"},[_c('div',{staticClass:"form-group"},[_c('v-select',{attrs:{"loading":_vm.loading.referencia,"disabled":_vm.loading.referencia,"placeholder":_vm.referenciaLabel,"options":_vm.referencias,"reduce":function (referencia) { return referencia.value; },"selectOnTab":true},on:{"input":_vm.loadEscala},scopedSlots:_vm._u([{key:"spinner",fn:function(ref){
var loading = ref.loading;
return [(loading)?_c('div',{staticClass:"vs__spinner",staticStyle:{"border-left-color":"rgba(93, 197, 150, 0.71)"}},[_vm._v("\n                      The .vs__spinner class will hide the text for me.\n                    ")]):_vm._e()]}}]),model:{value:(_vm.referencia),callback:function ($$v) {_vm.referencia=$$v},expression:"referencia"}},[_vm._v(" "),_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("Desculpe, não há nenhum item.")])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-success btn-md btn-block",attrs:{"disabled":_vm.escalaStatus != 'done'},on:{"click":function($event){$event.preventDefault();return _vm.imprimir.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":'print'}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.buttonLabel))]),_vm._v(" "),_c('pulse-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.escalaStatus == 'processing'),expression:"escalaStatus == 'processing'"}],staticClass:"loading",attrs:{"size":'0.5em'}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('section',{staticClass:"print"},[_c('header',[_c('h4',[_vm._v(_vm._s(_vm.print.unidade))]),_vm._v(" "),_c('h5',[_vm._v("ESCALA DE "+_vm._s(_vm.print.referencia))])]),_vm._v(" "),_c('data-table-public',{ref:"escalas",attrs:{"api-mode":false,"data":_vm.print.calendario,"fields":_vm.columns,"css":_vm.tableCss}}),_vm._v(" "),(_vm.print.observacao)?_c('section',[_c('h6',[_vm._v("OBSERVAÇÃO:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.print.observacao))])]):_vm._e()],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TJSQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TJcf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TQp1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      model: {
        username: '',
        password: '',
        usuarioExterno: false
      },
      requestPendente: false
    };
  },
  mounted: function mounted() {
    var params = this.$route.params;

    if (params.errorMsg) {
      this.$toastr.e(params.errorMsg);
      this.$refs.username.focus();
    }
    if (params.user) {
      this.model.username = params.user;
      this.$refs.password.focus();
    }

    if (!params.errorMsg && !params.hasOwnProperty('user')) {
      this.$refs.username.focus();
    }
  },

  methods: {
    login: function login() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        _this.requestPendente = true;
        if (!result) {
          _this.requestPendente = false;
          _this.$refs[_this.$validator.errors.items[0].field].focus();
          _this.$toastr.e('Verifique os campos obrigatórios');
          return;
        }
        _this.$store.dispatch('tryLogin', _this.model).then(function (response) {
          _this.requestPendente = false;
          _this.$toastr.s('Login efetuado com sucesso.');
          _this.$router.push('/admin');
        }).catch(function (_ref) {
          var data = _ref.data;

          _this.requestPendente = false;
          _this.errorMsg = Array.isArray(data) ? data[0] : data;
          _this.model.password = '';
          _this.$toastr.e(_this.errorMsg);
          _this.$refs.password.focus();
        });
      });
    }
  }
});

/***/ }),

/***/ "TZBS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(item){return _c('div',{key:item.codigo,class:['card-receitas', _vm.gridClass]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[(item.hasOwnProperty('link'))?_c('router-link',{attrs:{"to":item.link}},[(item.hasOwnProperty('tooltip'))?_c('h4',{attrs:{"title":item.title,"data-content":item.tooltip,"data-toggle":"popover","data-placement":"auto","data-trigger":"hover focus"}},[_vm._v(_vm._s(item.title))]):_c('h4',{attrs:{"title":item.title}},[_vm._v("\n            "+_vm._s(item.title)+"\n          ")])]):_c('h4',{attrs:{"title":item.title}},[_vm._v(_vm._s(item.title))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},_vm._l((item.data),function(line){return _c('p',{key:line.label},[_c('strong',[_vm._v(_vm._s(line.label))]),_vm._v(": "+_vm._s(line.value)+"\n        ")])}),0)])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TeJu":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "TeVB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"habilitados"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h2',{staticClass:"page-header"},[_vm._v("Habilitados")]),_vm._v(" "),_c('h3',[_vm._v("\n        Edital nº "+_vm._s(_vm.edital.numero)+" - Processo nº\n        "+_vm._s(_vm.edital.processo_numero)+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table',{ref:"vuetable",attrs:{"title":'Lista de Cargos',"dados":_vm.cargos,"fields":_vm.fields,"carregando":_vm.isLoading}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12 form-group"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.baixarPlanilhaBase()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}}),_vm._v(" Baixar CSV base\n      ")],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"input-file-import"}},[_vm._v("Upload CSV Habilitados")]),_vm._v(" "),_c('input',{ref:"import_file",staticClass:"form-control",class:{ ' is-invalid': _vm.error.message },attrs:{"type":"file","id":"input-file-import","name":"file_import","accept":".csv"},on:{"change":_vm.onFileChange}})]),_vm._v(" "),(_vm.error.message)?_c('div',{staticClass:"invalid-feedback"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":!this.import_file || _vm.isLoading},on:{"click":_vm.proceedAction}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n          Enviar\n        ")],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n        Lista de Habilitados -\n        "),_c('button',{staticClass:"btn btn-default",attrs:{"title":"Excluir Todos","disabled":!_vm.habilitados.length || _vm.isLoading},on:{"click":function($event){return _vm.excluir({ id: 0, geral: 1, pcd: 0, cotas: 0 })}}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir todos habilitados")])],1)]),_vm._v(" "),_c('data-table',{ref:"vuetable_habilitados",attrs:{"id":"vuetable_habilitados","title":'Lista de Habilitados',"dados":_vm.habilitados,"fields":_vm.fields_habilitados,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-danger",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir")])],1)]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n        Lista de Habilitados PCD -\n        "),_c('button',{staticClass:"btn btn-default",attrs:{"title":"Excluir Todos","disabled":!_vm.habilitados_pcd.length || _vm.isLoading},on:{"click":function($event){return _vm.excluir({ id: 0, geral: 0, pcd: 1, cotas: 0 })}}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir todos habilitados")])],1)]),_vm._v(" "),_c('data-table',{ref:"vuetable_habilitados_pcd",attrs:{"id":"vuetable_habilitados_pcd","title":'Lista de Habilitados - PCD',"dados":_vm.habilitados_pcd,"fields":_vm.fields_habilitados,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-danger",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir")])],1)]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n        Lista de Habilitados Negros -\n        "),_c('button',{staticClass:"btn btn-default",attrs:{"title":"Excluir Todos","disabled":!_vm.habilitados_cotas.length || _vm.isLoading},on:{"click":function($event){return _vm.excluir({ id: 0, geral: 0, pcd: 0, cotas: 1 })}}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir todos habilitados")])],1)]),_vm._v(" "),_c('data-table',{ref:"vuetable_habilitados_cotas",attrs:{"id":"vuetable_habilitados_cotas","title":'Lista de Habilitados - Negros',"dados":_vm.habilitados_cotas,"fields":_vm.fields_habilitados,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-danger",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[(_vm.isLoading)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Excluir")])],1)]}}])})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',{attrs:{"id":"cabecalho_habilitados"}},[_vm._v("Importar Habilitados")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TrY4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalheGrupoDespesa_vue__ = __webpack_require__("bsTZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ac1de52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalheGrupoDespesa_vue__ = __webpack_require__("xtcC");
function injectStyle (ssrContext) {
  __webpack_require__("n6NU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ac1de52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalheGrupoDespesa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ac1de52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalheGrupoDespesa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TtC/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("syb/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1109196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("WI/y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1109196_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U/ps":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control-group"},[_vm._l((_vm.checkboxs),function(item,index){return _c('div',{key:index,staticClass:"control"},[_c('span',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"value":item.value,"checked":_vm.isChecked(item.value)},on:{"click":function($event){return _vm.changeValues(item.value, $event)}}}),_vm._v(" "),_c('div',{staticClass:"checkmark"})])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-sm",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.emitValues}},[_vm._v("\n    OK\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U3HO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.entradaIsEmpty)?_c('div',[_c('i',{staticClass:"fa fa-arrow-circle-right fa-lg",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(_vm.time.entrada))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),(_vm.saidaIsEmpty)?_c('div',[_c('i',{staticClass:"fa fa-arrow-circle-right fa-lg",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(_vm.time.saida))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U8qx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeCell_vue__ = __webpack_require__("mT4T");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d44babc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeCell_vue__ = __webpack_require__("U3HO");
function injectStyle (ssrContext) {
  __webpack_require__("9fKv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d44babc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeCell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d44babc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeCell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "U9j/":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./BadgeNovembroAzul.png": "g2M9",
	"./LogoNovembroAzul.png": "HDmn",
	"./LogoPMS.png": "FiMJ",
	"./LogoPMS.svg": "tz3W",
	"./LogoPMS_old.png": "UA7T",
	"./LogoPMS_old.svg": "/3wm",
	"./brasao-cor-branco-vertical.svg": "wOM0",
	"./brasao-cor-horizontal.png": "VhyD",
	"./carregando.gif": "Jwkc",
	"./conecte-sus.svg": "c/cq",
	"./govbr-logo.png": "wM2B",
	"./ico-assistencia.svg": "9+xg",
	"./ico-azul.svg": "iDa5",
	"./ico-compras.svg": "kzZg",
	"./ico-comunicacao.svg": "Glix",
	"./ico-cultura.svg": "pdY+",
	"./ico-default.svg": "6ig6",
	"./ico-educacao.svg": "TeJu",
	"./ico-esporte.svg": "8m+r",
	"./ico-financas.svg": "R+m3",
	"./ico-gestao.svg": "lFPT",
	"./ico-governo.svg": "k82x",
	"./ico-imovel.svg": "G2dL",
	"./ico-manutencao.svg": "adyD",
	"./ico-meioambiente.svg": "uC+7",
	"./ico-ouvidoria.svg": "GIS3",
	"./ico-porto.svg": "Ffni",
	"./ico-saude.svg": "yZwr",
	"./ico-seguranca.svg": "M9oD",
	"./ico-servico-servicospublicos.svg": "V7DC",
	"./ico-servidor.svg": "jDDP",
	"./ico-turismo.svg": "8bzg",
	"./ico-urbanismo.svg": "MEYP",
	"./ico-verde.svg": "i1A9",
	"./ico-vermelho.svg": "3R7G",
	"./logo-remedio-facil.png": "nkjI",
	"./ods/banner-movimento-ods.jpg": "/vAg",
	"./ods/flags/1.jpg": "YTMB",
	"./ods/flags/10.jpg": "7/wm",
	"./ods/flags/11.jpg": "hQn3",
	"./ods/flags/12.jpg": "u3WT",
	"./ods/flags/13.jpg": "Juz5",
	"./ods/flags/14.jpg": "WKXi",
	"./ods/flags/15.jpg": "Hi7N",
	"./ods/flags/16.jpg": "pEvt",
	"./ods/flags/17.jpg": "+FX6",
	"./ods/flags/2.jpg": "84Lw",
	"./ods/flags/3.jpg": "Wzr1",
	"./ods/flags/4.jpg": "VINc",
	"./ods/flags/5.jpg": "1neZ",
	"./ods/flags/6.jpg": "mbtb",
	"./ods/flags/7.jpg": "CUx3",
	"./ods/flags/8.jpg": "LrMQ",
	"./ods/flags/9.jpg": "GAy2",
	"./ods/logo/movimento_ods_logo.jpg": "xuae"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "U9j/";

/***/ }),

/***/ "UA7T":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "UAyp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',{staticClass:"page-header"},[_vm._v("Acompanhamento")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"list_editais_andamento",attrs:{"show-empty":true,"title":"Editais em andamento","api-url":"edital/listar","report-title":"Editais","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'acompanhamentos',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('router-link',{staticClass:"btn btn-success",attrs:{"title":"Detalhes","to":{
                name: 'acompanhamento_detalhes',
                params: { edital_id: props.rowData.id }
              }}},[_c('font-awesome-icon',{attrs:{"icon":'search'}})],1)]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font"},[_vm._v("Nº Edital")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numero),expression:"numero"}],staticClass:"form-control",attrs:{"type":"text","name":"numero_filter"},domProps:{"value":(_vm.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font"},[_vm._v("Nº Processo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.processo_numero),expression:"processo_numero"}],staticClass:"form-control",attrs:{"type":"text","name":"processo_numero_filter"},domProps:{"value":(_vm.processo_numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.processo_numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{staticClass:"custom-font"},[_vm._v("Publicado")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.publicado),expression:"publicado"}],staticClass:"form-control select-selected",attrs:{"name":"publicado_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.publicado=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.consultar('list_editais_andamento')}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Sim")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar('list_editais_andamento')}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                Filtrar\n              ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar('list_editais_andamento')}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                Limpar Filtros\n              ")],1)])])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"list_editais_encerrados",attrs:{"show-empty":true,"title":"Editais encerrados","api-url":"edital/listar","report-title":"Editais","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'acompanhamentos',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('router-link',{staticClass:"btn btn-success",attrs:{"title":"Detalhes","to":{
                name: 'acompanhamento_detalhes',
                params: { edital_id: props.rowData.id }
              }}},[_c('font-awesome-icon',{attrs:{"icon":'search'}})],1)]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font"},[_vm._v("Nº Edital")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numero),expression:"numero"}],staticClass:"form-control",attrs:{"type":"text","name":"numero_filter"},domProps:{"value":(_vm.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font"},[_vm._v("Nº Processo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.processo_numero),expression:"processo_numero"}],staticClass:"form-control",attrs:{"type":"text","name":"processo_numero_filter"},domProps:{"value":(_vm.processo_numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.processo_numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',[_vm._v("Publicado")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.publicado),expression:"publicado"}],staticClass:"form-control select-selected",attrs:{"name":"publicado_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.publicado=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Sim")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar('list_editais_encerrados')}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtrar\n              ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar('list_editais_encerrados')}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v(" Limpar Filtros\n              ")],1)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UCz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paginacao"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 flex"},[_c('button',{class:['btn btn-primary', _vm.inputVal === 1 ? 'disabled' : ''],attrs:{"disabled":_vm.inputVal === 1,"title":"Primeira página"},on:{"click":function($event){return _vm.firstPage()}}},[_vm._v("\n        <<<\n      ")]),_vm._v(" "),_c('button',{class:['btn btn-primary', _vm.inputVal === 1 ? 'disabled' : ''],attrs:{"disabled":_vm.inputVal === 1,"title":"Página anterior"},on:{"click":function($event){return _vm.prevPage()}}},[_vm._v("\n        <\n      ")]),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.options,"clearable":false},scopedSlots:_vm._u([{key:"no-options",fn:function(ref){
var search = ref.search;
var searching = ref.searching;
var loading = ref.loading;
return [_vm._v("\n          Página não encontrada!\n        ")]}}]),model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "),_c('button',{class:['btn btn-primary', _vm.inputVal === _vm.qtPaginas ? 'disabled' : ''],attrs:{"disabled":_vm.inputVal === _vm.qtPaginas,"title":"Próxima página"},on:{"click":function($event){return _vm.nextPage()}}},[_vm._v("\n        >\n      ")]),_vm._v(" "),_c('button',{class:['btn btn-primary', _vm.inputVal === _vm.qtPaginas ? 'disabled' : ''],attrs:{"disabled":_vm.inputVal === _vm.qtPaginas,"title":"Última página"},on:{"click":function($event){return _vm.lastPage()}}},[_vm._v("\n        >>>\n      ")]),_vm._v(" "),_c('div',{staticClass:"self-end"},[_vm._v("\n        "+_vm._s(("Exibindo de " + ((_vm.inputVal - 1) * 100 + 1) + " a " + (_vm.total < _vm.inputVal * 100 ? _vm.total : _vm.inputVal * 100) + " de um total de " + _vm.total))+"\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UM0c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UXFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SideModal',{attrs:{"sides":_vm.navs}},[_c('template',{slot:'homologar'},[_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"min-height":"65vh"}},[_c('h3',[_vm._v("As ações deste compromisso")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Início")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Descritivo")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Responsável")])])]),_vm._v(" "),_c('tbody',[(_vm.homologarData.acoes && _vm.homologarData.acoes.length === 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("\n                  Nenhuma ação foi cadastrada.\n                ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.homologarData.acoes),function(ref){
                var id = ref.id;
                var data_inicio = ref.data_inicio;
                var data_estimada_inicio = ref.data_estimada_inicio;
                var descritivo = ref.descritivo;
                var status = ref.status;
                var data_conclusao = ref.data_conclusao;
                var data_estimada_conclusao = ref.data_estimada_conclusao;
                var responsavel = ref.responsavel;
                var sshd_responsavel = ref.sshd_responsavel;
                var justificativa_rejeicao = ref.justificativa_rejeicao;
return _c('tr',{key:id},[_c('td',[_vm._v("\n                  "+_vm._s(data_inicio !== null ? data_inicio : data_estimada_inicio)+"\n                ")]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},attrs:{"title":descritivo}},[_vm._v("\n                  "+_vm._s(((descritivo.substring(0, 100)) + "..."))+"\n                ")]),_vm._v(" "),_c('td',[(status === 'Não Iniciado')?_c('div',{staticClass:"status",attrs:{"title":("Previsão de inicio em " + data_estimada_conclusao)}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'hourglass-start'}}),_vm._v("\n                    "+_vm._s(status)+"\n                  ")],1):_vm._e(),_vm._v(" "),(status === 'Em andamento')?_c('div',{staticClass:"status",attrs:{"title":("Estimativa de conclusão em " + data_estimada_conclusao)}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'clock'}}),_vm._v("\n                    "+_vm._s(status)+"\n                  ")],1):_vm._e(),_vm._v(" "),(status === 'Concluído')?_c('div',{staticClass:"status",attrs:{"title":("Concluído em " + data_conclusao)}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'check-square'}}),_vm._v("\n                    "+_vm._s(status)+"\n                  ")],1):_vm._e(),_vm._v(" "),(status === 'Rejeitada')?_c('div',{staticClass:"status",attrs:{"title":("Justificativa: " + justificativa_rejeicao)}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'times'}}),_vm._v("\n                    "+_vm._s(status)+"\n                  ")],1):_vm._e(),_vm._v(" "),(status === 'Cancelada')?_c('div',{staticClass:"status",attrs:{"title":("Justificativa: " + justificativa_rejeicao)}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'ban'}}),_vm._v("\n                    "+_vm._s(status)+"\n                  ")],1):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"title":responsavel.nome}},[_c('div',{},[_vm._v("\n                    "+_vm._s(sshd_responsavel)+"\n                  ")])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.homologarData.acoes && _vm.homologarData.acoes.length === 0},on:{"click":function($event){return _vm.$emit('homologar', _vm.homologarData.id)}}},[_vm._v("\n            Homologar\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('fechaModal', _vm.homologarData.identidade)}}},[_vm._v("\n            Cancelar\n          ")])])])])]),_vm._v(" "),_c('template',{slot:'info'},[_c('main',[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Período")]),_vm._v(" "),_c('p',[_vm._v("\n          "+_vm._s(_vm.infoData.periodo)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Unidade")]),_vm._v(" "),_c('p',[_vm._v("\n          "+_vm._s(_vm.infoData.unidade_executora)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("\n          Responsável\n        ")]),_vm._v(" "),(_vm.infoData.responsavel)?_c('p',[_vm._v("\n          "+_vm._s(_vm.infoData.responsavel.nome)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Status")]),_vm._v(" "),_c('p',[_vm._v("\n          "+_vm._s(_vm.infoData.status)+"\n        ")])]),_vm._v(" "),(_vm.infoData.justificativa_cancelamento)?_c('div',{staticClass:"col-xs-12"},[_c('label',[_vm._v("Justificativa de Cancelamento")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.infoData.justificativa_cancelamento))])]):_c('div',{staticClass:"col-xs-12"},[_c('label',[_vm._v("Data de conclusão")]),_vm._v(" "),(_vm.infoData.data_conclusao)?_c('p',[_vm._v("\n          "+_vm._s(_vm.infoData.data_conclusao)+"\n        ")]):_c('p',[_vm._v("\n          Não definida\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('label',[_vm._v("Sumário das ações")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Total")])])]),_vm._v(" "),_c('tbody',[(_vm.infoData.sumario && _vm.infoData.sumario.length === 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("\n                Nenhuma ação foi cadastrada.\n              ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.infoData.sumario),function(ref){
                var status = ref.status;
                var total = ref.total;
return _c('tr',{key:status},[_c('td',[_vm._v(_vm._s(status))]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(total)+"\n              ")])])})],2)])])])]),_vm._v(" "),_c('template',{slot:'pedido-cancelamento'},[_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"min-height":"65vh"}},[_c('h3',[_vm._v("Deseja realizar o pedido de cancelamento?")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.justificativa),expression:"justificativa"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":"Digite sua justificativa aqui..."},domProps:{"value":(_vm.justificativa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.justificativa=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.$emit('cancelar', {
                compromisso: _vm.pedidoCancelamentoData,
                justificativa: _vm.justificativa
              })}}},[_vm._v("\n            Confirmar\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('fechaModal', _vm.pedidoCancelamentoData.identidade)}}},[_vm._v("\n            Cancelar\n          ")])])])])]),_vm._v(" "),_c('template',{slot:'cancelar'},[_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Período")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.cancelarData.periodo)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Unidade")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.cancelarData.unidade_executora)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Responsável")]),_vm._v(" "),(_vm.cancelarData.responsavel)?_c('p',[_vm._v("\n            "+_vm._s(_vm.cancelarData.responsavel.nome)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Status")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.cancelarData.status)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('label',[_vm._v("Justificativa de Cancelamento")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.cancelarData.justificativa_cancelamento))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("As ações deste compromisso")]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Início")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Descritivo")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")])])]),_vm._v(" "),_c('tbody',[(_vm.cancelarData.acoes && _vm.cancelarData.acoes.length === 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("\n                  Nenhuma ação foi cadastrada.\n                ")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.cancelarData.acoes),function(ref){
                var id = ref.id;
                var data_inicio = ref.data_inicio;
                var data_estimada_inicio = ref.data_estimada_inicio;
                var descritivo = ref.descritivo;
                var status = ref.status;
                var data_conclusao = ref.data_conclusao;
                var data_estimada_conclusao = ref.data_estimada_conclusao;
                var justificativa_rejeicao = ref.justificativa_rejeicao;
return _c('tr',{key:id},[_c('td',[_vm._v("\n                  "+_vm._s(data_inicio !== null ? data_inicio : data_estimada_inicio)+"\n                ")]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},attrs:{"title":descritivo}},[_vm._v("\n                  "+_vm._s(((descritivo.substring(0, 100)) + "..."))+"\n                ")]),_vm._v(" "),_c('td',[(status === 'Não Iniciado')?_c('div',{staticClass:"status",attrs:{"title":("Previsão de inicio em " + data_estimada_conclusao)}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'hourglass-start'}}),_vm._v("\n                    "+_vm._s(status)+"\n                  ")],1):_vm._e(),_vm._v(" "),(status === 'Em andamento')?_c('div',{staticClass:"status",attrs:{"title":("Estimativa de conclusão em " + data_estimada_conclusao)}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'clock'}}),_vm._v("\n                    "+_vm._s(status)+"\n                  ")],1):_vm._e(),_vm._v(" "),(status === 'Concluído')?_c('div',{staticClass:"status",attrs:{"title":("Concluído em " + data_conclusao)}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'check-square'}}),_vm._v("\n                    "+_vm._s(status)+"\n                  ")],1):_vm._e(),_vm._v(" "),(status === 'Rejeitada')?_c('div',{staticClass:"status",attrs:{"title":("Justificativa: " + justificativa_rejeicao)}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'times'}}),_vm._v("\n                    "+_vm._s(status)+"\n                  ")],1):_vm._e(),_vm._v(" "),(status === 'Cancelada')?_c('div',{staticClass:"status",attrs:{"title":("Justificativa: " + justificativa_rejeicao)}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'ban'}}),_vm._v("\n                    "+_vm._s(status)+"\n                  ")],1):_vm._e()])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.$emit('aceitarRequisicao', _vm.cancelarData)}}},[_vm._v("\n            Confirmar Cancelamento\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('rejeitarRequisicao', _vm.cancelarData.id)}}},[_vm._v("\n            Rejeitar Cancelamento\n          ")])])])])]),_vm._v(" "),_c('template',{slot:'editar'},[_c('main',[_c('div',{staticClass:"col-xs-12"},[_c('SelectFuncionario',{ref:"selectFuncionario",attrs:{"label":'Funcionário Responsável',"name":'sshd_responsavel',"placeholder":'Pesquise pelo nome ou SSHD',"is-required":true},model:{value:(_vm.sshd_responsavel),callback:function ($$v) {_vm.sshd_responsavel=$$v},expression:"sshd_responsavel"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Descritivo do Compromisso")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'comment'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.novoDescritivo),expression:"novoDescritivo"}],staticClass:"form-control",attrs:{"placeholder":"Descreva o compromisso...","maxlength":"1000","rows":"8"},domProps:{"value":(_vm.novoDescritivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.novoDescritivo=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(1000 - (_vm.novoDescritivo || '').length)}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",on:{"click":_vm.salvarEdicao}},[_c('font-awesome-icon',{attrs:{"icon":"save"}}),_vm._v("\n          Salvar\n        ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":_vm.cancelarEdicao}},[_vm._v("\n          Cancelar\n        ")])])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UZE8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v("Salvar Meta")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-4"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('Logotipo') }]},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-control",staticStyle:{"height":"240px","width":"320px","border-style":"solid","padding":"0px","border-radius":"0px"}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.image},on:{"click":function($event){return _vm.$upload.select('logo')}}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fileImagem),expression:"model.fileImagem"}],ref:"Logotipo",attrs:{"type":"hidden","name":"Logotipo"},domProps:{"value":(_vm.model.fileImagem)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "fileImagem", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('Título') }]},[_c('label',{class:[
                'control-label',
                'custom-font',
                { 'is-danger': _vm.errors.has('Título') }
              ]},[_vm._v("Título")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('Título') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.MET_DCTITULO),expression:"model.MET_DCTITULO"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"Título",staticClass:"form-control",attrs:{"name":"Título","maxlength":"100","placeholder":"Título","type":"text"},domProps:{"value":(_vm.model.MET_DCTITULO)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "MET_DCTITULO", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                    'input-group-addon custom-input-group-addon-count',
                    { 'is-danger': _vm.errors.has('Título') }
                  ],domProps:{"textContent":_vm._s(100 - _vm.model.MET_DCTITULO.length)}})]),_vm._v(" "),(_vm.errors.has('Título'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"Título"}},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('Título') }],attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                Preenchimento obrigatório!")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('Objetivo') }]},[_c('label',{class:[
                'control-label',
                'custom-font',
                { 'is-danger': _vm.errors.has('Objetivo') }
              ]},[_vm._v("Objetivo")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('Objetivo') }],attrs:{"icon":'tags'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.MET_DLOBJETIVO),expression:"model.MET_DLOBJETIVO"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"Objetivo",staticClass:"form-control",attrs:{"name":"Objetivo","placeholder":"Objetivo","maxlength":"300","rows":"3"},domProps:{"value":(_vm.model.MET_DLOBJETIVO)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "MET_DLOBJETIVO", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                    'input-group-addon custom-input-group-addon-count',
                    { 'is-danger': _vm.errors.has('Objetivo') }
                  ],domProps:{"textContent":_vm._s(300 - _vm.model.MET_DLOBJETIVO.length)}})]),_vm._v(" "),(_vm.errors.has('Objetivo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"Objetivo"}},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('Objetivo') }],attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                Preenchimento obrigatório!")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('Link') }]},[_c('label',{class:[
                'control-label',
                'custom-font',
                { 'is-danger': _vm.errors.has('Link') }
              ]},[_vm._v("Link")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('Link') }],attrs:{"icon":'external-link-alt'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.MET_DLLINK),expression:"model.MET_DLLINK"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"Link",staticClass:"form-control",attrs:{"maxlength":"200","name":"Link","placeholder":"Link","type":"text"},domProps:{"value":(_vm.model.MET_DLLINK)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "MET_DLLINK", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                    'input-group-addon custom-input-group-addon-count',
                    { 'is-danger': _vm.errors.has('Link') }
                  ],domProps:{"textContent":_vm._s(200 - _vm.model.MET_DLLINK.length)}})]),_vm._v(" "),(_vm.errors.has('Link'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"Link"}},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('Link') }],attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                Preenchimento obrigatório!")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('Número') }]},[_c('label',{class:[
                'control-label',
                'custom-font',
                { 'is-danger': _vm.errors.has('Número') }
              ]},[_vm._v("Número [1-99]")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('Número') }],attrs:{"icon":'sort-numeric-up-alt'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.MET_NRNUMERO),expression:"model.MET_NRNUMERO"},{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],ref:"Número",staticClass:"form-control",attrs:{"type":"text","name":"Número","placeholder":"Número"},domProps:{"value":(_vm.model.MET_NRNUMERO)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "MET_NRNUMERO", $event.target.value)}}})]),_vm._v(" "),(_vm.errors.has('Número'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"Número"}},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('Número') }],attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                Preenchimento obrigatório!")],1):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 text-right",staticStyle:{"padding-right":"30px"}},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){return _vm.save()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n          Salvar\n        ")],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"control-label custom-font"},[_vm._v("Logotipo\n            "),_c('small',[_vm._v(" - Clique na imagem para adicionar:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UbQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"salvar-edital"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h2',{staticClass:"page-header"},[_vm._v("\n        "+_vm._s(_vm.montarTitulo())+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-3"},[_c('label',{class:['custom-font', { 'is-danger': _vm.errors.has('numero_edital') }]},[_vm._v("Nº do Edital")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.numero),expression:"model.numero"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"numero_edital",class:[
          'form-control',
          { 'is-danger': _vm.errors.has('numero_edital') }
        ],attrs:{"type":"text","name":"numero_edital"},domProps:{"value":(_vm.model.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "numero", $event.target.value)}}}),_vm._v(" "),_c('message',{attrs:{"name":'numero_edital',"show":_vm.errors.has('numero_edital'),"erro":_vm.errors.first('numero_edital')}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6 col-md-4"},[_c('label',{class:[
          'custom-font',
          { 'is-danger': _vm.errors.has('numero_processor') }
        ]},[_vm._v("Nº do Processo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.processo_numero),expression:"model.processo_numero"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"numero_processo",class:[
          'form-control',
          { 'is-danger': _vm.errors.has('numero_processo') }
        ],attrs:{"type":"text","name":"numero_processo"},domProps:{"value":(_vm.model.processo_numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "processo_numero", $event.target.value)}}}),_vm._v(" "),_c('message',{attrs:{"name":'numero_processo',"show":_vm.errors.has('numero_processo'),"erro":_vm.errors.first('numero_processo')}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{class:['custom-font', { 'is-danger': _vm.errors.has('publicado') }]},[_vm._v("Publicado")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.publicado),expression:"model.publicado"}],staticClass:"form-control select-selected",attrs:{"name":"publicado"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "publicado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Sim")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 form-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){return _vm.salvar()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n        Salvar\n      ")],1)])]),_vm._v(" "),(_vm.model.id)?_c('arquivos-edital',{attrs:{"edital":_vm.model}}):_vm._e(),_vm._v(" "),(_vm.model.id)?_c('cargos',{attrs:{"edital_id":_vm.model.id,"numero":_vm.model.numero}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UcRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mp-grupos',
  inject: ["showConfirm"],
  data: function data() {
    return {
      apiUrl: 'material/grupo',
      fields: [{
        name: 'nome',
        title: 'Nome',
        sortField: 'nome',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  methods: {
    excluir: function excluir(data) {
      var _this = this;

      var me = this;
      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].delete(_this.apiUrl + '/' + data.codigo).then(function (resp) {
            me.consultar();
            me.$toastr.s('Item removido com sucesso');
          }).catch(function (error) {
            me.$toastr.e(error.response.data);
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    consultar: function consultar() {
      this.$refs.vuetable.refresh();
    },
    limpar: function limpar() {
      this.nome = '';
      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'grupos',
        value: 1
      });
    }
  },
  computed: {
    filtros: function filtros() {
      var nome = this.nome;

      return {
        nome: nome
      };
    },

    pagina: {
      get: function get() {
        var grupos = this.$store.state.vuetableState.grupos;
        var pagina = grupos.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'grupos',
          value: value
        });
      }
    },
    nome: {
      get: function get() {
        var grupos = this.$store.state.vuetableState.grupos;
        var nome = grupos.filtros.nome;

        return nome;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'grupos',
          value: value
        });
        this.resetPageStore();
      }
    }
  }
});

/***/ }),

/***/ "Ud3u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ue5m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emendasGeral__ = __webpack_require__("uHUi");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_4__components__["a" /* PublicHeader */],
    DataTable: __WEBPACK_IMPORTED_MODULE_4__components__["n" /* NoApiTable */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components__["b" /* Breadcrumb */],
    SideEmendas: __WEBPACK_IMPORTED_MODULE_4__components__["o" /* SideEmendas */],
    SelectAnoEmendas: __WEBPACK_IMPORTED_MODULE_4__components__["p" /* SelectAnoEmendas */]
  },
  data: function data() {
    return {
      emenda: {},
      navs: __WEBPACK_IMPORTED_MODULE_6__emendasGeral__["a" /* navs */],
      dataFields: __WEBPACK_IMPORTED_MODULE_6__emendasGeral__["b" /* dataFields */],
      filtros: {
        descricao: ''
      }
    };
  },

  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_5__utils__["e" /* formatarMoeda */],
    showDetails: function showDetails(emenda) {
      var _navs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(this.navs, 1),
          nav = _navs[0];

      nav.titulo = 'Detalhes da emenda';
      nav.subtitulo = 'Emenda n\xBA ' + emenda.numero + ' / ' + emenda.ano;
      nav.subtDetalhe = emenda.nome_orgao;
      this.emenda = emenda;

      this.$refs['side-emendas'].$emit('abreModal', nav.identidade);
    },
    downloadToCSV: function downloadToCSV() {
      var headers = {
        numero: 'Emenda nº',
        vereador: 'Vereador',
        secretaria: 'Secretaria',
        descricao: 'Descrição',
        valor: 'Valor',
        saldo: 'Saldo'
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* exportCSVFile */])(headers, [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.emendas.map(function (item) {
        return {
          numero: item.numero,
          vereador: item.vereador.nome,
          secretaria: item.nome_orgao,
          descricao: item.descricao,
          valor: Number(item.valor).toFixed(2).replace('.', ','),
          saldo: Number(item.saldo).toFixed(2).replace('.', ',')
        };
      }))), 'emendas');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    breadcrumb: function breadcrumb() {
      return [{
        label: 'Emendas Parlamentares',
        named_link: { name: 'emendas_parlamentares' }
      }, {
        label: this.ano
      }];
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    ano: function ano(state) {
      return state.emendas_parlamentares.ano;
    },
    emendasStore: function emendasStore(state) {
      return state.emendas_parlamentares.emendas;
    }
  }), {
    emendas: function emendas() {
      var _this = this;

      if (this.filtros.descricao) {
        var filter = function filter(item) {
          var vereador = item.vereador,
              sigla_orgao = item.sigla_orgao,
              descricao = item.descricao;


          var termo = _this.filtros.descricao.toUpperCase();
          return vereador.nome.toUpperCase().includes(termo) || sigla_orgao.toUpperCase().includes(termo) || descricao.toUpperCase().includes(termo);
        };

        return this.emendasStore.filter(filter);
      }

      return this.emendasStore;
    }
  })
});

/***/ }),

/***/ "UpjY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Upub":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UrVS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("76x5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc79d58a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("vVtC");
function injectStyle (ssrContext) {
  __webpack_require__("OX0H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc79d58a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc79d58a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UsLt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uv37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Minhas Ações")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"api-url":"planogoverno/compromisso-acao-profile","report-title":"Minhas Ações","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'minhasAcoes',"append-params":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [(props.rowData.unidade === props.rowData.unidade_executora && (!props.rowData.data_estimada_inicio || !props.rowData.data_estimada_conclusao))?_c('div',[_c('button',{staticClass:"btn btn-warning",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_vm._v("\n                            EDITAR\n                        ")])]):(props.rowData.unidade !== props.rowData.unidade_executora && (!props.rowData.data_estimada_inicio || !props.rowData.data_estimada_conclusao) && props.rowData.status != 'Rejeitada')?_c('div',[_c('button',{staticClass:"button button-success",attrs:{"title":"Aceitar","type":"button"},on:{"click":function($event){return _vm.saveActionState(props.rowData, 'Aceitar')}}},[_vm._v("\n                            Aceitar\n                        ")]),_vm._v(" "),_c('button',{staticClass:"button button-danger",attrs:{"title":"Rejeitar","type":"button"},on:{"click":function($event){return _vm.saveActionState(props.rowData, 'Rejeitar')}}},[_vm._v("\n                            Rejeitar\n                        ")])]):_c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Informações","type":"button"},on:{"click":function($event){return _vm.detalhar(props.rowData)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'info'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Iniciar ação","type":"button","disabled":props.rowData.status !== 'Não Iniciado'},on:{"click":function($event){return _vm.iniciar(props.rowData)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'calendar'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Concluir ação","type":"button","disabled":props.rowData.status !== 'Em andamento'},on:{"click":function($event){return _vm.concluir(props.rowData)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'check'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":props.rowData.unidade === props.rowData.unidade_executora ? 'Cancelar' : 'Rejeitar',"type":"button","disabled":props.rowData.status === 'Cancelada' 
                                || props.rowData.status === 'Rejeitada' 
                                || props.rowData.status === 'Concluído'},on:{"click":function($event){return _vm.cancelar(props.rowData)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'times'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"custom-font",attrs:{"for":"descritivo_filter"}},[_vm._v("Descritivo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.descritivo),expression:"descritivo"}],ref:"descritivo_filter",staticClass:"form-control",attrs:{"type":"text","name":"descritivo_filter","placeholder":"Buscar por descrição"},domProps:{"value":(_vm.descritivo)},on:{"change":_vm.consultar,"input":function($event){if($event.target.composing){ return; }_vm.descritivo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"custom-font",attrs:{"for":"status-filter"}},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],ref:"status_filter",staticClass:"form-control select-selected",attrs:{"name":"status_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("\n                                        Todos\n                                    ")]),_vm._v(" "),_vm._l((_vm.listas.status),function(status){return _c('option',{key:status,domProps:{"value":status}},[_vm._v("\n                                        "+_vm._s(status)+"\n                                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{staticClass:"custom-font",attrs:{"for":"prazo-filter"}},[_vm._v("Prazo")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.prazo),expression:"prazo"}],staticClass:"form-control select-selected",attrs:{"name":"prazo_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.prazo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("\n                                        Todos\n                                    ")]),_vm._v(" "),_vm._l((_vm.listas.prazos),function(prazo){return _c('option',{key:prazo.value,domProps:{"value":prazo.value}},[_vm._v("\n                                        "+_vm._s(prazo.text)+"\n                                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                                Filtrar\n                            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                                Limpar Filtros\n                            ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n                    ")],1)])],2)],1),_vm._v(" "),_c('SideAcao',{ref:"side",attrs:{"navs":_vm.sideConfig},on:{"concluir":_vm.concluirAcao,"iniciar":_vm.iniciarAcao,"salvarEdicao":_vm.salvarEdicao,"cancelarAcao":_vm.cancelarAcao,"aceitarAcao":_vm.aceitarAcao}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ux1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("XBKu");




var actions = {
  carregarEscolas: function carregarEscolas(store) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      try {
        __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('pesquisa/retorno-atividades-escolares/listar-escolas').then(function (response) {
          store.commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* LOAD_ESCOLAS */], response.data);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      } catch (e) {
        reject(e);
      }
    });
  }
};

/***/ }),

/***/ "Uynb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("\n      Plano de Governo\n      "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.periodoSelecionado),expression:"periodoSelecionado"}],staticClass:"select-periodo",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.periodoSelecionado=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.periodos),function(periodo,index){return _c('option',{key:index,domProps:{"value":periodo}},[_vm._v(_vm._s(periodo))])}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Lista dos Compromissos","api-url":"planogoverno/compromisso","report-title":"Planos de Governo","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'planoGoverno',"append-params":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Ver Detalhes","to":{ name: 'admin_planogoverno_details', 
                params: { id: props.rowData.id } }}},[_c('font-awesome-icon',{attrs:{"icon":'search'}})],1),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Editar","to":{ name: 'admin_planogoverno_edit', params: { id: props.rowData.id } }}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Homologar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'check'}})],1)],1)]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-2"},[_c('label',{staticClass:"custom-font",attrs:{"for":"unidade_filter"}},[_vm._v("Unidades")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.unidade_executora),expression:"unidade_executora"}],ref:"unidade_filter",staticClass:"form-control select-selected",attrs:{"name":"unidade_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.unidade_executora=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('optgroup',{attrs:{"label":"Secretarias"}},_vm._l((_vm.listas.secretarias),function(s){return _c('option',{key:s.sigla,attrs:{"title":s.nome},domProps:{"value":s.sigla}},[_vm._v("\n                        "+_vm._s(s.sigla)+"\n                      ")])}),0),_vm._v(" "),_c('optgroup',{attrs:{"label":"Autarquias"}},_vm._l((_vm.listas.autarquias),function(a){return _c('option',{key:a.sigla,attrs:{"title":a.nome},domProps:{"value":a.sigla}},[_vm._v("\n                        "+_vm._s(a.sigla)+"\n                      ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('label',{staticClass:"custom-font",attrs:{"for":"titulo_filter"}},[_vm._v("Título")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.titulo),expression:"titulo"}],staticClass:"form-control",attrs:{"type":"text","name":"titulo_filter"},domProps:{"value":(_vm.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.titulo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{staticClass:"custom-font",attrs:{"for":"status_filter"}},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],ref:"status_filter",staticClass:"form-control select-selected",attrs:{"name":"status_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("\n                      Todos\n                    ")]),_vm._v(" "),_vm._l((_vm.listas.status),function(status){return _c('option',{key:status,domProps:{"value":status}},[_vm._v("\n                      "+_vm._s(status)+"\n                    ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'admin_planogoverno_save' }}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" Adicionar\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V3RT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datatableFields__ = __webpack_require__("MtQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("0xDb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    chave: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: function _default() {
        return [{
          posicao: 0,
          gravidade: 'Normal',
          dtsolicitacao: null,
          media_espera: 0
        }];
      }
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getGravidadeClass: __WEBPACK_IMPORTED_MODULE_0__datatableFields__["b" /* getGravidadeClass */],
    formatTo2DigitsDate: __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* formatTo2DigitsDate */]
  }
});

/***/ }),

/***/ "V7DC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "V99r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return formatObjectToQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return capitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return capitalizeEachWord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return removeAccents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return contains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return createRelevanceIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toDate; });
/* unused harmony export twoDigit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return formatarDataMysql; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatarMoeda; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return desformatarMoeda; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mesesAbr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return mesesExt; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


var formatObjectToQueryString = function formatObjectToQueryString(obj) {
  if (obj instanceof Object) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).map(function (i) {
      var value = obj[i];
      if (Array.isArray(value)) {
        return value.map(function (v) {
          return i + '=' + value;
        }).join('&');
      } else {
        return i + '=' + value;
      }
    }).join('&');
  } else {
    console.log('Error queryStringFormat: param is not object!');
  }
};

var capitalize = function capitalize(string) {
  if (string) {
    var match = string.match(/(?!<.?)(\w)(?!.?>)/);
    var chars = string.split('');

    chars[match.index] = chars[match.index].toUpperCase();

    return chars.join('');
  }
  return string;
};

var capitalizeEachWord = function capitalizeEachWord(string) {
  if (string) {
    var arr = string.split(' ');

    //loop through each element of the array and capitalize the first letter.

    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }

    //Join all the elements of the array back into a string
    //using a blankspace as a separator
    var str2 = arr.join(' ');
    return str2;
  }
  return '';
};

var removeAccents = function removeAccents(string) {
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

var contains = function contains(string1, string2) {
  if (string1 === null || string2 === null) return false;

  var s1 = removeAccents(string1.toLowerCase());
  var s2 = removeAccents(string2.toLowerCase());

  return s1.indexOf(s2) > -1;
};

var createRelevanceIndex = function createRelevanceIndex(value, term) {
  if (!contains(value, term)) return false;

  var valueSplit = value.split(' ');
  if (valueSplit.length === 1) return 1;

  var foundIndex = valueSplit.findIndex(function (item) {
    return contains(item, term);
  });

  return foundIndex === -1 ? false : foundIndex;
};

var toDate = function toDate(dateStr) {
  var _dateStr$split = dateStr.split('/'),
      _dateStr$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_dateStr$split, 3),
      day = _dateStr$split2[0],
      month = _dateStr$split2[1],
      year = _dateStr$split2[2];

  return new Date(year, month - 1, day);
};

var twoDigit = function twoDigit(num) {
  if (num.toString().length === 2) return num.toString();

  return '0' + num;
};

var formatarDataMysql = function formatarDataMysql(data) {
  return new Date(data + ' 00:00').toLocaleDateString();
};

var formatarMoeda = function formatarMoeda(val) {
  var value = val;
  if (typeof val === 'string') {
    value = Number(val);
  }
  return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
};

// CREDO, OLHA A GAMBIARRA
var desformatarMoeda = function desformatarMoeda(val) {
  return Number(val.replace(/[R$ .]/g, '').replace(',', '.'));
};

var mesesAbr = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

var mesesExt = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

/***/ }),

/***/ "VByn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('label',{staticClass:"control-label"},[_vm._v("Localizar colaboradores")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.term),expression:"term"}],staticClass:"form-control",attrs:{"type":"text","pattern":"[a-zA-Z ]","placeholder":_vm.placeholder,"disabled":!_vm.employeesLoaded || _vm.disabled},domProps:{"value":(_vm.term)},on:{"keydown":_vm.keydownAllowOnlyPattern,"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.scrollEmployeesFound('down')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.scrollEmployeesFound('up')},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.selectEmployeeActive.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.reset.apply(null, arguments)}],"blur":_vm.resetLazy,"input":function($event){if($event.target.composing){ return; }_vm.term=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasEmployeesFound),expression:"hasEmployeesFound"}],ref:"autocomplete"},_vm._l((_vm.employeesFound),function(e,index){return _c('article',{key:index,class:{ selected: e.active },on:{"click":function($event){return _vm.select(e)}}},[_c('span',{domProps:{"innerHTML":_vm._s(e.termo)}},[_vm._v(_vm._s(e.termo))]),_vm._v(" "),_c('span',{staticClass:"pull-right",domProps:{"innerHTML":_vm._s(e.termoCargo)}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden"},domProps:{"value":e.sshd}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VINc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.39b4a7c.jpg";

/***/ }),

/***/ "VKxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("tBN9");


var _LOGIN_USER$LOGOUT_US;



/* harmony default export */ __webpack_exports__["a"] = (_LOGIN_USER$LOGOUT_US = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_USER$LOGOUT_US, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* LOGIN_USER */], function (state, payload) {
  //   state.codigo = payload.user.codigo
  //   state.email = payload.user.email
  //   state.origem = payload.user.origem
  //   state.username = payload.user.username
  //   state.perfis = payload.perfis
  //   state.isLogged = true
  //   state.initialized = true
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_USER$LOGOUT_US, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* LOGOUT_USER */], function (state) {
  // state.user = {}
  // state.isLogged = false
  // state.initialized = false
}), _LOGIN_USER$LOGOUT_US);

/***/ }),

/***/ "VPee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_colors__ = __webpack_require__("ZAg2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BarChart: __WEBPACK_IMPORTED_MODULE_0__common__["d" /* BarChart */]
  },
  data: function data() {
    return {
      especialidades: Array(),
      exames: Array(),
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function label(tooltipItem, data) {
              return Number(tooltipItem.yLabel).toLocaleString();
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: function callback(label, index, labels) {
                return Number(label).toLocaleString();
              }
            }
          }]
        }
      }
    };
  },
  mounted: function mounted() {
    this.fetchAgendados();
  },

  methods: {
    fetchAgendados: function fetchAgendados() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('/procedimentos-saude/especialidades/total-agendados').then(function (response) {
        _this.especialidades = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('/procedimentos-saude/exames/total-agendados').then(function (response) {
        _this.exames = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    }
  },
  computed: {
    chartData: function chartData() {
      var labels = this.especialidades.map(function (item) {
        var dataAtual = new Date(item.mesano + '-01 00:00');
        return _.startCase(dataAtual.toLocaleString('default', {
          month: 'short'
        })) + ' / ' + dataAtual.getFullYear().toString().substring(2);
      });

      var datasets = [{
        label: 'Especialidades',
        data: this.especialidades.map(function (item) {
          return item.total;
        }),
        backgroundColor: __WEBPACK_IMPORTED_MODULE_2__utils_colors__["a" /* default */].coresHexa[0]
      }, {
        label: 'Exames',
        data: this.exames.map(function (item) {
          return item.total;
        }),
        backgroundColor: __WEBPACK_IMPORTED_MODULE_2__utils_colors__["a" /* default */].coresHexa[1]
      }];
      return {
        labels: labels,
        datasets: datasets
      };
    }
  }
});

/***/ }),

/***/ "VRry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-reference-container"},[_c('label',{staticClass:"control-label"},[_vm._v("Mês de referência")]),_vm._v(" "),_c('Select',{attrs:{"showOptionEmpty":false,"options":_vm.references},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VSlJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VZDn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VaBq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VdjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_pesquisa_js__ = __webpack_require__("JA75");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_148125da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("mg2T");
function injectStyle (ssrContext) {
  __webpack_require__("aN5D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_pesquisa_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_148125da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VhEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"habilitados"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h2',{staticClass:"page-header"},[_vm._v("Pré-habilitados")]),_vm._v(" "),_c('h3',[_vm._v("\n        Edital nº "+_vm._s(_vm.edital.numero)+" - Processo nº\n        "+_vm._s(_vm.edital.processo_numero)+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table',{ref:"vuetable",attrs:{"title":'Lista de Cargos',"dados":_vm.cargos,"fields":_vm.fields,"carregando":_vm.loading.data}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12 form-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"role":"button"},on:{"click":function($event){return _vm.urlArquivoBase()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}}),_vm._v("\n        Baixar arquivo base\n      ")],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"input-file-import"}},[_vm._v("Upload CSV Habilitados")]),_vm._v(" "),_c('input',{ref:"import_file",staticClass:"form-control",class:{ ' is-invalid': _vm.error.message },attrs:{"type":"file","id":"input-file-import","name":"file_import","accept":".csv"},on:{"change":_vm.onFileChange}})]),_vm._v(" "),(_vm.error.message)?_c('div',{staticClass:"invalid-feedback"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":!this.import_file || _vm.loading.file},on:{"click":_vm.proceedAction}},[(_vm.loading.file)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n          Enviar\n        ")],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('pre-habilitado-table',{ref:"vuetable_habilitados",attrs:{"id":"vuetable_habilitados","title":'Lista de Pré-Habilitados',"data":_vm.habilitados,"carregando":_vm.loading.data}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',{attrs:{"id":"cabecalho_habilitados"}},[_vm._v("Importar Pré-habilitados")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VhyD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brasao-cor-horizontal.0effeb8.png";

/***/ }),

/***/ "VlT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common___ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_strings_js__ = __webpack_require__("V99r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card__ = __webpack_require__("9i0h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PublicHeader: __WEBPACK_IMPORTED_MODULE_3__components_common___["a" /* PublicHeader */], BarChart: __WEBPACK_IMPORTED_MODULE_3__components_common___["d" /* BarChart */], Card: __WEBPACK_IMPORTED_MODULE_6__Card__["a" /* default */], AnoBase: __WEBPACK_IMPORTED_MODULE_3__components_common___["j" /* AnoBase */] },
  data: function data() {
    return {
      cores: [],
      graficos_base: { labels: [], datasets: [{ label: '', data: [] }] },
      items: {
        iptu: {
          title: 'IPTU',
          nome: 'Imposto sobre a Propriedade Predial e Territorial Urbana'
        },
        issqn: {
          title: 'ISSQN',
          nome: 'Imposto sobre Serviços de Qualquer Natureza'
        },
        itbi: {
          title: 'ITBI',
          nome: 'Transmissão "Inter Vivos" de Bens Imóveis e de Direitos Reais sobre Imóveis'
        },
        ir_fonte: {
          title: 'Imposto de Renda Retido na Fonte',
          nome: 'Imposto sobre a Renda - Retido na Fonte'
        },
        taxas: {
          title: 'Taxas',
          nome: 'Taxas'
        },
        fundeb: {
          title: 'FUNDEB',
          nome: 'Transferências de Recursos do Fundo de Manutenção e Desenvolvimento da Educação Básica e de Valorização dos Profissionais da Educação - FUNDEB'
        },
        ipva: {
          title: 'IPVA',
          nome: 'Cota-Parte do IPVA'
        },
        transf_uniao: {
          title: 'Transferências da União',
          nome: 'Transferências da União e de suas Entidades'
        },
        transf_estado: {
          title: 'Transferências do Estado',
          nome: 'Transferências dos Estados e do Distrito Federal e de suas Entidades'
        }
      }
    };
  },
  created: function created() {
    this.cores = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__utils_colors_js__["a" /* default */].coresHexa));
  },

  methods: {
    filtrarPorCodigo: function filtrarPorCodigo(codigo) {
      var receitas_proprias = this.$store.state.receitas_despesas.receitas_proprias;


      var filterByID = function filterByID(obj) {
        if ('ds_plano_conta' in obj && obj.ds_plano_conta.includes(codigo)) {
          return true;
        } else {
          return false;
        }
      };

      var atual = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, receitas_proprias.filter(filterByID));

      return { atual: atual[0] };
    },
    infoCards: function infoCards(codigo) {
      var receita = this.filtrarPorCodigo(codigo);
      var percentual = (receita.atual.vl_total_f / (receita.atual.vl_atualizado_f || 1) * 100).toFixed(0);

      return [{ label: 'Previsão Anual', value: receita.atual.vl_atualizado }, { label: 'Arrecadado', value: receita.atual.vl_total }, {
        label: 'Percentual',
        value: 'Arrecadado aproximadamente ' + percentual + '% da previs\xE3o'
      }];
    },

    formatarMoeda: __WEBPACK_IMPORTED_MODULE_5__utils_strings_js__["b" /* formatarMoeda */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapState */])({
    anoAtual: function anoAtual(state) {
      return state.receitas_despesas.ano_base;
    }
  }), {
    retornaMesComparativo: function retornaMesComparativo() {
      var data = new Date();
      if (this.anoAtual !== data.getFullYear()) {
        return new Date(this.anoAtual, 11, 31).toLocaleString('default', { month: 'long' });
      }

      return data.toLocaleString('default', { month: 'long' });
    },
    loading: function loading() {
      return this.receitas.length === 0;
    },
    receitas: function receitas() {
      return this.$store.state.receitas_despesas.receitas_proprias;
    },
    listaCards: function listaCards() {
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.items);
      var items = [];

      for (var index = 0; index < keys.length; index++) {
        var element = this.items[keys[index]];

        items.push({
          title: element.title,
          data: this.infoCards(element.nome),
          link: 'receitas/detalhes/' + this.filtrarPorCodigo(element.nome).atual.cd_plano_conta_rel + '/',
          tooltip: this.filtrarPorCodigo(element.nome).atual.ds_plano_conta
        });
      }

      return items;
    },
    graficoHeader: function graficoHeader() {
      var dadosCorrente = this.filtrarPorCodigo('Receitas Correntes');
      var dadosCapital = this.filtrarPorCodigo('Receitas de Capital');
      var labelFinal = [];
      var data = [];
      var acum = 0;

      for (var index = 0; index < __WEBPACK_IMPORTED_MODULE_5__utils_strings_js__["a" /* mesesAbr */].length; index++) {
        var element = __WEBPACK_IMPORTED_MODULE_5__utils_strings_js__["a" /* mesesAbr */][index].toLowerCase();

        if (dadosCorrente.atual['vl_' + element + '_f'] === '0' && dadosCapital.atual['vl_' + element + '_f'] === '0') {
          break;
        }

        labelFinal.push(__WEBPACK_IMPORTED_MODULE_5__utils_strings_js__["a" /* mesesAbr */][index]);
        acum += Number(dadosCorrente.atual['vl_' + element + '_f']) + Number(dadosCapital.atual['vl_' + element + '_f']);
        data.push(acum);
      }

      var previsaoAtual = Array(labelFinal.length).fill(this.orcamentoAtual);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.graficos_base, {
        labels: labelFinal,
        datasets: [{
          type: 'line',
          label: 'Previs\xE3o Anual - ' + this.anoAtual,
          backgroundColor: this.cores[0],
          borderColor: this.cores[0],
          fill: false,
          data: previsaoAtual
        }, {
          label: 'Receita Acumulada - ' + this.anoAtual,
          backgroundColor: this.cores[1],
          data: data
        }]
      });
    },
    receitaAtual: function receitaAtual() {
      var loading = this.loading,
          formatarMoeda = this.formatarMoeda,
          filtrarPorCodigo = this.filtrarPorCodigo;


      if (loading) {
        return formatarMoeda(0);
      }

      var receitaCorrente = filtrarPorCodigo('Receitas Correntes').atual.vl_total_f;
      var receitaCapital = filtrarPorCodigo('Receitas de Capital').atual.vl_total_f;

      return Number(receitaCorrente) + Number(receitaCapital);
    },
    orcamentoAtual: function orcamentoAtual() {
      var loading = this.loading,
          formatarMoeda = this.formatarMoeda,
          filtrarPorCodigo = this.filtrarPorCodigo;


      if (loading) {
        return formatarMoeda(0);
      }

      var receitaCorrente = filtrarPorCodigo('Receitas Correntes').atual.vl_atualizado_f;
      var receitaCapital = filtrarPorCodigo('Receitas de Capital').atual.vl_atualizado_f;

      return Number(receitaCorrente) + Number(receitaCapital);
    }
  })
});

/***/ }),

/***/ "VmGU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("/f4+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143e9bba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("4SMn");
function injectStyle (ssrContext) {
  __webpack_require__("P/0t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-143e9bba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143e9bba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vp40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("M6vP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23be3786_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GhZd");
function injectStyle (ssrContext) {
  __webpack_require__("3uwM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23be3786"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23be3786_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vvib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pdg"},[_c('public-header',{attrs:{"title":'Plano de Metas'}},[_c('div',{staticClass:"col-sm-6"},[_c('p',[_vm._v("\n        Aqui você encontra um resumo das METAS da Administração Municipal a\n        serem executadas no período de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v("2021 a 2024")]),_vm._v(".\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        A atual administração possui um total de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.total))]),_vm._v("\n        metas e até a presente data,\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.concluidas))]),_vm._v("\n        estão concluídas,\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.emAndamento))]),_vm._v("\n        estão em andamento e\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.naoCumpridas))]),_vm._v("\n        não foram cumpridas.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Para mais detalhes,\n        "),_c('a',{attrs:{"href":"https://egov.santos.sp.gov.br/santosmapeada/Gestao/PlanoMunicipalGoverno/MapaPlanoMunicipalGoverno/#","target":"_blank"}},[_vm._v("\n          acesse o conteúdo completo aqui.\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"row"},[_c('doughnut',{staticStyle:{"max-width":"300px","floating":"none","margin":"0 auto"},attrs:{"chart-data":_vm.createChartData(_vm.metasPorStatus),"gradiente":false,"options":Object.assign({}, this.options,
            {legend: {
              labels: {
                fontColor: 'rgb(255, 255, 255)'
              }
            }})}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-offset-1 col-xs-11 margem-topo"},[_c('span',{staticClass:"destaque-header"},[_vm._v("EM ANDAMENTO:")]),_vm._v(" Meta iniciada e\n          ainda em andamento."),_c('br'),_vm._v(" "),_c('span',{staticClass:"destaque-header"},[_vm._v("CONCLUÍDA:")]),_vm._v(" Meta finalizada."),_c('br'),_vm._v(" "),_c('span',{staticClass:"destaque-header"},[_vm._v("NÃO CUMPRIDA:")]),_vm._v(" Meta não\n          finalizada.\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',{},[_vm._v("Metas")])])]),_vm._v(" "),_c('div',{staticClass:"filtro-secretaria"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('v-select',{ref:"unidades",staticClass:"style-chooser",attrs:{"label":"unidaderesponsavel","placeholder":'Todas as secretarias',"options":_vm.secretarias,"selectOnTab":true},model:{value:(_vm.unidade),callback:function ($$v) {_vm.unidade=$$v},expression:"unidade"}})],1)]),_vm._v(" "),(_vm.unidade)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('doughnut',{staticStyle:{"max-width":"300px","margin":"10px auto"},attrs:{"chart-data":_vm.createChartData(_vm.metasSecretariaStatus),"gradiente":false,"options":_vm.options}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("\n            "+_vm._s(this.unidade)+"\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.total))]),_vm._v("\n            metas\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.totalPorcentagem)+"%")]),_vm._v("\n            do total de compromissos/metas\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.concluidas))]),_vm._v("\n            metas(s) concluída(s)\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.emAndamento))]),_vm._v("\n            metas(s) em andamento\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.naoCumpridas))]),_vm._v("\n            metas(s) não cumprida(s)\n          ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.secretariaSumario.naoIniciadas))]),_vm._v("\n            metas(s) não iniciada(s)\n          ")]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.link_externo,"target":"_blank"}},[_c('i',{staticClass:"fa fa-list"}),_vm._v(" Veja a lista completa aqui")])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mais-compromissos"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.secretariasTop6Metas),function(ref,index){
          var sigla = ref.sigla;
          var count = ref.count;
          var percentual = ref.percentual;
return _c('div',{key:index,staticClass:"col-sm-4 margem-bottom"},[_c('h4',[_vm._v("\n            "+_vm._s(_vm.entidadeBySigla(sigla))+"\n          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(count))]),_vm._v(" de um total de "),_c('b',[_vm._v(_vm._s(_vm.total))]),_vm._v(" metas\n          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(percentual)+"%")]),_vm._v(" do\n            total\n          ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"rank-concluido"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"hidden-xs"},[_vm._m(3),_vm._v(" "),_vm._l((_vm.rankingConcluidas.data),function(ref,index){
          var sigla = ref.sigla;
          var secretaria = ref.secretaria;
          var total = ref.total;
          var concluidas = ref.concluidas;
          var percentual = ref.percentual;
return _c('div',{key:index + '-' + sigla,class:[index % 2 === 0 ? '' : 'lista-impar', 'row lista-body']},[_c('div',{staticClass:"col-xs-12 col-sm-1"},[_vm._v("\n            "+_vm._s(index + 1)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-5"},[_vm._v("\n            "+_vm._s(secretaria)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(total)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(concluidas)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(percentual)+"%\n          ")])])}),_vm._v(" "),_c('div',{staticClass:"row lista-impar lista-header"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(_vm.rankingConcluidas.totalMetas)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(_vm.rankingConcluidas.totalConcluidas)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            "+_vm._s(_vm.rankingConcluidas.totalPercentual)+"%\n          ")])])],2),_vm._v(" "),_c('div',{staticClass:"row hidden-sm hidden-md hidden-lg"},_vm._l((_vm.rankingConcluidas.data),function(ref,index){
          var sigla = ref.sigla;
          var secretaria = ref.secretaria;
          var concluidas = ref.concluidas;
          var total = ref.total;
          var percentual = ref.percentual;
return _c('div',{key:sigla,staticClass:"col-sm-4 altura-card"},[_c('h4',[_vm._v(_vm._s(index + 1 + ' - ' + secretaria))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(concluidas))]),_vm._v(" de um total de "),_c('b',[_vm._v(_vm._s(total))])]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(percentual)+"%")]),_vm._v(" do total\n          ")])])}),0),_vm._v(" "),_c('div',{staticClass:"row margem-topo"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Downloads")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.DownloadJSON2CSV()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}}),_vm._v(" Exportar para CSV\n          ")],1)])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Informações por Secretaria")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Secretarias / Entidades com mais metas no total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Secretarias / Entidades com mais metas concluídas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row lista-impar lista-header"},[_c('div',{staticClass:"col-xs-12 col-sm-1"},[_vm._v("\n             \n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-5"},[_vm._v("\n            Unidade\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            Total de Metas\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            Concluídas\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2 text-right"},[_vm._v("\n            Percentual (%)\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-6 text-left"},[_c('strong',[_vm._v("Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VwQt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keydownFormatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return keydownAllowOnlyPattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lockIfValueIsNull; });
var keydownFormatTime = function keydownFormatTime(event) {
  var key = event.key,
      code = event.code,
      value = event.target.value;


  if (code.indexOf('Digit') === -1 || value.length > 3 || key === 'h') return;

  if (
  // validando o primeiro digito
  value === '' && eval(key) > 2 ||
  // validando o segundo digito
  value.length === 1 && eval(value) === 2 && eval(key) > 3 ||
  // validando o terceiro digito
  value.length === 2 && eval(key) > 5 || value.length === 3 && eval(key) > 5) {
    event.preventDefault();
  }
};

//it needed to use the attribute pattern in the input tag
var keydownAllowOnlyPattern = function keydownAllowOnlyPattern(event) {
  var key = event.key,
      pattern = event.target.pattern;


  var regex = new RegExp(pattern);
  if (!regex.test(key)) {
    event.preventDefault();
  } else {
    return;
  }
};

var lockIfValueIsNull = function lockIfValueIsNull(event) {
  var target = event.target;


  if (target.value.length === 0) {
    target.focus();
  }
};

/***/ }),

/***/ "VyLF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COORDENADAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return latLong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return latLongGroup; });
var COORDENADAS = [
// filtradas
{
  nome: 'USF CASTELO',
  lat: -23.948655969597233,
  lng: -46.378859589829766
}, {
  nome: 'UBS VILA MATHIAS',
  lat: -23.94986450867183,
  lng: -46.324961894342856
}, {
  nome: 'UBS MARAPE',
  lat: -23.952380801527806,
  lng: -46.34974688930224
}, {
  nome: 'UBS GONZAGA',
  lat: -23.960129346688642,
  lng: -46.33060778563961
}, {
  nome: 'USF CARUARA',
  lat: -23.88866980655436,
  lng: -46.189055399998864
}, {
  nome: 'USF ESTUARIO',
  lat: -23.970534224204897,
  lng: -46.30218188258747
}, {
  nome: 'USF PIRATININGA',
  lat: -23.92516069865887,
  lng: -46.38838778249971
}, {
  nome: 'CAPS ORQUIDARIO',
  lat: -23.965265546418568,
  lng: -46.34792012989119
}, {
  nome: 'CENTRO DE ATENCAO PSICOSSOCIAL ZONA NOROESTE CAPS ZNO',
  lat: -23.9405310087029,
  lng: -46.37595669746882
}, {
  nome: 'USF BOM RETIRO',
  lat: -23.936049899472838,
  lng: -46.37057115023008
}, {
  nome: 'UBS APARECIDA',
  lat: -23.971490037337663,
  lng: -46.30827495872207
}, {
  nome: 'USF AREIA BRANCA',
  lat: -23.945553091945303,
  lng: -46.37335972250497
}, {
  nome: 'USF VILA NOVA',
  lat: -23.9378914040528,
  lng: -46.328092405057475
}, {
  nome: 'USF NOVA CINTRA',
  lat: -23.943053498792523,
  lng: -46.35181977779323
}, {
  nome: 'USF ALEMOA E CHICO DE PAULA',
  lat: -23.93117499528208,
  lng: -46.35868460978533
}, {
  nome: 'USF VILA PROGRESSO',
  lat: -23.939034471212008,
  lng: -46.35291569872289
}, {
  nome: 'CENTRO DE ATENCAO PSICOSSOCIAL III DA VILA CAPS DA VILA',
  lat: -23.95817071369301,
  lng: -46.34499981524723
}, {
  nome: 'UBS POMPEIA/JOSE MENINO',
  lat: -23.963293507881293,
  lng: -46.341737775222704
}, {
  nome: 'UBS CAMPO GRANDE',
  lat: -23.955068012704256,
  lng: -46.34348323129469
}, {
  nome: 'UBS EMBARE',
  lat: -23.965351872876845,
  lng: -46.310599296607904
}, {
  nome: 'AMBULATORIO DE ESPECIALIDADES NELSON TEIXEIRA',
  lat: -23.958613708854887,
  lng: -46.31862380006187
}, {
  nome: 'USF MORRO SAO BENTO',
  lat: -23.937083812831098,
  lng: -46.342338778195334
}, {
  nome: 'USF JABAQUARA',
  lat: -23.940787200116358,
  lng: -46.33551170165025
}, {
  nome: 'USF SAO MANOEL',
  lat: -23.929615810334692,
  lng: -46.379725156412604
}, {
  nome: 'USF MARTINS FONTES',
  lat: -23.945755278537607,
  lng: -46.319208905131966
}, {
  nome: 'USF VALONGO',
  lat: -23.930420480318787,
  lng: -46.34177722800046
}, {
  nome: 'SEAMBESP ZONA NOROESTE SANTOS',
  lat: -23.943680013079863,
  lng: -46.37667988033745
}, {
  nome: 'USF MORRO DA PENHA',
  lat: -23.93148478206371,
  lng: -46.3427929641413
}, {
  nome: 'USF MORRO SANTA MARIA',
  lat: -23.93729263305818,
  lng: -46.35916923384224
}, {
  nome: 'USF MONTE SERRAT',
  lat: -23.93793601287503,
  lng: -46.32786214457841
}, {
  nome: 'CAPS CENTRO',
  lat: -23.95596377065241,
  lng: -46.31653351200402
}, {
  nome: 'USF MORRO JOSE MENINO',
  lat: -23.96319076545849,
  lng: -46.357686621978665
}, {
  nome: 'UBS RADIO CLUBE',
  lat: -23.94059590952182,
  lng: -46.38219565790921
}, {
  nome: 'CENTRO DE ATENCAO PSICOSSOCIAL PRAIA CAPS PRAIA',
  lat: -23.979061037919244,
  lng: -46.30336651725274
}, {
  nome: 'UBS PONTA DA PRAIA',
  lat: -23.97837940194696,
  lng: -46.300794127962156
}, {
  nome: 'UBS CONSELHEIRO NEBIAS',
  lat: -23.953952114137504,
  lng: -46.32231301028231
}, {
  nome: 'USF VILA SAO JORGE E CANELEIRA',
  lat: -23.94565584783224,
  lng: -46.36570039178782
}, {
  nome: 'USF MONTE CABRAO',
  lat: -23.919432746967548,
  lng: -46.2860376405012
  // não filtradas
}];

var latLong = function latLong(unidade) {
  var finder = function finder(latitude) {
    return latitude.nome === unidade;
  };
  return COORDENADAS.find(finder) || {
    nome: 'santos-default',
    lat: -23.857523739574418,
    lng: -46.293318312076764
  };
};

var latLongGroup = function latLongGroup(unidades) {
  var filter = function filter(coordenada) {
    return unidades.find(function (_ref) {
      var unidade_saude = _ref.unidade_saude;
      return unidade_saude === coordenada.nome;
    });
  };

  return COORDENADAS.filter(filter).map(function (_ref2) {
    var lat = _ref2.lat,
        lng = _ref2.lng,
        title = _ref2.nome;

    var _unidades$find = unidades.find(function (unidade) {
      return unidade.unidade_saude === title;
    }),
        available = _unidades$find.disponivel;

    return {
      position: {
        lat: lat,
        lng: lng
      },
      title: title,
      available: available
    };
  });
};

/***/ }),

/***/ "Vzbx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beneficios"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table',{ref:"vuetable",attrs:{"show-empty":true,"title":"Lista de Pagamentos","api-url":"assistencia/pagamentos/listar","report-title":"Pagamentos","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'assistenciaPagamentos',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"icon",fn:function(props){return [_vm._v("\n          "+_vm._s(_vm.retornarPeriodo(props.rowData))+"\n        ")]}},{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.$router.push({
                  name: 'pagamentos_edit',
                  params: { item: props.rowData }
                })}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash-alt'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{staticClass:"custom-font"},[_vm._v("Filtros")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 form-group"},[_c('label',{staticClass:"custom-font"},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nome),expression:"nome"}],staticClass:"form-control",attrs:{"name":"filter_nome","type":"text","placeholder":"Digite um nome..."},domProps:{"value":(_vm.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 col-sm-4 form-group"},[_c('label',{staticClass:"custom-font"},[_vm._v("Ano")]),_vm._v(" "),_c('the-mask',{staticClass:"form-control",attrs:{"mask":'####'},model:{value:(_vm.ano),callback:function ($$v) {_vm.ano=$$v},expression:"ano"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6 col-sm-4 form-group"},[_c('label',{staticClass:"custom-font"},[_vm._v("Mês")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mes),expression:"mes"}],staticClass:"form-control select-selected",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mes=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{key:0,domProps:{"value":''}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.meses),function(mes,index){return _c('option',{key:(index + "-" + mes),domProps:{"value":index + 1}},[_vm._v(_vm._s(mes))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 col-sm-4 form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Benefício")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.beneficio),expression:"beneficio"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"beneficio",staticClass:"form-control select-selected",attrs:{"name":"beneficio"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.beneficio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{key:0,domProps:{"value":''}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.beneficios),function(item){return _c('option',{key:item.codigo,domProps:{"value":item.codigo}},[_vm._v("\n                  "+_vm._s(item.sigla)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'search'}}),_vm._v("\n              Consultar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n              Limpar dados\n            ")],1)])]),_vm._v(" "),_vm._v(" "),_c('template',{staticClass:"form-group",slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":'/admin/assistencia/load'}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n          ")],1)],1)],2)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',{staticClass:"page-header"},[_vm._v("Pagamentos de Benefícios")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W6qi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: String,
    name: String,
    placeholder: String,
    model: Object,
    urlsource: String,
    propsource: String,
    classNameWrapper: String,
    classNameInput: String,
    classNameList: {
      type: String,
      default: ''
    },
    classNameListItem: String,
    item_key: String,
    item_text: String,
    onSetData: Function
  },
  data: function data() {
    return {
      source: [],
      list: [],
      selectedIndex: -1,
      user: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    var me = this;
    __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].get(this.urlsource).then(function (r) {
      var data = r;
      if (_this.propsource.length > 0) {
        data = r[_this.propsource];
      }
      var s = data.map(function (i) {
        i.actived = i.selected = false;
        return i;
      });
      me.source = s;
      me.list = s;
    }).catch(function (e) {
      console.log(e);
    });
  },

  methods: {
    showList: function showList() {
      return this.user.length > 0 && this.list.length > 0;
    },
    onKeyup: function onKeyup(event) {
      if (event.keyCode === 38 || event.keyCode === 40) {
        this.toogleActive(event);
      } else if (this.user.length > 0) {
        this.filter();
      }
    },
    toogleActive: function toogleActive(event) {
      var kcode = event.keyCode;
      var currentIndex = this.selectedIndex;

      if (kcode === 38) {
        if (this.selectedIndex === 0) {
          return;
        }
        this.selectedIndex--;
      }
      if (kcode === 40) {
        if (this.selectedIndex === this.list.length - 1) {
          return;
        }
        this.selectedIndex++;
      }

      if (currentIndex > -1) {
        this.list[currentIndex].actived = false;
      }

      this.list[this.selectedIndex].actived = true;
    },
    filter: function filter() {
      var m = this;
      var value = m.user.toLowerCase();
      m.list = m.source.filter(function (item) {
        return item[m.item_text].toLowerCase().indexOf(value) > -1;
      });
    },
    setData: function setData(item) {
      // var u = {}
      // if (this.selectedIndex > -1) {
      //   u = this.list[this.selectedIndex]
      // } else {
      //   u = this.list[0]
      // }
      this.onSetData(item);
      item.actived = false;
      // u.actived = false
      this.user = '';
      this.selectedIndex = -1;
    }
  }
});

/***/ }),

/***/ "WDd6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WH8E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_colors__ = __webpack_require__("ZAg2");

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_1__common__["c" /* PieChart */]
  },
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      dados: { datasets: [] },
      options: {
        responsive: true,
        title: {
          display: true,
          text: 'Quantidade de ' + this.title,
          position: 'bottom'
        },
        tooltips: this.getToolTip(this.title),
        plugins: {
          datalabels: {
            color: ['#697473', '#FFF', '#697473', '#FFF', '#FFF', '#FFF'],
            font: {
              size: 20
            },
            align: 'end',
            display: false
          }
        }
      }
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },

  methods: {
    getToolTip: function getToolTip(value) {
      return {
        callbacks: {
          label: function label(tooltip, dataset) {
            var index = tooltip.index;
            var data = dataset.datasets[0].data;

            var label = dataset.labels[index];

            return label + ': ' + data[index] + ' ' + value;
          }
        }
      };
    },
    fetchData: function fetchData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get(this.apiUrl).then(function (response) {
        var data = response.data;


        var medias = data.map(function (item) {
          return Number(item.media).toFixed(0);
        });

        _this.setMedias(medias);
      }).catch(function (error) {
        var response = error.response;

        console.log(response);
        _this.$toastr.e('Houve um errro ao carregar as estat\xEDsticas. Atualize a p\xE1gina e tente novamente');
      });
    },

    mediaReducer: function mediaReducer(acum, atual) {
      var value = Number(atual);
      switch (true) {
        // case value < 15:
        //   acum.quinze++
        //   break
        // case value < 30:
        //   acum.trinta++
        //   break
        // case value < 45:
        //   acum.quarentacinco++
        //   break
        // case value < 60:
        //   acum.sessenta++
        //   break
        // case value < 75:
        //   acum.setentacinco++
        //   break
        case value <= 90:
          acum.noventa++;
          break;
        default:
          acum.mais++;
          break;
      }

      return acum;
    },
    setMedias: function setMedias(medias) {
      var _medias$reduce = medias.reduce(this.mediaReducer, {
        // quinze: 0,
        // trinta: 0,
        // quarentacinco: 0,
        // sessenta: 0,
        // setentacinco: 0,
        noventa: 0,
        mais: 0
      }),
          noventa = _medias$reduce.noventa,
          mais = _medias$reduce.mais;

      var datasets = [{
        data: [
        // quinze,
        // trinta,
        // quarentacinco,
        // sessenta,
        // setentacinco,
        noventa, mais],
        backgroundColor: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__utils_colors__["a" /* default */].coresHexa))
        // backgroundColor: [
        //   '#0ba81f',
        //   '#3c8e21',
        //   '#6d7323',
        //   '#9d5925',
        //   '#ce3e27',
        //   '#ff2429'
        // ]
      }];

      this.dados = {
        labels: [
        // 'Até 15 dias',
        // 'Até 30 dias',
        // 'Até 45 dias',
        // 'Até 60 dias',
        // 'Até 75 dias',
        '0 a 90 dias', 'Acima de 90 dias'],
        datasets: datasets
      };
    }
  },
  computed: {
    chartData: function chartData() {
      return this.dados;
    }
  }
});

/***/ }),

/***/ "WI/y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("\n      Relatórios\n      "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Ranking de lançamentos de dados "+_vm._s(_vm.anoAnterior))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable1",attrs:{"show-empty":true,"title":"Secretarias","api-url":"dado/secretaria/rankinglancamentos","report-title":"Ranking de lançamentos de dados 2018 por secretarias","initial-page":_vm.paginaSecretarias,"pageCollection":'dadosRelatoriosSecretarias',"fields":_vm.fields1}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable2",attrs:{"show-empty":true,"title":"Autarquias","api-url":"dado/autarquia/rankinglancamentos","report-title":"Ranking de lançamentos de dados 2018 por secretarias","initial-page":_vm.paginaAutarquias,"pageCollection":'dadosRelatoriosAutarquias',"fields":_vm.fields2}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WKXi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/14.ab71b1c.jpg";

/***/ }),

/***/ "WTlz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WWR1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row educacao"},[_c('public-header',{attrs:{"title":'Educação Transparente'}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"subheader"},[(_vm.model.lista_escolas.length)?_c('span',[_vm._v(_vm._s(_vm.model.lista_escolas.length)+" escolas\n        ")]):_c('span',[_c('pulse-loader',{staticClass:"loading",attrs:{"size":'0.5em'}})],1),_vm._v("\n        "+_vm._s(_vm.model.filtros.bairro
            ? 'no bairro ' + _vm.model.filtros.bairro.descricao
            : '')+"\n        com um total de\n        "),(_vm.model.totalAlunos)?_c('span',[_vm._v(_vm._s(_vm.formatTotalAlunos))]):_c('span',[_c('pulse-loader',{staticClass:"loading",attrs:{"size":'0.5em'}})],1),_vm._v("\n        alunos\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-3"},[_c('v-select',{ref:"bairros",staticClass:"style-chooser",attrs:{"label":"descricao","placeholder":'Selecione o bairro',"options":_vm.model.lista_bairros,"selectOnTab":true},on:{"input":_vm.listarEscolas},model:{value:(_vm.model.filtros.bairro),callback:function ($$v) {_vm.$set(_vm.model.filtros, "bairro", $$v)},expression:"model.filtros.bairro"}},[_c('template',{slot:"no-options"},[_vm._v("\n          Bairro não encontrado...\n        ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-5 col-md-4"},[_c('v-select',{ref:"ensinos",staticClass:"style-chooser",attrs:{"label":"descricao","placeholder":'Selecione o tipo de ensino',"options":_vm.model.lista_ensinos,"selectOnTab":true},on:{"input":_vm.listarEscolas},model:{value:(_vm.model.filtros.ensino),callback:function ($$v) {_vm.$set(_vm.model.filtros, "ensino", $$v)},expression:"model.filtros.ensino"}},[_c('template',{slot:"no-options"},[_vm._v("\n          Ensino não encontrado...\n        ")])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"container conteudo"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',{},[_vm._v("Escolas")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],staticClass:"form-control filtro-escola",attrs:{"type":"text","placeholder":"Digite o nome da escola..."},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){return _vm.$refs.isotope.filter('filterByText')},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}})])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[(!!_vm.model.lista_escolas.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"escolas"},[_c('isotope',{ref:"isotope",attrs:{"options":_vm.getOptions(),"list":_vm.model.lista_escolas}},_vm._l((_vm.model.lista_escolas),function(i){return _c('div',{key:i.codigo,staticClass:"col-xs-12 col-sm-4 col-md-3"},[_c('card',{attrs:{"title":i.nomeconhecido,"description":i.nome,"url":{ name: 'dados_escola', query: { escola: [i.codigo] } }}})],1)}),0)],1)]):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WY6r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("07cc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28be5572_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("poTn");
function injectStyle (ssrContext) {
  __webpack_require__("O7VY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28be5572"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28be5572_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WcJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h2',{staticClass:"page-header"},[_vm._v("Edital "+_vm._s(_vm.edital.numero))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-sm-4 text-center"},[_c('label',{staticClass:"custom-font"},[_vm._v("Processo")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.edital.processo_numero))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 text-center"},[_c('label',{staticClass:"custom-font"},[_vm._v("Publicado")]),_vm._v(" "),_c('p',{class:_vm.edital.publicado === 1 ? 'is-open' : 'is-closed'},[_vm._v("\n            "+_vm._s(_vm.edital.publicado === 1 ? 'Sim' : 'Não')+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 text-center"},[_c('label',{staticClass:"custom-font"},[_vm._v("Status")]),_vm._v(" "),_c('p',{class:_vm.edital.status == 'Encerrado' ? 'is-closed' : 'is-open'},[_vm._v("\n            "+_vm._s(_vm.edital.status)+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('font-awesome-icon',{attrs:{"icon":'address-card',"size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9 text-right"},[_c('div',{staticClass:"huge"},[_vm._v(_vm._s(_vm.habilitados.length))]),_vm._v(" "),_c('div',[_vm._v("Habilitados")])])])]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.scrollToElement('habilitados')}}},[_c('div',{staticClass:"panel-footer"},[_c('span',{staticClass:"pull-left"},[_vm._v("Detalhes")]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('font-awesome-icon',{attrs:{"icon":'bullhorn',"size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9 text-right"},[_c('div',{staticClass:"huge"},[_vm._v(_vm._s(_vm.nomeados.length))]),_vm._v(" "),_c('div',[_vm._v("Nomeados")])])])]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.scrollToElement('nomeados')}}},[_c('div',{staticClass:"panel-footer"},[_c('span',{staticClass:"pull-left"},[_vm._v("Detalhes")]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('font-awesome-icon',{attrs:{"icon":'user-check',"size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9 text-right"},[_c('div',{staticClass:"huge"},[_vm._v(_vm._s(_vm.empossados.length))]),_vm._v(" "),_c('div',[_vm._v("Empossados")])])])]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.scrollToElement('empossados')}}},[_c('div',{staticClass:"panel-footer"},[_c('span',{staticClass:"pull-left"},[_vm._v("Detalhes")]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('font-awesome-icon',{attrs:{"icon":'user-times',"size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9 text-right"},[_c('div',{staticClass:"huge"},[_vm._v(_vm._s(_vm.revogados.length))]),_vm._v(" "),_c('div',[_vm._v("Revogados")])])])]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.scrollToElement('revogados')}}},[_c('div',{staticClass:"panel-footer"},[_c('span',{staticClass:"pull-left"},[_vm._v("Detalhes")]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Cargos")]),_vm._v(" "),_c('data-table',{ref:"list_cargos",attrs:{"title":'Cargos',"dados":_vm.cargos,"fields":_vm.fields.cargos,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('router-link',{staticClass:"btn btn-success",attrs:{"title":"Detalhes","to":{
                name: 'acompanhamento_detalhes_cargo',
                params: { edital_id: _vm.edital.id, cargo_id: props.rowData.id }
              }}},[_c('font-awesome-icon',{attrs:{"icon":'search'}})],1)]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{attrs:{"id":"habilitados"}},[_c('font-awesome-icon',{attrs:{"icon":'address-card'}}),_vm._v("\n          Habilitados\n        ")],1),_vm._v(" "),_c('data-table',{ref:"list_habilitados",attrs:{"dados":_vm.habilitadosNormal,"fields":_vm.fields.habilitados,"carregando":_vm.isLoading}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_c('font-awesome-icon',{attrs:{"icon":'address-card'}}),_vm._v("\n          Habilitados - PCD\n        ")],1),_vm._v(" "),_c('data-table',{ref:"list_habilitadosPCD",attrs:{"dados":_vm.habilitadosPCD,"fields":_vm.fields.habilitados,"carregando":_vm.isLoading}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{attrs:{"id":"nomeados"}},[_c('font-awesome-icon',{attrs:{"icon":'bullhorn'}}),_vm._v("\n          Nomeados\n        ")],1),_vm._v(" "),_c('data-table',{ref:"list_nomeados",attrs:{"dados":_vm.nomeados,"fields":_vm.fields.nomeados,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.retornarTipoCandidato(props.rowData))+"\n          ")]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{attrs:{"id":"empossados"}},[_c('font-awesome-icon',{attrs:{"icon":'user-check'}}),_vm._v("\n          Empossados\n        ")],1),_vm._v(" "),_c('data-table',{ref:"list_empossados",attrs:{"dados":_vm.empossados,"fields":_vm.fields.empossados,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.retornarTipoCandidato(props.rowData))+"\n          ")]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{attrs:{"id":"revogados"}},[_c('font-awesome-icon',{attrs:{"icon":'user-times'}}),_vm._v("\n          Revogados\n        ")],1),_vm._v(" "),_c('data-table',{ref:"list_revogados",attrs:{"dados":_vm.revogados,"fields":_vm.fields.revogados,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.retornarTipoCandidato(props.rowData))+"\n          ")]}}])})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WgM/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WgxL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideAcao_vue__ = __webpack_require__("zSEq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ddf1515_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideAcao_vue__ = __webpack_require__("lpUG");
function injectStyle (ssrContext) {
  __webpack_require__("DXsn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ddf1515"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideAcao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ddf1515_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideAcao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WiHl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("\n        Início\n      ")])],1),_vm._v(" "),_vm._l((_vm.links),function(ref){
var named_link = ref.named_link;
var link = ref.link;
var label = ref.label;
return _c('li',{key:label},[(named_link || link)?_c('router-link',{attrs:{"to":named_link ? named_link : link}},[_vm._v("\n        "+_vm._s(label)+" \n      ")]):_vm._e(),_vm._v("\n      "+_vm._s(named_link || link ? '' : label)+"\n    ")],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wov6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wx5S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wz7f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wzr1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.c48c4d1.jpg";

/***/ }),

/***/ "X+GA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X4tR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_events__ = __webpack_require__("VwQt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_times__ = __webpack_require__("0Btv");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: Array
  },
  created: function created() {
    this.scale = this.value.map(function (_ref) {
      var times = _ref.times,
          rest = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['times']);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        times: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(times))
      }, rest, {
        selected: false
      });
    });
  },
  data: function data() {
    return {
      scale: [],
      selectedIndex: -1,
      times: [],
      entrada: '',
      saida: ''
    };
  },

  computed: {
    shownFormTime: function shownFormTime() {
      return this.selectedIndex > -1 && this.times.length < 3;
    },
    diasAtivos: function diasAtivos() {
      return this.scale.filter(function (item) {
        return item.active;
      }).length;
    }
  },
  watch: {
    diasAtivos: function diasAtivos(value) {
      if (value === 0) this.$emit('remove');
    }
  },
  methods: {
    dateFormatDDMM: function dateFormatDDMM(date) {
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit'
      });
    },
    toggleSelectDay: function toggleSelectDay(index) {
      var selected = this.scale[index].selected;

      if (selected) {
        this.unSelectDay(index);
      } else {
        this.selectDay(index);
      }
    },
    unSelectDay: function unSelectDay(index) {
      this.selectedIndex = -1;

      this.scale[index].active = false;
      this.scale[index].selected = false;
      this.times = [];

      this.update();
    },
    selectDay: function selectDay(index) {
      var scale = this.scale;
      // deseleciona todos os selecionados

      scale.filter(function (_ref2) {
        var selected = _ref2.selected;
        return selected;
      }).forEach(function (date) {
        date.selected = false;
      });

      scale[index].active = true;
      scale[index].selected = true;
      var times = scale[index].times;


      this.times = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(times));

      if (this.times.length > 0) {
        this.update();
      }

      this.selectedIndex = index;
    },
    addTime: function addTime() {
      this.entrada = this.formatTime(this.entrada);
      this.saida = this.formatTime(this.saida);

      var entrada = this.entrada,
          saida = this.saida,
          scale = this.scale,
          selectedIndex = this.selectedIndex;

      var daySelected = scale[selectedIndex];
      var lastScaleIndex = scale.length - 1;
      var lastDay = scale[lastScaleIndex];

      // verifica se o dia selecionado é o ultimo da escala
      if (lastDay.date === daySelected.date) {
        // se for mudar a saida do time para as 23h59
        this.saida = '23h59';
        this.addTimeLeaveOnDay();
        return;
      }

      switch (this.getTimeType({ entrada: entrada, saida: saida })) {
        case 'leaveOnDay':
          this.addTimeLeaveOnDay();
          break;
        case 'leaveOnNextDay':
          this.addTimeLeaveOnNextDay();
          break;
        default:
          break;
      }
    },
    formatTime: function formatTime(time) {
      if (time.length === 0) {
        return time;
      }

      if (time.length === 2) {
        return time + 'h00';
      }

      return time;
    },
    getTimeType: function getTimeType(_ref3) {
      var entrada = _ref3.entrada,
          saida = _ref3.saida;

      if (entrada === '' && saida === '') return '';
      if (entrada === '') return 'timeOut';
      if (saida === '') return 'timeIn';

      var entradaNumber = parseInt(entrada.replace(/\D/, ''));
      var saidaNumber = parseInt(saida.replace(/\D/, ''));

      if (entradaNumber < saidaNumber) return 'leaveOnDay';
      if (entradaNumber >= saidaNumber) return 'leaveOnNextDay';
    },
    addTimeLeaveOnDay: function addTimeLeaveOnDay() {
      var entrada = this.entrada,
          saida = this.saida,
          selectedIndex = this.selectedIndex;


      if (!this.validTime({ entrada: entrada, saida: saida })) {
        this.$toastr.e('Esse período é inválido, verifique se há algum conflito!');
        return;
      }

      this.times.push({ entrada: entrada, saida: saida });
      this.scale[selectedIndex].times = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.times));
      this.update();
      this.reset();
    },
    addTimeLeaveOnNextDay: function addTimeLeaveOnNextDay() {
      var entrada = this.entrada,
          saida = this.saida,
          selectedIndex = this.selectedIndex;

      var timeIn = { entrada: entrada, saida: '' };
      var timeOut = { entrada: '', saida: saida };

      var timesIn = this.scale[selectedIndex].times;
      if (!this.validTime(timeIn, timesIn)) {
        this.$toastr.e('Esse per\xEDodo \xE9 inv\xE1lido, verifique se h\xE1 algum conflito no dia ' + this.scale[selectedIndex].day + '!');
        return;
      }

      var timesOut = this.scale[selectedIndex + 1].times;
      if (!this.validTime(timeOut, timesOut)) {
        this.$toastr.e('Esse per\xEDodo \xE9 inv\xE1lido, verifique se h\xE1 algum conflito no dia ' + this.scale[selectedIndex + 1].day + '!');
      }

      // add time
      timesIn.push({ entrada: entrada, saida: '' });
      timesOut.push({ entrada: '', saida: saida });

      this.times.push({ entrada: entrada, saida: '' });

      this.scale[selectedIndex].times = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(timesIn));
      this.scale[selectedIndex + 1].times = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(timesOut));
      this.scale[selectedIndex + 1].active = true;

      this.update();
      this.reset();
    },
    removeTime: function removeTime(index) {
      this.times.splice(index, 1);
      this.scale[this.selectedIndex].times = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.times));
      this.update();
    },
    validTime: function validTime(time, times) {
      var isValid = true;

      if (!times) {
        times = this.scale[this.selectedIndex].times;
      }

      var timeNew = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_times__["c" /* parseTimeToInt */])(time);

      var index = 0;
      while (isValid && index < times.length) {
        var _time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_times__["c" /* parseTimeToInt */])(times[index++]);
        var timeIsBefore = false;
        var timeIsAfter = false;

        // verificar se o time é anterior
        if (typeof timeNew.saida === 'number' && typeof _time.entrada === 'number') {
          timeIsBefore = timeNew.saida <= _time.entrada;
        }

        // verificar se o time é posterior
        if (typeof timeNew.entrada === 'number' && typeof _time.saida === 'number') {
          timeIsAfter = timeNew.entrada >= _time.saida;
        }

        isValid = timeIsBefore || timeIsAfter;
      }

      return isValid;
    },
    reset: function reset() {
      this.entrada = '';
      this.saida = '';
    },
    update: function update() {
      if (this.diasAtivos > 0) this.$emit('input', [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.scale)));
    },

    lockIfValueIsNull: __WEBPACK_IMPORTED_MODULE_3__utils_events__["b" /* lockIfValueIsNull */]
  }
});

/***/ }),

/***/ "XBKu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_ESCOLAS; });
var LOAD_ESCOLAS = 'LOAD_ESCOLAS';

/***/ }),

/***/ "XCQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* PublicHeader */],
    CardsODS: __WEBPACK_IMPORTED_MODULE_2__components__["F" /* CardsODS */],
    CardsSecretaria: __WEBPACK_IMPORTED_MODULE_2__components__["G" /* CardsSecretaria */],
    CardsPortais: __WEBPACK_IMPORTED_MODULE_2__components__["H" /* CardsPortais */]
  },
  data: function data() {
    return {
      metas: [],
      secretarias: [],
      favoritos: {
        titulo: 'Favoritos',
        descricao: 'Favoritos e comparativos',
        nome_rota: 'favoritos',
        show: this.tem_favoritos()
      },
      btnTopVisible: false
    };
  },
  created: function created() {
    this.loadDataFilters();
    window.addEventListener('scroll', this.scrollHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandler);
  },

  methods: {
    scrollHandler: function scrollHandler() {
      var scrollTop = document.documentElement.scrollTop;

      this.btnTopVisible = scrollTop > 425;
    },
    scrollToElement: function scrollToElement(id) {
      var note = document.getElementById(id);

      var _note$getBoundingClie = note.getBoundingClientRect(),
          y = _note$getBoundingClie.y;

      var scrollTop = document.documentElement.scrollTop;


      window.scrollTo({ top: y + scrollTop - 57, behavior: 'smooth' });
    },
    tem_favoritos: function tem_favoritos() {
      var dados = localStorage.getItem('pmsdadosabertos');
      if (dados) {
        return JSON.parse(dados).favoritos.length > 0;
      } else {
        return false;
      }
    },
    loadDataFilters: function loadDataFilters() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('listar-filtros').then(function (_ref) {
        var data = _ref.data;
        var metas = data.metas,
            secretarias = data.secretarias,
            autarquias = data.autarquias;

        var todas = {
          nome: 'Todas as Metas',
          titulo: 'Todas as Metas',
          objetivo: 'Exibe a listagem completa de metas',
          cardTodos: true
        };

        _this.metas = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(metas), [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, todas)]);
        _this.secretarias = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(secretarias), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(autarquias.map(function (a) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a, { isAutarquia: true });
        })), [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, todas)]);
      }).catch(function (e) {
        console.log(e + ' | > dashboard.loadDataFilters:error');
      });
    }
  }
});

/***/ }),

/***/ "XJ9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectTime_vue__ = __webpack_require__("5B48");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ecfb2c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectTime_vue__ = __webpack_require__("eCqW");
function injectStyle (ssrContext) {
  __webpack_require__("6F2v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ecfb2c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ecfb2c7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XNWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_1__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components__["b" /* Breadcrumb */]
  },
  created: function created() {
    var candidato = this.$route.params.candidato;


    if (!candidato) {
      this.$router.push({ name: 'eleicao_conselho' });
    } else {
      this.candidato = this.candidatos.find(function (item) {
        return item.numero === candidato.numero;
      });
    }
  },
  data: function data() {
    return {
      isLoading: true,
      candidato: {
        total_votos: 0
      }
    };
  },

  methods: {
    findVotoCandidato: function findVotoCandidato(secao) {
      var _this = this;

      var finder = function finder(voto) {
        return voto.candidato_id === _this.candidato.id;
      };

      return secao.votos.find(finder);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])({
    candidatos: function candidatos(_ref) {
      var eleicoes_conselho = _ref.eleicoes_conselho;
      return eleicoes_conselho.candidatos;
    },
    votos: function votos(_ref2) {
      var eleicoes_conselho = _ref2.eleicoes_conselho;
      return eleicoes_conselho.votos;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapGetters */])({
    total_votos: 'votosTotais'
  }), {
    breadcrumb: function breadcrumb() {
      return [{
        label: 'Eleições - Conselho Tutelar',
        named_link: { name: 'eleicao_conselho' }
      }, {
        label: this.candidato.numero + ' - ' + this.candidato.nome
      }];
    }
  })
});

/***/ }),

/***/ "XOAW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Modal__ = __webpack_require__("2iX2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ModalAlert__ = __webpack_require__("NH9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_LoginModal__ = __webpack_require__("tf6l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_auto_progress__ = __webpack_require__("AmOw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_auto_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_auto_progress__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'index',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_common_Modal__["a" /* default */],
    ModalAlert: __WEBPACK_IMPORTED_MODULE_2__components_common_ModalAlert__["a" /* default */],
    LoginModal: __WEBPACK_IMPORTED_MODULE_3__components_auth_LoginModal__["a" /* default */],
    autoProgress: __WEBPACK_IMPORTED_MODULE_4_vue_auto_progress___default.a
  },
  provide: function provide() {
    return {
      showAlert: this.showAlert,
      closeAlert: this.closeAlert,
      showConfirm: this.showConfirm,
      closeConfirm: this.closeConfirm,
      showLoginModal: this.showLoginModal,
      closeLoginModal: this.closeLoginModal
    };
  },
  data: function data() {
    return {
      menus: [],
      menusActive: []
    };
  },
  created: function created() {
    this.loadMenus();
  },

  methods: {
    loadMenus: function loadMenus() {
      var perfis = this.$store.state.user.perfis;


      if (!perfis) {
        return;
      }

      var isAdmin = perfis.includes('admin');

      this.menus.push({
        nome: 'Painel',
        url: '/admin/painel',
        iconName: 'tachometer-alt'
      });

      if (isAdmin) {
        this.menus.push({
          nome: 'Usuários',
          url: '/admin/users/list',
          iconName: 'address-card'
        });
        this.menus.push({
          nome: 'Dados',
          iconName: 'cube',
          submenus: [{
            nome: 'Lista de dados',
            url: '/admin/dado/list',
            iconName: 'cube'
          }, {
            nome: 'Tags',
            url: '/admin/tags/list',
            iconName: 'tags'
          }, {
            nome: 'Eixos',
            url: '/admin/eixos/list',
            iconName: 'th-large'
          }, {
            nome: 'Metas',
            url: '/admin/metas/list',
            iconName: 'check-circle'
          }, {
            nome: 'Associar usuários e dados',
            url: '/admin/users/associate',
            iconName: 'sitemap'
          }, {
            nome: 'Relatórios',
            url: '/admin/relatorio',
            iconName: 'file-alt'
          }]
        });
      }

      if (perfis.includes('emendas-default')) {
        this.menus.push({
          nome: 'Emendas Parlamentares',
          iconName: 'landmark',
          submenus: [{
            nome: 'Emendas',
            url: '/admin/emenda/list',
            iconName: 'file-alt'
          }, {
            nome: 'Vereadores',
            url: '/admin/vereador/list',
            iconName: 'user-tie'
          }, {
            nome: 'Processos de Pagamento',
            url: '/admin/processospagamento/list',
            iconName: 'money-check-alt'
          }]
        });
      }

      if (perfis.includes('default') || perfis.includes('temporario')) {
        this.menus.push({
          nome: 'Dados do Usuário',
          iconName: 'cube',
          submenus: [{
            nome: 'Lista de dados',
            url: '/admin/user/dado/list',
            iconName: 'cube'
          }]
        });
      }

      var menusEscalaSMS = [];
      if (perfis.includes('sms-admin') || isAdmin) {
        menusEscalaSMS.push({
          nome: 'Relatório de status',
          url: '/admin/escalas/relatorio',
          iconName: 'calendar-check'
        });
        menusEscalaSMS.push({
          nome: 'Vincular unidades ao usuário',
          url: '/admin/escalas/vincular-unidades-usuario',
          iconName: 'sitemap'
        });
        menusEscalaSMS.push({
          nome: 'Relações entre perfis e unidades',
          url: '/admin/escalas/relatorio-perfil-unidade',
          iconName: 'user-tag'
        });
      }

      if (perfis.includes('sms-gest') || isAdmin) {
        menusEscalaSMS.push({
          nome: 'Publicar escalas',
          url: '/admin/escalas/publicar',
          iconName: 'calendar-check'
        });
      }

      if (perfis.includes('sms-admin') || isAdmin) {
        menusEscalaSMS.push({
          nome: 'Remover publicação',
          url: '/admin/escalas/remover-publicacao',
          iconName: 'calendar-times'
        });
      }

      if (perfis.includes('sms-gest') && !isAdmin) {
        menusEscalaSMS.push({
          nome: 'Relações entre perfis e unidades',
          url: '/admin/escalas/gestao-perfil-unidade',
          iconName: 'user-tag'
        });
      }

      if (perfis.includes('sms-user') || isAdmin) {
        menusEscalaSMS.push({
          nome: 'Pendências',
          url: '/admin/escalas/pendentes',
          iconName: 'calendar-check'
        });
        menusEscalaSMS.push({
          nome: 'Escalas',
          url: '/admin/escalas/list',
          iconName: 'calendar-alt'
        });
        menusEscalaSMS.push({
          nome: 'Impressão',
          url: '/admin/escalas/impressao',
          iconName: 'print'
        });
      }

      if (perfis.includes('sms-admin') || perfis.includes('sms-gest') || perfis.includes('sms-user') || isAdmin) {
        this.loadEscalaFuncionarios();

        this.menus.push({
          nome: 'Escalas SMS',
          iconName: 'calendar-check',
          submenus: [].concat(menusEscalaSMS)
        });
      } else {
        this.$store.commit('INITIALIZED', true);
      }

      var planoDeGovernoMenuBase = {
        nome: 'Plano de Governo',
        url: '/admin/planogoverno',
        iconName: 'file-alt',
        submenus: []
      };

      if (perfis.includes('pdg-master')) {
        planoDeGovernoMenuBase.submenus.push({
          nome: 'Importar Compromissos',
          url: '/admin/planogoverno/compromisso/importar',
          iconName: 'upload'
        }, {
          nome: 'Responsáveis Compromissos',
          url: '/admin/planogoverno/compromisso/editar',
          iconName: 'edit'
        }, {
          nome: 'Gestão de Compromissos',
          url: '/admin/planogoverno/gestao-compromisso',
          iconName: 'folder'
        });
      }

      if (perfis.includes('pdg-gestor')) {
        planoDeGovernoMenuBase.submenus.push({
          nome: 'Meus Compromissos',
          url: '/admin/planogoverno/compromisso',
          iconName: 'file-alt'
        });
      }

      if (perfis.includes('pdg-user')) {
        planoDeGovernoMenuBase.submenus.push({
          nome: 'Minhas Ações',
          url: '/admin/planogoverno/acao',
          iconName: 'file-alt'
        });
      }

      if (planoDeGovernoMenuBase.submenus.length > 0) {
        this.menus.push(planoDeGovernoMenuBase);
      }

      if (perfis.includes('mp-user') || isAdmin) {
        var menusMP = [];
        menusMP.push({
          nome: 'Materiais Padronizados',
          url: '/admin/material/list',
          iconName: 'cube'
        });
        menusMP.push({
          nome: 'Medidas',
          url: '/admin/material/medida/list',
          iconName: 'balance-scale'
        });
        menusMP.push({
          nome: 'Grupos',
          url: '/admin/material/grupo/list',
          iconName: 'th-large'
        });
        menusMP.push({
          nome: 'Subgrupos',
          url: '/admin/material/subgrupo/list',
          iconName: 'sitemap'
        });

        this.menus.push({
          nome: 'Materiais Padronizados',
          iconName: 'cube',
          submenus: [].concat(menusMP)
        });
      }

      if (perfis.includes('assistencia') || isAdmin) {
        var menusAssist = [{
          nome: 'Benefícios',
          url: '/admin/assistencia/beneficios',
          iconName: 'hand-holding-heart'
        }, {
          nome: 'Pagamentos de benefícios',
          url: '/admin/assistencia/pagamentos',
          iconName: 'money-bill'
        }];

        this.menus.push({
          nome: 'Assistência Social',
          iconName: 'hand-holding-heart',
          submenus: [].concat(menusAssist)
        });
      }

      this.menus = this.menus.map(function (item) {
        item.active = false;
        if (item.hasOwnProperty('submenus')) {
          item.submenus = item.submenus.map(function (subItem) {
            subItem.active = false;
            subItem.parent = item;
            return subItem;
          });
        }
        return item;
      });

      if (perfis.includes('concursos-admin') || perfis.includes('concursos-default') || isAdmin) {
        var menuEdital = {
          nome: 'Editais',
          url: '/admin/concursos/edital',
          iconName: 'list'
        };

        var menuAcompanhamento = {
          nome: 'Acompanhamento',
          url: '/admin/concursos/acompanhamento',
          iconName: 'chart-line'
        };

        var menusConcurso = [];

        if (perfis.includes('concursos-default')) {
          menusConcurso = [menuAcompanhamento];
        }
        if (perfis.includes('concursos-admin') || isAdmin) {
          menusConcurso = [menuEdital, menuAcompanhamento];
        }

        this.menus.push({
          nome: 'Concursos Públicos',
          iconName: 'clipboard-list',
          submenus: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(menusConcurso))
        });
      }

      if (perfis.includes('ods') || isAdmin) {
        var menusODS = [{
          nome: 'Movimentos ODS',
          url: '/admin/ods/movimentos',
          iconName: 'running'
        }];

        this.menus.push({
          nome: 'ODS',
          iconName: 'flag-checkered',
          submenus: [].concat(menusODS)
        });
      }

      this.menus = this.menus.map(function (item) {
        item.active = false;
        if (item.hasOwnProperty('submenus')) {
          item.submenus = item.submenus.map(function (subItem) {
            subItem.active = false;
            subItem.parent = item;
            return subItem;
          });
        }
        return item;
      });
    },
    loadEscalaFuncionarios: function loadEscalaFuncionarios() {
      this.$store.dispatch('loadFuncionarios');
    },
    changePartialView: function changePartialView(menu) {
      this.toogleActive(menu);
      this.$router.push(menu.url);

      // resetando os dados de state da vuetable para o state de uma table não interferir na outra
      //this.$store.commit('RESET_VUETABLE_STATE')
    },
    toogleActive: function toogleActive(menu) {
      this.resetMenuActives();

      var value = !menu.active;
      menu.active = value;

      this.menusActive.push(menu);

      if (menu.hasOwnProperty('parent')) {
        menu.parent.active = value;
        this.menusActive.push(menu.parent);
      }
    },
    resetMenuActives: function resetMenuActives() {
      this.menusActive.forEach(function (menu) {
        menu.active = false;
      });
      this.menusActive = [];
    },
    logout: function logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    showAlert: function showAlert(options) {
      this.$refs.modalAlert.show(options);
    },
    closeAlert: function closeAlert() {
      this.$refs.modalAlert.close();
    },
    showConfirm: function showConfirm(message, config) {
      this.$refs.modal.confirm(message, config);
    },
    closeConfirm: function closeConfirm() {
      this.$refs.modal.close();
    },
    showLoginModal: function showLoginModal() {
      this.$refs.loginModal.show();
    },
    closeLoginModal: function closeLoginModal() {
      this.$refs.loginModal.hide();
    }
  }
});

/***/ }),

/***/ "XTf4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xdwg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return consumo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__("4Nwh");


var consumo = [{
  name: 'gastos_consumo',
  path: '/consumos',
  component: function component() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "kT7J"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Gastos de Consumo'
  }
}];

/***/ }),

/***/ "XeOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Select__ = __webpack_require__("MGJx");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Select: __WEBPACK_IMPORTED_MODULE_0__components_common_Select__["a" /* default */]
  },
  props: {
    value: {
      type: Object
    }
  },
  created: function created() {
    this.generateReferences();
    var _value = this.value,
        year = _value.year,
        month = _value.month;

    this.reference = '' + year + month;
  },
  data: function data() {
    return {
      references: [],
      reference: '',
      year: '',
      month: ''
    };
  },

  watch: {
    reference: function reference(value) {
      this.year = value.substr(0, 4);
      this.month = value.substr(4, 2);
      this.update();
    }
  },
  methods: {
    update: function update() {
      var year = this.year,
          month = this.month;

      this.$emit('input', { year: year, month: month });
    },
    generateReferences: function generateReferences() {
      var currentYear = new Date().getFullYear();

      for (var index = 0; index < 12; index++) {
        var date = new Date(currentYear, index, 1);
        this.references.push({
          label: date.toLocaleString('pt-br', {
            month: 'long',
            year: 'numeric'
          }),
          value: '' + currentYear + date.toLocaleString('pt-BR', {
            month: '2-digit'
          })
        });
      }
    }
  }
});

/***/ }),

/***/ "Xll0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressoCandidato_vue__ = __webpack_require__("F+Dw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8439d5a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressoCandidato_vue__ = __webpack_require__("3ytx");
function injectStyle (ssrContext) {
  __webpack_require__("pgzv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8439d5a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressoCandidato_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8439d5a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressoCandidato_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xnd0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("GvjO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb031b4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("UZE8");
function injectStyle (ssrContext) {
  __webpack_require__("3pzb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb031b4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb031b4e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YE+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-inline-block"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ano),expression:"ano"}],attrs:{"name":"select-ano","id":"select-ano"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ano=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.fetchEmendasAno]}},_vm._l((_vm.options),function(option){return _c('option',{key:("ano-" + option),domProps:{"value":option}},[_vm._v("\n      "+_vm._s(option)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YIRx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__("5BtY");






var geosiapApi = function geosiapApi(ano, grupo) {
  var base = 'https://geosiap.santos.sp.gov.br/portal-transparencia/api/default/execucao';
  return {
    receitas_proprias: base + '/receitas/proprias/receitas_proprias?ano=' + ano.getFullYear() + '&dt_inicial=undefined&dt_final=undefined&id_entidade=1&dias=0&layout=Anual',
    detalhamento_despesas: base + '/detalhamento_despesas/detalhamento_despesas?ano=' + ano.getFullYear() + '&id_entidade=1&dias=0',
    grupo_despesas: base + '/despesas_acao/despesas_acao?id_entidade=1&tipo_despesa=' + grupo + '&ano_selecionado=' + ano + '&data_inicial=undefined&data_final=undefined',
    adiantamentos: base + '/adiantamentos/adiantamentos?dt_inicial=' + new Date(ano.getFullYear(), 0, 1) + '&dt_final=' + ano + '&id_entidade=1&dias=0',
    despesas_detalhadas: base + '/despesas_detalhadas/despesas_detalhadas?ano=' + ano + '&data_inicial=undefined&data_final=undefined&id_entidade=1&filtro=undefined'
  };
};

var retornaData = function retornaData(store) {
  var ano_base = store.state.ano_base;

  var data_atual = new Date();

  if (ano_base !== data_atual.getFullYear()) {
    return new Date(ano_base, 11, 31, 23, 59, 59);
  }

  return data_atual;
};

var actions = {
  atualizaAnoBase: function atualizaAnoBase(store, ano) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.commit(__WEBPACK_IMPORTED_MODULE_4__types__["a" /* SET_ANO_BASE */], ano);
              store.dispatch('loadReceitasProprias');
              store.dispatch('loadDetalhamentoDespesas');
              store.dispatch('loadGrupoDespesas');
              store.dispatch('loadFuncaoSubfuncao');
              _context.next = 7;
              return store.dispatch('loadDespesasDetalhadas');

            case 7:
              return _context.abrupt('return', true);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  loadReceitasProprias: function loadReceitasProprias(store) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get(geosiapApi(retornaData(store)).receitas_proprias).then(function (response) {
        store.commit(__WEBPACK_IMPORTED_MODULE_4__types__["b" /* SET_RECEITAS_PROPRIAS */], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  loadDetalhamentoDespesas: function loadDetalhamentoDespesas(store) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get(geosiapApi(retornaData(store)).detalhamento_despesas).then(function (response) {
        store.commit(__WEBPACK_IMPORTED_MODULE_4__types__["c" /* SET_DETALHAMENTO_DESPESAS */], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  loadGrupoDespesas: function loadGrupoDespesas(store) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get(geosiapApi(retornaData(store), 'uo').grupo_despesas).then(function (response) {
        store.commit(__WEBPACK_IMPORTED_MODULE_4__types__["d" /* SET_GRUPO_DESPESAS */], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  loadFuncaoSubfuncao: function loadFuncaoSubfuncao(store) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get(geosiapApi(retornaData(store), 'fs').grupo_despesas).then(function (response) {
        store.commit(__WEBPACK_IMPORTED_MODULE_4__types__["e" /* SET_FUNCAO_SUBFUNCAO */], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  loadAdiantamentos: function loadAdiantamentos(store) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get(geosiapApi(retornaData(store)).adiantamentos).then(function (response) {
        store.commit(__WEBPACK_IMPORTED_MODULE_4__types__["f" /* SET_ADIANTAMENTOS */], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  loadDespesasDetalhadas: function loadDespesasDetalhadas(store) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get(geosiapApi(retornaData(store)).despesas_detalhadas).then(function (response) {
        store.commit(__WEBPACK_IMPORTED_MODULE_4__types__["g" /* SET_DESPESAS_DETALHADAS */], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  }
};

/***/ }),

/***/ "YIkh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("0058");




var actions = {
  loadFuncionarios: function loadFuncionarios(store) {
    __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('escala/listar-funcionario').then(function (response) {
      var data = Array.isArray(response) ? response : response.data;
      var payload = data.map(function (i) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, i, { ativo: false });
      });

      store.commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* SET_ESCALA_FUNCIONARIO */], payload);
      store.commit('INITIALIZED', true);
    }).catch(function (error) {
      return console.log(error);
    });
  }
};

/***/ }),

/***/ "YTMB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.0179b64.jpg";

/***/ }),

/***/ "YYs8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__("aceD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public__ = __webpack_require__("CG7d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__admin__ = __webpack_require__("4piF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__const__ = __webpack_require__("4Nwh");








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/dadosabertos/',
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__public__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__admin__["a" /* default */]))
});

router.beforeEach(function (to, from, next) {
  document.title = to.meta.title || __WEBPACK_IMPORTED_MODULE_6__const__["a" /* DEFAULT_TITLE */];

  if (to.name === 'Logout') {
    Logout.logout(router.app, next);
    return;
  }

  next();

  // var authUser = false
  // if (localStorage.getItem('daUser') !== '') {
  //   authUser = JSON.parse(localStorage.getItem('daUser'))
  // }
  // if (from.name === 'Login' && to.path === '/admin') {
  //   if (authUser.perfis.indexOf('admin') > -1) {
  //     next()
  //   } else if (authUser.perfis[0].indexOf('default') > -1) {
  //     next('/user')
  //   }
  // } else {
  //   if (to.meta.requiresAuth) {
  //     if (!authUser || !authUser.token) {
  //       next({
  //         name: 'Login'
  //       })
  //     } else {
  //       if (to.meta.adminAuth) {
  //         if (authUser.perfis.indexOf('admin') > -1) {
  //           next()
  //         } else {
  //           next({
  //             name: 'Login'
  //           })
  //         }
  //       } else if (to.meta.userAuth) {
  //         if (authUser.perfis[0].indexOf('default') > -1 ||
  //           authUser.perfis[0].indexOf('admin') > -1) {
  //           next()
  //         } else {
  //           next({
  //             name: 'Login'
  //           })
  //         }
  //       }
  //     }
  //   } else {
  //     next()
  //   }
  // }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YcTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row grafico-consumo"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.unidades.length)?_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Unidades")])]):_vm._e(),_vm._v(" "),(_vm.unidades.length)?_c('div',{staticClass:"col-xs-12 col-md-10 col-lg-8 form-group"},[_c('v-select',{ref:("unidades-" + _vm.title),staticClass:"style-chooser",attrs:{"label":"nome","placeholder":'Filtrar pela unidade...',"get-option-label":_vm.getLabel,"options":_vm.unidades,"selectOnTab":true},model:{value:(_vm.unidadeFiltro),callback:function ($$v) {_vm.unidadeFiltro=$$v},expression:"unidadeFiltro"}},[_c('template',{slot:"no-options"},[_vm._v("\n        Unidade não encontrada...\n      ")])],2)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('bar-chart',{ref:_vm.reference,attrs:{"gradiente":false,"chart-data":_vm.chartData,"options":_vm.getChartOptions({ money: _vm.money })}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YgrM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yij3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YzIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PulseLoader_vue__ = __webpack_require__("i/iG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__ = __webpack_require__("iL/f");
function injectStyle (ssrContext) {
  __webpack_require__("dxQL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PulseLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z0Eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Metas")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Listagem de Metas","report-title":"Metas","api-url":"meta/list","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'metas',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}},{key:"icon",fn:function(props){return [_c('img',{attrs:{"src":_vm.concateImgPathWith(props.rowData.MET_DLURLIMAGEM),"alt":props.rowData.MET_DCTITULO,"width":"48","height":"48"}})]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"MET_DCTITULO_filter"}},[_vm._v("Título")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MET_DCTITULO),expression:"MET_DCTITULO"}],staticClass:"form-control",attrs:{"type":"text","name":"MET_DCTITULO_filter"},domProps:{"value":(_vm.MET_DCTITULO)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MET_DCTITULO=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"custom-font",attrs:{"for":"MET_DLOBJETIVO_filter"}},[_vm._v("Objetivo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.MET_DLOBJETIVO),expression:"MET_DLOBJETIVO"}],staticClass:"form-control",attrs:{"type":"text","name":"MET_DLOBJETIVO_filter"},domProps:{"value":(_vm.MET_DLOBJETIVO)},on:{"input":function($event){if($event.target.composing){ return; }_vm.MET_DLOBJETIVO=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'admin_metas_save' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z1Zy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"processos-pagamento"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.label)+" Processo de Pagamento")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('valor') }]},[_c('label',{class:[
                  'control-label',
                  'primary',
                  { 'is-danger': _vm.errors.has('valor') }
                ]},[_vm._v("Valor")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[
                        { 'is-danger': _vm.errors.has('numero_pagamento') }
                      ],attrs:{"icon":'money-bill'}})],1),_vm._v(" "),_c('money',_vm._b({directives:[{name:"validate",rawName:"v-validate",value:('required|min_value:1.00'),expression:"'required|min_value:1.00'"}],ref:"valor",class:['form-control'],attrs:{"name":"valor","placeholder":"Valor da emenda","maxlength":"22","type":"text"},model:{value:(_vm.model.valor),callback:function ($$v) {_vm.$set(_vm.model, "valor", $$v)},expression:"model.valor"}},'money',_vm.money,false))],1),_vm._v(" "),(_vm.errors.has('valor'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"valor"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('valor'))+"\n                ")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:[
                'form-group',
                { 'has-error': _vm.errors.has('numero_pagamento') }
              ]},[_c('label',{class:[
                  'control-label',
                  'primary',
                  { 'is-danger': _vm.errors.has('numero_pagamento') }
                ]},[_vm._v("\n                Número\n              ")]),_vm._v(" "),_c('div',{staticClass:"inputGroupContainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[
                        { 'is-danger': _vm.errors.has('numero_pagamento') }
                      ],attrs:{"icon":'money-check-alt'}})],1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:9'),expression:"'required|min:9'"},{name:"model",rawName:"v-model",value:(_vm.model.numero_pagamento),expression:"model.numero_pagamento"}],ref:"numero_pagamento",class:[
                      'form-control',
                      { 'is-danger': _vm.errors.has('numero_pagamento') }
                    ],attrs:{"type":"text","name":"numero_pagamento","maxlength":"15","data-vv-as":"número de pagamento","placeholder":"Número com formato"},domProps:{"value":(_vm.model.numero_pagamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "numero_pagamento", $event.target.value)}}})]),_vm._v(" "),(_vm.errors.has('numero_pagamento'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"numero_pagamento"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('numero_pagamento'))+"\n                ")],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label primary"},[_vm._v("Número da emenda")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.emenda_id),expression:"model.emenda_id"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"emenda_id",staticClass:"form-control select-selected",attrs:{"name":"emenda_id","data-vv-as":"número da emenda"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "emenda_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.emendas),function(emenda){return _c('option',{key:emenda.id,domProps:{"value":emenda.id}},[_vm._v("\n                    "+_vm._s(emenda.numero)+"\n                  ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12",staticStyle:{"margin-top":"30px"}},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){return _vm.save()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n              Salvar\n            ")],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z1i1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("0xDb");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'emendas-parlamentares',
  inject: ["showConfirm"],
  components: {
    List: __WEBPACK_IMPORTED_MODULE_2__components_common__["n" /* DataTable */],
    PDFImport: __WEBPACK_IMPORTED_MODULE_2__components_common__["m" /* PDFImport */]
  },
  data: function data() {
    return {
      emenda_codigo_selecionado: '',
      numero_emenda_selecionado: '',
      resumo_utilizacao_selecionado: '',
      resumo_original: '',
      desativado: false,
      arquivo_upload: '',
      orgaos: [],
      vereadores: [],
      emenda_anexos: {},
      lista_anexos: [],
      processos_pagamento_numero: [],
      slots: ['descricao', 'resumo_utilizacao', 'saldo'],
      fields: [{
        name: 'numero',
        title: 'Número',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'ano',
        title: 'Ano',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'vereador.nome',
        title: 'Vereador',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'sigla_orgao',
        title: 'Sigla',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'numero_processo',
        title: 'Processo',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'valor',
        title: 'Valor',
        dataClass: 'align-middle text-right',
        filterable: true,
        callback: function callback(value) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* formatarMoeda */])(value);
        }
      }, {
        name: '__slot:saldo',
        title: 'Saldo',
        dataClass: 'align-middle text-right'
      }, {
        name: '__slot:descricao',
        title: 'Descrição',
        dataClass: 'align-middle',
        filterable: true,
        width: '20%'
      }, {
        name: 'processos_pagamento',
        title: 'Processos de pagamento',
        dataClass: 'align-middle',
        filterable: true,
        callback: function callback(value) {
          return value.length === 0 ? 'Nenhum processo de pagamento de encontrado.' : value.map(function (numero) {
            return numero.numero_pagamento;
          }).join(', ');
        }
      }, {
        name: '__slot:resumo_utilizacao',
        title: 'Resumo de utilização',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-2',
        dataClass: 'text-center'
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('listar-vereadores').then(function (resp) {
      if (resp.length === 0) return;
      _this.vereadores = resp.data;
    }).catch(function (resp) {
      console.log(resp);
    });

    __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('processospagamento').then(function (resp) {
      if (resp.length === 0) return;
      _this.processos_pagamento_numero = resp.data.data;
    }).catch(function (resp) {
      console.log(resp);
    });

    __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('unidade-organizacional/orgaos').then(function (resp) {
      if (resp.length === 0) return;
      _this.orgaos = resp.data;
    }).catch(function (resp) {
      console.log(resp);
    });
  },

  computed: {
    filtros: function filtros() {
      var ano = this.ano,
          vereador = this.vereador,
          processos_pagamento = this.processos_pagamento,
          sigla_orgao = this.sigla_orgao,
          numero = this.numero,
          numero_processo = this.numero_processo,
          descricao = this.descricao,
          resumo_utilizacao = this.resumo_utilizacao;


      return {
        ano: ano,
        vereador: vereador,
        processos_pagamento: processos_pagamento,
        sigla_orgao: sigla_orgao,
        numero: numero,
        numero_processo: numero_processo,
        descricao: descricao,
        resumo_utilizacao: resumo_utilizacao
      };
    },

    pagina: {
      get: function get() {
        var emendasParlamentares = this.$store.state.vuetableState.emendasParlamentares;
        var pagina = emendasParlamentares.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'emendasParlamentares',
          value: value
        });
      }
    },
    ano: {
      get: function get() {
        var emendasParlamentares = this.$store.state.vuetableState.emendasParlamentares;
        var ano = emendasParlamentares.filtros.ano;

        return ano;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'ano',
          collection: 'emendasParlamentares',
          value: value
        });
        this.resetPageStore();
      }
    },
    vereador: {
      get: function get() {
        var emendasParlamentares = this.$store.state.vuetableState.emendasParlamentares;
        var vereador = emendasParlamentares.filtros.vereador;

        return vereador;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'vereador',
          collection: 'emendasParlamentares',
          value: value
        });
        this.resetPageStore();
      }
    },
    sigla_orgao: {
      get: function get() {
        var emendasParlamentares = this.$store.state.vuetableState.emendasParlamentares;
        var sigla_orgao = emendasParlamentares.filtros.sigla_orgao;

        return sigla_orgao;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'sigla_orgao',
          collection: 'emendasParlamentares',
          value: value
        });
        this.resetPageStore();
      }
    },
    numero: {
      get: function get() {
        var emendasParlamentares = this.$store.state.vuetableState.emendasParlamentares;
        var numero = emendasParlamentares.filtros.numero;

        return numero;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'numero',
          collection: 'emendasParlamentares',
          value: value
        });
        this.resetPageStore();
      }
    },
    numero_processo: {
      get: function get() {
        var emendasParlamentares = this.$store.state.vuetableState.emendasParlamentares;
        var numero_processo = emendasParlamentares.filtros.numero_processo;

        return numero_processo;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'numero_processo',
          collection: 'emendasParlamentares',
          value: value
        });
        this.resetPageStore();
      }
    },
    descricao: {
      get: function get() {
        var emendasParlamentares = this.$store.state.vuetableState.emendasParlamentares;
        var descricao = emendasParlamentares.filtros.descricao;

        return descricao;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'descricao',
          collection: 'emendasParlamentares',
          value: value
        });
        this.resetPageStore();
      }
    },
    processos_pagamento: {
      get: function get() {
        var emendasParlamentares = this.$store.state.vuetableState.emendasParlamentares;
        var processos_pagamento = emendasParlamentares.filtros.processos_pagamento;

        return processos_pagamento;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'processos_pagamento',
          collection: 'emendasParlamentares',
          value: value
        });
        this.resetPageStore();
      }
    },
    resumo_utilizacao: {
      get: function get() {
        var emendasParlamentares = this.$store.state.vuetableState.emendasParlamentares;
        var resumo_utilizacao = emendasParlamentares.filtros.resumo_utilizacao;

        return resumo_utilizacao;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'resumo_utilizacao',
          collection: 'emendasParlamentares',
          value: value
        });
        this.resetPageStore();
      }
    }
  },
  methods: {
    mensagemExclusao: function mensagemExclusao(anexo) {
      var _this2 = this;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          _this2.excluirAnexo(anexo);
        }
      };

      this.showConfirm('Deseja realmente excluir o anexo ' + anexo.nome + '?', config);
    },
    excluirAnexo: function excluirAnexo(anexo) {
      var _this3 = this;

      var id = anexo.id;

      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].post('emendas/excluir-anexo', { id: id }).then(function (response) {
        var data = response.data;

        _this3.$toastr.s('Anexo excluído com sucesso');
        console.log(data);
        _this3.exibirAnexos(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.emenda_anexos));
      }).catch(function (error) {
        _this3.$toastr.e('Houve um erro ao excluir o anexo. Tente novamente');
        console.log(error.response);
      });
      console.log(anexo);
    },
    cleanFile: function cleanFile() {
      this.$refs.upload.clean();
    },
    setFile: function setFile(file) {
      this.arquivo_upload = file;
    },
    uploadFile: function uploadFile() {
      var _this4 = this;

      if (!this.arquivo_upload) {
        this.$toastr.e('Selecione o arquivo a ser importado');
        return;
      }

      var data = new FormData();
      data.append('file', this.arquivo_upload);
      data.append('emenda_id', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.emenda_anexos.id));

      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].post('emendas/salvar-anexo', data).then(function (response) {
        _this4.$toastr.s('Arquivo anexado com sucesso');
        _this4.exibirAnexos(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.emenda_anexos));
        _this4.cleanFile();
      }).catch(function (error) {
        _this4.$toastr.e('Houve um erro ao anexar o arquivo. Tente novamente');
        console.log(error.response);
      });
    },
    downloadFile: function downloadFile(anexo) {
      var _this5 = this;

      var nome = anexo.nome,
          id = anexo.id;

      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('emendas/download-anexo/' + id).then(function (response) {
        var data = response.data;

        var link = document.createElement('a');
        link.download = nome;
        link.href = data;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(function (error) {
        _this5.$toastr.e('Houve um erro ao baixar o anexo. Tente novamente');
        console.log(error.response);
      });
    },
    exibirAnexos: function exibirAnexos(emenda) {
      var _this6 = this;

      this.emenda_anexos = emenda;

      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('emendas/listar-anexos/' + this.emenda_anexos.id).then(function (response) {
        var data = response.data;

        _this6.lista_anexos = data;
        window.jQuery('#modal_anexos').modal('show');
      }).catch(function (error) {
        _this6.$toastr.e('Houve um erro ao listar os anexos. Tente novamente');
        console.log(error.response);
      });
    },
    getSaldo: function getSaldo(emenda) {
      var reducer = function reducer(accum, proc) {
        return accum += Number(proc.valor);
      };

      var somaProcessos = emenda.processos_pagamento.reduce(reducer, 0);

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* formatarMoeda */])(emenda.valor - somaProcessos);
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'emendasParlamentares',
        value: 1
      });
    },
    editar: function editar(data) {
      var id = data.id;

      this.$router.push({ name: 'user_salvar_emenda', params: { id: id } });
    },
    remajenar: function remajenar(data) {
      this.$router.push({ name: 'user_remanejamento', params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data) });
    },
    listarProcessos: function listarProcessos(data) {
      var id = data.id;

      this.$router.push({
        name: 'user_list_emenda_processos',
        params: { id: id }
      });
    },
    getEmendaDados: function getEmendaDados(data) {
      var id = data.id;
      var numero = data.numero;
      var resumo_utilizacao = data.resumo_utilizacao;

      this.emenda_codigo_selecionado = id;
      this.numero_emenda_selecionado = numero;
      this.resumo_original = resumo_utilizacao;

      if (window.jQuery('#modal_resumo_utilizacao').modal('hide')) {
        document.getElementById('textAreaResumo').value = this.resumo_original;
      }
    },
    showModal: function showModal(title, msg, success) {
      this.showConfirm(msg, { title: title, question: false, yes: success });
    },
    openResumoModal: function openResumoModal() {
      this.resumo_utilizacao_selecionado = this.resumo_original;
      window.jQuery('#modal_resumo_utilizacao').modal('show');

      if (document.getElementById('textAreaResumo').value == this.resumo_original) this.desativado = true;
    },
    updateResumoModal: function updateResumoModal(value) {
      document.getElementById('textAreaResumo').value == this.resumo_original ? this.desativado = true : this.desativado = false;
      this.resumo_utilizacao_selecionado = value;
    },
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Resumo de utilização editado com sucesso!');
      this.$refs.vuetable.refresh();
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar editar o resumo.');
    },
    saveResumoModal: function saveResumoModal() {
      if (this.emenda_codigo_selecionado) {
        __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].put('emenda/' + this.emenda_codigo_selecionado + '/resumoutilizacao/update', {
          resumo_utilizacao: this.resumo_utilizacao_selecionado
        }).then(this.saveSuccess).catch(this.saveFail);
      }
    },
    verificarResumoUtilizacao: function verificarResumoUtilizacao() {
      console.log(this.resumo_utilizacao_selecionado);
    },
    excluir: function excluir(data) {
      var me = this;
      var id = data.id,
          id_emenda_origem = data.id_emenda_origem;


      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].delete('emenda/' + id).then(function (resp) {
            me.consultar();
            me.$toastr.s('Emenda removida com sucesso!');
          }).catch(function (error) {
            var response = error.response;


            if (response.status === 403) {
              me.$toastr.e(response.data);
              return;
            }

            me.$toastr.e('Houve uma falha ao tentar remover esse item, por favor, tente novamente mais tarde!');
          });
        }
      };

      var complemento = id_emenda_origem ? ' <br/><b>Esta emenda foi remanejada e o seu saldo voltará a emenda original.</b>' : '';

      this.showConfirm('Deseja realmente deletar este item?' + complemento, config);
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      this.ano = '';
      this.vereador = '';
      this.sigla_orgao = '';
      this.numero = '';
      this.numero_processo = '';
      this.descricao = '';
      this.processos_pagamento = '';
      this.resumo_utilizacao = '';
    }
  }
});

/***/ }),

/***/ "Z2MM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__ = __webpack_require__("doAb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a6b9806_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__ = __webpack_require__("eTp2");
function injectStyle (ssrContext) {
  __webpack_require__("1u0E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a6b9806"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a6b9806_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z68B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__("nrd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__ = __webpack_require__("iI18");
var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LeafletMap',
  props: {
    mapStyle: {
      type: Object,
      default: function _default() {
        return { height: '300px', borderRadius: '10px' };
      }
    },
    latitute: {
      type: Number,
      default: -23.9335988
    },
    longitude: {
      type: Number,
      default: -46.3286399
    },
    zoom: {
      type: Number,
      default: 11
    },
    mapOptions: {
      type: Object,
      default: function _default() {
        return {
          zoomSnap: 0.5
        };
      }
    },
    showParagraph: {
      type: Boolean,
      default: false
    },
    showMap: {
      type: Boolean,
      default: true
    },
    pins: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    icon: {
      type: Object,
      default: function _default() {
        var icon = __webpack_require__("iDa5");
        return new __WEBPACK_IMPORTED_MODULE_0_leaflet__["Icon"]({
          shadowSize: undefined,
          iconUrl: icon,
          iconSize: _this.dynamicSize,
          shadowAnchor: [30, 30],
          popupAnchor: [-10, -10],
          iconAnchor: [40, 30]
        });
      }
    },
    popupPoint: {
      default: function _default() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_leaflet__["point"])(0, 0);
      }
    }
  },
  components: {
    LMap: __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__["a" /* LMap */],
    LTileLayer: __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__["b" /* LTileLayer */],
    LMarker: __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__["c" /* LMarker */],
    LPopup: __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__["d" /* LPopup */],
    LTooltip: __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__["e" /* LTooltip */],
    LIcon: __WEBPACK_IMPORTED_MODULE_1_vue2_leaflet__["f" /* LIcon */]
  },
  data: function data() {
    return {
      center: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_leaflet__["latLng"])(this.latitute, this.longitude),
      url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      withPopup: this.pins,
      withTooltip: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_leaflet__["latLng"])(-23.9452227, -46.3772091),
      currentZoom: this.zoom,
      currentCenter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_leaflet__["latLng"])(this.latitute, this.longitude),
      router: this.$router
    };
  },

  methods: {
    zoomUpdate: function zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate: function centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText: function showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    fitPins: function fitPins() {
      this.$refs.mapa.fitBounds(this.getPositions);
    }
  },
  computed: {
    dynamicSize: function dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor: function dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    },
    shadowAnchorDefault: function shadowAnchorDefault() {
      return [30, 30];
    },
    getPositions: function getPositions() {
      return this.pins.map(function (_ref) {
        var position = _ref.position;

        return position;
      });
    },
    computedPins: function computedPins() {
      return this.pins;
    }
  }
});

/***/ }),

/***/ "ZAg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cores: ['210, 230, 139', // #D2E68B
  '92, 138, 149', // #5C8A95
  '241, 193, 146', // #F1C192
  '173, 104, 160', // #AD68A0
  '34, 34, 34', // #222222
  '105, 11, 31', // #690B1F
  '183, 81, 107', // #B7516B

  // New distinct colors (20) with 7:1 contrast
  '0, 87, 184', // #0057B8
  '255, 149, 0', // #FF9500
  '0, 168, 107', // #00A86B
  '230, 25, 75', // #E6194B
  '123, 104, 238', // #7B68EE
  '255, 215, 0', // #FFD700
  '64, 224, 208', // #40E0D0
  '246, 84, 106', // #F6546A
  '147, 112, 219', // #9370DB
  '75, 0, 130', // #4B0082
  '0, 206, 209', // #00CED1
  '255, 99, 71', // #FF6347
  '50, 205, 50', // #32CD32
  '138, 43, 226', // #8A2BE2
  '255, 105, 180', // #FF69B4
  '85, 107, 47', // #556B2F
  '153, 50, 204', // #9932CC
  '70, 130, 180', // #4682B4
  '139, 69, 19', // #8B4513
  '32, 178, 170' // #20B2AA
  ],
  coresHexa: ['#D2E68B', '#5C8A95', '#F1C192', '#AD68A0', '#222222', '#690B1F', '#B7516B', '#0057B8', '#FF9500', '#00A86B', '#E6194B', '#7B68EE', '#FFD700', '#40E0D0', '#F6546A', '#9370DB', '#4B0082', '#00CED1', '#FF6347', '#32CD32', '#8A2BE2', '#FF69B4', '#556B2F', '#9932CC', '#4682B4', '#8B4513', '#20B2AA'],
  coresRGB: ['rgb(210, 230, 139)', // #D2E68B
  'rgb(92, 138, 149)', // #5C8A95
  'rgb(241, 193, 146)', // #F1C192
  'rgb(173, 104, 160)', // #AD68A0
  'rgb(34, 34, 34)', // #222222
  'rgb(105, 11, 31)', // #690B1F
  'rgb(183, 81, 107)', // #B7516B

  // New distinct colors (20) with 7:1 contrast
  'rgb(0, 87, 184)', // #0057B8
  'rgb(255, 149, 0)', // #FF9500
  'rgb(0, 168, 107)', // #00A86B
  'rgb(230, 25, 75)', // #E6194B
  'rgb(123, 104, 238)', // #7B68EE
  'rgb(255, 215, 0)', // #FFD700
  'rgb(64, 224, 208)', // #40E0D0
  'rgb(246, 84, 106)', // #F6546A
  'rgb(147, 112, 219)', // #9370DB
  'rgb(75, 0, 130)', // #4B0082
  'rgb(0, 206, 209)', // #00CED1
  'rgb(255, 99, 71)', // #FF6347
  'rgb(50, 205, 50)', // #32CD32
  'rgb(138, 43, 226)', // #8A2BE2
  'rgb(255, 105, 180)', // #FF69B4
  'rgb(85, 107, 47)', // #556B2F
  'rgb(153, 50, 204)', // #9932CC
  'rgb(70, 130, 180)', // #4682B4
  'rgb(139, 69, 19)', // #8B4513
  'rgb(32, 178, 170)' // #20B2AA
  ]
});

/***/ }),

/***/ "ZBZv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Downloads")]),_vm._v(" "),_c('ul',{staticClass:"downloads"},[_c('li',[_c('a',{attrs:{"href":_vm.download('csv'),"target":"_blank"}},[_c('span',{staticClass:"label label-success"},[_vm._v("CSV")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.download('pdf'),"target":"_blank"}},[_c('span',{staticClass:"label label-danger"},[_vm._v("PDF")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.download('json'),"target":'_blank'}},[_c('span',{staticClass:"label label-warning"},[_vm._v("JSON")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_c('span',{staticClass:"label label-info"},[_vm._v("Dicionário")])])])])]),_vm._v(" "),(_vm.isModalVisible)?_c('div',{staticClass:"modal-overlay",on:{"click":_vm.closeModal}},[_c('div',{staticClass:"modal-content",on:{"click":function($event){$event.stopPropagation();}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.isLoading)?_c('div',[_vm._v("\n          Carregando...\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.dictionaryContent.length > 0)?_c('table',{staticClass:"dictionary-table"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.dictionaryContent),function(item){return _c('tr',{key:item.campo,class:item.classe},[_c('td',[_vm._v(_vm._s(item.campo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDescricao(item.campo)))])])}),0)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.error)?_c('div',[_vm._v("\n          "+_vm._s(_vm.error)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"close-button",on:{"click":_vm.closeModal}},[_vm._v("Fechar")])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',[_vm._v("Dicionário de Dados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Campo")]),_vm._v(" "),_c('th',[_vm._v("Descrição")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZGVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rodape',
  methods: {
    mostraRodape: function mostraRodape() {
      var html = document.querySelector('html').clientHeight;
      var tela = window.innerHeight;
      var posicao = window.innerHeight + window.scrollY;

      if (tela === posicao) {
        window.scrollTo({ top: html, behavior: 'smooth' });
      }
    }
  }
});

/***/ }),

/***/ "ZTpT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Breadcrumb',
  props: {
    links: {
      type: Array,
      default: function _default() {
        return [{
          named_link: '',
          link: '',
          label: ''
        }];
      }
    }
  }
});

/***/ }),

/***/ "ZUDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListaCandidatosGeral_vue__ = __webpack_require__("H6LR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6082aad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListaCandidatosGeral_vue__ = __webpack_require__("Sy/z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListaCandidatosGeral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6082aad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListaCandidatosGeral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zbiu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.entradaIsEmpty)?_c('div',[_c('i',{staticClass:"fa fa-arrow-circle-right fa-lg",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(_vm.time.entrada))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),(_vm.saidaIsEmpty)?_c('div',[_c('i',{staticClass:"fa fa-arrow-circle-right fa-lg",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(_vm.time.saida))]),_vm._v(" "),_c('button',{on:{"click":_vm.click}},[_vm._v("\n    ×\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zd6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      default: {
        route: '#',
        nome: 'título',
        icon: 'ico-servidor.svg'
      }
    };
  },


  computed: {
    fields: function fields() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.default, this.item);
    }
  }
});

/***/ }),

/***/ "ZdZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListaPrestacoes',
  props: {
    title: {
      type: String,
      required: true
    },
    prestacoes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    entidade: {
      type: Object,
      required: true
    }
  },
  methods: {
    statusHomologada: function statusHomologada(prestacao) {
      return prestacao.status_prestacao ? prestacao.status_prestacao.codigo === 3 : false;
    }
  }
});

/***/ }),

/***/ "ZmJt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zn3k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("5BtY");


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* SET_RECEITAS_PROPRIAS */], function (state, payload) {
  state.receitas_proprias = payload.receitas_proprias;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* SET_DETALHAMENTO_DESPESAS */], function (state, payload) {
  state.detalhamento_despesas = payload.detalhamento_despesas;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* SET_GRUPO_DESPESAS */], function (state, payload) {
  state.grupo_despesas = payload.despesas_acao;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["e" /* SET_FUNCAO_SUBFUNCAO */], function (state, payload) {
  state.funcao_subfuncao = payload.despesas_acao;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["f" /* SET_ADIANTAMENTOS */], function (state, payload) {
  state.adiantamentos = payload.adiantamentos;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["g" /* SET_DESPESAS_DETALHADAS */], function (state, payload) {
  state.despesas_detalhadas = payload.despesas_detalhadas;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_ANO_BASE */], function (state, payload) {
  state.ano_base = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["h" /* TOGGLE_LOADING */], function (state) {
  state.loading = !state.loading;
}), _mutations);

/***/ }),

/***/ "ZqNb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'input-error-message',
  props: {
    message: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "ZquW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CSVImport_vue__ = __webpack_require__("INat");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4070d16c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CSVImport_vue__ = __webpack_require__("3eTZ");
function injectStyle (ssrContext) {
  __webpack_require__("DvDe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4070d16c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CSVImport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4070d16c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CSVImport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zsc/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',{staticClass:"page-header"},[_vm._v("\n      Edital "+_vm._s(_vm.cargo.edital.numero)+" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.cargo.descricao))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-sm-3 text-center"},[_c('label',[_vm._v("Data de Homologação")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.cargo.data_homologacao))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-center"},[_c('label',[_vm._v("Total de vagas")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.cargo.vagas))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-center"},[_c('label',[_vm._v("Validade")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.cargo.data_validade))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-center"},[_c('label',[_vm._v("Data da ultima nomeação")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.cargo.ultima_nomeacao))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('font-awesome-icon',{attrs:{"icon":'address-card',"size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9 text-right"},[_c('div',{staticClass:"huge"},[_vm._v(_vm._s(_vm.habilitados.length))]),_vm._v(" "),_c('div',[_vm._v("Habilitados")])])])]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.scrollToElement('habilitados')}}},[_c('div',{staticClass:"panel-footer"},[_c('span',{staticClass:"pull-left"},[_vm._v("Detalhes")]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('font-awesome-icon',{attrs:{"icon":'bullhorn',"size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9 text-right"},[_c('div',{staticClass:"huge"},[_vm._v(_vm._s(_vm.nomeados.length))]),_vm._v(" "),_c('div',[_vm._v("Nomeados")])])])]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.scrollToElement('nomeados')}}},[_c('div',{staticClass:"panel-footer"},[_c('span',{staticClass:"pull-left"},[_vm._v("Detalhes")]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('font-awesome-icon',{attrs:{"icon":'user-check',"size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9 text-right"},[_c('div',{staticClass:"huge"},[_vm._v(_vm._s(_vm.empossados.length))]),_vm._v(" "),_c('div',[_vm._v("Empossados")])])])]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.scrollToElement('empossados')}}},[_c('div',{staticClass:"panel-footer"},[_c('span',{staticClass:"pull-left"},[_vm._v("Detalhes")]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('font-awesome-icon',{attrs:{"icon":'user-times',"size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9 text-right"},[_c('div',{staticClass:"huge"},[_vm._v(_vm._s(_vm.revogados.length))]),_vm._v(" "),_c('div',[_vm._v("Revogados")])])])]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.scrollToElement('revogados')}}},[_c('div',{staticClass:"panel-footer"},[_c('span',{staticClass:"pull-left"},[_vm._v("Detalhes")]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]),_vm._v(" "),(_vm.userPerfil == 'admin')?_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('font-awesome-icon',{attrs:{"icon":'users',"size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-9 text-right"},[_c('div',{staticClass:"huge"},[_vm._v(_vm._s(_vm.revogados.length))]),_vm._v(" "),_c('div',[_vm._v("Vagas do Quadro Permanente")])])])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{attrs:{"id":"habilitados"}},[_c('font-awesome-icon',{attrs:{"icon":'address-card'}}),_vm._v("\n          Habilitados\n        ")],1),_vm._v(" "),_c('data-table',{ref:"list_habilitados",attrs:{"dados":_vm.habilitadosNormal,"fields":_vm.fields.habilitados,"carregando":_vm.isLoading}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_c('font-awesome-icon',{attrs:{"icon":'address-card'}}),_vm._v("\n          Habilitados - PCD\n        ")],1),_vm._v(" "),_c('data-table',{ref:"list_habilitadosPCD",attrs:{"dados":_vm.habilitadosPCD,"fields":_vm.fields.habilitados,"carregando":_vm.isLoading}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{attrs:{"id":"nomeados"}},[_c('font-awesome-icon',{attrs:{"icon":'bullhorn'}}),_vm._v("\n          Nomeados\n        ")],1),_vm._v(" "),_c('data-table',{ref:"list_nomeados",attrs:{"dados":_vm.nomeados,"fields":_vm.fields.nomeados,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.retornarTipoCandidato(props.rowData))+"\n          ")]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{attrs:{"id":"empossados"}},[_c('font-awesome-icon',{attrs:{"icon":'user-check'}}),_vm._v("\n          Empossados\n        ")],1),_vm._v(" "),_c('data-table',{ref:"list_empossados",attrs:{"dados":_vm.empossados,"fields":_vm.fields.empossados,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.retornarTipoCandidato(props.rowData))+"\n          ")]}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{attrs:{"id":"revogados"}},[_c('font-awesome-icon',{attrs:{"icon":'user-times'}}),_vm._v("\n          Revogados\n        ")],1),_vm._v(" "),_c('data-table',{ref:"list_revogados",attrs:{"dados":_vm.revogados,"fields":_vm.fields.revogados,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_vm._v("\n            "+_vm._s(_vm.retornarTipoCandidato(props.rowData))+"\n          ")]}}])})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a3yM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emendas-list"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v("\n        Lista de Processos da Emenda nº "+_vm._s(_vm.numero)+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"title":"Adicionar","type":"button"},on:{"click":function($event){return _vm.adicionar()}}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v("\n        Adicionar\n      ")],1),_vm._v(" "),_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Lista de processos de pagamento","report-title":"Processos de pagamento","fields":_vm.fields,"dados":_vm.processos_pagamento},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)]}}])})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a9qp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aIkI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          infoClass: 'left floated left aligned six wide column'
        };
      }
    },
    infoTemplate: {
      type: String,
      default: function _default() {
        return "Displaying {from} to {to} of {total} items";
      }
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No relevant data';
      }
    }
  },
  data: function data() {
    return {
      tablePagination: null
    };
  },
  computed: {
    paginationInfo: function paginationInfo() {
      if (this.tablePagination == null || this.tablePagination.total == 0) {
        return this.noDataTemplate;
      }

      return this.infoTemplate.replace('{from}', this.tablePagination.from || 0).replace('{to}', this.tablePagination.to || 0).replace('{total}', this.tablePagination.total || 0);
    }
  },
  methods: {
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),

/***/ "aJoW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal_alert","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('header',[_c('i',{staticClass:"fa fa-exclamation-triangle fa-4x"}),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('main',{style:({ height: Array.isArray(_vm.content) ? '300px' : 'auto' })},[(!Array.isArray(_vm.content))?_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._l((_vm.content),function(ctt,index){return _c('p',{key:index,domProps:{"innerHTML":_vm._s(ctt)}})})],2),_vm._v(" "),_c('footer',[_c('button',{on:{"click":_vm.close}},[_vm._v("Sair")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aL4x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Ki62");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b72e30f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("mVoC");
function injectStyle (ssrContext) {
  __webpack_require__("nTWC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b72e30f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b72e30f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aLQB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aN5D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aUfs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aX8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectUOR_vue__ = __webpack_require__("Bgom");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e09666ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectUOR_vue__ = __webpack_require__("MOpE");
function injectStyle (ssrContext) {
  __webpack_require__("GmTN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e09666ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectUOR_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e09666ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectUOR_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aXsH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return escala; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__("1zm9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("YIkh");



var escala = {
  state: function state() {
    return { funcionarios: [] };
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["a" /* mutations */],
  actions: __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* actions */]
};

/***/ }),

/***/ "aceD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_auth_Login__ = __webpack_require__("3Jfp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_auth_RegistrarSenha__ = __webpack_require__("DXFb");



var routes = [{
  path: '/login/:errorMsg?',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_0__views_auth_Login__["a" /* default */]
}, {
  path: '/login/:user?',
  name: 'login_user',
  component: __WEBPACK_IMPORTED_MODULE_0__views_auth_Login__["a" /* default */]
}, {
  path: '/registrarsenha',
  name: 'RegistrarSenha',
  component: __WEBPACK_IMPORTED_MODULE_1__views_auth_RegistrarSenha__["a" /* default */]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "adyD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ag7F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Container__ = __webpack_require__("ik/t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SelectUOR__ = __webpack_require__("aX8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Escala_SelectReferencia__ = __webpack_require__("EGzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Calendar__ = __webpack_require__("Aaei");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Employee_Replicate__ = __webpack_require__("27/G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Employee_Search__ = __webpack_require__("6st+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Employee_List__ = __webpack_require__("jCVy");







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Container: __WEBPACK_IMPORTED_MODULE_8__components_Container__["a" /* default */],
    SelectUOR: __WEBPACK_IMPORTED_MODULE_9__components_SelectUOR__["a" /* default */],
    SelectReferencia: __WEBPACK_IMPORTED_MODULE_10__components_Escala_SelectReferencia__["a" /* default */],
    Calendar: __WEBPACK_IMPORTED_MODULE_11__components_Calendar__["a" /* default */],
    EmployeeReplicate: __WEBPACK_IMPORTED_MODULE_12__components_Employee_Replicate__["a" /* default */],
    EmployeeSearch: __WEBPACK_IMPORTED_MODULE_13__components_Employee_Search__["a" /* default */],
    EmployeeList: __WEBPACK_IMPORTED_MODULE_14__components_Employee_List__["a" /* default */]
  },
  beforecreate: function beforecreate() {
    if (!this.$store.state.islogged) {
      this.$router.push('/login');
    }
  },
  data: function data() {
    return {
      uor: '',
      referencia: '',
      scaleDefault: {},
      employeesSelected: [],
      observacao: '',
      statusLoading: false
    };
  },

  computed: {
    scaleDefaultIsEmpty: function scaleDefaultIsEmpty() {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(this.scaleDefault).length === 0;
    },
    hasEmployeesSelected: function hasEmployeesSelected() {
      return this.employeesSelected.length > 0;
    },
    uor_sigla: function uor_sigla() {
      return this.uor.split('|')[0];
    },
    uor_nome: function uor_nome() {
      return this.uor.split('|')[1];
    }
  },
  watch: {
    employeesSelected: function employeesSelected(value) {
      var _this = this;

      var newItens = value.filter(function (employee) {
        return !employee.hasOwnProperty('scale');
      });
      newItens.forEach(function (employee) {
        employee.scale = _this.scaleDefault.dates.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, item);
        });
      });
    }
  },
  methods: {
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var validateForm, getPayload, getPayloadChuncks, success, fail, _success, index;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validateForm = _this2.validateForm, getPayload = _this2.getPayload, getPayloadChuncks = _this2.getPayloadChuncks, success = _this2.success, fail = _this2.fail;

                if (validateForm()) {
                  _success = true;
                  index = 0;


                  __WEBPACK_IMPORTED_MODULE_7__request__["a" /* request */].post('escala/add', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, getPayload())).then(_this2.success).catch(function (error) {
                    _this2.$toastr.e(error.response.data);
                  });

                  //const payloads = getPayloadChuncks(9)

                  // do {
                  //   const { status } = await request.post('escala/add', { ...payloads[index++] })
                  //   success = status === 200
                  // } while (index < payloads.length && success)

                  // if (success) {
                  //   this.$toastr.s('Escala adicionada com sucesso!')
                  // } else {
                  //   this.$toastr.e('Houve uma falha ao tentar adicionar a escala, verifique na listagem se todos foram adicionados!')
                  // }

                  // this.$router.push('list')

                  // const { status } = await request.post('escala/add', { ...payload })

                  // if (status === 200) {
                  //   this.success()
                  // } else {
                  //   this.fails()
                  // }

                  // request.post('escala/add', payload, success, fail)
                }

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    validateForm: function validateForm() {
      var uor = this.uor,
          scaleDefault = this.scaleDefault,
          employeesSelected = this.employeesSelected;


      if (uor === undefined) {
        this.$toastr.e('Selecione uma unidade!');
        return false;
      }

      if (scaleDefault.dates.length === 0) {
        this.$toastr.e('Escolha os dias da escala no calendário!');
        return false;
      }

      if (employeesSelected.length === 0) {
        this.$toastr.e('Escolha os colaboradores!');
        return false;
      }

      if (employeesSelected.find(function (item) {
        return item.scaleStatus === 'invalid';
      })) {
        this.$toastr.e('Favor resolver os conflitos de escala dos funcionários!');
        return false;
      }

      return true;
    },
    getPayload: function getPayload() {
      var uor_sigla = this.uor_sigla,
          uor_nome = this.uor_nome,
          observacao = this.observacao,
          referencia = this.referencia;


      var colaboradores = this.employeesSelected.map(function (_ref) {
        var colaborador_id = _ref.id,
            scale = _ref.scale;

        // filtrar a escala somente pelos dias ativos e com times maior que zero
        var escalaFiltrada = scale.filter(function (_ref2) {
          var active = _ref2.active,
              times = _ref2.times;
          return active && times.length > 0;
        });

        // preparar a escala com a estrutra 1 horario -> lista de dias
        var horariosDatas = {};
        escalaFiltrada.forEach(function (_ref3) {
          var date = _ref3.date,
              times = _ref3.times;

          var data = date.toLocaleDateString('pt-BR', { month: '2-digit', day: '2-digit' });
          times.forEach(function (_ref4) {
            var entrada = _ref4.entrada,
                saida = _ref4.saida;

            var keyTime = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ entrada: entrada, saida: saida });
            if (horariosDatas.hasOwnProperty(keyTime)) horariosDatas[keyTime].datas.push(data);else horariosDatas[keyTime] = { entrada: entrada, saida: saida, datas: [data] };
          });
        });

        // finalizar convertendo o objeto de horarios em array
        var horarios_datas = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(horariosDatas).length > 0 ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(horariosDatas)) : false;

        return { colaborador_id: colaborador_id, horarios_datas: horarios_datas };
      });

      return {
        uor_sigla: uor_sigla,
        uor_nome: uor_nome,
        referencia: referencia,
        observacao: observacao,
        colaboradores: colaboradores
      };
    },
    getPayloadChuncks: function getPayloadChuncks(size) {
      var _getPayload = this.getPayload(),
          escala = _getPayload.escala,
          referencia = _getPayload.referencia,
          uor = _getPayload.uor;

      var payloads = [];

      for (var i = 0; i < escala.length; i += size) {
        payloads.push({
          escala: escala.slice(i, i + size),
          referencia: referencia,
          uor_sigla: uor.sigla,
          uor_nome: uor.nome
        });
      }

      return payloads;
    },
    success: function success() {
      this.$toastr.s('Escala adicionada com sucesso!');
      this.$router.push('list');
    },
    fails: function fails() {
      this.$toastr.e('Houve uma falha ao tentar adicionar a escala, Tente novamente daqui alguns minutos!');
    },
    changeStatusLoading: function changeStatusLoading(value) {
      this.statusLoading = value;
    }
  }
});

/***/ }),

/***/ "aoa/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editais',
  data: function data() {
    return {
      fields: [{
        name: 'numero',
        title: 'Nº Edital',
        sortField: 'numero',
        filterable: true
      }, {
        name: 'processo_numero',
        title: 'Nº Processo',
        sortField: 'processo_numero',
        width: '15%',
        filterable: true
      }, {
        name: 'publicado',
        title: 'Publicado',
        sortField: 'publicado',
        filterable: true,
        callback: function callback(value) {
          return value ? 'Sim' : 'Não';
        },

        titleClass: 'text-center',
        dataClass: 'text-center'
      }, {
        name: 'cargos_descricao',
        title: 'Cargos',
        callback: function callback(value) {
          var cargos = value[0];
          for (var index = 1; index < value.length; index++) {
            cargos += ', ' + value[index];
          }
          return cargos;
        }
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center',
        dataClass: 'text-center col-xs-1'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_1__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  methods: {
    editar: function editar(data) {
      this.$router.push({
        name: 'salvar_edital',
        params: data
      });
    },
    consultar: function consultar(keyTable) {
      var me = this;
      this.$nextTick(function () {
        me.$refs[keyTable].refresh();
      });
    },
    limpar: function limpar() {
      /**
       * Se não fizer desse jeito, um a um, não vai.
       * Passando um objeto completo, dá pau. Precisa limpar 2 vezes.
       * Full bugado.
       */
      this.numero = '';
      this.processo_numero = '';
      this.publicado = '';
      this.$refs.vuetable.refresh();
    },
    teste: function teste() {
      var _document$getElements = document.getElementsByTagName('table'),
          _document$getElements2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_document$getElements, 1),
          table = _document$getElements2[0];

      var html = table.innerHTML;

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('teste2', { html: html }).then(function (response) {
        var blob = new Blob([response.data]);
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'print.pdf';
        link.click();
      });
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'acompanhamentos',
        value: 1
      });
    }
  },
  computed: {
    filtros: function filtros() {
      var numero = this.numero,
          processo_numero = this.processo_numero,
          publicado = this.publicado,
          status = this.status;

      return {
        numero: numero,
        processo_numero: processo_numero,
        publicado: publicado,
        status: status
      };
    },

    pagina: {
      get: function get() {
        var acompanhamentos = this.$store.state.vuetableState.acompanhamentos;
        var pagina = acompanhamentos.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'acompanhamentos',
          value: value
        });
      }
    },
    numero: {
      get: function get() {
        var acompanhamentos = this.$store.state.vuetableState.acompanhamentos;
        var numero = acompanhamentos.filtros.numero;


        return numero;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'numero',
          collection: 'acompanhamentos',
          value: value
        });
        this.resetPageStore();
      }
    },
    processo_numero: {
      get: function get() {
        var acompanhamentos = this.$store.state.vuetableState.acompanhamentos;
        var processo_numero = acompanhamentos.filtros.processo_numero;


        return processo_numero;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'processo_numero',
          collection: 'acompanhamentos',
          value: value
        });
        this.resetPageStore();
      }
    },
    publicado: {
      get: function get() {
        var acompanhamentos = this.$store.state.vuetableState.acompanhamentos;
        var publicado = acompanhamentos.filtros.publicado;


        return publicado;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'publicado',
          collection: 'acompanhamentos',
          value: value
        });
        this.resetPageStore();
      }
    },
    status: {
      get: function get() {
        var acompanhamentos = this.$store.state.vuetableState.acompanhamentos;
        var status = acompanhamentos.filtros.status;


        return status;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'status',
          collection: 'acompanhamentos',
          value: value
        });
        this.resetPageStore();
      }
    }
  }
});

/***/ }),

/***/ "ap9C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "axda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("NcFF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c59ba822_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("E0MG");
function injectStyle (ssrContext) {
  __webpack_require__("DfAy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c59ba822_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b3FG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("p0Qv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f6461c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("QKAJ");
function injectStyle (ssrContext) {
  __webpack_require__("Jn6W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79f6461c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f6461c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bCKG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datatableFields__ = __webpack_require__("MtQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExportCSV__ = __webpack_require__("lknt");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_2__common__["e" /* NoApiTable */],
    ExportCSV: __WEBPACK_IMPORTED_MODULE_4__ExportCSV__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    chave: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getGravidadeClass: __WEBPACK_IMPORTED_MODULE_1__datatableFields__["b" /* getGravidadeClass */],
    getProximidadeData: __WEBPACK_IMPORTED_MODULE_1__datatableFields__["c" /* getProximidadeData */],
    formatTo2DigitsDate: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* formatTo2DigitsDate */]
  },
  computed: {
    dados: function dados() {
      return this.items;
    },
    fieldsAgendados: function fieldsAgendados() {
      var array = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1__datatableFields__["d" /* fieldsAgendados */]));

      if (this.chave) {
        array.splice(array.length - 2, 0, {
          name: this.chave,
          title: this.title,
          callback: function callback(value) {
            return value.replace(/^.\d+ - /, '');
          }
        });
      }

      return array;
    }
  }
});

/***/ }),

/***/ "bEN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vueisotope__ = __webpack_require__("jOQl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vueisotope___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vueisotope__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common___ = __webpack_require__("vAZe");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'educacao',
  components: {
    isotope: __WEBPACK_IMPORTED_MODULE_2_vueisotope___default.a,
    Card: __WEBPACK_IMPORTED_MODULE_3__components_common___["l" /* CardLG */],
    PublicHeader: __WEBPACK_IMPORTED_MODULE_3__components_common___["a" /* PublicHeader */]
  },
  data: function data() {
    return {
      model: {
        lista_escolas: [],
        totalAlunos: 0,
        lista_bairros: [],
        lista_ensinos: [],
        filtros: {
          bairro: null,
          ensino: null,
          escola: null
        }
      },
      filterText: '',
      filterOption: 'filterByText'
    };
  },

  methods: {
    retira_acentos: function retira_acentos(str) {
      var parsed = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return parsed;
    },
    getOptions: function getOptions() {
      var _this = this;
      return {
        getSortData: {
          id: "id",
          name: function name(itemElem) {
            return itemElem.codigo.toLowerCase();
          }
        },
        getFilterData: {
          isEven: function isEven(itemElem) {
            return itemElem.codigo % 2 === 0;
          },
          isOdd: function isOdd(itemElem) {
            return itemElem.codigo % 2 !== 0;
          },
          filterByText: function filterByText(itemElem) {
            return _this.retira_acentos(itemElem.nome.toLowerCase()).includes(_this.textoFiltrado) || _this.retira_acentos(itemElem.nomeconhecido.toLowerCase()).includes(_this.textoFiltrado);
          }
        }
      };
    },
    listarBairros: function listarBairros() {
      var _this2 = this;

      var bairros = this.$refs.bairros;
      bairros.toggleLoading();
      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('educacao/listarBairros', function (response) {
        _this2.model.lista_bairros = response.data;
        bairros.toggleLoading();
      }, function (response) {
        console.log(response);
        bairros.toggleLoading();
      });
    },
    listarEnsinos: function listarEnsinos() {
      var _this3 = this;

      var ensinos = this.$refs.ensinos;
      ensinos.toggleLoading();
      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('educacao/listarEnsinos', function (response) {
        _this3.model.lista_ensinos = response.data;
        ensinos.toggleLoading();
      }, function (response) {
        console.log(response);
        ensinos.toggleLoading();
      });
    },
    listarEscolas: function listarEscolas() {
      var _this4 = this;

      var params = '?';
      this.filterText = '';
      this.model.lista_escolas = [];
      this.model.totalAlunos = 0;

      if (this.model.filtros.bairro) {
        params += '&bairro=' + this.model.filtros.bairro.codigo;
      }

      if (this.model.filtros.ensino) {
        params += '&ensino=' + this.model.filtros.ensino.codigo;
      }

      // if (this.model.filtros.escola) {
      //   params += '&escola=' + this.model.filtros.escola.codigo
      // }

      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('educacao/listarEscolas' + params, function (response) {
        _this4.model.lista_escolas = response.data;
        _this4.totalAlunos();
      }, function (response) {
        console.log(response);
      });
    },
    totalAlunos: function totalAlunos() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('educacao/totalAlunos?escolas=' + this.escolasListadas, function (response) {
        _this5.model.totalAlunos = response.data;
      }, function (response) {
        console.log(response);
      });
    },
    carregarLista: function carregarLista(url, callback) {
      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get(url, function (response) {
        callback(response.data);
      }, function (response) {
        callback(console.log(response));
      });
    }
  },
  computed: {
    textoFiltrado: function textoFiltrado() {
      return this.retira_acentos(this.filterText.toLowerCase());
    },
    formatTotalAlunos: function formatTotalAlunos() {
      var nf = Intl.NumberFormat('pt-BR');
      return nf.format(this.model.totalAlunos);
    },
    escolasListadas: function escolasListadas() {
      var esc = [];
      for (var index = 0; index < this.model.lista_escolas.length; index++) {
        esc.push(this.model.lista_escolas[index].codigo);
      }

      return encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(esc));
    }
  },
  mounted: function mounted() {
    this.listarEscolas();
    this.listarBairros();
    this.listarEnsinos();
  }
});

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrestacaoContas_ListaPrestacoes__ = __webpack_require__("6yB8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreHabilitadoTable__ = __webpack_require__("0w91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Consumo_GraficoConsumo__ = __webpack_require__("tRNT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CriterioRemedio__ = __webpack_require__("x3LP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeafletMap__ = __webpack_require__("id8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardEmendas__ = __webpack_require__("aL4x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emendas_SideEmendas__ = __webpack_require__("72VV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emendas_SelectAno__ = __webpack_require__("xdfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EleicaoConselho_ProgressoCandidato__ = __webpack_require__("Xll0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EleicaoConselho_ProgressoGeral__ = __webpack_require__("AxvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EleicaoConselho_ListaCandidatos__ = __webpack_require__("KyBI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EleicaoConselho_ListaCandidatosGeral__ = __webpack_require__("ZUDy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardsODS__ = __webpack_require__("9mlN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardsODS_CardsFiltro_vue__ = __webpack_require__("pFwp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Dados_InfoDados__ = __webpack_require__("ukyS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Dados_Downloads__ = __webpack_require__("bNK7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dados_Graficos__ = __webpack_require__("QZjH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Dados_TabelaValores__ = __webpack_require__("wexX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CardsODS_CardsSecretaria__ = __webpack_require__("hNdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Dados_CardsFiltrosSecretaria_vue__ = __webpack_require__("gL/a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Dados_FaixaComparacao_vue__ = __webpack_require__("7NBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Panel_CardsPortais__ = __webpack_require__("COst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ValorDestaque__ = __webpack_require__("T0+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Cards_InstitucionalNomeValor__ = __webpack_require__("rnkU");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_0__PrestacaoContas_ListaPrestacoes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_1__PreHabilitadoTable__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__Consumo_GraficoConsumo__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_3__CriterioRemedio__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_4__LeafletMap__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_5__CardEmendas__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_6__emendas_SideEmendas__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_7__emendas_SelectAno__["a"]; });
/* unused harmony reexport ProgressoCandidato */
/* unused harmony reexport ProgressoGeral */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_10__EleicaoConselho_ListaCandidatos__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_11__EleicaoConselho_ListaCandidatosGeral__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_12__CardsODS__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_13__CardsODS_CardsFiltro_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_14__Dados_InfoDados__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_15__Dados_Downloads__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_16__Dados_Graficos__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_17__Dados_TabelaValores__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_18__CardsODS_CardsSecretaria__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_19__Dados_CardsFiltrosSecretaria_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_20__Dados_FaixaComparacao_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_21__Panel_CardsPortais__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_22__ValorDestaque__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_23__Cards_InstitucionalNomeValor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ProcedimentosSaude_index__ = __webpack_require__("uM8Y");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_24__ProcedimentosSaude_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_24__ProcedimentosSaude_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_24__ProcedimentosSaude_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_24__ProcedimentosSaude_index__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common__ = __webpack_require__("vAZe");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_25__common__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_25__common__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_25__common__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_25__common__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_25__common__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_25__common__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_25__common__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_25__common__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_25__common__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_25__common__["m"]; });






























/***/ }),

/***/ "bIuM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectScaleType_vue__ = __webpack_require__("PmNd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e71e5ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectScaleType_vue__ = __webpack_require__("pzbd");
function injectStyle (ssrContext) {
  __webpack_require__("szDb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e71e5ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectScaleType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e71e5ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectScaleType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bKJR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Habilitados_vue__ = __webpack_require__("4vaI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dbdb6a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Habilitados_vue__ = __webpack_require__("TeVB");
function injectStyle (ssrContext) {
  __webpack_require__("6yGG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8dbdb6a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Habilitados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dbdb6a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Habilitados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bLdy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mp-medidas',
  inject: ["showConfirm"],
  data: function data() {
    return {
      apiUrl: 'material/medida',
      fields: [{
        name: 'nome',
        title: 'Nome',
        sortField: 'nome',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  methods: {
    excluir: function excluir(data) {
      var _this = this;

      var me = this;
      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].delete(_this.apiUrl + '/' + data.codigo).then(function (resp) {
            me.consultar();
            me.$toastr.s('Item removido com sucesso');
          }).catch(function (error) {
            me.$toastr.e(error.response.data);
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    consultar: function consultar() {
      this.$refs.vuetable.refresh();
    },
    limpar: function limpar() {
      this.nome = '';
      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'medidas',
        value: 1
      });
    }
  },
  computed: {
    filtros: function filtros() {
      var nome = this.nome;

      return {
        nome: nome
      };
    },

    pagina: {
      get: function get() {
        var medidas = this.$store.state.vuetableState.medidas;
        var pagina = medidas.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'medidas',
          value: value
        });
      }
    },
    nome: {
      get: function get() {
        var medidas = this.$store.state.vuetableState.medidas;
        var nome = medidas.filtros.nome;

        return nome;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'medidas',
          value: value
        });
        this.resetPageStore();
      }
    }
  }
});

/***/ }),

/***/ "bNK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Downloads_vue__ = __webpack_require__("ufvN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f8269c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Downloads_vue__ = __webpack_require__("ZBZv");
function injectStyle (ssrContext) {
  __webpack_require__("nZDk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f8269c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Downloads_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f8269c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Downloads_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bRzK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bUcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v("Adicionar Tag")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('fieldset',[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('tag') }]},[_c('label',{class:[
                'col-xs-12',
                'control-label',
                'custom-font',
                { 'is-danger': _vm.errors.has('tag') }
              ]},[_vm._v("Nome da tag")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 inputGroupContainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('tag') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.TAG_DCTAG),expression:"model.TAG_DCTAG"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"tag",class:[
                    'form-control',
                    { 'is-danger': _vm.errors.has('tag') }
                  ],attrs:{"name":"tag","maxlength":"45","placeholder":"Tag","type":"text"},domProps:{"value":(_vm.model.TAG_DCTAG)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "TAG_DCTAG", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                    'input-group-addon custom-input-group-addon-count',
                    { 'is-danger': _vm.errors.has('tag') }
                  ],domProps:{"textContent":_vm._s(45 - _vm.model.TAG_DCTAG.length)}})]),_vm._v(" "),(_vm.errors.has('tag'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"tag"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                "+_vm._s(_vm.errors.first('tag'))+"\n              ")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){return _vm.save()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n                Salvar\n              ")],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bVt6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bYZH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      file: ''
    };
  },

  methods: {
    loadPDF: function loadPDF(e) {
      var pdf_file = e.target.files[0];
      this.file = pdf_file;
    },
    clean: function clean() {
      this.file = '';
      this.$refs.pdf_file.value = '';
    }
  },
  watch: {
    file: function file(newValue) {
      this.$emit('loadFile', newValue);
    }
  }
});

/***/ }),

/***/ "be+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Employee_Item__ = __webpack_require__("qVZE");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { EmployeeItem: __WEBPACK_IMPORTED_MODULE_1__components_Employee_Item__["a" /* default */] },
  props: {
    value: Array,
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    count: function count() {
      return this.value.length;
    }
  },
  methods: {
    removeItem: function removeItem(index) {
      var newValue = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.value));
      newValue.splice(index, 1);
      this.update(newValue);
    },
    update: function update(value) {
      this.$emit('input', [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(value)));
    },
    updateItem: function updateItem(_ref, index) {
      var scaleStatus = _ref.scaleStatus,
          scale = _ref.scale;

      var newValue = this.value;
      newValue[index].scaleStatus = scaleStatus;
      newValue[index].scale = scale;
      this.update(newValue);
    }
  }
});

/***/ }),

/***/ "bjbF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputModal_vue__ = __webpack_require__("u5A4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09980639_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputModal_vue__ = __webpack_require__("jJwK");
function injectStyle (ssrContext) {
  __webpack_require__("ea5K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09980639"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09980639_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bkmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'planos-governo',
  inject: ["showConfirm"],
  data: function data() {
    return {
      fields: [{
        name: 'unidade_executora',
        title: 'Unidade Executora',
        sortField: 'unidade_executora',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'descritivo',
        title: 'Título',
        sortField: 'titulo',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'status',
        title: 'Status',
        sortField: 'status',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'data_conclusao',
        title: 'Homologado',
        sortField: 'data_conclusao',
        titleClass: 'text-center',
        dataClass: 'text-center',
        filterable: true,
        callback: function callback(value) {
          return value === null ? 'Não' : 'Sim';
        }
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }],
      listas: {
        secretarias: [],
        autarquias: [],
        status: ['Não Iniciado', 'Em andamento', 'Concluído', 'Cancelado']
      },
      periodos: ['2017-2020', '2021-2024', '2025-2028'],
      periodoSelecionado: '2025-2028'
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_2__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    if (this.$router.history.current.params.state) {
      this.state = this.$router.history.current.params.state;
    }

    this.loadUnidades();
  },

  computed: {
    filtros: function filtros() {
      var descricao = this.descricao,
          unidade_executora = this.unidade_executora,
          status = this.status;

      return {
        descricao: descricao,
        unidade_executora: unidade_executora,
        status: status
      };
    },

    pagina: {
      get: function get() {
        var planoGoverno = this.$store.state.vuetableState.planoGoverno;
        var pagina = planoGoverno.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'planoGoverno',
          value: value
        });
      }
    },

    unidade_executora: {
      get: function get() {
        var planoGoverno = this.$store.state.vuetableState.planoGoverno;
        var unidade_executora = planoGoverno.filtros.unidade_executora;


        return unidade_executora;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'unidade_executora',
          collection: 'planoGoverno',
          value: value
        });
        this.resetPageStore();
      }
    },
    descricao: {
      get: function get() {
        var planoGoverno = this.$store.state.vuetableState.planoGoverno;
        var descricao = planoGoverno.filtros.descricao;

        return descricao;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'descricao',
          collection: 'planoGoverno',
          value: value
        });
        this.resetPageStore();
      }
    },
    status: {
      get: function get() {
        var planoGoverno = this.$store.state.vuetableState.planoGoverno;
        var status = planoGoverno.filtros.status;

        return status;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'status',
          collection: 'planoGoverno',
          value: value
        });
        this.resetPageStore();
      }
    }
  },
  methods: {
    loadUnidades: function loadUnidades() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, secretarias, _ref2, autarquias;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('listar-secretarias');

              case 2:
                _ref = _context.sent;
                secretarias = _ref.data.data;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('listar-autarquias');

              case 6:
                _ref2 = _context.sent;
                autarquias = _ref2.data.data;


                _this.listas.secretarias = secretarias;
                _this.listas.autarquias = autarquias;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    adicionarAcao: function adicionarAcao(rowData) {
      this.$router.push({
        name: 'user_planogoverno_acao_save',
        params: { rowData: rowData }
      });
    },
    editar: function editar(modelData) {
      this.$router.push({
        name: 'admin_planogoverno_save',
        params: { modelData: modelData }
      });
    },
    excluir: function excluir(data) {
      var dt = this.$refs.vuetable;
      data.type = 'PLANOGOVERNO';

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].delete(data, function () {
            dt.refresh();
          }, function () {
            console.log('houve um error ao tentar excluir este item, por favor tente novamente mais tarde!');
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este Plano de Governo?', config);
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      this.unidade_executora = '';
      this.descricao = '';
      this.status = '';

      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'planoGoverno',
        value: 1
      });
    }
  }
});

/***/ }),

/***/ "blu3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_emendas_js__ = __webpack_require__("6IHv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1933d1d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("sWrA");
function injectStyle (ssrContext) {
  __webpack_require__("zmb6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1933d1d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_emendas_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1933d1d2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bsTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common___ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_strings_js__ = __webpack_require__("V99r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Card_vue__ = __webpack_require__("9i0h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_side_modal__ = __webpack_require__("fc38");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_2__components_common___["a" /* PublicHeader */],
    PieChart: __WEBPACK_IMPORTED_MODULE_2__components_common___["c" /* PieChart */],
    Card: __WEBPACK_IMPORTED_MODULE_5__Card_vue__["a" /* default */],
    BarChart: __WEBPACK_IMPORTED_MODULE_2__components_common___["d" /* BarChart */],
    SideBar: __WEBPACK_IMPORTED_MODULE_6__components_common_side_modal__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_8__components_common_NoApiTable__["a" /* default */],
    AnoBase: __WEBPACK_IMPORTED_MODULE_2__components_common___["j" /* AnoBase */]
  },
  data: function data() {
    return {
      filtros: {
        descricao: ''
      },
      title: '',
      operacao: '',
      detalhe_empenho: {},
      historico_empenho: [],
      items: [],
      navs: [{
        titulo: 'Adiantamentos',
        subtitulo: 'Detalhes do empenho',
        subtDetalhe: '',
        largura: 1200,
        identidade: 'aditamento',
        abreProximo: true,
        aberto: false
      }],
      graficoOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Acompanhamento de receitas',
          fontColor: '#C1D1C1'
        },
        legend: {
          display: true,
          labels: {
            fontColor: '#C1D1C1'
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              suggestedMax: 50,
              fontColor: '#C1D1C1',
              callback: function callback(value, index, values) {
                return value.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL'
                });
              }
            }
          }],
          xAxes: [{
            maxBarThickness: 50,
            ticks: {
              fontColor: '#C1D1C1'
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function label(tooltip, dataset) {
              var xLabel = dataset.datasets[tooltip.datasetIndex].label;
              var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              });
              return xLabel + ': ' + yLabel;
            }
          }
        }
      },
      graficos_base: {
        labels: [],
        datasets: [{ label: '', backgroundColor: [], data: [] }]
      },
      url_geosiap_base: 'https://geosiap.santos.sp.gov.br/portal-transparencia/api/default/execucao/despesas_detalhadas',
      fields: [{
        name: '__slot:column',
        title: 'Empenho'
      }, {
        name: 'dt_doc_despesa',
        title: 'Data',
        callback: function callback(value) {
          return new Date(value + ' 00:00:00').toLocaleDateString();
        }
      }, {
        name: 'historico',
        title: 'Histórico'
      }, {
        name: 'vl_empenhado',
        title: 'Empenhado',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }, {
        name: 'vl_liquidado',
        title: 'Liquidado',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }, {
        name: 'vl_pago',
        title: 'Pago',
        titleClass: 'text-right',
        dataClass: 'text-right'
      }, {
        name: '__slot:actions',
        title: 'Visualizar',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }]
    };
  },
  created: function created() {
    var operacao = this.$route.params.operacao;

    this.operacao = operacao;

    switch (operacao) {
      case 'ue':
        var grupo_despesas = this.$store.state.receitas_despesas.grupo_despesas;

        this.loadGrupoDespesas(grupo_despesas);
        break;
      case 'fs':
        var funcao_subfuncao = this.$store.state.receitas_despesas.funcao_subfuncao;

        this.loadGrupoDespesas(funcao_subfuncao);
        break;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapState */])({
    ano_base: function ano_base(state) {
      return state.receitas_despesas.ano_base;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["d" /* mapGetters */])(['isLoading']), {
    mes_base: function mes_base() {
      var data = new Date();
      if (this.ano_base !== data.getFullYear()) {
        var val = new Date(this.ano_base, 11, 31);
        return {
          nome: val.toLocaleString('default', { month: 'long' }),
          valor: val.getMonth()
        };
      }

      return {
        nome: data.toLocaleString('default', { month: 'long' }),
        valor: data.getMonth()
      };
    },
    totalDespesasFiltradas: function totalDespesasFiltradas() {
      var _this = this;

      var reducer = function reducer(acumulador, atual) {
        acumulador.vl_empenhado += _this.desformatarMoeda(atual.vl_empenhado);
        acumulador.vl_liquidado += _this.desformatarMoeda(atual.vl_liquidado);
        acumulador.vl_pago += _this.desformatarMoeda(atual.vl_pago);

        return acumulador;
      };

      var base = {
        vl_empenhado: 0,
        vl_liquidado: 0,
        vl_pago: 0
      };

      if (!this.despesasUnidade.length) return base;

      return this.despesasUnidade.reduce(reducer, base);
    },
    despesasUnidade: function despesasUnidade() {
      var despesas_detalhadas = this.$store.state.receitas_despesas.despesas_detalhadas;
      var descricao = this.$route.params.descricao;


      var filter = function filter(item) {
        if (item.funcao.substring(0, descricao.length) === descricao || item.unidade_orcamentaria.substring(0, descricao.length) === descricao) {
          return true;
        }

        return false;
      };

      var despesas = despesas_detalhadas.filter(filter);

      if (this.filtros.descricao) {
        return this.filtrar(despesas);
      }

      return despesas;
    },
    carregandoDespesas: function carregandoDespesas() {
      var despesas_detalhadas = this.$store.state.receitas_despesas.despesas_detalhadas;


      if (despesas_detalhadas.length) {
        return false;
      }

      return true;
    },
    gastosNivel1: function gastosNivel1() {
      if (this.items.length === 0) {
        return {};
      }

      var _items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(this.items, 1),
          first = _items[0];

      return first;
    },
    gastosNivel2: function gastosNivel2() {
      return this.items.slice(1);
    },
    graficoDespesa: function graficoDespesa() {
      var labels = ['Empenho', 'Liquidação', 'Pagamento'];

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.graficos_base, {
        labels: labels,
        datasets: [{
          type: 'line',
          label: 'Previs\xE3o Anual - ' + this.ano_base,
          backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__["a" /* default */].coresHexa[0],
          borderColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__["a" /* default */].coresHexa[0],
          fill: false,
          data: Array(3).fill(this.gastosNivel1.vl_previsto)
        }, {
          label: 'Acumulado - ' + this.ano_base,
          backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__["a" /* default */].coresHexa[1],
          data: [this.gastosNivel1.vl_empenhado_acu, this.gastosNivel1.vl_liquidado_acu, this.gastosNivel1.vl_pago_acu]
        }]
      });
    }
  }),
  methods: {
    filtrar: function filtrar(lista) {
      var _this2 = this;

      var filter = function filter(obj) {
        if (_this2.filtros.descricao !== '') {
          return _this2.contains(obj.historico, _this2.filtros.descricao);
        }

        return true;
      };

      return lista.filter(filter);
    },
    montarEmpenho: function montarEmpenho(item) {
      var _item$rowData = item.rowData,
          ano_doc_despesa = _item$rowData.ano_doc_despesa,
          nr_doc_despesa = _item$rowData.nr_doc_despesa;

      this.abrir(nr_doc_despesa + '/' + ano_doc_despesa, 'Despesa');
    },

    formatarMoeda: __WEBPACK_IMPORTED_MODULE_3__utils_strings_js__["b" /* formatarMoeda */],
    desformatarMoeda: __WEBPACK_IMPORTED_MODULE_3__utils_strings_js__["e" /* desformatarMoeda */],
    contains: __WEBPACK_IMPORTED_MODULE_3__utils_strings_js__["f" /* contains */],
    abrir: function abrir(empenho, title) {
      this.navs[0].titulo = title;
      this.navs[0].subtDetalhe = 'Empenho n\xBA: ' + empenho;
      this.carregarDetalhesEmpenho(empenho);
      this.$emit('abreModal', this.navs[0].identidade);
    },
    carregarDetalhesEmpenho: function carregarDetalhesEmpenho(empenho) {
      var emp = empenho.split('/');
      var filter = function filter(obj) {
        if (obj.ano_doc_despesa === emp[1] && obj.nr_doc_despesa === emp[0]) {
          return true;
        }
        return false;
      };

      var despesas_detalhadas = this.$store.state.receitas_despesas.despesas_detalhadas;


      this.detalhe_empenho = despesas_detalhadas.filter(filter)[0];
      this.carregarHistoricoEmpenho(this.detalhe_empenho.id_doc_despesa);
    },
    carregarHistoricoEmpenho: function carregarHistoricoEmpenho(idEmpenho) {
      var _this3 = this;

      this.historico_empenho = [];

      __WEBPACK_IMPORTED_MODULE_7__request__["a" /* request */].get(this.url_geosiap_base + '/empenhos?ano=' + new Date() + '&data_inicial=undefined&data_final=undefined&id_entidade=1&id_empenho=' + idEmpenho).then(function (response) {
        _this3.historico_empenho = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    listaCards: function listaCards() {
      var data = [];

      for (var index = 0; index < this.gastosNivel2.length; index++) {
        var element = this.gastosNivel2[index];
        data.push({
          title: element.descricao,
          data: [{
            label: 'Valor Previsto',
            value: this.formatarMoeda(Number(element.vl_previsto))
          }, {
            label: 'Valor Autorizado',
            value: this.formatarMoeda(Number(element.vl_autorizado))
          }, {
            label: 'Empenhado',
            value: this.formatarMoeda(Number(element.vl_empenhado_acu)) + ' (' + element.vl_empenhado_perc + ')'
          }, {
            label: 'Liquidado',
            value: this.formatarMoeda(Number(element.vl_liquidado_acu)) + ' (' + element.vl_liquidado_perc + ')'
          }, {
            label: 'Pago',
            value: this.formatarMoeda(Number(element.vl_pago_acu)) + ' (' + element.vl_pago_perc + ')'
          }]
        });
      }

      return data;
    },
    loadGrupoDespesas: function loadGrupoDespesas(grupo_despesas) {
      var descricao = this.$route.params.descricao;


      var filter = function filter(item) {
        if (item.chave.substring(0, descricao.length) === descricao) {
          return true;
        }

        return false;
      };

      this.items = grupo_despesas.filter(filter);

      if (!this.items.length) {
        this.$router.push('/despesas');
        return;
      }

      this.title = _.first(this.items).descricao;
    }
  }
});

/***/ }),

/***/ "bzbO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalheSecao_vue__ = __webpack_require__("/End");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d25702_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalheSecao_vue__ = __webpack_require__("pt+G");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalheSecao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05d25702_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalheSecao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c/7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("VlT+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e516aa5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("9IrP");
function injectStyle (ssrContext) {
  __webpack_require__("puUd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e516aa5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e516aa5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c/cq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/conecte-sus.a693755.svg";

/***/ }),

/***/ "c0bW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c7SH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datatableFields__ = __webpack_require__("MtQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListaFilaAgendados__ = __webpack_require__("pTTs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputCartaoSUS__ = __webpack_require__("s6u6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListaFilaEspera__ = __webpack_require__("6bWN");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_3__common__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__common__["b" /* Breadcrumb */],
    DataTable: __WEBPACK_IMPORTED_MODULE_3__common__["e" /* NoApiTable */],
    ListaFilaAgendados: __WEBPACK_IMPORTED_MODULE_6__ListaFilaAgendados__["a" /* default */],
    InputCartaoSUS: __WEBPACK_IMPORTED_MODULE_7__InputCartaoSUS__["a" /* default */],
    ListaFilaEspera: __WEBPACK_IMPORTED_MODULE_8__ListaFilaEspera__["a" /* default */]
  },
  props: {
    title: {
      type: String,
      required: true
    },
    termoConsulta: {
      type: String,
      required: true
    },
    breadcrumb: {
      type: Array,
      required: true
    },
    urls: {
      type: Object,
      default: function _default() {
        return { espera: '', agendados: '' };
      }
    },
    tipo: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      carregando: {
        espera: false,
        agendados: false,
        media: false
      },
      numeroCartao: {
        espera: '',
        agendados: ''
      },
      lista: {
        espera: [],
        agendados: []
      },
      listaOriginal: {
        espera: [],
        agendados: []
      },
      fields: __WEBPACK_IMPORTED_MODULE_5__datatableFields__["a" /* fields */],
      mediaEspera: -1
    };
  },
  created: function created() {
    this.getLista('espera');
    this.getLista('agendados');
    this.getMediaEspera();
  },

  methods: {
    getGravidadeClass: __WEBPACK_IMPORTED_MODULE_5__datatableFields__["b" /* getGravidadeClass */],
    toggleLoading: function toggleLoading(key) {
      this.carregando[key] = !this.carregando[key];
    },
    getLista: function getLista(key) {
      var _this = this;

      this.toggleLoading(key);
      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get(this.urls[key], {
        params: {
          consulta: this.termoConsulta,
          cartao: this.numeroCartao[key]
        }
      }).then(function (response) {
        var data = response.data;


        _this.lista[key] = data;

        if (!_this.numeroCartao[key]) {
          _this.listaOriginal[key] = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this.lista[key]));
        }
      }).catch(function (error) {
        console.log(error.response);
        _this.$toastr.e('Houve um errro ao carregar a lista de ' + key + '. Atualize a p\xE1gina e tente novamente');
      }).finally(function () {
        return _this.toggleLoading(key);
      });
    },
    getByCartao: function getByCartao(key) {
      if (this.numeroCartao[key]) {
        this.getLista(key);
      } else {
        this.lista[key] = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.listaOriginal[key]));
      }
    },
    getMediaEspera: function getMediaEspera() {
      var _this2 = this;

      this.toggleLoading('espera');
      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('/procedimentos-saude/' + this.tipo + '/media-dias', {
        params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.tipo, [this.termoConsulta])
      }).then(function (response) {
        var _response$data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(response.data, 1),
            first = _response$data[0];

        if (first) {
          _this2.mediaEspera = Number(first.media).toFixed(0);
        }
      }).catch(function (error) {
        _this2.$toastr.e('Houve um erro ao calcular o tempo médio para agendamento. Tente novamente mais tarde');
      }).finally(function () {
        _this2.toggleLoading('espera');
      });
    }
  },
  computed: {
    dados: function dados() {
      return this.lista;
    }
  }
});

/***/ }),

/***/ "cA2U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PorCartaoSUS_vue__ = __webpack_require__("Sw8N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c5c7fd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PorCartaoSUS_vue__ = __webpack_require__("o+Ct");
function injectStyle (ssrContext) {
  __webpack_require__("1D+Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c5c7fd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PorCartaoSUS_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c5c7fd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PorCartaoSUS_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cGMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeSpan_vue__ = __webpack_require__("t/V9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbed27d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeSpan_vue__ = __webpack_require__("LYAu");
function injectStyle (ssrContext) {
  __webpack_require__("2OzP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbed27d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeSpan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbed27d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeSpan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cGkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoverPublicacao_vue__ = __webpack_require__("xziQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b9f17c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoverPublicacao_vue__ = __webpack_require__("dAQQ");
function injectStyle (ssrContext) {
  __webpack_require__("4agJ")
  __webpack_require__("01Zv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56b9f17c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoverPublicacao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b9f17c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoverPublicacao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cLoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'print-table',
  data: function data() {
    return {
      types: [{ value: 'pdf', icon: 'file-pdf', downloadIcon: 'download' }, { value: 'csv', icon: 'file-csv', downloadIcon: 'download' }, { value: 'xls', icon: 'file-excel', downloadIcon: 'download' }]
    };
  },

  props: {
    apiUrl: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    appendParams: Object,
    title: {
      type: String,
      default: 'Listagem'
    }
  },
  methods: {
    imprimir: function imprimir(extension) {
      var appendParams = this.appendParams,
          fields = this.fields,
          apiUrl = this.apiUrl,
          title = this.title;

      var link = document.createElement('a');
      var retorno = {};
      var href = '';

      if (extension === 'csv') {
        return this.convertToCSV();
      }

      fields.filter(function (field) {
        return field.visible;
      }).forEach(function (item) {
        return retorno[item.name] = item.title;
      });

      var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(retorno) + '/' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(title);
      var token = JSON.parse(localStorage.getItem('daUser')).token;
      href = apiUrl + '/' + extension + '/' + params + '?token=' + token;

      if (appendParams) href += '&' + window.jQuery.param(appendParams);

      link.href = href;
      link.click();
    },
    convertToCSV: function convertToCSV() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var apiUrl, title, filename, token, _ref, total, response, headers, rows, csv, csvStr, downloadLink, blob, url;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiUrl = _this.apiUrl, title = _this.title;
                filename = title.replaceAll(' ', '') + '.csv';
                token = JSON.parse(localStorage.getItem('daUser')).token;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get(apiUrl + '?token=' + token + '&page=1&per_page=1');

              case 5:
                _ref = _context.sent;
                total = _ref.data.total;
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get(apiUrl + '?token=' + token + '&page=1&per_page=' + total);

              case 9:
                response = _context.sent;
                headers = _this.getHeaders();
                rows = _this.getRows(headers, response.data.data);
                csv = [headers.map(function (item) {
                  return item.title;
                }).join(';')];

                rows.forEach(function (row) {
                  return csv.push(row.join(';'));
                });

                csvStr = csv.join('\r\n');
                downloadLink = document.createElement('a');
                blob = new Blob(['\uFEFF', csvStr]);
                url = URL.createObjectURL(blob);

                downloadLink.href = url;
                downloadLink.download = filename;

                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getHeaders: function getHeaders() {
      var fields = this.fields;


      return fields.filter(function (item) {
        return item.name != '__slot:actions' && item.visible;
      }).map(function (field) {
        return field.hasOwnProperty('columnName') ? { name: field.columnName, title: field.title } : { name: field.name, title: field.title };
      });
    },
    getRows: function getRows(headers, data) {
      var rows = data.map(function (item) {
        return headers.map(function (_ref2) {
          var name = _ref2.name;

          var value = item[name];

          if (typeof value === 'boolean') {
            value = value ? 'Sim' : 'Não';
          }

          return value;
        });
      });

      return rows;
    }
  }
});

/***/ }),

/***/ "cQ3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoComplete_vue__ = __webpack_require__("W6qi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773fc536_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutoComplete_vue__ = __webpack_require__("NL3H");
function injectStyle (ssrContext) {
  __webpack_require__("okTQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoComplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773fc536_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutoComplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cTvv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Responsáveis pelos Compromissos")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"api-url":"planogoverno/compromisso","report-title":"Comptomissos do Plano de Governo","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'compromissoDetails',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar o Compromisso","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":'edit'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"custom-font"},[_vm._v("Período")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.periodo),expression:"periodo"}],staticClass:"form-control select-selected",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.periodo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.listas.periodos),function(value,index){return _c('option',{key:index,domProps:{"value":value}},[_vm._v("\n                                    "+_vm._s(value)+"\n                                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"custom-font"},[_vm._v("Unidade Executora")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'sitemap'}})],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.unidade_executora),expression:"unidade_executora"}],staticClass:"form-control select-selected",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.unidade_executora=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Todas")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Secretarias"}},_vm._l((_vm.listas.secretarias),function(s){return _c('option',{key:s.sigla,attrs:{"title":s.nome},domProps:{"value":s.sigla}},[_vm._v("\n                                            "+_vm._s(s.sigla)+"\n                                        ")])}),0),_vm._v(" "),_c('optgroup',{attrs:{"label":"Autarquias"}},_vm._l((_vm.listas.autarquias),function(a){return _c('option',{key:a.sigla,attrs:{"title":a.nome},domProps:{"value":a.sigla}},[_vm._v("\n                                            "+_vm._s(a.sigla)+"\n                                        ")])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"custom-font"},[_vm._v("Compromisso (descritivo)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.descritivo),expression:"descritivo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Pesquisar por descritivo..."},domProps:{"value":(_vm.descritivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descritivo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"custom-font"},[_vm._v("Responsável (SSHD)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.responsavel),expression:"responsavel"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Pesquisar por SSHD do responsável..."},domProps:{"value":(_vm.responsavel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.responsavel=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4",staticStyle:{"padding-top":"15px"}},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                                Filtrar\n                            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                                Limpar Filtros\n                            ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n                    ")],1)])],2)],1),_vm._v(" "),_c('SidePlanoGoverno',{ref:"side",attrs:{"navs":_vm.sideConfig},on:{"fechaModal":_vm.handleFecharModal,"salvar-edicao":_vm.salvarEdicao}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cWdo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectTime_vue__ = __webpack_require__("4u8+");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dee63ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectTime_vue__ = __webpack_require__("Bb7T");
function injectStyle (ssrContext) {
  __webpack_require__("Llmj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9dee63ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dee63ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "cWeO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_strings__ = __webpack_require__("V99r");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_3__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_3__components__["b" /* Breadcrumb */],
    DataTablePublic: __WEBPACK_IMPORTED_MODULE_3__components__["w" /* DataTablePublic */],
    CardsFiltrosSecretaria: __WEBPACK_IMPORTED_MODULE_3__components__["x" /* CardsFiltrosSecretaria */],
    SideBar: __WEBPACK_IMPORTED_MODULE_3__components__["y" /* SideModal */],
    FaixaComparacao: __WEBPACK_IMPORTED_MODULE_3__components__["z" /* FaixaComparacao */]
  },
  data: function data() {
    return {
      addDadoState: {},
      nav: {
        titulo: 'Filtros',
        subtitulo: 'Selecione as secretarias desejadas',
        subtDetalhe: '',
        largura: 1200,
        identidade: 'filtro-secretaria',
        abreProximo: true,
        aberto: false
      },
      title: 'Dados',
      filtros: {
        secretarias: [],
        autarquias: [],
        termo_pesquisa: {
          codigo: '',
          ativo: true
        }
      },
      model: {
        columnID: 'DAD_IDDADP',
        columns: [{
          name: 'nome',
          title: 'Nome',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: 'fonte',
          title: 'Fonte',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: '__slot:icon',
          title: 'Favoritos',
          titleClass: 'text-center',
          dataClass: 'align-middle text-center'
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }]
      },
      filtrosParametro: { secretarias: [] }
    };
  },
  created: function created() {
    this.formatQueryParams();
  },
  mounted: function mounted() {
    this.loadFiltros();
  },

  methods: {
    classeSelecionados: function classeSelecionados(codigo) {
      return this.addDadoState[codigo] ? ['btn-remove'] : ['btn-add'];
    },
    getPopoverContent: function getPopoverContent(codigo) {
      return this.addDadoState[codigo] ? 'Clique para remover o dado da comparação' : 'Clique para adicionar o dado para comparação';
    },
    toggleAddDado: function toggleAddDado(codigo) {
      if (this.addDadoState[codigo] === undefined) {
        this.$set(this.addDadoState, codigo, true);
      } else {
        this.addDadoState[codigo] = !this.addDadoState[codigo];
      }
    },
    abrir: function abrir() {
      this.nav.titulo = 'Filtros';
      this.$emit('abreModal', this.nav.identidade);
    },
    addFiltro: function addFiltro(codigo) {
      this.filtrosParametro.secretarias.push(codigo);
      this.$refs.dt.refresh();
    },
    removerFiltro: function removerFiltro(secretaria) {
      var filter = function filter(secr) {
        return secr !== secretaria.codigo;
      };

      this.filtrosParametro.secretarias = this.filtrosParametro.secretarias.filter(filter);

      this.$refs.dt.refresh();
    },
    formatQueryParams: function formatQueryParams() {
      var query = this.$router.history.current.query;
      var secretarias = query.secretarias,
          autarquias = query.autarquias;

      var getValues = function getValues(item) {
        return isNaN(item) ? 0 : Number(item);
      };

      if (secretarias) {
        if (Array.isArray(secretarias)) {
          return this.filtrosParametro.secretarias = secretarias.map(function (item) {
            return getValues(item);
          });
        }

        this.filtrosParametro.secretarias.push(getValues(secretarias));
      }

      if (autarquias) {
        if (Array.isArray(autarquias)) {
          return this.filtrosParametro.autarquias = autarquias.map(function (item) {
            return getValues(item);
          });
        }

        this.filtrosParametro.autarquias = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(getValues(autarquias)));
      }
    },
    loadFiltros: function loadFiltros() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('listar-filtros').then(function (_ref) {
        var data = _ref.data;
        var secretarias = data.secretarias;

        _this.filtros.secretarias = secretarias;
      }).catch(function (error) {
        var response = error.response;

        if (response) {
          console.log(response);
        }

        _this.$toastr.e('Houve um erro ao carregar os filtros. Tente novamente');
      });
    },
    salvarFavorito: function salvarFavorito(codigo) {
      var objeto = JSON.parse(localStorage.getItem('pmsdadosabertos'));

      if (objeto) {
        var index = objeto.favoritos.indexOf(codigo);
        if (index === -1) {
          objeto.favoritos.push(codigo);
        } else {
          objeto.favoritos.splice(index, 1);
        }
      } else {
        objeto = { favoritos: [codigo] };
      }

      localStorage.setItem('pmsdadosabertos', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(objeto));
      this.$refs.dt.refresh();
      this.$toastr.s('Favoritos salvos com sucesso.');
    },
    classeFavoritos: function classeFavoritos(codigo) {
      var objeto = JSON.parse(localStorage.getItem('pmsdadosabertos'));

      if (objeto && objeto.favoritos.indexOf(codigo) > -1) {
        return ['fas', 'star'];
      }

      return ['far', 'star'];
    },
    add: function add(tipo, filtro) {
      var _this2 = this;

      if (tipo !== 'termo_pesquisa') {
        filtro.ativo = true;
      } else {
        this.filtrosParametro[tipo] = null;
      }

      if (this.filtrosParametro[tipo]) {
        this.filtrosParametro[tipo].push(filtro.codigo);
      } else {
        this.filtrosParametro[tipo] = [filtro.codigo];
      }

      window.history.pushState(null, null, '?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_strings__["i" /* formatObjectToQueryString */])(this.filtrosParametro));
      this.$nextTick(function () {
        _this2.loadFiltros();
        _this2.$refs.dt.refresh();
      });
    }
  },
  computed: {
    idsArray: function idsArray() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.addDadoState).filter(function (codigo) {
        return _this3.addDadoState[codigo];
      });
    },
    secretariasFiltradas: function secretariasFiltradas() {
      var _this4 = this;

      var filter = function filter(secr) {
        return _this4.filtrosParametro.secretarias.includes(secr.codigo);
      };

      return this.filtros.secretarias.filter(filter);
    },
    secretariasNaoFiltradas: function secretariasNaoFiltradas() {
      var _this5 = this;

      var filter = function filter(secr) {
        return !_this5.filtrosParametro.secretarias.includes(secr.codigo);
      };

      return this.filtros.secretarias.filter(filter);
    }
  }
});

/***/ }),

/***/ "cbZW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationInfoMixin_vue__ = __webpack_require__("aIkI");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationInfoMixin_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cd/n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cklB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagamentos-edit"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h2',{staticClass:"page-header"},[_vm._v("Editar Pagamento")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('beneficiado') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Beneficiado")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('beneficiado') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.beneficiado),expression:"item.beneficiado"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"beneficiado",staticClass:"form-control",attrs:{"name":"beneficiado","placeholder":"Beneficiado","maxlength":"100","type":"text"},domProps:{"value":(_vm.item.beneficiado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "beneficiado", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
              'input-group-addon custom-input-group-addon-count',
              { 'is-danger': _vm.errors.has('beneficiado') }
            ],domProps:{"textContent":_vm._s(100 - _vm.item.beneficiado.length)}})]),_vm._v(" "),(_vm.errors.has('nome'))?_c('small',{staticClass:"help-block"},[_vm._v("preenchimento obrigatório!")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('data') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Data do Pagamento")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('data') }],attrs:{"icon":'calendar-alt'}})],1),_vm._v(" "),_c('datepicker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"data",attrs:{"name":"data"},model:{value:(_vm.item.data),callback:function ($$v) {_vm.$set(_vm.item, "data", $$v)},expression:"item.data"}})],1),_vm._v(" "),(_vm.errors.has('data'))?_c('small',{staticClass:"help-block"},[_vm._v("preenchimento obrigatório!")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('valor') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Valor")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('valor') }],attrs:{"icon":'money-bill'}})],1),_vm._v(" "),_c('money',_vm._b({directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"valor",staticClass:"form-control",attrs:{"name":"valor"},model:{value:(_vm.item.valor),callback:function ($$v) {_vm.$set(_vm.item, "valor", $$v)},expression:"item.valor"}},'money',_vm.money,false))],1),_vm._v(" "),(_vm.errors.has('valor'))?_c('small',{staticClass:"help-block"},[_vm._v("preenchimento obrigatório!")]):_vm._e()])]),_vm._v(" "),(_vm.cd_beneficios_periodo.includes(_vm.item.cd_beneficio))?_c('section',[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('periodoini') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Início do Período")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('periodoini') }],attrs:{"icon":'calendar-alt'}})],1),_vm._v(" "),_c('datepicker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"periodoini",attrs:{"name":"periodoini"},model:{value:(_vm.item.periodo_inicio),callback:function ($$v) {_vm.$set(_vm.item, "periodo_inicio", $$v)},expression:"item.periodo_inicio"}})],1),_vm._v(" "),(_vm.errors.has('periodoini'))?_c('small',{staticClass:"help-block"},[_vm._v("preenchimento obrigatório!")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('periodofim') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Fim do Período")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'calendar-alt'}})],1),_vm._v(" "),_c('datepicker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"periodofim",attrs:{"name":"periodofim"},model:{value:(_vm.item.periodo_fim),callback:function ($$v) {_vm.$set(_vm.item, "periodo_fim", $$v)},expression:"item.periodo_fim"}})],1),_vm._v(" "),(_vm.errors.has('periodofim'))?_c('small',{staticClass:"help-block"},[_vm._v("preenchimento obrigatório!")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('beneficio') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Benefício")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.cd_beneficio),expression:"item.cd_beneficio"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"beneficio",staticClass:"form-control",attrs:{"name":"beneficio"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.item, "cd_beneficio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.beneficios),function(item){return _c('option',{key:item.codigo,domProps:{"value":item.codigo}},[_vm._v("\n            "+_vm._s(item.sigla)+"\n          ")])}),0),_vm._v(" "),(_vm.errors.has('beneficio'))?_c('small',{staticClass:"help-block"},[_vm._v("preenchimento obrigatório!")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12 margem-topo"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){$event.preventDefault();return _vm.salvar()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n        Salvar\n      ")],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ctQb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nomeados_vue__ = __webpack_require__("w9xy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412d7587_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nomeados_vue__ = __webpack_require__("iSjT");
function injectStyle (ssrContext) {
  __webpack_require__("oKLp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-412d7587"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nomeados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_412d7587_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nomeados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d+S1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("0xDb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SideModal: __WEBPACK_IMPORTED_MODULE_0__common__["g" /* SideModal */] },
  props: {
    emenda: {
      type: Object,
      required: true
    },
    navs: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_1__utils__["e" /* formatarMoeda */],
    getProcessosPagamento: function getProcessosPagamento(processos) {
      var retorno = '';

      processos.forEach(function (processo) {
        retorno += processo.numero_pagamento + ' (' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* formatarMoeda */])(Number(processo.valor)) + ') \\';
      });

      return retorno.substring(0, retorno.length - 1);
    }
  }
});

/***/ }),

/***/ "d1yX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("MI1d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_537e4912_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("/2wR");
function injectStyle (ssrContext) {
  __webpack_require__("OlTv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-537e4912"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_537e4912_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d2cg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("/tvh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121a4e9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("dZpf");
function injectStyle (ssrContext) {
  __webpack_require__("gmZi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121a4e9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d93A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detalhe-por-vereador"},[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":'Emendas Por Vereador'}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n          Aqui você encontra as emendas parlamentares organizadas por\n          vereador.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          No ano de "),_c('SelectAnoEmendas'),_vm._v(" ,\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.vereadores.length,"isLoading":_vm.loading}}),_vm._v("\n\n          vereadores repassaram emendas paralamentares para a Prefeitura\n          Municipal de Santos, no valor total de\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.valorTotalEmendas),"isLoading":_vm.loading}}),_vm._v("\n          .\n        ")],1),_vm._v(" "),_c('p',[_vm._v("\n          Do total,\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.valorTotalUtilizado),"isLoading":_vm.loading}}),_vm._v("\n          já foram utilizados, restando um saldo total de\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.saldoTotal),"isLoading":_vm.loading}}),_vm._v("\n          .\n        ")],1)])])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.cardItems),function(item){return _c('div',{key:item.nome,staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('CardEmendas',{attrs:{"item":item}})],1)}),0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Total em emendas por vereador")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dAQQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"custom-font"},[_vm._v("Mês de Referência")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('v-select',{attrs:{"options":_vm.referencias,"reduce":function (option) { return option.value; },"selectOnTab":true},on:{"input":_vm.loadEscalas},model:{value:(_vm.referencia),callback:function ($$v) {_vm.referencia=$$v},expression:"referencia"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"custom-font"},[_vm._v("Pesquisar por palavras")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.termoPesquisa),expression:"termoPesquisa"}],staticClass:"form-control input-custom",attrs:{"type":"text"},domProps:{"value":(_vm.termoPesquisa)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.pesquisar.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.termoPesquisa=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"input-group-addon",attrs:{"href":"#"},on:{"click":_vm.pesquisar}},[_c('font-awesome-icon',{attrs:{"icon":'search'}})],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('data-table',{ref:"escalas",attrs:{"has-auth":false,"api-mode":false,"dados":_vm.escalas,"show-empty":true,"carregando":_vm.carregandoDados,"fields":_vm.datatable.columns},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Remover publicação"},on:{"click":function($event){return _vm.removerPublicacao(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}})],1)])]}}])})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dGG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row receitas"},[_c('public-header',{attrs:{"title":_vm.title}},[_c('ano-base'),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p',[_vm._v("\n        Aqui você encontra um resumo dos(as)\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v("\n        recebidas pela Prefeitura\n        Municipal de Santos.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        A Prefeitura Municipal de Santos, no ano de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.anoAtual))]),_vm._v("\n        até o mês de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.retornaMesComparativo))]),_vm._v(", \n        arrecadou de  \n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v("\n        um total de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.filtrarPorCodigo(_vm.receitaID).atual.vl_total))]),_vm._v("\n        de um orçamento estimado para este ano de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.filtrarPorCodigo(_vm.receitaID).atual.vl_atualizado))]),_vm._v(".\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p',[_c('bar-chart',{ref:"receita_mensal",attrs:{"chart-data":_vm.graficoHeader,"gradiente":false,"coloredLine":true,"options":{
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: true,
              labels: {
                fontColor: '#C1D1C1',
              },
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    suggestedMax: 50,
                    fontColor: '#C1D1C1',
                    callback: function (value, index, values) {
                      return value.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      })
                    },
                  },
                } ],
              xAxes: [
                {
                  maxBarThickness: 50,
                  ticks: {
                    fontColor: '#C1D1C1',
                  },
                } ],
            },
            tooltips: {
              callbacks: {
                label: function (tooltip, dataset) {
                  var xLabel = dataset.datasets[tooltip.datasetIndex].label
                  var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                  return xLabel + ': ' + yLabel
                },
              },
            },
          }}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_vm._l((_vm.breadcrumbLinks),function(link,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":link.url}},[_vm._v(_vm._s(link.descricao))])],1)}),_vm._v(" "),_c('li',{},[_vm._v(_vm._s(_vm.title))])],2)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('card',{attrs:{"data":_vm.dataCards}})],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Arrecadações em Destaque")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dJ9v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dLWi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dRze":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("RM09");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caf65838_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("FDGm");
function injectStyle (ssrContext) {
  __webpack_require__("P3He")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-caf65838"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caf65838_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dZPN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("hFAm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8517410e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("7wt9");
function injectStyle (ssrContext) {
  __webpack_require__("F+KH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8517410e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dZpf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"movimentos_ods"},[_c('div',{staticClass:"row"},[_c('public-header',{attrs:{"title":'Movimento ODS Santos 2030'}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{staticClass:"subheader"},[_vm._v("\n                    O Movimento ODS Santos 2030 é um coletivo entre sociedade civil organizada, iniciativa privada e administração pública e serve como ponto de partida de uma nova fase para o desenvolvimento sustentável da Cidade. Iniciativa da Prefeitura de Santos e Associação Comercial de Santos.\n                ")])])])],1),_vm._v(" "),_c('div',{staticClass:"container",staticStyle:{"padding-top":"15px"}},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',{},[_vm._v("Movimentos ODS")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"30px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table-public',{ref:"dt",attrs:{"has-auth":false,"title":"Movimentos ODS","api-url":"movimentos-ods","show-empty":true,"fields":_vm.fields,"data-path":"","paginationInfoShow":false},scopedSlots:_vm._u([{key:"icon",fn:function(props){return _vm._l((_vm.listBandeirasInfo(props.rowData.bandeiras)),function(ref){
var titulo = ref.titulo;
var img = ref.img;
return _c('img',{attrs:{"src":img,"title":titulo,"alt":titulo}})})}},{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","title":"Mais informações"},on:{"click":function($event){return _vm.maisInformacoes(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'info'}})],1)]}}])})],1)])])]),_vm._v(" "),_c('modal-movimento-info',{ref:"modalInfo"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "df1z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      required: true
    }
  }
});

/***/ }),

/***/ "doAb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filterText: '',
      fieldName: '',
      filtered: false
    };
  },

  props: {
    fields: Array
  },
  computed: {
    filterableFields: function filterableFields() {
      return this.fields.filter(function (field) {
        return field.filterable;
      });
    }
  },
  mounted: function mounted() {
    this.fieldName = this.filterableFields[0].name;
  },

  methods: {
    filtrar: function filtrar() {
      this.$events.fire('filter-set', [this.filterText, this.fieldName]);
      this.filtered = true;
    },
    limpar: function limpar() {
      this.filterText = '';
      this.filtered = false;
      this.$events.fire('filter-reset', this.fieldName);
    }
  },
  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
});

/***/ }),

/***/ "dq31":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__ = __webpack_require__("kl3E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_23911c86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__ = __webpack_require__("7SRS");
function injectStyle (ssrContext) {
  __webpack_require__("XTf4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23911c86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Vuetable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_23911c86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Vuetable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dxQL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dzCM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e20T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Remanejamento_vue__ = __webpack_require__("IeSM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7a0d15c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Remanejamento_vue__ = __webpack_require__("CiCH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Remanejamento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7a0d15c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Remanejamento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e5l/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputErrorMessage_vue__ = __webpack_require__("ZqNb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2392e85f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputErrorMessage_vue__ = __webpack_require__("Az5h");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputErrorMessage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2392e85f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputErrorMessage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eCqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-time-container"},[_c('div',{staticClass:"select-time-row"},[_c('div',{staticClass:"select-time-control"},[_c('label',{staticClass:"control-label"},[_vm._v("Horário")]),_vm._v(" "),_c('Select',{attrs:{"options":_vm.timeList,"disabled":_vm.disabled},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)]),_vm._v(" "),_c('div',{staticClass:"select-time-row"},[_c('div',{staticClass:"select-time-control"},[_c('label',{staticClass:"control-label"},[_vm._v("Entrada")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.entrada),expression:"entrada"}],ref:"entrada",staticClass:"form-control",attrs:{"type":"time","disabled":_vm.inputDisable},domProps:{"value":(_vm.entrada)},on:{"change":_vm.update,"blur":_vm.lockIfValueIsNull,"input":function($event){if($event.target.composing){ return; }_vm.entrada=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"select-time-control"},[_c('label',{staticClass:"control-label"},[_vm._v("Saida")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saida),expression:"saida"}],ref:"saida",staticClass:"form-control",attrs:{"type":"time","disabled":_vm.inputDisable},domProps:{"value":(_vm.saida)},on:{"change":_vm.update,"blur":_vm.lockIfValueIsNull,"input":function($event){if($event.target.composing){ return; }_vm.saida=$event.target.value}}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eEu7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('font-awesome-icon',{staticClass:"destaque-header",attrs:{"icon":'spinner',"spin":""}}):_c('span',{staticClass:"destaque-header"},[_vm._v("\n  "+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eFiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("NgUq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d504b68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("/QpF");
function injectStyle (ssrContext) {
  __webpack_require__("7Bwy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d504b68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d504b68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eIf4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"footer",attrs:{"id":"footer"}},[_c('div',{staticClass:"container",on:{"click":function($event){return _vm.mostraRodape()}}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-6 info-content"},[_c('div',{staticClass:"info"},[_c('p',{staticClass:"title"},[_vm._v("ERROS NO SITE?")]),_vm._v(" "),_c('address',[_c('p',[_vm._v("\n            Entre em contato através do email: "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:portaldatransparencia@santos.sp.gov.br"}},[_vm._v("\n              portaldatransparencia@santos.sp.gov.br\n            ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-6 info-content"},[_c('div',{staticClass:"info"},[_c('p',{staticClass:"title"},[_vm._v("OUVIDORIA")]),_vm._v(" "),_c('address',[_c('p',[_vm._v("\n            Paço Municipal"),_c('br'),_vm._v("\n            Praça Visconde de Mauá, s/n"),_c('br'),_vm._v("\n            Piso Térreo"),_c('br'),_vm._v("\n            Cep: 11010-900"),_c('br'),_vm._v("\n            Tel.: "),_c('a',{attrs:{"href":"tel:162"}},[_vm._v("162")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12",staticStyle:{"padding-top":"15px"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n        Prefeitura Municipal de Santos\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eKWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("bkmn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5bb2a46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Uynb");
function injectStyle (ssrContext) {
  __webpack_require__("OSaL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5bb2a46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5bb2a46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eOZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datepicker_vue__ = __webpack_require__("l+iZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2e04bde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__ = __webpack_require__("gsAe");
function injectStyle (ssrContext) {
  __webpack_require__("/829")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a2e04bde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2e04bde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eTp2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filterBar"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"input-group"},[(_vm.filterableFields.length > 1)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldName),expression:"fieldName"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fieldName=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.filterableFields),function(field){return _c('option',{domProps:{"value":field.name}},[_vm._v(_vm._s(_vm._f("capitalize")(field.title ? field.title : field.name)))])}),0):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Filtrar"},domProps:{"value":(_vm.filterText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }!_vm.filtered ? _vm.filtrar() : _vm.limpar()},"input":function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[(!_vm.filtered)?_c('button',{staticClass:"btn btn-default",on:{"click":_vm.filtrar}},[_c('span',{staticClass:"glyphicon glyphicon-search"})]):_c('button',{staticClass:"btn btn-default",on:{"click":_vm.limpar}},[_c('span',{staticClass:"glyphicon glyphicon-remove"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eTq4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eZ4i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("wM/k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af045fe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("K9io");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af045fe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ea5K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "enHs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "evUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emendas-por-ano"},[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":'Emendas do ano'}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_vm._v("\n        Aqui você encontra a lista e os detalhes de todas as emendas do ano de\n        "),_c('SelectAnoEmendas'),_vm._v(".\n      ")],1)])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Emendas de "+_vm._s(_vm.ano))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.descricao),expression:"filtros.descricao"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Digite o nome do vereador, secretaria ou descrição...","aria-placeholder":"Digite o nome do vereador, secretaria ou descrição..."},domProps:{"value":(_vm.filtros.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "descricao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-right"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.downloadToCSV()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}}),_vm._v(" Exportar para CSV\n          ")],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('DataTable',{attrs:{"dados":_vm.emendas,"fields":_vm.dataFields},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Exibir detalhes","type":"button"},on:{"click":function($event){return _vm.showDetails(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'search'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Exibir detalhes")])],1)]}}])})],1)])],1)]),_vm._v(" "),_c('SideEmendas',{ref:"side-emendas",attrs:{"navs":_vm.navs,"emenda":_vm.emenda}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f+vX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_DoughnutChart_js__ = __webpack_require__("xVH2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_DataTablePublic__ = __webpack_require__("+Mmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_entidades_js__ = __webpack_require__("Sr7P");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PlanosMunicipal',
  components: {
    doughnut: __WEBPACK_IMPORTED_MODULE_2__components_common_DoughnutChart_js__["a" /* default */],
    dataTablePublic: __WEBPACK_IMPORTED_MODULE_3__components_common_DataTablePublic__["a" /* default */],
    PublicHeader: __WEBPACK_IMPORTED_MODULE_6__components_common__["a" /* PublicHeader */]
  },
  data: function data() {
    return {
      texto: {
        'Prioridade+de+Gest%C3%A3o': {
          geral: 'metas',
          concluido: 'meta(s) concluída(s)',
          andamento: 'meta(s) em andamento',
          naoConcluido: 'meta(s) não cumprida(s)',
          analise: 'meta(s) não iniciada(s)'
        },
        'Plano+de+Governo': {
          geral: 'compromissos',
          concluido: 'compromisso(s) concluído(s)',
          andamento: 'compromisso(s) em andamento',
          naoConcluido: 'compromisso(s) não cumprido(s)',
          analise: 'compromisso(s) não iniciado(s)'
        },
        todos: {
          geral: 'metas',
          concluido: 'metas(s) concluída(s)',
          andamento: 'metas(s) em andamento',
          naoConcluido: 'metas(s) não cumprida(s)',
          analise: 'metas(s) não iniciada(s)'
        }
      },
      unidade: '',
      secretarias: [],
      tipoPlanoCodigo: '',
      tiposPlano: [],
      tipoPlanoData: {
        nome: '',
        total: 0,
        concluidoPorcentagem: 0,
        concluido: 0,
        emAndamento: 0,
        naoConcluido: 0,
        indefinido: 0,
        chartData: { labels: [], data: [] }
      },
      rankingConcluidas: [],
      rankingCompromissos: [],
      totais: {
        metas: 0,
        planogoverno: {
          total: 0,
          naoInformado: 0,
          naoConcluido: 0,
          emAndamento: 0,
          concluido: 0
        },
        prioridade: {
          total: 0,
          naoInformado: 0,
          naoConcluido: 0,
          emAndamento: 0,
          concluido: 0
        }
      },
      model: {
        por_status: {
          CONCLUÍDA: 0,
          'EM ANDAMENTO': 0,
          'NÃO INICIADA': 0,
          'NÃO CUMPRIDA': 0
        },
        por_status_secretaria: {},
        rank_compromissos: [],
        total: 0
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: true
        },
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            formatter: function formatter(value, ctx) {
              var sum = 0;
              var dataArr = ctx.chart.data.datasets[0].data;
              dataArr.map(function (data) {
                sum += data;
              });
              var percentage = (value * 100 / sum).toFixed(2) + '%';
              return percentage;
            },
            color: ['#000', '#FFF', '#000', '#FFF', '#FFF', '#FFF', '#000']
          }
        }
      },
      totalStatus: [],
      totalStatusSecretaria: []
    };
  },

  computed: {
    doughnutHeader: function doughnutHeader() {
      return this.gerarGraficoHeader(this.totalStatus);
    },
    doughnutContent: function doughnutContent() {
      return this.gerarGraficoHeader(this.totalStatusSecretaria);
    },
    doughnutTipoPlano: function doughnutTipoPlano() {
      return this.gerarChartJsDonught(this.tipoPlanoData.chartData);
    },
    link_externo: function link_externo() {
      return 'https://egov.santos.sp.gov.br/santosmapeada/Gestao/PlanoMunicipalGoverno/MapaPlanoMunicipalGoverno/montarMapaPlanoMunicipalGoverno/' + this.unidade.iduorre;
    }
  },
  methods: {
    DownloadJSON2CSV: function DownloadJSON2CSV() {
      var _this = this;

      var headers = {
        indice: ' - ',
        unidade: 'Sigla',
        nome: 'Unidade',
        total: 'Total de Metas',
        concluidas: 'Concluídas',
        percentual: 'Percentual (%)'
      };

      var items = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.rankingConcluidas.map(function (item, index) {
        return {
          indice: index + 1,
          unidade: item.unidade,
          nome: _this.entidadeBySigla(item.unidade),
          total: item.total,
          concluidas: item.concluidas,
          percentual: (item.concluidas / item.total * 100).toFixed(2).replace('.', ',')
        };
      })));

      var reducer = function reducer(acum, atual) {
        acum.total += atual.total;
        acum.concluidas += atual.concluidas;
        return acum;
      };

      var totais = this.rankingConcluidas.reduce(reducer, {
        total: 0,
        concluidas: 0
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* exportCSVFile */])(headers, [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(items), [{
        indice: ' ',
        unidade: ' ',
        nome: 'TOTAL',
        total: totais.total,
        concluidas: totais.concluidas,
        percentual: (totais.concluidas / totais.total * 100).toFixed(2).replace('.', ',')
      }]), 'ranking_conclusao');
    },
    retornaSecretaria: function retornaSecretaria(sigla) {
      var nome = '';

      switch (sigla) {
        case 'SEAS':
          nome = 'Assistência Social';
          break;
        case 'SECID':
          nome = 'Cidadania';
          break;
        case 'SERIC':
          nome = 'Relações Institucionais e Cidadania';
          break;
        case 'SEFIN':
          nome = 'Finanças';
          break;
        case 'SEDURB':
          nome = 'Desenvolvimento Urbano';
          break;
        case 'SESERP':
          nome = 'Serviços Públicos';
          break;
        case 'SETUR':
          nome = 'Turismo';
          break;
        case 'SECULT':
          nome = 'Cultura';
          break;
        case 'SEGES':
          nome = 'Gestão';
          break;
        case 'SEDUC':
          nome = 'Educação';
          break;
        case 'GPM':
          nome = 'Gabinete do Prefeito';
          break;
        case 'GVP':
          nome = 'Gabinete do Vice-Prefeito';
          break;
        case 'SEGOV':
          nome = 'Governo';
          break;
        case 'SEMAM':
          nome = 'Meio Ambiente';
          break;
        case 'SMS':
          nome = 'Saúde';
          break;
        case 'SEDES':
          nome = 'Desenvolvimento Econômico e Inovação';
          break;
        case 'SIEDI':
          nome = 'Infraestrutura e Edificações';
          break;
        case 'SECOM':
          nome = 'Comunicação';
          break;
        case 'SECOR':
          nome = 'Comunicação e Resultados';
          break;
        case 'OTC':
          nome = 'Ouvidoria Transparência e Controle';
          break;
        case 'OPM':
          nome = 'Ouvidoria Pública';
          break;
        case 'SEPORT':
          nome = 'Assuntos Portuários';
          break;
        case 'SAPIC':
          nome = 'Porto, Indústria e Comércio';
          break;
        case 'SEMES':
          nome = 'Esportes';
          break;
        case 'PGM':
          nome = 'Procuradoria';
          break;
        case 'SESEG':
          nome = 'Segurança';
          break;
        case 'FAMS-ADM':
          nome = 'Fundação Arquivo e Memória';
          break;
        case 'FPTS':
          nome = 'Fundação Parque Tecnológico';
          break;
        case 'FUPES':
          nome = 'Fundação Pró-Esporte';
          break;
        case 'SEDS':
          nome = 'Desenvolvimento Social';
          break;
        case 'SEPLAN':
          nome = 'Planejamento e Inovação';
          break;
        case 'SEECTUR':
          nome = 'Empreendedorismo, Economia Criativa e Turismo';
          break;
        case 'SAPDC':
        case 'SAPDRC':
        case 'SEPORT-RC':
          nome = 'Assuntos Portuários e Desenvolvimento da Região Central';
          break;
        default:
          nome = sigla;
          break;
      }

      return nome;
    },
    gerarGraficoHeader: function gerarGraficoHeader(dados) {
      var labels = [];
      var data = [];

      dados.forEach(function (_ref) {
        var tipostatusplano = _ref.tipostatusplano,
            total = _ref.total;

        labels.push(tipostatusplano);
        data.push(parseInt(total));
      });

      return {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__["a" /* default */].coresRGB,
          borderWidth: 0
        }]
      };
    },
    gerarChartJsDonught: function gerarChartJsDonught(_ref2) {
      var labels = _ref2.labels,
          data = _ref2.data;

      return {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: __WEBPACK_IMPORTED_MODULE_4__utils_colors_js__["a" /* default */].coresRGB,
          borderWidth: 0
        }]
      };
    },
    loadRankingConcluidas: function loadRankingConcluidas() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('planogoverno/ranking-concluidas', function (response) {
        var temp_array = response.data;

        var returnPerc = function returnPerc(value, total) {
          return value / total * 100;
        };

        var compareNsort = function compareNsort(a, b) {
          if (returnPerc(a.concluidas, a.total) < returnPerc(b.concluidas, b.total)) {
            return 1;
          }
          if (returnPerc(a.concluidas, a.total) > returnPerc(b.concluidas, b.total)) {
            return -1;
          }
          if (a.total < b.total) {
            return 1;
          }
          if (a.total > b.total) {
            return -1;
          }
          return 0;
        };
        temp_array.sort(compareNsort);

        _this2.rankingConcluidas = response.data;
      }, function (response) {
        console.log(response);
      });
    },
    loadRankingCompromissos: function loadRankingCompromissos() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('planogoverno/ranking-compromissos', function (response) {
        _this3.rankingCompromissos = response.data;
      }, function (response) {
        console.log(response);
      });
    },
    listarSecretarias: function listarSecretarias() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('sigsantos/secretarias', function (response) {
        _this4.secretarias = response.data.map(function (item) {
          return {
            iduorre: item.iduorre,
            unidaderesponsavel: _this4.entidadeBySigla(item.unidaderesponsavel)
          };
        });
      }, function (response) {
        console.log(response);
      });
    },
    totalPorTipo: function totalPorTipo() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('sigsantos/totalTipo', function (response) {
        var itens = [];

        if (response.data.map(function (_ref3) {
          var tipostatusplano = _ref3.tipostatusplano;
          return tipostatusplano;
        }).includes('NÃO INICIADA') === false) {
          itens = response.data;
        } else {
          var itemNaoIniciada = response.data.find(function (i) {
            return i.tipostatusplano === 'NÃO INICIADA';
          });
          itens = response.data.filter(function (i) {
            return i.tipostatusplano != 'NÃO INICIADA';
          });
          var indexItemNaoCumprida = itens.findIndex(function (i) {
            return i.tipostatusplano === 'NÃO CUMPRIDA';
          });

          itens[indexItemNaoCumprida].total = parseInt(itens[indexItemNaoCumprida].total) + parseInt(itemNaoIniciada.total);
        }

        _this5.totalStatus = itens;
        itens.forEach(function (_ref4) {
          var tipostatusplano = _ref4.tipostatusplano,
              total = _ref4.total;

          _this5.model.por_status[tipostatusplano] = parseInt(total);
        });

        var inicial = 0;
        _this5.model.total = itens.reduce(function (acumulador, objeto) {
          return acumulador + parseInt(objeto.total);
        }, inicial);
      }, function (error) {
        console.log(error);
      });
    },
    consultar: function consultar() {
      var _this6 = this;

      if (!this.unidade) {
        return;
      }

      this.totalStatusSecretaria = [];
      this.model.totalSecretaria = null;

      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('sigsantos/totalTipo/' + this.unidade.iduorre, function (response) {
        var itens = [];

        if (response.data.map(function (_ref5) {
          var tipostatusplano = _ref5.tipostatusplano;
          return tipostatusplano;
        }).includes('NÃO INICIADA') === false) {
          itens = response.data;
        } else {
          var itemNaoIniciada = response.data.find(function (i) {
            return i.tipostatusplano === 'NÃO INICIADA';
          });
          itens = response.data.filter(function (i) {
            return i.tipostatusplano != 'NÃO INICIADA';
          });
          var indexItemNaoCumprida = itens.findIndex(function (i) {
            return i.tipostatusplano === 'NÃO CUMPRIDA';
          });

          itens[indexItemNaoCumprida].total = parseInt(itens[indexItemNaoCumprida].total) + parseInt(itemNaoIniciada.total);
        }

        _this6.totalStatusSecretaria = itens;

        itens.forEach(function (_ref6) {
          var tipostatusplano = _ref6.tipostatusplano,
              total = _ref6.total;

          _this6.model.por_status_secretaria[tipostatusplano] = parseInt(total);
        });

        var inicial = 0;
        _this6.model.totalSecretaria = itens.reduce(function (acumulador, objeto) {
          return acumulador + parseInt(objeto.total);
        }, inicial);
      }, function (error) {
        console.log(error);
      });
    },
    loadTotais: function loadTotais() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('sigsantos/totais', function (response) {
        var planogoverno = response.planogoverno,
            prioridade = response.prioridade,
            metas = response.metas;


        planogoverno.naoConcluido += Number(planogoverno.naoInformado);
        delete planogoverno.naoInformado;

        prioridade.naoConcluido += Number(prioridade.naoInformado);
        delete prioridade.naoInformado;

        _this7.totais = { metas: metas, planogoverno: planogoverno, prioridade: prioridade };
      }, function (response) {
        console.log(response);
      });
    },
    loadTiposPlano: function loadTiposPlano() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('sigsantos/tiposplano', function (response) {
        _this8.tiposPlano = [{ codigo: 'todos', nome: 'Todos' }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response));
        _this8.tipoPlanoCodigo = _this8.tiposPlano[0].codigo;
        _this8.getTipoPlanoData();
      }, function (response) {
        console.log(response);
      });
    },
    getTipoPlanoData: function getTipoPlanoData() {
      var _this9 = this;

      if (!this.tipoPlanoCodigo) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('sigsantos/totalTipoPlano/' + this.tipoPlanoCodigo, function (response) {
        // concatenar não cumprida com não iniciada
        if (response.indefinido > 0) {
          var _response$chartData = response.chartData,
              labels = _response$chartData.labels,
              data = _response$chartData.data;

          var index = labels.findIndex(function (i) {
            return i === 'NÃO INICIADA';
          });

          labels.splice(index, 1);
          data.splice(index, 1);

          response.chartData = { labels: labels, data: data };
          response.naoConcluido += parseInt(response.indefinido);
        }
        delete response.indefinido;

        _this9.tipoPlanoData = response;
      }, function (error) {
        return console.log(error);
      });
    },

    entidadeBySigla: __WEBPACK_IMPORTED_MODULE_7__utils_entidades_js__["a" /* entidadeBySigla */]
  },
  mounted: function mounted() {
    var _this10 = this;

    __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].get('sigsantos/rankCompromissos', function (response) {
      _this10.model.rank_compromissos = response.data;
    }, function (response) {
      console.log(response);
    });

    this.totalPorTipo();
    this.loadRankingConcluidas();
    this.listarSecretarias();
    this.loadTotais();
    this.loadTiposPlano();
  }
});

/***/ }),

/***/ "f/CB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Calendar_SelectScaleType__ = __webpack_require__("bIuM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Calendar_SelectTime__ = __webpack_require__("XJ9K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Calendar_TimeSpan__ = __webpack_require__("cGMz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Calendar_TimeCell__ = __webpack_require__("4atV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_times__ = __webpack_require__("0Btv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_strings__ = __webpack_require__("V99r");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SelectScaleType: __WEBPACK_IMPORTED_MODULE_3__components_Calendar_SelectScaleType__["a" /* default */],
    SelectTime: __WEBPACK_IMPORTED_MODULE_4__components_Calendar_SelectTime__["a" /* default */],
    TimeSpan: __WEBPACK_IMPORTED_MODULE_5__components_Calendar_TimeSpan__["a" /* default */],
    TimeCell: __WEBPACK_IMPORTED_MODULE_6__components_Calendar_TimeCell__["a" /* default */]
  },
  props: {
    language: {
      type: String,
      default: 'pt-BR'
    },
    firstWeekday: {
      type: Number,
      default: 1
    },
    value: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    referencia: {
      type: String,
      required: true
    }
  },
  mounted: function mounted() {
    this.generateCelsWeekday();
    this.generateAvaliableDates();
    this.generateCels();
    this.fillDaysInCels();
  },
  data: function data() {
    return {
      scaleType: '',
      time: { entrada: '', saida: '' },
      weekdays: [],
      avaliableDates: [],
      cels: [],
      daySelected: {
        isEmpty: true,
        day: '',
        timeToAdd: { entrada: '', saida: '' },
        times: []
      }
    };
  },

  computed: {
    weekdayOrdered: function weekdayOrdered() {
      var _this = this;

      var list = [];
      var sufix = [];

      this.weekdays.forEach(function (i) {
        if (i.number >= _this.firstWeekday) {
          list.push(i);
        } else {
          sufix.push(i);
        }
      });

      return [].concat(list, sufix);
    },
    hasTimeEntrada: function hasTimeEntrada() {
      var entrada = this.time.entrada;

      return entrada !== '';
    },
    hasTimeSaida: function hasTimeSaida() {
      var saida = this.time.saida;

      return saida !== '';
    },
    hasTime: function hasTime() {
      return this.hasTimeEntrada || this.hasTimeSaida;
    },
    totalDaysActive: function totalDaysActive() {
      return this.cels.filter(function (c) {
        return c.active;
      }).length;
    }
  },
  watch: {
    referencia: function referencia() {
      this.generateAvaliableDates();
      this.generateCels();
      this.fillDaysInCels();
      this.resetControls();
      this.update();
    },
    scaleType: function scaleType(value) {
      this.generateCels();
      this.fillDaysInCels();
      this.resetTime();
      this.generateScale(value);

      this.weekdays.forEach(function (cell) {
        return cell.avaliable = value === '*';
      });

      // if (this.hasTime) {
      //   this.setTimeInCells(this.time)
      // }
    },

    time: {
      handler: function handler(value) {
        // this.resetDays()
        this.generateScale(this.scaleType);
        this.setTimeInCells(value);
        this.update();
      },

      deep: true
    },
    totalDaysActive: function totalDaysActive(value) {
      if (this.hasTime && value > 0) {
        this.update();
      }
    },
    disabled: function disabled(value) {
      var _this2 = this;

      this.weekdays.forEach(function (cell) {
        return cell.avaliable = !value;
      });

      var _avaliableDates = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(this.avaliableDates, 1),
          weekdayStart = _avaliableDates[0].weekday;

      var startIndex = this.cels.findIndex(function (_ref) {
        var weekday = _ref.weekday;
        return weekday === weekdayStart;
      });

      var index = startIndex;
      this.avaliableDates.forEach(function (_ref2) {
        var date = _ref2.date;

        var cell = _this2.cels[index++];
        cell.isAvaliable = !value;
      });
    }
  },
  methods: {
    generateAvaliableDates: function generateAvaliableDates() {
      var referencia = !this.referencia ? this.getReferenciaDefault() : this.referencia;

      var year = referencia.substr(0, 4);
      var month = referencia.substr(-2);
      var end = new Date(year, month - 1, 25);
      var start = new Date(end.getTime());
      this.avaliableDates = [];

      start.setMonth(start.getMonth() - 1);
      start.setDate(26);

      var seek = new Date(start.getTime());
      seek.setHours(0);

      do {
        var date = new Date(seek.getTime());
        this.avaliableDates.push({
          date: date,
          weekday: date.getDay(),
          month: date.getMonth()
        });
        seek.setDate(seek.getDate() + 1);
      } while (seek <= end);
    },
    getReferenciaDefault: function getReferenciaDefault() {
      var dateDefault = new Date();
      dateDefault.setMonth(dateDefault.getMonth() + 1);
      var year = dateDefault.toLocaleString("pt-BR", { year: 'numeric' });
      var month = dateDefault.toLocaleString("pt-BR", { month: "2-digit" });

      return '' + year + month;
    },
    generateCelsWeekday: function generateCelsWeekday() {
      for (var number = 0; number < 7; number++) {
        this.weekdays.push({
          label: this.getWeekdayLabelBy(number),
          number: number,
          avaliable: false,
          active: false,
          selected: false
        });
      }
    },
    generateCels: function generateCels() {
      var _avaliableDates2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(this.avaliableDates, 1),
          startWeekday = _avaliableDates2[0].weekday;

      var datesLength = this.avaliableDates.length;
      var lenghtCels = 35;

      if (startWeekday === 6 && datesLength > 30 || startWeekday === 0 && datesLength > 29) {
        lenghtCels = 42;
      }

      this.cels = [];
      for (var index = 0; index < lenghtCels; index++) {
        var weekday = this.weekdayOrdered[index % 7].number;
        this.cels.push({
          key: index + 7,
          day: '',
          month: '',
          year: '',
          yearMonth: '',
          weekday: weekday,
          isEven: false,
          isOdd: false,
          isWeekend: weekday === 6 || weekday === 0,
          isAvaliable: false,
          active: false,
          selected: false,
          info: '',
          times: this.hasTime ? [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.time)) : []
        });
      }
    },
    fillDaysInCels: function fillDaysInCels() {
      var _this3 = this;

      var _avaliableDates3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(this.avaliableDates, 1),
          weekdayStart = _avaliableDates3[0].weekday;

      var startIndex = this.cels.findIndex(function (_ref3) {
        var weekday = _ref3.weekday;
        return weekday === weekdayStart;
      });

      var index = startIndex;
      this.avaliableDates.forEach(function (_ref4) {
        var date = _ref4.date;

        var cell = _this3.cels[index++];
        _this3.fillDayInCel(cell, date);
      });
    },
    fillDayInCel: function fillDayInCel(cell, date) {
      var day = date.getDate();
      var isEven = date.getDate() % 2 === 0;

      cell.date = date;
      cell.day = day;
      cell.month = date.getMonth();
      cell.year = date.getFullYear(), cell.yearMonth = parseInt('' + date.getFullYear() + date.toLocaleDateString("PT-br", { month: '2-digit' }));
      cell.isEven = isEven;
      cell.isOdd = !isEven;
      cell.isAvaliable = true;
    },
    getWeekdayLabelBy: function getWeekdayLabelBy(weekdayNumber) {
      var date = new Date(2006, 0, 1);
      date.setDate(date.getDate() + weekdayNumber);

      return date.toLocaleString(this.language, { weekday: 'short' }).toUpperCase().replace('.', '');
    },
    deactivateCells: function deactivateCells() {
      for (var index = 0; index < this.weekdays.length; index++) {
        this.weekdays[index].active = false;
        this.weekdays[index].selected = false;
      }
      for (var _index = 0; _index < this.cels.length; _index++) {
        this.cels[_index].active = false;
        this.cels[_index].selected = false;
      }
    },
    generateScale: function generateScale(type) {
      this.deactivateCells();

      switch (type) {
        case 'adm':
          this.generateScaleAdm();
          break;
        case 'par':
        case 'impar':
          this.generateScalePlantao(type);
          break;
        default:
          this.$toastr.s('Para plantão fixo clique no dia da semana para selecionar todos!');
          break;
      }
    },
    generateScaleAdm: function generateScaleAdm() {
      var cells = this.cels.filter(function (c) {
        return c.isAvaliable && !c.isWeekend;
      });
      for (var index = 0; index < cells.length; index++) {
        cells[index].active = true;
      }
    },
    generateScalePlantao: function generateScalePlantao(type) {
      var cellsAvaliable = this.cels.filter(function (c) {
        return c.isAvaliable;
      });
      var condicao = type === 'par' ? 0 : 1;

      // criando os indices das celulas que serão ativadas de acordo com a condição se é par ou impar
      var indexes = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Array(cellsAvaliable.length).keys())).filter(function (k) {
        return k % 2 === condicao;
      });

      indexes.forEach(function (i) {
        return cellsAvaliable[i].active = true;
      });
    },
    activeCellByWeekday: function activeCellByWeekday(celWeekday) {
      var _this4 = this;

      var activeValue = !celWeekday.active;

      // 1 caminhos ativar as celulas OK
      if (activeValue) {
        switch (this.getTimeType(this.time)) {
          // 1.1 ativar celulas com horarios normais OK
          case 'leaveOnDay':
            var cells = this.getCellsAvaliableByWeekday(celWeekday.number);
            cells.forEach(function (cell) {
              cell.active = true;
              cell.times = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this4.time)];
            });
            celWeekday.active = true;
            break;
          // 1.2 ativar celulas com horarios de saida no proximo dia OK
          case 'leaveOnNextDay':
            // 1.2.1 verificação se o dia da semana é o ultimo
            if (this.isLastWeekDay(celWeekday.number)) {
              // 1.2.1.1 se for não ativa e envia uma mensagem dizendo que para o horario de saida no próximo dia
              // não é possivel selecionar o ultimo dia da semana
              this.$toastr.e('Não é possivel selecionar o ultimo dia da semana para adicionar horário com saida no proxímo dia!');
              return;
            }

            var cellsTimeIn = this.getCellsAvaliableByWeekday(celWeekday.number);

            var celWeekdayNextIndex = celWeekday.number === 6 ? 0 : celWeekday.number + 1;
            var celWeekdayNext = this.weekdays.find(function (_ref5) {
              var number = _ref5.number;
              return number === celWeekdayNextIndex;
            });
            var cellsTimeOut = this.getCellsAvaliableByWeekday(celWeekdayNext.number);

            cellsTimeIn.forEach(function (cell) {
              cell.active = true;
              cell.times = [{ entrada: _this4.time.entrada, saida: '' }];
            });

            cellsTimeOut.forEach(function (cell) {
              cell.active = true;
              cell.times = [{ entrada: '', saida: _this4.time.saida }];
            });

            celWeekday.active = true;
            celWeekdayNext.active = true;
            break;
          default:
            break;
        }
      }
      // 2 desativar celulas
      else {
          switch (this.getTimeType(this.time)) {
            // 2.1 desativar celulas com horarios normais OK
            case 'leaveOnDay':
              var _cells = this.getCellsAvaliableByWeekday(celWeekday.number);
              _cells.forEach(function (cell) {
                cell.active = false;
                cell.times = [];
              });
              celWeekday.active = false;
              break;
            // 2.1 desativar celulas com horarios de saida no proximo dia
            case 'leaveOnNextDay':
              var cells2 = this.getCellsAvaliableByWeekday(celWeekday.number);
              var time = cells2[0].times.find(function (_ref6) {
                var entrada = _ref6.entrada,
                    saida = _ref6.saida;
                return _this4.time.entrada === entrada || _this4.time.saida === saida;
              });
              // criando uma lista de index da weekday para poder navegar entre as colunas calendário
              var weekdayIndexes = [];
              for (var i = this.firstWeekday; i < this.weekdays.length; i++) {
                weekdayIndexes.push(this.weekdays[i].number);
              }

              // verificando a diferença entre os dois arrays
              var lastWeekday = this.weekdays.find(function (_ref7) {
                var number = _ref7.number;
                return !weekdayIndexes.includes(number);
              });
              weekdayIndexes.push(lastWeekday.number);

              var currentIndex = weekdayIndexes.findIndex(function (index) {
                return index === celWeekday.number;
              });
              var _celWeekdayNext = {};

              if (this.getTimeType(time) === 'timeIn') {
                _celWeekdayNext = this.weekdays[weekdayIndexes[currentIndex + 1]];
              } else {
                _celWeekdayNext = this.weekdays[weekdayIndexes[currentIndex - 1]];
              }

              var cellsNext = this.getCellsAvaliableByWeekday(_celWeekdayNext.number);

              cells2.forEach(function (cell) {
                cell.active = false;
                cell.times = [];
              });

              cellsNext.forEach(function (cell) {
                cell.active = false;
                cell.times = [];
              });

              celWeekday.active = false;
              _celWeekdayNext.active = false;
              break;
            default:
              break;
          }
        }
    },
    getCellsAvaliableByWeekday: function getCellsAvaliableByWeekday(weekday) {
      return this.cels.filter(function (cell) {
        return cell.isAvaliable && cell.weekday === weekday;
      });
    },
    isLastWeekDay: function isLastWeekDay(weekday) {
      var lastWeekday = this.firstWeekday === 0 ? 6 : this.firstWeekday - 1;
      return weekday === lastWeekday;
    },
    selectDay: function selectDay(cel) {
      var selected = cel.selected;

      this.deselectAllCells();

      // deselecionar
      if (selected) {
        cel.selected = false;
        cel.active = false;
        cel.times = [];
      }
      // selecionar
      else {
          cel.active = true;
          cel.selected = true;

          if (this.headerAvailableSelection) {
            cel.times = [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.time)];
          }

          this.daySelected.day = cel.day;
          this.daySelected.times = cel.times;
        }
      this.daySelected.isEmpty = selected;
    },
    resetDays: function resetDays() {
      this.resetDaysActived();
      this.resetDaySelected();
    },
    resetDaysActived: function resetDaysActived() {
      this.cels.filter(function (_ref8) {
        var active = _ref8.active;
        return active;
      }).forEach(function (item) {
        return item.active = false;
      });
    },
    resetDaySelected: function resetDaySelected() {
      this.cels.filter(function (_ref9) {
        var selected = _ref9.selected;
        return selected;
      }).forEach(function (item) {
        return item.selected = false;
      });
      this.daySelected = {
        isEmpty: true,
        day: '',
        timeToAdd: { entrada: '', saida: '' },
        times: []
      };
    },
    deselectAllCells: function deselectAllCells() {
      var cellsSelected = this.cels.filter(function (c) {
        return c.selected;
      });
      cellsSelected.forEach(function (c) {
        return c.selected = false;
      });
    },
    resetControls: function resetControls() {
      this.scaleType = '';
      this.resetTime();
    },
    resetTime: function resetTime() {
      this.time.entrada = '';
      this.time.saida = '';
    },
    setTimeInCells: function setTimeInCells(time) {
      switch (this.getTimeType(time)) {
        case 'leaveOnDay':
          this.setTimeLeaveOnDayInCells(time);
          break;
        case 'leaveOnNextDay':
          this.setTimeLeaveOnNextDayInCells(time);
          break;
        default:
          break;
      }
    },
    getTimeType: function getTimeType(_ref10) {
      var entrada = _ref10.entrada,
          saida = _ref10.saida;

      if (entrada === '' && saida === '') return '';
      if (entrada === '') return 'timeOut';
      if (saida === '') return 'timeIn';

      var entradaNumber = parseInt(entrada.replace(/\D/, ''));
      var saidaNumber = parseInt(saida.replace(/\D/, ''));

      if (entradaNumber < saidaNumber) return 'leaveOnDay';
      if (entradaNumber >= saidaNumber) return 'leaveOnNextDay';
    },
    setTimeLeaveOnDayInCells: function setTimeLeaveOnDayInCells(_ref11) {
      var entrada = _ref11.entrada,
          saida = _ref11.saida;

      if (entrada === '' || saida === '') return;

      var cellsActives = this.cels.filter(function (_ref12) {
        var active = _ref12.active;
        return active;
      });
      cellsActives.forEach(function (cel) {
        cel.times = [{ entrada: entrada, saida: saida }];
      });
    },
    setTimeLeaveOnNextDayInCells: function setTimeLeaveOnNextDayInCells(_ref13) {
      var _this5 = this;

      var entrada = _ref13.entrada,
          saida = _ref13.saida;

      var indexes = this.cels.map(function (_ref14, index) {
        var active = _ref14.active;
        return { index: index, active: active };
      }).filter(function (item) {
        return item.active;
      }).map(function (_ref15) {
        var index = _ref15.index;
        return index;
      });

      if (indexes.length > 0) {
        var _avaliableDates$rever = this.avaliableDates.reverse(),
            _avaliableDates$rever2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_avaliableDates$rever, 1),
            lastAvailableDate = _avaliableDates$rever2[0];

        indexes.forEach(function (index) {
          // verificar se é o ultimo dia da escala
          if (lastAvailableDate.date === _this5.cels[index].date) {
            // se for ignora a saida do próximo dia e adiciona no mesmo dia o ultimo horário
            _this5.cels[index].times = [{ entrada: entrada, saida: '' }];

            var nextDate = new Date(_this5.cels[index].date);
            nextDate.setDate(nextDate.getDate() + 1);

            _this5.fillDayInCel(_this5.cels[index + 1], nextDate);

            _this5.cels[index + 1].times = [{ entrada: '', saida: saida }];
            _this5.cels[index + 1].active = true;
            _this5.cels[index + 1].referencia = _this5.nextReferencia;
          } else {
            // se não for adiciona a saida no próximo dia
            _this5.cels[index].times = [{ entrada: entrada, saida: '' }];
            _this5.cels[index + 1].times = [{ entrada: '', saida: saida }];
            _this5.cels[index + 1].active = true;
          }
        });
      }
    },
    addTime: function addTime() {
      var _daySelected = this.daySelected,
          day = _daySelected.day,
          timeToAdd = _daySelected.timeToAdd;

      var lastIndex = this.avaliableDates.length - 1;
      var lastAvailableDate = this.avaliableDates[lastIndex];

      timeToAdd.entrada = this.formatTime(timeToAdd.entrada);
      timeToAdd.saida = this.formatTime(timeToAdd.saida);

      // verifica se o dia selecionado é o ultimo da escala
      if (lastAvailableDate.date.getDate() === day) {
        // se for mudar a saida do time para as 23h59
        var _daySelected$timeToAd = this.daySelected.timeToAdd,
            entrada = _daySelected$timeToAd.entrada,
            saida = _daySelected$timeToAd.saida;


        if (saida < entrada) {
          this.daySelected.timeToAdd.saida = '23:59';
        }

        this.addTimeLeaveOnDay();
        return;
      }

      switch (this.getTimeType(timeToAdd)) {
        case 'leaveOnDay':
          this.addTimeLeaveOnDay();
          break;
        case 'leaveOnNextDay':
          this.addTimeLeaveOnNextDay();
          break;
        default:
          break;
      }
    },
    formatTime: function formatTime(time) {
      if (time.length === 0) {
        return time;
      }

      if (time.length === 2) {
        return time + 'h00';
      }

      return time;
    },
    addTimeLeaveOnDay: function addTimeLeaveOnDay() {
      var _daySelected2 = this.daySelected,
          timeToAdd = _daySelected2.timeToAdd,
          times = _daySelected2.times;


      if (this.validTime(timeToAdd)) {
        this.daySelected.times.push(timeToAdd);
        this.daySelected.timeToAdd = { entrada: '', saida: '' };
        this.update();
      } else {
        this.$toastr.e('Esse período é inválido, verifique se há algum conflito!');
      }
    },
    addTimeLeaveOnNextDay: function addTimeLeaveOnNextDay() {
      var _daySelected3 = this.daySelected,
          day = _daySelected3.day,
          timeToAdd = _daySelected3.timeToAdd;

      var timeIn = { entrada: timeToAdd.entrada, saida: '' };
      var timeOut = { entrada: '', saida: timeToAdd.saida };
      var cellIn = this.cels.find(function (cell) {
        return cell.day === day;
      });
      var cellNextIndex = this.cels.findIndex(function (cell) {
        return cell.key === cellIn.key + 1;
      });

      var timesIn = cellIn.times;
      if (!this.validTime(timeIn, timesIn)) {
        this.$toastr.e('Esse per\xEDodo \xE9 inv\xE1lido, verifique se h\xE1 algum conflito no dia ' + cellIn.day + '!');
        return;
      }

      var timesOut = this.cels[cellNextIndex].times;
      if (!this.validTime(timeOut, timesOut)) {
        this.$toastr.e('Esse per\xEDodo \xE9 inv\xE1lido, verifique se h\xE1 algum conflito no dia ' + this.cels[cellNextIndex].day + '!');
      }

      // add time
      this.daySelected.times.push(timeIn);
      this.cels[cellNextIndex].times.push(timeOut);

      this.cels[cellNextIndex].active = true;
      this.daySelected.timeToAdd = { entrada: '', saida: '' };

      this.update();
    },
    activeCell: function activeCell(index, date) {
      this.fillDayInCel(this.cels[index], date);
      this.cels[index].isAvaliable = true;
      this.cels[index].active = true;
    },
    removeTime: function removeTime(index) {
      this.daySelected.times.splice(index, 1);
      this.update();
    },
    validTime: function validTime(time, times) {
      var isValid = true;

      if (!times) {
        times = this.daySelected.times;
      }

      var timeNew = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_times__["c" /* parseTimeToInt */])(time);

      var index = 0;
      while (isValid && index < times.length) {
        var _time = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_times__["c" /* parseTimeToInt */])(times[index++]);
        var timeIsBefore = false;
        var timeIsAfter = false;

        // verificar se o time é anterior
        if (typeof timeNew.saida === 'number' && typeof _time.entrada === 'number') {
          timeIsBefore = timeNew.saida <= _time.entrada;
        }

        // verificar se o time é posterior
        if (typeof timeNew.entrada === 'number' && typeof _time.saida === 'number') {
          timeIsAfter = timeNew.entrada >= _time.saida;
        }

        isValid = timeIsBefore || timeIsAfter;
      }

      return isValid;
    },
    update: function update() {
      var cels = this.cels,
          refBase = this.referencia;

      // only days active and that contains times

      var dates = cels.filter(function (_ref16) {
        var isAvaliable = _ref16.isAvaliable;
        return isAvaliable;
      }).map(function (_ref17) {
        var date = _ref17.date,
            refDay = _ref17.referencia,
            times = _ref17.times,
            active = _ref17.active,
            selected = _ref17.selected;
        return {
          date: date,
          times: times,
          active: active,
          selected: selected,
          referencia: !!refDay ? refDay : refBase
        };
      });

      this.$emit('input', { referencia: refBase, dates: dates });
    }
  }
});

/***/ }),

/***/ "f0y4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__);





var getters = {
  getSecretarias: function getSecretarias(_ref) {
    var compromissos = _ref.compromissos;

    var secretarias = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();

    compromissos.forEach(function (element) {
      secretarias.set(element.unidade_executora, {
        sigla: element.unidade_executora,
        nome: element.nome_unidade_executora
      });
    });

    var sortedSecretarias = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(secretarias.values()).sort(function (a, b) {
      return a.nome.localeCompare(b.nome);
    });

    return sortedSecretarias;
  },
  getTotalCompromissosPorSecretaria: function getTotalCompromissosPorSecretaria(_ref2) {
    var compromissos = _ref2.compromissos;

    var reducer = function reducer(acum, compr) {
      var sigla = compr.unidade_executora;
      var nome = compr.nome_unidade_executora;

      if (!acum[sigla]) {
        acum[sigla] = {
          nome: nome,
          total: 0
        };
      }

      acum[sigla].total++;

      return acum;
    };

    var totaisPorSecretaria = compromissos.reduce(reducer, {});
    var sortedObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(totaisPorSecretaria).sort(function (a, b) {
      return b[1].total - a[1].total;
    });

    return sortedObject.map(function (_ref3) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          sigla = _ref4[0],
          dados = _ref4[1];

      return {
        sigla: sigla,
        nome: dados.nome,
        total: dados.total
      };
    });
  },
  getTotalCompromissosPorStatus: function getTotalCompromissosPorStatus(_ref5) {
    var compromissos = _ref5.compromissos;

    var reducer = function reducer(acum, compr) {
      var status = compr.status;

      if (!acum[status]) {
        acum[status] = 0;
      }

      acum[status]++;

      return acum;
    };

    var totaisPorStatus = compromissos.reduce(reducer, {});
    var sortedObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(totaisPorStatus).sort(function (a, b) {
      return b[1] - a[1];
    });

    return sortedObject.map(function (_ref6) {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref6, 2),
          status = _ref7[0],
          total = _ref7[1];

      return {
        status: status,
        total: total
      };
    });
  },
  getSecretariasComResumo: function getSecretariasComResumo(_ref8) {
    var compromissos = _ref8.compromissos;

    var unidades = {};

    compromissos.forEach(function (compr) {
      var sigla = compr.unidade_executora;

      if (!unidades[sigla]) {
        unidades[sigla] = {
          sigla: sigla,
          nome: compr.nome_unidade_executora,
          total: 0,
          concluido: 0,
          emAndamento: 0,
          naoIniciado: 0,
          cancelado: 0,
          percentual: 0
        };
      }

      unidades[sigla].total++;
      if (compr.status === 'Concluído') unidades[sigla].concluido++;
      if (compr.status === 'Em andamento') unidades[sigla].emAndamento++;
      if (compr.status === 'Não Iniciado') unidades[sigla].naoIniciado++;
      if (compr.status === 'Cancelado') unidades[sigla].cancelado++;
    });

    var arrayUnidades = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(unidades);

    arrayUnidades.forEach(function (unidade) {
      var total = unidade.total - unidade.cancelado;

      if (total > 0) {
        unidade.percentual = Math.round(unidade.concluido / total * 100);
      }
    });

    return arrayUnidades.sort(function (a, b) {
      return a.nome.localeCompare(b.nome);
    });
  }
};

/***/ }),

/***/ "fApd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fBmq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fEej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"header-action"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_c('font-awesome-icon',{attrs:{"icon":'check'}}),_vm._v("\n        Homologar\n      ")],1)]),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v("\n      Editar Compromisso\n      "),_c('span',{staticClass:"status",class:_vm.statusClass(_vm.model.status)},[_vm._v("\n        "+_vm._s(_vm.model.status)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Período")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'calendar-alt'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.periodo),expression:"model.periodo"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.model.periodo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "periodo", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Funcionário Responsável")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'user'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.responsavel_sshd),expression:"model.responsavel_sshd"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.model.responsavel_sshd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "responsavel_sshd", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('unidade') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Unidade")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'sitemap'}})],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.unidade_executora),expression:"model.unidade_executora"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"unidade",staticClass:"form-control select-selected",attrs:{"name":"unidade"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "unidade_executora", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selecione a unidade")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Secretarias"}},_vm._l((_vm.listas.secretarias),function(s){return _c('option',{key:s.sigla,attrs:{"title":s.nome},domProps:{"value":s.sigla}},[_vm._v("\n                      "+_vm._s(s.sigla)+"\n                    ")])}),0),_vm._v(" "),_c('optgroup',{attrs:{"label":"Autarquias"}},_vm._l((_vm.listas.autarquias),function(a){return _c('option',{key:a.sigla,attrs:{"title":a.nome},domProps:{"value":a.sigla}},[_vm._v("\n                      "+_vm._s(a.sigla)+"\n                    ")])}),0)])]),_vm._v(" "),(_vm.errors.has('unidade'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"unidade"}},[_vm._v("Preenchimento obrigatório!\n              ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('titulo') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Título")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'tags'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.titulo),expression:"model.titulo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"titulo",staticClass:"form-control",attrs:{"type":"text","name":"titulo","placeholder":"Título","disabled":"","maxlength":"255"},domProps:{"value":(_vm.model.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "titulo", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(255 - _vm.model.titulo.length)}})]),_vm._v(" "),(_vm.errors.has('titulo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"titulo"}},[_vm._v("Preenchimento obrigatório!\n              ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('descricao') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Descrição")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'comment'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"descricao",staticClass:"form-control",attrs:{"name":"descricao","disabled":"","placeholder":"Descreva o compromisso...","maxlength":"1000","rows":"8"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(1000 - _vm.model.descricao.length)}})]),_vm._v(" "),(_vm.errors.has('descricao'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"descricao"}},[_vm._v("Preenchimento obrigatório!\n              ")]):_vm._e()])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fEnf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("oO9a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a42c41f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("MWZs");
function injectStyle (ssrContext) {
  __webpack_require__("YYs8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a42c41f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a42c41f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fIhQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fa7C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    idsArray: {
      type: Array
    },
    query: {
      type: String
    }
  },
  computed: {
    selectedCount: function selectedCount() {
      return this.idsArray.length;
    }
  }
});

/***/ }),

/***/ "fc38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("OlJP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127c83bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Pmya");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127c83bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fizg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common___ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_DataTablePublic__ = __webpack_require__("+Mmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_strings__ = __webpack_require__("V99r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PublicHeader: __WEBPACK_IMPORTED_MODULE_3__components_common___["a" /* PublicHeader */], BarChart: __WEBPACK_IMPORTED_MODULE_3__components_common___["d" /* BarChart */], DataTable: __WEBPACK_IMPORTED_MODULE_4__components_common_DataTablePublic__["a" /* default */] },
  data: function data() {
    var _ref;

    return _ref = {
      meses: __WEBPACK_IMPORTED_MODULE_5__utils_strings__["j" /* mesesExt */],
      grafico_base: { labels: [], datasets: [{ label: '', data: [] }] },
      beneficio: {},
      total_mes: [],
      total_ano: { total: 0, valor: 0 },
      pagamentos: []
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'meses', __WEBPACK_IMPORTED_MODULE_5__utils_strings__["j" /* mesesExt */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'filtros', {
      nome: '',
      ano: '',
      mes: '',
      beneficio: ''
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'fields', [{
      name: 'data',
      title: 'Data',
      callback: function callback(value) {
        return new Date('' + value).toLocaleDateString();
      }
    }, {
      name: 'beneficiado',
      title: 'Nome'
    }, {
      name: 'beneficio.sigla',
      title: 'Benefício'
    }, {
      name: '__slot:column',
      title: 'Período'
    }, {
      name: 'valor',
      title: 'Valor',
      titleClass: 'text-right',
      dataClass: 'text-right',
      callback: function callback(value) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_strings__["b" /* formatarMoeda */])(Number(value));
      }
    }]), _ref;
  },
  beforeMount: function beforeMount() {
    var _$route$params = this.$route.params,
        item = _$route$params.item,
        sigla = _$route$params.sigla;

    this.filtros.ano = this.ano_base;

    if (item) {
      this.beneficio = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item);
      this.filtros.beneficio = this.beneficio.codigo;
    } else {
      this.carregaBeneficio(sigla);
    }
  },
  created: function created() {
    var sigla = this.$route.params.sigla;

    this.carregaPagamentos(sigla);
  },

  methods: {
    retornarPeriodo: function retornarPeriodo(props) {
      if (props.periodo_inicio && props.periodo_fim) {
        return 'de ' + new Date(props.periodo_inicio).toLocaleDateString() + '\n                \xE0 ' + new Date(props.periodo_fim).toLocaleDateString();
      }

      return '_________';
    },

    formatarMoeda: __WEBPACK_IMPORTED_MODULE_5__utils_strings__["b" /* formatarMoeda */],
    carregaBeneficio: function carregaBeneficio(sigla) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('/assistencia/listar-beneficios').then(function (response) {
        var data = response.data;


        var filter = function filter(item) {
          return item.sigla === sigla;
        };

        _this.beneficio = _.first(data.filter(filter));
        _this.filtros.beneficio = _this.beneficio.codigo;

        _this.$refs.dt.refresh();
      }).catch(function (error) {
        var data = error.response.data;

        _this.$toastr.e('Houve um erro ao carregar a lista de benefícios. Atualize a página e, caso o problema persista, contate o administrador.');
        console.log(data.msg);
      });
    },
    carregaPagamentos: function carregaPagamentos(sigla) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('assistencia/pagamentos-mes/' + this.ano_base + '/' + sigla).then(function (response) {
        var data = response.data;

        _this2.total_mes = data;
      }).catch(function (error) {
        var data = error.response.data;

        _this2.$toastr.e('Houve um erro ao carregar a lista de pagamentos. Atualize a página e, caso o problema persista, contate o administrador.');
      });

      __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('/assistencia/pagamentos-ano/' + this.ano_base).then(function (response) {
        var data = response.data;

        var filter = function filter(item) {
          return item.beneficio === sigla;
        };

        var total = _.first(data.filter(filter));

        if (total) {
          _this2.total_ano = total;
        }
      }).catch(function (error) {
        var data = error.response.data;

        _this2.$toastr.e('Houve um erro ao carregar os totais por ano. Atualize a página e, caso o problema persista, contate o administrador no email do rodapé.');
        console.log(data.msg);
      }).then(function () {
        _this2.carregando = false;
      });
    },
    atualizaGrid: function atualizaGrid() {
      this.$refs.dt.refresh();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapState */])({
    ano_base: function ano_base(state) {
      return state.receitas_despesas.ano_base;
    }
  }), {
    listaBeneficiados: function listaBeneficiados() {
      var _this3 = this;

      var filter = function filter(item) {
        return new Date(item.data).getMonth() === _this3.filtros.mes - 1;
      };

      if (this.filtros.mes === 0) {
        return this.pagamentos;
      }

      return this.pagamentos.filter(filter);
    },
    descricao_limpa: function descricao_limpa() {
      var descricao = this.beneficio.descricao;


      if (descricao) {
        return descricao.replace(/\r\n|\n|\r/g, '<br/>');
      }

      return '';
    },
    graficoHeader: function graficoHeader() {
      var labels = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__utils_strings__["a" /* mesesAbr */]));
      var data = Array(12).fill(0);

      this.total_mes.forEach(function (element) {
        data[element.mes - 1] = element.valor;
      });

      var datasets = [{
        label: this.ano_base,
        data: data
      }];

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.grafico_base, {
        labels: labels,
        datasets: datasets
      });
    }
  })
});

/***/ }),

/***/ "fxU9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.lista),function(candidato){return _c('div',{key:("candidato-" + (candidato.numero))},[(_vm.destaque)?_c('ProgressoCandidato',{attrs:{"candidato":candidato,"perc":((candidato.total_votos / _vm.totalVotos) * 100).toFixed(2)}}):_c('ProgressoGeral',{attrs:{"candidato":candidato,"perc":((candidato.total_votos / _vm.totalVotos) * 100).toFixed(2)}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g2E0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g2M9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "gGPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Jh32");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf3a0a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Odph");
function injectStyle (ssrContext) {
  __webpack_require__("Kro4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cf3a0a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf3a0a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gL/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardsFiltrosSecretaria_vue__ = __webpack_require__("zX+d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e68ddb28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardsFiltrosSecretaria_vue__ = __webpack_require__("udoz");
function injectStyle (ssrContext) {
  __webpack_require__("Gav6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e68ddb28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardsFiltrosSecretaria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e68ddb28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardsFiltrosSecretaria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gVmU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gmZi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gojI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_strings__ = __webpack_require__("V99r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Modal__ = __webpack_require__("2iX2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'processos-pagamento',
  inject: ["showConfirm"],
  data: function data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      fields: [{
        name: 'numero_pagamento',
        title: 'Número',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'valor',
        title: 'Valor',
        dataClass: 'align-middle',
        filterable: true,
        callback: function callback(value) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_strings__["b" /* formatarMoeda */])(Number(value));
        }
      }, {
        name: 'numero',
        title: 'Número da emenda',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-2',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_3__components_common_Modal__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  computed: {
    filtros: function filtros() {
      var numero_pagamento = this.numero_pagamento,
          valor = this.valor,
          emenda = this.emenda;


      return {
        numero_pagamento: numero_pagamento,
        valor: valor,
        emenda: emenda
      };
    },

    pagina: {
      get: function get() {
        var processos_pagamento = this.$store.state.vuetableState.processos_pagamento;
        var pagina = processos_pagamento.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'processos_pagamento',
          value: value
        });
      }
    },
    numero_pagamento: {
      get: function get() {
        var processos_pagamento = this.$store.state.vuetableState.processos_pagamento;
        var numero_pagamento = processos_pagamento.filtros.numero_pagamento;

        return numero_pagamento;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'numero_pagamento',
          collection: 'processos_pagamento',
          value: value
        });
        this.resetPageStore();
      }
    },
    valor: {
      get: function get() {
        var processos_pagamento = this.$store.state.vuetableState.processos_pagamento;
        var valor = processos_pagamento.filtros.valor;

        return valor;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'valor',
          collection: 'processos_pagamento',
          value: value
        });
        this.resetPageStore();
      }
    },
    emenda: {
      get: function get() {
        var processos_pagamento = this.$store.state.vuetableState.processos_pagamento;
        var emenda = processos_pagamento.filtros.emenda;

        return emenda;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'emenda',
          collection: 'processos_pagamento',
          value: value
        });
        this.resetPageStore();
      }
    }
  },
  methods: {
    editar: function editar(data) {
      var id = data.id;

      this.$router.push({
        name: 'user_salvar_processospagamento',
        params: { id: id }
      });
    },
    excluir: function excluir(data) {
      var me = this;
      var id = data.id;


      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].delete('processospagamento/' + id).then(function (resp) {
            me.consultar();
            me.$toastr.s('Processo de pagamento removido com sucesso!');
          }).catch(function (error) {
            me.$toastr.e('Houve uma falha ao tentar remover esse item, por favor, tente novamente mais tarde!');
          });
        }
      };

      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      this.numero_pagamento = '';
      this.valor = '';
      this.emenda = '';
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'processos_pagamento',
        value: 1
      });
    }
  }
});

/***/ }),

/***/ "gp6J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gqFd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-6 flex-column-center"},[_c('h4',[_vm._v("\n    Tempo médio de agendamento de "+_vm._s(_vm.title)),_c('br'),_vm._v(" "),_c('small',[_vm._v("(últimos 6 meses)")])]),_vm._v(" "),_c('div',{staticClass:"chartWrapper"},[_c('PieChart',{attrs:{"chartData":_vm.chartData,"options":_vm.options}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gsAe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datepicker input-group"},[_c('date',{attrs:{"placeholder":"Selecione a data","input-class":"form-control","format":_vm.format,"typeable":_vm.typeable,"language":_vm.ptBR},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}},[_c('span',{staticClass:"animated-placeholder",attrs:{"slot":"afterDateInput"},slot:"afterDateInput"})]),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default btn-dateclear",attrs:{"type":"button"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'times'}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gsQE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h40+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("khKq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_171dd540_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("NtCD");
function injectStyle (ssrContext) {
  __webpack_require__("Q7mu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-171dd540"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_171dd540_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h4zR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioPerfilUnidade_vue__ = __webpack_require__("rjNL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9cc634_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioPerfilUnidade_vue__ = __webpack_require__("//wV");
function injectStyle (ssrContext) {
  __webpack_require__("pLiO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b9cc634"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioPerfilUnidade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9cc634_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioPerfilUnidade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hFAm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_CSVImport__ = __webpack_require__("ZquW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_strings_js__ = __webpack_require__("V99r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  components: { upload: __WEBPACK_IMPORTED_MODULE_0__components_common_CSVImport__["a" /* default */], DataTable: __WEBPACK_IMPORTED_MODULE_1__components_common_NoApiTable__["a" /* default */] },
  data: function data() {
    return {
      carregando: false,
      model: {
        header: [],
        body: []
      },
      beneficios: [],
      fields: [{
        name: 'BENEFICIO',
        title: 'Benefício'
      }, {
        name: 'DATA',
        title: 'Data'
      }, {
        name: '__slot:column',
        title: 'Período'
      }, {
        name: 'NOME',
        title: 'Nome'
      }, {
        name: 'VALOR',
        title: 'Valor',
        titleClass: 'text-right',
        dataClass: 'text-right',
        callback: function callback(value) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_strings_js__["b" /* formatarMoeda */])(Number(value.replace(',', '.')));
        }
      }]
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('assistencia/listar-beneficios').then(function (response) {
      _this.beneficios = response.data;
    }).catch(function (error) {
      console.log(error.message);
    });
  },

  methods: {
    loadCSV: function loadCSV(payload) {
      var checkFields = ['DATA', 'NOME', 'BENEFICIO', 'VALOR'];

      for (var index = 0; index < checkFields.length; index++) {
        var element = checkFields[index];
        if (!payload.header.includes(element)) {
          this.$toastr.e(element + ' \xE9 um campo obrigat\xF3rio! Verifique a planilha.');
          return;
        }
      }

      this.model.header = payload.header;
      this.model.body = payload.body;
    },
    salvar: function salvar() {
      var _this2 = this;

      var me = this;
      var config = {
        title: 'Deseja Salvar?',
        question: true,
        yes: function yes() {
          me.carregando = !me.carregando;
          __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].post('assistencia/pagamentos/salvar', _this2.rawInfo).then(function (response) {
            _this2.$toastr.s(response.data.msg);
            _this2.$router.push('/admin/assistencia/pagamentos');
          }).catch(function (error) {
            var data = error.response.data;

            _this2.$toastr.e('Houve um erro na importa\xE7\xE3o dos dados, verifique o arquivo na linha ' + data.linha + ' e tente novamente.');
            console.log(data.msg);
          }).then(function () {
            me.carregando = !me.carregando;
          });
        }
      };
      this.showConfirm('Confirmar a inserção dos itens?', config);
    }
  },
  computed: {
    rawInfo: function rawInfo() {
      var _this3 = this;

      return this.model.body.map(function (item) {
        var finder = function finder(sub) {
          return sub.sigla === item['BENEFICIO'];
        };

        return {
          data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_strings_js__["g" /* toDate */])(item['DATA']).toLocaleDateString('en-US'),
          periodo_inicio: item['INICIO'] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_strings_js__["g" /* toDate */])(item['INICIO']).toLocaleDateString('en-US') : '',
          periodo_fim: item['FIM'] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_strings_js__["g" /* toDate */])(item['FIM']).toLocaleDateString('en-US') : '',
          beneficiado: item['NOME'],
          cd_beneficio: _this3.beneficios.find(finder).codigo,
          valor: Number(item['VALOR'].replace(',', '.'))
        };
      });
    }
  }
});

/***/ }),

/***/ "hJI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['vuetable-pagination-info', _vm.css.infoClass],domProps:{"innerHTML":_vm._s(_vm.paginationInfo)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hNdE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardsSecretaria_vue__ = __webpack_require__("9tfk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071b12af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardsSecretaria_vue__ = __webpack_require__("+gXo");
function injectStyle (ssrContext) {
  __webpack_require__("rr4i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-071b12af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardsSecretaria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071b12af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardsSecretaria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hQn3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.3eadeea.jpg";

/***/ }),

/***/ "haG+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":'Bem-vindo ao Dados Abertos'}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n        Dados são abertos quando qualquer pessoa pode livremente usá-los,\n        reutilizá-los e redistribuí-los, estando sujeito a, no máximo, a\n        exigência de creditar a sua autoria e compartilhar pela mesma licença.\n      ")]),_vm._v(" "),_c('cite',{attrs:{"title":"Open Knowledge Foundation"}},[_c('a',{attrs:{"href":"http://opendatahandbook.org/pt_BR/what-is-open-data/index.html","rel":"nofollow","target":"_blank"}},[_vm._v("\n          Open Knowledge Foundation\n        ")])])])]),_vm._v(" "),_c('nav',{staticClass:"panel-nav"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"text-xl"},[_c('li',[_c('a',{attrs:{"role":"button"},on:{"click":function($event){return _vm.scrollToElement('cards-ods')}}},[_vm._v("\n            Objetivos do Desenvolvimento Sustentável (ODS)\n          ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"role":"button"},on:{"click":function($event){return _vm.scrollToElement('cards-secretaria')}}},[_vm._v("\n            Secretarias Municipais\n          ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"role":"button"},on:{"click":function($event){return _vm.scrollToElement('cards-portais')}}},[_vm._v("\n            Portais de transparência\n          ")])])])])]),_vm._v(" "),_c('main',{staticClass:"container"},[(_vm.favoritos.show)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Favoritos")]),_vm._v(" "),_c('router-link',{staticClass:"text-xl favoritos",attrs:{"to":{ name: _vm.favoritos.nome_rota }}},[_vm._v("\n          Acessar meus favoritos\n        ")])],1)]):_vm._e(),_vm._v(" "),_c('CardsODS',{attrs:{"id":"cards-ods","metas":_vm.metas}}),_vm._v(" "),_c('CardsSecretaria',{attrs:{"id":"cards-secretaria","secretarias":_vm.secretarias}}),_vm._v(" "),_c('CardsPortais',{attrs:{"id":"cards-portais"}}),_vm._v(" "),(_vm.btnTopVisible)?_c('a',{staticClass:"btn-topo",attrs:{"role":"button","title":"Voltar ao Início"},on:{"click":function($event){return _vm.scrollToElement('app')}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-up'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Voltar ao topo")])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i/iG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),

/***/ "i1A9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "i2IB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i7Gx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i85P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i94k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PieChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels__ = __webpack_require__("cNRp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp;


var PieChart = {
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Pie */],
  mixins: [reactiveProp],
  data: function data() {
    return {};
  },

  props: {
    options: {
      type: Object
    },
    gradiente: {
      type: Boolean,
      default: true
    },
    coloredLine: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.$refs.canvas) {
      this.addPlugin(__WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels___default.a);
      this.renderChart(this.chartData, this.options);
      this.htmlLegend = this.generateLegend();
    }
  },

  methods: {
    montarCor: function montarCor(cor) {
      if (this.gradiente) {
        return this.gradient(cor);
      } else {
        return 'rgb(' + cor + ')';
      }
    },
    gradient: function gradient(color) {
      var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);

      gradient.addColorStop(0, 'rgba(' + color + ', 1)');
      gradient.addColorStop(0.5, 'rgba(' + color + ', 0.6)');
      gradient.addColorStop(1, 'rgba(' + color + ', 0.2)');

      return gradient;
    }
  },
  watch: {
    chartData: function chartData() {
      this.$data._chart.update();
    }
  }
};

/***/ }),

/***/ "iDa5":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTlweCIgaGVpZ2h0PSI2N3B4IiB2aWV3Qm94PSIwIDAgNTkgNjciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjYgKDY3NDkxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY28tYXp1bDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxwYXRoIGQ9Ik05Ljk5OTk5ODEsMCBMMjMsLTYuMzI3OTQ4MTJlLTA3IEMyOC41MjI4NDc1LC02LjMyNzk0ODEzZS0wNyAzMyw0LjQ3NzE1MTg3IDMzLDkuOTk5OTk5MzcgQzMzLDkuOTk5OTk5NiAzMyw5Ljk5OTk5OTc3IDMzLDEwIEwzMi45OTk5OTg0LDI0LjkwNzc2NDUgQzMyLjk5OTk5ODIsMjguMTA3MTMwMSAzMS40NjkxNTc5LDMxLjExMzM0ODMgMjguODgxNzE1NiwzMi45OTUxMjQ2IEwxNi40OTk5OTkxLDQyLjAwMDAwOTkgTDQuMTE4MjgxMzUsMzIuOTk1MTI0OCBDMS41MzA4Mzg2LDMxLjExMzM0ODQgLTEuODk4Mzg0NjVlLTA2LDI4LjEwNzEyOTggLTEuODk4Mzg0NjVlLTA2LDI0LjkwNzc2MzggTC0xLjg5ODM4NDY1ZS0wNiwxMCBDLTEuODk4Mzg0NjZlLTA2LDQuNDc3MTUyNSA0LjQ3NzE1MDYsMS4wMTQ1MzA2M2UtMTUgOS45OTk5OTgxLDAgWiIgaWQ9InBhdGgtMSI+PC9wYXRoPgogICAgICAgIDxmaWx0ZXIgeD0iLTYyLjElIiB5PSItNDguOCUiIHdpZHRoPSIyMjQuMiUiIGhlaWdodD0iMTk5LjklIiBmaWx0ZXJVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIGlkPSJmaWx0ZXItMiI+CiAgICAgICAgICAgIDxmZU1vcnBob2xvZ3kgcmFkaXVzPSIyLjUiIG9wZXJhdG9yPSJkaWxhdGUiIGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dTcHJlYWRPdXRlcjEiPjwvZmVNb3JwaG9sb2d5PgogICAgICAgICAgICA8ZmVPZmZzZXQgZHg9IjAiIGR5PSIwIiBpbj0ic2hhZG93U3ByZWFkT3V0ZXIxIiByZXN1bHQ9InNoYWRvd09mZnNldE91dGVyMSI+PC9mZU9mZnNldD4KICAgICAgICAgICAgPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iNSIgaW49InNoYWRvd09mZnNldE91dGVyMSIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIj48L2ZlR2F1c3NpYW5CbHVyPgogICAgICAgICAgICA8ZmVDb21wb3NpdGUgaW49InNoYWRvd0JsdXJPdXRlcjEiIGluMj0iU291cmNlQWxwaGEiIG9wZXJhdG9yPSJvdXQiIHJlc3VsdD0ic2hhZG93Qmx1ck91dGVyMSI+PC9mZUNvbXBvc2l0ZT4KICAgICAgICAgICAgPGZlQ29sb3JNYXRyaXggdmFsdWVzPSIwIDAgMCAwIDAgICAwIDAgMCAwIDAgICAwIDAgMCAwIDAgIDAgMCAwIDAuMSAwIiB0eXBlPSJtYXRyaXgiIGluPSJzaGFkb3dCbHVyT3V0ZXIxIiByZXN1bHQ9InNoYWRvd01hdHJpeE91dGVyMSI+PC9mZUNvbG9yTWF0cml4PgogICAgICAgICAgICA8ZmVNb3JwaG9sb2d5IHJhZGl1cz0iMSIgb3BlcmF0b3I9ImRpbGF0ZSIgaW49IlNvdXJjZUFscGhhIiByZXN1bHQ9InNoYWRvd1NwcmVhZE91dGVyMiI+PC9mZU1vcnBob2xvZ3k+CiAgICAgICAgICAgIDxmZU9mZnNldCBkeD0iMCIgZHk9IjEiIGluPSJzaGFkb3dTcHJlYWRPdXRlcjIiIHJlc3VsdD0ic2hhZG93T2Zmc2V0T3V0ZXIyIj48L2ZlT2Zmc2V0PgogICAgICAgICAgICA8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIzIiBpbj0ic2hhZG93T2Zmc2V0T3V0ZXIyIiByZXN1bHQ9InNoYWRvd0JsdXJPdXRlcjIiPjwvZmVHYXVzc2lhbkJsdXI+CiAgICAgICAgICAgIDxmZUNvbXBvc2l0ZSBpbj0ic2hhZG93Qmx1ck91dGVyMiIgaW4yPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9Im91dCIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIyIj48L2ZlQ29tcG9zaXRlPgogICAgICAgICAgICA8ZmVDb2xvck1hdHJpeCB2YWx1ZXM9IjAgMCAwIDAgMCAgIDAgMCAwIDAgMCAgIDAgMCAwIDAgMCAgMCAwIDAgMC41IDAiIHR5cGU9Im1hdHJpeCIgaW49InNoYWRvd0JsdXJPdXRlcjIiIHJlc3VsdD0ic2hhZG93TWF0cml4T3V0ZXIyIj48L2ZlQ29sb3JNYXRyaXg+CiAgICAgICAgICAgIDxmZU1lcmdlPgogICAgICAgICAgICAgICAgPGZlTWVyZ2VOb2RlIGluPSJzaGFkb3dNYXRyaXhPdXRlcjEiPjwvZmVNZXJnZU5vZGU+CiAgICAgICAgICAgICAgICA8ZmVNZXJnZU5vZGUgaW49InNoYWRvd01hdHJpeE91dGVyMiI+PC9mZU1lcmdlTm9kZT4KICAgICAgICAgICAgPC9mZU1lcmdlPgogICAgICAgIDwvZmlsdGVyPgogICAgPC9kZWZzPgogICAgPGcgaWQ9Ik5vZGUtTG9jYWwiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJpY28tYXp1bCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMuMDAwMDAwLCAxMy4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IlJlY3RhbmdsZS1Db3B5LTE3Ij4KICAgICAgICAgICAgICAgIDx1c2UgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMSIgZmlsdGVyPSJ1cmwoI2ZpbHRlci0yKSIgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgICAgICA8dXNlIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSIjRkZGRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgogICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtQ29weS0xOCIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9IiM1OUMxRUIiIHg9Ii0xLjg5ODM4NDY1ZS0wNiIgeT0iMCIgd2lkdGg9IjMzIiBoZWlnaHQ9IjMzIiByeD0iMTAiPjwvcmVjdD4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjAwMDAwMCwgOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik02LjM1MDc5ODU1LDEuMzYxMjMwNDkgTDYuMzUwNzk4NTUsMy4xMjU5NDkxOCIgaWQ9IlN0cm9rZS02IiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTcuMjQxODQ3NTUsMi4yNDM0OTE4MyBMNS40NTk4MTQ4OCwyLjI0MzQ5MTgzIiBpZD0iU3Ryb2tlLTciIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCAyLjEyMjkxNSkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLjMyMTQ1MTkwNiwxLjU1NTk3MDk2IEwxLjIzNDUxOTA2LDEuNTU1OTcwOTYgQzEuNDExOTA1NjMsMS41NTU5NzA5NiAxLjU1NTk3MDk2LDEuNDEyMjMyMyAxLjU1NTk3MDk2LDEuMjM0NTE5MDYgTDEuNTU1OTcwOTYsMC4zMjE0NTE5MDYgQzEuNTU1OTcwOTYsMC4xNDQwNjUzMzYgMS42OTk3MDk2MiwwIDEuODc3NDIyODcsMCBMMy40NDU4MDc2MiwwIEMzLjYyMzUyMDg3LDAgMy43NjcyNTk1MywwLjE0NDA2NTMzNiAzLjc2NzI1OTUzLDAuMzIxNDUxOTA2IEwzLjc2NzI1OTUzLDEuMjM0NTE5MDYgQzMuNzY3MjU5NTMsMS40MTIyMzIzIDMuOTExMzI0ODYsMS41NTU5NzA5NiA0LjA4ODcxMTQzLDEuNTU1OTcwOTYgTDUuMDAxNzc4NTgsMS41NTU5NzA5NiBDNS4xNzkxNjUxNSwxLjU1NTk3MDk2IDUuMzIzMjMwNDksMS42OTk3MDk2MiA1LjMyMzIzMDQ5LDEuODc3NDIyODcgTDUuMzIzMjMwNDksMy40NDU4MDc2MiBDNS4zMjMyMzA0OSwzLjYyMzUyMDg3IDUuMTc5MTY1MTUsMy43NjcyNTk1MyA1LjAwMTc3ODU4LDMuNzY3MjU5NTMgTDQuMDg4NzExNDMsMy43NjcyNTk1MyBDMy45MTEzMjQ4NiwzLjc2NzI1OTUzIDMuNzY3MjU5NTMsMy45MTEzMjQ4NiAzLjc2NzI1OTUzLDQuMDg4NzExNDMgTDMuNzY3MjU5NTMsNS4wMDE3Nzg1OCBDMy43NjcyNTk1Myw1LjE3OTE2NTE1IDMuNjIzNTIwODcsNS4zMjMyMzA0OSAzLjQ0NTgwNzYyLDUuMzIzMjMwNDkgTDEuODc3NDIyODcsNS4zMjMyMzA0OSBDMS42OTk3MDk2Miw1LjMyMzIzMDQ5IDEuNTU1OTcwOTYsNS4xNzkxNjUxNSAxLjU1NTk3MDk2LDUuMDAxNzc4NTggTDEuNTU1OTcwOTYsNC4wODg3MTE0MyBDMS41NTU5NzA5NiwzLjkxMTMyNDg2IDEuNDExOTA1NjMsMy43NjcyNTk1MyAxLjIzNDUxOTA2LDMuNzY3MjU5NTMgTDAuMzIxNDUxOTA2LDMuNzY3MjU5NTMgQzAuMTQ0MDY1MzM2LDMuNzY3MjU5NTMgMCwzLjYyMzUyMDg3IDAsMy40NDU4MDc2MiBMMCwxLjg3NzQyMjg3IEMwLDEuNjk5NzA5NjIgMC4xNDQwNjUzMzYsMS41NTU5NzA5NiAwLjMyMTQ1MTkwNiwxLjU1NTk3MDk2IiBpZD0iRmlsbC04Ij48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuNjEzNDMwLCAwLjU2MjExNikiPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik02LjY3Nzk1MzU4LDYuMDkwNTg4NzUgTDEwLjQxNzU3NzgsOS4zMjI4MjYxNiBMMTQuMjU3OTg3OCw2LjQ4NTE5NzYgQzE1LjQwODU2ODUsNS4yODIzMzYyMiAxNS4zOTIzNjM0LDMuMzc0MDY4NzkgMTQuMjA5MzcyMywyLjE5MTA3Nzc0IEMxMy4wMDk5NTExLDAuOTkxNjU2NDgxIDExLjA2NDk2NzIsMC45OTE2NTY0ODEgOS45MzIwNjI4MSwyLjExNzYxNjM4IEw2LjY3Nzk1MzU4LDYuMDkwNTg4NzUgWiIgaWQ9IlBhdGgiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTIuMTI5NDY2MTMsMTQuMjcwOTg0IEMzLjMyODg4NzM5LDE1LjQ3MDQwNTIgNS4yNzM4NzEyMywxNS40NzA0MDUyIDYuNDczMjkyNDksMTQuMjcwOTg0IEM4LjY1OTI5Mzk5LDEyLjA4NDk4MjUgOC42NTkyOTM5OSwxMi4wODQ5ODI1IDEwLjA1MDM4NTksMTAuNjkzODkwNiBDMTEuNjY3NzY5NSw5LjA3NjUwNjk2IDExLjY2Nzc2OTUsOS4wNzY1MDY5NiAxNC4yMDkzNzIzLDYuNTM0OTA0MTEgQzE1LjQwODc5MzYsNS4zMzU0ODI4NSAxNS40MDg3OTM2LDMuMzkwNDk5IDE0LjIwOTM3MjMsMi4xOTEwNzc3NCBDMTMuMDA5OTUxMSwwLjk5MTY1NjQ4MSAxMS4wNjQ5NjcyLDAuOTkxNjU2NDgxIDkuODY1NTQ1OTgsMi4xOTEwNzc3NCBDNy4xNjQ1MTQ2MSw0Ljg5MjEwOTExIDcuMTY0NTE0NjEsNC44OTIxMDkxMSA1LjQ0NTY3NjQ3LDYuNjEwOTQ3MjUgQzQuMTU2MDM5MTIsNy45MDA1ODQ2MSA0LjE1NjAzOTEyLDcuOTAwNTg0NjEgMi4xMjk0NjYxMyw5LjkyNzE1NzYgQzAuOTMwMDQ0ODY2LDExLjEyNjU3ODkgMC45MzAwNDQ4NjYsMTMuMDcxNTYyNyAyLjEyOTQ2NjEzLDE0LjI3MDk4NCBaIiBpZD0iU3Ryb2tlLTExIiBzdHJva2U9IiNGRkZGRkYiIHN0cm9rZS13aWR0aD0iMiI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik00LjkyODI3NTg2LDUuNzU0MTE5NzggQzYuNTQzNzAyMzYsNS40ODU5MTY1MiAxMC44ODYyNDMyLDkuODMwMDkwNzQgMTAuNzI0NTM3MiwxMS4xNzg2MjA3IiBpZD0iU3Ryb2tlLTEzIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTQuMjcxNTExNjgsMTAuNTI2MzE1OCBDMy45NjU3NDAzNSwxMC43MzYwODU2IDMuNzA5NjI0MiwxMC45MTE3OTAzIDMuNTk0MzA2NiwxMC45OTA5MDIyIEMzLjE5ODA0NTI1LDExLjI2Mjc1MTQgMi44MDU3MDQwNiwxMS45OTU4MjUzIDMuNzAyNzYzOTUsMTIuODI2Mzg4NCIgaWQ9IlN0cm9rZS0xNSIgZmlsbD0iI0ZGRkZGRiI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik00LjgxODA1NDQ1LDguMzExMjMwNDkgQzQuODE4MDU0NDUsOC4zMTEyMzA0OSA0Ljc0OTEyNTIzLDguMzgwMTU5NzEgNC4xMzkyMTU5Nyw4Ljk5MDA2ODk3IiBpZD0iU3Ryb2tlLTE3IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "iGhK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iHhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Modal__ = __webpack_require__("2iX2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  name: 'Moderation',
  data: function data() {
    return {
      listModeration: {
        columnID: 'id',
        columns: [{
          name: 'dado_nome',
          title: 'Nome',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: 'user',
          title: 'Usuário',
          dataClass: 'align-middle',
          filterable: true,
          callback: function callback(_ref) {
            var USU_NMUSUARIO = _ref.USU_NMUSUARIO,
                username = _ref.username;
            return '<span title="' + USU_NMUSUARIO + '">' + username + '</span>';
          }
        }, {
          name: 'data_valor',
          title: 'Data',
          dataClass: 'align-middle',
          filterable: true,
          callback: function callback(date) {
            return new Date(date).toLocaleDateString();
          }
        }, {
          name: '__slot:column_custom',
          title: 'Valor Anterior',
          titleClass: 'text-center col-md-2',
          dataClass: 'text-center'
        }, {
          name: '__slot:column_custom_2',
          title: 'Valor Atual',
          titleClass: 'text-center col-md-2',
          dataClass: 'text-center'
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-2',
          dataClass: 'text-center'
        }]
      },
      listApproved: {
        columnID: 'id',
        columns: [{
          name: 'dado_nome',
          title: 'Nome',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: '__slot:column_custom',
          title: 'Valor',
          titleClass: 'text-center col-md-2',
          dataClass: 'text-center'
        }, {
          name: 'moderate_at',
          title: '<span title="Data da moderação">Data</span>',
          dataClass: 'align-middle',
          filterable: true,
          callback: function callback(date) {
            return new Date(date).toLocaleDateString();
          }
        }, {
          name: 'user_moderador',
          title: '<span title="Usuário que moderou">Usuário</span>',
          dataClass: 'align-middle',
          filterable: true,
          callback: function callback(_ref2) {
            var USU_NMUSUARIO = _ref2.USU_NMUSUARIO,
                username = _ref2.username;
            return '<span title="' + USU_NMUSUARIO + '">' + username + '</span>';
          }
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-2',
          dataClass: 'text-center'
        }]
      }
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_2__components_common_DataTable__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_3__components_common_Modal__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  computed: {
    listModeration_pagina: {
      get: function get() {
        return this.$store.state.vuetableState.listModeration.pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'listModeration',
          value: value
        });
      }
    },
    listApproved_pagina: {
      get: function get() {
        return this.$store.state.vuetableState.listApproved.pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'listApproved',
          value: value
        });
      }
    }
  },
  methods: {
    aprovar: function aprovar(_ref3) {
      var _this = this;

      var id = _ref3.id;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function () {
          var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].put('moderacao/' + id);

                  case 3:
                    _this.$toastr.s('Valor aprovado com sucesso.');
                    _this.consultar();
                    _context.next = 10;
                    break;

                  case 7:
                    _context.prev = 7;
                    _context.t0 = _context['catch'](0);

                    _this.$toastr.e('Tivemos um problema técnico para aprovar o valor, por favor tente daqui alguns minutos.');

                  case 10:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this, [[0, 7]]);
          }));

          return function yes() {
            return _ref4.apply(this, arguments);
          };
        }()
      };
      this.showConfirm('Tem certeza que deseja aprovar este valor?', config);
    },
    reprovar: function reprovar(_ref5) {
      var _this2 = this;

      var id = _ref5.id;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function () {
          var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].delete('moderacao/' + id);

                  case 3:
                    _this2.$toastr.s('Valor reprovado com sucesso.');
                    _this2.consultar();
                    _context2.next = 10;
                    break;

                  case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2['catch'](0);

                    _this2.$toastr.e('Tivemos um problema técnico para reprovar o valor, por favor tente daqui alguns minutos.');

                  case 10:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this2, [[0, 7]]);
          }));

          return function yes() {
            return _ref6.apply(this, arguments);
          };
        }()
      };
      this.showConfirm('Tem certeza que deseja reprovar este valor?', config);
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.listModeration.refresh();
        this.$refs.listApproved.refresh();
      });
    },
    showModal: function showModal(_ref7) {
      var valor_texto_anterior = _ref7.valor_texto_anterior,
          valor_texto_atual = _ref7.valor_texto_atual,
          observacao_atual = _ref7.observacao_atual,
          observacao_anterior = _ref7.observacao_anterior;

      var config = {
        title: 'Respostas',
        question: false
      };

      var templateObsAtual = observacao_atual ? '<h6><b>Observa\xE7\xE3o:</b>' + observacao_atual + '</h6>' : '';
      var templateObsAnterior = observacao_anterior ? '<h6><b>Observa\xE7\xE3o:</b>' + observacao_anterior + '</h6>' : '';

      var htmlContent = '<div class="form-group">\n                              <label class="control-label">\n                                Atual\n                              </label> \n                              <textarea readonly rows="7" class="form-control" aria-required="true" aria-invalid="false">\n                              ' + valor_texto_atual + '\n                              </textarea>\n                              ' + templateObsAtual + '\n                            </div>\n                            <div class="form-group">\n                              <label class="control-label">\n                                Anterior\n                              </label> \n                              <textarea readonly rows="7" class="form-control" aria-required="true" aria-invalid="false">\n                              ' + valor_texto_anterior + '\n                              </textarea>\n                              ' + templateObsAnterior + '\n                            </div>';

      this.showConfirm(htmlContent, config);
    }
  }
});

/***/ }),

/***/ "iL/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-pulse v-pulse1",style:([_vm.spinnerStyle,_vm.spinnerDelay1])}),_c('div',{staticClass:"v-pulse v-pulse2",style:([_vm.spinnerStyle,_vm.spinnerDelay2])}),_c('div',{staticClass:"v-pulse v-pulse3",style:([_vm.spinnerStyle,_vm.spinnerDelay3])})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iMpk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Select__ = __webpack_require__("MGJx");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Select: __WEBPACK_IMPORTED_MODULE_0__components_common_Select__["a" /* default */]
  },
  props: {
    value: [String]
  },
  data: function data() {
    return {
      scaleList: [{ label: 'Administrativo', value: 'adm' }, { label: 'Plantão Impar', value: 'impar' }, { label: 'Plantão Par', value: 'par' }, { label: 'Personalizado', value: '*' }],
      scale: ''
    };
  },

  watch: {
    scale: function scale(value) {
      this.update(value);
    },
    value: function value(_value) {
      this.scale = _value;
    }
  },
  methods: {
    update: function update(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),

/***/ "iQBf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 lista-metas"},_vm._l((_vm.metas),function(meta){return _c('div',{key:("meta-" + (meta.numero)),staticClass:"card-metas"},[_c('a',{attrs:{"role":"button"},on:{"click":function($event){return _vm.$emit('click', meta)}}},[_c('img',{staticClass:"imgODS",attrs:{"title":meta.titulo,"data-toggle":'popover',"data-content":meta.objetivo,"data-placement":'top',"data-trigger":'hover',"src":("" + _vm.imgUrl + (meta.imagem_url)),"alt":("imagem representando a meta " + (meta.titulo) + " para filtrar a lista")}})])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iSjT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nomeados"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h2',{staticClass:"page-header"},[_vm._v("Nomear Candidatos")]),_vm._v(" "),_c('h3',[_vm._v("Edital nº "+_vm._s(_vm.edital.numero))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table',{ref:"vuetable",attrs:{"title":'Lista de Cargos',"dados":_vm.cargos,"fields":_vm.fields,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.selecionarHabilitadosCargo(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'search'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Selecionar cargo")])],1)]}}])})],1)]),_vm._v(" "),(_vm.cargo.id)?_c('div',{staticClass:"row"},[_c('habilitado-table',{attrs:{"id":"lista-habilitados","title":"Lista de Habilitados","data":_vm.habilitadosGeral,"fullData":_vm.habilitados},on:{"updateData":_vm.listarHabilitadosEdital}}),_vm._v(" "),_c('habilitado-table',{attrs:{"title":"Lista de Habilitados - PCD","data":_vm.habilitadosPCD,"fullData":_vm.habilitados},on:{"updateData":_vm.listarHabilitadosEdital}}),_vm._v(" "),_c('habilitado-table',{attrs:{"title":"Lista de Habilitados - Cotas","is-cotas":true,"data":_vm.habilitadosCotas,"fullData":_vm.habilitados},on:{"updateData":_vm.listarHabilitadosEdital}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "id8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Z68B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0da77f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("uwvT");
function injectStyle (ssrContext) {
  __webpack_require__("Hubs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c0da77f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0da77f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "if7j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("Mostrar")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function (event) { return _vm.$emit('updatePerPage', Number(event.target.value)); }}},_vm._l((_vm.options),function(n,index){return _c('option',{key:index,domProps:{"value":n === 'Todos' ? 0 : n,"selected":n == _vm.perPage}},[_vm._v("\n      "+_vm._s(n)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "igL+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_CSVImport__ = __webpack_require__("ZquW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  components: { upload: __WEBPACK_IMPORTED_MODULE_1__components_common_CSVImport__["a" /* default */], DataTable: __WEBPACK_IMPORTED_MODULE_2__components_common_NoApiTable__["a" /* default */] },
  data: function data() {
    return {
      carregando: false,
      model: {
        header: [],
        body: []
      },
      periodicidades: [],
      eixos: [],
      metas: [],
      tags: [],
      secretarias: [],
      fields: [{
        name: 'NOME',
        title: 'NOME'
      }, {
        name: 'DESCRIÇÃO',
        title: 'DESCRIÇÃO'
      }, {
        name: 'FONTE',
        title: 'FONTE'
      }, {
        name: 'TIPO VALOR',
        title: 'TIPO VALOR'
      }, {
        name: 'PERIODICIDADE',
        title: 'PERIODICIDADE'
      }, {
        name: 'TAG',
        title: 'TAG'
      }, {
        name: 'EIXO',
        title: 'EIXO'
      }, {
        name: 'METAS',
        title: 'METAS'
      }, {
        name: 'SECRETARIAS',
        title: 'SECRETARIAS'
      }]
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('meta/listar').then(function (response) {
      _this.metas = response.data.data;
    }).catch(function (error) {
      console.log(error.message);
    });
    __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('eixos/listar').then(function (response) {
      _this.eixos = response.data.data;
    }).catch(function (error) {
      console.log(error.message);
    });
    __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('tags/listar').then(function (response) {
      _this.tags = response.data.data;
    }).catch(function (error) {
      console.log(error.message);
    });
    __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('listar-periodicidades').then(function (response) {
      _this.periodicidades = response.data.data;
    }).catch(function (error) {
      console.log(error.message);
    });
    __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('filtrar-secretarias/1').then(function (response) {
      _this.secretarias = response.data.data;
    }).catch(function (error) {
      console.log(error.message);
    });
  },

  methods: {
    loadCSV: function loadCSV(payload) {
      this.model.header = payload.header;
      this.model.body = payload.body;
    },
    salvar: function salvar() {
      var _this2 = this;

      var me = this;
      var config = {
        title: 'Deseja Salvar?',
        question: true,
        yes: function yes() {
          me.carregando = !me.carregando;
          __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].post('dado/importar', _this2.rawInfo).then(function (response) {
            _this2.$toastr.s(response.data);
            _this2.$router.push('/admin/dado/list');
          }).catch(function (error) {
            var data = error.response.data;

            _this2.$toastr.e('Houve um erro na importa\xE7\xE3o dos dados, verifique o arquivo na linha ' + data.linha + ' e tente novamente.');
            console.log(data.msg);
          }).finally(function () {
            me.carregando = !me.carregando;
          });
        }
      };
      this.showConfirm('Confirmar a inserção dos itens?', config);
    },
    filtrarEixo: function filtrarEixo(desc_eixo) {
      var descricao = desc_eixo.toLowerCase();
      var eixos = this.eixos.filter(function (item) {
        return item.descricao.toLowerCase() === descricao;
      });

      return eixos;
    },
    filtrarPeriodicidade: function filtrarPeriodicidade(desc_periodicidade) {
      return this.periodicidades.find(function (item) {
        return item.descricao.toLowerCase() === desc_periodicidade.toLowerCase();
      });
    },
    filtrarTag: function filtrarTag(desc_tag) {
      var descricao = desc_tag.toLowerCase();
      var tags = this.tags.filter(function (item) {
        return item.descricao.toLowerCase() === descricao;
      });

      return tags;
    },
    filtrarMetas: function filtrarMetas(desc_metas) {
      var nr_metas = desc_metas.split(',');
      var metas = this.metas.filter(function (item) {
        return nr_metas.includes(item.numero.toString());
      });
      return metas;
    },
    filtrarSecretaria: function filtrarSecretaria(desc_secretaria) {
      var nr_secretarias = desc_secretaria.split(',');
      var secretarias = this.secretarias.filter(function (item) {
        return nr_secretarias.includes(item.sigla);
      });
      return secretarias;
    }
  },
  computed: {
    rawInfo: function rawInfo() {
      var _this3 = this;

      return this.model.body.map(function (item) {
        var eixo = _this3.filtrarEixo(item.EIXO) || { codigo: item.EIXO };
        var periodicidade = _this3.filtrarPeriodicidade(item.PERIODICIDADE) || {
          codigo: item.PERIODICIDADE
        };
        var tag = _this3.filtrarTag(item.TAG) || { codigo: item.TAG };
        var meta = _this3.filtrarMetas(item.METAS) || [];
        var secretarias = _this3.filtrarSecretaria(item.SECRETARIAS) || [];

        var mapper = function mapper(item) {
          return item.codigo || null;
        };

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          EIXO: eixo.map(mapper),
          PERIODICIDADE: periodicidade.codigo,
          TAG: tag.map(mapper),
          METAS: meta.map(mapper),
          SECRETARIAS: secretarias
        });
      });
    }
  }
});

/***/ }),

/***/ "ik/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Container_vue__ = __webpack_require__("RGWY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a3ae0cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Container_vue__ = __webpack_require__("DvK6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Container_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a3ae0cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Container_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ikgP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Pendências")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"escalas",attrs:{"show-empty":true,"title":"Listagem de escalas pendentes","reportTitle":"Escalas pendentes","has-auth":false,"api-mode":false,"dados":_vm.pendencias,"fields":_vm.datatable.columns,"show-print-button":false,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Enviar para análise"},on:{"click":function($event){return _vm.enviarAnalise(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'paper-plane'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Atualizar a Observação","type":"button"},on:{"click":function($event){return _vm.atualizarObservacao(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}})],1)])]}}])}),_vm._v(" "),_c('input-modal',{ref:"inputModal",attrs:{"titulo":"Atualizar a observação","descricao":"Descreva abaixo a observação para está escala","label":"Observação","placeholder":"Descreva aqui a observação da escala..."}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ioH+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emendasGeral__ = __webpack_require__("uHUi");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_4__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components__["b" /* Breadcrumb */],
    DataTable: __WEBPACK_IMPORTED_MODULE_4__components__["n" /* NoApiTable */],
    SideEmendas: __WEBPACK_IMPORTED_MODULE_4__components__["o" /* SideEmendas */],
    SelectAnoEmendas: __WEBPACK_IMPORTED_MODULE_4__components__["p" /* SelectAnoEmendas */],
    ValorDestaqueHeader: __WEBPACK_IMPORTED_MODULE_4__components__["q" /* ValorDestaqueHeader */]
  },
  data: function data() {
    return {
      vereador: '',
      breadcrumb: [],
      navs: __WEBPACK_IMPORTED_MODULE_6__emendasGeral__["a" /* navs */],
      dataFields: __WEBPACK_IMPORTED_MODULE_6__emendasGeral__["b" /* dataFields */],
      emendaSelecionada: {},
      filtros: {
        descricao: ''
      }
    };
  },
  created: function created() {
    var vereador = this.$route.params.vereador;

    this.vereador = vereador;

    this.fillBreadcrumb();
  },

  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_5__utils__["e" /* formatarMoeda */],
    showDetails: function showDetails(emenda) {
      var _navs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(this.navs, 1),
          nav = _navs[0];

      nav.titulo = 'Detalhes da emenda';
      nav.subtitulo = 'Emenda n\xBA ' + emenda.numero + ' / ' + emenda.ano;
      nav.subtDetalhe = emenda.nome_orgao;
      this.emendaSelecionada = emenda;

      this.$refs['side-emendas'].$emit('abreModal', nav.identidade);
    },
    fillBreadcrumb: function fillBreadcrumb() {
      this.breadcrumb = [{
        label: 'Emendas Parlamentares',
        named_link: { name: 'emendas_parlamentares' }
      }, {
        label: 'Emendas Por Vereador',
        named_link: { name: 'emendas_por_vereador' }
      }, {
        label: this.vereador
      }];
    },

    reducer: function reducer(key) {
      return function (acum, emenda) {
        return acum += Number(emenda[key]);
      };
    },
    downloadToCSV: function downloadToCSV() {
      var headers = {
        numero: 'Emenda nº',
        vereador: 'Vereador',
        secretaria: 'Secretaria',
        descricao: 'Descrição',
        valor: 'Valor',
        saldo: 'Saldo'
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["b" /* exportCSVFile */])(headers, [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.emendasDoVereador.map(function (item) {
        return {
          numero: item.numero,
          vereador: item.vereador.nome,
          secretaria: item.nome_orgao,
          descricao: item.descricao,
          valor: Number(item.valor).toFixed(2).replace('.', ','),
          saldo: Number(item.saldo).toFixed(2).replace('.', ',')
        };
      }))), 'emendas');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    emendas: function emendas(state) {
      return state.emendas_parlamentares.emendas;
    },
    loading: function loading(_ref) {
      var emendas_parlamentares = _ref.emendas_parlamentares;
      return emendas_parlamentares.loading;
    }
  }), {
    emendasDoVereador: function emendasDoVereador() {
      var _this = this;

      var filter = function filter(emenda) {
        return emenda.vereador.nome === _this.vereador;
      };

      var emendasVereador = this.emendas.filter(filter);

      if (this.filtros.descricao) {
        var _filter = function _filter(item) {
          var sigla_orgao = item.sigla_orgao,
              descricao = item.descricao;


          var termo = _this.filtros.descricao.toUpperCase();
          return sigla_orgao.toUpperCase().includes(termo) || descricao.toUpperCase().includes(termo);
        };

        return emendasVereador.filter(_filter);
      }

      return emendasVereador;
    },
    valorTotalEmendas: function valorTotalEmendas() {
      return this.emendasDoVereador.reduce(this.reducer('valor'), 0);
    },
    saldoTotalEmendas: function saldoTotalEmendas() {
      return this.emendasDoVereador.reduce(this.reducer('saldo'), 0);
    },
    valorUtilizadoEmendas: function valorUtilizadoEmendas() {
      return this.valorTotalEmendas - this.saldoTotalEmendas;
    }
  })
});

/***/ }),

/***/ "irGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__("bGai");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'emenda-save',
  components: {
    TheMask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["TheMask"],
    PDFImport: __WEBPACK_IMPORTED_MODULE_5__components__["I" /* PDFImport */]
  },
  data: function data() {
    return {
      label: 'Adicionar',
      vereadores: [],
      orgaos: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      hasEntidade: false,
      model: {
        ano: '',
        nome_orgao: '',
        sigla_orgao: '',
        termo_busca: '',
        valor: '',
        numero: '',
        numero_processo: '',
        vereador_id: '',
        resumo_utilizacao: '',
        descricao: '',
        observacao: '',
        nome_entidade: ''
      },
      carregando: false
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var id;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadVereadores();

            case 2:
              _context.next = 4;
              return _this.loadOrgaos();

            case 4:
              id = _this.$route.params.id;

              if (id) {
                _this.label = 'Editar';
                _this.loadModel(id);
              }

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    limparEntidade: function limparEntidade(e) {
      this.model.nome_entidade = '';
    },
    fetchVereadores: function fetchVereadores() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('vereadores/listar-vereadores');

              case 2:
                return _context2.abrupt('return', _context2.sent);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadVereadores: function loadVereadores() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var respVereador;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.fetchVereadores();

              case 2:
                respVereador = _context3.sent;

                _this3.vereadores = respVereador.data;

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    fetchSecretarias: function fetchSecretarias() {
      return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('unidade-organizacional/secretarias');
    },
    fetchOrgaos: function fetchOrgaos() {
      return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('unidade-organizacional/orgaos');
    },
    loadOrgaos: function loadOrgaos() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.fetchOrgaos();

              case 2:
                _ref = _context4.sent;
                data = _ref.data;

                _this4.orgaos = data;

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    loadNomeOrgao: function loadNomeOrgao() {
      var _this5 = this;

      var filter = function filter(o) {
        return o.sigla === _this5.model.sigla_orgao;
      };

      var _orgaos$filter = this.orgaos.filter(filter),
          _orgaos$filter2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_orgaos$filter, 1),
          orgao = _orgaos$filter2[0];

      this.model.nome_orgao = orgao.nome;
    },
    loadModel: function loadModel(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('emenda/' + id);

              case 2:
                response = _context5.sent;


                _this6.model = response.data;
                _this6.hasEntidade = !!_this6.model.nome_entidade;

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    toogleLoading: function toogleLoading() {
      this.carregando = !this.carregando;
    },
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Emenda salva com sucesso.');
      this.$router.push({ name: 'user_emendasparlamentares' });
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
      this.toogleLoading();
    },
    save: function save() {
      var _this7 = this;

      this.toogleLoading();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this7.toogleLoading();
          _this7.$refs[_this7.$validator.errors.items[0].field];
          _this7.$toastr.e(_this7.$validator.errors.items[0].msg);
          return;
        }
        if (_this7.model.id) {
          __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].put('emenda/' + _this7.model.id, _this7.model).then(_this7.saveSuccess).catch(_this7.saveFail);
        } else {
          __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('emenda', _this7.model).then(_this7.saveSuccess).catch(_this7.saveFail);
        }
      });
    }
  }
});

/***/ }),

/***/ "iw4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProcedimentosSaude',{attrs:{"title":_vm.especialidade,"termo-consulta":_vm.especialidade,"breadcrumb":_vm.breadcrumb,"urls":_vm.urls,"tipo":'especialidades'}},[_c('template',{slot:"header-slot"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        Aqui você encontra as solicitações agendadas da especialidade\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.especialidade))]),_vm._v(".\n      ")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jBdJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jCVy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__("be+e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43b10343_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__("/VVI");
function injectStyle (ssrContext) {
  __webpack_require__("FzUi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43b10343"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43b10343_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jCfh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emendasParlamentares; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_public_emendas_parlamentares__ = __webpack_require__("blu3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_public_emendas_parlamentares_EmendasPorArea__ = __webpack_require__("O64i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_public_emendas_parlamentares_EmendasPorVereador__ = __webpack_require__("zqOz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_public_emendas_parlamentares_DetalhesPorArea__ = __webpack_require__("qyzn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_public_emendas_parlamentares_DetalhesPorVereador__ = __webpack_require__("FNw0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_public_emendas_parlamentares_DetalhesPorAno__ = __webpack_require__("0wpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__const__ = __webpack_require__("4Nwh");








var emendasParlamentares = [{
  path: '/emendas_parlamentares',
  name: 'emendas_parlamentares',
  component: __WEBPACK_IMPORTED_MODULE_0__views_public_emendas_parlamentares__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_6__const__["a" /* DEFAULT_TITLE */] + ' | Emendas Parlamentares'
  }
}, {
  path: '/emendas_parlamentares/emendas-por-area',
  name: 'emendas_por_area',
  component: __WEBPACK_IMPORTED_MODULE_1__views_public_emendas_parlamentares_EmendasPorArea__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_6__const__["a" /* DEFAULT_TITLE */] + ' | Emendas por \xC1rea'
  }
}, {
  path: '/emendas_parlamentares/emendas-por-vereador',
  name: 'emendas_por_vereador',
  component: __WEBPACK_IMPORTED_MODULE_2__views_public_emendas_parlamentares_EmendasPorVereador__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_6__const__["a" /* DEFAULT_TITLE */] + ' | Emendas por Vereador'
  }
}, {
  path: '/emendas_parlamentares/detalhe-por-area/:secretaria',
  name: 'emendas_detalhe_por_area',
  component: __WEBPACK_IMPORTED_MODULE_3__views_public_emendas_parlamentares_DetalhesPorArea__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_6__const__["a" /* DEFAULT_TITLE */] + ' | Detalhes por \xC1rea'
  }
}, {
  path: '/emendas_parlamentares/detalhe-por-vereador/:vereador',
  name: 'emendas_detalhe_por_vereador',
  component: __WEBPACK_IMPORTED_MODULE_4__views_public_emendas_parlamentares_DetalhesPorVereador__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_6__const__["a" /* DEFAULT_TITLE */] + ' | Detalhes por Vereador'
  }
}, {
  path: '/emendas_parlamentares/detalhes-por-ano',
  name: 'emendas_detalhe_por_ano',
  component: __WEBPACK_IMPORTED_MODULE_5__views_public_emendas_parlamentares_DetalhesPorAno__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_6__const__["a" /* DEFAULT_TITLE */] + ' | Detalhes por Ano'
  }
}];

/***/ }),

/***/ "jDDP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTJweCIgaGVpZ2h0PSI1NXB4IiB2aWV3Qm94PSIwIDAgNTIgNTUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjYgKDY3NDkxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY28tc2Vydmlkb3I8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYzNC4wMDAwMDAsIC0yNC4wMDAwMDApIiBzdHJva2Utd2lkdGg9IjMiPgogICAgICAgICAgICA8ZyBpZD0iaWNvLXNlcnZpZG9yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2MzUuMDAwMDAwLCAyNi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJTdHJva2UtMSIgc3Ryb2tlPSIjNjdCNDUwIiBwb2ludHM9IjMuNzg1NCAzNC4xNDg4IDAuODIyNCAzNC4xNDg4IDAuODIyNCA0Mi40NDQ4IDQ5LjE3ODQgNDIuNDQ0OCA0OS4xNzg0IDM0LjE0ODggNDYuMTM5NCAzNC4xNDg4IDQ2LjEzNzQgMTQuODA5OCA0OS4xNzg0IDE0LjgwOTggNDkuMTc4NCA3Ljc0MTggNDMuOTAyNCA3Ljc0MTggNDMuOTAyNCA0LjM4MjggMzcuOTAyNCA0LjM5MDggMzcuODk2NCAwLjExMTggMTEuODI0NCAwLjExMTggMTEuNzg2NCA0Ljc4MzggNS43ODY0IDQuODE2OCA1Ljc4NjQgOC4yMjA4IDAuODIyNCA4LjIyMDggMC44MjI0IDE0LjczMDggMy43ODY0IDE0LjczMDgiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik00LjI3NjYsNDYuNjczNyBMNDUuNzIzNiw0Ni42NzM3IiBpZD0iU3Ryb2tlLTIiIHN0cm9rZT0iIzE0NDc3QyI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTEwLjI4MzQsNTEuMTc5IEwzOS43MTc0LDUxLjE3OSIgaWQ9IlN0cm9rZS0zIiBzdHJva2U9IiMxNDQ3N0MiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zNC4wOSw0Mi40NDUxIEwzNC4wOSwzNi4xODQxIEMzNC4wOSwzNC40NDQxIDM1LjY1LDMzLjAzMzEgMzcuNTczLDMzLjAzMzEgQzM5LjQ5NywzMy4wMzMxIDQxLjA1NywzNC40NDQxIDQxLjA1NywzNi4xODQxIEw0MS4wNTcsNDIuNDQ1MSIgaWQ9IlN0cm9rZS00IiBzdHJva2U9IiM2N0I0NTAiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMS41MTY4LDQyLjQ0NTEgTDIxLjUxNjgsMzYuMTg0MSBDMjEuNTE2OCwzNC40NDQxIDIzLjA3NjgsMzMuMDMzMSAyNC45OTk4LDMzLjAzMzEgQzI2LjkyMzgsMzMuMDMzMSAyOC40ODM4LDM0LjQ0NDEgMjguNDgzOCwzNi4xODQxIEwyOC40ODM4LDQyLjQ0NTEiIGlkPSJTdHJva2UtNiIgc3Ryb2tlPSIjNjdCNDUwIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNOC45NDM2LDQyLjQ0NTEgTDguOTQzNiwzNi4xODQxIEM4Ljk0MzYsMzQuNDQ0MSAxMC41MDM2LDMzLjAzMzEgMTIuNDI1NiwzMy4wMzMxIEMxNC4zNDk2LDMzLjAzMzEgMTUuOTA5NiwzNC40NDQxIDE1LjkwOTYsMzYuMTg0MSBMMTUuOTA5Niw0Mi40NDUxIiBpZD0iU3Ryb2tlLTgiIHN0cm9rZT0iIzY3QjQ1MCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJTdHJva2UtMTAiIHN0cm9rZT0iIzY3QjQ1MCIgcG9pbnRzPSIzNC4wOSAyOS4wNzExIDM0LjA5IDE0LjczMTEgNDEuMDU3IDE0LjczMTEgNDEuMDU3IDI5LjA3MTEiPjwvcG9seWxpbmU+CiAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlN0cm9rZS0xMiIgc3Ryb2tlPSIjNjdCNDUwIiBwb2ludHM9IjIxLjUxNjggMjkuMDcxMSAyMS41MTY4IDE0LjczMTEgMjguNDgzOCAxNC43MzExIDI4LjQ4MzggMjkuMDcxMSI+PC9wb2x5bGluZT4KICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iU3Ryb2tlLTE0IiBzdHJva2U9IiM2N0I0NTAiIHBvaW50cz0iOC45NDM2IDI5LjA3MTEgOC45NDM2IDE0LjczMTEgMTUuOTA5NiAxNC43MzExIDE1LjkwOTYgMjkuMDcxMSI+PC9wb2x5bGluZT4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zMy4xNDY3LDkuNDQzMiBMMzcuMDg5Nyw5LjQ0MzIiIGlkPSJTdHJva2UtMTYiIHN0cm9rZT0iIzY3QjQ1MCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTIzLjAyODUsOS40NDMyIEwyNi45NzE1LDkuNDQzMiIgaWQ9IlN0cm9rZS0xOCIgc3Ryb2tlPSIjNjdCNDUwIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTIuOTA5NCw5LjQ0MzIgTDE2Ljg1MzQsOS40NDMyIiBpZD0iU3Ryb2tlLTIwIiBzdHJva2U9IiM2N0I0NTAiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMS43ODYzLDQuNzgzNSBMMjYuOTcyMyw0Ljc4MzUiIGlkPSJTdHJva2UtMjIiIHN0cm9rZT0iIzY3QjQ1MCI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "jDVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_side_modal_vue__ = __webpack_require__("tO7f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4709cdcb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_side_modal_vue__ = __webpack_require__("v0+V");
function injectStyle (ssrContext) {
  __webpack_require__("1wGp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4709cdcb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_side_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4709cdcb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_side_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jJwK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"modal fade",attrs:{"id":"modal_input","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('header',[_c('i',{staticClass:"fa fa-exclamation-triangle fa-4x"}),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.titulo))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.descricao))])]),_vm._v(" "),_c('main',[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"rows":"6","placeholder":_vm.placeholder,"maxlength":"500"},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.value},on:{"click":_vm.ok}},[_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.btnRemoveText=='Remover'),expression:"btnRemoveText=='Remover'"}],attrs:{"icon":'save'}}),_vm._v(" "),_c('i',{staticClass:"fa fa-check"}),_vm._v(" Salvar\n                ")],1),_vm._v(" "),_c('button',{class:[ 'btn', { 'btn-primary': _vm.btnRemoveText=='Remover' }, { 'btn-danger': _vm.btnRemoveText !='Remover' }],attrs:{"type":"button","disabled":!_vm.value},on:{"click":_vm.startRemove}},[_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.btnRemoveText=='Remover'),expression:"btnRemoveText=='Remover'"}],attrs:{"icon":'eraser'}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.btnRemoveText))])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.hide}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Fechar")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jOZS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jTs1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_footer__ = __webpack_require__("Bnh8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_receitas_despesas_types__ = __webpack_require__("5BtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accessibility__ = __webpack_require__("/qkq");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'index',
  components: {
    rodape: __WEBPACK_IMPORTED_MODULE_0__components_footer__["a" /* default */]
  },
  mounted: function mounted() {
    var options = {
      labels: {
        resetTitle: 'Reiniciar',
        closeTitle: 'Fechar',
        menuTitle: 'Acessibilidade',
        increaseText: 'Aumentar texto',
        decreaseText: 'Diminuir texto',
        increaseTextSpacing: 'Aumentar espaçamento',
        decreaseTextSpacing: 'Diminuir espaçamento',
        invertColors: 'Alto contraste',
        grayHues: 'Tons de cinza',
        underlineLinks: 'Sublinhar links'
      },
      modules: {
        bigCursor: false,
        readingGuide: false,
        disableAnimations: false,
        textToSpeech: false,
        speechToText: false,
        increaseLineHeight: false,
        decreaseLineHeight: false
      },
      hotkeys: {
        enabled: false
      },
      session: {
        persistent: false
      }
    };

    var instance = new __WEBPACK_IMPORTED_MODULE_2_accessibility__["Accessibility"](options);

    setTimeout(function () {
      if (instance.menuInterface) {
        instance.menuInterface.increaseText = function () {
          if (instance.sessionState.textSize < 5) {
            instance.alterTextSize(true);
          } else {
            instance.resetTextSize();
          }
        };
        instance.menuInterface.decreaseText = function () {
          if (instance.sessionState.textSize <= 5 && instance.sessionState.textSize > -2) {
            instance.alterTextSize(false);
          } else {
            instance.resetTextSize();
          }
        };

        instance.menuInterface.increaseTextSpacing = function () {
          if (instance.sessionState.textSpace < 5) {
            instance.alterTextSpace(true);
          } else {
            instance.resetTextSpace();
          }
        };
        instance.menuInterface.decreaseTextSpacing = function () {
          if (instance.sessionState.textSpace <= 5 && instance.sessionState.textSpace > -3) {
            instance.alterTextSpace(false);
          } else {
            instance.resetTextSpace();
          }
        };
      } else {
        console.warn("Não foi possivel carregar o menuInterface");
      }
    }, 500);
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$store.dispatch('loadReceitasProprias').then(function () {}).catch(function () {
      _this.$toastr.e('Houve um problema ao carregar as informações de Receitas do ano atual. A página estará com as informações indisponíveis.');
    });

    this.$store.dispatch('loadDetalhamentoDespesas').then(function () {}).catch(function () {
      _this.$toastr.e('Houve um problema ao carregar as informações de Despesas do ano atual. A página estará com as informações indisponíveis.');
    });

    this.$store.dispatch('loadGrupoDespesas').then(function () {}).catch(function () {
      _this.$toastr.e('Houve um problema ao carregar as informações de Despesas por grupo. A página estará com as informações indisponíveis.');
    });

    this.$store.dispatch('loadFuncaoSubfuncao').then(function () {}).catch(function () {
      _this.$toastr.e('Houve um problema ao carregar as informações de Despesas por função e subfunção. A página estará com as informações indisponíveis.');
    });

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_modules_receitas_despesas_types__["h" /* TOGGLE_LOADING */]);

    this.$store.dispatch('loadDespesasDetalhadas').then(function () {}).catch(function (error) {
      _this.$toastr.e('Houve um problema ao carregar as informações de Despesas detalhadas. A página estará com as informações indisponíveis.');
    }).finally(function () {
      return _this.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_modules_receitas_despesas_types__["h" /* TOGGLE_LOADING */]);
    });
  }
});

/***/ }),

/***/ "jqvm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"procedimentos-saude"},[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":'Minha Saúde'}},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n          Aqui você acessa o seu histórico de atendimentos na Rede Municipal\n          de Saúde de Santos. Também poderá acompanhar o agendamento de\n          consultas de especialidades e exames.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Caso não saiba o número do seu cartão SUS, você pode consultá-lo\n          através do portal \"Meu SUS Digital\". Clique no logo abaixo para\n          acessá-lo:\n        ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://meususdigital.saude.gov.br/login","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"portal-govbr margem-bottom",attrs:{"src":__webpack_require__("c/cq"),"alt":"Logo com o link do portal Meu SUS Digital"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Link para o portal Conecte SUS")])]),_vm._v(" "),_c('p',[_vm._v("\n          Para mais informações, ligue na central de agendamento:\n          0800-013-0013\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:[
              'form-group',
              { 'has-error': _vm.errors.has('filtro-cartao') }
            ]},[_c('label',{staticClass:"font-lg",attrs:{"for":"filtro-cartao"}},[_vm._v("\n              Pesquisar meu histórico de saúde - Cartão SUS\n            ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:('required|length:15'),expression:"'required|length:15'"}],ref:"filtro-cartao",staticClass:"form-control",attrs:{"id":"filtro-cartao","name":"filtro-cartao","placeholder":"Digite o nº do seu cartão SUS...","data-vv-as":"cartão SUS","mask":'###############'},model:{value:(_vm.filtroCartao),callback:function ($$v) {_vm.filtroCartao=$$v},expression:"filtroCartao"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default btn-border",on:{"click":function($event){return _vm.pesquisarPorCartao()}}},[_c('span',{staticClass:"sr-only"},[_vm._v(" Botão ")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":'search'}})],1)])],1),_vm._v(" "),(_vm.errors.has('filtro-cartao'))?_c('input-error-message',{attrs:{"message":_vm.errors.first('filtro-cartao')}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',{staticClass:"font-lg",attrs:{"for":"lista-especialidades"}},[_vm._v("\n            Ver a lista por especialidade\n          ")]),_vm._v(" "),(_vm.loading.especialidades)?_c('font-awesome-icon',{staticClass:"font-lg",attrs:{"icon":'spinner',"spin":""}}):_c('v-select',{staticClass:"style-chooser",attrs:{"id":"lista-especialidades","name":"lista-especialidades","placeholder":"-- Selecione uma Especialidade --","options":_vm.especialidades},on:{"input":function($event){return _vm.routeToPage('especialidade')}},model:{value:(_vm.model.especialidade),callback:function ($$v) {_vm.$set(_vm.model, "especialidade", $$v)},expression:"model.especialidade"}},[_c('template',{slot:"no-options"},[_vm._v("\n              Nenhum resultado encontrado\n            ")])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',{staticClass:"font-lg",attrs:{"for":"lista-exames"}},[_vm._v("\n            Ver a lista por exames\n          ")]),_vm._v(" "),(_vm.loading.exames)?_c('font-awesome-icon',{staticClass:"font-lg",attrs:{"icon":'spinner',"spin":""}}):_c('v-select',{staticClass:"style-chooser",attrs:{"id":"lista-exames","name":"lista-exames","placeholder":"-- Selecione um Exame --","options":_vm.exames},on:{"input":function($event){return _vm.routeToPage('exame')}},model:{value:(_vm.model.exame),callback:function ($$v) {_vm.$set(_vm.model, "exame", $$v)},expression:"model.exame"}},[_c('template',{slot:"no-options"},[_vm._v("\n              Nenhum resultado encontrado\n            ")])],2)],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('EstatisticaTotalAgendamentos')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n            O que você deseja?\n          ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-center"},[_c('h3',[_vm._v("Estatísticas")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jzC+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k/S7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k0f5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"panel panel-default"},[(!!_vm.title)?_c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"custom-font"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_vm._t("filters")],2),_vm._v(" "),_c('div',{staticClass:"row margem-topo form-group"},[_c('div',{staticClass:"col-xs-12"},[(_vm.showPrintButton)?_c('print-table',{staticClass:"pull-right hidden-xs",attrs:{"title":_vm.reportTitle,"fields":_vm.fieldsDefinition,"api-url":_vm.restUrl,"append-params":_vm.params}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"actions pull-left"},[_vm._t("actions")],2),_vm._v(" "),(_vm.showColumnVisibilityButton)?_c('column-visibility',{staticClass:"pull-right hidden-xs",attrs:{"fields":_vm.fieldsDefinition},on:{"update:fields":function($event){_vm.fieldsDefinition=$event}}}):_vm._e(),_vm._v(" "),_c('pulse-loader',{attrs:{"loading":_vm.carregando}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"overflow":"auto"}},[_c('vuetable',{ref:"vuetable",staticClass:"custom-table-font",attrs:{"load-on-start":_vm.loadOnStart,"api-url":_vm.restUrl,"api-mode":_vm.apiMode,"fields":_vm.fieldsDefinition,"css":_vm.css.table,"data-path":_vm.dataPath,"data":_vm.data,"http-options":_vm.auth,"pagination-path":_vm.paginationPath,"per-page":_vm.itemsPerPage,"append-params":_vm.params,"muti-sort":_vm.multiSort,"multi-sort-key":_vm.multiSortKey,"initial-page":_vm.initialPage,"no-data-template":"Nenhum registro encontrado."},on:{"vuetable:loading":function($event){_vm.carregando = true},"vuetable:loaded":function($event){_vm.carregando = false},"vuetable:pagination-data":_vm.onPaginationData,"vuetable:load-success":_vm.onSuccess,"vuetable:load-error":_vm.onError},scopedSlots:_vm._u([{key:"icon",fn:function(props){return [_vm._t("icon",null,{"rowData":props.rowData})]}},{key:"icon1",fn:function(props){return [_vm._t("ano1",null,{"rowData":props.rowData})]}},{key:"icon2",fn:function(props){return [_vm._t("ano2",null,{"rowData":props.rowData})]}},{key:"icon3",fn:function(props){return [_vm._t("ano3",null,{"rowData":props.rowData})]}},{key:"icon4",fn:function(props){return [_vm._t("ano4",null,{"rowData":props.rowData})]}},{key:"column_custom",fn:function(props){return [_vm._t("custom",null,{"rowData":props.rowData})]}},{key:"column_custom_2",fn:function(props){return [_vm._t("custom_2",null,{"rowData":props.rowData})]}},{key:"actions",fn:function(props){return [_vm._t("rowrender",null,{"rowData":props.rowData})]}},_vm._l((_vm.slots),function(item){return {key:item,fn:function(props){return [_vm._t(item,null,{"rowData":props.rowData})]}}})],null,true)},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('template',{slot:"noDataTemplate"},[_c('pulse-loader',{attrs:{"loading":_vm.carregando}})],1)],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"panel-footer"},[_c('pagination',{ref:"pagination",attrs:{"css":_vm.css.pagination,"icons":_vm.css.icons},on:{"vuetable-pagination:change-page":_vm.onChangePage}}),_vm._v(" "),_c('pagination-info',{ref:"paginationInfo",staticClass:"pull-left custom-table-font",attrs:{"css":_vm.css.paginationInfo,"info-template":"Registro(s) {from} ao {to} de um total de {total}","no-data-template":"Nenhum registro"}}),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k0wL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MensagemErro__ = __webpack_require__("3FI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cargos__ = __webpack_require__("LXnX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArquivosEdital_vue__ = __webpack_require__("6QmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Message: __WEBPACK_IMPORTED_MODULE_1__MensagemErro__["a" /* default */], Cargos: __WEBPACK_IMPORTED_MODULE_2__Cargos__["a" /* default */], ArquivosEdital: __WEBPACK_IMPORTED_MODULE_3__ArquivosEdital_vue__["a" /* default */] },
  data: function data() {
    return {
      carregando: false,
      model: {}
    };
  },
  created: function created() {
    this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      publicado: 1
    }, this.$route.params);
  },

  methods: {
    handleLoading: function handleLoading() {
      this.carregando = !this.carregando;
    },
    montarTitulo: function montarTitulo() {
      return this.model.id ? 'Alterar edital - ' + this.model.numero : 'Inserir edital';
    },
    salvar: function salvar() {
      var _this = this;

      this.handleLoading();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.handleLoading();
          _this.$refs[_this.$validator.errors.items[0].field].focus();
          _this.$toastr.e(_this.$validator.errors.items[0].msg);
          return;
        }

        var id = _this.model.id;

        if (id) {
          __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].put('edital/' + id, _this.model).then(_this.saveSuccess).catch(_this.saveFail).finally(function () {
            return _this.handleLoading();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('edital', _this.model).then(_this.saveSuccess).catch(_this.saveFail).finally(function () {
            return _this.handleLoading();
          });
        }
      });
    },
    saveSuccess: function saveSuccess(response) {
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data);
      this.$toastr.s('Edital salvo com sucesso.');
    },
    saveFail: function saveFail(error) {
      this.$toastr.s('Houve um erro ao salvar o edital, verifique as informações e tente novamente.');
    }
  }
});

/***/ }),

/***/ "k2k2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assistencia; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_assistencia_pagamentos___ = __webpack_require__("57pT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_assistencia_pagamentos_Edit__ = __webpack_require__("QzpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_assistencia_pagamentos_Save__ = __webpack_require__("dZPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_admin_assistencia_beneficios___ = __webpack_require__("ESfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_admin_assistencia_beneficios_Save__ = __webpack_require__("psVR");






var assistencia = [{
  path: 'assistencia',
  redirect: 'assistencia/beneficios',
  component: function component() {
    return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "AOj5"));
  },
  children: [{
    path: 'pagamentos',
    component: __WEBPACK_IMPORTED_MODULE_0__views_admin_assistencia_pagamentos___["a" /* default */],
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  }, {
    path: 'pagamentos/edit',
    name: 'pagamentos_edit',
    component: __WEBPACK_IMPORTED_MODULE_1__views_admin_assistencia_pagamentos_Edit__["a" /* default */],
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  }, {
    path: 'load',
    component: __WEBPACK_IMPORTED_MODULE_2__views_admin_assistencia_pagamentos_Save__["a" /* default */],
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  }, {
    path: 'beneficios',
    component: __WEBPACK_IMPORTED_MODULE_3__views_admin_assistencia_beneficios___["a" /* default */],
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  }, {
    path: 'beneficios/edit',
    name: 'beneficios_edit',
    component: __WEBPACK_IMPORTED_MODULE_4__views_admin_assistencia_beneficios_Save__["a" /* default */],
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  }]
}];

/***/ }),

/***/ "k4YG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k82x":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "kBtK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lista-unidades"},[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":_vm.remedio.principio_ativo || _vm.principio_ativo}},[_c('div',{staticClass:"col-xs-12 font-lg"},[(_vm.remedio.portaria === '344/98')?_c('p',[_vm._v("\n          Medicamento Controlado - Portaria 344/98\n        ")]):_vm._e(),_vm._v(" "),(_vm.remedio.portaria === '471/2021')?_c('p',[_vm._v("\n          Medicamento Antimicrobiano - RDC 471/2021\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',{staticClass:"subheader"},[_vm._v("\n          Veja abaixo as unidades que possuem o medicamento pesquisado.\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":[
          { label: 'Remédio Fácil', link: '/remedio-facil' },
          { label: _vm.remedio.principio_ativo || _vm.principio_ativo }
        ]}}),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.remedio.orientacao)?_c('div',{staticClass:"col-xs-12 form-group"},[_c('CriterioRemedio',{attrs:{"remedio":_vm.remedio}})],1):_vm._e()]),_vm._v(" "),_vm._m(0),_vm._v(" "),(!_vm.carregando)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('OpenMap',{ref:"mapa",staticClass:"border-map",attrs:{"pins":_vm.pins}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.carregando)?_c('div',{staticClass:"col-xs-12 loading-unidades"},[_c('span',[_vm._v("Carregando unidades")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":'spinner',"size":"2x","spin":""}})],1):_c('div',{staticClass:"lista"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._l((_vm.unidades),function(unidade){return _c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('router-link',{attrs:{"to":{
                name: 'detalhe-unidade',
                params: {
                  detalhes: unidade.unidade_saude,
                  apelido: unidade.apelido,
                  unidade: unidade,
                  unidadesComRemedio: _vm.unidades,
                  remedio: _vm.remedio,
                  principio_ativo: _vm.principio_ativo
                }
              }}},[_c('div',{staticClass:"card card-badge"},[(_vm.isAvailable(unidade.saldo))?_c('span',{staticClass:"label label-success"},[_vm._v("\n                  Disponível\n                ")]):_c('span',{staticClass:"label label-danger"},[_vm._v("\n                  Indisponível\n                ")]),_vm._v("\n                "+_vm._s(unidade.apelido || unidade.unidade_saude)+"\n              ")])])],1)})],2),_vm._v(" "),(!_vm.carregando && _vm.unidades.length == 0)?_c('div',{staticClass:"col-xs-12 font-lg text-center"},[_c('span',[_vm._v("\n            Nenhuma unidade encontrada para o medicamento\n            "+_vm._s(_vm.remedio.principio_ativo || _vm.principio_ativo)+"\n          ")])]):_vm._e()])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Lista de unidades")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 form-group"},[_c('span',{staticClass:"label label-success"},[_vm._v("Disponível")]),_vm._v(" - Estoque\n            disponível\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 form-group"},[_c('span',{staticClass:"label label-danger"},[_vm._v("Indisponível")]),_vm._v(" - Estoque\n            indisponível\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('p',{},[_c('b',[_vm._v("Observação:")]),_vm._v(" A disponibilidade dos estoques está sujeita a\n              variações. Pode conter diferença entre Sistema e estoque físico\n              em períodos de 24h.\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kEG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      portais: [{
        titulo: 'Assistência Social',
        descricao: 'Benefícios assistenciais e auxílios',
        nome_rota: 'beneficios_auxilios',
        show: true
      }, {
        titulo: 'Concursos Publicos',
        descricao: 'Portal dos concursos publicos vigentes',
        nome_rota: 'concursos',
        show: true
      }, {
        titulo: 'Gastos e Consumo',
        descricao: 'Gastos da Prefeitura com consumo de água/luz',
        nome_rota: 'gastos_consumo',
        show: true
      }, {
        titulo: 'Conselho Tutelar',
        descricao: 'Resultado das eleições do Conselho Tutelar',
        nome_rota: 'eleicao_conselho',
        show: true
      }, {
        titulo: 'Dívida Ativa',
        descricao: 'Lista de devedores da dívida ativa do município',
        nome_rota: 'divida-ativa',
        show: true
      }, {
        titulo: 'Emendas Parlamentares',
        descricao: 'Listas de emendas parlamentares registradas no ano atual e em anos anteriores',
        nome_rota: 'emendas_parlamentares',
        show: true
      }, {
        titulo: 'Gestão',
        descricao: 'Materiais padronizados',
        nome_rota: 'materiais',
        show: true
      }, {
        titulo: 'Plano de Governo',
        descricao: 'Plano municipal de governo',
        nome_rota: 'planodegoverno',
        show: true
      }, {
        titulo: 'Plano de Metas',
        descricao: 'Plano municipal de metas',
        nome_rota: 'planometas',
        show: true
      }, {
        titulo: 'Planos Municipais',
        descricao: 'Planos Municipais',
        nome_rota: 'planosmunicipal',
        show: true
      }, {
        titulo: 'Minha Saúde',
        descricao: 'Fila de espera dos procedimentos da saúde',
        nome_rota: 'procedimentos_saude',
        // nome_rota: 'manutencao',
        show: true
      }, {
        titulo: 'Movimentos ODS',
        descricao: 'Aqui você localiza todos os movimentos ODS que as instituições estão organizando.',
        nome_rota: 'movimentos_ods',
        show: true
      }, {
        titulo: 'Prestação de Contas',
        descricao: 'Prestação de contas das entidades do terceiro setor',
        nome_rota: 'prestacao_contas',
        show: true
      }, {
        titulo: 'Receitas e Despesas',
        descricao: 'Portal analítico de receitas e despesas',
        nome_rota: 'receitas_despesas',
        show: true
      }, {
        titulo: 'Remédio Fácil',
        descricao: 'Aqui você localiza os medicamentos distribuidos pela rede de saúde municipal',
        nome_rota: 'remedio',
        // nome_rota: 'manutencao',
        show: true
      }, {
        titulo: 'Saúde',
        descricao: 'Escalas de Plantão',
        nome_rota: 'escalas',
        show: true
      }]
    };
  }
});

/***/ }),

/***/ "kHjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'materiais-padronizados-new-save',
  data: function data() {
    return {
      label: 'Adicionar',
      model: {
        referencia: '',
        nome: '',
        descricao: '',
        medida_codigo: '',
        subgrupo_codigo: '',
        grupo_codigo: ''
      },
      carregando: false,
      medidas: [],
      subgrupos: [],
      grupos: []
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var id = this.$router.history.current.params.id;

    if (id) {
      this.label = 'Editar';
      this.loadModel(id);
    } else {
      this.loadMedidas();
      this.loadGrupos();
    }
  },

  methods: {
    loadGrupos: function loadGrupos() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var respGrupo, grupo, respSubgrupo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchGrupos();

              case 2:
                respGrupo = _context.sent;
                grupo = respGrupo.data.grupo_codigo;
                _context.next = 6;
                return _this.fetchSubgrupos(grupo);

              case 6:
                respSubgrupo = _context.sent;


                _this.grupos = respGrupo.data;
                _this.subgrupos = respSubgrupo.data;

                _this.model.grupo_codigo = _this.grupos[0].codigo;
                _this.model.subgrupo_codigo = _this.subgrupos[0].codigo;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchGrupos: function fetchGrupos() {
      return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('materiais/listar-grupos');
    },
    loadSubgrupos: function loadSubgrupos() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var grupo, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                grupo = _this2.model.grupo_codigo;
                _context2.next = 3;
                return _this2.fetchSubgrupos(grupo);

              case 3:
                response = _context2.sent;

                _this2.subgrupos = response.data;
                _this2.model.subgrupo_codigo = _this2.subgrupos[0].codigo;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchSubgrupos: function fetchSubgrupos(grupo) {
      return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('materiais/listar-subgrupos', { params: { grupo: grupo } });
    },
    loadMedidas: function loadMedidas() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.fetchMedidas();

              case 2:
                response = _context3.sent;

                _this3.medidas = response.data;
                if (!_this3.model.medida_codigo) _this3.model.medida_codigo = _this3.medidas[0].codigo;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    fetchMedidas: function fetchMedidas() {
      return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('materiais/lista-medidas');
    },
    loadModel: function loadModel(id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, responseMedidas, responseGrupos, grupo, responseSubgrupos;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('material/' + id);

              case 2:
                response = _context4.sent;
                _context4.next = 5;
                return _this4.fetchMedidas();

              case 5:
                responseMedidas = _context4.sent;
                _context4.next = 8;
                return _this4.fetchGrupos();

              case 8:
                responseGrupos = _context4.sent;
                grupo = responseGrupos.data.codigo;
                _context4.next = 12;
                return _this4.fetchSubgrupos(grupo);

              case 12:
                responseSubgrupos = _context4.sent;


                _this4.medidas = responseMedidas.data;
                _this4.grupos = responseGrupos.data;
                _this4.subgrupos = responseSubgrupos.data;

                _this4.model = response.data;

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    toogleLoading: function toogleLoading() {
      this.carregando = !this.carregando;
    },
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Este item foi salvo com sucesso.');
      this.$router.push({ name: 'user_material' });
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
      this.toogleLoading();
    },
    save: function save() {
      var _this5 = this;

      this.toogleLoading();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this5.$refs[_this5.$validator.errors.items[0].field].focus();
          _this5.$toastr.e(_this5.$validator.errors.items[0].msg);
          return;
        }
      });

      // update
      if (this.model.codigo) {
        __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].put('material/' + this.model.codigo, this.model).then(this.saveSuccess).catch(this.saveFail);
      } else {
        // add
        __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('material', this.model).then(this.saveSuccess).catch(this.saveFail);
      }
    }
  }
});

/***/ }),

/***/ "kKoq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Datepicker__ = __webpack_require__("eOZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_planogoverno_SideAcao_vue__ = __webpack_require__("WgxL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__request__ = __webpack_require__("OOvn");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { list: __WEBPACK_IMPORTED_MODULE_3__components_common_DataTable__["a" /* default */], datepicker: __WEBPACK_IMPORTED_MODULE_4__components_common_Datepicker__["a" /* default */], SideAcao: __WEBPACK_IMPORTED_MODULE_5__components_planogoverno_SideAcao_vue__["a" /* default */] },
    data: function data() {
        return {
            fields: [{
                name: 'unidade_executora',
                title: 'Unidade Executora',
                sortField: 'unidade_executora',
                dataClass: 'align-middle',
                filterable: true
            }, {
                name: 'descritivo',
                title: 'Descritivo',
                sortField: 'descritivo',
                dataClass: 'align-middle truncate-multiline',
                filterable: true,
                callback: function callback(value) {
                    if (!value) return '';
                    return value.length > 150 ? value.substring(0, 97) + '...' : value;
                }
            }, {
                name: 'data_estimada_inicio',
                title: 'Inicia',
                sortField: 'data_estimada_inicio',
                titleClass: 'text-center',
                dataClass: 'text-center align-middle',
                filterable: true
            }, {
                name: 'data_estimada_conclusao',
                title: 'Finaliza',
                sortField: 'data_estimada_conclusao',
                titleClass: 'text-center',
                dataClass: 'text-center align-middle',
                filterable: true
            }, {
                name: 'status',
                title: 'Status',
                sortField: 'status',
                titleClass: 'text-center text-nowrap',
                dataClass: 'text-center text-nowrap',
                filterable: true
            }, {
                name: '__slot:actions',
                title: 'Ações',
                titleClass: 'text-center col-md-3',
                dataClass: 'text-center'
            }],
            listas: {
                secretarias: [],
                autarquias: [],
                status: ['Não Iniciado', 'Em andamento', 'Concluído', 'Cancelada', 'Rejeitada'],
                prazos: [{ value: 'inicio_30', text: 'Início em 30 dias' }, { value: 'inicio_60', text: 'Início em 60 dias' }, { value: 'finaliza_30', text: 'Término em 30 dias' }, { value: 'finaliza_60', text: 'Término em 60 dias' }]
            },
            sideConfig: [{
                titulo: 'Concluir',
                subtitulo: '',
                subtDetalhe: '',
                largura: 500,
                identidade: 'concluir',
                abreProximo: false,
                aberto: false,
                data: null
            }, {
                titulo: 'Iniciar',
                subtitulo: '',
                subtDetalhe: '',
                largura: 500,
                identidade: 'iniciar',
                abreProximo: false,
                aberto: false,
                data: null
            }, {
                titulo: 'Detalhes',
                subtitulo: '',
                subtDetalhe: '',
                largura: 500,
                identidade: 'detalhes',
                abreProximo: false,
                aberto: false,
                data: null
            }, {
                titulo: 'Editar',
                subtitulo: '',
                subtDetalhe: '',
                largura: 500,
                identidade: 'editar',
                abreProximo: false,
                aberto: false,
                data: null
            }, {
                titulo: 'Cancelar',
                subtitulo: '',
                subtDetalhe: '',
                largura: 500,
                identidade: 'cancelar',
                abreProximo: false,
                aberto: false,
                data: null
            }, {
                titulo: 'Aceitar',
                subtitulo: '',
                subtDetalhe: '',
                largura: 500,
                identidade: 'aceitar',
                abreProximo: false,
                aberto: false,
                data: null
            }],
            responsaveisCache: {}
        };
    },

    computed: {
        filtros: function filtros() {
            return {
                descritivo: this.descritivo,
                status: this.status,
                prazo: this.prazo
            };
        },

        pagina: {
            get: function get() {
                var minhasAcoes = this.$store.state.vuetableState.minhasAcoes;
                var pagina = minhasAcoes.pagina;

                return pagina;
            },
            set: function set(value) {
                this.$store.commit('SET_FILTER_PAGE', {
                    collection: 'minhasAcoes',
                    value: value
                });
            }
        },
        descritivo: {
            get: function get() {
                return this.$store.state.vuetableState.minhasAcoes.filtros.descritivo || '';
            },
            set: function set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'descritivo',
                    collection: 'minhasAcoes',
                    value: value
                });
                this.resetPageStore();
            }
        },
        status: {
            get: function get() {
                return this.$store.state.vuetableState.minhasAcoes.filtros.status || '';
            },
            set: function set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'status',
                    collection: 'minhasAcoes',
                    value: value
                });
                this.resetPageStore();
            }
        },
        prazo: {
            get: function get() {
                return this.$store.state.vuetableState.minhasAcoes.filtros.prazo || '';
            },
            set: function set(value) {
                this.$store.commit('SET_FILTER_FIELD', {
                    field: 'prazo',
                    collection: 'minhasAcoes',
                    value: value
                });
                this.resetPageStore();
            }
        }
    },
    methods: {
        consultar: function consultar() {
            var _this = this;

            this.$nextTick(function () {
                _this.$refs.vuetable.refresh();
            });
        },
        limpar: function limpar() {
            this.descritivo = '';
            this.status = '';
            this.prazo = '';

            this.$refs.vuetable.refresh();
        },
        resetPageStore: function resetPageStore() {
            this.$store.commit('SET_FILTER_PAGE', {
                collection: 'minhasAcoes',
                value: 1
            });
        },
        formatDate: function formatDate(date) {
            var year = date.getFullYear();
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var day = ('0' + date.getDate()).slice(-2);
            var hour = ('0' + date.getHours()).slice(-2);
            var minute = ('0' + date.getMinutes()).slice(-2);
            var second = ('0' + date.getSeconds()).slice(-2);

            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
        },
        detalhar: function detalhar(acao) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var painel;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                painel = _this2.sideConfig.find(function (p) {
                                    return p.identidade === 'detalhes';
                                });

                                painel.data = acao;
                                _this2.$refs.side.$emit('abreModal', 'detalhes');

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        concluir: function concluir(acao) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var painel;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                painel = _this3.sideConfig.find(function (p) {
                                    return p.identidade === 'concluir';
                                });

                                painel.data = acao;
                                _this3.$refs.side.$emit('abreModal', 'concluir');

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        iniciar: function iniciar(acao) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var painel;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                painel = _this4.sideConfig.find(function (p) {
                                    return p.identidade === 'iniciar';
                                });

                                painel.data = acao;
                                _this4.$refs.side.$emit('abreModal', 'iniciar');

                            case 3:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4);
            }))();
        },
        cancelar: function cancelar(acao) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var painel;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                painel = _this5.sideConfig.find(function (p) {
                                    return p.identidade === 'cancelar';
                                });

                                painel.data = acao;
                                _this5.$refs.side.$emit('abreModal', 'cancelar');

                            case 3:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            }))();
        },
        aceitar: function aceitar(acao) {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var painel;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                painel = _this6.sideConfig.find(function (p) {
                                    return p.identidade === 'aceitar';
                                });

                                painel.data = structuredClone(acao);
                                _this6.$refs.side.$emit('abreModal', 'aceitar');

                            case 3:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this6);
            }))();
        },
        editar: function editar(acao) {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var painel;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                painel = _this7.sideConfig.find(function (p) {
                                    return p.identidade === 'editar';
                                });

                                painel.data = structuredClone(acao);
                                _this7.$refs.side.$emit('abreModal', 'editar');

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this7);
            }))();
        },
        validateDates: function validateDates(acao) {
            if (acao.data_estimada_inicio && acao.data_estimada_conclusao) {
                var inicio = new Date(acao.data_estimada_inicio);
                var termino = new Date(acao.data_estimada_conclusao);

                if (termino < inicio) {
                    this.$toastr.e("A data de conclusão não pode ser anterior à data de início.");
                    return false;
                }
            }
            return true;
        },
        concluirAcao: function concluirAcao(acaoId) {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
                var _ref, status;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].put('planogoverno/compromisso-acao/' + acaoId, {
                                    status: 'Concluído',
                                    data_conclusao: _this8.formatDate(new Date())
                                });

                            case 2:
                                _ref = _context7.sent;
                                status = _ref.status;

                                if (!(status !== 200)) {
                                    _context7.next = 6;
                                    break;
                                }

                                return _context7.abrupt('return', _this8.$toastr.e('Erro ao concluir a ação.'));

                            case 6:

                                _this8.$toastr.s('Ação concluída com sucesso!');
                                _this8.$refs.vuetable.refresh();

                                _this8.$refs.side.$emit('fechaModal', 'concluir');

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this8);
            }))();
        },
        iniciarAcao: function iniciarAcao(acaoId) {
            var _this9 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
                var _ref2, status;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].put('planogoverno/compromisso-acao/' + acaoId, {
                                    status: 'Em andamento',
                                    data_inicio: _this9.formatDate(new Date())
                                });

                            case 2:
                                _ref2 = _context8.sent;
                                status = _ref2.status;

                                if (!(status !== 200)) {
                                    _context8.next = 6;
                                    break;
                                }

                                return _context8.abrupt('return', _this9.$toastr.e('Erro ao iniciar a ação.'));

                            case 6:

                                _this9.$toastr.s('Ação iniciada com sucesso!');
                                _this9.$refs.vuetable.refresh();

                                _this9.$refs.side.$emit('fechaModal', 'iniciar');

                            case 9:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this9);
            }))();
        },
        salvarEdicao: function salvarEdicao(acao) {
            var _this10 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
                var _ref3, status;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (_this10.validateDates(acao)) {
                                    _context9.next = 2;
                                    break;
                                }

                                return _context9.abrupt('return');

                            case 2:
                                _context9.prev = 2;
                                _context9.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].put('planogoverno/compromisso-acao/' + acao.id, {
                                    data_estimada_inicio: _this10.formatDate(new Date(acao.data_estimada_inicio)),
                                    data_estimada_conclusao: _this10.formatDate(new Date(acao.data_estimada_conclusao))
                                });

                            case 5:
                                _ref3 = _context9.sent;
                                status = _ref3.status;

                                if (!(status !== 200)) {
                                    _context9.next = 9;
                                    break;
                                }

                                return _context9.abrupt('return', _this10.$toastr.e('Erro ao salvar as datas da ação.'));

                            case 9:

                                _this10.$toastr.s('Datas da ação atualizadas com sucesso!');
                                _this10.$refs.vuetable.refresh();
                                _this10.$refs.side.$emit('fechaModal', 'editar');
                                _context9.next = 18;
                                break;

                            case 14:
                                _context9.prev = 14;
                                _context9.t0 = _context9['catch'](2);

                                console.error('Erro ao salvar as datas da ação: ', _context9.t0);
                                _this10.$toastr.e('Erro ao salvar as datas da ação.');

                            case 18:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this10, [[2, 14]]);
            }))();
        },
        aceitarAcao: function aceitarAcao(acao) {
            var _this11 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
                var _ref4, status, objeto;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (_this11.validateDates(acao)) {
                                    _context10.next = 2;
                                    break;
                                }

                                return _context10.abrupt('return');

                            case 2:
                                _context10.prev = 2;
                                _context10.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].put('planogoverno/compromisso-acao/' + acao.id, {
                                    data_inicio: _this11.formatDate(new Date(acao.data_estimada_inicio)),
                                    data_estimada_conclusao: _this11.formatDate(new Date(acao.data_estimada_conclusao))
                                });

                            case 5:
                                _ref4 = _context10.sent;
                                status = _ref4.status;

                                if (!(status != 200)) {
                                    _context10.next = 9;
                                    break;
                                }

                                return _context10.abrupt('return', _this11.$toastr.e('Erro ao aceitar a ação.'));

                            case 9:
                                objeto = JSON.parse(localStorage.getItem('acaoPerfil')) || { state: [] };

                                if (!objeto.state.includes(acao.id)) {
                                    objeto.state.push(acao.id);
                                    localStorage.setItem('acaoPerfil', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(objeto));
                                }

                                _this11.$toastr.s('Ação aceita com sucesso!');
                                _this11.$refs.vuetable.refresh();
                                _this11.$refs.side.$emit('fechaModal', 'aceitar');
                                _context10.next = 20;
                                break;

                            case 16:
                                _context10.prev = 16;
                                _context10.t0 = _context10['catch'](2);

                                console.error('Erro ao aceitar a ação: ', _context10.t0.response.data);
                                return _context10.abrupt('return', _this11.$toastr.e('Erro ao aceitar a ação.'));

                            case 20:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this11, [[2, 16]]);
            }))();
        },
        cancelarAcao: function cancelarAcao(_ref5) {
            var _this12 = this;

            var acao = _ref5.acao,
                justificativa = _ref5.justificativa;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
                var novoStatus, _ref6, status, objeto;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.prev = 0;
                                novoStatus = acao.unidade === acao.unidade_executora ? 'Cancelada' : 'Rejeitada';
                                _context11.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].put('planogoverno/compromisso-acao-profile/' + acao.id, {
                                    justificativa_rejeicao: justificativa,
                                    status: novoStatus
                                });

                            case 4:
                                _ref6 = _context11.sent;
                                status = _ref6.status;

                                if (!(status != 200)) {
                                    _context11.next = 8;
                                    break;
                                }

                                return _context11.abrupt('return', _this12.$toastr.e('Erro ao ' + (acao.unidade !== acao.unidade_executora ? 'rejeitar' : 'cancelar') + ' a a\xE7\xE3o.'));

                            case 8:
                                objeto = JSON.parse(localStorage.getItem('acaoPerfil')) || { state: [] };

                                if (!objeto.state.includes(acao.id)) {
                                    objeto.state.push(acao.id);
                                    localStorage.setItem('acaoPerfil', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(objeto));
                                }

                                _this12.$toastr.s('A\xE7\xE3o ' + (acao.unidade === acao.unidade_executora ? 'cancelada' : 'rejeitada') + ' com sucesso!');
                                _this12.$refs.vuetable.refresh();
                                _this12.$refs.side.$emit('fechaModal', 'cancelar');
                                _context11.next = 18;
                                break;

                            case 15:
                                _context11.prev = 15;
                                _context11.t0 = _context11['catch'](0);

                                _this12.$toastr.e('Erro ao ' + (acao.unidade === acao.unidade_executora ? 'cancelar' : 'rejeitar rejeição') + ' a a\xE7\xE3o.');

                            case 18:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this12, [[0, 15]]);
            }))();
        },
        saveActionState: function saveActionState(acao, status) {
            var _this13 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                if (status === 'Aceitar') {
                                    _this13.aceitar(acao);
                                } else if (status === 'Rejeitar') {
                                    _this13.cancelar(acao);
                                }

                            case 1:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this13);
            }))();
        },
        actionState: function actionState(id) {
            var objeto = JSON.parse(localStorage.getItem('acaoPerfil'));
            return objeto && objeto.state.includes(id);
        }
    }
});

/***/ }),

/***/ "kYpN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("\n            Editar Ação\n        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-12"},[_c('SelectFuncionario',{attrs:{"label":'Funcionário Responsável',"name":'sshd_responsavel',"placeholder":'Pesquise pelo nome ou SSHD',"is-required":true},model:{value:(_vm.model.sshd_responsavel),callback:function ($$v) {_vm.$set(_vm.model, "sshd_responsavel", $$v)},expression:"model.sshd_responsavel"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-16 col-sm-6"},[_c('div',{class:['form-group', { 'has-error' : _vm.errors.has('ordem') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Ordem")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'list-ol'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ordem),expression:"model.ordem"},{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],ref:"ordem",staticClass:"form-control",attrs:{"type":"number","min":"1","placeholder":"Ordem da ação","name":"ordem"},domProps:{"value":(_vm.model.ordem)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ordem", $event.target.value)}}})])]),_vm._v(" "),(_vm.errors.has('ordem'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"ordem"}},[_vm._v("\n                            Preenchimento obrigatório!\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('unidade') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Unidade")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'sitemap'}})],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.unidade),expression:"model.unidade"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"unidade",staticClass:"form-control select-selected",attrs:{"name":"unidade"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "unidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selecione a unidade")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Secretarias"}},_vm._l((_vm.listas.secretarias),function(s){return _c('option',{key:s.sigla,attrs:{"title":s.nome},domProps:{"value":s.sigla}},[_vm._v("\n                                            "+_vm._s(s.sigla)+"\n                                        ")])}),0),_vm._v(" "),_c('optgroup',{attrs:{"label":"Autarquias"}},_vm._l((_vm.listas.autarquias),function(a){return _c('option',{key:a.sigla,attrs:{"title":a.nome},domProps:{"value":a.sigla}},[_vm._v("\n                                            "+_vm._s(a.sigla)+"\n                                        ")])}),0)])]),_vm._v(" "),(_vm.errors.has('unidade'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"unidade"}},[_vm._v("\n                                Preenchimento obrigatório!\n                            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('descritivo') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Descritivo")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'comment'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descritivo),expression:"model.descritivo"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"descritivo",staticClass:"form-control",attrs:{"placeholder":"Descreva a ação...","maxlength":"1000","name":"descritivo","rows":"8"},domProps:{"value":(_vm.model.descritivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descritivo", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(1000 - (_vm.model.descritivo || '').length)}})])]),_vm._v(" "),(_vm.errors.has('descritivo'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"descritivo"}},[_vm._v("\n                            Preenchimento obrigatório!\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.model.unidade !== _vm.compromisso.unidade_executora),expression:"model.unidade !== compromisso.unidade_executora"}],staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('justificativa_criacao') }]},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Justificativa de Criação")]),_vm._v(" "),_c('div',{staticClass:"inputgroupcontainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{attrs:{"icon":'comment'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.justificativa_criacao),expression:"model.justificativa_criacao"},{name:"validate",rawName:"v-validate",value:({ required: _vm.model.unidade !== _vm.compromisso.unidade_executora }),expression:"{ required: model.unidade !== compromisso.unidade_executora }"}],ref:"justificativa_criacao",staticClass:"form-control",attrs:{"placeholder":"Justifique a criação da ação...","maxlength":"1000","name":"justificativa_criacao","rows":"8"},domProps:{"value":(_vm.model.justificativa_criacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "justificativa_criacao", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon custom-input-group-addon-count",domProps:{"textContent":_vm._s(1000 - (_vm.model.justificativa_criacao || '').length)}})])]),_vm._v(" "),(_vm.errors.has('justificativa_criacao'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notempty","data-bv-validator-for":"justificativa_criacao"}},[_vm._v("\n                            Preenchimento obrigatório!\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 margem-bottom"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{class:'fa-long-arrow-alt-left-white',attrs:{"icon":'long-arrow-alt-left'}}),_vm._v(" Voltar\n                    ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.validar()}}},[_c('font-awesome-icon',{class:'fa-save-white',attrs:{"icon":'save'}}),_vm._v(" Salvar\n                    ")],1)])])]),_vm._v(" "),_c('SideAcao',{ref:"side",attrs:{"navs":_vm.sideConfig},on:{"confirmarReordenacao":function($event){return _vm.save()}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kfu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValueSave_vue__ = __webpack_require__("7Uir");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e84a258_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValueSave_vue__ = __webpack_require__("6+O2");
function injectStyle (ssrContext) {
  __webpack_require__("i7Gx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e84a258"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValueSave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e84a258_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValueSave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "khKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Modal__ = __webpack_require__("2iX2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tags',
  inject: ["showConfirm"],
  data: function data() {
    return {
      fields: [{
        name: 'TAG_DCTAG',
        title: 'Nome',
        sortField: 'TAG_DCTAG',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_2__components_common_Modal__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  computed: {
    filtros: function filtros() {
      var TAG_DCTAG = this.TAG_DCTAG;

      return {
        TAG_DCTAG: TAG_DCTAG
      };
    },

    pagina: {
      get: function get() {
        var tags = this.$store.state.vuetableState.tags;
        var pagina = tags.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'tags',
          value: value
        });
      }
    },
    TAG_DCTAG: {
      get: function get() {
        var tags = this.$store.state.vuetableState.tags;
        var TAG_DCTAG = tags.filtros.TAG_DCTAG;


        return TAG_DCTAG;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'TAG_DCTAG',
          collection: 'tags',
          value: value
        });
        this.resetPageStore();
      }
    }
  },
  methods: {
    editar: function editar(data) {
      this.$router.push({
        name: 'admin_tags_save',
        params: { id: data.TAG_IDTAG, name: data.TAG_DCTAG }
      });
    },
    excluir: function excluir(data) {
      var dt = this.$refs.vuetable;
      data.type = 'TAG';

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["b" /* default */].delete(data, function () {
            dt.refresh();
          }, function () {
            console.log('houve um error ao tentar excluir esta tag, por favor tente novamente mais tarde.');
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    consultar: function consultar() {
      this.$refs.vuetable.refresh();
    },
    limpar: function limpar() {
      this.TAG_DCTAG = '';
      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'tags',
        value: 1
      });
    }
  }
});

/***/ }),

/***/ "kkWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beneficios"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h2',{staticClass:"page-header"},[_vm._v("Inserir Movimentos ODS")])])]),_vm._v(" "),_c('div',{staticClass:"row margem-bottom"},[_c('div',{staticClass:"col-xs-12"},[_c('upload',{attrs:{"separador":';'},on:{"loadCSV":_vm.loadCSV}})],1)]),_vm._v(" "),(_vm.model.body.length)?_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('data-table',{attrs:{"dados":_vm.model.data,"fields":_vm.fields},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_vm._v("\n          "+_vm._s(("de " + (props.rowData.INICIO || '-----') + " à " + (props.rowData.FIM || '-----')))+"\n        ")]}}],null,false,1754594463)})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 margem-bottom"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){return _vm.salvar()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n        Salvar\n      ")],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Pré Visualização")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kl3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("4ik2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    fields: {
      type: Array,
      required: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get',
      validator: function validator(value) {
        return ['get', 'post'].indexOf(value) > -1;
      }
    },
    reactiveApiUrl: {
      type: Boolean,
      default: true
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: [Array, Object],
      default: null
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    dataManager: {
      type: Function,
      default: null
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    paginationPath: {
      type: [String],
      default: 'links.pagination'
    },
    queryParams: {
      type: [Object, Function],
      default: function _default() {
        return {
          sort: 'sort',
          page: 'page',
          perPage: 'per_page'
        };
      }
    },
    appendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpFetch: {
      type: Function,
      default: null
    },
    perPage: {
      type: Number,
      default: 10
    },
    initialPage: {
      type: Number,
      default: 1
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tableHeight: {
      type: String,
      default: null
    },

    multiSortKey: {
      type: String,
      default: 'alt'
    },

    rowClassCallback: {
      type: [String, Function],
      default: ''
    },
    rowClass: {
      type: [String, Function],
      default: ''
    },
    detailRowComponent: {
      type: String,
      default: ''
    },
    detailRowTransition: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          tableClass: 'ui blue selectable celled stackable attached table',
          loadingClass: 'loading',
          ascendingIcon: 'blue chevron up icon',
          descendingIcon: 'blue chevron down icon',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: '',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon',
          tableBodyClass: 'vuetable-semantic-no-top vuetable-fixed-layout',
          tableHeaderClass: 'vuetable-fixed-layout'
        };
      }
    },
    minRows: {
      type: Number,
      default: 0
    },
    silent: {
      type: Boolean,
      default: false
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No Data Available';
      }
    },
    showSortIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable:',
      tableFields: [],
      tableData: null,
      tablePagination: null,
      currentPage: this.initialPage,
      selectedTo: [],
      visibleDetailRows: [],
      lastScrollPosition: 0,
      scrollBarWidth: '17px',
      scrollVisible: false
    };
  },
  mounted: function mounted() {
    this.normalizeFields();
    this.normalizeSortOrder();
    if (this.isFixedHeader) {
      this.scrollBarWidth = this.getScrollBarWidth() + 'px';
    }
    this.$nextTick(function () {
      this.fireEvent('initialized', this.tableFields);
    });

    if (this.loadOnStart) {
      this.loadData();
    }
    if (this.isFixedHeader) {
      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        elem.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  destroyed: function destroyed() {
    var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
    if (elem != null) {
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },

  computed: {
    version: function version() {
      return VERSION;
    },
    useDetailRow: function useDetailRow() {
      if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
        this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
        return false;
      }

      return this.detailRowComponent !== '';
    },
    countVisibleFields: function countVisibleFields() {
      return this.tableFields.filter(function (field) {
        return field.visible;
      }).length;
    },
    countTableData: function countTableData() {
      if (this.tableData === null) {
        return 0;
      }
      return this.tableData.length;
    },
    displayEmptyDataRow: function displayEmptyDataRow() {
      return this.countTableData === 0 && this.noDataTemplate.length > 0;
    },
    lessThanMinRows: function lessThanMinRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return true;
      }
      return this.tableData.length < this.minRows;
    },
    blankRows: function blankRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return this.minRows;
      }
      if (this.tableData.length >= this.minRows) {
        return 0;
      }

      return this.minRows - this.tableData.length;
    },
    isApiMode: function isApiMode() {
      return this.apiMode;
    },
    isDataMode: function isDataMode() {
      return !this.apiMode;
    },
    isFixedHeader: function isFixedHeader() {
      return this.tableHeight != null;
    }
  },
  methods: {
    getScrollBarWidth: function getScrollBarWidth() {
      var outer = document.createElement('div');
      var inner = document.createElement('div');

      outer.style.visibility = 'hidden';
      outer.style.width = '100px';

      inner.style.width = '100%';

      outer.appendChild(inner);
      document.body.appendChild(outer);

      var widthWithoutScrollbar = outer.offsetWidth;

      outer.style.overflow = 'scroll';

      var widthWithScrollbar = inner.offsetWidth;

      document.body.removeChild(outer);

      return widthWithoutScrollbar - widthWithScrollbar;
    },
    handleScroll: function handleScroll(e) {
      var horizontal = e.currentTarget.scrollLeft;
      if (horizontal != this.lastScrollPosition) {
        var header = this.$el.getElementsByClassName('vuetable-head-wrapper')[0];
        if (header != null) {
          header.scrollLeft = horizontal;
        }
        this.lastScrollPosition = horizontal;
      }
    },
    normalizeFields: function normalizeFields() {
      if (typeof this.fields === 'undefined') {
        this.warn('You need to provide "fields" prop.');
        return;
      }

      this.tableFields = [];
      var self = this;
      var obj = void 0;
      this.fields.forEach(function (field, i) {
        if (typeof field === 'string') {
          obj = {
            name: field,
            title: self.setTitle(field),
            titleClass: '',
            dataClass: '',
            callback: null,
            visible: true
          };
        } else {
          obj = {
            name: field.name,
            width: field.width,
            title: field.title === undefined ? self.setTitle(field.name) : field.title,
            sortField: field.sortField,
            titleClass: field.titleClass === undefined ? '' : field.titleClass,
            dataClass: field.dataClass === undefined ? '' : field.dataClass,
            callback: field.callback === undefined ? '' : field.callback,
            visible: field.visible === undefined ? true : field.visible
          };
        }
        self.tableFields.push(obj);
      });
    },
    setData: function setData(data) {
      if (data === null || typeof data === 'undefined') return;

      this.fireEvent('loading');

      if (Array.isArray(data)) {
        this.tableData = data;
        this.fireEvent('loaded');
        return;
      }

      this.tableData = this.getObjectValue(data, this.dataPath, null);
      this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    setTitle: function setTitle(str) {
      if (this.isSpecialField(str)) {
        return '';
      }

      return this.titleCase(str);
    },
    getTitle: function getTitle(field) {
      if (typeof field.title === 'function') return field.title();

      return typeof field.title === 'undefined' ? field.name.replace('.', ' ') : field.title;
    },
    renderTitle: function renderTitle(field) {
      var title = this.getTitle(field);

      if (title.length > 0 && this.isInCurrentSortGroup(field) || this.hasSortableIcon(field)) {
        var style = 'opacity:' + this.sortIconOpacity(field) + ';position:relative;float:right';
        var iconTag = this.showSortIcons ? this.renderIconTag(['sort-icon', this.sortIcon(field)], 'style="' + style + '"') : '';
        return title + ' ' + iconTag;
      }

      return title;
    },
    renderSequence: function renderSequence(index) {
      return this.tablePagination ? this.tablePagination.from + index : index;
    },
    renderNormalField: function renderNormalField(field, item) {
      return this.hasCallback(field) ? this.callCallback(field, item) : this.getObjectValue(item, field.name, '');
    },
    isSpecialField: function isSpecialField(fieldName) {
      return fieldName.slice(0, 2) === '__';
    },
    titleCase: function titleCase(str) {
      return str.replace(/\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    camelCase: function camelCase(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

      var self = this;
      return str.split(delimiter).map(function (item) {
        return self.titleCase(item);
      }).join('');
    },
    notIn: function notIn(str, arr) {
      return arr.indexOf(str) === -1;
    },
    loadData: function loadData() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.loadSuccess;
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.loadFailed;

      if (this.isDataMode) {
        this.callDataManager();
        return;
      }

      this.fireEvent('loading');

      this.httpOptions['params'] = this.getAppendParams(this.getAllQueryParams());

      return this.fetch(this.apiUrl, this.httpOptions).then(success, failed).catch(function () {
        return failed();
      });
    },
    fetch: function fetch(apiUrl, httpOptions) {
      return this.httpFetch ? this.httpFetch(apiUrl, httpOptions) : __WEBPACK_IMPORTED_MODULE_1_axios___default.a[this.httpMethod](apiUrl, httpOptions);
    },
    loadSuccess: function loadSuccess(response) {
      this.fireEvent('load-success', response);

      var body = this.transform(response.data);

      this.tableData = this.getObjectValue(body, this.dataPath, null);
      this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

      if (this.tablePagination === null) {
        this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + "or you may have set it incorrectly.\n" + 'You can explicitly suppress this warning by setting pagination-path="".');
      }

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    fixHeader: function fixHeader() {
      if (!this.isFixedHeader) {
        return;
      }

      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        if (elem.scrollHeight > elem.clientHeight) {
          this.scrollVisible = true;
        } else {
          this.scrollVisible = false;
        }
      }
    },
    loadFailed: function loadFailed(response) {
      console.error('load-error', response);
      this.fireEvent('load-error', response);
      this.fireEvent('loaded');
    },
    transform: function transform(data) {
      var func = 'transform';

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, data);
      }

      return data;
    },
    parentFunctionExists: function parentFunctionExists(func) {
      return func !== '' && typeof this.$parent[func] === 'function';
    },
    callParentFunction: function callParentFunction(func, args) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, args);
      }

      return defaultValue;
    },
    fireEvent: function fireEvent(eventName, args) {
      this.$emit(this.eventPrefix + eventName, args);
    },
    warn: function warn(msg) {
      if (!this.silent) {
        console.warn(msg);
      }
    },
    getAllQueryParams: function getAllQueryParams() {
      var params = {};

      if (typeof this.queryParams === 'function') {
        params = this.queryParams(this.sortOrder, this.currentPage, this.perPage);
        return (typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(params)) !== 'object' ? {} : params;
      }

      params[this.queryParams.sort] = this.getSortParam();
      params[this.queryParams.page] = this.currentPage;
      params[this.queryParams.perPage] = this.perPage;

      return params;
    },
    getSortParam: function getSortParam() {
      if (!this.sortOrder || this.sortOrder.field == '') {
        return '';
      }

      if (typeof this.$parent['getSortParam'] === 'function') {
        return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
      }

      return this.getDefaultSortParam();
    },
    getDefaultSortParam: function getDefaultSortParam() {
      var result = '';

      for (var i = 0; i < this.sortOrder.length; i++) {
        var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

        result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
      }
      return result;
    },
    getAppendParams: function getAppendParams(params) {
      for (var x in this.appendParams) {
        params[x] = this.appendParams[x];
      }

      return params;
    },
    extractName: function extractName(string) {
      return string.split(':')[0].trim();
    },
    extractArgs: function extractArgs(string) {
      return string.split(':')[1];
    },
    isSortable: function isSortable(field) {
      return !(typeof field.sortField === 'undefined');
    },
    isInCurrentSortGroup: function isInCurrentSortGroup(field) {
      return this.currentSortOrderPosition(field) !== false;
    },
    hasSortableIcon: function hasSortableIcon(field) {
      return this.isSortable(field) && this.css.sortableIcon != '';
    },
    currentSortOrderPosition: function currentSortOrderPosition(field) {
      if (!this.isSortable(field)) {
        return false;
      }

      for (var i = 0; i < this.sortOrder.length; i++) {
        if (this.fieldIsInSortOrderPosition(field, i)) {
          return i;
        }
      }

      return false;
    },
    fieldIsInSortOrderPosition: function fieldIsInSortOrderPosition(field, i) {
      return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
    },
    orderBy: function orderBy(field, event) {
      if (!this.isSortable(field)) return;

      var key = this.multiSortKey.toLowerCase() + 'Key';

      if (this.multiSort && event[key]) {
        this.multiColumnSort(field);
      } else {
        this.singleColumnSort(field);
      }

      this.currentPage = 1;
      if (this.apiMode || this.dataManager) {
        this.loadData();
      }
    },
    multiColumnSort: function multiColumnSort(field) {
      var i = this.currentSortOrderPosition(field);

      if (i === false) {
        this.sortOrder.push({
          field: field.name,
          sortField: field.sortField,
          direction: 'asc'
        });
      } else {
        if (this.sortOrder[i].direction === 'asc') {
          this.sortOrder[i].direction = 'desc';
        } else {
          this.sortOrder.splice(i, 1);
        }
      }
    },
    singleColumnSort: function singleColumnSort(field) {
      if (this.sortOrder.length === 0) {
        this.clearSortOrder();
      }

      this.sortOrder.splice(1);

      if (this.fieldIsInSortOrderPosition(field, 0)) {
        this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder[0].direction = 'asc';
      }
      this.sortOrder[0].field = field.name;
      this.sortOrder[0].sortField = field.sortField;
    },
    clearSortOrder: function clearSortOrder() {
      this.sortOrder.push({
        field: '',
        sortField: '',
        direction: 'asc'
      });
    },
    sortClass: function sortClass(field) {
      var cls = '';
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingClass : this.css.descendingClass;
      }

      return cls;
    },
    sortIcon: function sortIcon(field) {
      var cls = this.css.sortableIcon;
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingIcon : this.css.descendingIcon;
      }

      return cls;
    },
    sortIconOpacity: function sortIconOpacity(field) {
      var max = 1.0,
          min = 0.3,
          step = 0.3;

      var count = this.sortOrder.length;
      var current = this.currentSortOrderPosition(field);

      if (max - count * step < min) {
        step = (max - min) / (count - 1);
      }

      var opacity = max - current * step;

      return opacity;
    },
    hasCallback: function hasCallback(item) {
      return item.callback ? true : false;
    },
    callCallback: function callCallback(field, item) {
      if (!this.hasCallback(field)) return;

      if (typeof field.callback == 'function') {
        return field.callback(this.getObjectValue(item, field.name));
      }

      var args = field.callback.split('|');
      var func = args.shift();

      if (typeof this.$parent[func] === 'function') {
        var value = this.getObjectValue(item, field.name);

        return args.length > 0 ? this.$parent[func].apply(this.$parent, [value].concat(args)) : this.$parent[func].call(this.$parent, value);
      }

      return null;
    },
    getObjectValue: function getObjectValue(object, path, defaultValue) {
      defaultValue = typeof defaultValue === 'undefined' ? null : defaultValue;

      var obj = object;
      if (path.trim() != '') {
        var keys = path.split('.');
        keys.forEach(function (key) {
          if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
            obj = obj[key];
          } else {
            obj = defaultValue;
            return;
          }
        });
      }
      return obj;
    },
    toggleCheckbox: function toggleCheckbox(dataItem, fieldName, event) {
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (dataItem[idColumn] === undefined) {
        this.warn('__checkbox field: The "' + this.trackBy + '" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
        return;
      }

      var key = dataItem[idColumn];
      if (isChecked) {
        this.selectId(key);
      } else {
        this.unselectId(key);
      }
      this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
    },
    selectId: function selectId(key) {
      if (!this.isSelectedRow(key)) {
        this.selectedTo.push(key);
      }
    },
    unselectId: function unselectId(key) {
      this.selectedTo = this.selectedTo.filter(function (item) {
        return item !== key;
      });
    },
    isSelectedRow: function isSelectedRow(key) {
      return this.selectedTo.indexOf(key) >= 0;
    },
    rowSelected: function rowSelected(dataItem, fieldName) {
      var idColumn = this.trackBy;
      var key = dataItem[idColumn];

      return this.isSelectedRow(key);
    },
    checkCheckboxesState: function checkCheckboxesState(fieldName) {
      if (!this.tableData) return;

      var self = this;
      var idColumn = this.trackBy;
      var selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]';
      var els = document.querySelectorAll(selector);

      if (els.forEach === undefined) els.forEach = function (cb) {
        [].forEach.call(els, cb);
      };

      var selected = this.tableData.filter(function (item) {
        return self.selectedTo.indexOf(item[idColumn]) >= 0;
      });

      if (selected.length <= 0) {
        els.forEach(function (el) {
          el.indeterminate = false;
        });
        return false;
      } else if (selected.length < this.perPage) {
          els.forEach(function (el) {
            el.indeterminate = true;
          });
          return true;
        } else {
            els.forEach(function (el) {
              el.indeterminate = false;
            });
            return true;
          }
    },
    toggleAllCheckboxes: function toggleAllCheckboxes(fieldName, event) {
      var self = this;
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (isChecked) {
        this.tableData.forEach(function (dataItem) {
          self.selectId(dataItem[idColumn]);
        });
      } else {
        this.tableData.forEach(function (dataItem) {
          self.unselectId(dataItem[idColumn]);
        });
      }
      this.$emit('vuetable:checkbox-toggled-all', isChecked);
    },
    gotoPreviousPage: function gotoPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadData();
      }
    },
    gotoNextPage: function gotoNextPage() {
      if (this.currentPage < this.tablePagination.last_page) {
        this.currentPage++;
        this.loadData();
      }
    },
    gotoPage: function gotoPage(page) {
      if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
        this.currentPage = page;
        this.loadData();
      }
    },
    isVisibleDetailRow: function isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow: function showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow: function hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow: function toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    showField: function showField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = true;
    },
    hideField: function hideField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = false;
    },
    toggleField: function toggleField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = !this.tableFields[index].visible;
    },
    renderIconTag: function renderIconTag(classes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return typeof this.css.renderIcon === 'undefined' ? '<i class="' + classes.join(' ') + '" ' + options + '></i>' : this.css.renderIcon(classes, options);
    },
    makePagination: function makePagination() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = {};
      total = total === null ? this.dataTotal : total;
      perPage = perPage === null ? this.perPage : perPage;
      currentPage = currentPage === null ? this.currentPage : currentPage;

      return {
        'total': total,
        'per_page': perPage,
        'current_page': currentPage,
        'last_page': Math.ceil(total / perPage) || 0,
        'next_page_url': '',
        'prev_page_url': '',
        'from': (currentPage - 1) * perPage + 1,
        'to': Math.min(currentPage * perPage, total)
      };
    },
    normalizeSortOrder: function normalizeSortOrder() {
      this.sortOrder.forEach(function (item) {
        item.sortField = item.sortField || item.field;
      });
    },
    callDataManager: function callDataManager() {
      if (this.dataManager === null && this.data === null) return;

      if (Array.isArray(this.data)) {
        return this.setData(this.data);
      }

      this.normalizeSortOrder();

      return this.setData(this.dataManager ? this.dataManager(this.sortOrder, this.makePagination()) : this.data);
    },
    onRowClass: function onRowClass(dataItem, index) {
      if (this.rowClassCallback !== '') {
        this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
        return;
      }

      if (typeof this.rowClass === 'function') {
        return this.rowClass(dataItem, index);
      }

      return this.rowClass;
    },
    onRowChanged: function onRowChanged(dataItem) {
      this.fireEvent('row-changed', dataItem);
      return true;
    },
    onRowClicked: function onRowClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
      return true;
    },
    onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
    },
    onDetailRowClick: function onDetailRowClick(dataItem, event) {
      this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
    },
    onCellClicked: function onCellClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
    },
    onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
    },
    onCellRightClicked: function onCellRightClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-rightclicked', dataItem, field, event);
    },
    changePage: function changePage(page) {
      if (page === 'prev') {
        this.gotoPreviousPage();
      } else if (page === 'next') {
        this.gotoNextPage();
      } else {
        this.gotoPage(page);
      }
    },
    reload: function reload() {
      return this.loadData();
    },
    refresh: function refresh() {
      this.currentPage = 1;
      return this.loadData();
    },
    resetData: function resetData() {
      this.tableData = null;
      this.tablePagination = null;
      this.fireEvent('data-reset');
    }
  },
  watch: {
    'multiSort': function multiSort(newVal, oldVal) {
      if (newVal === false && this.sortOrder.length > 1) {
        this.sortOrder.splice(1);
        this.loadData();
      }
    },
    'apiUrl': function apiUrl(newVal, oldVal) {
      if (this.reactiveApiUrl && newVal !== oldVal) this.refresh();
    },
    'data': function data(newVal, oldVal) {
      this.setData(newVal);
    },
    'tableHeight': function tableHeight(newVal, oldVal) {
      this.fixHeader();
    }
  }
});

/***/ }),

/***/ "ksNf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":'Dados por secretaria'}},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n        Aqui você encontra a lista de dados, vinculados com as Secretarias\n        Municipais e/ou Fundações e Autarquias.\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":[{ label: 'Dados por Secretaria' }]}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('a',{staticClass:"text-2xl",attrs:{"role":"button"},on:{"click":function($event){return _vm.abrir()}}},[_vm._v("\n          Adicionar filtros\n          "),_c('font-awesome-icon',{staticClass:"text-xl",attrs:{"icon":'plus'}})],1)])]),_vm._v(" "),(_vm.secretariasFiltradas.length)?_c('CardsFiltrosSecretaria',{attrs:{"secretarias":_vm.secretariasFiltradas},on:{"click":_vm.removerFiltro}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"input-group filtro-pesquisa"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.termo_pesquisa.codigo),expression:"filtros.termo_pesquisa.codigo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Filtrar pesquisa..."},domProps:{"value":(_vm.filtros.termo_pesquisa.codigo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros.termo_pesquisa, "codigo", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.add('termo_pesquisa', _vm.filtros.termo_pesquisa)}}},[_c('font-awesome-icon',{attrs:{"icon":'search'}})],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table-public',{ref:"dt",attrs:{"has-auth":false,"title":"lista de dados","api-url":"listar-dados","show-empty":true,"fields":_vm.model.columns,"append-params":_vm.filtrosParametro},scopedSlots:_vm._u([{key:"icon",fn:function(props){return [_c('a',{attrs:{"role":"button"},on:{"click":function($event){return _vm.salvarFavorito(props.rowData.codigo)}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.classeFavoritos(props.rowData.codigo)}})],1)]}},{key:"rowrender",fn:function(props){return [_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Listar valores","to":{
                name: 'public_detalhes',
                params: { id: props.rowData.codigo },
                query: { origem: 'dados-secretaria' }
              }}},[_c('font-awesome-icon',{attrs:{"icon":'list-ol'}})],1),_vm._v(" "),_c('button',{class:['btn', _vm.classeSelecionados(props.rowData.codigo)],attrs:{"title":"Dado Comparativo","data-toggle":'popover',"data-content":_vm.getPopoverContent(props.rowData.codigo),"data-placement":'top',"data-trigger":'hover'},on:{"click":function($event){return _vm.toggleAddDado(props.rowData.codigo)}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.addDadoState[props.rowData.codigo] ? 'minus' : 'plus'}})],1)]}}])})],1)])],1),_vm._v(" "),_c('side-bar',{attrs:{"sides":[].concat( _vm.nav )}},[_c('template',{slot:_vm.nav.identidade},[_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},_vm._l((_vm.secretariasNaoFiltradas),function(secr){return _c('a',{key:secr.codigo,staticClass:"link-filtro text-lg",attrs:{"role":"button","title":secr.titulo,"data-toggle":'popover',"data-content":secr.objetivo,"data-trigger":'hover'},on:{"click":function($event){return _vm.addFiltro(secr.codigo)}}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(secr.sigla)+" - "+_vm._s(secr.nome)+" ")])],1)}),0)])])])],2),_vm._v(" "),_c('FaixaComparacao',{attrs:{"idsArray":_vm.idsArray,"query":'dados-secretaria'}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col col-xs-10"},[_c('h3',[_vm._v("Digite sua pesquisa")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Lista de dados")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kzZg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "l+iZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__("IC97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__("D52M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'datepicker',
  props: {
    value: {},
    /**
     * Se for utilizar a formatação diferente da padrão (dd MMM yyyy), não utilizar typeable=true
     * Caso ocorra, o datepicker buga e considera o primeiro campo como mês
     * Sendo assim, qualquer dia acima de 12 gera uma data null no final
     */
    format: {
      type: String,
      default: 'dd MMM yyyy'
    },
    typeable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    date: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      ptBR: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["ptBR"],
      language: 'pt-BR'
    };
  },

  methods: {
    limpar: function limpar() {
      this.inputVal = null;
    },
    dateSelected: function dateSelected(date) {
      return null;
    },
    formatarData: function formatarData(date) {
      return date.toLocaleDateString();
    }
  },
  computed: {
    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  }
});

/***/ }),

/***/ "l0f2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("k0wL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3c28e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("UbQF");
function injectStyle (ssrContext) {
  __webpack_require__("7qQ1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e3c28e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e3c28e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l88I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VincularUnidadesUsuario_vue__ = __webpack_require__("m9li");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3cac6e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VincularUnidadesUsuario_vue__ = __webpack_require__("IpL5");
function injectStyle (ssrContext) {
  __webpack_require__("yiqO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a3cac6e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VincularUnidadesUsuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3cac6e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VincularUnidadesUsuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l9ae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_strings__ = __webpack_require__("V99r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_events__ = __webpack_require__("VwQt");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: Array
  },
  data: function data() {
    return {
      term: '',
      employeesFound: [],
      employeesSelected: [],
      updatedForModel: false
    };
  },

  watch: {
    term: function term(value) {
      if (value.length === 0) {
        this.reset();
      } else {
        this.searchEmployees(value);
      }
    },
    employeesSelected: function employeesSelected(value) {
      if (this.updatedForModel) {
        this.updatedForModel = false;
      } else {
        this.update();
      }
    },
    value: function value(_value) {
      this.employeesSelected = _value;
      this.updatedForModel = true;
    }
  },
  computed: {
    employees: function employees() {
      return this.$store.state.escala.funcionarios;
    },
    employeesLoaded: function employeesLoaded() {
      return this.employees.length > 0;
    },
    placeholder: function placeholder() {
      return this.employeesLoaded ? 'Pesquise por nome ou cargo | Pressione enter para adicionar' : 'Por favor aguarde carregando lista de funcionários...';
    },
    hasEmployeesFound: function hasEmployeesFound() {
      return this.employeesFound.length > 0;
    },
    employeeIndexActive: function employeeIndexActive() {
      return this.employeesFound.map(function (i) {
        return i.active;
      }).indexOf(true);
    }
  },
  methods: {
    searchEmployees: function searchEmployees(term) {
      var _this = this;

      if (term.length > 3) {
        var employeesSelected = this.employeesSelected,
            employees = this.employees;

        // buscando os funcionarios selecionados para excluir da lista de pesquisa

        var selected = employeesSelected.map(function (i) {
          return i.id;
        });

        // criando a lista de pesquisa excluindo os que já foram selecionados
        var searchList = employees.filter(function (_ref) {
          var id = _ref.id;
          return !selected.includes(id);
        });

        var searchValue = term.trim();

        // buscando os funcionarios
        var found = searchList.filter(function (_ref2) {
          var nome = _ref2.nome,
              cargo = _ref2.cargo;
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["f" /* contains */])(nome, searchValue) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["f" /* contains */])(cargo, searchValue);
        });

        // indexando o resultado
        var foundIndexed = found.map(function (item) {
          var indexNome = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["k" /* createRelevanceIndex */])(item.nome, searchValue);
          var indexCargo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["k" /* createRelevanceIndex */])(item.cargo, searchValue);

          if (indexNome === false) return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, { index: indexCargo });
          if (indexCargo === false) return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, { index: indexNome });

          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, { index: (indexNome + indexCargo) / 2 });
        });

        // ordenado o resultado
        foundIndexed.sort(function (item1, item2) {
          if (item1.index > item2.index) return 1;
          if (item1.index < item2.index) return -1;

          return 0;
        });

        // formatando o resultado
        var result = foundIndexed.map(function (_ref3) {
          var nome = _ref3.nome,
              cargo = _ref3.cargo,
              rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['nome', 'cargo']);

          var termo = nome;
          var termoCargo = cargo;

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["f" /* contains */])(nome, term)) {
            termo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["d" /* capitalize */])(_this.highlightTerm(nome, searchValue));
          } else {
            var lengthTotal = nome.length + cargo.length;
            termoCargo = '';

            if (lengthTotal > 50) {
              var lengthDiff = lengthTotal - 50;
              var lengthMax = cargo.length - lengthDiff;
              termoCargo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["d" /* capitalize */])(_this.highlightTerm(cargo, searchValue)).substring(0, lengthMax).trimEnd() + '...';
            } else {
              termoCargo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["d" /* capitalize */])(_this.highlightTerm(cargo, searchValue));
            }
          }

          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ nome: nome, termo: termo, cargo: cargo, termoCargo: termoCargo, active: false }, rest);
        });

        this.employeesFound = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(result));
        if (this.employeesFound.length > 0) {
          this.employeesFound[0].active = true;
        }
      }
    },
    selectEmployeeActive: function selectEmployeeActive() {
      var hasEmployeesFound = this.hasEmployeesFound,
          employeeIndexActive = this.employeeIndexActive,
          employeesSelected = this.employeesSelected,
          employeesFound = this.employeesFound;


      if (hasEmployeesFound && employeeIndexActive > -1) {
        this.select(employeesFound[employeeIndexActive]);
      }
      this.reset();
    },
    select: function select(_ref4) {
      var id = _ref4.id,
          sshd = _ref4.sshd,
          nome = _ref4.nome,
          cargo = _ref4.cargo;
      var employeesSelected = this.employeesSelected;

      if (employeesSelected.map(function (i) {
        return i.nome;
      }).includes(nome)) {
        this.$toastr.e('Colaborador já foi selecionado!');
        return;
      }

      this.employeesSelected.push({ id: id, sshd: sshd, nome: nome, cargo: cargo });
      this.reset();
    },
    scrollEmployeesFound: function scrollEmployeesFound(direction) {
      var hasEmployeesFound = this.hasEmployeesFound,
          employeesFound = this.employeesFound,
          employeeIndexActive = this.employeeIndexActive;


      if (!hasEmployeesFound) return;

      if (employeeIndexActive > -1) {
        // desativar todos os itens da lista
        this.desactiveEmployeesFound();

        var autocomplete = this.$refs.autocomplete;
        var scrollTop = autocomplete.scrollTop,
            scrollHeight = autocomplete.scrollHeight;


        if (direction === 'down') {
          if (employeeIndexActive + 1 < employeesFound.length) {
            employeesFound[employeeIndexActive + 1].active = true;
            if ((employeeIndexActive + 1) % 9 === 0) {
              if (scrollTop + 369 > scrollHeight) {
                autocomplete.scrollTop = scrollHeight;
              } else {
                autocomplete.scrollTop += 369;
              }
            }
          } else {
            employeesFound[employeeIndexActive].active = true;
          }
        } else {
          if (employeeIndexActive - 1 > -1) {
            autocomplete.scrollTop -= 41;
            employeesFound[employeeIndexActive - 1].active = true;
          } else {
            employeesFound[employeeIndexActive].active = true;
          }
        }
      } else {
        if (direction === 'down') {
          employeesFound[0].active = true;
        }
      }
    },
    desactiveEmployeesFound: function desactiveEmployeesFound() {
      this.employeesFound.forEach(function (e) {
        return e.active = false;
      });
    },
    reset: function reset() {
      this.term = '';
      this.employeesFound = [];
      this.$refs.autocomplete.scrollTop = 0;
    },
    resetLazy: function resetLazy() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.reset();
      }, 200);
    },
    highlightTerm: function highlightTerm(string, term) {
      var termIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["l" /* removeAccents */])(string).toLowerCase().indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_strings__["l" /* removeAccents */])(term).toLowerCase());

      if (termIndex === -1) return string;

      return string.substr(0, termIndex) + '<b>' + string.substr(termIndex, term.length) + '</b>' + string.substr(termIndex + term.length);
    },
    update: function update() {
      this.$emit('input', [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.employeesSelected)));
    },

    keydownAllowOnlyPattern: __WEBPACK_IMPORTED_MODULE_4__utils_events__["c" /* keydownAllowOnlyPattern */]
  }
});

/***/ }),

/***/ "lFKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12 chartBarWrapper"},[_c('BarChart',{attrs:{"chartData":_vm.chartData,"gradiente":false,"options":_vm.options}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Total de agendamentos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lFPT":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTVweCIgaGVpZ2h0PSI0NnB4IiB2aWV3Qm94PSIwIDAgNTUgNDYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjYgKDY3NDkxKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY28tZ2VzdGFvPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjQuMDAwMDAwLCAtODQzLjAwMDAwMCkiIHN0cm9rZS13aWR0aD0iMyI+CiAgICAgICAgICAgIDxnIGlkPSJpY28tZ2VzdGFvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjUuMDAwMDAwLCA4NDQuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlN0cm9rZS0zOSIgc3Ryb2tlPSIjNjdCNDUwIiBwb2ludHM9IjUuODAxNSA0Mi42MDAyIDUuODAxNSAyOC42MTYyIDE0LjM3ODUgMjguNjE2MiAxNC4zNzg1IDMyLjg3MTIiPjwvcG9seWxpbmU+CiAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlN0cm9rZS00MSIgc3Ryb2tlPSIjNjdCNDUwIiBwb2ludHM9IjE5LjA5NjQgMzIuMzY3OCAxOS4wOTY0IDE2Ljg2NjggMjcuNjc0NCAxNi44NjY4IDI3LjY3NDQgMzAuMzY5OCI+PC9wb2x5bGluZT4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik00MC45Njk1LDM2LjkxNjYgTDQwLjk2OTUsNDIuMTcxNiIgaWQ9IlN0cm9rZS00MyIgc3Ryb2tlPSIjNjdCNDUwIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlN0cm9rZS00NSIgc3Ryb2tlPSIjNjdCNDUwIiBwb2ludHM9IjMyLjM5MjMgMjguNDM3MSAzMi4zOTIzIDAuOTk5MSA0MC45NjkzIDAuOTk5MSA0MC45NjkzIDEwLjg3NTEiPjwvcG9seWxpbmU+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMC45MTk2LDQzLjQ1NzYgTDUyLjI4NDYsNDMuNDU3NiIgaWQ9IlN0cm9rZS00NyIgc3Ryb2tlPSIjNjdCNDUwIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNDYuMTIyOCwxNS4wNzM4IEM0Ni42Mzk4LDM2LjAwOTggMjAuNzgxOCwzOS4yMDc4IDEwLjA5MDgsMzkuMjA3OCIgaWQ9IlN0cm9rZS00OSIgc3Ryb2tlPSIjMTQ0NzdDIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cG9seWxpbmUgaWQ9IlN0cm9rZS01MSIgc3Ryb2tlPSIjMTQ0NzdDIiBwb2ludHM9IjUxLjM4NzQgMTguOTM1MSA0Ni4zMzE0IDEzLjIyMzEgMzkuOTk1NCAxOC45MzUxIj48L3BvbHlsaW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "lGBC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lHdj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("0xDb");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PublicHeader: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* PublicHeader */], Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components__["b" /* Breadcrumb */], CriterioRemedio: __WEBPACK_IMPORTED_MODULE_2__components__["s" /* CriterioRemedio */], OpenMap: __WEBPACK_IMPORTED_MODULE_2__components__["t" /* OpenMap */] },
  data: function data() {
    return {
      carregando: false,
      remedio: {},
      principio_ativo: '',
      unidades: [],
      pins: []
    };
  },
  created: function created() {
    var _$route$params = this.$route.params,
        remedio = _$route$params.remedio,
        principio = _$route$params.principio;


    if (!remedio && !principio) {
      this.$router.push('/aqui-tem-remedio');
      return;
    }

    this.principio_ativo = remedio ? remedio.principio_ativo : principio;
    this.remedio = remedio || {};

    this.getUnidadesRemedios();
  },
  updated: function updated() {
    if (this.$refs.mapa) {
      this.$refs.mapa.fitPins();
    }
  },

  methods: {
    getPosicaoMapa: function getPosicaoMapa() {
      var nomesUnidades = this.unidades.map(function (unidade, index) {
        return {
          unidade_saude: unidade.unidade_saude,
          disponivel: Number(unidade.saldo) > 0
        };
      });

      this.pins = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["h" /* latLongGroup */])(nomesUnidades);
    },
    toggleLoading: function toggleLoading() {
      this.carregando = !this.carregando;
    },
    isAvailable: function isAvailable(item) {
      var saldo = Number(item);
      return saldo > 0;
    },
    getUnidadesRemedios: function getUnidadesRemedios() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, _data, finder, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.toggleLoading();

                _context.prev = 1;

                if (_this.remedio.principio_ativo) {
                  _context.next = 9;
                  break;
                }

                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('remedios/pesquisa', {
                  params: { term: _this.principio_ativo }
                });

              case 5:
                _ref = _context.sent;
                _data = _ref.data;

                finder = function finder(item) {
                  return item.principio_ativo === _this.principio_ativo;
                };

                _this.remedio = _data.find(finder) || {};

              case 9:
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('remedios/enderecos', {
                  params: { remedio_id: _this.remedio.id_princ_ativo }
                });

              case 11:
                _ref2 = _context.sent;
                data = _ref2.data;


                _this.unidades = data;
                _this.getPosicaoMapa();
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);
                _this.$toastr.e('Houve um erro ao carregar as informações, tente novamente mais tarde.');

              case 21:

                _this.toggleLoading();

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 17]]);
      }))();
    }
  }
});

/***/ }),

/***/ "lJN9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      disabled: false
    };
  },

  methods: {
    retornaListaAnos: function retornaListaAnos() {
      var lista = [];
      var ano = new Date().getFullYear();

      do {
        lista.push(ano);
        ano--;
      } while (ano >= 2020);

      return lista;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    ano_base: {
      get: function get() {
        return this.$store.state.receitas_despesas.ano_base;
      },
      set: function set(value) {
        var _this = this;

        this.$store.commit('TOGGLE_LOADING');
        this.$store.dispatch('atualizaAnoBase', value).catch(function () {
          _this.$toastr.e('Houve um erro ao carregar as informações de receitas e despesas. Algumas informações não estarão disponíveis. Tente atualizar a página');
        }).finally(function () {
          _this.$store.commit('TOGGLE_LOADING');
        });
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapGetters */])(['isLoading']))
});

/***/ }),

/***/ "lN6u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_events__ = __webpack_require__("EZrF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__ = __webpack_require__("dq31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__ = __webpack_require__("BOqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_VuetablePaginationInfo__ = __webpack_require__("nLhK");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_events___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'data-table-public',
  components: { vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__["a" /* default */], pagination: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__["a" /* default */], paginationInfo: __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_VuetablePaginationInfo__["a" /* default */] },
  data: function data() {
    return {
      fieldsDefinition: this.fields,
      totalRows: 0,
      carregando: false
    };
  },
  updated: function updated() {
    jQuery('[data-toggle="popover"]').popover({});
  },

  props: {
    hasAuth: {
      type: Boolean,
      default: true
    },
    refresh: {
      type: Function,
      default: function _default() {
        this.$refs.vuetable.refresh();
      }
    },
    useFilter: {
      type: Boolean,
      default: true
    },
    title: String,
    reportTitle: String,
    apiUrl: String,
    apiMode: {
      type: Boolean,
      default: true
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    reference: String,
    appendParams: Object,
    fields: Array,
    multiSort: {
      type: Boolean,
      default: true
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSortKey: {
      type: String,
      default: 'ctrl'
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    data: {
      type: Array,
      required: false
    },
    paginationPath: {
      type: String,
      default: ''
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          table: {
            tableClass: 'table table-striped table-hover',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down'
          },
          pagination: {
            wrapperClass: 'pagination pull-right',
            activeClass: 'btn-primary',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: 'glyphicon glyphicon-step-backward',
              prev: 'glyphicon glyphicon-chevron-left',
              next: 'glyphicon glyphicon-chevron-right',
              last: 'glyphicon glyphicon-step-forward'
            }
          }
        };
      }
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    paginationInfoShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    restUrl: function restUrl() {
      return __WEBPACK_IMPORTED_MODULE_3__request__["b" /* default */].apiUrlRoot + this.apiUrl;
    },
    auth: function auth() {
      if (this.hasAuth) {
        return { headers: __WEBPACK_IMPORTED_MODULE_3__request__["b" /* default */].apiHeaderAuthorization() };
      } else {
        return {};
      }
    },
    params: function params() {
      return this.appendParams;
    }
  },
  methods: {
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onSuccess: function onSuccess(response) {
      if (this.dataPath) {
        this.totalRows = response.data[this.dataPath].length;
      } else {
        this.totalRows = response.data.length;
      }
    },
    onError: function onError(o) {
      if (o.response.status === 401) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOGOUT_USER');
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ name: 'Login', params: { errorMsg: 'Sessão Expirada!' } });
      }
      if (o.response.status === 400) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOGOUT_USER');
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
          name: 'Login',
          params: { errorMsg: o.response.data.msg }
        });
      }
    },
    normalizeFields: function normalizeFields() {
      var _this = this;

      this.$nextTick(function () {
        return _this.$refs.vuetable.normalizeFields();
      });
    }
  }
});

/***/ }),

/***/ "lNFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return concursos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_concursos_edital__ = __webpack_require__("WY6r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_concursos_edital_Save__ = __webpack_require__("l0f2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_concursos_edital_Habilitados__ = __webpack_require__("bKJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_admin_concursos_edital_PreHabilitados__ = __webpack_require__("PbIO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_admin_concursos_acompanhamento_Nomeados__ = __webpack_require__("ctQb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_admin_concursos_acompanhamento__ = __webpack_require__("SSAr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_admin_concursos_acompanhamento_Details__ = __webpack_require__("FBte");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_admin_concursos_acompanhamento_DetailsCargo__ = __webpack_require__("lsuD");









var concursos = [{
  name: 'editais',
  path: 'concursos/edital',
  component: __WEBPACK_IMPORTED_MODULE_0__views_admin_concursos_edital__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'salvar_edital',
  path: 'concursos/edital/salvar',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin_concursos_edital_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'habilitados',
  path: 'concursos/habilitados/',
  component: __WEBPACK_IMPORTED_MODULE_2__views_admin_concursos_edital_Habilitados__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'pre_habilitados',
  path: 'concursos/pre-habilitados/',
  component: __WEBPACK_IMPORTED_MODULE_3__views_admin_concursos_edital_PreHabilitados__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'nomeados',
  path: 'concursos/nomeados/',
  component: __WEBPACK_IMPORTED_MODULE_4__views_admin_concursos_acompanhamento_Nomeados__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'acompanhamento',
  path: 'concursos/acompanhamento',
  component: __WEBPACK_IMPORTED_MODULE_5__views_admin_concursos_acompanhamento__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'acompanhamento_detalhes',
  path: 'concursos/acompanhamento/detalhes/:edital_id',
  component: __WEBPACK_IMPORTED_MODULE_6__views_admin_concursos_acompanhamento_Details__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'acompanhamento_detalhes_cargo',
  path: 'concursos/acompanhamento/detalhes/cargo/:edital_id/:cargo_id',
  component: __WEBPACK_IMPORTED_MODULE_7__views_admin_concursos_acompanhamento_DetailsCargo__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}];

/***/ }),

/***/ "lQJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFImport_vue__ = __webpack_require__("bYZH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f310fc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PDFImport_vue__ = __webpack_require__("Eudy");
function injectStyle (ssrContext) {
  __webpack_require__("TJSQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f310fc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFImport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f310fc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PDFImport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lU9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('article',[_c('h4',[_vm._v(_vm._s(_vm.nome))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.cargo))]),_vm._v(" "),_c('div',{staticClass:"status"},[(_vm.scaleStatus === 'validating')?_c('pulse-loader',{attrs:{"size":'0.5em',"title":"Verificando disponibilidade da escala"}}):(_vm.scaleStatus === 'valid')?_c('font-awesome-icon',{staticStyle:{"color":"rgba(70, 140, 54, 0.8)"},attrs:{"icon":'calendar-check',"title":"Todos os dias e horários estão disponiveis"}}):(_vm.scaleStatus === 'invalid')?_c('button',{attrs:{"type":"button"},on:{"click":_vm.show}},[_c('font-awesome-icon',{attrs:{"icon":'calendar-times',"title":"Há conflitos de horário na escala deste funcionário, clique para saber mais!"}})],1):_c('button',{attrs:{"type":"button"},on:{"click":_vm.verificaEscalaEhAtualizaItem}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle',"title":"Não foi possivel verificar a disponibilidade, clique novamente aqui para verificar novamente!"}})],1)],1)]),_vm._v(" "),_c('EmployeeItemScaleControl',{on:{"input":_vm.verificaEscalaEhAtualizaItem,"remove":function($event){return _vm.$emit('clickClose')}},model:{value:(_vm.scale),callback:function ($$v) {_vm.scale=$$v},expression:"scale"}}),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.$emit('clickClose')}}},[_vm._v("\n    ×\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lVqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("bGai");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProcedimentosSaude: __WEBPACK_IMPORTED_MODULE_0__components__["k" /* ProcedimentosSaude */]
  },
  data: function data() {
    return {
      urls: {
        espera: 'procedimentos-saude/lista-especialidades',
        agendados: 'procedimentos-saude/lista-especialidades-agendados'
      },
      especialidade: ''
    };
  },
  created: function created() {
    var especialidade = this.$route.params.especialidade;


    this.especialidade = especialidade;
  },

  computed: {
    breadcrumb: function breadcrumb() {
      return [{
        label: 'Minha Saúde',
        named_link: { name: 'procedimentos_saude' }
      }, {
        label: this.especialidade
      }];
    }
  }
});

/***/ }),

/***/ "ld51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_strings__ = __webpack_require__("V99r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Modal__ = __webpack_require__("2iX2");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  data: function data() {
    return {
      numero: '',
      codigo_emenda: '',
      processos_pagamento: [],
      fields: [{
        name: 'numero_pagamento',
        title: 'Número',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'valor',
        title: 'Valor',
        dataClass: 'align-middle',
        filterable: true,
        callback: function callback(value) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_strings__["b" /* formatarMoeda */])(Number(value));
        }
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-2',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_4__components_common_NoApiTable__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_6__components_common_Modal__["a" /* default */]
  },
  mounted: function mounted() {
    var id = this.$route.params.id;

    if (id) {
      this.loadEmendaProcessos(id);
    }
  },

  methods: {
    loadEmendaProcessos: function loadEmendaProcessos(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, emenda;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('emenda/' + id + '/processos');

              case 2:
                response = _context.sent;
                emenda = response.data;

                _this.numero = emenda.numero;
                _this.codigo_emenda = emenda.id;
                _this.processos_pagamento = emenda.processos_pagamento;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    adicionar: function adicionar() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var codigo_emenda;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                codigo_emenda = _this2.codigo_emenda;

                _this2.$router.push({
                  name: 'user_salvar_processospagamento',
                  params: { codigo_emenda: codigo_emenda }
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    editar: function editar(data) {
      var id = data.id;

      this.$router.push({
        name: 'user_salvar_processospagamento',
        params: { id: id }
      });
    },
    carregarProcessosPagamento: function carregarProcessosPagamento() {
      var _this3 = this;

      var id = this.codigo_emenda;
      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('emenda/' + id + '/processos', this.formatedProcessosPagamento).then(function (response) {
        var emenda = response.data;
        _this3.processos_pagamento = emenda.processos_pagamento;
      }).catch(function (error) {
        _this3.$toastr.e('Houve um erro ao carregar a lista de processos de pagamento. Por favor, tente novamente mais tarde.');
      });
    },
    excluir: function excluir(data) {
      var me = this;
      var id = data.id;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].delete('processospagamento/' + id).then(function (resp) {
            me.$toastr.s('Processo de pagamento removido com sucesso!');
            me.carregarProcessosPagamento();
          }).catch(function (error) {
            console.log(error);
            me.$toastr.e('Houve uma falha ao tentar remover esse item, por favor, tente novamente mais tarde!');
          });
        }
      };

      this.showConfirm('Deseja realmente deletar este item?', config);
    }
  },
  computed: {
    formatedProcessosPagamento: function formatedProcessosPagamento() {
      var _processos_pagamento = this.processos_pagamento,
          numero_pagamento = _processos_pagamento.numero_pagamento,
          valor = _processos_pagamento.valor;


      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.processos_pagamento);
    }
  }
});

/***/ }),

/***/ "ljz1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_DataTablePublic__ = __webpack_require__("+Mmc");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Imprimir Escala',
      columns: [{
        name: 'colaborador',
        title: 'Colaboradores',
        titleClass: 'align-middle',
        dataClass: 'column-name align-middle',
        callback: function callback(_ref) {
          var nome = _ref.nome,
              cargo = _ref.cargo;

          var html = [];
          html.push('<span>' + cargo + '</span>');
          html.push('<p>' + nome + '</p>');
          return html.join('');
        }
      }],
      uor: null,
      uors: [],
      referencia: null,
      referencias: [],
      escalas: [],
      print: {
        unidade: 'Nome da unidade',
        referencia: 'Mês/Ano',
        observacao: 'Sem nenhuma observação',
        calendario: []
      },
      loading: {
        unidade: false,
        referencia: false
      },
      escalaStatus: 'wait',
      tableCss: {
        table: {
          tableClass: 'table table-bordered table-hover',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down'
        },
        pagination: {
          wrapperClass: 'pagination pull-right',
          activeClass: 'btn-primary',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: 'glyphicon glyphicon-step-backward',
            prev: 'glyphicon glyphicon-chevron-left',
            next: 'glyphicon glyphicon-chevron-right',
            last: 'glyphicon glyphicon-step-forward'
          }
        }
      }
    };
  },

  components: {
    DataTablePublic: __WEBPACK_IMPORTED_MODULE_4__components_common_DataTablePublic__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.loadUors();
  },

  computed: {
    acaoIndisponivel: function acaoIndisponivel() {
      return this.uor === null || this.referencia === null;
    },
    unidadeLabel: function unidadeLabel() {
      var unidade = this.loading.unidade;

      return unidade ? 'Carregando as unidades...' : 'Selecione a unidade';
    },
    referenciaLabel: function referenciaLabel() {
      var referencia = this.loading.referencia;

      return referencia ? 'Carregando as referências...' : 'Selecione a referência';
    },
    buttonLabel: function buttonLabel() {
      switch (this.escalaStatus) {
        case 'wait':
          return 'Aguardando os dados para gerar a escala!';
          break;
        case 'processing':
          return 'Gerando a escala';
          break;
        case 'done':
          return 'OK clique aqui!';
          break;
      }
    }
  },
  methods: {
    loadUors: function loadUors() {
      var _this = this;

      this.loading.unidade = true;
      this.escalaStatus = 'wait';

      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('escala/listar-unidade-publicada-user').then(function (_ref2) {
        var data = _ref2.data;

        _this.uors = data.map(function (_ref3) {
          var uor_sigla = _ref3.uor_sigla,
              uor_nome = _ref3.uor_nome;

          return {
            uor_sigla: uor_sigla,
            nome: uor_sigla === uor_nome ? uor_sigla : uor_sigla + ' | ' + uor_nome
          };
        });
        _this.loading.unidade = false;
      }).catch(function (e) {
        console.log(e);
      });
    },
    loadReferencias: function loadReferencias() {
      var _this2 = this;

      if (this.uor === null) {
        this.referencia = null;
        this.referencias = [];
        this.escalas = [];
        return;
      }

      this.escalaStatus = 'wait';
      this.loading.referencia = true;

      var uor_sigla = this.uor;


      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].post('escala/listar-referencia-publicada', { uor_sigla: uor_sigla }).then(function (response) {
        var data = response.data;

        _this2.referencias = data.map(function (referencia) {
          var value = referencia;
          var ano = value.substr(0, 4);
          var mes = Number(value.substr(-2)) - 1;

          var label = new Date(ano, mes, 1).toLocaleString('pt-BR', { month: 'long', year: 'numeric' }).toUpperCase();

          return { value: value, label: label };
        });
        _this2.loading.referencia = false;
      }).catch(function (e) {
        console.log(e);
      });
    },
    loadEscala: function loadEscala() {
      var _this3 = this;

      var me = this;
      var uor_sigla = me.uor,
          referencia = me.referencia;

      if (uor_sigla === null || referencia === null) {
        me.escalas = [];
        return;
      }

      this.escalaStatus = 'processing';

      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('escala/listar-escala-uor-referencia?uor_sigla=' + uor_sigla + '&referencia=' + referencia).then(function (response) {
        _this3.print = response.data;

        if (_this3.print.calendario) {
          var _print$calendario = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_this3.print.calendario, 1),
              firstItem = _print$calendario[0];

          var colaborador = firstItem.colaborador,
              rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(firstItem, ['colaborador']);

          var columnsName = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(rest);
          _this3.createColumns(columnsName);

          var referenciaSelecionada = _this3.referencias.find(function (referencia) {
            return referencia.value == _this3.referencia;
          });
          _this3.print.referencia = referenciaSelecionada.label;
        }
        _this3.escalaStatus = 'done';
      }).catch(function (e) {
        console.log(e);
      });
    },
    createColumns: function createColumns(columnsName) {
      var _this4 = this;

      // mantendo a primeira coluna de funcionarios
      this.columns = [this.columns[0]];

      columnsName.forEach(function (name) {
        return _this4.columns.push(_this4.createColumn(name));
      });

      this.$refs.escalas.normalizeFields();
    },
    createColumn: function createColumn(name) {
      var year = name.substr(0, 4);
      var month = name.substr(4, 2);
      var day = name.substr(6, 2);
      var date = new Date(year, parseInt(month) - 1, day);
      var weekday = date.toLocaleDateString('pt-BR', { weekday: 'short' }).toUpperCase().replace('.', '');

      return {
        name: name,
        titleClass: 'text-center',
        title: '<span>' + weekday + '</span><div>' + day + '</div>',
        dataClass: 'align-middle column-day',
        callback: function callback(value) {
          return Array.isArray(value) ? value.map(function (time) {
            return '<p>' + time + '</p>';
          }).join('') : '';
        }
      };
    },
    imprimir: function imprimir() {
      window.print();
    }
  }
});

/***/ }),

/***/ "lknt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportCSV_vue__ = __webpack_require__("A11D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_146ab6c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportCSV_vue__ = __webpack_require__("/LCp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportCSV_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_146ab6c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportCSV_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "llwE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lmlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tablePagination && _vm.tablePagination.last_page > 1),expression:"tablePagination && tablePagination.last_page > 1"}],class:_vm.css.wrapperClass},[_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){return _vm.loadPage(1)}}},[(_vm.css.icons.first != '')?_c('i',{class:[_vm.css.icons.first]}):_c('span',[_vm._v("«")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],on:{"click":function($event){return _vm.loadPage('prev')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.prev]}):_c('span',[_vm._v(" ‹")])]),_vm._v(" "),(_vm.notEnoughPages)?[_vm._l((_vm.totalPage),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(n) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(n)},on:{"click":function($event){return _vm.loadPage(n)}}})]})]:[_vm._l((_vm.windowSize),function(n){return [_c('a',{class:[_vm.css.pageClass, _vm.isCurrentPage(_vm.windowStart+n-1) ? _vm.css.activeClass : ''],domProps:{"innerHTML":_vm._s(_vm.windowStart+n-1)},on:{"click":function($event){return _vm.loadPage(_vm.windowStart+n-1)}}})]})],_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){return _vm.loadPage('next')}}},[(_vm.css.icons.next != '')?_c('i',{class:[_vm.css.icons.next]}):_c('span',[_vm._v("› ")])]),_vm._v(" "),_c('a',{class:['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],on:{"click":function($event){return _vm.loadPage(_vm.totalPage)}}},[(_vm.css.icons.last != '')?_c('i',{class:[_vm.css.icons.last]}):_c('span',[_vm._v("»")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lp1m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lpUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SideModal',{ref:"sideModal",attrs:{"sides":_vm.navs},on:{"fechou":_vm.handleFechou},scopedSlots:_vm._u([{key:"detalhes",fn:function(){return [_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('strong',[_vm._v("Status:")]),_vm._v(" "+_vm._s(_vm.detalhesData.status))]),_vm._v(" "),(_vm.detalhesData.responsavel)?_c('p',[_c('strong',[_vm._v("Responsável:")]),_vm._v(" "+_vm._s(_vm.detalhesData.responsavel.nome))]):_vm._e(),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Previsão de Início:")]),_vm._v(" "+_vm._s(_vm.detalhesData.data_estimada_inicio || 'Não definido'))]),_vm._v(" "),(_vm.detalhesData.data_inicio)?_c('p',[_c('strong',[_vm._v("Início:")]),_vm._v(" "+_vm._s(_vm.detalhesData.data_inicio))]):_vm._e(),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Previsão de Conclusão:")]),_vm._v(" "+_vm._s(_vm.detalhesData.data_estimada_conclusao || 'Não definida'))]),_vm._v(" "),(_vm.detalhesData.data_conclusao)?_c('p',[_c('strong',[_vm._v("Conclusão:")]),_vm._v(" "+_vm._s(_vm.detalhesData.data_conclusao))]):_vm._e(),_vm._v(" "),(_vm.detalhesData.justificativa_criacao)?_c('p',[_c('strong',[_vm._v("Justificativa de Criação:")]),_vm._v(" "+_vm._s(_vm.detalhesData.justificativa_criacao)+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.detalhesData.justificativa_rejeicao)?_c('p',[_c('strong',[_vm._v("Justificativa de Cancelamento:")]),_vm._v(" "+_vm._s(_vm.detalhesData.justificativa_rejeicao)+"\n                    ")]):_vm._e()]),_vm._v(" "),(_vm.detalhesData.compromisso)?_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Compromisso Relacionado")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Descrição:")]),_vm._v(" "+_vm._s(_vm.detalhesData.compromisso.descritivo))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Período:")]),_vm._v(" "+_vm._s(_vm.detalhesData.compromisso.periodo))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Status:")]),_vm._v(" "+_vm._s(_vm.detalhesData.compromisso.status))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('fechaModal', 'detalhes')}}},[_vm._v("Fechar")])])])])]},proxy:true},{key:"concluir",fn:function(){return [_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('strong',[_vm._v("Status Atual:")]),_vm._v(" "+_vm._s(_vm.concluirData.status))]),_vm._v(" "),(_vm.concluirData.responsavel)?_c('p',[_c('strong',[_vm._v("Responsável:")]),_vm._v(" "+_vm._s(_vm.concluirData.responsavel.nome))]):_vm._e(),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Início:")]),_vm._v(" "+_vm._s(_vm.concluirData.data_inicio || 'Não definido'))]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Previsão de Conclusão:")]),_vm._v(" "+_vm._s(_vm.concluirData.data_estimada_conclusao || 'Não definida'))]),_vm._v(" "),(_vm.diferencaConclusao)?_c('span',{staticClass:"diferenca",class:_vm.diferencaConclusao.classe},[_vm._v("\n                        "+_vm._s(_vm.diferencaConclusao.texto)+"\n                        "),(_vm.diferencaConclusao.dias !== 0)?[_vm._v("\n                            ("+_vm._s(_vm.diferencaConclusao.dias)+" "+_vm._s(_vm.diferencaConclusao.dias === 1 ? 'dia' : 'dias')+")\n                        ")]:_vm._e()],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Definir Concluir a ação?")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Data de Conclusão:")]),_vm._v(" "+_vm._s(_vm.dataAtualConclusao))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.$emit('concluir', _vm.concluirData.id)}}},[_vm._v("Concluir")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('fechaModal', 'concluir')}}},[_vm._v("Cancelar")])])])])]},proxy:true},{key:"iniciar",fn:function(){return [_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('strong',[_vm._v("Status Atual:")]),_vm._v(" "+_vm._s(_vm.iniciarData.status))]),_vm._v(" "),(_vm.iniciarData.responsavel)?_c('p',[_c('strong',[_vm._v("Responsável:")]),_vm._v(" "+_vm._s(_vm.iniciarData.responsavel.nome))]):_vm._e(),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Previsão de Início:")]),_vm._v(" "+_vm._s(_vm.iniciarData.data_estimada_inicio || 'Não definido'))]),_vm._v(" "),(_vm.diferencaInicio)?_c('span',{staticClass:"diferenca",class:_vm.diferencaInicio.classe},[_vm._v("\n                        "+_vm._s(_vm.diferencaInicio.texto)+"\n                        "),(_vm.diferencaInicio.dias !== 0)?[_vm._v("\n                            ("+_vm._s(_vm.diferencaInicio.dias)+" "+_vm._s(_vm.diferencaInicio.dias === 1 ? 'dia' : 'dias')+")\n                        ")]:_vm._e()],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v("Deseja Iniciar a ação?")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Data de Início:")]),_vm._v(" "+_vm._s(_vm.dataAtualInicio))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.$emit('iniciar', _vm.iniciarData.id)}}},[_vm._v("Iniciar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('fechaModal', 'iniciar')}}},[_vm._v("Cancelar")])])])])]},proxy:true},{key:"editar",fn:function(){return [_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"col-xs-12"},[(_vm.editarData.compromisso)?_c('p',[_c('strong',[_vm._v("Compromisso:")]),_vm._v(" "+_vm._s(_vm.editarData.compromisso.descritivo))]):_vm._e(),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Ação:")]),_vm._v(" "+_vm._s(_vm.editarData.descritivo))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Data de inicio estimada")]),_vm._v(" "),_c('datepicker',{model:{value:(_vm.editarData.data_estimada_inicio),callback:function ($$v) {_vm.$set(_vm.editarData, "data_estimada_inicio", $$v)},expression:"editarData.data_estimada_inicio"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Data de conclusão estimada")]),_vm._v(" "),_c('datepicker',{model:{value:(_vm.editarData.data_estimada_conclusao),callback:function ($$v) {_vm.$set(_vm.editarData, "data_estimada_conclusao", $$v)},expression:"editarData.data_estimada_conclusao"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"disabled":!_vm.editarData.data_estimada_inicio || !_vm.editarData.data_estimada_conclusao},on:{"click":function($event){return _vm.$emit('salvarEdicao', _vm.editarData)}}},[_vm._v("\n                    Salvar\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('fechaModal', 'editar')}}},[_vm._v("Cancelar")])])])]},proxy:true},{key:"aceitar",fn:function(){return [_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[(_vm.aceitarData.compromisso)?_c('p',[_c('strong',[_vm._v("Compromisso:")]),_vm._v(" "+_vm._s(_vm.aceitarData.compromisso.descritivo))]):_vm._e(),_vm._v(" "),(_vm.aceitarData.compromisso)?_c('p',[_c('strong',[_vm._v("Unidade Executora:")]),_vm._v(" "+_vm._s(_vm.aceitarData.compromisso.nome_unidade_executora))]):_vm._e(),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Ação:")]),_vm._v(" "+_vm._s(_vm.aceitarData.descritivo))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Data de início estimada")]),_vm._v(" "),_c('datepicker',{model:{value:(_vm.aceitarData.data_estimada_inicio),callback:function ($$v) {_vm.$set(_vm.aceitarData, "data_estimada_inicio", $$v)},expression:"aceitarData.data_estimada_inicio"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label custom-font"},[_vm._v("Data de conclusão estimada")]),_vm._v(" "),_c('datepicker',{model:{value:(_vm.aceitarData.data_estimada_conclusao),callback:function ($$v) {_vm.$set(_vm.aceitarData, "data_estimada_conclusao", $$v)},expression:"aceitarData.data_estimada_conclusao"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"disabled":!_vm.aceitarData.data_estimada_inicio || !_vm.aceitarData.data_estimada_conclusao},on:{"click":function($event){return _vm.$emit('aceitarAcao', _vm.aceitarData)}}},[_vm._v("\n                        Aceitar\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('fechaModal', 'aceitar')}}},[_vm._v("Cancelar")])])])])]},proxy:true},{key:"cancelar",fn:function(){return [_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h4',{staticClass:"modal-title"},[_vm._v("\n                        Justifique "+_vm._s(_vm.cancelarData.unidade === _vm.cancelarData.unidade_executora ? 'o Cancelamento' : 'a Rejeição')+"\n                    ")]),_vm._v(" "),(_vm.cancelarData.compromisso)?_c('p',[_c('strong',[_vm._v("Compromisso:")]),_vm._v(" "+_vm._s(_vm.cancelarData.compromisso.descritivo))]):_vm._e(),_vm._v(" "),(_vm.cancelarData.compromisso)?_c('p',[_c('strong',[_vm._v("Unidade Executora:")]),_vm._v(" "+_vm._s(_vm.cancelarData.compromisso.nome_unidade_executora))]):_vm._e(),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Ação:")]),_vm._v(" "+_vm._s(_vm.cancelarData.descritivo))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.justificativa),expression:"justificativa"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":"Digite sua justificativa aqui..."},domProps:{"value":(_vm.justificativa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.justificativa=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"disabled":!_vm.justificativa.trim()},on:{"click":function($event){return _vm.$emit('cancelarAcao', { acao: _vm.cancelarData, justificativa: _vm.justificativa })}}},[_vm._v("\n                        Salvar\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('fechaModal', 'cancelar')}}},[_vm._v("Cancelar")])])])])]},proxy:true},{key:"deletar",fn:function(){return [_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('strong',[_vm._v("Ação a ser excluída:")])]),_vm._v(" "),_c('p',[_c('em',[_vm._v(_vm._s(_vm.deletarData.descritivo))])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.$emit('deletar', _vm.deletarData.id)}}},[_c('font-awesome-icon',{attrs:{"icon":"trash-alt"}}),_vm._v(" Excluir\n                    ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('fechaModal', 'deletar')}}},[_vm._v("\n                        Cancelar\n                    ")])])])])]},proxy:true},{key:"reordenar",fn:function(){return [_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n                        A ordem "),_c('strong',[_vm._v(_vm._s(_vm.reordenarData.ordem))]),_vm._v(" já está vinculada a outra ação.\n                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                        Deseja inserir esta nova ação nesta posição? As ações existentes a partir deste ponto serão reordenadas automaticamente.\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 slide-footer"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.$emit('confirmarReordenacao')}}},[_vm._v("\n                        Confirmar\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.$emit('fechaModal', 'reordenar')}}},[_vm._v("\n                        Cancelar\n                    ")])])])])]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lr95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintTable_vue__ = __webpack_require__("cLoA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee5767e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintTable_vue__ = __webpack_require__("skE1");
function injectStyle (ssrContext) {
  __webpack_require__("QFkB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee5767e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee5767e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lsuD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailsCargo_vue__ = __webpack_require__("Ak+W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce03476_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailsCargo_vue__ = __webpack_require__("Zsc/");
function injectStyle (ssrContext) {
  __webpack_require__("UpjY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ce03476"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailsCargo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce03476_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailsCargo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m0t7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("N9rg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4334f642_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("SL9F");
function injectStyle (ssrContext) {
  __webpack_require__("mU6k")
  __webpack_require__("NkcH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4334f642"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4334f642_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m0wa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m2hG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MensagemErro__ = __webpack_require__("3FI8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_0__MensagemErro__["a" /* default */]
  },
  props: {
    type: {
      type: String,
      default: 'text'
    },
    cssClass: {
      type: String,
      default: 'col-xs-12 col-sm-6 col-md-3'
    },
    value: {},
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    error: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputVal: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  }
});

/***/ }),

/***/ "m3VM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":_vm.detalhes.dado.nome}},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticClass:"text-xl"},[_vm._v("\n        "+_vm._s(_vm.detalhes.dado.descricao)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('ul',{attrs:{"id":"bandeiras"}},_vm._l((_vm.detalhes.bandeiras),function(ods){return _c('li',{key:ods.codigo},[_c('a',{attrs:{"href":ods.link,"target":"_blank","title":ods.titulo,"data-toggle":"popover","data-placement":"top","data-trigger":"hover","data-content":ods.objetivo}},[_c('img',{attrs:{"src":_vm.imgPath + ods.imagem,"alt":ods.titulo}})])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumblinks}}),_vm._v(" "),_c('InfoDados',{attrs:{"type":"single","title":"Fonte","description":_vm.detalhes.dado.fonte}}),_vm._v(" "),_c('InfoDados',{attrs:{"type":"list","title":"Assuntos","list":_vm.detalhes.eixos}}),_vm._v(" "),_c('InfoDados',{attrs:{"type":"list","title":"Programas Municipais","list":_vm.detalhes.tags}}),_vm._v(" "),_c('InfoDados',{attrs:{"type":"list","title":"Secretarias / Órgãos","list":_vm.detalhes.secretarias}}),_vm._v(" "),_c('Downloads'),_vm._v(" "),_c('Graficos',{attrs:{"detalhes":_vm.detalhes,"valores":_vm.valores}}),_vm._v(" "),_c('TabelaValores',{attrs:{"detalhes":_vm.detalhes,"valores":_vm.valores}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m437":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":'Comparar Dados'}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n                Abaixo você encontra os dados selecionados para ser realizada a comparação.\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"container comparativos"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumblinks}}),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.selecionados),function(selecionado){return _c('div',{key:selecionado.codigo,staticClass:"col-xs-12 col-md-6 linha-detalhe"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-9"},[_c('p',[_vm._v(_vm._s(selecionado.nome))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3 text-left"},[(_vm.permitirComparativo(selecionado))?_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Adicionar Comparativo"},on:{"click":function($event){return _vm.adicionarComparativo(selecionado.codigo, selecionado.nome)}}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}})],1):_vm._e(),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"title":"Listar valores","to":{ name: 'public_detalhes', params: { id: selecionado.codigo } }}},[_c('font-awesome-icon',{attrs:{"icon":'chart-bar'}})],1)],1)])])})],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[(_vm.dados.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Dados")]),_vm._v(" "),_vm._l((_vm.dados),function(item,index){return _c('p',{key:index},[_vm._v("\n                        "+_vm._s(item.nome)+" -\n                        "),_c('font-awesome-icon',{style:({ color: _vm.cores[index] }),attrs:{"icon":'square'}}),_vm._v(" "),_c('a',{attrs:{"role":"button","title":"remover este item do comparativo"},on:{"click":function($event){return _vm.removerComparativo(index)}}},[_c('font-awesome-icon',{style:({ color: '#d9534f' }),attrs:{"icon":'trash-alt'}})],1)],1)}),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoGrafico),expression:"tipoGrafico"}],attrs:{"type":"radio","value":"bar","name":"radiograph","checked":""},domProps:{"checked":_vm._q(_vm.tipoGrafico,"bar")},on:{"change":function($event){_vm.tipoGrafico="bar"}}}),_vm._v("Gráfico\n                            de barras")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoGrafico),expression:"tipoGrafico"}],attrs:{"type":"radio","value":"line","name":"radiograph"},domProps:{"checked":_vm._q(_vm.tipoGrafico,"line")},on:{"change":function($event){_vm.tipoGrafico="line"}}}),_vm._v("Gráfico de\n                            linhas")])])],2),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.tipoGrafico === 'bar')?_c('bar-chart',{ref:"graph_barra",attrs:{"css-classes":'chart-container',"chart-data":_vm.dados_grafico,"gradiente":false,"options":{
                            responsive: true,
                            maintainAspectRatio: false,
                            legend: {
                                display: true
                            },
                            scales: {
                                yAxes: [
                                    {
                                        ticks: {
                                            beginAtZero: true,
                                            suggestedMax: 50
                                        }
                                    }
                                ],
                                xAxes: [
                                    {
                                        maxBarThickness: 50
                                    }
                                ]
                            }
                        }}}):_vm._e(),_vm._v(" "),(_vm.tipoGrafico === 'line')?_c('line-chart',{ref:"graph_linha",attrs:{"css-classes":'chart-container',"chart-data":_vm.dados_grafico,"gradiente":false,"coloredLine":true,"options":{
                            responsive: true,
                            maintainAspectRatio: false,
                            legend: {
                                display: true
                            },
                            scales: {
                                yAxes: [
                                    {
                                        ticks: {
                                            beginAtZero: true,
                                            suggestedMax: 50
                                        }
                                    }
                                ],
                                xAxes: [
                                    {
                                        maxBarThickness: 50
                                    }
                                ]
                            },
                            elements: {
                                line: {
                                    fill: false,
                                    borderWidth: 4
                                },
                                point: {
                                    radius: 5,
                                    hoverRadius: 6
                                }
                            }
                        }}}):_vm._e()],1)]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"mode":"in-out"}},[(_vm.dados.length > 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Comparativos")]),_vm._v(" "),_vm._l((_vm.dados),function(item,index){return _c('p',{key:index},[_vm._v("\n                        "+_vm._s(item.nome)+" - "),_c('b',[_vm._v("Dado "+_vm._s(index + 1))]),_vm._v(" "),_c('a',{attrs:{"role":"button","title":"remover este item do comparativo"},on:{"click":function($event){return _vm.removerComparativo(index)}}},[_c('font-awesome-icon',{style:({ color: '#d9534f' }),attrs:{"icon":'trash-alt'}})],1)])}),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoComparativo),expression:"tipoComparativo"}],attrs:{"type":"radio","value":"soma","name":"radiocomparativo","checked":""},domProps:{"checked":_vm._q(_vm.tipoComparativo,"soma")},on:{"change":function($event){_vm.tipoComparativo="soma"}}}),_vm._v("Soma Simples (Dado 1 + Dado 2 + ... + Dado N)")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoComparativo),expression:"tipoComparativo"}],attrs:{"type":"radio","value":"mediaSimples","name":"radiocomparativo"},domProps:{"checked":_vm._q(_vm.tipoComparativo,"mediaSimples")},on:{"change":function($event){_vm.tipoComparativo="mediaSimples"}}}),_vm._v("Média Simples ((Dado 1 + Dado 2 + ... + Dado N) / N)")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoComparativo),expression:"tipoComparativo"}],attrs:{"type":"radio","value":"mediaAnual","name":"radiocomparativo"},domProps:{"checked":_vm._q(_vm.tipoComparativo,"mediaAnual")},on:{"change":function($event){_vm.tipoComparativo="mediaAnual"}}}),_vm._v("Média Anual ((Ano 1 + Ano 2 + ... + Ano N ) / N)")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoComparativo),expression:"tipoComparativo"}],attrs:{"type":"radio","value":"relacao","name":"radiocomparativo"},domProps:{"checked":_vm._q(_vm.tipoComparativo,"relacao")},on:{"change":function($event){_vm.tipoComparativo="relacao"}}}),_vm._v("Relação (Dado 1 / Dado 2)")])])],2),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('bar-chart',{ref:"grafico_comparativo",attrs:{"css-classes":'chart-container',"chart-data":_vm.dados_comparativos,"gradiente":false,"options":{
                            responsive: true,
                            maintainAspectRatio: false,
                            legend: {
                                display: true
                            },
                            scales: {
                                yAxes: [
                                    {
                                        ticks: {
                                            beginAtZero: true
                                        }
                                    }
                                ],
                                xAxes: [
                                    {
                                        maxBarThickness: 50
                                    }
                                ]
                            }
                        }}})],1)]):_vm._e()])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Comparativos Disponíveis")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m6QU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receitasDespesas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_public_receitas_despesas_receitas__ = __webpack_require__("c/7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_public_receitas_despesas_receitas_Detalhes__ = __webpack_require__("F9jO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_public_receitas_despesas_despesas__ = __webpack_require__("UrVS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_public_receitas_despesas_despesas_DetalheGrupoDespesa__ = __webpack_require__("TrY4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const__ = __webpack_require__("4Nwh");






var receitasDespesas = [{
  name: 'receitas_despesas',
  path: '/receitas_despesas',
  component: function component() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "U6dw"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_4__const__["a" /* DEFAULT_TITLE */] + ' | Receitas e Despesas'
  }
}, {
  name: 'receitas',
  path: '/receitas',
  component: __WEBPACK_IMPORTED_MODULE_0__views_public_receitas_despesas_receitas__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_4__const__["a" /* DEFAULT_TITLE */] + ' | Receitas'
  }
}, {
  name: 'receitas_detalhes',
  path: '/receitas/detalhes/:id',
  component: __WEBPACK_IMPORTED_MODULE_1__views_public_receitas_despesas_receitas_Detalhes__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_4__const__["a" /* DEFAULT_TITLE */] + ' | Detalhes de receitas'
  }
}, {
  name: 'despesas',
  path: '/despesas',
  component: __WEBPACK_IMPORTED_MODULE_2__views_public_receitas_despesas_despesas__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_4__const__["a" /* DEFAULT_TITLE */] + ' | Despesas'
  }
}, {
  name: 'detalhe_grupo_despesa',
  path: '/despesas/grupo/:descricao/:operacao/detalhes',
  component: __WEBPACK_IMPORTED_MODULE_3__views_public_receitas_despesas_despesas_DetalheGrupoDespesa__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_4__const__["a" /* DEFAULT_TITLE */] + ' | Despesas por grupo'
  }
}];

/***/ }),

/***/ "m82R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m9li":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vincular-unidades-usuario',
  data: function data() {
    return {
      users: [],
      filters: {
        sshd: '',
        filter: ''
      },
      lastFilter: '*',
      columns: [{
        name: 'sigla',
        title: 'Nome',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.loadUsers();
  },

  computed: {
    associadoFiltros: function associadoFiltros() {
      return {
        userid: this.userActive,
        nome: this.associadoNome
      };
    },
    associarFiltros: function associarFiltros() {
      return {
        userid: this.userActive,
        nome: this.associarNome
      };
    },

    paginaUnidadesVinculadas: {
      get: function get() {
        var escalasVincularUnidadeUsuario = this.$store.state.vuetableState.escalasVincularUnidadeUsuario;
        var paginaUnidadesVinculadas = escalasVincularUnidadeUsuario.paginaUnidadesVinculadas;

        return paginaUnidadesVinculadas;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'escalasVincularUnidadeUsuario',
          value: value
        });
      }
    },
    paginaUnidadesDisponiveis: {
      get: function get() {
        var escalasVincularUnidadeUsuario = this.$store.state.vuetableState.escalasVincularUnidadeUsuario;
        var paginaUnidadesDisponiveis = escalasVincularUnidadeUsuario.paginaUnidadesDisponiveis;

        return paginaUnidadesDisponiveis;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'escalasVincularUnidadeUsuario',
          value: value
        });
      }
    }
  },
  methods: {
    loadUsers: function loadUsers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('user/list/all').then(function (response) {
        var data = response.data;

        _this.users = data;
      }).catch(function (e) {
        console.log(e);
      });
    },
    pesquisarUnidades: function pesquisarUnidades() {
      var filter = this.filters.filter;

      if ((filter.length === 0 || filter.length > 3) && filter !== this.lastFilter) {
        this.$refs.listUnidadesDisponiveis.refresh();
        this.lastFilter = filter;
      }
    },
    vincular: function vincular(unidade) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('escala/vincular-unidade', { sshd: this.filters.sshd, unidade: unidade }).then(function (response) {
        _this2.refreshLists();
      }).catch(function (e) {
        _this2.$toastr.e('Ops falha ao tentar vincular a unidade ' + unidade.sigla + ' , Tente novamente daqui alguns minutos!');
        console.log(e);
      });
    },
    desvincular: function desvincular(unidade) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('escala/desvincular-unidade', {
        sshd: this.filters.sshd,
        unidade: unidade
      }).then(function (response) {
        _this3.refreshLists();
      }).catch(function (e) {
        _this3.$toastr.e('Ops falha ao tentar desvincular a unidade ' + unidade.sigla + ' , Tente novamente daqui alguns minutos!');
        console.log(e);
      });
    },
    refreshLists: function refreshLists() {
      this.$nextTick(function () {
        this.$refs.listUnidadesVinculadas.refresh();
        this.$refs.listUnidadesDisponiveis.refresh();
      });
    }
  }
});

/***/ }),

/***/ "mMgo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__ = __webpack_require__("C9Vx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a51c532_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Vvib");
function injectStyle (ssrContext) {
  __webpack_require__("Yij3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a51c532"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_app_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a51c532_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mOIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mRqr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__request__ = __webpack_require__("OOvn");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-associate',
  inject: ["showConfirm"],
  data: function data() {
    return {
      carregando: false,
      users: [],
      userActive: '',
      otherUsers: {},
      associadoNome: '',
      associarNome: '',
      associarSecretaria: '',
      secretarias: [],
      autarquias: [],
      columns: [{
        name: 'nome',
        title: 'Nome',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_3__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('listar-secretarias-associadas').then(function (_ref) {
      var data = _ref.data;

      if (data.status) {
        _this.secretarias = data.data;
      }
    }).catch(function () {
      _this.$toastr.e('Houve uma falha ao tentar carregar o filtro secretarias!');
    });

    __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('listar-autarquias-associadas').then(function (_ref2) {
      var data = _ref2.data;

      if (data.status) {
        _this.autarquias = data.data;
      }
    }).catch(function () {
      _this.$toastr.e('Houve uma falha ao tentar carregar o filtro secretarias!');
    });

    __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].get('user/list/all').then(function (response) {
      _this.loadUsers(response.data);
    }).catch(function (error) {
      console.log(error.response);
    });
  },

  computed: {
    associadoFiltros: function associadoFiltros() {
      return {
        userid: this.userActive,
        nome: this.associadoNome
      };
    },
    associarFiltros: function associarFiltros() {
      return {
        userid: this.userActive,
        nome: this.associarNome,
        secretaria: this.associarSecretaria
      };
    },

    paginaAssociados: {
      get: function get() {
        var dadosAssociados = this.$store.state.vuetableState.dadosAssociados;
        var pagina = dadosAssociados.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dadosAssociados',
          value: value
        });
      }
    },
    paginaParaAssociar: {
      get: function get() {
        var dadosParaAssociar = this.$store.state.vuetableState.dadosParaAssociar;
        var pagina = dadosParaAssociar.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dadosParaAssociar',
          value: value
        });
      }
    },
    multiplosUsuarios: function multiplosUsuarios() {
      var usuarios = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.otherUsers);
      var ids = [];

      for (var index = 0; index < usuarios.length; index++) {
        var element = this.otherUsers[usuarios[index]];

        if (element && !ids.includes(element) && this.userActive !== element) {
          ids.push(element);
        }
      }

      return ids;
    }
  },
  methods: {
    newUser: function newUser() {
      var userNumber = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.otherUsers).length + 1;
      this.otherUsers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.otherUsers, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'user' + userNumber, ''));
    },
    associarDados: function associarDados() {
      var _this2 = this;

      var config = {
        title: 'Atenção',
        question: true,
        yes: function yes() {
          _this2.associarVarios();
        }
      };
      this.showConfirm('Deseja associar os mesmos dados aos usuários selecionados? Qualquer dado associado anteriormente será removido.', config);
    },
    loadUsers: function loadUsers(data) {
      this.users = data;
      // if (this.users.length > 0) {
      //   this.selectUser(this.users[0].codigo)
      // }
    },
    selectUser: function selectUser(id) {
      this.userActive = id;
      this.otherUsers = {};
      this.loadDadosAssociados();
      this.loadDadosAssociar();
    },
    loadDadosAssociados: function loadDadosAssociados() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs.dt_associado.refresh();
      });
    },
    loadDadosAssociar: function loadDadosAssociar() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.$refs.dt_associar.refresh();
      });
    },
    loadDados: function loadDados() {
      this.loadDadosAssociados();
      this.loadDadosAssociar();
    },
    associarVarios: function associarVarios() {
      var _this5 = this;

      this.carregando = true;
      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('dado/associar-varios', { idusuario: this.userActive, listausuarios: this.multiplosUsuarios }).then(function (response) {
        _this5.$toastr.s(response.data.msg);
      }).catch(function (error) {
        _this5.$toastr.e('Houve um erro ao associar dados. Tenta novamente ou contate o administrador');
        console.log(error.response);
      }).then(function () {
        _this5.carregando = false;
      });
    },
    associar: function associar(item) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('dado/associar', { dadoid: item.codigo, userid: this.userActive }).then(function (response) {
        if (response.data.status) {
          _this6.loadDados();
          _this6.$toastr.s('Dado associado com sucesso');
        } else {
          _this6.$toastr.e('Houve uma falha ao tentar associar o dado, por favor tente novamente daqui alguns minutos!');
        }
      }).catch(function (error) {
        return console.log(error.response);
      });
    },
    associarTodos: function associarTodos() {
      var _this7 = this;

      var salvar = function salvar() {
        __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('dado/associar-todos', _this7.associarFiltros).then(function (response) {
          var data = response.data;

          if (data.status) {
            _this7.$refs.dt_associado.refresh();
            _this7.$refs.dt_associar.refresh();
          }

          _this7.$toastr.s(data.msg);
        }).catch(function (error) {
          _this7.$toastr.e('Houve um erro ao associar os dados. Tente novamente e, caso o problema persista, contate o administrador.');
          console.log(error.response);
        });
      };

      var config = {
        title: 'Atenção',
        question: true,
        yes: function yes() {
          salvar();
        }
      };
      this.showConfirm('Deseja associar TODOS OS DADOS LISTADOS para o usuário selecionado?', config);
    },
    desassociarTodos: function desassociarTodos() {
      var _this8 = this;

      var salvar = function salvar() {
        __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('dado/desassociar-todos', { userid: _this8.userActive }).then(function (response) {
          var data = response.data;

          if (data.status) {
            _this8.$refs.dt_associado.refresh();
            _this8.$refs.dt_associar.refresh();
          }

          _this8.$toastr.s(data.msg);
        }).catch(function (error) {
          _this8.$toastr.e('Houve um erro ao desassociar os dados. Tente novamente e, caso o problema persista, contate o administrador.');
          console.log(error.response);
        });
      };

      var config = {
        title: 'Atenção',
        question: true,
        yes: function yes() {
          salvar();
        }
      };
      this.showConfirm('Deseja desassociar TODOS OS DADOS LISTADOS para o usuário selecionado?', config);
    },
    desassociar: function desassociar(item) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_4__request__["a" /* request */].post('dado/desassociar', { dadoid: item.codigo, userid: this.userActive }).then(function (response) {
        if (response.data.status) {
          _this9.loadDados();
          _this9.$toastr.s('Dado desassociado com sucesso');
        } else {
          _this9.$toastr.e('Houve uma falha ao tentar desassociar o dado, por favor tente novamente daqui alguns minutos!');
        }
      }).catch(function (error) {
        return console.log(error.response);
      });
    },
    limparDadoAssociado: function limparDadoAssociado() {
      this.associadoNome = '';
      this.associarSecretaria = '';
      this.loadDadosAssociados();
    },
    limparDadoAssociar: function limparDadoAssociar() {
      this.associarNome = '';
      this.associarSecretaria = '';
      this.loadDadosAssociar();
    }
  }
});

/***/ }),

/***/ "mSLM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CriterioRemedio',
  props: {
    remedio: {
      type: Object,
      required: true
    }
  },
  methods: {
    getDescricaoOrientacao: function getDescricaoOrientacao(_ref) {
      var orientacao = _ref.orientacao;

      var index = orientacao.indexOf(':');
      var title = orientacao.substring(0, index + 1);
      var text = orientacao.substring(index + 1);

      return '<strong>' + title + '</strong> ' + text;
    }
  }
});

/***/ }),

/***/ "mT4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    time: {
      type: Object
    }
  },
  computed: {
    entradaIsEmpty: function entradaIsEmpty() {
      return this.time.entrada === '';
    },
    saidaIsEmpty: function saidaIsEmpty() {
      return this.time.saida === '';
    }
  }
});

/***/ }),

/***/ "mU6k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__env_json__ = __webpack_require__("ufme");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__env_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__env_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_user_types__ = __webpack_require__("tBN9");






var actions = {
  tryLogin: function tryLogin(store, payload) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__env_json__["apiUrl"] + 'auth/login', payload).then(function (response) {
        localStorage.setItem('daUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'token': response.data.token }));
        store.commit(__WEBPACK_IMPORTED_MODULE_4__modules_user_types__["a" /* LOGIN_USER */], response.data);
        resolve(response);
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  logout: function logout(store, payload) {
    localStorage.removeItem('daUser');
    localStorage.removeItem('vuex');
    store.commit('CLEAR_MODULES');
    store.commit(__WEBPACK_IMPORTED_MODULE_4__modules_user_types__["b" /* LOGOUT_USER */]);
  }
};

/***/ }),

/***/ "mVoC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.fields.namedRoute}},[_c('div',{staticClass:"card-emendas bg form-group",style:({
      backgroundImage:
        'url(' + __webpack_require__("U9j/")("./" + (_vm.fields.icon)) + ')'
    })},[_c('div',{staticClass:"context"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.fields.nome))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.formatarMoeda(_vm.fields.valor)))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mZdd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('label',{staticClass:"control-label"},[_vm._v("Replicar os colaboradores por escalas anteriores")]),_vm._v(" "),_c('div',{staticClass:"control-wrapper"},[_c('Select',{attrs:{"options":_vm.replicableReferences,"showOptionEmpty":false,"disabled":_vm.desactive},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.desactive},on:{"click":_vm.loadEmployees}},[_vm._v("\n      Replicar\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mbtb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.9469a16.jpg";

/***/ }),

/***/ "mg2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pesquisa"},[_c('div',{staticClass:"row"},[_c('public-header',{attrs:{"title":'Pesquisa Volta as Aulas'}},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"subheader"},[_vm._v("\n          Pesquisa de intenção de retorno as aulas\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._v("\n        Pesquisa finalizada em: 19/09/2020\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-8"},[_c('h3',[_vm._v("Selecione a escola desejada")]),_vm._v(" "),_c('v-select',{ref:"escolas",staticClass:"style-chooser",attrs:{"label":"descricao","options":_vm.lista_escolas,"placeholder":'Selecione a escola',"selectOnTab":true},on:{"input":function($event){return _vm.listarDados()}},model:{value:(_vm.escola),callback:function ($$v) {_vm.escola=$$v},expression:"escola"}},[_c('template',{slot:"no-options"},[_vm._v("\n              Escola não encontrada...\n            ")])],2)],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[(_vm.informacoes.length > 0)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Resultado geral do retorno as aulas - SETEMBRO/2020")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('doughnut',{ref:"geral",attrs:{"css-classes":'chart-container',"chart-data":_vm.retornoResultadoGeral,"gradiente":false,"options":_vm.options}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Pai de aluno/estudante menor de 18 anos")])]),_vm._v(" "),(_vm.retornoPaiAluno.labels.length)?_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('h4',[_vm._v("\n                9.b Pai e/ou responsável, em relação à COVID-19, quando você\n                autorizaria o seu filho a retornar às aulas presenciais?\n              ")]),_vm._v(" "),_c('doughnut',{ref:"pai_aluno",attrs:{"css-classes":'chart-container',"chart-data":_vm.retornoPaiAluno,"gradiente":false,"options":_vm.options}})],1):_vm._e(),_vm._v(" "),(_vm.retornoSetembroPai.labels.length)?_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('h4',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n                7.b De acordo com a resolução n.61 do Governo do Estado de SP,\n                as unidades escolares de educação básica poderão oferecer\n                atividades presenciais de reforço e recuperação de\n                aprendizagem, acolhimento emocional, orientação de estudos e\n                tutoria, atividades esportivas e culturais, para um número\n                reduzido de alunos e horas de permanência na escola, a partir\n                de setembro. Diante disso, você pai/responsável autorizaria o\n                seu filho a frequentar presencialmente a escola em setembro?\n              ")]),_vm._v(" "),_c('p',{staticClass:"hidden-sm hidden-xs",staticStyle:{"font-weight":"bold"}},[_vm._v("\n                7.b De acordo com a resolução n.61 do Governo do Estado de SP,\n                as unidades escolares de educação básica poderão oferecer\n                atividades presenciais de reforço e recuperação de\n                aprendizagem, acolhimento emocional, orientação de estudos e\n                tutoria, atividades esportivas e culturais, para um número\n                reduzido de alunos e horas de permanência na escola, a partir\n                de setembro. Diante disso, você pai/responsável autorizaria o\n                seu filho a frequentar presencialmente a escola em setembro?\n              ")]),_vm._v(" "),_c('doughnut',{ref:"retorno_setembro_pai",attrs:{"css-classes":'chart-container',"chart-data":_vm.retornoSetembroPai,"gradiente":false,"options":_vm.options}})],1):_vm._e(),_vm._v(" "),(_vm.retornoOutubroPai.labels.length)?_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('h4',[_vm._v("\n                8.b Sobre o retorno às aulas presenciais, previsto para\n                outubro, você pai/responsável autorizaria o seu filho a\n                frequentar presencialmente a escola?\n              ")]),_vm._v(" "),_c('doughnut',{ref:"retorno_outubro_pai",attrs:{"css-classes":'chart-container',"chart-data":_vm.retornoOutubroPai,"gradiente":false,"options":_vm.options}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Profissionais da educação")])]),_vm._v(" "),(_vm.retornoProfissionalEducacao.labels.length)?_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('h4',[_vm._v("\n                8.c Profissional da educação, em relação à COVID-19, quando\n                você retornaria às aulas presenciais?\n              ")]),_vm._v(" "),_c('doughnut',{ref:"profissional",attrs:{"css-classes":'chart-container',"chart-data":_vm.retornoProfissionalEducacao,"gradiente":false,"options":_vm.options}})],1):_vm._e(),_vm._v(" "),(_vm.retornoProfissionalSetembro.labels.length)?_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('h4',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n                6.c De acordo com a resolução n.61 do Governo do Estado de SP,\n                as unidades escolares de educação básica poderão oferecer\n                atividades presenciais de reforço e recuperação de\n                aprendizagem, acolhimento emocional, orientação de estudos e\n                tutoria, atividades esportivas e culturais, para um número\n                reduzido de alunos e horas de permanência na escola, a partir\n                de setembro. Diante disso, você profissional da educação se\n                sente seguro em frequentar presencialmente a escola em\n                setembro?\n              ")]),_vm._v(" "),_c('p',{staticClass:"hidden-xs hidden-sm",staticStyle:{"font-weight":"bold"}},[_vm._v("\n                6.c De acordo com a resolução n.61 do Governo do Estado de SP,\n                as unidades escolares de educação básica poderão oferecer\n                atividades presenciais de reforço e recuperação de\n                aprendizagem, acolhimento emocional, orientação de estudos e\n                tutoria, atividades esportivas e culturais, para um número\n                reduzido de alunos e horas de permanência na escola, a partir\n                de setembro. Diante disso, você profissional da educação se\n                sente seguro em frequentar presencialmente a escola em\n                setembro?\n              ")]),_vm._v(" "),_c('doughnut',{ref:"profissional_setembro",attrs:{"css-classes":'chart-container',"chart-data":_vm.retornoProfissionalSetembro,"gradiente":false,"options":_vm.options}})],1):_vm._e(),_vm._v(" "),(_vm.retornoProfissionalOutubro.labels.length)?_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('h4',[_vm._v("\n                7.c Sobre o retorno às aulas presenciais, previsto para\n                outubro, você profissional da educação se sente seguro para\n                frequentar presencialmente a escola?\n              ")]),_vm._v(" "),_c('doughnut',{ref:"profissional_outrubro",attrs:{"css-classes":'chart-container',"chart-data":_vm.retornoProfissionalOutubro,"gradiente":false,"options":_vm.options}})],1):_vm._e()]),_vm._v(" "),(_vm.retornoAlunoMaior.labels.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Aluno/estudante Maior de 18 anos")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-6"},[_c('h4',[_vm._v("\n                7.a Aluno/estudante Maior de 18 anos, em relação à COVID-19,\n                quando você retornaria às aulas presenciais?\n              ")]),_vm._v(" "),_c('doughnut',{ref:"aluno_maior",attrs:{"css-classes":'chart-container',"chart-data":_vm.retornoAlunoMaior,"gradiente":false,"options":_vm.options}})],1)]):_vm._e()]):_vm._e()])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mxon":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mz2l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return escalas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_escalas__ = __webpack_require__("BCwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_escalas_Save__ = __webpack_require__("ycrs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_escalas_Pendentes__ = __webpack_require__("x/Qh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_admin_escalas_Publicar__ = __webpack_require__("KPqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_admin_escalas_RemoverPublicacao__ = __webpack_require__("cGkU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_admin_escalas_RelatorioPerfilUnidade__ = __webpack_require__("h4zR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_admin_escalas_gestao_GestaoPerfilUnidade__ = __webpack_require__("qY+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_admin_escalas_Relatorio__ = __webpack_require__("++Vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_admin_escalas_VincularUnidadesUsuario__ = __webpack_require__("l88I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_admin_escalas_Impressao__ = __webpack_require__("ua68");











var escalas = [{
  path: 'escalas/list',
  component: __WEBPACK_IMPORTED_MODULE_0__views_admin_escalas__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  path: 'escalas/add',
  name: 'escalas_add',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin_escalas_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  path: 'escalas/pendentes',
  component: __WEBPACK_IMPORTED_MODULE_2__views_admin_escalas_Pendentes__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'escalas_publicar',
  path: 'escalas/publicar',
  component: __WEBPACK_IMPORTED_MODULE_3__views_admin_escalas_Publicar__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'escalas_remover_publicacao',
  path: 'escalas/remover-publicacao',
  component: __WEBPACK_IMPORTED_MODULE_4__views_admin_escalas_RemoverPublicacao__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'relatorio_perfil_unidade',
  path: 'escalas/relatorio-perfil-unidade',
  component: __WEBPACK_IMPORTED_MODULE_5__views_admin_escalas_RelatorioPerfilUnidade__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'gestao_perfil_unidade',
  path: 'escalas/gestao-perfil-unidade',
  component: __WEBPACK_IMPORTED_MODULE_6__views_admin_escalas_gestao_GestaoPerfilUnidade__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'escalas_relatorio_status',
  path: 'escalas/relatorio',
  component: __WEBPACK_IMPORTED_MODULE_7__views_admin_escalas_Relatorio__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'vincular-unidades-usuario',
  path: 'escalas/vincular-unidades-usuario',
  component: __WEBPACK_IMPORTED_MODULE_8__views_admin_escalas_VincularUnidadesUsuario__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'escala-impressao',
  path: 'escalas/impressao',
  component: __WEBPACK_IMPORTED_MODULE_9__views_admin_escalas_Impressao__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}];

/***/ }),

/***/ "n/ii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eixos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_eixos__ = __webpack_require__("VmGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_eixos_Save__ = __webpack_require__("fEnf");



var eixos = [{
  path: 'eixos/list',
  component: __WEBPACK_IMPORTED_MODULE_0__views_admin_eixos__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}, {
  name: 'admin_eixos_save',
  path: 'eixos/save/:id?/:name?',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin_eixos_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}];

/***/ }),

/***/ "n0p4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ods; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_ods_movimentos__ = __webpack_require__("m0t7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_ods_movimentos_Import__ = __webpack_require__("KRwM");



var ods = [{
  path: 'ods',
  redirect: 'ods/movimentos',
  component: function component() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "+DB5"));
  },
  children: [{
    path: 'movimentos',
    component: __WEBPACK_IMPORTED_MODULE_0__views_admin_ods_movimentos__["a" /* default */],
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  }, {
    path: 'movimentos/import',
    component: __WEBPACK_IMPORTED_MODULE_1__views_admin_ods_movimentos_Import__["a" /* default */],
    meta: {
      requiresAuth: true,
      userAuth: true
    }
  }]
}];

/***/ }),

/***/ "n6NU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n96d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 scroll"},[(_vm.detalhes.dado.periodicidade === 6)?_c('div',[_c('h3',[_vm._v("Tabela")]),_vm._v(" "),_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('th',[_vm._v("\n            Período\n          ")]),_vm._v(" "),(_vm.detalhes.dado.tipo != 'T')?_c('th',[_vm._v("\n            Valores\n          ")]):_vm._e(),_vm._v(" "),(_vm.detalhes.dado.tipo == 'T')?_c('th',[_vm._v("\n            Ações\n          ")]):_vm._e()]),_vm._v(" "),_c('tbody',_vm._l((_vm.valores),function(valor){return _c('tr',{key:valor.codigo},[_c('td',[_vm._v("\n              "+_vm._s(new Date(valor.data).getFullYear())+"\n            ")]),_vm._v(" "),(_vm.detalhes.dado.tipo != 'T')?_c('td',[_vm._v("\n              "+_vm._s(_vm.formatValue(valor.valor))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.detalhes.dado.tipo == 'T')?_c('td',[_vm._v("\n              "+_vm._s(valor.descricao)+"\n            ")]):_vm._e()])}),0)])]):_vm._e(),_vm._v(" "),(_vm.detalhes.dado.periodicidade === 1)?_c('div',[_c('h3',[_vm._v("Tabela")]),_vm._v(" "),_c('table',{staticClass:"table table-striped"},[_c('thead',_vm._l((_vm.dados_tabela.header),function(item,index){return _c('th',{key:index,staticClass:"table-head-right"},[_vm._v("\n            "+_vm._s(item)+"\n          ")])}),0),_vm._v(" "),_c('tbody',_vm._l((_vm.dados_tabela.body),function(item,index){return _c('tr',{key:index,staticClass:"table-body-right"},_vm._l((item),function(subitem,subindex){return _c('td',{key:subindex},[_vm._v("\n              "+_vm._s(subindex > 0 ? _vm.formatValue(subitem) : subitem)+"\n            ")])}),0)}),0)])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n9qF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__ = __webpack_require__("H/Tp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_045d4022_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__("BrMx");
function injectStyle (ssrContext) {
  __webpack_require__("T8tZ")
  __webpack_require__("GAf2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-045d4022"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_045d4022_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nAL6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("KWRI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a8a8da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("SLoD");
function injectStyle (ssrContext) {
  __webpack_require__("Brul")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a8a8da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nBdW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PorSecretaria_vue__ = __webpack_require__("cWeO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d092828_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PorSecretaria_vue__ = __webpack_require__("ksNf");
function injectStyle (ssrContext) {
  __webpack_require__("9pAA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d092828"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PorSecretaria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d092828_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PorSecretaria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nLhK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationInfo_vue__ = __webpack_require__("8Pjl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_204c9cd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePaginationInfo_vue__ = __webpack_require__("hJI8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuetablePaginationInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_204c9cd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuetablePaginationInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nNvT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('header',[_c('nav',{staticClass:"navbar navbar-default navbar-static-top",attrs:{"role":"navigation"}},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand-admin",attrs:{"to":"/admin"}},[_vm._v("Dados Abertos - Admin")])],1),_vm._v(" "),_c('ul',{staticClass:"nav navbar-top-links navbar-right",attrs:{"id":"menu-principal"}},[_c('li',{staticClass:"dropdown right"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"data-toggle":"dropdown","href":"#"}},[_c('font-awesome-icon',{attrs:{"icon":'user'}}),_c('font-awesome-icon',{attrs:{"icon":'caret-down'}})],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-user"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Perfil"),_c('font-awesome-icon',{staticClass:"icones-margem",attrs:{"icon":'user'}})],1)]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.logout}},[_vm._v("\n                Logout"),_c('font-awesome-icon',{staticClass:"icones-margem",attrs:{"icon":'sign-out-alt'}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"navbar-default sidebar",attrs:{"role":"navigation"}},[_c('div',{staticClass:"sidebar-nav collapse navbar-collapse"},[_c('ul',{staticClass:"nav",attrs:{"id":"side-menu"}},_vm._l((_vm.menus),function(menu){return _c('li',{key:menu.nome},[(menu.hasOwnProperty('submenus'))?_c('a',{class:{ active: menu.active },attrs:{"href":"#"}},[_c('font-awesome-icon',{attrs:{"icon":menu.iconName}}),_vm._v("\n                "+_vm._s(menu.nome)+"\n                "),_c('font-awesome-icon',{attrs:{"icon":'caret-down'}})],1):_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.changePartialView(menu)}}},[_c('font-awesome-icon',{attrs:{"icon":menu.iconName}}),_vm._v("\n                "+_vm._s(menu.nome)+"\n              ")],1),_vm._v(" "),(menu.hasOwnProperty('submenus'))?_c('ul',{staticClass:"nav nav-second-level"},_vm._l((menu.submenus),function(submenu){return _c('li',{key:submenu.nome},[_c('a',{class:{ active: submenu.active },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.changePartialView(submenu)}}},[_c('font-awesome-icon',{attrs:{"icon":submenu.iconName}}),_vm._v("\n                    "+_vm._s(submenu.nome)+"\n                  ")],1)])}),0):_vm._e()])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"page-print",attrs:{"id":"page-content"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('auto-progress'),_vm._v(" "),_c('modal',{ref:"modal"}),_vm._v(" "),_c('modal-alert',{ref:"modalAlert"}),_vm._v(" "),_c('login-modal',{ref:"loginModal"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":".navbar-collapse"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nOv1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":'Listagem de ' + _vm.title,"reportTitle":"Dados","api-url":"dado/list","fields":_vm.model.columns,"initial-page":_vm.pagina,"pageCollection":'dados',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"ano1",fn:function(props){return [_c('div',{},[_c('span',[(props.rowData.hasValorAno1)?_c('font-awesome-icon',{staticStyle:{"color":"green"},attrs:{"icon":'check'}}):_c('font-awesome-icon',{staticStyle:{"color":"red"},attrs:{"icon":'minus'}})],1)])]}},{key:"ano2",fn:function(props){return [_c('div',{},[_c('span',[(props.rowData.hasValorAno2)?_c('font-awesome-icon',{staticStyle:{"color":"green"},attrs:{"icon":'check'}}):_c('font-awesome-icon',{staticStyle:{"color":"red"},attrs:{"icon":'minus'}})],1)])]}},{key:"ano3",fn:function(props){return [_c('div',{},[_c('span',[(props.rowData.hasValorAno3)?_c('font-awesome-icon',{staticStyle:{"color":"green"},attrs:{"icon":'check'}}):_c('font-awesome-icon',{staticStyle:{"color":"red"},attrs:{"icon":'minus'}})],1)])]}},{key:"ano4",fn:function(props){return [_c('div',{},[_c('span',[(props.rowData.hasValorAno4)?_c('font-awesome-icon',{staticStyle:{"color":"green"},attrs:{"icon":'check'}}):_c('font-awesome-icon',{staticStyle:{"color":"red"},attrs:{"icon":'minus'}})],1)])]}},{key:"rowrender",fn:function(props){return [_c('div',{staticClass:"button-wrapper"},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Listar valores","type":"button"},on:{"click":function($event){return _vm.listValues(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'list-ol'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"nome_filter"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nome),expression:"nome"}],staticClass:"form-control",attrs:{"type":"text","name":"nome_filter"},domProps:{"value":(_vm.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"periodicidade_codigo_filter"}},[_vm._v("Periodicidade")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.periodicidade_codigo),expression:"periodicidade_codigo"}],staticClass:"form-control select-selected",attrs:{"name":"periodicidade_codigo_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.periodicidade_codigo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":"*"}},[_vm._v("Todas")]),_vm._v(" "),_vm._l((_vm.periodicidades),function(i){return _c('option',{key:i.codigo,domProps:{"value":i.codigo}},[_vm._v("\n                    "+_vm._s(i.descricao)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"DAD_DLFONTE_filter"}},[_vm._v("Fonte")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fonte),expression:"fonte"}],staticClass:"form-control",attrs:{"type":"text","name":"DAD_DLFONTE_filter"},domProps:{"value":(_vm.fonte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fonte=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"secretaria_sigla_filter"}},[_vm._v("Secretaria")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.secretaria_sigla),expression:"secretaria_sigla"}],staticClass:"form-control select-selected",attrs:{"name":"secretaria_sigla_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.secretaria_sigla=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":""}},[_vm._v("Todas")]),_vm._v(" "),_vm._l((_vm.secretarias),function(i){return _c('option',{key:i.codigo,domProps:{"value":i.sigla}},[_vm._v("\n                    "+_vm._s(i.sigla)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"autarquia_sigla_filter"}},[_vm._v("Autarquia")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.autarquia_sigla),expression:"autarquia_sigla"}],staticClass:"form-control select-selected",attrs:{"name":"autarquia_sigla_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.autarquia_sigla=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":""}},[_vm._v("Todas")]),_vm._v(" "),_vm._l((_vm.autarquias),function(i){return _c('option',{key:i.codigo,domProps:{"value":i.sigla}},[_vm._v("\n                    "+_vm._s(i.sigla)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"status_values_filter"}},[_vm._v("Status de Preenchimento")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status_values),expression:"status_values"}],staticClass:"form-control select-selected",attrs:{"name":"status_values_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status_values=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":"*"}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"completo"}},[_vm._v("Completo")]),_vm._v(" "),_c('option',{attrs:{"value":"pendente_ultimoano"}},[_vm._v("\n                    Ultimo ano pendente\n                  ")]),_vm._v(" "),_c('option',{attrs:{"value":"pendente_anos_anteriores"}},[_vm._v("\n                    Anos anteriores pendente\n                  ")]),_vm._v(" "),_c('option',{attrs:{"value":"nenhum"}},[_vm._v("Sem lançamentos")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'admin_dado_save' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v("\n              Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nP6t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("0xDb");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_4__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_4__components__["b" /* Breadcrumb */],
    CardEmendas: __WEBPACK_IMPORTED_MODULE_4__components__["r" /* CardEmendas */],
    SelectAnoEmendas: __WEBPACK_IMPORTED_MODULE_4__components__["p" /* SelectAnoEmendas */],
    ValorDestaqueHeader: __WEBPACK_IMPORTED_MODULE_4__components__["q" /* ValorDestaqueHeader */]
  },
  data: function data() {
    return {
      breadcrumb: [{
        label: 'Emendas Parlamentares',
        named_link: { name: 'emendas_parlamentares' }
      }, {
        label: 'Emendas Por Vereador'
      }]
    };
  },


  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_5__utils__["e" /* formatarMoeda */],
    reducer: function reducer(key) {
      return function (acum, emenda) {
        return acum += Number(emenda[key]);
      };
    },
    getEmendasVereador: function getEmendasVereador(vereador) {
      var filter = function filter(emenda) {
        return emenda.vereador.nome === vereador;
      };

      return this.emendas.filter(filter);
    },
    getValorFromVereador: function getValorFromVereador(vereador) {
      var emendas = this.getEmendasVereador(vereador);
      return emendas.reduce(this.reducer('valor'), 0);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    emendas: function emendas(state) {
      return state.emendas_parlamentares.emendas;
    },
    loading: function loading(_ref) {
      var emendas_parlamentares = _ref.emendas_parlamentares;
      return emendas_parlamentares.loading;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapGetters */])(['valorTotalEmendas', 'saldoTotal', 'valorTotalUtilizado']), {
    vereadores: function vereadores() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.emendas.map(function (emenda) {
        return emenda.vereador.nome;
      }))));
    },
    cardItems: function cardItems() {
      var _this = this;

      var items = [];
      this.vereadores.forEach(function (vereador) {
        items.push({
          nome: vereador,
          valor: _this.getValorFromVereador(vereador),
          namedRoute: {
            name: 'emendas_detalhe_por_vereador',
            params: { vereador: vereador }
          }
        });
      });

      return items;
    }
  })
});

/***/ }),

/***/ "nTWC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nWxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":_vm.title}},[_vm._t("header-slot")],2)],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),(_vm.mediaEspera >= 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Lista de solicitações")]),_vm._v(" "),_c('p',{staticClass:"font-lg"},[_vm._v("\n          Tempo médio para agendamento de "+_vm._s(_vm.mediaEspera)+" dias*.\n        ")]),_vm._v(" "),_c('p',{staticClass:"subtitulo"},[_vm._v("\n          * Com base nos agendamentos dos últimos 6 meses\n        ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])]):_vm._e(),_vm._v(" "),_c('InputCartaoSUS',{attrs:{"id":'filtro_espera',"carregando":_vm.carregando.espera},on:{"click":function($event){return _vm.getByCartao('espera')}},model:{value:(_vm.numeroCartao.espera),callback:function ($$v) {_vm.$set(_vm.numeroCartao, "espera", $$v)},expression:"numeroCartao.espera"}}),_vm._v(" "),_c('ListaFilaEspera',{attrs:{"carregando":_vm.carregando.espera,"items":_vm.dados.espera}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('InputCartaoSUS',{attrs:{"id":'filtro_agendados',"carregando":_vm.carregando.agendados},on:{"click":function($event){return _vm.getByCartao('agendados')}},model:{value:(_vm.numeroCartao.agendados),callback:function ($$v) {_vm.$set(_vm.numeroCartao, "agendados", $$v)},expression:"numeroCartao.agendados"}}),_vm._v(" "),_c('ListaFilaAgendados',{attrs:{"carregando":_vm.carregando.agendados,"items":_vm.dados.agendados}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"gravidade bg-success"},[_vm._v("Normal")]),_vm._v(" - Gravidade padrão\n          para agendamento.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"gravidade bg-warning"},[_vm._v("Prioridade Clínica")]),_vm._v(" -\n          Gravidade definida a critério do médico responsável pelo\n          atendimento.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Agendados")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nZDk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ncxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("zlqU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b458e50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("fEej");
function injectStyle (ssrContext) {
  __webpack_require__("WTlz")
  __webpack_require__("bVt6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b458e50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b458e50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ng9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DividaAtiva_Paginacao_vue__ = __webpack_require__("vkGC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("0xDb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_1__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components__["b" /* Breadcrumb */],
    Paginacao: __WEBPACK_IMPORTED_MODULE_2__components_DividaAtiva_Paginacao_vue__["a" /* default */]
  },
  data: function data() {
    return {
      devedores: [],
      nome: '',
      loading: false,
      total: 0,
      page: 1,
      filter: '',
      lastFilter: ''
    };
  },
  mounted: function mounted() {
    this.fetchDividaAtiva();
  },

  watch: {
    page: function page() {
      this.fetchDividaAtiva();
    }
  },
  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_4__utils__["e" /* formatarMoeda */],
    toggleLoading: function toggleLoading() {
      this.loading = !this.loading;
    },
    filterByName: function filterByName() {
      this.filter = this.nome;

      if (this.page === 1) {
        this.fetchDividaAtiva();
        return;
      }

      this.page = 1;
    },
    fetchDividaAtiva: function fetchDividaAtiva() {
      var _this = this;

      this.toggleLoading();

      __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('lista-divida-ativa', {
        params: {
          start: (this.page - 1) * 100,
          total: 100,
          name: this.filter ? this.filter : null
        }
      }).then(function (response) {
        _this.devedores = response.data[0];
        _this.total = response.data[1];
      }).catch(function (error) {
        console.log(error.response);
        _this.$toastr.e('Houve um erro ao carregar a listagem da dívida ativa. Tente novamente mais tarde.');
      }).finally(function () {
        _this.toggleLoading();
      });
    },
    downloadPaginaDividaAtiva: function downloadPaginaDividaAtiva() {
      var headers = {
        NMCONTRIBUINTE: 'Contribuinte',
        DLCOBRANCA: 'Cobrança',
        QTDIVIDA: 'Qtde.Dívidas',
        VLACUMULADO: 'Valor da Dívida'
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* exportCSVFile */])(headers, [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.devedores.map(function (item) {
        return {
          NMCONTRIBUINTE: item.NMCONTRIBUINTE,
          DLCOBRANCA: item.DLCOBRANCA,
          QTDIVIDA: item.QTDIVIDA,
          VLACUMULADO: item.VLACUMULADO
        };
      }))), 'divida-ativa');
    }
  }
});

/***/ }),

/***/ "nkjI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-remedio-facil.27778b7.png";

/***/ }),

/***/ "o+Ct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"por-cartao"},[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":"Pesquisa por Nº SUS"}},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n          Aqui você encontra seu histórico de atendimentos e suas solicitações\n          de consultas e exames.\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_c('section',{staticClass:"border-bottom"},[_vm._m(0),_vm._v(" "),_c('CardFilaEspera',{attrs:{"carregando":_vm.carregando.especialidades,"title":'Consultas',"items":_vm.listaEspecialidades,"chave":'especialidade'}}),_vm._v(" "),_c('CardFilaEspera',{attrs:{"carregando":_vm.carregando.exames,"title":'Exames',"items":_vm.listaExames,"chave":'exame'}}),_vm._v(" "),_vm._m(1)],1),_vm._v(" "),_c('section',{staticClass:"border-bottom"},[_vm._m(2),_vm._v(" "),_c('ListaFilaAgendados',{attrs:{"carregando":_vm.carregando.especialidadesAgendados,"items":_vm.listaEspecialidadesAgendadas,"title":'Consultas',"chave":'especialidade'}}),_vm._v(" "),_c('ListaFilaAgendados',{attrs:{"carregando":_vm.carregando.examesAgendados,"items":_vm.listaExamesAgendados,"title":'Exames',"chave":'exame'}})],1),_vm._v(" "),_c('section',[_vm._m(3),_vm._v(" "),_c('ListaFilaAgendados',{attrs:{"carregando":_vm.carregando.especialidadesAgendados,"items":_vm.listaEspecialidadesConcluidas,"title":'Consultas',"chave":'especialidade'}}),_vm._v(" "),_c('ListaFilaAgendados',{attrs:{"carregando":_vm.carregando.examesAgendados,"items":_vm.listaExamesConcluidos,"title":'Exames',"chave":'exame'}})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h2',[_vm._v("Solicitações de agendamento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"font-lg"},[_vm._v("\n        Para mais informações, ligue na central de agendamento\n        "),_c('span',{staticClass:"destaque"},[_vm._v("(0800-013-0013)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h2',[_vm._v("Agendados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h2',[_vm._v("Meu histórico de saúde")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o0wj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputVagas_vue__ = __webpack_require__("m2hG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89fe4eda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputVagas_vue__ = __webpack_require__("KIXZ");
function injectStyle (ssrContext) {
  __webpack_require__("jBdJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputVagas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89fe4eda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputVagas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o7ck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_1__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components__["b" /* Breadcrumb */],
    CardEmendas: __WEBPACK_IMPORTED_MODULE_1__components__["r" /* CardEmendas */],
    SelectAnoEmendas: __WEBPACK_IMPORTED_MODULE_1__components__["p" /* SelectAnoEmendas */],
    ValorDestaqueHeader: __WEBPACK_IMPORTED_MODULE_1__components__["q" /* ValorDestaqueHeader */]
  },
  data: function data() {
    return {
      breadcrumb: [{
        label: 'Emendas Parlamentares',
        named_link: { name: 'emendas_parlamentares' }
      }, {
        label: 'Emendas Por Secretaria'
      }]
    };
  },

  methods: {
    formatarMoeda: __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* formatarMoeda */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    emendas: function emendas(state) {
      return state.emendas_parlamentares.emendas;
    },
    loading: function loading(state) {
      return state.emendas_parlamentares.loading;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapGetters */])(['valorTotalEmendas', 'valorTotalPorSecretaria', 'secretariasComEmendas', 'vereadoresComEmendas']), {
    listaCards: function listaCards() {
      var _this = this;

      var items = [];
      this.secretariasComEmendas.forEach(function (secretaria) {
        items.push({
          nome: secretaria,
          namedRoute: {
            name: 'emendas_detalhe_por_area',
            params: { secretaria: secretaria }
          },
          valor: _this.valorTotalPorSecretaria(secretaria)
        });
      });
      return items;
    }
  })
});

/***/ }),

/***/ "oKLp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oMxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards-ods"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 lista-metas"},_vm._l((_vm.metas),function(meta){return _c('div',{key:("meta-" + (meta.numero)),staticClass:"card-metas"},[_c('router-link',{attrs:{"to":meta.cardTodos
              ? { name: 'listar_dados' }
              : { name: 'listar_dados', query: { metas: meta.codigo } }}},[_c('div',{staticClass:"flip-card"},[_c('div',{staticClass:"flip-card-inner"},[_c('div',{staticClass:"flip-card-front"},[(meta.cardTodos)?_c('span',[_vm._v("\n                  Todas as metas\n                ")]):_vm._e(),_vm._v(" "),_c('img',{class:meta.cardTodos ? 'imgPMS' : 'imgODS',attrs:{"src":meta.cardTodos ? _vm.logo : ("" + _vm.imgUrl + (meta.imagem_url)),"alt":("imagem representando " + (meta.cardTodos
                        ? 'todas as metas'
                        : ("a meta " + (meta.titulo))))}})]),_vm._v(" "),_c('div',{staticClass:"flip-card-back"},[_c('p',[_vm._v(_vm._s(meta.objetivo))])])])])])],1)}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Vinculação aos ODS (Objetivos do Desenvolvimento Sustentável)")]),_vm._v(" "),_c('p',[_vm._v("\n        Os dados abertos da Prefeitura de Santos são vinculados aos ODSs. Você\n        pode consultá-los através das bandeiras abaixo:\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oN5s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oO9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'eixo-save',
  data: function data() {
    return {
      model: {
        EIX_DCEIXO: ''
      }
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var params = this.$router.history.current.params;
    if (params.hasOwnProperty('id')) {
      this.model.EIX_IDEIXO = params.id;
      this.model.EIX_DCEIXO = params.name;
    }
    this.$refs.eixo.focus();
  },

  methods: {
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Este item foi salvo com sucesso.');
      this.$router.push('list');
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
    },
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.$refs[_this.$validator.errors.items[0].field].focus();
          _this.$toastr.e(_this.$validator.errors.items[0].msg);
          return;
        }

        __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].post('eixos/save', _this.model).then(_this.saveSuccess).catch(_this.saveFail);
      });
    }
  }
});

/***/ }),

/***/ "oOIW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h3',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.config.title))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(!Array.isArray(_vm.message))?_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}}):_vm._l((_vm.message),function(ctt,index){return _c('p',{key:index,domProps:{"innerHTML":_vm._s(ctt)}})})],2),_vm._v(" "),(_vm.config.question)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.yes()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "+_vm._s(_vm.config.labelYes)+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.no()}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" "+_vm._s(_vm.config.labelNo)+"\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.config.question)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.close()}}},[_vm._v(_vm._s(_vm.config.labelOk))])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Fechar"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oX5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n      Voltar\n    ")],1),_vm._v(" "),_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.label)+" Grupo")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('form',{attrs:{"role":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.save()}}},[_c('fieldset',[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('nome') }]},[_c('label',{class:[
                  'col-xs-12',
                  'control-label',
                  'custom-font',
                  { 'is-danger': _vm.errors.has('nome') }
                ]},[_vm._v("Nome do Grupo")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 inputGroupContainer"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('nome') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome",class:[
                      'form-control',
                      { 'is-danger': _vm.errors.has('nome') }
                    ],attrs:{"name":"nome","maxlength":"50","placeholder":"Nome","type":"text"},domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': _vm.errors.has('nome') }
                    ],domProps:{"textContent":_vm._s(50 - _vm.model.nome.length)}})]),_vm._v(" "),(_vm.errors.has('nome'))?_c('small',{staticClass:"help-block",attrs:{"data-bv-validator":"notEmpty","data-bv-validator-for":"nome"}},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v("\n                  "+_vm._s(_vm.errors.first('nome'))+"\n                ")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n                  Salvar\n                ")],1)])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "obj8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "okTQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ol2m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p0Qv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_planogoverno_SideAcao_vue__ = __webpack_require__("WgxL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Datepicker__ = __webpack_require__("eOZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SelectFuncionario__ = __webpack_require__("JrGC");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'compromisso-acoes-save',
    inject: ["showConfirm"],
    components: {
        datepicker: __WEBPACK_IMPORTED_MODULE_6__components_common_Datepicker__["a" /* default */],
        SelectFuncionario: __WEBPACK_IMPORTED_MODULE_7__components_SelectFuncionario__["a" /* default */],
        SideAcao: __WEBPACK_IMPORTED_MODULE_4__components_planogoverno_SideAcao_vue__["a" /* default */]
    },
    props: ['id'],
    data: function data() {
        return {
            listas: {
                secretarias: [],
                autarquias: [],
                ordensExistentes: []
            },
            compromisso: {},
            model: {
                compromisso_id: null,
                unidade: '',
                nome_unidade: '',
                sshd_responsavel: '',
                user_sshd: '',
                ordem: null,
                descritivo: '',
                data_estimada_inicio: null,
                data_estimada_conclusao: null,
                status: 'Não Iniciado',
                justificativa_criacao: '',
                assign_pdg_profile: false
            },
            sideConfig: [{
                titulo: 'Confirmar Ordem',
                subtitulo: '',
                subtDetalhe: '',
                largura: 500,
                identidade: 'reordenar',
                abreProximo: false,
                aberto: false,
                data: null
            }],
            dadosParaSalvar: null
        };
    },
    created: function created() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getCompromissoData();

                        case 2:
                            _this.loadUnidades();
                            _this.loadUser();

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    watch: {
        'model.unidade': function modelUnidade(novaSigla, siglaAntiga) {
            if (novaSigla && novaSigla !== siglaAntiga) {
                this.loadNomeUnidade();
            }
        }
    },
    computed: {
        isUpdate: function isUpdate() {
            return this.model.hasOwnProperty('codigo');
        },
        isAdd: function isAdd() {
            return !this.isUpdate;
        },
        urlToSave: function urlToSave() {
            return this.isUpdate ? 'planogoverno/update' : 'planogoverno/add';
        }
    },
    methods: {
        saveSuccess: function saveSuccess(result) {
            this.$router.back();
            this.$toastr.s('A ação foi salva com sucesso.');
        },
        saveFail: function saveFail(result) {
            this.$toastr.e('Houve uma falha ao tentar salvar este item.');
        },
        getOrdensExistentes: function getOrdensExistentes() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, data, status, ordens, maiorOrdem;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.model.compromisso_id) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _context2.prev = 2;
                                _context2.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get('planogoverno/compromisso-acao?compromisso_id=' + _this2.model.compromisso_id + '&all=true');

                            case 5:
                                _ref = _context2.sent;
                                data = _ref.data;
                                status = _ref.status;

                                if (status === 200) {
                                    _this2.listas.ordensExistentes = data.map(function (acao) {
                                        return {
                                            id: acao.id,
                                            ordem: acao.ordem
                                        };
                                    });

                                    if (_this2.listas.ordensExistentes.length > 0) {
                                        ordens = _this2.listas.ordensExistentes.map(function (acao) {
                                            return acao.ordem;
                                        });
                                        maiorOrdem = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(ordens));


                                        _this2.model.ordem = maiorOrdem + 1;
                                    } else {
                                        _this2.model.ordem = 1;
                                    }
                                } else {
                                    _this2.$toastr.e('Erro ao carregar ordens existentes.');
                                }
                                _context2.next = 15;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2['catch'](2);

                                console.error('Erro ao buscar ordens existentes:', _context2.t0);
                                _this2.$toastr.e('Erro ao buscar ordens existentes.');

                            case 15:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 11]]);
            }))();
        },
        validar: function validar() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var isValid, campoComErro, msg, ordemNumerica, ordemExistes, painel;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this3.$validator.validateAll();

                            case 2:
                                isValid = _context3.sent;

                                if (isValid) {
                                    _context3.next = 9;
                                    break;
                                }

                                campoComErro = _this3.$validator.errors.items[0].field;


                                if (campoComErro === 'sshd_responsavel') {
                                    _this3.$refs.SelectFuncionario.$el.querySelector('input').focus();
                                } else {
                                    _this3.$refs[campoComErro].focus();
                                }

                                msg = _this3.$validator.errors.items[0].msg;

                                _this3.$toastr.e(msg);
                                return _context3.abrupt('return');

                            case 9:
                                ordemNumerica = parseInt(_this3.model.ordem, 10);
                                ordemExistes = _this3.listas.ordensExistentes.some(function (o) {
                                    return o.ordem === ordemNumerica && o.id !== _this3.model.id;
                                });


                                if (ordemExistes) {
                                    painel = _this3.sideConfig.find(function (p) {
                                        return p.identidade === 'reordenar';
                                    });

                                    painel.data = { ordem: _this3.model.ordem };
                                    _this3.$refs.side.$emit('abreModal', 'reordenar');
                                } else {
                                    _this3.save();
                                }

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        save: function save() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var _ref2, status;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.$refs.side.$emit('fechaModal', 'reordenar');

                                if (_this4.compromisso.unidade_executora !== _this4.model.unidade) {
                                    _this4.model.data_estimada_inicio = null;
                                    _this4.model.data_estimada_conclusao = null;
                                } else {
                                    _this4.model.justificativa_criacao = '';
                                }

                                if (_this4.validateDates()) {
                                    _context4.next = 4;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 4:

                                if (_this4.model.data_estimada_inicio) {
                                    _this4.model.data_estimada_inicio = _this4.formatDate(new Date(_this4.model.data_estimada_inicio));
                                }
                                if (_this4.model.data_estimada_conclusao) {
                                    _this4.model.data_estimada_conclusao = _this4.formatDate(new Date(_this4.model.data_estimada_conclusao));
                                }

                                _context4.prev = 6;
                                _context4.next = 9;
                                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].post('planogoverno/compromisso-acao', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this4.model));

                            case 9:
                                _ref2 = _context4.sent;
                                status = _ref2.status;


                                if (status === 201) {
                                    _this4.saveSuccess();
                                } else {
                                    _this4.saveFail();
                                }
                                _context4.next = 18;
                                break;

                            case 14:
                                _context4.prev = 14;
                                _context4.t0 = _context4['catch'](6);

                                console.error("Houve uma falha ao tentar salvar a ação: ", _context4.t0.response ? _context4.t0.response.data : _context4.t0.message);
                                _this4.saveFail();

                            case 18:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4, [[6, 14]]);
            }))();
        },
        validateDates: function validateDates() {
            if (this.model.data_estimada_inicio && this.model.data_estimada_conclusao) {
                var inicio = new Date(this.model.data_estimada_inicio);
                var termino = new Date(this.model.data_estimada_conclusao);
                if (termino < inicio) {
                    this.$toastr.e("A data prevista de conclusão não pode ser menor que a data de início");
                    return false;
                }
            }
            return true;
        },
        formatDate: function formatDate(date) {
            var year = date.getFullYear();
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var day = ('0' + date.getDate()).slice(-2);
            var hour = ('0' + date.getHours()).slice(-2);
            var minute = ('0' + date.getMinutes()).slice(-2);
            var second = ('0' + date.getSeconds()).slice(-2);

            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
        },
        getCompromissoData: function getCompromissoData() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var _ref3, data, perfis;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get('planogoverno/compromisso/' + _this5.id);

                            case 2:
                                _ref3 = _context5.sent;
                                data = _ref3.data;

                                _this5.compromisso = data;

                                _this5.model.compromisso_id = _this5.compromisso.id;
                                _this5.model.unidade = _this5.compromisso.unidade_executora;

                                perfis = _this5.$store.state.user.perfis;

                                if (perfis.includes('pdg-gestor') && perfis.includes('pdg-user')) {
                                    _this5.model.sshd_responsavel = _this5.$store.state.user.username;
                                }

                                _context5.next = 11;
                                return _this5.loadNomeUnidade();

                            case 11:
                                _context5.next = 13;
                                return _this5.getOrdensExistentes();

                            case 13:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },
        loadUnidades: function loadUnidades() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var _ref4, secretarias, _ref5, autarquias;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get('listar-secretarias');

                            case 2:
                                _ref4 = _context6.sent;
                                secretarias = _ref4.data.data;
                                _context6.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get('listar-autarquias');

                            case 6:
                                _ref5 = _context6.sent;
                                autarquias = _ref5.data.data;


                                _this6.listas.secretarias = secretarias;
                                _this6.listas.autarquias = autarquias;

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6);
            }))();
        },
        loadUser: function loadUser() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (_this7.$store.state.user) {
                                    _this7.model.user_sshd = _this7.$store.state.user.username;
                                } else {
                                    _this7.$toastr.e('Houve um erro ao tentar carregar os dados do usuário!');
                                }

                            case 1:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7);
            }))();
        },
        loadNomeUnidade: function loadNomeUnidade() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
                var _ref6, data, status;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (_this8.model.unidade) {
                                    _context8.next = 3;
                                    break;
                                }

                                _this8.model.nome_unidade = '';
                                return _context8.abrupt('return');

                            case 3:
                                _context8.prev = 3;
                                _context8.next = 6;
                                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get('unidade-organizacional/siglas', {
                                    params: { siglas: [_this8.model.unidade] }
                                });

                            case 6:
                                _ref6 = _context8.sent;
                                data = _ref6.data;
                                status = _ref6.status;

                                if (!(status !== 200)) {
                                    _context8.next = 12;
                                    break;
                                }

                                _this8.$toastr.e('Não foi possível buscar o nome da unidade.');
                                return _context8.abrupt('return');

                            case 12:

                                _this8.model.nome_unidade = data[0].nome || _this8.model.unidade;
                                _context8.next = 19;
                                break;

                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8['catch'](3);

                                console.error('Falha ao buscar nome da unidade:', _context8.t0);
                                _this8.$toastr.e('Ocorreu um erro ao validar a unidade no servidor.');

                            case 19:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this8, [[3, 15]]);
            }))();
        }
    }
});

/***/ }),

/***/ "p69W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_tags__ = __webpack_require__("h40+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_tags_Save__ = __webpack_require__("3HME");



var tags = [{
  path: 'tags/list',
  component: __WEBPACK_IMPORTED_MODULE_0__views_admin_tags__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}, {
  name: 'admin_tags_save',
  path: 'tags/save/:id?/:name?',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin_tags_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}];

/***/ }),

/***/ "pApq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_CSVImport__ = __webpack_require__("ZquW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { upload: __WEBPACK_IMPORTED_MODULE_1__components_common_CSVImport__["a" /* default */], DataTable: __WEBPACK_IMPORTED_MODULE_2__components_common_NoApiTable__["a" /* default */] },
  inject: ["showConfirm"],
  data: function data() {
    return {
      carregando: false,
      model: {
        header: [],
        body: [],
        data: []
      },
      beneficios: [],
      fields: [{
        name: 'criado_em',
        title: 'Data'
      }, {
        name: 'instituicao',
        title: 'Instituição'
      }, {
        name: 'titulo',
        title: 'Titulo'
      }, {
        name: 'data_inicio',
        title: 'Inicia em'
      }, {
        name: 'hora_inicio',
        title: 'hora'
      }, {
        name: 'data_encerramento',
        title: 'Encerramento'
      }, {
        name: 'acao_online',
        title: 'Online'
      }]
    };
  },

  methods: {
    loadCSV: function loadCSV(payload) {
      var checkFields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getDicionarioHeader());

      for (var index = 0; index < checkFields.length; index++) {
        var element = checkFields[index];
        if (!payload.header.includes(element)) {
          this.$toastr.e(element + ' \xE9 um campo obrigat\xF3rio! Verifique a planilha.');
          return;
        }
      }

      this.model.header = payload.header;
      this.model.body = payload.body;

      this.model.data = this.convertCSVToJSON(this.model.body);
    },
    getDicionarioHeader: function getDicionarioHeader() {
      return {
        "Carimbo de data/hora": "criado_em",
        "Endereço de e-mail": "email",
        "INSTITUIÇÃO RESPONSÁVEL": "instituicao",
        "TÍTULO DA AÇÃO": "titulo",
        "DESCRIÇÃO DA AÇÃO (MÁXIMO 300 CARACTERES)": "descricao",
        "LOCAL DA AÇÃO": "local",
        "DATA DE INÍCIO": "data_inicio",
        "HORA DE INÍCIO": "hora_inicio",
        "DATA DE ENCERRAMENTO": "data_encerramento",
        "AÇÃO SERÁ ONLINE?": "acao_online",
        "LINKS OU INSTRUÇÕES DE COMO PARTICIPAR OU SE INSCREVER NA AÇÃO (SE APLICÁVEL)": "links_instrucao",
        "QUE TIPO DE AÇÃO?": "tipo_acao",
        "ENVIE FOTOS DA AÇÃO": "link_fotos",
        "QUAL(IS) BANDEIRA(S) ODS É(SÃO) O FOCO DE SUA AÇÃO?": "bandeiras",
        "NÚMERO ESPERADO DE PARTICIPANTES (PODE ESTIMAR)": "total_participantes_esperado"
      };
    },
    convertCSVToJSON: function convertCSVToJSON(body) {
      var _this = this;

      return body.map(function (item) {
        return _this.convertItem(item);
      });
    },
    convertItem: function convertItem(item) {
      return {
        "criado_em": new Date(item["Carimbo de data/hora"]).toLocaleString().replace(', ', ' '),
        "email": item["Endereço de e-mail"],
        "instituicao": item["INSTITUIÇÃO RESPONSÁVEL"],
        "titulo": item["TÍTULO DA AÇÃO"],
        "descricao": item["DESCRIÇÃO DA AÇÃO (MÁXIMO 300 CARACTERES)"],
        "local": item["LOCAL DA AÇÃO"],
        "data_inicio": item["DATA DE INÍCIO"],
        "hora_inicio": item["HORA DE INÍCIO"],
        "data_encerramento": item["DATA DE ENCERRAMENTO"],
        "acao_online": item["AÇÃO SERÁ ONLINE?"],
        "links_instrucao": item["LINKS OU INSTRUÇÕES DE COMO PARTICIPAR OU SE INSCREVER NA AÇÃO (SE APLICÁVEL)"],
        "tipo_acao": item["QUE TIPO DE AÇÃO?"],
        "link_fotos": item["ENVIE FOTOS DA AÇÃO"],
        "bandeiras": item["QUAL(IS) BANDEIRA(S) ODS É(SÃO) O FOCO DE SUA AÇÃO?"],
        "total_participantes_esperado": item["NÚMERO ESPERADO DE PARTICIPANTES (PODE ESTIMAR)"]
      };
    },
    salvar: function salvar() {
      var me = this;
      var data = this.model.data;

      var config = {
        title: 'Deseja Salvar?',
        question: true,
        yes: function yes() {
          me.carregando = !me.carregando;
          __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].post('ods/movimentos', { data: data }).then(function () {
            return me.$router.back();
          }).catch(function (error) {
            console.log(error);
          }).then(function () {
            me.carregando = !me.carregando;
          });
        }
      };
      this.showConfirm('Confirmar a inserção dos itens?', config);
    }
  }
});

/***/ }),

/***/ "pEtG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTablePublic__ = __webpack_require__("+Mmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common___ = __webpack_require__("vAZe");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Materiais',
  components: {
    DataTablePublic: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTablePublic__["a" /* default */],
    PublicHeader: __WEBPACK_IMPORTED_MODULE_2__components_common___["a" /* PublicHeader */]
  },
  data: function data() {
    return {
      model: {
        columns: [{
          name: 'referencia',
          sortField: 'referencia',
          title: 'Código',
          dataClass: 'align-left nowrap',
          filterable: true
        }, {
          name: 'medida.nome',
          title: 'Medida',
          dataClass: 'align-left',
          filterable: true
        }, {
          name: 'nome',
          title: 'Material',
          dataClass: 'align-left',
          filterable: true
        }, {
          name: 'descricao',
          title: 'Descrição do Material',
          dataClass: 'align-left',
          filterable: true
        }, {
          name: 'subgrupo.grupo.nome',
          title: 'Grupo',
          dataClass: 'align-left',
          filterable: true
        }, {
          name: 'subgrupo.nome',
          title: 'Subgrupo',
          dataClass: 'align-left',
          filterable: true
        }],
        lista_medidas: [],
        lista_grupos: [],
        lista_subgrupos: [],
        filters: {
          referencia: '',
          pesquisa: '',
          descricao: '',
          medida: '',
          grupo: '',
          subgrupo: ''
        }
      }
    };
  },

  methods: {
    consultar: _.debounce(function () {
      var grupo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (grupo) {
        this.model.filters.subgrupo = null;
        this.subgrupos();
      }

      this.$refs.dt.refresh();
    }, 1000),

    medidas: function medidas() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('materiais/lista-medidas').then(function (response) {
        _this.model.lista_medidas = response.data;
      }).catch(function (response) {
        console.log(response);
      });
    },
    grupos: function grupos() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('materiais/listar-grupos').then(function (response) {
        _this2.model.lista_grupos = response.data;
      }).catch(function (response) {
        console.log(response);
      });
    },
    subgrupos: function subgrupos() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('materiais/listar-subgrupos?grupo=' + (this.model.filters.grupo ? this.model.filters.grupo : '')).then(function (response) {
        _this3.model.lista_subgrupos = response.data;
      }).catch(function (response) {
        console.log(response);
      });
    },
    exportar: function exportar() {
      return this.$root.$data.apiUrl + 'materiais/lista-material?exportar=true';
    }
  },
  mounted: function mounted() {
    this.medidas();
    this.grupos();
    this.subgrupos();
  }
});

/***/ }),

/***/ "pEvt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/16.c760d27.jpg";

/***/ }),

/***/ "pFwp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardsFiltro_vue__ = __webpack_require__("3VhN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_283332a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardsFiltro_vue__ = __webpack_require__("iQBf");
function injectStyle (ssrContext) {
  __webpack_require__("obj8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-283332a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardsFiltro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_283332a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardsFiltro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pK0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mp-grupo-save',
  data: function data() {
    return {
      label: 'Adicionar',
      apiUrl: 'material/grupo',
      model: {
        nome: ''
      },
      carregando: false
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  methods: {
    toogleLoading: function toogleLoading() {
      this.carregando = !this.carregando;
    },
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Este item foi salvo com sucesso.');
      this.$router.push({ name: 'user_material_grupo' });
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
      console.log(result.response);
      this.toogleLoading();
    },
    save: function save() {
      var _this = this;

      this.toogleLoading();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.$refs[_this.$validator.errors.items[0].field].focus();
          _this.$toastr.e(_this.$validator.errors.items[0].msg);
          return;
        }

        __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].post(_this.apiUrl, _this.model).then(_this.saveSuccess).catch(_this.saveFail);
      });
    }
  }
});

/***/ }),

/***/ "pLiO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pN11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_js__ = __webpack_require__("bEN/");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14e1cf25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("WWR1");
function injectStyle (ssrContext) {
  __webpack_require__("vwPJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_dashboard_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14e1cf25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "pQJU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Grupos")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Listagem de Grupos","api-url":_vm.apiUrl,"report-title":"Grupos","fields":_vm.fields,"initial-page":_vm.pagina,"appendParams":_vm.filtros,"pageCollection":'grupos'},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font",attrs:{"for":"nome_filter"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nome),expression:"nome"}],staticClass:"form-control",attrs:{"type":"text","name":"nome_filter"},domProps:{"value":(_vm.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'user_material_grupo_save' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pSzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_planogoverno_SidePlanoGoverno_vue__ = __webpack_require__("3p2T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__("OOvn");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { list: __WEBPACK_IMPORTED_MODULE_3__components_common_DataTable__["a" /* default */], SidePlanoGoverno: __WEBPACK_IMPORTED_MODULE_4__components_planogoverno_SidePlanoGoverno_vue__["a" /* default */] },
    data: function data() {
        return {
            fields: [{
                name: 'periodo',
                title: 'Período',
                filterable: true,
                titleClass: 'text-center text-nowrap',
                dataClass: 'text-center text-nowrap'
            }, {
                name: 'descritivo',
                title: 'Compromisso',
                filterable: true
            }, {
                name: 'status',
                title: 'Status',
                filterable: true,
                titleClass: 'text-center text-nowrap',
                dataClass: 'text-center text-nowrap'
            }, {
                name: '__slot:actions',
                title: 'Ações',
                titleClass: 'text-center col-md-3',
                dataClass: 'text-center'
            }],
            filtros: {
                periodo: '',
                status: ''
            },
            periodos: ['2021-2024', '2025-2028'],
            status: ['Não Iniciado', 'Em andamento', 'Concluído', 'Cancelado'],
            sideConfig: [{
                titulo: 'Homologar',
                subtitulo: '',
                subtDetalhe: '',
                largura: 900,
                identidade: 'homologar',
                abreProximo: false,
                aberto: false,
                data: null
            }, {
                titulo: 'Informações',
                subtitulo: '',
                subtDetalhe: '',
                largura: 900,
                identidade: 'info',
                abreProximo: false,
                aberto: false,
                data: null
            }, {
                titulo: 'Cancelar',
                subtitulo: '',
                subtDetalhe: '',
                largura: 500,
                identidade: 'pedido-cancelamento',
                abreProximo: false,
                aberto: false,
                data: null
            }]
        };
    },

    methods: {
        info: function info(compromisso) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var painel;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                painel = _this.sideConfig.find(function (p) {
                                    return p.identidade === 'info';
                                });


                                painel.subtitulo = compromisso.descritivo;
                                painel.data = compromisso;
                                _this.$refs.side.$emit('abreModal', painel.identidade);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        homologar: function homologar(compromisso) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var painel;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                painel = _this2.sideConfig.find(function (p) {
                                    return p.identidade === 'homologar';
                                });

                                painel.subtitulo = compromisso.descritivo;
                                painel.data = compromisso;

                                _this2.$refs.side.$emit('abreModal', painel.identidade);

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        cancelar: function cancelar(compromisso) {
            var painel = this.sideConfig.find(function (p) {
                return p.identidade === 'pedido-cancelamento';
            });
            painel.subtitulo = compromisso.descritivo;
            painel.data = compromisso;

            this.$refs.side.$emit('abreModal', painel.identidade);
        },
        homologarCompromisso: function homologarCompromisso(compromissoId) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _toISOString$split, _toISOString$split2, now, _ref, status;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _toISOString$split = new Date().toISOString().split('T'), _toISOString$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_toISOString$split, 1), now = _toISOString$split2[0];
                                _context3.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].put('planogoverno/compromisso-profile/' + compromissoId, { status: 'Concluído', data_conclusao: now });

                            case 3:
                                _ref = _context3.sent;
                                status = _ref.status;

                                if (!(status != 200)) {
                                    _context3.next = 7;
                                    break;
                                }

                                return _context3.abrupt('return', _this3.$toastr.e('Erro ao homologar o compromisso.'));

                            case 7:

                                _this3.$refs.vuetable.refresh();
                                _this3.$toastr.s('Compromisso homologado com sucesso!');
                                _this3.$refs.side.$emit('fechaModal', _this3.sideConfig[0].identidade);

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        cancelarCompromisso: function cancelarCompromisso(_ref2) {
            var _this4 = this;

            var compromisso = _ref2.compromisso,
                justificativa = _ref2.justificativa;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var qtdCancelamento, _ref3, status;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(!justificativa || justificativa.trim() === '')) {
                                    _context4.next = 2;
                                    break;
                                }

                                return _context4.abrupt('return', _this4.$toastr.e('A justificativa é obrigatória para solicitar o cancelamento.'));

                            case 2:
                                qtdCancelamento = compromisso.qtd_cancelamento + 1;
                                _context4.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].put('planogoverno/compromisso-profile/' + compromisso.id, {
                                    justificativa_cancelamento: justificativa,
                                    qtd_cancelamento: qtdCancelamento
                                });

                            case 5:
                                _ref3 = _context4.sent;
                                status = _ref3.status;

                                if (!(status != 200)) {
                                    _context4.next = 9;
                                    break;
                                }

                                return _context4.abrupt('return', _this4.$toastr.e('Erro ao solicitar o cancelamento do compromisso.'));

                            case 9:

                                _this4.$refs.vuetable.refresh();
                                _this4.$toastr.s('Solicitação de cancelamento enviada com sucesso!');
                                _this4.$refs.side.$emit('fechaModal', _this4.sideConfig[2].identidade);

                            case 12:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        cancelarAcoes: function cancelarAcoes(compromisso) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
                var acoes;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                acoes = compromisso.acoes;


                                if (acoes && Array.isArray(acoes)) {
                                    acoes.forEach(function () {
                                        var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(acao) {
                                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                                                while (1) {
                                                    switch (_context5.prev = _context5.next) {
                                                        case 0:
                                                            if (!(acao.status !== 'Cancelada' || acao.status !== 'Rejeitada')) {
                                                                _context5.next = 9;
                                                                break;
                                                            }

                                                            _context5.prev = 1;
                                                            _context5.next = 4;
                                                            return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].put('planogoverno/compromisso-acao/' + acao.id, {
                                                                justificativa_rejeicao: 'Compromisso cancelado',
                                                                status: 'Cancelada'
                                                            });

                                                        case 4:
                                                            _context5.next = 9;
                                                            break;

                                                        case 6:
                                                            _context5.prev = 6;
                                                            _context5.t0 = _context5['catch'](1);

                                                            console.error('Erro ao cancelar a a\xE7\xE3o ' + acao.id + ': ', _context5.t0);

                                                        case 9:
                                                        case 'end':
                                                            return _context5.stop();
                                                    }
                                                }
                                            }, _callee5, _this5, [[1, 6]]);
                                        }));

                                        return function (_x) {
                                            return _ref4.apply(this, arguments);
                                        };
                                    }());
                                }

                            case 2:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this5);
            }))();
        },
        fecharSideModal: function fecharSideModal(identidade) {
            this.$refs.side.$emit('fechaModal', identidade);
        },
        resetFiltros: function resetFiltros() {
            this.filtros.periodo = '';
            this.filtros.status = '';
        }
    }
});

/***/ }),

/***/ "pTTs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListaFilaAgendados_vue__ = __webpack_require__("bCKG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c933be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListaFilaAgendados_vue__ = __webpack_require__("uOq9");
function injectStyle (ssrContext) {
  __webpack_require__("w/Lh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58c933be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListaFilaAgendados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58c933be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListaFilaAgendados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pZly":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("pK0X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b9f490_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("oX5R");
function injectStyle (ssrContext) {
  __webpack_require__("GXEe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34b9f490"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34b9f490_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pdY+":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "pgzv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "poTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h2',{staticClass:"page-header"},[_vm._v("Edital")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Lista de editais","api-url":"edital/listar","report-title":"Editais","fields":_vm.fields,"initial-page":_vm.pagina,"pageCollection":'concursosEdital',"appendParams":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-success",attrs:{"title":"Editar dados do Edital","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('router-link',{staticClass:"btn btn-success",attrs:{"title":"Importar Habilitados","to":{
                name: 'habilitados',
                params: { edital: props.rowData }
              }}},[_c('font-awesome-icon',{attrs:{"icon":'users'}})],1),_vm._v(" "),_c('router-link',{staticClass:"btn btn-success",attrs:{"title":"Importar Pré-Habilitados","to":{
                name: 'pre_habilitados',
                params: { edital: props.rowData }
              }}},[_c('font-awesome-icon',{attrs:{"icon":'upload'}})],1),_vm._v(" "),_c('router-link',{staticClass:"btn btn-success",attrs:{"title":"Nomear Candidatos","to":{
                name: 'nomeados',
                params: { edital: props.rowData }
              }}},[_c('font-awesome-icon',{attrs:{"icon":'list'}})],1),_vm._v(" "),_c('a',{staticClass:"btn btn-success",attrs:{"title":"Exportar edital e seus arquivos anexados","target":"_blank","href":_vm.exportarEditalComArquivosAnexadosCSV(props.rowData)}},[_c('font-awesome-icon',{attrs:{"icon":'file-csv'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir edital"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font"},[_vm._v("Nº Edital")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numero),expression:"numero"}],staticClass:"form-control",attrs:{"type":"text","name":"numero_filter"},domProps:{"value":(_vm.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"custom-font"},[_vm._v("Nº Processo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.processo_numero),expression:"processo_numero"}],staticClass:"form-control",attrs:{"type":"text","name":"processo_numero_filter"},domProps:{"value":(_vm.processo_numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.processo_numero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{staticClass:"custom-font"},[_vm._v("Publicado")]),_vm._v(" "),_c('div',{staticClass:"custom-select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.publicado),expression:"publicado"}],staticClass:"form-control select-selected",attrs:{"name":"publicado_filter"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.publicado=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.consultar]}},[_c('option',{attrs:{"value":""}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Sim")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                Filtrar\n              ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                Limpar Filtros\n              ")],1)])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'salvar_edital' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "psVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("qn9Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef92dd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("tbtc");
function injectStyle (ssrContext) {
  __webpack_require__("EnF0")
  __webpack_require__("EeL1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ef92dd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef92dd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pt+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eleicao-conselho"},[_c('div',{staticClass:"row"},[_c('public-header',{staticClass:"public-header",attrs:{"title":("Seção " + _vm.secao)}},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.dadosSecao.unidade))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.dadosSecao.endereco))]),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n          Esta seção possui\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(Number(_vm.dadosSecao.aptos).toLocaleString()))]),_vm._v("\n          eleitores aptos para votação, dos quais\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(Number(_vm.dadosSecao.compareceram).toLocaleString()))]),_vm._v("\n          compareceram, totalizando\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s((
              _vm.dadosSecao.total_nominais +
              _vm.dadosSecao.total_brancos +
              _vm.dadosSecao.total_nulos
            ).toLocaleString()))]),_vm._v("\n          votos.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Abaixo você pode acompanhar como foi a votação por candidato nesta\n          seção.\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_c('ListaCandidatosGeral',{attrs:{"title":'Resultado nesta Seção',"listaCandidatos":_vm.candidatosSecao,"votosNominaisTotais":Number(_vm.dadosSecao.total_nominais)}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "puUd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pueA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    time: {
      type: Object
    },
    click: {
      type: Function,
      required: true
    }
  },
  computed: {
    entradaIsEmpty: function entradaIsEmpty() {
      return this.time.entrada === '';
    },
    saidaIsEmpty: function saidaIsEmpty() {
      return this.time.saida === '';
    }
  }
});

/***/ }),

/***/ "pzbd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-scale-container"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de escala")]),_vm._v(" "),_c('Select',{attrs:{"options":_vm.scaleList,"disabled":_vm.disabled},model:{value:(_vm.scale),callback:function ($$v) {_vm.scale=$$v},expression:"scale"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q0Ye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("gojI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117b3667_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("xDod");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_117b3667_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q8VL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("/6fP");


var _mutations;



var INITIAL_STATE = [];
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1____["b" /* LOAD_EMENDAS */], function (state, payload) {
  state.emendas = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1____["c" /* SET_YEAR */], function (state, payload) {
  state.ano = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1____["d" /* CLEAR_EMENDAS */], function (state) {
  state.emendas = INITIAL_STATE;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1____["e" /* TOGGLE_LOADING */], function (state) {
  state.loading = !state.loading;
}), _mutations);

/***/ }),

/***/ "q9aI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("LZ76");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d82a9c94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("ISmE");
function injectStyle (ssrContext) {
  __webpack_require__("PeW4")
  __webpack_require__("6iLB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d82a9c94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d82a9c94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qI0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListProcessosPagamento_vue__ = __webpack_require__("ld51");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b868d70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListProcessosPagamento_vue__ = __webpack_require__("a3yM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListProcessosPagamento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b868d70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListProcessosPagamento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qNDT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditarResponsaveis_vue__ = __webpack_require__("HiLe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d2369e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditarResponsaveis_vue__ = __webpack_require__("cTvv");
function injectStyle (ssrContext) {
  __webpack_require__("Wx5S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d2369e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditarResponsaveis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d2369e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditarResponsaveis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qVZE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__ = __webpack_require__("DbjU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a26044f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__ = __webpack_require__("lU9q");
function injectStyle (ssrContext) {
  __webpack_require__("yGGR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a26044f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a26044f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qWtj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_NoApiTable__ = __webpack_require__("Vp40");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Relatório de status de escalas',
      params: {
        referencia: null,
        status: 'Todos'
      },
      referencias: [],
      status: [],
      scales: [],
      loadingScales: false,
      datatable: {
        columnID: 'id',
        columns: [{
          name: 'uor_label',
          title: 'Unidade',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: 'status',
          title: 'Status',
          dataClass: 'align-middle',
          filterable: false
        }, {
          name: 'data_publicacao',
          title: 'Data de Publicação',
          titleClass: 'text-center',
          dataClass: 'text-center',
          filterable: false
        }]
      }
    };
  },

  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_1__components_common_NoApiTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.loadReferencias();
    this.loadStatus();

    this.setReferencia();
  },
  mounted: function mounted() {
    this.loadScales();
  },

  methods: {
    loadReferencias: function loadReferencias() {
      var currentYear = new Date().getFullYear();
      for (var index = 0; index < 12; index++) {
        var date = new Date(currentYear, index, 1, 1);
        var month = date.toLocaleDateString('pt-BR', { month: '2-digit' });

        var label = date.toLocaleDateString('pt-BR', {
          month: 'long',
          year: 'numeric'
        });
        var value = '' + date.getFullYear() + month;

        this.referencias.push({
          label: label,
          value: value
        });
      }
    },
    loadStatus: function loadStatus() {
      var _this = this;

      var labels = ['Todos', 'Sem registro', 'Pendente', 'Em análise', 'Publicado'];
      labels.forEach(function (item) {
        return _this.status.push({ label: item, value: item });
      });
    },
    setReferencia: function setReferencia() {
      var currentDate = new Date();
      var date = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1, 1);
      var month = date.toLocaleDateString('pt-BR', {
        month: '2-digit'
      });
      this.params.referencia = '' + date.getFullYear() + month;
    },
    loadScales: function loadScales() {
      var _this2 = this;

      if (this.params.referencia == null) this.setReferencia();
      if (this.params.status == null) this.params.status = 'Todos';

      var _params = this.params,
          referencia = _params.referencia,
          status = _params.status;


      this.loadingScales = true;

      var url = 'escala/listar-status?referencia=' + referencia + '&status=' + status;

      __WEBPACK_IMPORTED_MODULE_0__request__["a" /* request */].get(url).then(function (response) {
        return _this2.scales = response.data;
      }).catch(function (error) {
        return console.log(error);
      }).then(function () {
        return _this2.loadingScales = false;
      });
    }
  }
});

/***/ }),

/***/ "qXhe":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAABSCAMAAAAhFXfZAAAC91BMVEVMaXEzeak2f7I4g7g3g7cua5gzeKg8hJo3grY4g7c3grU0gLI2frE0daAubJc2gbQwd6QzeKk2gLMtd5sxdKIua5g1frA2f7IydaM0e6w2fq41fK01eqo3grgubJgta5cxdKI1f7AydaQydaMxc6EubJgvbJkwcZ4ubZkwcJwubZgubJcydqUydKIxapgubJctbJcubZcubJcvbJYubJcvbZkubJctbJctbZcubJg2f7AubJcrbZcubJcubJcua5g3grY0fq8ubJcubJdEkdEwhsw6i88vhswuhcsuhMtBjMgthMsrg8srgss6is8qgcs8i9A9iMYtg8spgcoogMo7hcMngMonf8olfso4gr8kfck5iM8jfMk4iM8he8k1fro7itAgesk2hs8eecgzfLcofssdeMg0hc4cd8g2hcsxeLQbdsgZdcgxeLImfcszhM0vda4xgckzhM4xg84wf8Yxgs4udKsvfcQucqhUndROmdM1fK0wcZ8vb5w0eqpQm9MzeKhXoNVcpdYydKNWn9VZotVKltJFjsIwcJ1Rms9OlslLmtH///8+kc9epdYzd6dbo9VHkMM2f7FHmNBClM8ydqVcpNY9hro3gLM9hLczealQmcw3fa46f7A8gLMxc6I3eagyc6FIldJMl9JSnNRSntNNl9JPnNJFi75UnM9ZodVKksg8kM45jc09e6ZHltFBk883gbRBh7pDk9EwcaBzn784g7dKkcY2i81Om9M7j85Llc81is09g7Q4grY/j9A0eqxKmdFFltBEjcXf6fFImdBCiLxJl9FGlNFBi78yiMxVndEvbpo6js74+vx+psPP3+o/ks5HkcpGmNCjwdZCkNDM3ehYoNJEls+lxNkxh8xHks0+jdC1zd5Lg6r+/v/H2ufz9/o3jM3t8/edvdM/k89Th61OiLBSjbZklbaTt9BfptdjmL1AicBHj8hGk9FAgK1dkLNTjLRekrdClc/k7fM0icy0y9tgp9c4jc2NtM9Dlc8zicxeXZn3AAAAQ3RSTlMAHDdTb4yPA+LtnEQmC4L2EmHqB7XA0d0sr478x4/Yd5i1zOfyPkf1sLVq4Nh3FvjxopQ2/STNuFzUwFIwxKaejILpIBEV9wAABhVJREFUeF6s1NdyFEcYBeBeoQIhRAkLlRDGrhIgY3BJL8CVeKzuyXFzzjkn5ZxzzuScg3PO8cKzu70JkO0LfxdTU//pM9vTu7Xgf6KqOVTb9X7toRrVEfBf1HTVjZccrT/2by1VV928Yty9ZbVuucdz90frG8DBjl9pVApbOstvmMuvVgaNXSfAAd6pGxpy6yxf5ph43pS/4f3uoaGm2rdu72S9xzOvMymkZFq/ptDrk90mhW7e4zl7HLzhxGWPR20xmSxJ/VqldG5m9XhaVOA1DadsNh3Pu5L2N6QtPO/32JpqQBVVk20oy/Pi2s23WEvyfHbe1thadVQttvm7Llf65gGmXK67XtupyoM7HQhmXdLS8oGWJNeOJ3C5fG5XCEJnkez3/oFdsvgJ4l2ANZwhrJKk/7OSXa+3Vw2WJMlKnGkobouYk6T0TyX30klOUnTD9HJ5qpckL3EW/w4XF3Xd0FGywXUrstrclVsqz5Pd/sXFYyDnPdrLcQODmGOK47IZb4CmibmMn+MYRzFZ5jg33ZL/EJrWcszHmANy3ARBK/IXtciJy8VsitPSdE3uuHxzougojcUdr8/32atnz/ev3f/K5wtpxUTpcaI45zusVDpYtZi+jg0oU9b3x74h7+n9ABvYEZeKaVq0sh0AtLKsFtqNBdeT0MrSzwwlq9+x6xAO4tgOtSzbCjrNQQiNvQUbUEubvzBUeGw26yDCsRHCoLkTHDa7IdOLIThs/gHvChszh2CimE8peRs47cxANI0lYNB5y1DljpOF0IhzBDPOZnDOqYYbeGKECbPzWnXludPphw5c2YBq5zlwXphIbO4VDCZ0gnPfUO1TwZoYwAs2ExPCedAu9DAjfQUjzITQb3jNj0KG2Sgt6BHaQUdYzWz+XmBktOHwanXjaSTcwwziBcuMOtwBmqPrTOxFQR/DRKKPqyur0aiW6cULYsx6tBm0jXpR/AUWR6HRq9WVW6MRhIq5jLyjbaCTDCijyYJNpCajdyobP/eTw0iexBAKkJ3gA5KcQb2zBXsIBckn+xVv8jkZSaEFHE+jFEleAEfayRU0MouNoBmB/L50Ai/HSLIHxcrpCvnhSQAuakKp2C/YbCylJjXRVy/z3+Kv/RrNcCo+WUzlVEhzKffnTQnxeN9fWF88fiNCUdSTsaufaChKWInHeysygfpIqagoakW+vV20J8uyl6TyNKEZWV4oRSPyCkWpgOLSbkCObT8o2r6tlG58HQquf6O0v50tB7JM7F4EORd2dx/K0w/KHsVkLPaoYrwgP/y7krr3SSMA4zj+OBgmjYkxcdIJQyQRKgg2viX9Hddi9UBb29LrKR7CVVEEEXWojUkXNyfTNDE14W9gbHJNuhjDettN3ZvbOvdOqCD3Jp/9l+/wJE+9PkYGjx/fqkys3S2rMozM/o2106rfMUINo6hVqz+eu/hd1c4xTg0TAfy5kV+4UG6+IthHTU9woWmxuKNbTfuCSfovBCxq7EtHqvYL4Sm6F8GVxsSXHMQ07TOi1DKtZxjWaaIyi4CXWjxPccUw8WVbMYY5wxC1mzEyXMJWkllpRloi+Kkoq69sxBTlElF6aAxYUbjXNlhlDZilDnM4U5SlN5biRsRHnbx3mbeWjEh4mEyiuJDl5XcWVmX5GvNkFgLWZM5qwsop4/AWfLhU1cR7k1VVvcYCWRkOI6Xy5gmnphCYIkvzuNYzHzosq2oNk2RtSs8khfUOfHIDgR6ysYBaMpl4uEgk2U/oJTs9AaTSwma7dT69geAE2ZpEjUsn2ieJNHeKfrI3EcAGJ2ZaNgVuC8EBctCLc57P5u5led6IOBkIYkuQMrmmjChs4VkfOerHqSBkPzZlhe06RslZ3zMjk2sscqKwY0RcjKK+LWbzd7KiHhkncs/siFJ+V5eXxD34B8nVuJEpGJNmxN2gH3vSvp7J70tF+D1Ej8qUJD1TkErAND2GZwTFg/LubvmgiBG3SOvdlsqFQrkEzJCL1rstlnVFROixZoDDSuXQFHESwVGlcuQcMb/b42NgjLowh5MTDFE3vNB5qStRIErdCQEh6pLPR92anSUb/wAIhldAaDMpGgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "qY+M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoPerfilUnidade_vue__ = __webpack_require__("7IRF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d97dd52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoPerfilUnidade_vue__ = __webpack_require__("0YbL");
function injectStyle (ssrContext) {
  __webpack_require__("QZPo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d97dd52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoPerfilUnidade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d97dd52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoPerfilUnidade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qhpI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PorEspecialidade_vue__ = __webpack_require__("lVqp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f529a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PorEspecialidade_vue__ = __webpack_require__("iw4G");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PorEspecialidade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f529a6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PorEspecialidade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qn9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      item: {},
      carregando: false
    };
  },
  created: function created() {
    this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.params.item);
  },

  methods: {
    salvar: function salvar() {
      this.carregando = !this.carregando;
      var me = this;
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          me.$refs[me.$validator.errors.items[0].field].focus();
          me.$toastr.e(me.$validator.errors.items[0].msg);
          me.carregando = !me.carregando;
          return;
        }

        __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('/assistencia/beneficios/salvar', me.item).then(function (response) {
          me.$toastr.s(response.data.msg);
          me.$router.push('/admin/assistencia/beneficios');
        }).catch(function (error) {
          if (error.response.status === 401) {
            return;
          }

          me.$toastr.e('Houve um erro ao tentar salvar o benefício. Atualize a página e tente novamente.');
        }).then(function () {
          me.carregando = !me.carregando;
        });
      });
    }
  }
});

/***/ }),

/***/ "qyzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesPorArea_vue__ = __webpack_require__("PoxJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29daaab0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesPorArea_vue__ = __webpack_require__("NpjO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalhesPorArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29daaab0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalhesPorArea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rU1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__("3WfR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");



var actions = {
  getEmendasAno: function getEmendasAno(store, payload) {
    var ano = payload.ano;


    store.commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_YEAR */], ano);
    store.commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* TOGGLE_LOADING */]);

    __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('emendas/emendas-ano', {
      params: { ano: ano || new Date().getFullYear() }
    }).then(function (request) {
      var data = request.data;

      store.commit(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* LOAD_EMENDAS */], data);
    }).catch(function (error) {
      console.log(error.response);
    }).finally(function () {
      store.commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* TOGGLE_LOADING */]);
    });
  }
};

/***/ }),

/***/ "rc/t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rjNL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_NoApiTable__ = __webpack_require__("Vp40");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Relatório de acesso',
      termoPesquisa: '',
      acessos: [],
      loadingScales: false,
      fields: [{
        name: 'unidade',
        title: 'Unidade',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Usuários com acesso',
        titleClass: 'text-left',
        filterable: true
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_4__components_common_NoApiTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    this.loadAcessos();
  },

  methods: {
    consultar: function consultar() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var acessos, filtersAcesso;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchAcessos();

              case 2:
                acessos = _context.sent;
                filtersAcesso = acessos.filter(function (_ref) {
                  var unidade = _ref.unidade,
                      usuarios = _ref.usuarios;

                  var unidadeMatch = unidade.toLowerCase().indexOf(_this.termoPesquisa.toLowerCase()) > -1;
                  var usuariosMatch = usuarios.filter(function (_ref2) {
                    var nome = _ref2.nome;

                    return nome.toLowerCase().indexOf(_this.termoPesquisa.toLowerCase()) > -1;
                  }).length > 0;
                  return unidadeMatch || usuariosMatch;
                });

                _this.acessos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(filtersAcesso));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadAcessos: function loadAcessos() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var acessos;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.fetchAcessos();

              case 2:
                acessos = _context2.sent;

                _this2.setAcessos(acessos);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchAcessos: function fetchAcessos() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref3, acessos;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loadingScales = true;

                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('escala/listar-unidades-acesso-usuario');

              case 3:
                _ref3 = _context3.sent;
                acessos = _ref3.data;


                _this3.loadingScales = false;

                return _context3.abrupt('return', acessos);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    setAcessos: function setAcessos(acessos) {
      this.acessos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(acessos));
    }
  }
});

/***/ }),

/***/ "rnkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstitucionalNomeValor_vue__ = __webpack_require__("Zd6g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48fbaa42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstitucionalNomeValor_vue__ = __webpack_require__("+8Yl");
function injectStyle (ssrContext) {
  __webpack_require__("oN5s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48fbaa42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstitucionalNomeValor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48fbaa42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstitucionalNomeValor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rr4i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s4g1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common___ = __webpack_require__("vAZe");


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'escalas',
  created: function created() {
    this.isCreating = true;
    this.loadMonths();
    this.setCurrentMonth();
    this.setFirstWeekOfMonth();
    this.generateWeek();
    this.loadUors();
  },
  mounted: function mounted() {
    scroll(0, 0);
  },
  data: function data() {
    return {
      uors: [],
      uor: '',
      months: [],
      month: 0,
      week: [],
      weekStart: null,
      weekEnd: null,
      search: '',
      scale: [],
      isCreating: false,
      loadingScale: false,
      observacao: 'Não há observação para está escala.'
    };
  },

  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_1__components_common___["a" /* PublicHeader */]
  },
  watch: {
    uor: function uor(value) {
      if (value) {
        this.loadScale();
        this.loadObservacao();
      }
    }
  },
  computed: {
    queryParams: function queryParams() {
      var queryParams = ['referencia=' + this.months[this.month].referencia, 'semana=' + this.week.map(function (_ref) {
        var data = _ref.data;
        return data;
      }).join(',')];

      if (this.search) {
        queryParams.push('filter=' + search);
        this.uor = '';
      }

      if (this.uor) queryParams.push('uor_sigla=' + this.uor);

      return queryParams;
    }
  },
  methods: {
    loadScale: function loadScale() {
      var _this = this;

      if (this.uor === "") return;

      var queryParams = this.queryParams;


      this.loadingScale = true;

      __WEBPACK_IMPORTED_MODULE_0__request__["b" /* default */].get('escalas?' + queryParams.join('&'), function (response) {
        _this.scale = response;
        _this.loadingScale = false;
      }, function (error) {
        _this.loadingScale = false;
        console.log(error);
      });
    },
    loadObservacao: function loadObservacao() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.observacao = "Carregando observação...";

        __WEBPACK_IMPORTED_MODULE_0__request__["b" /* default */].get('escala/observacao-sigla-referencia?uor_sigla=' + _this2.uor + '&referencia=' + _this2.months[_this2.month].referencia, function (response) {
          _this2.observacao = response;
        }, function (error) {
          _this2.observacao = "Houve um erro ao tentar carregar a observação desta escala!";
          console.log(error);
        });
      });
    },
    loadUors: function loadUors() {
      var me = this;
      var referencia = this.months[this.month].referencia;

      __WEBPACK_IMPORTED_MODULE_0__request__["b" /* default */].get('listar-unidades-associadas?referencia=' + referencia, function (response) {
        return me.uors = response;
      }, function (error) {
        return console.log(error);
      });
    },
    loadMonths: function loadMonths() {
      var date = new Date();
      for (var index = 0; index < 12; index++) {
        date.setMonth(index);
        this.months.push({
          label: date.toLocaleDateString('pt-BR', {
            month: 'long',
            year: 'numeric'
          }),
          value: index,
          referencia: date.toISOString().split('T')[0].replace('-', '').substring(0, 6)
        });
      }
    },
    setCurrentMonth: function setCurrentMonth() {
      var date = new Date();
      this.month = date.getMonth();
    },
    setFirstWeekOfMonth: function setFirstWeekOfMonth() {
      var date = new Date();
      date.setDate(1);
      date.setMonth(this.month);
      date.setDate(date.getDate() - date.getDay());

      this.weekStart = new Date(date.getTime());

      date.setDate(date.getDate() + 6);

      this.weekEnd = new Date(date.getTime());
    },
    generateWeek: function generateWeek() {
      var seekDate = new Date(this.weekStart.getTime());
      this.week = [];
      do {
        this.week.push({
          weekday: seekDate.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', ''),
          monthday: seekDate.getDate(),
          dayIndex: seekDate.toLocaleDateString('pt-BR', { day: '2-digit' }),
          data: seekDate.toLocaleDateString().substring(0, 5)
        });
        seekDate.setDate(seekDate.getDate() + 1);
      } while (seekDate.getTime() <= this.weekEnd.getTime());
    },
    dateFormatDDMM: function dateFormatDDMM(date) {
      return ' ' + date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit'
      }) + ' ';
    },
    handleSelectedMonth: function handleSelectedMonth() {
      this.setFirstWeekOfMonth();
      this.generateWeek();
      this.loadUors();
    },
    nextWeek: function nextWeek() {
      this.navWeek(7);
    },
    prevWeek: function prevWeek() {
      this.navWeek(-7);
    },
    navWeek: function navWeek(days) {
      this.weekStart.setDate(this.weekStart.getDate() + days);
      this.weekEnd.setDate(this.weekEnd.getDate() + days);
      this.month = this.weekStart.getMonth();

      this.generateWeek();
      this.loadScale();
    }
  }
});

/***/ }),

/***/ "s6u6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputCartaoSUS_vue__ = __webpack_require__("tSov");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4662d5a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputCartaoSUS_vue__ = __webpack_require__("3KOu");
function injectStyle (ssrContext) {
  __webpack_require__("+6jN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4662d5a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputCartaoSUS_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4662d5a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputCartaoSUS_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sELz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalheCandidato_vue__ = __webpack_require__("XNWN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a22604_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalheCandidato_vue__ = __webpack_require__("vcwe");
function injectStyle (ssrContext) {
  __webpack_require__("iGhK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00a22604"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalheCandidato_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00a22604_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalheCandidato_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sLGZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'processos-pagamento-save',
  data: function data() {
    return {
      label: 'Adicionar',
      emendas: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      model: {
        numero_pagamento: '',
        valor: '',
        emenda_id: ''
      },
      carregando: false
    };
  },

  components: {
    TheMask: __WEBPACK_IMPORTED_MODULE_2_vue_the_mask__["TheMask"]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    var codigo_emenda = this.$route.params.codigo_emenda;

    if (id) {
      this.label = 'Editar';
      this.loadModel(id);
    } else if (codigo_emenda) {
      this.loadEmendas();
      this.model.emenda_id = codigo_emenda;
    } else {
      this.loadEmendas();
    }
  },

  methods: {
    fetchEmendas: function fetchEmendas() {
      return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('emenda');
    },
    loadEmendas: function loadEmendas() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var respEmenda;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetchEmendas();

              case 2:
                respEmenda = _context.sent;

                _this.emendas = respEmenda.data.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadModel: function loadModel(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, responseEmendas;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('processospagamento/' + id);

              case 2:
                response = _context2.sent;
                _context2.next = 5;
                return _this2.fetchEmendas();

              case 5:
                responseEmendas = _context2.sent;


                _this2.emendas = responseEmendas.data.data;

                _this2.model = response.data;

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    toogleLoading: function toogleLoading() {
      this.carregando = !this.carregando;
    },
    saveSuccess: function saveSuccess(result) {
      this.$toastr.s('Processo de pagamento salvo com sucesso.');
      this.$router.back();
    },
    saveFail: function saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.');
      this.toogleLoading();
    },
    save: function save() {
      var _this3 = this;

      this.toogleLoading();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this3.toogleLoading();
          _this3.$refs[_this3.$validator.errors.items[0].field];
          _this3.$toastr.e(_this3.$validator.errors.items[0].msg);
          return;
        }
        if (_this3.model.codigo) {
          __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].put('processospagamento/' + _this3.model.codigo, _this3.model).then(_this3.saveSuccess).catch(_this3.saveFail);
        } else {
          __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].post('processospagamento', _this3.model).then(_this3.saveSuccess).catch(_this3.saveFail);
        }
      });
    }
  }
});

/***/ }),

/***/ "sSSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detalhes-por-vereador"},[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":_vm.vereador}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n          Aqui você encontra as emendas parlamentares do(a) vereador(a)\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.vereador}}),_vm._v(".\n        ")],1),_vm._v(" "),_c('p',[_vm._v("\n          No ano de "),_c('SelectAnoEmendas'),_vm._v(", foram repassados\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.valorTotalEmendas),"isLoading":_vm.loading}}),_vm._v("\n          em emendas parlamentares, dos quais\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.valorUtilizadoEmendas),"isLoading":_vm.loading}}),_vm._v("\n          já foram utilizados, restando um saldo de\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.saldoTotalEmendas),"isLoading":_vm.loading}}),_vm._v(".\n        ")],1)])])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.descricao),expression:"filtros.descricao"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Digite a secretaria ou descrição...","aria-placeholder":"Digite a secretaria ou descrição..."},domProps:{"value":(_vm.filtros.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "descricao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 text-right"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.downloadToCSV()}}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}}),_vm._v(" Exportar para CSV\n        ")],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('DataTable',{attrs:{"dados":_vm.emendasDoVereador,"fields":_vm.dataFields},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Exibir detalhes","type":"button"},on:{"click":function($event){return _vm.showDetails(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'search'}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Exibir detalhes")])],1)]}}])})],1)])],1),_vm._v(" "),_c('SideEmendas',{ref:"side-emendas",attrs:{"emenda":_vm.emendaSelecionada,"navs":_vm.navs}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n          Lista de Emendas\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sWrA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emendas"},[_c('div',{staticClass:"row"},[_c('public-header',{attrs:{"title":"Emendas Parlamentares"}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n          Aqui você encontra as emendas parlamentares recebidas da Câmara\n          Municipal de Santos.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          No ano de "),_c('SelectAnoEmendas'),_vm._v(",\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.quantidadeVereadores,"isLoading":_vm.loading}}),_vm._v(" "),(_vm.quantidadeVereadores === 1)?_c('span',[_vm._v(" vereador repassou ")]):_c('span',[_vm._v(" vereadores repassaram ")]),_vm._v(" "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.quantidadeEmendas,"isLoading":_vm.loading}}),_vm._v(" "),(_vm.quantidadeEmendas === 1)?_c('span',[_vm._v(" emenda ")]):_c('span',[_vm._v(" emendas ")]),_vm._v(" para o Munícipio de Santos, com um\n          total de\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.valorTotalEmendas),"isLoading":_vm.loading}}),_vm._v("\n          em verbas repassadas.\n        ")],1),_vm._v(" "),_c('p',[_vm._v("\n          Do total,\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.valorTotalUtilizado),"isLoading":_vm.loading}}),_vm._v("\n          já foram utilizadas em seus respectivos projetos, restando um saldo\n          de\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.saldoTotal),"isLoading":_vm.loading}}),_vm._v("\n          .\n        ")],1)])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"card-container"},[_c('router-link',{staticClass:"col-xs-12 col-sm-6 col-md-3",attrs:{"to":{ name: 'emendas_por_area' }}},[_c('div',{staticClass:"card"},[_vm._v("\n              Emendas por área de atuação\n            ")])]),_vm._v(" "),_c('router-link',{staticClass:"col-xs-12 col-sm-6 col-md-3",attrs:{"to":{ name: 'emendas_por_vereador' }}},[_c('div',{staticClass:"card"},[_vm._v("\n              Emendas por vereador\n            ")])]),_vm._v(" "),_c('router-link',{staticClass:"col-xs-12 col-sm-6 col-md-3",attrs:{"to":{ name: 'emendas_detalhe_por_ano' }}},[_c('div',{staticClass:"card"},[_vm._v("\n              Todas as emendas do ano\n            ")])])],1)])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Para mais informações")]),_vm._v(" "),_c('p',{staticClass:"font-lg"},[_vm._v("\n            Abaixo, você poderá consultar um resumo de todas as emendas\n            parlamentares por área de atuação (Saúde, Educação, Assistência\n            Social etc.) ou por vereador. Após a seleção, você poderá navegar\n            por diferentes níveis de informações e, ao final, encontrará a\n            listagem com todas as emendas parlamentares do ano.\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sgek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_favoritos_js__ = __webpack_require__("uR7G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_536b0b2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("/AuF");
function injectStyle (ssrContext) {
  __webpack_require__("AUiK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_favoritos_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_536b0b2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "skE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-info dropdown-toggle",attrs:{"title":"Exportar dados","type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('font-awesome-icon',{attrs:{"icon":'file-download'}}),_vm._v(" "),_c('span',{staticClass:"caret"})],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},_vm._l((_vm.types),function(item){return _c('li',{key:item.value},[_c('a',{staticClass:"link-export",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.imprimir(item.value)}}},[_c('span',[_c('font-awesome-icon',{attrs:{"icon":item.icon}}),_vm._v(" "),_c('span',{staticClass:"icon-space"},[_vm._v(_vm._s(item.value))])],1),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":item.downloadIcon}})],1)])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "suTU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "syb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'relatorio',
  data: function data() {
    return {
      fields1: [{
        name: 'sigla',
        title: 'Sigla',
        dataClass: 'align-middle'
      }, {
        name: 'nome',
        title: 'Nome',
        dataClass: 'align-middle'
      }, {
        name: 'total_dados',
        title: 'Total de dados',
        dataClass: 'da-align-center'
      }, {
        name: 'total_lancado',
        title: 'Dados lançados',
        dataClass: 'da-align-center'
      }, {
        name: 'total_concluido',
        title: '% Concluido',
        dataClass: 'da-align-center'
      }],
      fields2: [{
        name: 'sigla',
        title: 'Sigla',
        dataClass: 'align-middle'
      }, {
        name: 'nome',
        title: 'Nome',
        dataClass: 'align-middle'
      }, {
        name: 'total_dados',
        title: 'Total de dados',
        dataClass: 'da-align-center'
      }, {
        name: 'total_lancado',
        title: 'Dados lançados',
        dataClass: 'da-align-center'
      }, {
        name: 'total_concluido',
        title: '% Concluido',
        dataClass: 'da-align-center'
      }],
      timer: ''
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    var _this = this;

    var atualiza = function atualiza() {
      _this.$refs.vuetable1.refresh();
      _this.$refs.vuetable2.refresh();
    };

    this.timer = setInterval(atualiza, 60000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },

  computed: {
    anoAnterior: function anoAnterior() {
      return new Date().getFullYear() - 1;
    },

    paginaSecretarias: {
      get: function get() {
        var dadosRelatoriosSecretarias = this.$store.state.vuetableState.dadosRelatoriosSecretarias;
        var paginaSecretarias = dadosRelatoriosSecretarias.paginaSecretarias;

        return paginaSecretarias;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dadosRelatoriosSecretarias',
          value: value
        });
      }
    },
    paginaAutarquias: {
      get: function get() {
        var dadosRelatoriosAutarquias = this.$store.state.vuetableState.dadosRelatoriosAutarquias;
        var paginaAutarquias = dadosRelatoriosAutarquias.paginaAutarquias;

        return paginaAutarquias;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dadosRelatoriosAutarquias',
          value: value
        });
      }
    }
  }
});

/***/ }),

/***/ "szDb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t/V9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    time: {
      type: Object
    },
    click: {
      type: Function,
      required: true
    }
  },
  computed: {
    entradaIsEmpty: function entradaIsEmpty() {
      return this.time.entrada === '';
    },
    saidaIsEmpty: function saidaIsEmpty() {
      return this.time.saida === '';
    }
  }
});

/***/ }),

/***/ "t1vn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'acompanhamento_detalhes',
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_0__components_common_NoApiTable__["a" /* default */]
  },
  data: function data() {
    return {
      fields: {
        cargos: [{
          name: 'data_homologacao',
          title: 'Homologação'
        }, {
          name: 'descricao',
          title: 'Descrição'
        }, {
          name: 'vagas',
          title: 'Vagas',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }, {
          name: 'ultima_nomeacao',
          title: 'Ultima Nomeação',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }, {
          name: 'data_validade',
          title: 'Validade',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center',
          dataClass: 'text-center col-xs-1'
        }],
        habilitados: [{
          name: 'classificacao',
          title: 'Classificação'
        }, {
          name: 'nome',
          title: 'Nome'
        }, {
          name: 'descricao',
          title: 'Cargo'
        }, {
          name: 'data_habilitado',
          title: 'Data Habilitação',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }],
        nomeados: [{
          name: '__slot:column',
          title: 'Tipo Candidato'
        }, {
          name: 'classificacao',
          title: 'Classificação'
        }, {
          name: 'nome',
          title: 'Nome'
        }, {
          name: 'descricao',
          title: 'Cargo'
        }, {
          name: 'data_nomeacao',
          title: 'Data Nomeação',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }],
        empossados: [{
          name: '__slot:column',
          title: 'Tipo Candidato'
        }, {
          name: 'classificacao',
          title: 'Classificação'
        }, {
          name: 'nome',
          title: 'Nome'
        }, {
          name: 'descricao',
          title: 'Cargo'
        }, {
          name: 'data_nomeacao',
          title: 'Data Nomeação',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }],
        revogados: [{
          name: '__slot:column',
          title: 'Tipo Candidato'
        }, {
          name: 'classificacao',
          title: 'Classificação'
        }, {
          name: 'nome',
          title: 'Nome'
        }, {
          name: 'descricao',
          title: 'Cargo'
        }, {
          name: 'data_nomeacao',
          title: 'Data Nomeação',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }]
      },
      edital: {
        id: 0,
        numero: '',
        processo: '',
        publicado: '',
        status: ''
      },
      cargos: [],
      habilitados: [],
      isLoading: false
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.edital.id = this.$router.history.current.params.edital_id;

    this.carregarEdital();
    this.carregarCargos();
    this.carregarHabilitados();
  },

  computed: {
    habilitadosNormal: function habilitadosNormal() {
      return this.habilitados.filter(function (item) {
        return item.tipo_normal === 1;
      });
    },
    habilitadosPCD: function habilitadosPCD() {
      return this.habilitados.filter(function (item) {
        return item.tipo_pcd === 1;
      });
    },
    nomeados: function nomeados() {
      return this.habilitados.filter(function (item) {
        return item.data_nomeacao && !item.data_empossado && !item.data_revogacao;
      });
    },
    empossados: function empossados() {
      return this.habilitados.filter(function (item) {
        return !!item.data_empossado;
      });
    },
    revogados: function revogados() {
      return this.habilitados.filter(function (item) {
        return !!item.data_revogacao;
      });
    },
    editalId: function editalId() {
      return this.edital.id;
    }
  },
  methods: {
    retornarTipoCandidato: function retornarTipoCandidato(_ref) {
      var tipo_pcd = _ref.tipo_pcd,
          tipo_cotas = _ref.tipo_cotas;

      if (tipo_pcd) {
        return 'PCD';
      }

      if (tipo_cotas) {
        return 'Cotas';
      }

      return 'Geral';
    },
    carregarEdital: function carregarEdital() {
      var _this = this;

      var editalId = this.editalId,
          toogleLoading = this.toogleLoading;

      toogleLoading();

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('edital/' + editalId).then(function (response) {
        return _this.edital = response.data;
      }).catch(function (error) {
        return console.log(error.response);
      }).then(toogleLoading);
    },
    carregarCargos: function carregarCargos() {
      var _this2 = this;

      var editalId = this.editalId,
          toogleLoading = this.toogleLoading;

      toogleLoading();

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('cargo', { params: { edital_id: editalId } }).then(function (response) {
        return _this2.cargos = response.data;
      }).catch(function (error) {
        return console.log(error.response);
      }).then(toogleLoading);
    },
    carregarHabilitados: function carregarHabilitados() {
      var _this3 = this;

      var editalId = this.editalId,
          toogleLoading = this.toogleLoading;

      toogleLoading();

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('habilitado', { params: { edital_id: editalId } }).then(function (response) {
        return _this3.habilitados = response.data;
      }).catch(function (error) {
        return console.log(error.response);
      }).then(toogleLoading);
    },
    toogleLoading: function toogleLoading() {
      this.isLoading = !this.isLoading;
    },

    scrollToElement: __WEBPACK_IMPORTED_MODULE_2__utils__["o" /* scrollToElement */]
  }
});

/***/ }),

/***/ "tAay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mp-subgrupos',
  inject: ["showConfirm"],
  data: function data() {
    return {
      apiUrl: 'material/subgrupo',
      grupos: [],
      fields: [{
        name: 'nome',
        title: 'Nome',
        sortField: 'nome',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'grupo.nome',
        title: 'Grupo',
        sortField: 'grupo.nome',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }],
      carregando: false
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_2__components_common_DataTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    this.loadGrupos();
  },

  methods: {
    loadGrupos: function loadGrupos() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].get('materiais/listar-grupos');

              case 2:
                response = _context.sent;

                _this.grupos = response.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    excluir: function excluir(data) {
      var _this2 = this;

      var me = this;
      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_3__request__["a" /* request */].delete(_this2.apiUrl + '/' + data.codigo).then(function (resp) {
            me.consultar();
            me.$toastr.s('Item removido com sucesso');
          }).catch(function (error) {
            me.$toastr.e(error.response.data);
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      this.nome = '';
      this.grupo_codigo = '';
      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'subgrupos',
        value: 1
      });
    }
  },
  computed: {
    filtros: function filtros() {
      var nome = this.nome,
          grupo_codigo = this.grupo_codigo;

      return {
        nome: nome,
        grupo_codigo: grupo_codigo
      };
    },

    nome: {
      get: function get() {
        var subgrupos = this.$store.state.vuetableState.subgrupos;
        var nome = subgrupos.filtros.nome;

        return nome;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'subgrupos',
          value: value
        });
        this.resetPageStore();
      }
    },
    pagina: {
      get: function get() {
        var subgrupos = this.$store.state.vuetableState.subgrupos;
        var pagina = subgrupos.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'subgrupos',
          value: value
        });
      }
    },
    grupo_codigo: {
      get: function get() {
        var subgrupos = this.$store.state.vuetableState.subgrupos;
        var grupo_codigo = subgrupos.filtros.grupo_codigo;

        return grupo_codigo;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'grupo_codigo',
          collection: 'subgrupos',
          value: value
        });
        this.resetPageStore();
      }
    }
  }
});

/***/ }),

/***/ "tBN9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN_USER; });
var LOGOUT_USER = 'LOGOUT_USER';
var LOGIN_USER = 'LOGIN_USER';

/***/ }),

/***/ "tBvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Importar_vue__ = __webpack_require__("L+8o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dcc87d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Importar_vue__ = __webpack_require__("2HAx");
function injectStyle (ssrContext) {
  __webpack_require__("v9fZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dcc87d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Importar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dcc87d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Importar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tO7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Botao from '@/components/shared/botao'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SideModal',

  props: {
    tit: {
      required: true,
      type: String,
      value: ''
    },
    subtit: {
      required: false,
      type: String,
      value: ''
    },
    subtDetl: {
      required: false,
      type: String,
      value: ''
    },
    larg: {
      required: false,
      type: Number,
      value: 600
    },
    id: {
      required: true,
      type: String,
      value: ''
    },
    abreMaisUm: {
      required: false,
      type: Boolean,
      value: false
    },
    aberto: {
      required: true,
      type: Boolean,
      value: false
    }
  },
  methods: {
    largString: function largString(larg) {
      return larg + 'px';
    },
    largCalc: function largCalc(larg) {
      // soma para esconder o box-shadow
      var calc = larg + 30;
      return '-' + calc + 'px';
    },
    abre: function abre(id) {
      document.querySelector('#' + id).style.right = '0px';
    },
    abreOutro: function abreOutro() {
      this.$emit('abreFromChild');
    },
    fecha: function fecha(id) {
      document.querySelector('#' + id).style.width = this.largString(this.larg);
      document.querySelector('#' + id).style.right = this.largCalc(this.larg);
      this.$emit('fechou');
    },
    fechaFromParent: function fechaFromParent(id, larg) {
      document.querySelector('#' + id).style.right = this.largCalc(larg);
    },
    expande: function expande(id, larg) {
      document.querySelector('#' + id).style.width = this.largString(larg);
      this.abre(id);
    },
    contrai: function contrai(id, larg) {
      document.querySelector('#' + id).style.width = this.largString(larg);
      this.$emit('largura', larg);
    }
  },
  components: {
    // botao: Botao
  },
  created: function created() {
    var _this = this;

    this.$parent.$on('mostra', function (id) {
      return _this.abre(id);
    });
    this.$parent.$on('esconde', function (prop) {
      return _this.fechaFromParent(prop.identidade, prop.largura);
    });
    this.$parent.$on('mostraMais', function (prop) {
      return _this.expande(prop.id, prop.larg);
    });
    this.$parent.$on('escondeMais', function (prop) {
      return _this.contrai(prop.identidade, prop.largura);
    });
  },
  mounted: function mounted() {
    document.querySelector('#' + this.id).style.width = this.largString(this.larg);
    document.querySelector('#' + this.id).style.right = this.largCalc(this.larg);
  }
});

/***/ }),

/***/ "tR7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"por-exames"},[_c('ProcedimentosSaude',{attrs:{"title":_vm.exame,"termo-consulta":_vm.exame,"breadcrumb":_vm.breadcrumb,"urls":_vm.urls,"tipo":'exames'}},[_c('template',{slot:"header-slot"},[_c('div',{staticClass:"col-xs-12"},[_c('p',[_vm._v("\n          Aqui você encontra as solicitações agendadas para realização do\n          exame "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.exame))]),_vm._v(".\n        ")])])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tRNT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GraficoConsumo_vue__ = __webpack_require__("9Phz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79208d72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GraficoConsumo_vue__ = __webpack_require__("YcTg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GraficoConsumo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79208d72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GraficoConsumo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tSov":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_the_mask__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: String
    },
    id: {
      type: String,
      required: true
    },
    carregando: {
      type: Boolean,
      required: true
    }
  },
  components: { TheMask: __WEBPACK_IMPORTED_MODULE_0_vue_the_mask__["TheMask"] },
  data: function data() {
    return { propValue: this.value };
  },

  watch: {
    value: function value(newValue) {
      this.propValue = newValue;
    }
  }
});

/***/ }),

/***/ "tU0y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tYv3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.detalhes.dado.tipo !== 'T')?_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Gráfico")]),_vm._v(" "),(_vm.detalhes.dado.periodicidade === 6)?_c('Chart',{attrs:{"css-classes":'chart-container',"chart-data":_vm.dados_grafico,"coloredLine":true,"options":_vm.chartOptions}}):_vm._e(),_vm._v(" "),(_vm.detalhes.dado.periodicidade === 1)?_c('bar-chart',{ref:"graph_barra",attrs:{"css-classes":'chart-container',"chart-data":_vm.dados_grafico,"gradiente":false,"options":_vm.chartOptions}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tbtc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beneficios-save"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-primary btn-voltar",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.back()}}},[_c('font-awesome-icon',{attrs:{"icon":'arrow-left'}}),_vm._v("\n        Voltar\n      ")],1),_vm._v(" "),_c('h2',{staticClass:"page-header"},[_vm._v("\n        "+_vm._s(_vm.item.codigo ? 'Editar benefício' : 'Inserir novo benefício')+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('nome') }]},[_c('label',{class:[
            'control-label',
            'custom-font',
            { 'is-danger': _vm.errors.has('nome') }
          ]},[_vm._v("Nome")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('nome') }],attrs:{"icon":'id-card'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.nome),expression:"item.nome"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"nome",staticClass:"form-control",attrs:{"name":"nome","placeholder":"Nome","maxlength":"50","type":"text"},domProps:{"value":(_vm.item.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "nome", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
              'input-group-addon custom-input-group-addon-count',
              { 'is-danger': _vm.errors.has('nome') }
            ],domProps:{"textContent":_vm._s(50 - (_vm.item.nome ? _vm.item.nome.length : 0))}})]),_vm._v(" "),(_vm.errors.has('nome'))?_c('small',{staticClass:"help-block"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v(" Preenchimento\n          obrigatório!")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('sigla') }]},[_c('label',{class:[
            'control-label',
            'custom-font',
            { 'is-danger': _vm.errors.has('sigla') }
          ]},[_vm._v("Sigla")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('sigla') }],attrs:{"icon":'tags'}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.sigla),expression:"item.sigla"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"sigla",staticClass:"form-control",attrs:{"name":"sigla","placeholder":"Sigla","maxlength":"15","type":"text"},domProps:{"value":(_vm.item.sigla)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "sigla", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
              'input-group-addon custom-input-group-addon-count',
              { 'is-danger': _vm.errors.has('sigla') }
            ],domProps:{"textContent":_vm._s(15 - (_vm.item.sigla ? _vm.item.sigla.length : 0))}})]),_vm._v(" "),(_vm.errors.has('sigla'))?_c('small',{staticClass:"help-block"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v(" Preenchimento\n          obrigatório!")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{class:['form-group', { 'has-error': _vm.errors.has('descricao') }]},[_c('label',{class:[
            'control-label',
            'custom-font',
            { 'is-danger': _vm.errors.has('descricao') }
          ]},[_vm._v("Descrição")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font-awesome-icon',{class:[{ 'is-danger': _vm.errors.has('descricao') }],attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.descricao),expression:"item.descricao"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"descricao",staticClass:"form-control",attrs:{"rows":"3","name":"descricao","placeholder":"Informe a descrição do benefício...","maxlength":"2000"},domProps:{"value":(_vm.item.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.item, "descricao", $event.target.value)}}}),_vm._v(" "),_c('div',{class:[
              'input-group-addon custom-input-group-addon-count',
              { 'is-danger': _vm.errors.has('descricao') }
            ],domProps:{"textContent":_vm._s(2000 - (_vm.item.descricao ? _vm.item.descricao.length : 0))}})]),_vm._v(" "),(_vm.errors.has('descricao'))?_c('small',{staticClass:"help-block"},[_c('font-awesome-icon',{attrs:{"icon":'exclamation-triangle'}}),_vm._v(" Preenchimento\n          obrigatório!")],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group col-xs-12 margem-topo"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){return _vm.salvar()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n        Salvar\n      ")],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tf6l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginModal_vue__ = __webpack_require__("L+UB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36411268_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginModal_vue__ = __webpack_require__("9Gsj");
function injectStyle (ssrContext) {
  __webpack_require__("CyOM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36411268"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36411268_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tjMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProgressoCandidato__ = __webpack_require__("Xll0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProgressoGeral__ = __webpack_require__("AxvQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ProgressoCandidato: __WEBPACK_IMPORTED_MODULE_0__ProgressoCandidato__["a" /* default */], ProgressoGeral: __WEBPACK_IMPORTED_MODULE_1__ProgressoGeral__["a" /* default */] },
  props: {
    title: {
      type: String,
      required: true
    },
    lista: {
      type: Array,
      required: true
    },
    totalVotos: {
      type: Number,
      required: true
    },
    destaque: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),

/***/ "tmhp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardFilaEspera_vue__ = __webpack_require__("V3RT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3077b9ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardFilaEspera_vue__ = __webpack_require__("8zfL");
function injectStyle (ssrContext) {
  __webpack_require__("JLTk")
  __webpack_require__("8SCe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3077b9ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardFilaEspera_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3077b9ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardFilaEspera_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "toeg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vuetableState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__("9ym8");


var vuetableState = {
  state: function state() {
    return {
      planoGoverno: {
        pagina: 1,
        filtros: {
          unidade: '',
          descricao: '',
          status: ''
        }
      },
      compromissoDetails: {
        pagina: 1,
        filtros: {
          periodo: '',
          unidade_executora: '',
          descritivo: '',
          responsavel: '',
          status: ''
        }
      },
      minhasAcoes: {
        pagina: 1,
        filtros: {
          periodo: '',
          unidade_executora: '',
          descritivo: '',
          responsavel: '',
          prazo: ''
        }
      },
      materiaisPadronizados: {
        pagina: 1,
        filtros: {
          nome: '',
          descricao: '',
          medida: '',
          subgrupo: '',
          grupo: ''
        }
      },
      tags: {
        pagina: 1,
        filtros: {
          TAG_DCTAG: ''
        }
      },
      eixos: {
        pagina: 1,
        filtros: {
          EIX_DCEIXO: ''
        }
      },
      metas: {
        pagina: 1,
        filtros: {
          MET_DCTITULO: '',
          MET_DLOBJETIVO: ''
        }
      },
      dados: {
        pagina: 1,
        filtros: {
          nome: '',
          fonte: '',
          periodicidade_codigo: '*',
          secretaria_sigla: '',
          autarquia_sigla: '',
          status_values: '*'
        }
      },
      listModeration: {
        pagina: 1
      },
      listApproved: {
        pagina: 1
      },
      userValues: {
        pagina: 1
      },
      adminValues: {
        pagina: 1
      },
      concursosEdital: {
        pagina: 1,
        filtros: {
          numero: '',
          processo_numero: '',
          publicado: ''
        }
      },
      acompanhamentos: {
        pagina: 1,
        filtros: {
          numero: '',
          processo_numero: '',
          publicado: '',
          status: ''
        }
      },
      assistenciaPagamentos: {
        pagina: 1,
        filtros: {
          nome: '',
          ano: '',
          mes: '',
          beneficio: ''
        }
      },
      grupos: {
        pagina: 1,
        filtros: {
          nome: ''
        }
      },
      medidas: {
        pagina: 1,
        filtros: {
          nome: ''
        }
      },
      subgrupos: {
        pagina: 1,
        filtros: {
          nome: '',
          grupo_codigo: ''
        }
      },
      escalasVincularUnidadeUsuario: {
        paginaUnidadesVinculadas: 1,
        paginaUnidadesDisponiveis: 1
      },
      usuarios: {
        pagina: 1,
        filtros: {
          username: '',
          USU_DCEMAIL: '',
          USU_NMUSUARIO: ''
        }
      },
      dadosAssociados: {
        paginaAssociados: 1
      },
      dadosParaAssociar: {
        paginaParaAssociar: 1
      },
      dadosRelatoriosSecretarias: {
        paginaSecretarias: 1
      },
      dadosRelatoriosAutarquias: {
        paginaAutarquias: 1
      },
      beneficiosAssistenciais: {
        pagina: 1
      },
      emendasParlamentares: {
        pagina: 1,
        filtros: {
          ano: '',
          vereador: '',
          processos_pagamento: '',
          sigla_orgao: '',
          numero: '',
          numero_processo: '',
          descricao: '',
          resumo_utilizacao: ''
        }
      },
      vereadores: {
        pagina: 1,
        filtros: {
          nome: ''
        }
      },
      processos_pagamento: {
        pagina: 1,
        filtros: {
          numero_pagamento: '',
          valor: '',
          emenda: ''
        }
      }
    };
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["a" /* mutations */]
};

/***/ }),

/***/ "tz3W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LogoPMS.a0f61e4.svg";

/***/ }),

/***/ "u+tz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u3WT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.3149a33.jpg";

/***/ }),

/***/ "u5A4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'InputModal',
    props: {
        titulo: String,
        descricao: String,
        label: String,
        placeholder: String
    },
    data: function data() {
        return {
            value: '',
            fnOk: null,
            btnRemoveText: 'Remover',
            timerInterval: null
        };
    },
    mounted: function mounted() {
        if (this.inputValue) this.value = this.inputValue;
    },

    computed: {
        control: function control() {
            return window.jQuery('#modal_input');
        }
    },
    methods: {
        ok: function ok() {
            if (this.fnOk) this.fnOk(this.value);
            this.value = '';
        },
        show: function show(_ref) {
            var value = _ref.value,
                fnOk = _ref.fnOk;

            this.value = value;
            this.fnOk = fnOk;
            this.btnRemoveText = 'Remover';
            this.control.modal('show');
        },
        hide: function hide() {
            this.control.modal('hide');
        },
        startRemove: function startRemove() {
            if (this.btnRemoveText === 'Remover') {
                this.btnRemoveText = "Clique para cancelar 7s";
                this.startTimer();
            } else {
                this.btnRemoveText = 'Remover';
                clearInterval(this.timerInterval);
            }
        },
        startTimer: function startTimer() {
            var me = this;
            this.timerInterval = setInterval(function () {
                var segundos = Number(me.btnRemoveText.replace(/\D/g, ''));
                if (segundos > 0) {
                    var novoSegundo = segundos - 1;
                    me.btnRemoveText = me.btnRemoveText.replace(segundos, novoSegundo);
                } else {
                    clearInterval(me.timerInterval);
                    me.fnOk(null);
                    me.hide();
                }
            }, 1000);
        }
    }
});

/***/ }),

/***/ "uC+7":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "uEig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [{
          title: 'Título',
          data: [{ label: 'Descrição', value: 'R$ 0,00' }]
        }];
      }
    },
    gridClass: {
      type: String,
      default: 'col-sm-6 col-md-4'
    }
  },
  mounted: function mounted() {
    window.jQuery('[data-toggle="popover"]').popover({});
  }
});

/***/ }),

/***/ "uHUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dataFields; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("0xDb");


var navs = [{
  titulo: '',
  subtitulo: '',
  subtDetalhe: '',
  largura: 900,
  identidade: 'emenda',
  abreProximo: true,
  aberto: false
}];

var dataFields = [{
  name: 'numero',
  title: 'Emenda nº',
  titleClass: 'text-right',
  dataClass: 'text-right'
}, {
  name: 'vereador.nome',
  title: 'Vereador'
}, {
  name: 'nome_orgao',
  title: 'Secretaria'
}, {
  name: 'descricao',
  title: 'Descrição'
}, {
  name: 'valor',
  title: 'Valor',
  titleClass: 'text-right',
  dataClass: 'text-right',
  callback: function callback(value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* formatarMoeda */])(Number(value));
  }
}, {
  name: 'saldo',
  title: 'Saldo',
  titleClass: 'text-right',
  dataClass: 'text-right',
  callback: function callback(value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* formatarMoeda */])(Number(value));
  }
}, {
  name: '__slot:actions',
  title: 'Detalhes',
  titleClass: 'text-center col-md-2',
  dataClass: 'text-center'
}];

/***/ }),

/***/ "uM8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardFilaEspera__ = __webpack_require__("tmhp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListaFilaAgendados__ = __webpack_require__("pTTs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_vue__ = __webpack_require__("RBHp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListaFilaEspera__ = __webpack_require__("6bWN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EstatisticaTotalAgendamentos__ = __webpack_require__("Ggm1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EstatisticaTempoMedio__ = __webpack_require__("SoQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__datatableFields__ = __webpack_require__("MtQW");
/* unused harmony namespace reexport */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CardFilaEspera__["a"]; });
/* unused harmony reexport ListaFilaEspera */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ListaFilaAgendados__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__index_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__EstatisticaTotalAgendamentos__["a"]; });
/* unused harmony reexport EstatisticaTempoMedio */











/***/ }),

/***/ "uOq9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.title)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])])]):_vm._e(),_vm._v(" "),(_vm.carregando)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 datatable-spinner text-center"},[_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}})],1)]):_vm._e(),_vm._v(" "),(!_vm.carregando && _vm.dados.length)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('DataTable',{attrs:{"fields":_vm.fieldsAgendados,"slots":['agendado', 'gravidade'],"dados":_vm.dados,"carregando":_vm.carregando},scopedSlots:_vm._u([{key:"gravidade",fn:function(props){return [_c('div',{class:[_vm.getGravidadeClass(props.rowData.gravidade), 'gravidade']},[_vm._v("\n            "+_vm._s(props.rowData.gravidade)+"\n          ")])]}},{key:"agendado",fn:function(props){return [_c('div',{class:[
              props.rowData.dtagendamento
                ? _vm.getProximidadeData(props.rowData.dtagendamento) +
                  ' gravidade'
                : ''
            ]},[_vm._v("\n            "+_vm._s(_vm.formatTo2DigitsDate(new Date(props.rowData.dtagendamento)))+"\n          ")])]}}],null,false,2348478051)},[_c('template',{slot:"header-actions"},[_c('ExportCSV',{attrs:{"dados":_vm.dados,"tipo":'agendados'}})],1)],2)],1)]):_vm._e(),_vm._v(" "),(!_vm.carregando && !_vm.dados.length)?_c('div',{staticClass:"row"},[_vm._m(0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 nenhum-item"},[_c('p',[_vm._v("Não há agendamento")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uQen":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('a',{staticClass:"skip-link",attrs:{"href":"#conteudo","id":"link-conteudo","accesskey":"1"}},[_vm._v("\n    Ir para o conteúdo principal [1]\n  ")]),_vm._v(" "),_c('a',{staticClass:"skip-link",attrs:{"href":"#menu","id":"link-menu","accesskey":"2"}},[_vm._v("\n    Ir para o menu principal [2]\n  ")]),_vm._v(" "),_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uR7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_strings__ = __webpack_require__("V99r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_colors__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common___ = __webpack_require__("vAZe");











/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  name: 'Favoritos',
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_9__components_common___["a" /* PublicHeader */],
    BarChart: __WEBPACK_IMPORTED_MODULE_9__components_common___["d" /* BarChart */],
    LineChart: __WEBPACK_IMPORTED_MODULE_9__components_common___["f" /* LineChart2 */]
  },
  data: function data() {
    return {
      favoritos: [],
      dados: [],
      comparativos: [],
      cores: __WEBPACK_IMPORTED_MODULE_8__utils_colors__["a" /* default */].coresHexa,
      tipoGrafico: 'bar',
      tipoComparativo: 'soma'
    };
  },

  methods: {
    fetchFavoritos: function fetchFavoritos() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('favoritos?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_strings__["i" /* formatObjectToQueryString */])(JSON.parse(localStorage.getItem('pmsdadosabertos')).favoritos)).then(function (response) {
        _this.favoritos = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    removerFavorito: function removerFavorito(favorito) {
      var _this2 = this;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          var _JSON$parse = JSON.parse(localStorage.getItem('pmsdadosabertos')),
              favoritos = _JSON$parse.favoritos,
              rest = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default()(_JSON$parse, ['favoritos']);

          if (favoritos.length) {
            var index = favoritos.indexOf(favorito.codigo);
            favoritos.splice(index, 1);
            localStorage.setItem('pmsdadosabertos', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, rest, { favoritos: favoritos })));
          }

          _this2.fetchFavoritos();

          _this2.$toastr.s('Favorito removido com sucesso');
        }
      };

      this.showConfirm('Deseja realmente remover este item?', config);
    },
    toDate: function toDate(dateStr) {
      var _dateStr$split = dateStr.split('/'),
          _dateStr$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_dateStr$split, 3),
          day = _dateStr$split2[0],
          month = _dateStr$split2[1],
          year = _dateStr$split2[2];

      return new Date(year, month - 1, day);
    },
    adicionarComparativo: function adicionarComparativo(id, nome) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_6__request__["a" /* request */].get('favoritos/valores/' + id).then(function (response) {
        var _response$data = response.data,
            datas = _response$data.datas,
            valores = _response$data.valores;


        _this3.dados.push({
          codigo: id,
          nome: nome,
          valores: valores,
          datas: datas
        });

        var aux = {};
        for (var index = 0; index < datas.length; index++) {
          var data_dado = _this3.toDate(datas[index]);
          aux[data_dado.getFullYear()] = valores[index];
        }

        _this3.comparativos.push(aux);
      }).catch(function (error) {
        _this3.$toastr.e(error.response);
      });
    },
    removerComparativo: function removerComparativo(item) {
      this.dados.splice(item, 1);
      this.comparativos.splice(item, 1);
    },
    permitirComparativo: function permitirComparativo(favorito) {
      if (favorito.tipo === 'T' || this.dados.findIndex(function (val) {
        return val.codigo === favorito.codigo;
      }) > -1 || this.dados.length > 4) {
        return false;
      }

      return true;
    },
    retornaSoma: function retornaSoma(grafico) {
      var result = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.comparativos));
      var anos = grafico.labels;

      grafico.datasets.push({
        label: 'Soma Simples',
        data: []
      });

      result = result.reduce(function (acumulador, atual) {
        var res = {};
        for (var index = 0; index < anos.length; index++) {
          res[anos[index]] = (parseFloat(acumulador[anos[index]]) || 0) + (parseFloat(atual[anos[index]]) || 0);
        }

        return res;
      });

      for (var index = 0; index < anos.length; index++) {
        grafico.datasets[0].data.push(result[anos[index]]);
      }

      return grafico;
    },
    retornaMediaSimples: function retornaMediaSimples(grafico) {
      var _this4 = this;

      var result = this.retornaSoma(grafico);
      result.datasets[0].label = 'Média simples';
      result.datasets[0].data = result.datasets[0].data.map(function (valor) {
        return valor / _this4.comparativos.length;
      });

      return result;
    },
    retornaMediaAnual: function retornaMediaAnual(grafico) {
      var base = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.comparativos));
      var result = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, grafico, {
        labels: ['Média Anual']

        // varrendo todos os objetos da variável base
      });for (var index = 0; index < base.length; index++) {
        // pegando os anos de cada objeto
        var anos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(base[index]);
        var acumulador = 0;

        // varrendo o array de anos para somar os valores do objeto que está em iteração
        for (var subindex = 0; subindex < anos.length; subindex++) {
          acumulador += parseFloat(base[index][anos[subindex]]) || 0;
        }

        // adicionando o resultado da soma na estrutura do gráfico
        result.datasets.push({
          label: 'Dado ' + (index + 1),
          data: [acumulador / anos.length]
        });
      }

      return result;
    },
    retornaRelacao: function retornaRelacao(grafico) {
      var result = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, grafico);
      var anos = result.labels;
      var base = [];

      for (var index = 0; index < 2; index++) {
        base.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.comparativos[index]));
      }

      var relacao = base.reduce(function (acumulador, atual) {
        var res = [];
        for (var _index = 0; _index < anos.length; _index++) {
          res.push((parseFloat(acumulador[anos[_index]]) || 0) / (parseFloat(atual[anos[_index]]) || 1));
        }

        return res;
      });

      result.datasets.push({
        label: 'Relação Dado 1 / Dado 2',
        data: relacao
      });

      return result;
    }
  },
  mounted: function mounted() {
    this.fetchFavoritos();
  },

  computed: {
    labels_grafico: function labels_grafico() {
      var _this5 = this;

      var base = [2014];
      var periodicidade = this.favoritos[this.favoritos.findIndex(function (val) {
        return val.codigo === _this5.dados[0].codigo;
      })].periodicidade;

      if (periodicidade === 6) {
        var data = new Date();
        while (base[base.length - 1] < data.getFullYear() - 1) {
          base.push(base[base.length - 1] + 1);
        }
      }

      return base;
    },
    dados_grafico: function dados_grafico() {
      var anos = this.labels_grafico;
      var dados = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.comparativos));
      var base = {
        labels: this.labels_grafico,
        datasets: []
      };

      for (var index = 0; index < dados.length; index++) {
        base.datasets.push({
          label: '',
          data: []
        });

        for (var subindex = 0; subindex < anos.length; subindex++) {
          base.datasets[index].data.push(dados[index][anos[subindex]]);
        }
      }

      return base;
    },
    dados_comparativos: function dados_comparativos() {
      var grafico = {
        labels: this.labels_grafico,
        datasets: []
      };

      switch (this.tipoComparativo) {
        case 'soma':
          return this.retornaSoma(grafico);
        case 'mediaSimples':
          return this.retornaMediaSimples(grafico);
        case 'mediaAnual':
          return this.retornaMediaAnual(grafico);
        case 'relacao':
          return this.retornaRelacao(grafico);
        default:
          return grafico;
      }
    }
  }
});

/***/ }),

/***/ "uSDW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ua68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Impressao_vue__ = __webpack_require__("ljz1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7080592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Impressao_vue__ = __webpack_require__("TJ7b");
function injectStyle (ssrContext) {
  __webpack_require__("HfSY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7080592"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Impressao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7080592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Impressao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "udoz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 lista-cards"},_vm._l((_vm.secretarias),function(secr){return _c('a',{key:secr.codigo,attrs:{"role":"button","title":secr.titulo,"data-toggle":'popover',"data-content":secr.objetivo,"data-trigger":'hover'},on:{"click":function($event){return _vm.$emit('click', secr)}}},[_c('span',[_vm._v("\n          "+_vm._s(secr.sigla)+"\n        ")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":'times'}})],1)}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Filtros ativos")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ufme":
/***/ (function(module, exports) {

module.exports = {"publicPath":"/dadosabertos/","apiUrl":"https://egov.santos.sp.gov.br/dadosabertos/backend/api/","imgUrl":"https://egov.santos.sp.gov.br/dadosabertos/upload/"}

/***/ }),

/***/ "ufvN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isModalVisible: false,
      isLoading: false,
      dictionaryContent: [],
      error: null,
      descricoes: {
        'codigo': 'Código de identificação principal do dado.',
        'nome': 'Nome completo do dado.',
        'descricao': 'Descrição detalhada sobre o que o dado representa.',
        'fonte': 'Fonte oficial da informação.',
        'tipoValor': 'Tipo de valor que o dado armazena (I - Numérico inteiro; D - Numérico decimal, T - Texto).',
        'periodicidade': 'Agrupador de dados de periodicidade.',
        'periodicidade.codigo': 'Código que representa a periodicidade do dado.',
        'periodicidade.descricao': 'Frequência com que o dado é atualizado (Anual, Mensal, etc).',
        'tags': 'Agrupador de tags (palavras-chave).',
        'tags.codigo': 'Código da tag ou palavra-chave associada.',
        'tags.descricao': 'Nome da tag ou palavra-chave associada.',
        'secretarias': 'Agrupador de dados das secretarias.',
        'secretarias.codigo': 'Código da secretaria responsável.',
        'secretarias.dado_codigo': 'Código interno da relação com a secretaria.',
        'secretarias.sigla': 'Sigla da secretaria responsável.',
        'secretarias.nome': 'Nome completo da secretaria responsável.',
        'autarquias': 'Agrupador de dados das autarquias.',
        'autarquias.codigo': 'Código da autarquia responsável.',
        'autarquias.dado_codigo': 'Código interno da relação com a autarquia.',
        'autarquias.sigla': 'Sigla da autarquia responsável.',
        'autarquias.nome': 'Nome completo da autarquia responsável.',
        'metas': 'Agrupador de dados das Metas ODS.',
        'metas.codigo': 'Código da meta (ODS) relacionada.',
        'metas.numero': 'Número da meta (ODS) relacionada.',
        'metas.titulo': 'Título da meta (ODS) relacionada.',
        'metas.objetivo': 'Objetivo da meta (ODS) relacionada.',
        'metas.imagem_url': 'URL da imagem representativa da meta (ODS).',
        'metas.link': 'Link para mais informações sobre a meta (ODS).',
        'eixos': 'Agrupador de eixos temáticos.',
        'eixos.codigo': 'Código do eixo temático relacionado.',
        'eixos.descricao': 'Descrição do eixo temático relacionado.',
        'valores': 'Agrupador dos valores do indicador.',
        'valores.codigo': 'Código de identificação único do registro de valor.',
        'valores.data': 'Data de referência do valor.',
        'valores.valor': 'O valor numérico ou textual do indicador para o período.',
        'valores.descricao': 'Descrição textual para valores do tipo texto ou observação específica.'
      }
    };
  },

  methods: {
    download: function download(type) {
      var url = this.$root.$data.apiUrl + 'detalhes/downloads/' + type + '/' + this.$route.params.id;
      return url;
    },
    closeModal: function closeModal() {
      this.isModalVisible = false;
    },
    openModal: function openModal() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isModalVisible = true;
                _this.isLoading = true;
                _this.dictionaryContent = [];
                _this.error = null;

                _context.prev = 4;
                url = _this.download('dicionario');
                _context.next = 8;
                return fetch(url);

              case 8:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 11;
                  break;
                }

                throw new Error('Erro ao buscar os dados do dicionário.');

              case 11:
                _context.next = 13;
                return response.json();

              case 13:
                data = _context.sent;

                _this.dictionaryContent = _this.processarDicionario(data);
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](4);

                _this.error = _context.t0.message;
                console.error("Erro ao buscar o dicionário:", _context.t0);

              case 21:
                _context.prev = 21;

                _this.isLoading = false;
                return _context.finish(21);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 17, 21, 24]]);
      }))();
    },
    getDescricao: function getDescricao(campo) {
      if (this.descricoes[campo]) {
        return this.descricoes[campo];
      }

      return 'Descrição não disponível.';
    },
    processarDicionario: function processarDicionario(campos) {
      var mapa = {};
      var resultadoPlano = [];

      campos.forEach(function (campo) {
        var raiz = campo.split('.')[0];
        if (!mapa[raiz]) {
          mapa[raiz] = {
            temRaiz: campos.includes(raiz),
            subcampos: []
          };
        }
        if (campo !== raiz) {
          mapa[raiz].subcampos.push(campo);
        }
      });

      for (var chave in mapa) {
        var grupo = mapa[chave];
        if (grupo.temRaiz) {
          resultadoPlano.push({ campo: chave, classe: 'grupo-principal' });
          grupo.subcampos.forEach(function (subcampo) {
            resultadoPlano.push({ campo: subcampo, classe: 'sub-item' });
          });
        } else {
          grupo.subcampos.forEach(function (subcampo) {
            resultadoPlano.push({ campo: subcampo, classe: 'sub-item-sem-raiz' });
          });
        }
      }

      return resultadoPlano;
    }
  }
});

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user_types__ = __webpack_require__("tBN9");



var _mutations;



var mutations = (_mutations = {
  INITIALIZED: function INITIALIZED(state, value) {
    state.initialized = value;
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__modules_user_types__["a" /* LOGIN_USER */], function (state, _ref) {
  var user = _ref.user,
      perfis = _ref.perfis;

  state.isLogged = true;
  state.initialized = true;
  state.user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, user, { perfis: perfis });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__modules_user_types__["b" /* LOGOUT_USER */], function (state) {
  state.user = {};
  state.isLogged = false;
  state.initialized = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'CLEAR_MODULES', function CLEAR_MODULES(state, value) {
  state.user = {};
  state.escala.funcionarios = [];
}), _mutations);

/***/ }),

/***/ "ukyS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoDados_vue__ = __webpack_require__("yYb3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8383778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoDados_vue__ = __webpack_require__("B+DO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoDados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8383778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoDados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "unm1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ["showConfirm"],
  data: function data() {
    return {
      title: 'Escalas',
      type: 'ESCALA',
      datatable: {
        columnID: 'id',
        columns: [{
          name: 'uor_sigla',
          title: 'Unidade',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: 'referencia',
          title: 'Referência',
          dataClass: 'align-middle',
          callback: function callback(value) {
            var year = value.substr(0, 4);
            var month = value.substr(-2) - 1;
            var date = new Date(year, month, 1);
            return Intl.DateTimeFormat('pt-BR', {
              month: 'short',
              year: 'numeric'
            }).format(date).toUpperCase().replace('. DE ', '/');
          },
          filterable: true
        }, {
          name: 'colaborador_nome',
          title: 'Colaborador',
          dataClass: 'align-middle text-capitalize',
          filterable: true
        }, {
          name: 'colaborador_cargo',
          title: 'Cargo',
          dataClass: 'align-middle text-capitalize',
          filterable: true
        }, {
          name: 'plantao_total',
          title: 'Qtde Plantões',
          dataClass: 'text-center'
        }, {
          name: '__slot:column',
          title: 'Horários | Dias'
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-1',
          dataClass: 'text-center'
        }],
        filters: {
          unidade: '',
          funcionario: ''
        }
      },
      lista: {
        escalas: [],
        carregando: false
      }
    };
  },

  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_1__components_common_NoApiTable__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.loadEscala();
  },

  methods: {
    loadEscala: function loadEscala() {
      var _this = this;

      this.lista.carregando = true;
      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('escala/list').then(function (response) {
        return _this.lista.escalas = response.data;
      }).catch(function (error) {
        return console.log(error);
      }).then(function () {
        return _this.lista.carregando = false;
      });
    },
    entradaIsEmpty: function entradaIsEmpty(periodo) {
      return this.getEmpty(periodo.split('-')) === 'entrada';
    },
    saidaIsEmpty: function saidaIsEmpty(periodo) {
      return this.getEmpty(periodo.split('-')) === 'saida';
    },
    getEmpty: function getEmpty(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          entrada = _ref2[0],
          saida = _ref2[1];

      if (entrada === '') return 'entrada';
      if (saida === '') return 'saida';

      return false;
    },
    excluir: function excluir(_ref3) {
      var _this2 = this;

      var id = _ref3.id;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('escala/removerFuncionario', { id: id }).then(function () {
            return _this2.removeEscala(id);
          }).catch(function (error) {
            console.log(error);
            _this2.$toastr.e('Houve uma falha ao tentar remover o funcionário da escala, Tente novamente daqui alguns minutos!');
          });
        }
      };
      this.showConfirm('Deseja realmente remover este item?', config);
    },
    removeEscala: function removeEscala(ID) {
      this.lista.escalas = this.lista.escalas.filter(function (_ref4) {
        var id = _ref4.id;
        return id !== ID;
      });
    }
  }
});

/***/ }),

/***/ "upps":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("jTs1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0755d4cd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("LyRi");
function injectStyle (ssrContext) {
  __webpack_require__("QMQn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0755d4cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0755d4cd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uvmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__ = __webpack_require__("RxW9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d793646c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__ = __webpack_require__("k0f5");
function injectStyle (ssrContext) {
  __webpack_require__("KfTt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d793646c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d793646c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uwvT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMap)?_c('l-map',{ref:"mapa",style:(_vm.mapStyle),attrs:{"zoom":_vm.zoom,"center":_vm.center,"options":_vm.mapOptions}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_vm._v(" "),_vm._l((_vm.computedPins),function(pin){return _c('l-marker',{key:pin.nome,attrs:{"icon":_vm.icon,"lat-lng":pin.position},on:{"update:latLng":function($event){return _vm.$set(pin, "position", $event)},"update:lat-lng":function($event){return _vm.$set(pin, "position", $event)}}},[(typeof pin.available === 'boolean')?_c('l-icon',{attrs:{"icon-url":__webpack_require__("6K9S")("./" + (pin.available ? 'ico-verde' : 'ico-vermelho') + ".svg"),"shadowAnchor":[30, 30],"popupAnchor":[-10, -10],"iconAnchor":[40, 30]}}):_vm._e(),_vm._v(" "),_c('l-popup',{attrs:{"options":{ offset: _vm.popupPoint }}},[_c('div',[_c('h4',{staticClass:"font-popup"},[_vm._v(_vm._s(pin.title))]),_vm._v(" "),_c('p',{staticClass:"font-popup"},[_vm._v("\n          Para ver detalhes da unidade,\n          "),_c('router-link',{staticClass:"btn btn-default btn-link",attrs:{"role":"button","to":{
              name: 'detalhe-unidade',
              params: {
                detalhes: pin.title.replace(/\./g, '(-)')
              }
            }}},[_vm._v("\n            CLIQUE AQUI\n          ")])],1)])])],1)})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uxyW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ModalAlert',
  data: function data() {
    return {
      title: 'titulo',
      description: 'descrição',
      content: 'conteúdo'
    };
  },

  methods: {
    show: function show(_ref) {
      var title = _ref.title,
          description = _ref.description,
          content = _ref.content;

      this.title = title;
      this.description = description;
      this.content = Array.isArray(content) && content.length === 1 ? content.shift() : content;

      window.jQuery('#modal_alert').modal('show');
    },
    close: function close() {
      window.jQuery('#modal_alert').modal('hide');
    }
  }
});

/***/ }),

/***/ "v0+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"role":"side-modal"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.aberto),expression:"aberto"}],attrs:{"id":"overlay"},on:{"click":function($event){return _vm.fecha(_vm.id)}}})]),_vm._v(" "),_c('div',{staticClass:"side",attrs:{"id":_vm.id}},[_c('div',{staticClass:"side-content"},[_c('div',{staticClass:"side-header"},[_c('div',{staticClass:"side-close",attrs:{"aria-label":"Close"},on:{"click":function($event){return _vm.fecha(_vm.id)}}},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"side-title",attrs:{"id":(_vm.id + "-label")}},[_vm._v(_vm._s(_vm.tit))])]),_vm._v(" "),_c('div',{staticClass:"side-subtitle",attrs:{"id":(_vm.id + "-sublabel")}},[_vm._v(_vm._s(_vm.subtit)+"\n                "),_c('p',[_vm._v(_vm._s(_vm.subtDetl))])]),_vm._v(" "),_vm._t("default")],2)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-close-circle"},[_c('div',{staticClass:"side-close-x"},[_c('div',{staticClass:"side-close-x1"}),_vm._v(" "),_c('div',{staticClass:"side-close-x2"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v9fZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vAZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardLG__ = __webpack_require__("P4Ur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnoBase__ = __webpack_require__("FsUo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__("FMx0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AutoComplete__ = __webpack_require__("cQ3+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CheckboxGroup__ = __webpack_require__("vZR2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CSVImport__ = __webpack_require__("ZquW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DataTablePublic__ = __webpack_require__("+Mmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Datepicker__ = __webpack_require__("eOZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FilterBar__ = __webpack_require__("Z2MM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormMessage__ = __webpack_require__("GX8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modal__ = __webpack_require__("2iX2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ModalAlert__ = __webpack_require__("NH9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PrintTable__ = __webpack_require__("lr95");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PublicHeader__ = __webpack_require__("2J0+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Select__ = __webpack_require__("MGJx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SelectReferenceDate__ = __webpack_require__("3zzW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SelectScaleType__ = __webpack_require__("8gNu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__SelectTime__ = __webpack_require__("cWdo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TimeCell__ = __webpack_require__("U8qx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__TimeSpan__ = __webpack_require__("Nn/W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__InputErrorMessage__ = __webpack_require__("e5l/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PDFImport__ = __webpack_require__("lQJE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__side_modal__ = __webpack_require__("fc38");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DoughnutChart__ = __webpack_require__("xVH2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ValorDestaqueHeader__ = __webpack_require__("FIhL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__LineChart2__ = __webpack_require__("9ICf");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_27__LineChart2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__BarChart__ = __webpack_require__("yd/Z");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_28__BarChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__PieChart__ = __webpack_require__("i94k");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_29__PieChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__LineChart__ = __webpack_require__("IGK6");
/* unused harmony namespace reexport */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__PublicHeader__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__CardLG__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__AnoBase__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__NoApiTable__["a"]; });
/* unused harmony reexport AutoComplete */
/* unused harmony reexport CheckboxGroup */
/* unused harmony reexport CSVImport */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_7__DataTable__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__DataTablePublic__["a"]; });
/* unused harmony reexport Datepicker */
/* unused harmony reexport FilterBar */
/* unused harmony reexport FormMessage */
/* unused harmony reexport Modal */
/* unused harmony reexport ModalAlert */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_23__PDFImport__["a"]; });
/* unused harmony reexport PrintTable */
/* unused harmony reexport Select */
/* unused harmony reexport SelectReferenceDate */
/* unused harmony reexport SelectScaleType */
/* unused harmony reexport SelectTime */
/* unused harmony reexport TimeCell */
/* unused harmony reexport TimeSpan */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_22__InputErrorMessage__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_24__side_modal__["a"]; });
/* unused harmony reexport DoughnutChart */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_26__ValorDestaqueHeader__["a"]; });



































/***/ }),

/***/ "vC4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return users; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_users__ = __webpack_require__("gGPC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_users_Save__ = __webpack_require__("Mfeo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_users_Associate__ = __webpack_require__("7qwS");




var users = [{
  path: 'users/list',
  component: __WEBPACK_IMPORTED_MODULE_0__views_admin_users__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}, {
  name: 'admin_users_save',
  path: 'users/save/:id?/:name?',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin_users_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}, {
  path: 'users/associate',
  component: __WEBPACK_IMPORTED_MODULE_2__views_admin_users_Associate__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}];

/***/ }),

/***/ "vQyN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("bGai");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Detalhes',
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_2__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components__["b" /* Breadcrumb */],
    InfoDados: __WEBPACK_IMPORTED_MODULE_2__components__["B" /* InfoDados */],
    Downloads: __WEBPACK_IMPORTED_MODULE_2__components__["C" /* Downloads */],
    Graficos: __WEBPACK_IMPORTED_MODULE_2__components__["D" /* Graficos */],
    TabelaValores: __WEBPACK_IMPORTED_MODULE_2__components__["E" /* TabelaValores */]
  },
  data: function data() {
    return {
      imgPath: this.$root.$data.imgUrl,
      detalhes: {
        dado: {
          tipo: 'T'
        },
        eixos: [],
        bandeiras: [],
        tags: [],
        valores: [],
        secretarias: []
      },
      valores: []
    };
  },

  methods: {
    voltar: function voltar() {
      this.$router.go(-1);
    },
    fetchInfos: function fetchInfos(url, keyOrFunction) {
      var _this = this;

      var resFunction = typeof keyOrFunction === 'string' ? function (_ref) {
        var data = _ref.data;

        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).length > 0) {
          _this.detalhes[keyOrFunction] = data[keyOrFunction];
        }
      } : keyOrFunction;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get(url + this.$route.params.id).then(resFunction).catch(function (error) {
        console.log(error.response);
      });
    }
  },
  computed: {
    breadcrumblinks: function breadcrumblinks() {
      var baseRoute = this.$route.query.origem === 'dados-secretaria' ? '/listar/dados-secretaria' : '/listar/dados';

      return [{ label: 'Listagem', link: baseRoute }, { label: 'Detalhes' }];
    }
  },
  created: function created() {
    var _this2 = this;

    this.fetchInfos('detalhes/', function (_ref2) {
      var data = _ref2.data;

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).length) {
        var dado = data.dado,
            valores = data.valores;

        _this2.detalhes.dado = dado;
        _this2.detalhes.valores = valores;
      }
    });

    this.fetchInfos('detalhes/valores2/', function (_ref3) {
      var data = _ref3.data;

      _this2.valores = data;
    });

    this.fetchInfos('detalhes/secretarias/', function (_ref4) {
      var data = _ref4.data;

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).length > 0) {
        _this2.detalhes.secretarias = data.secretarias.map(function (secretaria) {
          return {
            codigo: secretaria.sigla,
            descricao: secretaria.sigla + ' - ' + secretaria.nome
          };
        });
      }
    });

    this.fetchInfos('detalhes/eixos/', 'eixos');
    this.fetchInfos('detalhes/bandeiras/', 'bandeiras');
    this.fetchInfos('detalhes/tags/', 'tags');
  },
  updated: function updated() {
    window.jQuery('[data-toggle="popover"]').popover({});
  }
});

/***/ }),

/***/ "vTiM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vVbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("bLdy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5145899c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Salf");
function injectStyle (ssrContext) {
  __webpack_require__("ol2m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5145899c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5145899c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vVtC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row despesas"},[_c('public-header',{attrs:{"title":'Despesa Resumida'}},[_c('div',{staticClass:"row"},[_c('ano-base')],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n          Aqui você encontra um resumo das despesas realizadas pela Prefeitura\n          Municipal de Santos.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          A Prefeitura Municipal de Santos, no ano de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.anoAtual))]),_vm._v(", fez uma previsão de despesas no valor de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.despesaAnualPrevista.atual))]),_vm._v(".\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Deste total, até o mês de\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.mes_base.nome))]),_vm._v(",\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.despesaAnualEmpenhada.atual))]),_vm._v("\n          foram empenhados¹,\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.despesaAnualLiquidada.atual))]),_vm._v("\n          foram liquidados² e\n          "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.despesaAnualPaga.atual))]),_vm._v("\n          foram pagos³.\n        ")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"destaque-header"},[_vm._v("1 - Empenho:")]),_vm._v(" é efetuada uma\n          reserva de dinheiro para pagamento de uma determinada dívida,\n          baseada no orçamento previsto. "),_c('br'),_vm._v(" "),_c('span',{staticClass:"destaque-header"},[_vm._v("2 - Liquidação:")]),_vm._v(" processo de\n          ateste de que o serviço foi executado ou o material entregue e que,\n          estando tudo certo, pode-se efetuar o pagamento."),_c('br'),_vm._v(" "),_c('span',{staticClass:"destaque-header"},[_vm._v("3 - Pagamento:")]),_vm._v(" efetivação do\n          pagamento da compra.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('line-chart',{ref:"despesas-linha",attrs:{"chart-data":_vm.graficoDespesaLinha,"gradiente":false,"options":_vm.graficoOptions}})],1)])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":'/receitas_despesas'}},[_vm._v("Receitas e Despesas")])],1),_vm._v(" "),_c('li',{},[_vm._v("Despesas")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"btn-group btn-group-toggle margem-bottom"},[_c('label',{staticClass:"btn btn-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo_operacao),expression:"tipo_operacao"}],attrs:{"type":"radio","name":"options","value":"ue","id":"option1","checked":""},domProps:{"checked":_vm._q(_vm.tipo_operacao,"ue")},on:{"change":function($event){_vm.tipo_operacao="ue"}}}),_vm._v("\n            Unidade Executora\n          ")]),_vm._v(" "),_c('label',{staticClass:"btn btn-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo_operacao),expression:"tipo_operacao"}],attrs:{"type":"radio","name":"options","value":"fs","id":"option2"},domProps:{"checked":_vm._q(_vm.tipo_operacao,"fs")},on:{"change":function($event){_vm.tipo_operacao="fs"}}}),_vm._v("\n            Função e Subfunção\n          ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"row"},_vm._l((_vm.listaCards),function(item){return _c('div',{key:item.nome,staticClass:"col-sm-6 col-md-4 card-base"},[_c('router-link',{attrs:{"to":{
              name: 'detalhe_grupo_despesa',
              params: { descricao: item.chave, operacao: _vm.tipo_operacao }
            }}},[_c('div',{staticClass:"card-despesa bg",style:({
                backgroundImage:
                  'url(' + __webpack_require__("U9j/")("./" + (item.ico)) + ')'
              })},[_c('div',{staticClass:"context"},[_c('h3',{staticClass:"small"},[_vm._v(_vm._s(item.nome))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.vl_previsto))])])])])],1)}),0)])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h2',[_vm._v("Previsão de Gastos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vWku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("+jtw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_932d4cfe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("kYpN");
function injectStyle (ssrContext) {
  __webpack_require__("CqLP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-932d4cfe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_932d4cfe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vZR2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroup_vue__ = __webpack_require__("7j7X");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecc60e1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxGroup_vue__ = __webpack_require__("U/ps");
function injectStyle (ssrContext) {
  __webpack_require__("5hKR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ecc60e1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecc60e1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "vcwe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eleicao-conselho"},[_c('div',{staticClass:"row"},[_c('public-header',{staticClass:"public-header",attrs:{"title":'Detalhes do Candidato'}},[_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-3"},[_c('img',{attrs:{"src":_vm.candidato.url_foto,"alt":"Imagem do candidato a conselheiro tutelar"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-8 col-md-9"},[_c('p',{attrs:{"id":"dados-candidato"}},[_vm._v("\n          "+_vm._s(_vm.candidato.posicao)+"º COLOCADO"),_c('br'),_vm._v("\n          "+_vm._s(_vm.candidato.numero)+" - "+_vm._s(_vm.candidato.nome)),_c('br'),_vm._v("\n          "+_vm._s(_vm.candidato.total_votos.toLocaleString())+" votos no total"),_c('br'),_vm._v("\n          "+_vm._s((
              (Number(_vm.candidato.total_votos) / _vm.total_votos.total_nominais) *
              100
            ).toFixed(2))+"\n          % dos votos nominais\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.votos),function(voto,index){return _c('div',{key:("votos-" + index),staticClass:"col-xs-12 col-md-6",class:'wrapper-secao'},[_c('router-link',{attrs:{"to":{
            name: 'secao_conselho',
            params: {
              secao: voto.numero
            }
          }}},[_c('h4',[_vm._v("Seção "+_vm._s(voto.numero))])]),_vm._v(" "),_c('p',{staticClass:"detalhes-secao"},[_c('span',[_vm._v("Unidade:")]),_vm._v(" "+_vm._s(voto.unidade)),_c('br'),_vm._v("\n          "+_vm._s(voto.endereco)),_c('br'),_vm._v(" "),_c('span',[_vm._v("Votos Nominais:")]),_vm._v("\n          "+_vm._s(voto.total_nominais.toLocaleString())),_c('br'),_vm._v(" "),_c('span',[_vm._v("Votos Recebidos:")]),_vm._v("\n          "+_vm._s(_vm.findVotoCandidato(voto).total_votos.toLocaleString())+"\n          ("+_vm._s((
              (_vm.findVotoCandidato(voto).total_votos / voto.total_nominais) *
              100
            ).toFixed(2))+"\n          %)"),_c('br')])],1)})],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n          Votos por Seção\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vkGC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Paginacao_vue__ = __webpack_require__("LjSF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12cbb882_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Paginacao_vue__ = __webpack_require__("UCz5");
function injectStyle (ssrContext) {
  __webpack_require__("I9gH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12cbb882"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Paginacao_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12cbb882_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Paginacao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vm0W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"import_dado"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row margem-bottom"},[_c('div',{staticClass:"col-xs-12"},[_c('upload',{attrs:{"separador":';'},on:{"loadCSV":_vm.loadCSV}})],1)]),_vm._v(" "),(_vm.model.body.length)?_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('data-table',{attrs:{"dados":_vm.model.body,"fields":_vm.fields}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 margem-bottom"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":function($event){$event.preventDefault();return _vm.salvar()}}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n        Salvar\n      ")],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',{staticClass:"page-header"},[_vm._v("Importar Dados")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Pré Visualização")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vuGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_1__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components__["b" /* Breadcrumb */],
    TheMask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["TheMask"],
    InputErrorMessage: __WEBPACK_IMPORTED_MODULE_1__components__["l" /* InputErrorMessage */],
    EstatisticaTotalAgendamentos: __WEBPACK_IMPORTED_MODULE_1__components__["m" /* EstatisticaTotalAgendamentos */]
    // EstatisticaTempoMedio
  },
  data: function data() {
    return {
      conectSusSrc: __webpack_require__("c/cq"),
      filtroCartao: '',
      especialidades: [],
      exames: [],
      model: {
        especialidade: '',
        exame: ''
      },
      loading: {
        especialidades: true,
        exames: true
      },
      breadcrumb: [{
        label: 'Minha Saúde'
      }]
    };
  },
  created: function created() {
    this.fetchDataBykey('especialidades');
    this.fetchDataBykey('exames');
  },

  methods: {
    routeToPage: function routeToPage(page) {
      if (this.model[page]) {
        this.$router.push({
          name: 'procedimentos_por_' + page,
          params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, page, this.model[page])
        });
      }
    },
    pesquisarPorCartao: function pesquisarPorCartao() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this.$refs[_this.$validator.errors.items[0].field].$el.focus();
          _this.$toastr.e(_this.$validator.errors.items[0].msg);
          return;
        }

        _this.$router.push({
          name: 'procedimentos_por_cartao',
          params: { cartao: _this.filtroCartao }
        });
      });
    },
    fetchDataBykey: function fetchDataBykey(key) {
      var _this2 = this;

      this.loading[key] = true;
      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('procedimentos-saude/' + key).then(function (response) {
        var data = response.data;

        _this2[key] = data;
      }).catch(function (error) {
        var response = error.response;

        console.log(response);
        _this2.$toastr.e('Houve um errro ao carregar ' + key + '. Atualize a p\xE1gina e tente novamente');
      }).finally(function () {
        return _this2.loading[key] = false;
      });
    }
  }
});

/***/ }),

/***/ "vwEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("UcRr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faa166f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("pQJU");
function injectStyle (ssrContext) {
  __webpack_require__("Rfwc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-faa166f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faa166f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vwPJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w/Lh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w4jo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w9xy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HabilitadoTable__ = __webpack_require__("63id");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { DataTable: __WEBPACK_IMPORTED_MODULE_3__components_common_NoApiTable__["a" /* default */], HabilitadoTable: __WEBPACK_IMPORTED_MODULE_4__components_HabilitadoTable__["a" /* default */] },
  data: function data() {
    return {
      cargo: {},
      cargos: [],
      edital: {
        id: 0,
        numero: null
      },
      habilitados: [],
      isLoading: false,
      fields: [{
        name: '__slot:input',
        title: '#',
        dataClass: 'text-center'
      }, {
        name: 'descricao',
        title: 'Descrição'
      }, {
        name: 'vagas',
        title: 'Vagas'
      }, {
        name: 'vagas_pcd',
        title: 'Vagas PCD'
      }, {
        name: 'vagas_cotas',
        title: 'Vagas Cotas'
      }, {
        name: 'vagas_QP',
        title: 'Vagas QP'
      }, {
        name: '__slot:actions',
        title: 'Visualizar',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }]
    };
  },
  created: function created() {
    this.edital = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.params.edital);

    if (_.isEmpty(this.edital)) {
      this.$router.push('/admin/concursos/edital');
    } else {
      this.listarCargosEdital();
      this.listarHabilitadosEdital();
    }
  },

  methods: {
    selecionarHabilitadosCargo: function selecionarHabilitadosCargo(item) {
      this.cargo = item;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["o" /* scrollToElement */])('lista-habilitados');
    },
    listarCargosEdital: function listarCargosEdital() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('cargo', { params: { edital_id: this.edital.id } }).then(function (response) {
        _this.cargos = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    filter: function filter(key) {
      var _this2 = this;

      return function (item) {
        return item[key] === 1 && item['descricao'] === _this2.cargo.descricao;
      };
    },
    listarHabilitadosEdital: function listarHabilitadosEdital() {
      var _this3 = this;

      this.handleLoading();
      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('habilitado', { params: { edital_id: this.edital.id } }).then(function (response) {
        _this3.habilitados = response.data;
      }).catch(function (error) {
        return console.log(error.response);
      }).finally(this.handleLoading);
    },
    handleLoading: function handleLoading() {
      this.isLoading = !this.isLoading;
    }
  },
  computed: {
    habilitadosGeral: function habilitadosGeral() {
      return this.habilitados.filter(this.filter('tipo_normal'));
    },
    habilitadosPCD: function habilitadosPCD() {
      return this.habilitados.filter(this.filter('tipo_pcd'));
    },
    habilitadosCotas: function habilitadosCotas() {
      return this.habilitados.filter(this.filter('tipo_cotas'));
    }
  }
});

/***/ }),

/***/ "wCRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalheUnidade_vue__ = __webpack_require__("Jdug");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aefb3c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalheUnidade_vue__ = __webpack_require__("QMwt");
function injectStyle (ssrContext) {
  __webpack_require__("YgrM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7aefb3c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetalheUnidade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7aefb3c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetalheUnidade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wM/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Modal__ = __webpack_require__("2iX2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vereadores',
  inject: ["showConfirm"],
  data: function data() {
    return {
      fields: [{
        name: 'nome',
        title: 'Nome',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-2',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_2__components_common_Modal__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  computed: {
    filtros: function filtros() {
      var nome = this.nome;


      return {
        nome: nome
      };
    },

    pagina: {
      get: function get() {
        var vereadores = this.$store.state.vuetableState.vereadores;
        var pagina = vereadores.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'vereadores',
          value: value
        });
      }
    },
    nome: {
      get: function get() {
        var vereadores = this.$store.state.vuetableState.vereadores;
        var nome = vereadores.filtros.nome;

        return nome;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'vereadores',
          value: value
        });
        this.resetPageStore();
      }
    }
  },
  methods: {
    editar: function editar(data) {
      var id = data.id;

      this.$router.push({
        name: 'user_salvar_vereador',
        params: { id: id }
      });
    },
    excluir: function excluir(data) {
      var me = this;
      var id = data.id;


      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].delete('vereador/' + id).then(function (resp) {
            me.consultar();
            me.$toastr.s('Vereador removido com sucesso!');
          }).catch(function (error) {
            me.$toastr.e('Houve uma falha ao tentar remover esse item, por favor, tente novamente mais tarde!');
          });
        }
      };

      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    consultar: function consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    limpar: function limpar() {
      this.nome = '';
      this.$nextTick(function () {
        this.$refs.vuetable.refresh();
      });
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'vereadores',
        value: 1
      });
    }
  }
});

/***/ }),

/***/ "wM2B":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG8AAAAoCAMAAADHRlSGAAAAflBMVEVHcEz6vRAxd5IoZK8odpQnY676vRD5vRAoZK0oZK4oY65GrUQlZa8nZqonY64oY677vRAmY6//vxD6vRBErUP6vxD8vBAnZK5FrURFrUNFrEMnY676vRAoYq35vBD/vxBFqkZFrENErUT4vBBGrEOhtCnXuRooZK76vRBGrUSZ2+N1AAAAJ3RSTlMA1iBAEPDwwYDAoH8wcNDgf1AQZGcwRbDA2piQkGCwILDwOKNQnYto80LJAAAC+klEQVRYw+2X2ZqbMAxGzW4zEAIEyEYWMi3p+79gsS3JZpu5aXLRb3SFE1knkn8Jh7F/Y702zt5kP7wf3v/ESzzPS97F83mmvLN2WAi9E76qz85TWrSt5PJD2w53drg2PDeVEbI4Vw7lVpl8isLn05Gf5UGPtvFHvK2GaXNqxm5/tPnAg/WH4XEKJqRTpPeyQkeSvLa3LPMNr7Jp0i7FJ/AwwbteusSLrViBa3gQKhryD2xe3xCvCp9TcwoAHDUO8Hs6v3GsoVrAK5/Ea/pFY8UcNwCPmnDXvCNluxyEIy8knktfxmkam9/HHuASlnVRnxH4GwraKd6BTtOqohAZLfxociIsRTfVDe4GPSvEVVqnuDygQqS3Ka751fILDNqnhnepr+x6pXJC59BpYkYlKAPXvzTjID/b6edPixdrbwQK4mEcTAgVjgIDQYXYaVfY97A64mbOsp+EwZJGVMjxYNjgGrvDCAoMjjzak0Z8S6uYD3qfJrxqwiNHb8zbEg92RlDEG3VDtzTP+JgXsrX88m94jn/HKh7NSX7HM2XCQrPJ+a3WE5uug27Y2bxmpZ4mDIyTvoXRHYz14sz0gmU8djjLLF7AJjKc8TgNTrWkaYP6r8Fva3St8zrs8BxtfaZjFYgZL6G5kPssF/20351CueEwDQuaYlDOvBGp4QWeqhKmd5rxKPPp/EQlO0NGRRla+oGxomXDtdrMxjj3TjQW3TnPW+FdF+d1YY1NVU4o43KQhs15JKXxTjMyLYNhujM8cEdVi1GswF/iMfsdGTPTH/U0QwemhE+4A1QHVTd6mcpXwBKPediEWY7vJ9X/xcMmhqb38VoxzLKNjoy/MjFyCHK2whtUymPR8NzMF5hvRXnRSOdRWu7dHsxVb7AhMlXFT+HuxVWDnSNl59W7mpgMCtnqdfHV7c5NZndL/uXd0rWe23HfvuZuDHdFeRHF4icvvouLmPOTUbN4IW6p4b338k7srbzX/qtKssnQS9iLzW25EIG6qvLWfynqL/r5D/3pBzTJAAAAAElFTkSuQmCC"

/***/ }),

/***/ "wOM0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/brasao-cor-branco-vertical.68b0698.svg";

/***/ }),

/***/ "wUSq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListValue_vue__ = __webpack_require__("/jvO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7ea0332_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListValue_vue__ = __webpack_require__("J7Oz");
function injectStyle (ssrContext) {
  __webpack_require__("KmBR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7ea0332"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListValue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7ea0332_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListValue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wexX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabelaValores_vue__ = __webpack_require__("6hxu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d83e4854_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabelaValores_vue__ = __webpack_require__("n96d");
function injectStyle (ssrContext) {
  __webpack_require__("ykgm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d83e4854"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabelaValores_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d83e4854_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabelaValores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wkq0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),

/***/ "wlNL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dados; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_admin_dados__ = __webpack_require__("6JGi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_dados_Save__ = __webpack_require__("d1yX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_admin_dados_Moderation__ = __webpack_require__("1KE0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_admin_dados_values__ = __webpack_require__("nAL6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_admin_dados_values_Save__ = __webpack_require__("CWdf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_admin_dados_user_List__ = __webpack_require__("QALr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_admin_dados_user_ListValue__ = __webpack_require__("wUSq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_admin_dados_user_ValueSave__ = __webpack_require__("kfu5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_admin_dados_Import__ = __webpack_require__("9l6s");













var dados = [{
  path: 'dado/import',
  component: __WEBPACK_IMPORTED_MODULE_8__views_admin_dados_Import__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  path: 'user/dado/list',
  component: __WEBPACK_IMPORTED_MODULE_5__views_admin_dados_user_List__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_dado_valor_list',
  path: 'user/dado/valor/list/:DAD_IDDADO',
  component: __WEBPACK_IMPORTED_MODULE_6__views_admin_dados_user_ListValue__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'user_dado_valor_save',
  path: 'user/dado/valor/save/:DAD_IDDADO/:DVA_IDDADOVALOR?',
  component: __WEBPACK_IMPORTED_MODULE_7__views_admin_dados_user_ValueSave__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'dados_list',
  path: 'dado/list',
  component: __WEBPACK_IMPORTED_MODULE_0__views_admin_dados__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: false
  }
}, {
  name: 'admin_dado_save',
  path: 'dado/save/:id?',
  component: __WEBPACK_IMPORTED_MODULE_1__views_admin_dados_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}, {
  name: 'admin_dado_moderacao',
  path: 'dado/moderacao',
  component: __WEBPACK_IMPORTED_MODULE_2__views_admin_dados_Moderation__["a" /* default */],
  meta: {
    requiresAuth: true,
    userAuth: true
  }
}, {
  name: 'admin_dado_valor_list',
  path: '/dado/valor/list/:DAD_IDDADO?',
  component: __WEBPACK_IMPORTED_MODULE_3__views_admin_dados_values__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}, {
  name: 'admin_dado_valor_save',
  path: 'dado/valor/save/:DAD_IDDADO/:DVA_IDDADOVALOR?',
  component: __WEBPACK_IMPORTED_MODULE_4__views_admin_dados_values_Save__["a" /* default */],
  meta: {
    requiresAuth: true,
    adminAuth: true
  }
}];

/***/ }),

/***/ "wofJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emendas-por-area"},[_c('div',{staticClass:"row"},[_c('PublicHeader',{attrs:{"title":'Emendas Por Secretaria'}},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('p',[_vm._v("\n          Aqui você encontra as secretarias que receberam emendas\n          parlamentares da Câmara Municipal de Santos, seus valores totais e a\n          quantidade de emendas recebidas.\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          No ano de "),_c('SelectAnoEmendas'),_vm._v(",\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.secretariasComEmendas.length,"isLoading":_vm.loading}}),_vm._v("\n          secretarias receberam emendas parlamentares de\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.vereadoresComEmendas.length,"isLoading":_vm.loading}}),_vm._v("\n          vereadores, totalizando\n          "),_c('ValorDestaqueHeader',{attrs:{"value":_vm.formatarMoeda(_vm.valorTotalEmendas),"isLoading":_vm.loading}}),_vm._v("\n          em emendas. Veja abaixo mais informações sobre as secretarias.\n        ")],1)])])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('Breadcrumb',{attrs:{"links":_vm.breadcrumb}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.listaCards),function(item){return _c('div',{key:item.nome,staticClass:"col-xs-12 col-sm-6 col-md-4 card-base"},[_c('CardEmendas',{attrs:{"item":item}})],1)}),0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row form-group"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Total recebido em emendas por secretaria")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x/Qh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pendentes_vue__ = __webpack_require__("EIPb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca6a208_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pendentes_vue__ = __webpack_require__("ikgP");
function injectStyle (ssrContext) {
  __webpack_require__("mOIY")
  __webpack_require__("lp1m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ca6a208"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pendentes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca6a208_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pendentes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x/tY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedCount)?_c('div',{staticClass:"faixa-comparacao"},[_c('span',{staticClass:"text-lg"},[_vm._v("\n    "+_vm._s(_vm.selectedCount === 1
        ? 'Selecione ao menos 2 dados para comparação'
        : (_vm.selectedCount + " dados selecionados"))+"\n  ")]),_vm._v(" "),(_vm.selectedCount > 1)?_c('router-link',{staticClass:"btn btn-default",attrs:{"title":"Comparar Dados","to":{
      name: 'public_comparar',
      params: { ids: _vm.idsArray.join(',') }, 
      query: { origem: _vm.query }     
    }}},[_vm._v("\n    Comparar "+_vm._s(_vm.selectedCount)+" dados\n  ")]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x0vE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("XOAW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7838be8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("nNvT");
function injectStyle (ssrContext) {
  __webpack_require__("Wz7f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7838be8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7838be8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x3LP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("mSLM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_239dc672_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("7ERm");
function injectStyle (ssrContext) {
  __webpack_require__("uSDW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-239dc672"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_239dc672_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x5FH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-md-offset-4"},[_c('div',{staticClass:"login-panel panel panel-success"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('form',{attrs:{"role":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.username),expression:"model.username"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"username",class:[
                    'form-control',
                    { 'is-danger': _vm.errors.has('username') }
                  ],attrs:{"name":"username","type":"text","placeholder":"Usuário"},domProps:{"value":(_vm.model.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "username", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('username')),expression:"errors.has('username')"}],staticClass:"is-danger"},[_c('i',{staticClass:"fa fa-warning"}),_vm._v("\n                  O campo usuário é obrigatório\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"password",class:[
                    'form-control',
                    { 'is-danger': _vm.errors.has('password') }
                  ],attrs:{"placeholder":"Senha","name":"password","type":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"is-danger"},[_c('i',{staticClass:"fa fa-warning"}),_vm._v("\n                  O campo senha é obrigatório\n                ")])]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.usuarioExterno),expression:"model.usuarioExterno"}],ref:"usuarioExterno",attrs:{"type":"checkbox","name":"usuarioExterno"},domProps:{"checked":Array.isArray(_vm.model.usuarioExterno)?_vm._i(_vm.model.usuarioExterno,null)>-1:(_vm.model.usuarioExterno)},on:{"change":function($event){var $$a=_vm.model.usuarioExterno,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "usuarioExterno", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "usuarioExterno", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "usuarioExterno", $$c)}}}}),_vm._v("Usuário externo\n                ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-block",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"submit","disabled":_vm.requestPendente}},[_vm._v("\n                Acessar\n              ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Dados Abertos - Admin")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x9ll":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xA6P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    erro: {
      type: String
    }
  }
});

/***/ }),

/***/ "xCIE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xDod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Processos de Pagamento")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12"},[_c('list',{ref:"vuetable",attrs:{"show-empty":true,"title":"Lista de processos de pagamento","report-title":"Processos de pagamento","initial-page":_vm.pagina,"api-url":"processospagamento","fields":_vm.fields,"pageCollection":'processos_pagamento',"append-params":_vm.filtros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.editar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)]}}])},[_c('template',{slot:"filters"},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"primary",attrs:{"for":"numero_pagamento_filter"}},[_vm._v("Número")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numero_pagamento),expression:"numero_pagamento"}],staticClass:"form-control",attrs:{"type":"text","name":"numero_pagamento_filter"},domProps:{"value":(_vm.numero_pagamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numero_pagamento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"primary",attrs:{"for":"valor_filter"}},[_vm._v("Valor")]),_vm._v(" "),_c('money',_vm._b({ref:"money",staticClass:"form-control",attrs:{"type":"text","name":"valor_filter"},model:{value:(_vm.valor),callback:function ($$v) {_vm.valor=$$v},expression:"valor"}},'money',_vm.money,false))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{staticClass:"primary",attrs:{"for":"emenda_filter"}},[_vm._v("Número da emenda")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emenda),expression:"emenda"}],staticClass:"form-control",attrs:{"type":"text","name":"emenda_filter"},domProps:{"value":(_vm.emenda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emenda=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnFiltrar"},on:{"click":function($event){return _vm.consultar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v("\n                  Filtrar\n                ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default margem-topo",attrs:{"name":"btnLimpar"},on:{"click":function($event){return _vm.limpar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v("\n                  Limpar Filtros\n                ")],1)])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":{ name: 'user_salvar_processospagamento' }}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v("\n              Adicionar\n            ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)],1)],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xFXY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h1',{staticClass:"page-header"},[_vm._v("Associar usuários e dados")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Selecione o usuário")]),_vm._v(" "),_c('v-select',{ref:"usuario-ativo",attrs:{"clearable":false,"getOptionLabel":function (option) { return ((option.nome) + " - " + ((option.email || ''))); },"reduce":function (user) { return user.codigo; },"placeholder":"PESQUISE O NOME DO USUÁRIO AQUI...","options":_vm.users,"selectOnTab":true},on:{"input":function($event){return _vm.selectUser(_vm.userActive)}},model:{value:(_vm.userActive),callback:function ($$v) {_vm.userActive=$$v},expression:"userActive"}},[_c('template',{slot:"no-options"},[_vm._v("\n              Usuário não encontrado...\n            ")])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 form-group"},[_c('button',{staticClass:"btn btn-default",on:{"click":_vm.newUser}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar usuários\n        ")],1)]),_vm._v(" "),_vm._l((Object.keys(_vm.otherUsers)),function(item){return _c('section',{key:item},[_c('div',{staticClass:"col-xs-12 form-group"},[_c('label',[_vm._v("Selecione o usuário")]),_vm._v(" "),_c('v-select',{ref:"outros-usuarios",refInFor:true,attrs:{"getOptionLabel":function (option) { return ((option.nome) + " - " + ((option.email || ''))); },"reduce":function (user) { return user.codigo; },"placeholder":'Selecione o usuário',"options":_vm.users,"selectOnTab":true},model:{value:(_vm.otherUsers[item]),callback:function ($$v) {_vm.$set(_vm.otherUsers, item, $$v)},expression:"otherUsers[item]"}},[_c('template',{slot:"no-options"},[_vm._v("\n              Usuário não encontrado...\n            ")])],2)],1)])}),_vm._v(" "),(_vm.multiplosUsuarios.length > 0)?_c('div',{staticClass:"col-xs-12 form-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":_vm.associarDados}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v("\n          "+_vm._s(_vm.carregando ? 'Associando...' : 'Associar aos usuários ')+"\n        ")],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('list',{ref:"dt_associado",attrs:{"show-empty":true,"show-print-button":false,"show-column-visibility-button":false,"load-on-start":false,"title":"Dados associados","api-url":"dado/listbyuser","report-title":"Dados associados","fields":_vm.columns,"pageCollection":'dadosAssociados',"initial-page":_vm.paginaAssociados,"appendParams":_vm.associadoFiltros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Desassociar"},on:{"click":function($event){return _vm.desassociar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'times'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('fieldset',{attrs:{"disabled":!_vm.userActive}},[_c('div',{staticClass:"collapse",attrs:{"id":"filtros"}},[_c('div',{staticClass:"col-xs-12 form-group"},[_c('label',{attrs:{"for":"username_filter"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.associadoNome),expression:"associadoNome"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.associadoNome)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.loadDadosAssociados()},"input":function($event){if($event.target.composing){ return; }_vm.associadoNome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.loadDadosAssociados()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtrar\n                  ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.limparDadoAssociado()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v(" Limpar Filtros\n                  ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.carregando},on:{"click":_vm.desassociarTodos}},[(_vm.carregando)?_c('font-awesome-icon',{attrs:{"icon":'spinner',"spin":""}}):_c('font-awesome-icon',{attrs:{"icon":'times'}}),_vm._v("\n                    "+_vm._s(_vm.carregando ? 'Desassociando...' : 'Desassociar tudo')+"\n                  ")],1)])])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('list',{ref:"dt_associar",attrs:{"show-empty":true,"load-on-start":false,"show-print-button":false,"show-column-visibility-button":false,"title":"Dados para associar","api-url":"dado/list-associate-user","report-title":"Dados por usuário","fields":_vm.columns,"pageCollection":'dadosParaAssociar',"initial-page":_vm.paginaParaAssociar,"appendParams":_vm.associarFiltros},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-success",attrs:{"title":"Associar","type":"button"},on:{"click":function($event){return _vm.associar(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}})],1)])]}}])},[_c('template',{slot:"filters"},[_c('fieldset',{attrs:{"disabled":!_vm.userActive}},[_c('div',{staticClass:"collapse",attrs:{"id":"associar-filtros"}},[_c('div',{staticClass:"col-xs-12 form-group"},[_c('label',{attrs:{"for":"username_filter"}},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.associarNome),expression:"associarNome"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.associarNome)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.loadDadosAssociar()},"input":function($event){if($event.target.composing){ return; }_vm.associarNome=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 form-group"},[_c('label',[_vm._v("Unidade")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.associarSecretaria),expression:"associarSecretaria"}],ref:"secretaria_codigo_filter",staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.associarSecretaria=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.loadDadosAssociar()}]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Selecione a unidade")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Secretarias"}},_vm._l((_vm.secretarias),function(s){return _c('option',{key:s.codigo,attrs:{"title":s.nome},domProps:{"value":s.codigo}},[_vm._v("\n                        "+_vm._s(s.sigla)+"\n                      ")])}),0),_vm._v(" "),_c('optgroup',{attrs:{"label":"Autarquias"}},_vm._l((_vm.autarquias),function(a){return _c('option',{key:a.codigo,attrs:{"title":a.nome},domProps:{"value":a.codigo}},[_vm._v("\n                        "+_vm._s(a.sigla)+"\n                      ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.loadDadosAssociar()}}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtrar\n                  ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.limparDadoAssociar()}}},[_c('font-awesome-icon',{attrs:{"icon":'eraser'}}),_vm._v(" Limpar Filtros\n                  ")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":_vm.associarTodos}},[_c('font-awesome-icon',{attrs:{"icon":'save'}}),_vm._v(" Adicionar Todos\n                  ")],1)])])])]),_vm._v(" "),_c('template',{slot:"actions"},[_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"collapse","data-target":"#associar-filtros"}},[_c('font-awesome-icon',{attrs:{"icon":'filter'}}),_vm._v(" Filtros\n            ")],1)])],2)],1)],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  watch: {
    $route: function $route() {
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),

/***/ "xSGT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__ = __webpack_require__("uvmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Modal__ = __webpack_require__("2iX2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'metas',
  inject: ["showConfirm"],
  data: function data() {
    return {
      fields: [{
        name: '__slot:icon',
        title: 'Logo',
        dataClass: 'align-middle'
      }, {
        name: 'MET_DCTITULO',
        sortField: 'MET_DCTITULO',
        title: 'Título',
        dataClass: 'align-middle',
        filterable: false
      }, {
        name: 'MET_DLOBJETIVO',
        sortField: 'MET_DLOBJETIVO',
        title: 'Objetivo',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: 'MET_NRNUMERO',
        sortField: 'MET_NRNUMERO',
        title: 'Número',
        dataClass: 'align-middle',
        filterable: true
      }, {
        name: '__slot:actions',
        title: 'Ações',
        titleClass: 'text-center col-md-3',
        dataClass: 'text-center'
      }]
    };
  },

  components: {
    list: __WEBPACK_IMPORTED_MODULE_0__components_common_DataTable__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_2__components_common_Modal__["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },

  methods: {
    editar: function editar(data) {
      this.$router.push({
        name: 'admin_metas_save',
        params: { MET_IDMETA: data.MET_IDMETA }
      });
    },
    excluir: function excluir(data) {
      var dt = this.$refs.vuetable;
      data.type = 'META';

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('meta/delete', data).then(function () {
            return dt.refresh();
          }).catch(function (e) {
            console.log(e + ' | Houve um error ao tentar excluir esta meta, por favor tente novamente mais tarde.');
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este item?', config);
    },
    concateImgPathWith: function concateImgPathWith(fileImage) {
      return this.$root.$data.imgUrl + fileImage + '?' + new Date().getTime();
    },
    consultar: function consultar() {
      this.$refs.vuetable.refresh();
    },
    limpar: function limpar() {
      this.MET_DCTITULO = '';
      this.MET_DLOBJETIVO = '';
      this.$refs.vuetable.refresh();
    },
    resetPageStore: function resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'metas',
        value: 1
      });
    }
  },
  computed: {
    filtros: function filtros() {
      var MET_DCTITULO = this.MET_DCTITULO,
          MET_DLOBJETIVO = this.MET_DLOBJETIVO;

      return {
        MET_DCTITULO: MET_DCTITULO,
        MET_DLOBJETIVO: MET_DLOBJETIVO
      };
    },

    pagina: {
      get: function get() {
        var metas = this.$store.state.vuetableState.metas;
        var pagina = metas.pagina;

        return pagina;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'metas',
          value: value
        });
      }
    },
    MET_DCTITULO: {
      get: function get() {
        var metas = this.$store.state.vuetableState.metas;
        var MET_DCTITULO = metas.filtros.MET_DCTITULO;


        return MET_DCTITULO;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'MET_DCTITULO',
          collection: 'metas',
          value: value
        });
        this.resetPageStore();
      }
    },
    MET_DLOBJETIVO: {
      get: function get() {
        var metas = this.$store.state.vuetableState.metas;
        var MET_DLOBJETIVO = metas.filtros.MET_DLOBJETIVO;


        return MET_DLOBJETIVO;
      },
      set: function set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'MET_DLOBJETIVO',
          collection: 'metas',
          value: value
        });
        this.resetPageStore();
      }
    }
  }
});

/***/ }),

/***/ "xVH2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels__ = __webpack_require__("cNRp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels__);



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["e" /* Doughnut */],
  mixins: [reactiveProp],
  data: function data() {
    return {};
  },

  props: {
    options: {
      type: Object
    },
    gradiente: {
      type: Boolean,
      default: true
    },
    coloredLine: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.$refs.canvas) {
      this.addPlugin(__WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_datalabels___default.a);
      this.renderChart(this.chartData, this.options);
      this.htmlLegend = this.generateLegend();
    }
  },

  methods: {
    montarCor: function montarCor(cor) {
      if (this.gradiente) {
        return this.gradient(cor);
      } else {
        return 'rgb(' + cor + ')';
      }
    },
    gradient: function gradient(color) {
      var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);

      gradient.addColorStop(0, 'rgba(' + color + ', 1)');
      gradient.addColorStop(0.5, 'rgba(' + color + ', 0.6)');
      gradient.addColorStop(1, 'rgba(' + color + ', 0.2)');

      return gradient;
    }
  },
  watch: {
    chartData: function chartData() {
      this.$data._chart.update();
    }
  }
});

/***/ }),

/***/ "xdfN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectAno_vue__ = __webpack_require__("DTf4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a4e0da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectAno_vue__ = __webpack_require__("YE+B");
function injectStyle (ssrContext) {
  __webpack_require__("7d86")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25a4e0da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectAno_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a4e0da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectAno_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xk7p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_DoughnutChart_js__ = __webpack_require__("xVH2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_colors_js__ = __webpack_require__("ZAg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__("0xDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_entidades_js__ = __webpack_require__("Sr7P");












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PDG',
  components: {
    doughnut: __WEBPACK_IMPORTED_MODULE_6__components_common_DoughnutChart_js__["a" /* default */],
    PublicHeader: __WEBPACK_IMPORTED_MODULE_9__components_common__["a" /* PublicHeader */]
  },
  data: function data() {
    return {
      metas: [],
      unidade: '',
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: true
        },
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            formatter: function formatter(value, ctx) {
              var sum = 0;
              var dataArr = ctx.chart.data.datasets[0].data;
              dataArr.map(function (data) {
                sum += data;
              });
              var percentage = (value * 100 / sum).toFixed(2) + '%';
              return percentage;
            },
            color: ['#000', '#FFF', '#000', '#FFF', '#FFF', '#FFF', '#000']
          }
        }
      }
    };
  },
  created: function created() {
    this.loadCompromissos();
  },

  computed: {
    total: function total() {
      return this.metas.length;
    },
    concluidas: function concluidas() {
      var concluidas = this.metas.filter(function (i) {
        return i.tipostatusplano === 'CONCLUÍDA';
      });
      return concluidas.length;
    },
    emAndamento: function emAndamento() {
      var emAndamento = this.metas.filter(function (i) {
        return i.tipostatusplano === 'EM ANDAMENTO';
      });
      return emAndamento.length;
    },
    naoCumpridas: function naoCumpridas() {
      var naoCumpridas = this.metas.filter(function (i) {
        return i.tipostatusplano === 'NÃO CUMPRIDA';
      });
      return naoCumpridas.length;
    },
    metasPorStatus: function metasPorStatus() {
      var _this = this;

      var status = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(this.metas.map(function (m) {
        return m.tipostatusplano;
      }))));
      var result = status.map(function (status) {
        return { status: status, total: _this.metas.filter(function (m) {
            return m.tipostatusplano === status;
          }).length };
      });

      return result;
    },
    metasSecretariaStatus: function metasSecretariaStatus() {
      if (unidade) return [];

      var metas = this.metas,
          unidade = this.unidade;

      var metasSecretaria = metas.filter(function (m) {
        return m.unidaderesponsavel === unidade;
      });

      var status = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(metasSecretaria.map(function (m) {
        return m.tipostatusplano;
      }))));
      var result = status.map(function (status) {
        return { status: status, total: metasSecretaria.filter(function (m) {
            return m.tipostatusplano === status;
          }).length };
      });

      return result;
    },
    secretarias: function secretarias() {
      var data = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(this.metas.map(function (m) {
        return m.unidaderesponsavel;
      }))));
      data.sort();

      this.unidade = data[0];

      return data;
    },
    secretariaSumario: function secretariaSumario() {
      var _this2 = this;

      var data = {
        total: 0,
        totalPorcentagem: 0,
        concluidas: 0,
        emAndamento: 0,
        naoCumpridas: 0,
        naoIniciadas: 0
      };

      if (!this.unidade) return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data);

      var metasSecretaria = this.metas.filter(function (m) {
        return m.unidaderesponsavel === _this2.unidade;
      });

      data.total = metasSecretaria.length;
      data.totalPorcentagem = (data.total / this.metas.length * 100).toFixed(2);
      data.concluidas = metasSecretaria.filter(function (i) {
        return i.tipostatusplano === 'CONCLUÍDA';
      }).length;
      data.emAndamento = metasSecretaria.filter(function (i) {
        return i.tipostatusplano === 'EM ANDAMENTO';
      }).length;
      data.naoCumpridas = metasSecretaria.filter(function (i) {
        return i.tipostatusplano === 'NÃO CUMPRIDA';
      }).length;
      data.naoIniciadas = metasSecretaria.filter(function (i) {
        return i.tipostatusplano === 'NÃO INFORMADA';
      }).length;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data);
    },
    secretariasTop6Metas: function secretariasTop6Metas() {
      var metasPorSecretaria = Object.groupBy(this.metas, function (_ref) {
        var unidaderesponsavel = _ref.unidaderesponsavel;
        return unidaderesponsavel;
      });
      var ranking = [];

      for (var sigla in metasPorSecretaria) {
        var count = metasPorSecretaria[sigla].length;

        var percentual = (count / this.metas.length * 100).toFixed(2);
        ranking.push({ sigla: sigla, count: count, percentual: percentual });
      }

      ranking.sort(function (a, b) {
        return b.total - a.total;
      });

      return ranking.slice(0, 6);
    },
    rankingConcluidas: function rankingConcluidas() {
      var metas = this.metas,
          entidadeBySigla = this.entidadeBySigla;

      var metasAgrupdasSecretaria = Object.groupBy(metas, function (_ref2) {
        var unidaderesponsavel = _ref2.unidaderesponsavel;
        return unidaderesponsavel;
      });
      var data = [];
      var totalMetas = 0;
      var totalConcluidas = 0;

      for (var sigla in metasAgrupdasSecretaria) {
        var metasSecretaria = metasAgrupdasSecretaria[sigla];
        var metasSecretariaConcluidas = metasSecretaria.filter(function (m) {
          return m.tipostatusplano === 'CONCLUÍDA';
        });

        var total = metasSecretaria.length;
        var concluidas = metasSecretariaConcluidas.length;

        var percentual = (concluidas / total * 100).toFixed(2);

        data.push({ sigla: sigla, secretaria: entidadeBySigla(sigla), total: total, concluidas: concluidas, percentual: percentual });

        totalMetas += total;
        totalConcluidas += concluidas;
      }

      data.sort(function (a, b) {
        return b.percentual - a.percentual;
      });

      return {
        data: data,
        totalMetas: totalMetas,
        totalConcluidas: totalConcluidas,
        totalPercentual: (totalConcluidas / totalMetas * 100).toFixed(2)
      };
    },
    link_externo: function link_externo() {
      return 'https://egov.santos.sp.gov.br/santosmapeada/Gestao/PlanoMunicipalGoverno/MapaPlanoMunicipalGoverno/montarMapaPlanoMunicipalGoverno/' + this.unidade.iduorre;
    }
  },
  methods: {
    loadCompromissos: function loadCompromissos() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref3, status, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__request__["a" /* request */].get('sigsantos/planogoverno');

              case 2:
                _ref3 = _context.sent;
                status = _ref3.status;
                data = _ref3.data;

                if (!(status != 200)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt('return', _this3.$toastr.e('Houve um problema ao tentar carregar os compromissos, tente novamente daqui alguns minutos!'));

              case 7:

                _this3.metas = data;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    createChartData: function createChartData(dados) {
      return {
        labels: [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(dados.map(function (_ref4) {
          var status = _ref4.status;
          return status;
        }))),
        datasets: [{
          data: [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(dados.map(function (_ref5) {
            var total = _ref5.total;
            return total;
          }))),
          backgroundColor: __WEBPACK_IMPORTED_MODULE_7__utils_colors_js__["a" /* default */].coresRGB,
          borderWidth: 0
        }]
      };
    },
    DownloadJSON2CSV: function DownloadJSON2CSV() {
      var headers = {
        indice: ' - ',
        sigla: 'Sigla',
        secretaria: 'Unidade',
        total: 'Total de Metas',
        concluidas: 'Concluídas',
        percentual: 'Percentual (%)'
      };

      var _rankingConcluidas = this.rankingConcluidas,
          data = _rankingConcluidas.data,
          total = _rankingConcluidas.totalMetas,
          concluidas = _rankingConcluidas.totalConcluidas,
          percentual = _rankingConcluidas.totalPercentual;

      var footers = { indice: '', sigla: '', secretaria: 'TOTAL', total: total, concluidas: concluidas, percentual: percentual.replace('.', ',') };

      var items = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(data.map(function (_ref6, index) {
        var sigla = _ref6.sigla,
            secretaria = _ref6.secretaria,
            total = _ref6.total,
            concluidas = _ref6.concluidas,
            percentual = _ref6.percentual;
        return {
          indice: index + 1,
          sigla: sigla,
          secretaria: secretaria,
          total: total,
          concluidas: concluidas,
          percentual: percentual.replace('.', ',')
        };
      })));

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* exportCSVFile */])(headers, [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(items), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(footers)), 'ranking_conclusao');
    },

    entidadeBySigla: __WEBPACK_IMPORTED_MODULE_10__utils_entidades_js__["a" /* entidadeBySigla */]
  }
});

/***/ }),

/***/ "xtcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row detalhe-group-despesa"},[_c('public-header',{attrs:{"title":_vm.title}},[_c('ano-base'),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p',[_vm._v("\n        A Unidade Orçamentária\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v("\""+_vm._s(_vm.gastosNivel1.descricao)+"\"")]),_vm._v(",\n        para o ano de "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.ano_base))]),_vm._v("\n        possui uma previsão de gastos no valor de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.formatarMoeda(Number(_vm.gastosNivel1.vl_previsto))))]),_vm._v(", sendo autorizado um valor total de gastos de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.formatarMoeda(Number(_vm.gastosNivel1.vl_autorizado))))])]),_vm._v(" "),_c('p',[_vm._v("\n        Do valor total, até o mês de\n        "),_c('span',{staticClass:"destaque-header"},[_vm._v(_vm._s(_vm.mes_base.nome))]),_vm._v(", foram efetuados os seguintes valores:\n      ")]),_vm._v(" "),_c('ul',[_c('li',[_c('span',{staticClass:"destaque-header"},[_vm._v("\n            Empenho:\n            "+_vm._s(_vm.formatarMoeda(Number(_vm.gastosNivel1.vl_empenhado_acu)))+" ("+_vm._s(_vm.gastosNivel1.vl_empenhado_perc)+")\n          ")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"destaque-header"},[_vm._v("\n            Liquidação:\n            "+_vm._s(_vm.formatarMoeda(Number(_vm.gastosNivel1.vl_liquidado_acu)))+" ("+_vm._s(_vm.gastosNivel1.vl_liquidado_perc)+")\n          ")])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"destaque-header"},[_vm._v("\n            Pagamento:\n            "+_vm._s(_vm.formatarMoeda(Number(_vm.gastosNivel1.vl_pago_acu)))+" ("+_vm._s(_vm.gastosNivel1.vl_pago_perc)+")\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('bar-chart',{ref:"despesa_empenho",attrs:{"chart-data":_vm.graficoDespesa,"gradiente":false,"coloredLine":true,"options":_vm.graficoOptions}})],1)],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":'/receitas_despesas'}},[_vm._v("Receitas e Despesas")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":'/despesas'}},[_vm._v("Despesas")])],1),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('card',{attrs:{"data":_vm.listaCards()}})],1),_vm._v(" "),_c('div',{staticClass:"row margem-bottom"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',{attrs:{"for":"descricao"}},[_vm._v("Histórico")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.descricao),expression:"filtros.descricao"}],staticClass:"form-control",attrs:{"name":"descricao","placeholder":"Digite um texto para filtrar...","type":"text"},domProps:{"value":(_vm.filtros.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "descricao", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"totais-despesa"},[_c('span',[_c('strong',[_vm._v("Empenhado:")]),_vm._v("\n        "+_vm._s(_vm.formatarMoeda(_vm.totalDespesasFiltradas.vl_empenhado))+"\n      ")]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Liquidado:")]),_vm._v("\n        "+_vm._s(_vm.formatarMoeda(_vm.totalDespesasFiltradas.vl_liquidado))+"\n      ")]),_vm._v(" "),_c('span',[_c('strong',[_vm._v("Pago:")]),_vm._v("\n        "+_vm._s(_vm.formatarMoeda(_vm.totalDespesasFiltradas.vl_pago))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table',{attrs:{"dados":_vm.despesasUnidade,"fields":_vm.fields,"carregando":_vm.isLoading},scopedSlots:_vm._u([{key:"columncustom",fn:function(props){return [_vm._v("\n            "+_vm._s(((props.rowData.nr_doc_despesa) + "/" + (props.rowData.ano_doc_despesa)))+"\n          ")]}},{key:"rowrender",fn:function(props){return [_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.montarEmpenho(props)}}},[_c('font-awesome-icon',{attrs:{"icon":'search'}}),_c('span',{staticClass:"sr-only"},[_vm._v("Detalhes")])],1)]}}])})],1)])]),_vm._v(" "),_c('side-bar',{attrs:{"sides":_vm.navs}},[_c('template',{slot:_vm.navs[0].identidade},[_c('div',{staticClass:"side-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Data Despesa:")]),_vm._v("\n            "+_vm._s(new Date(
                ((_vm.detalhe_empenho['dt_doc_despesa']) + " 00:00:00")
              ).toLocaleDateString())+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Credor:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['credor'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Valor Empenhado:")]),_vm._v("\n            "+_vm._s(_vm.detalhe_empenho['vl_empenhado'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Valor Liquidado:")]),_vm._v("\n            "+_vm._s(_vm.detalhe_empenho['vl_liquidado'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Valor Pago:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['vl_pago'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Unid. Orçamentária:")]),_vm._v("\n            "+_vm._s(_vm.detalhe_empenho['unidade_orcamentaria'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Unid. Executora:")]),_vm._v("\n            "+_vm._s(_vm.detalhe_empenho['unidade_executora'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Função:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['funcao'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Subfunção:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['subfuncao'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Programa:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['programa'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Ação:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['acao'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Subelemento:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['subelemento'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Fonte Recurso:")]),_vm._v("\n            "+_vm._s(_vm.detalhe_empenho['fonte_recurso'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Aplicação:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['aplicacao'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Tipo:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['tipo'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Regime:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['regime'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Centro de Custo:")]),_vm._v("\n            "+_vm._s(_vm.detalhe_empenho['centro_custo'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Tipo Despesa:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['tipo_despesa'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Processo Despesa:")]),_vm._v("\n            "+_vm._s(_vm.detalhe_empenho['processo_despesa'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Licitação:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['licitacao'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Contrato:")]),_vm._v(" "+_vm._s(_vm.detalhe_empenho['contrato'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Tipo Contrato:")]),_vm._v("\n            "+_vm._s(_vm.detalhe_empenho['tipo_contrato'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4"},[_c('label',[_vm._v("Subtipo Contrato:")]),_vm._v("\n            "+_vm._s(_vm.detalhe_empenho['subtipo_contrato'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('label',[_vm._v("Objeto Contrato:")]),_vm._v("\n            "+_vm._s(_vm.detalhe_empenho['objeto_contrato'])+"\n          ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row lista-head"},[_c('div',{staticClass:"col-xs-12 col-sm-2"},[_vm._v("\n            Tipo Movimentação\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2"},[_vm._v("\n            Data\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2"},[_vm._v("\n            Valor\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_vm._v("\n            Descrição\n          ")])]),_vm._v(" "),_vm._l((_vm.historico_empenho.empenhos),function(item,index){return _c('div',{key:item.id_doc_despesa,class:[index % 2 !== 0 ? '' : 'lista-impar', 'row']},[_c('div',{staticClass:"col-xs-12 col-sm-2"},[_vm._v("\n            "+_vm._s(item['tp_movimento'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2"},[_vm._v("\n            "+_vm._s(new Date(
                ((item['dt_movimento']) + " 00:00:00")
              ).toLocaleDateString())+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-2"},[_vm._v("\n            "+_vm._s(item['vl_movimento'])+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_vm._v("\n            "+_vm._s(item['historico'])+"\n          ")])])})],2)])],2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Unidades Executoras")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("\n          Todas as Despesas\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xuae":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/movimento_ods_logo.c4acc84.jpg";

/***/ }),

/***/ "xugx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_detalhes_js__ = __webpack_require__("QB41");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df57c86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("FQTq");
function injectStyle (ssrContext) {
  __webpack_require__("AHzu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_detalhes_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df57c86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "xziQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_NoApiTable__ = __webpack_require__("Vp40");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DataTable: __WEBPACK_IMPORTED_MODULE_3__components_common_NoApiTable__["a" /* default */]
  },
  inject: ["showConfirm"],
  data: function data() {
    return {
      title: 'Remover publicação',
      escalaId: null,
      referencia: null,
      escalas: [],
      escalas_original: [],
      referencias: [],
      termoPesquisa: '',
      carregandoDados: false,
      datatable: {
        columnID: 'id',
        columns: [{
          name: 'uor_sigla',
          title: 'Unidade',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: 'nome',
          title: 'Criado por',
          dataClass: 'align-middle',
          filterable: true
        }, {
          name: 'publicado_em',
          title: 'Publicado em',
          dataClass: 'align-middle',
          callback: function callback(value) {
            return new Date(value).toLocaleString().replace(',', '');
          }
        }, {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-1',
          dataClass: 'text-center align-middle'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.loadReferencias();
    this.setReferencia();
  },

  computed: {
    colaboradores: function colaboradores() {
      return this.$store.state.escala.funcionarios;
    }
  },
  watch: {
    referencia: function referencia(value) {
      if (value) this.loadEscalas();
    }
  },
  methods: {
    loadReferencias: function loadReferencias() {
      var currentYear = new Date().getFullYear();
      var currentMonth = new Date().getMonth();

      if (currentMonth == 11) {
        var nextYear = currentYear + 1;
        var date = new Date(currentYear, currentMonth, 1, 1);
        var month = date.toLocaleDateString('pt-BR', { month: '2-digit' });

        var label = date.toLocaleDateString('pt-BR', {
          month: 'long',
          year: 'numeric'
        }).toLocaleUpperCase();
        var value = '' + date.getFullYear() + month;

        this.referencias.push({
          label: label,
          value: value
        });

        for (var index = 0; index < 5; index++) {
          date = new Date(nextYear, index, 1, 1);
          month = date.toLocaleDateString('pt-BR', { month: '2-digit' });

          label = date.toLocaleDateString('pt-BR', {
            month: 'long',
            year: 'numeric'
          }).toLocaleUpperCase();
          value = '' + date.getFullYear() + month;

          this.referencias.push({
            label: label,
            value: value
          });
        }
      } else {
        for (var _index = currentMonth; _index < 12; _index++) {
          var _date = new Date(currentYear, _index, 1, 1);
          var _month = _date.toLocaleDateString('pt-BR', { month: '2-digit' });

          var _label = _date.toLocaleDateString('pt-BR', {
            month: 'long',
            year: 'numeric'
          }).toLocaleUpperCase();
          var _value = '' + _date.getFullYear() + _month;

          this.referencias.push({
            label: _label,
            value: _value
          });
        }
      }
    },
    loadEscalas: function loadEscalas() {
      var _this = this;

      var referencia = this.referencia,
          adicionarDadosDeColaboradorNasEscalas = this.adicionarDadosDeColaboradorNasEscalas,
          toogleCarregandoDados = this.toogleCarregandoDados;


      toogleCarregandoDados();

      __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('escala/listar-publicadas?referencia=' + referencia).then(function (_ref) {
        var data = _ref.data;

        _this.escalas = adicionarDadosDeColaboradorNasEscalas(data);
        _this.escalas_original = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.escalas));
      }).catch(function (e) {
        console.log(e);
      }).finally(toogleCarregandoDados);
    },
    setReferencia: function setReferencia() {
      var currentDate = new Date();
      var date = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1, 1);
      var month = date.toLocaleDateString('pt-BR', {
        month: '2-digit'
      });
      this.referencia = '' + date.getFullYear() + month;
    },
    adicionarDadosDeColaboradorNasEscalas: function adicionarDadosDeColaboradorNasEscalas(lista) {
      var _this2 = this;

      return lista.map(function (item) {
        var colaborador = _this2.colaboradores.find(function (_ref2) {
          var sshd = _ref2.sshd;
          return sshd.toLocaleUpperCase() == item.user_sshd.toLocaleUpperCase();
        });
        var nome = colaborador.nome,
            cargo = colaborador.cargo;


        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ nome: nome, cargo: cargo }, item);
      });
    },
    pesquisar: function pesquisar() {
      var _this3 = this;

      this.escalas = this.escalas_original.filter(function (_ref3) {
        var uor_sigla = _ref3.uor_sigla,
            nome = _ref3.nome,
            publicado_em = _ref3.publicado_em;

        var sigla = uor_sigla.toUpperCase();
        var nome_usuario = nome.toUpperCase();
        var termo = _this3.termoPesquisa.toUpperCase();

        return sigla.indexOf(termo) > -1 || nome_usuario.indexOf(termo) > -1 || publicado_em.indexOf(termo) > -1;
      });
    },
    toogleCarregandoDados: function toogleCarregandoDados() {
      this.carregandoDados = !this.carregandoDados;
    },
    removerPublicacao: function removerPublicacao(_ref4) {
      var _this4 = this;

      var id = _ref4.id;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].post('escala/despublicar', { id: id }).then(function () {
            return _this4.removerItemEscala(id);
          }).catch(function (error) {
            console.log(error);
            _this4.$toastr.e('Houve uma falha ao tentar remover a publicação da escala, Tente novamente daqui alguns minutos!');
          });
        }
      };
      this.showConfirm('Deseja realmente remover a publicação desta escala?', config);
    },
    removerItemEscala: function removerItemEscala(id) {
      this.escalas = this.escalas_original.filter(function (item) {
        return item.id != id;
      });
      this.escalas_original = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.escalas));
    }
  }
});

/***/ }),

/***/ "y/Ru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalMovimentoInfo_vue__ = __webpack_require__("IhWE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f48f6b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalMovimentoInfo_vue__ = __webpack_require__("N7jy");
function injectStyle (ssrContext) {
  __webpack_require__("GohC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9f48f6b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalMovimentoInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f48f6b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalMovimentoInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y/xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eleicoes_conselho; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__("zS3q");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__types__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__types__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__types__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("IjOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("QzpD");




var eleicoes_conselho = {
  state: function state() {
    return {
      votos: [],
      candidatos: []
    };
  },
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* mutations */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* actions */],
  getters: __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* getters */]
};

/***/ }),

/***/ "yGGR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yRrB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return planoDeGoverno; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_public_plano_governo__ = __webpack_require__("6DEj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_public_plano_governo_PorSecretaria__ = __webpack_require__("zZs/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__("4Nwh");




var planoDeGoverno = [{
  name: 'planodegoverno',
  path: '/planodegoverno',
  component: __WEBPACK_IMPORTED_MODULE_0__views_public_plano_governo__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_2__const__["a" /* DEFAULT_TITLE */] + ' | Plano de Governo'
  }
}, {
  name: 'planoporsecretaria',
  path: '/planodegoverno/por-secretaria/:secretaria',
  component: __WEBPACK_IMPORTED_MODULE_1__views_public_plano_governo_PorSecretaria__["a" /* default */],
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_2__const__["a" /* DEFAULT_TITLE */] + ' | Plano de Governo - Por Secretaria'
  }
}];

/***/ }),

/***/ "yVX/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_COMPROMISSOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PDG_TOGGLE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_COMPROMISSOS_SECRETARIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_LOADING_SECRETARIA; });
var LOAD_COMPROMISSOS = 'LOAD_COMPROMISSOS';
var PDG_TOGGLE_LOADING = 'PDG_TOGGLE_LOADING';
var SET_COMPROMISSOS_SECRETARIA = 'SET_COMPROMISSOS_SECRETARIA';
var SET_LOADING_SECRETARIA = 'SET_LOADING_SECRETARIA';

/***/ }),

/***/ "yYb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      required: true
    },
    list: {
      type: Array
    },
    description: {
      type: String
    },
    title: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "yZwr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "yaaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PublicHeader: __WEBPACK_IMPORTED_MODULE_1__components__["a" /* PublicHeader */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components__["b" /* Breadcrumb */]
  },
  name: 'remedios',
  data: function data() {
    return {
      carregando: false,
      retornoVazio: false,
      remedios: [],
      termoBusca: ''
    };
  },

  methods: {
    toggleLoading: function toggleLoading() {
      this.carregando = !this.carregando;
    },
    getErrorByKey: function getErrorByKey(key) {
      var items = this.errors.items;


      var filter = function filter(item) {
        return item.field === key;
      };

      var _items$filter = items.filter(filter),
          _items$filter2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_items$filter, 1),
          descricao = _items$filter2[0];

      return descricao || {};
    },
    consultar: function consultar() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          _this.$toastr.e(_this.getErrors.descricao);
          return;
        }

        _this.toggleLoading();
        __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('remedios/pesquisa', { params: { term: _this.termoBusca } }).then(function (_ref) {
          var data = _ref.data;

          _this.remedios = data;
          _this.retornoVazio = !data.length;
        }).catch(function (error) {
          console.log(error.response);
          _this.$toastr.e('Houve um erro na consulta. Tente novamente');
        }).finally(_this.toggleLoading);
      });
    },
    limparConsulta: function limparConsulta() {
      this.remedios = [];
      this.termoBusca = '';
      this.$refs.descricao.focus();
    }
  },
  computed: {
    getErrors: function getErrors() {
      var descricao = this.getErrorByKey('descricao');

      var errorDesc = '';

      switch (descricao.rule) {
        case 'required':
          errorDesc = 'Por favor digite o nome ou princípio ativo do remédio';
          break;

        case 'min':
          errorDesc = 'Por favor digite ao menos 3 caracteres para consulta';
          break;
      }

      return { descricao: errorDesc };
    }
  }
});

/***/ }),

/***/ "ycrs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__ = __webpack_require__("ag7F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28638cfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__ = __webpack_require__("9MyI");
function injectStyle (ssrContext) {
  __webpack_require__("gsQE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Save_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28638cfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Save_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yd/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BarChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__("ikxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_colors__ = __webpack_require__("ZAg2");



var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp;


var BarChart = {
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* Bar */],
  mixins: [reactiveProp],
  data: function data() {
    return {
      colors: __WEBPACK_IMPORTED_MODULE_2__utils_colors__["a" /* default */].cores,
      colorHex: __WEBPACK_IMPORTED_MODULE_2__utils_colors__["a" /* default */].coresHexa
    };
  },

  props: {
    options: {
      type: Object
    },
    gradiente: {
      type: Boolean,
      default: true
    }
  },
  mounted: function mounted() {
    if (this.$refs.canvas) {
      __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a.plugins.register({
        id: 'paddingBelowLegends',
        beforeInit: function beforeInit(chart, options) {
          chart.legend.afterFit = function () {
            this.height = this.height + 15;
          };
        }
      });

      __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a.Tooltip.positioners.middle = function (items) {
        if (items.length !== 1) {
          // For more than 1 item, just show at the nearest
          return __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a.Tooltip.positioners.average(items);
        }

        var el = items[0]._view;
        var xPos = 0;
        var yPos = 0;

        if (el) {
          var base = el.base,
              horizontal = el.horizontal,
              x = el.x,
              y = el.y;

          if (horizontal) {
            xPos = (base + x) / 2;
            yPos = y;
          } else {
            xPos = x;
            yPos = (base + y) / 2;
          }
        }

        return {
          x: xPos,
          y: yPos
        };
      };

      // if (this.chartData.datasets[0])
      //   this.chartData.datasets[0].backgroundColor = this.montarCor(
      //     this.colors[0]
      //   )

      this.renderChart(this.chartData, this.options);
      this.htmlLegend = this.generateLegend();
    }
  },

  methods: {
    montarCor: function montarCor(cor) {
      if (this.gradiente) {
        return this.gradient(cor);
      } else {
        return 'rgba(' + cor + ',1)';
      }
    },
    gradient: function gradient(color) {
      var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450);

      gradient.addColorStop(0, 'rgba(' + color + ', 1)');
      gradient.addColorStop(0.5, 'rgba(' + color + ', 0.6)');
      gradient.addColorStop(1, 'rgba(' + color + ', 0.2)');

      return gradient;
    }
  },
  watch: {
    chartData: function chartData() {
      // for (
      //   let index = 0;
      //   index < this.$data._chart.data.datasets.length;
      //   index++
      // ) {
      //   this.$data._chart.data.datasets[index].backgroundColor = this.montarCor(
      //     this.colors[index]
      //   )
      // }
      // // necessário atualizar 2x para corrigir problemas nas cores das labels
      // this.$data._chart.update()
      // this.$data._chart.update()
    }
  }
};

/***/ }),

/***/ "ye37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prestacoes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__("4Nwh");


var prestacoes = [{
  name: 'prestacao_contas',
  path: '/prestacao_contas',
  component: function component() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "bs2l"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Presta\xE7\xE3o de Contas'
  }
}, {
  name: 'prestacao_areas',
  path: '/prestacao_contas/areas',
  component: function component() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "NWJ7"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Presta\xE7\xF5es por \xE1rea'
  }
}, {
  name: 'prestacao_lista_entidades',
  path: '/prestacao_contas/entidades/:area?',
  component: function component() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "DTx2"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Presta\xE7\xF5es por entidade'
  }
}, {
  name: 'prestacao_detalhe_entidade',
  path: '/prestacao_contas/detalhes/:nomeEntidade',
  component: function component() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "8/Hg"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Detalhes da entidade'
  }
}, {
  name: 'prestacao_detalhe',
  path: '/prestacao_contas/prestacao/:codigo',
  component: function component() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "FjEN"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Detalhes da presta\xE7\xE3o'
  }
}, {
  name: 'prestacao_todas_entidades',
  path: '/prestacao_contas/todas-entidades',
  component: function component() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "7tBS"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Lista de entidades'
  }
}];

/***/ }),

/***/ "yiqO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ykgm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ysb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'Título'
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),

/***/ "yxmf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z1vu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return concursos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const__ = __webpack_require__("4Nwh");


var concursos = [{
  name: 'concursos',
  path: '/concursos',
  component: function component() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "wg5L"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Concursos P\xFAblicos'
  }
}, {
  name: 'edital',
  path: '/concursos/edital/:edital',
  component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "7FVA"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Detalhes do edital'
  }
}, {
  name: 'cargo',
  path: '/concursos/edital/:edital/cargo/:cargo',
  component: function component() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "ORgV"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Detalhes do cargo'
  }
}, {
  name: 'pesquisa_nome',
  path: '/concursos/pesquisa/nome/:nome',
  component: function component() {
    return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "73Tf"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Pesquisa por candidato'
  }
}, {
  name: 'pesquisa_cargo',
  path: '/concursos/pesquisa/cargo/:cargo/:total',
  component: function component() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "XvuZ"));
  },
  meta: {
    title: __WEBPACK_IMPORTED_MODULE_0__const__["a" /* DEFAULT_TITLE */] + ' | Pesquisa por cargo'
  }
}];

/***/ }),

/***/ "z2KP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beneficios"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('data-table',{ref:"vuetable",attrs:{"show-empty":true,"title":"Lista de Benefícios","api-url":"assistencia/beneficios/listar","report-title":"Benefícios","initial-page":_vm.pagina,"pageCollection":'beneficiosAssistenciais',"fields":_vm.fields},scopedSlots:_vm._u([{key:"rowrender",fn:function(props){return [_c('div',{},[_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Editar","type":"button"},on:{"click":function($event){return _vm.$router.push({
                  name: 'beneficios_edit',
                  params: { item: props.rowData }
                })}}},[_c('font-awesome-icon',{attrs:{"icon":'edit'}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Excluir"},on:{"click":function($event){return _vm.excluir(props.rowData)}}},[_c('font-awesome-icon',{attrs:{"icon":'trash'}})],1)])]}}])},[_c('template',{slot:"actions"},[_c('router-link',{staticClass:"btn btn-default",attrs:{"to":'/admin/assistencia/beneficios/edit'}},[_c('font-awesome-icon',{attrs:{"icon":'plus'}}),_vm._v(" Adicionar\n          ")],1)],1)],2)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h2',{staticClass:"page-header"},[_vm._v("Benefícios Assistenciais")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z4Gh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scalecontrol-container"},[_c('div',[_c('label',[_vm._v("Dias")]),_vm._v(" "),_c('ul',{staticClass:"list-days"},_vm._l((_vm.value),function(ref,index){
var date = ref.date;
var active = ref.active;
var selected = ref.selected;
return _c('li',{key:index,class:[active ? 'active' : '', selected ? 'selected' : ''],on:{"click":function($event){return _vm.toggleSelectDay(index)}}},[_vm._v("\n        "+_vm._s(_vm.dateFormatDDMM(date))+"\n      ")])}),0)]),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":""}},[_vm._v("Períodos")]),_vm._v(" "),_c('ul',{staticClass:"list-times"},[_vm._l((_vm.times),function(ref,index){
var entrada = ref.entrada;
var saida = ref.saida;
return _c('li',{key:entrada + saida},[_c('article',[(entrada === '')?_c('div',[_c('i',{staticClass:"fa fa-arrow-circle-right fa-lg",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(entrada))]),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),(saida === '')?_c('div',[_c('i',{staticClass:"fa fa-arrow-circle-right fa-lg",attrs:{"aria-hidden":"true"}})]):_c('span',[_vm._v(_vm._s(saida))]),_vm._v(" "),_c('button',{on:{"click":function () { return _vm.removeTime(index); }}},[_vm._v("\n            ×\n          ")])])])}),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.shownFormTime),expression:"shownFormTime"}]},[_c('form',{attrs:{"spellcheck":"false"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.entrada),expression:"entrada"}],ref:"entrada",staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.entrada)},on:{"blur":_vm.lockIfValueIsNull,"input":function($event){if($event.target.composing){ return; }_vm.entrada=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saida),expression:"saida"}],ref:"saida",staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.saida)},on:{"blur":_vm.lockIfValueIsNull,"input":function($event){if($event.target.composing){ return; }_vm.saida=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.addTime.apply(null, arguments)}}},[_vm._v("\n            +\n          ")])])])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zA1L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__("OOvn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MensagemErro__ = __webpack_require__("3FI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_NoApiTable__ = __webpack_require__("Vp40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Datepicker__ = __webpack_require__("eOZt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputVagas_vue__ = __webpack_require__("o0wj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("0xDb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  inject: ['showConfirm'],
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_2__MensagemErro__["a" /* default */],
    InputVagas: __WEBPACK_IMPORTED_MODULE_5__InputVagas_vue__["a" /* default */],
    DataTable: __WEBPACK_IMPORTED_MODULE_3__components_common_NoApiTable__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_4__components_common_Datepicker__["a" /* default */]
  },
  props: {
    edital_id: {
      type: Number,
      required: true
    },
    numero: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false,
      cargos: [],
      listaCargos: [],
      model: {
        id: null,
        edital_id: null,
        descricao: '',
        vagas: '0',
        vagas_pcd: '0',
        vagas_cotas: '0',
        vagas_QP: '0',
        data_homologacao: '',
        data_validade: '',
        observacao_validade: ''
      },
      fields: [{
        name: 'descricao',
        title: 'Descrição'
      }, {
        name: 'vagas',
        title: 'Vagas'
      }, {
        name: 'vagas_pcd',
        title: 'Vagas PCD'
      }, {
        name: 'vagas_cotas',
        title: 'Vagas Cotas'
      }, {
        name: 'vagas_QP',
        title: 'Vagas QP'
      }, {
        name: '__slot:actions',
        title: 'Visualizar',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }]
    };
  },
  created: function created() {
    this.model.edital_id = this.edital_id;
    this.listarCargosEdital();
  },

  computed: {},
  methods: {
    homologarTodos: function homologarTodos() {
      var _this = this;

      var _model = this.model,
          data_homologacao = _model.data_homologacao,
          edital_id = _model.edital_id;


      if (!data_homologacao) {
        this.$toastr.e('Selecione uma data de homologação!');
        return;
      }

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          _this.handleLoading();
          setTimeout(function () {
            _this.handleLoading();
          }, 2000);
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('edital/homologar-todos', {
            id: edital_id,
            data_homologacao: _this.formatarData(data_homologacao)
          }).then(function (response) {
            _this.$toastr.s('Cargos homologados com sucesso');
            _this.listarCargosEdital();
          }).catch(function (error) {
            _this.$toastr.e('Houve um erro ao homologar os cargos, tente novamente e, se persistir o erro, entre em contato com o administrador.');
            console.log(error.response.data);
          });
        }
      };
      this.showConfirm('Deseja homologar todos os cargos deste edital com a mesma data (' + data_homologacao.toLocaleDateString() + ')?', config);
    },
    selecionarCargo: function selecionarCargo(item) {
      var data_homologacao = item.data_homologacao,
          data_validade = item.data_validade;

      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
        data_homologacao: data_homologacao ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["l" /* toDate */])(data_homologacao) : '',
        data_validade: data_validade ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["l" /* toDate */])(data_validade) : ''
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["o" /* scrollToElement */])('cargos');
    },
    excluir: function excluir(data) {
      var _this2 = this;

      var config = {
        title: 'Alerta',
        question: true,
        yes: function yes() {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].delete('cargo/' + data.id).then(function (response) {
            _this2.$toastr.s('Cargo excluído com sucesso');
            _this2.listarCargosEdital();
          }).catch(function (error) {
            _this2.$toastr.e('Houve um erro ao excluir o cargo, tente novamente e, se persistir o erro, entre em contato com o administrador.');
          });
        }
      };
      this.showConfirm('Deseja realmente deletar este cargo? Todos os habilitados atribuidos a ele também serão excluídos.', config);
    },
    formatarData: function formatarData(item) {
      if (item) {
        return item.toISOString().split('T')[0];
      }
      return '';
    },
    salvar: function salvar() {
      var _this3 = this;

      this.handleLoading();
      this.$validator.validateAll().then(function (result) {
        if (!result) {
          _this3.handleLoading();
          _this3.$toastr.e(_this3.$validator.errors.items[0].msg);
          return;
        }

        var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.model);

        obj.data_homologacao = _this3.formatarData(obj.data_homologacao);
        obj.data_validade = _this3.formatarData(obj.data_validade);

        var id = obj.id;


        if (id) {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].put('cargo/' + id, obj).then(function (response) {
            return _this3.$toastr.s('Cargo salvo com sucesso.');
          }).catch(function (error) {
            return _this3.$toastr.e('Houve um erro ao salvar o cargo, verifique as informações e tente novamente.');
          }).finally(function () {
            _this3.handleLoading();
            _this3.listarCargosEdital();
            _this3.limparCampos();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].post('cargo', obj).then(function (response) {
            return _this3.$toastr.s('Cargo inserido com sucesso.');
          }).catch(function (error) {
            return _this3.$toastr.e('Houve um erro ao salvar o edital, verifique as informações e tente novamente.');
          }).finally(function () {
            _this3.handleLoading();
            _this3.listarCargosEdital();
            _this3.limparCampos();
          });
        }
      });
    },
    handleLoading: function handleLoading() {
      this.isLoading = !this.isLoading;
    },
    listarCargosEdital: function listarCargosEdital() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__request__["a" /* request */].get('cargo', { params: { nr_edital: this.numero } }).then(function (response) {
        _this4.cargos = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    limparCampos: function limparCampos() {
      this.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.model, {
        id: null,
        descricao: '',
        vagas: '0',
        vagas_pcd: '0',
        vagas_cotas: '0',
        vagas_QP: '0',
        data_homologacao: '',
        data_validade: '',
        observacao_validade: ''
      });
    }
  }
});

/***/ }),

/***/ "zBJv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown column-visible"},[_c('button',{staticClass:"btn btn-default dropdown-toggle",attrs:{"type":"button","id":"dropdownMenu1","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"true"}},[_c('font-awesome-icon',{attrs:{"icon":'columns'}}),_vm._v(" "),_c('span',{staticClass:"caret"})],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"dropdownMenu1"}},_vm._l((_vm.fieldsToShowOnMenu),function(field){return _c('li',[_c('a',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.changeVisibility(field)}}},[_vm._v("\n                "+_vm._s(field.title)+"\n                "),(field.visible)?_c('font-awesome-icon',{attrs:{"icon":'check-double'}}):_c('font-awesome-icon',{attrs:{"icon":'times'}})],1)])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zIB3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    candidato: { type: Object, required: true },
    perc: { type: String, required: true }
  }
});

/***/ }),

/***/ "zS3q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_CANDIDATOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_VOTOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_ELEICOES; });
var LOAD_CANDIDATOS = 'LOAD_CANDIDATOS';
var LOAD_VOTOS = 'LOAD_VOTOS';
var RESET_ELEICOES = 'RESET_ELEICOES';

/***/ }),

/***/ "zSEq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__("vAZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Datepicker__ = __webpack_require__("eOZt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SideAcao',
    components: { SideModal: __WEBPACK_IMPORTED_MODULE_0__common__["g" /* SideModal */], datepicker: __WEBPACK_IMPORTED_MODULE_1__components_common_Datepicker__["a" /* default */] },
    props: {
        navs: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            justificativa: '',
            dataAtualInicio: null,
            dataAtualConclusao: null
        };
    },

    computed: {
        detalhesData: function detalhesData() {
            var detalhesNav = this.navs.find(function (n) {
                return n.identidade === 'detalhes';
            });
            return detalhesNav && detalhesNav.data ? detalhesNav.data : {};
        },
        concluirData: function concluirData() {
            var concluirNav = this.navs.find(function (n) {
                return n.identidade === 'concluir';
            });
            return concluirNav && concluirNav.data ? concluirNav.data : {};
        },
        iniciarData: function iniciarData() {
            var iniciarNav = this.navs.find(function (n) {
                return n.identidade === 'iniciar';
            });
            return iniciarNav && iniciarNav.data ? iniciarNav.data : {};
        },
        editarData: function editarData() {
            var editarNav = this.navs.find(function (n) {
                return n.identidade === 'editar';
            });
            return editarNav && editarNav.data ? editarNav.data : {};
        },
        aceitarData: function aceitarData() {
            var aceitarNav = this.navs.find(function (n) {
                return n.identidade === 'aceitar';
            });
            return aceitarNav && aceitarNav.data ? aceitarNav.data : {};
        },
        cancelarData: function cancelarData() {
            var cancelarNav = this.navs.find(function (n) {
                return n.identidade === 'cancelar';
            });
            return cancelarNav && cancelarNav.data ? cancelarNav.data : {};
        },
        deletarData: function deletarData() {
            var deletarNav = this.navs.find(function (n) {
                return n.identidade === 'deletar';
            });
            return deletarNav && deletarNav.data ? deletarNav.data : {};
        },
        reordenarData: function reordenarData() {
            var reordenarNav = this.navs.find(function (n) {
                return n.identidade === 'reordenar';
            });
            return reordenarNav && reordenarNav.data ? reordenarNav.data : {};
        },
        diferencaInicio: function diferencaInicio() {
            return this.calcularDiferenca(this.iniciarData.data_estimada_inicio);
        },
        diferencaConclusao: function diferencaConclusao() {
            return this.calcularDiferenca(this.concluirData.data_estimada_conclusao);
        }
    },
    methods: {
        abreModal: function abreModal(nome) {
            this.$refs.sideModal.abreModal(nome);
        },
        fechaModal: function fechaModal(nome) {
            this.$refs.sideModal.fechaModal(nome);
        },
        handleFechou: function handleFechou(_ref) {
            var identidade = _ref.identidade;

            var nav = this.navs.find(function (n) {
                return n.identidade === identidade;
            });
            if (nav) {
                nav.aberto = false;
            }
        },
        calcularDiferenca: function calcularDiferenca(dataPrevistaStr) {
            if (!dataPrevistaStr) return null;

            var partes = dataPrevistaStr.split('/');
            var dataFormatadaISO = partes[2] + '-' + partes[1] + '-' + partes[0];
            var dataPrevista = new Date(dataFormatadaISO + 'T00:00:00');
            var hoje = new Date();
            hoje.setHours(0, 0, 0, 0);

            var diffEmMS = hoje.getTime() - dataPrevista.getTime();
            var diffEmDias = Math.round(diffEmMS / (1000 * 60 * 60 * 24));

            if (diffEmDias === 0) {
                return { texto: 'Em dia', dias: 0, classe: 'status-ok' };
            } else if (diffEmDias > 0) {
                return { texto: 'Atrasado', dias: diffEmDias, classe: 'status-atrasado' };
            } else {
                return { texto: 'Adiantado', dias: Math.abs(diffEmDias), classe: 'status-adiantado' };
            }
        }
    },
    watch: {
        iniciarData: {
            handler: function handler(novosDados) {
                if (novosDados && novosDados.id) {
                    this.dataAtualInicio = new Date().toLocaleDateString('pt-BR');
                } else {
                    this.dataAtualInicio = null;
                }
            },

            deep: true
        },
        concluirData: {
            handler: function handler(novosDados) {
                if (novosDados && novosDados.id) {
                    this.dataAtualConclusao = new Date().toLocaleDateString('pt-BR');
                } else {
                    this.dataAtualConclusao = null;
                }
            },

            deep: true
        },
        'cancelarData.id': function cancelarDataId(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.justificativa = '';
            }
        }
    }
});

/***/ }),

/***/ "zTH1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"row"},[_c('public-header',{staticClass:"cabecalho",attrs:{"title":'Escala de Plantões da Saúde'}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"subheader"})]),_vm._v(" "),_c('form',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.month),expression:"month"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.month=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.handleSelectedMonth]}},_vm._l((_vm.months),function(month,index){return _c('option',{key:index,domProps:{"value":month.value}},[_vm._v("\n              "+_vm._s(month.label)+"\n            ")])}),0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.uor),expression:"uor"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.uor=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Selecione uma unidade")]),_vm._v(" "),_vm._l((_vm.uors),function(ref){
var uor_nome = ref.uor_nome;
var uor_sigla = ref.uor_sigla;
return _c('option',{key:uor_sigla,domProps:{"value":uor_sigla}},[_vm._v("\n              "+_vm._s((uor_sigla + " | " + uor_nome))+"\n            ")])})],2),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn",on:{"click":function($event){$event.preventDefault();return _vm.prevWeek.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":'chevron-left'}})],1),_vm._v(" "),(_vm.weekStart)?_c('label',[_vm._v("\n              Semana de\n              "+_vm._s(_vm.dateFormatDDMM(_vm.weekStart))+" á\n              "+_vm._s(_vm.dateFormatDDMM(_vm.weekEnd))+"\n            ")]):_c('label',[_vm._v("\n              Semana de\n              "),_c('pulse-loader',{staticClass:"loading",attrs:{"size":'0.5em'}})],1),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){$event.preventDefault();return _vm.nextWeek.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":'chevron-right'}})],1)])])])])]),_vm._v(" "),_c('main',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Início")])],1),_vm._v(" "),_c('li',{},[_vm._v("Escalas de plantões da Saúde")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ul',[_c('li',[_vm._v("Nome")]),_vm._v(" "),_vm._l((_vm.week),function(ref){
var weekday = ref.weekday;
var weekdayNumber = ref.weekdayNumber;
var monthday = ref.monthday;
return _c('li',{key:weekdayNumber},[_c('span',[_vm._v(_vm._s(weekday))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(monthday))])])})],2),_vm._v(" "),_c('ul',[(_vm.scale.length === 0)?_c('li',{staticClass:"empty"},[(_vm.loadingScale)?_c('span',{staticClass:"loading"},[_c('pulse-loader',{attrs:{"size":'0.7em'}})],1):_c('div',[_vm._v("\n            Nenhuma escala encontrada, tente escolher outros parâmetros.\n          ")])]):_vm._l((_vm.scale),function(ref,index){
var uor_sigla = ref.uor_sigla;
var colaborador_nome = ref.colaborador_nome;
var colaborador_cargo = ref.colaborador_cargo;
var rest$1 = objectWithoutProperties( ref, ["uor_sigla", "colaborador_nome", "colaborador_cargo"] );
var rest = rest$1;
return _c('li',{key:index},[_c('div',[_c('span',[_vm._v(_vm._s(colaborador_cargo))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(colaborador_nome))])]),_vm._v(" "),_vm._l((_vm.week),function(ref){
var dayIndex = ref.dayIndex;
return _c('div',{key:dayIndex},_vm._l((rest[dayIndex]),function(time,index){return (rest.hasOwnProperty(dayIndex))?_c('div',{key:index},[(time.split('-')[0] !== '' && time.split('-')[1] !== '')?_c('p',[_vm._v("\n                "+_vm._s(time)+"\n              ")]):(time.split('-')[0] == '')?_c('p',[_c('font-awesome-icon',{staticStyle:{"margin-right":"8px"},attrs:{"icon":'arrow-alt-circle-right'}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(time.split('-')[1])+" ")])],1):_c('p',[_c('span',{staticStyle:{"margin-right":"8px"}},[_vm._v(_vm._s(time.split('-')[0]))]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":'arrow-alt-circle-right'}})],1)]):_vm._e()}),0)})],2)})],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('label',[_vm._v("Observação")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.observacao))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zX+d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    secretarias: {
      type: Array,
      required: true
    }
  },
  mounted: function mounted() {
    this.triggerPopover();
  },
  updated: function updated() {
    this.triggerPopover();
  },

  methods: {
    triggerPopover: function triggerPopover() {
      window.jQuery('[data-toggle="popover"]').popover({});
    }
  }
});

/***/ }),

/***/ "zXfg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.url}},[_c('div',{staticClass:"card card-lg card-grande"},[_c('div',{staticClass:"row header"},[_c('div',{staticClass:"col-xs-12"},[_c('h4',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"row body"},[_c('div',{staticClass:"col-xs-12"},[_c('span',[_vm._v(_vm._s(_vm.description))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zY2p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("vuGp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dad42e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("jqvm");
function injectStyle (ssrContext) {
  __webpack_require__("UM0c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dad42e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dad42e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zZs/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PorSecretaria_vue__ = __webpack_require__("R7GV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_387a1084_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PorSecretaria_vue__ = __webpack_require__("4D6M");
function injectStyle (ssrContext) {
  __webpack_require__("g2E0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-387a1084"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PorSecretaria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_387a1084_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PorSecretaria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zlqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request__ = __webpack_require__("OOvn");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'plano-governo-edit',
  inject: ["showConfirm"],
  props: ['id'],
  data: function data() {
    return {
      listas: {
        secretarias: [],
        autarquias: []
      },
      model: {
        titulo: '',
        descricao: '',
        periodo: '',
        unidade_executora: '',
        responsavel_sshd: '',
        data_conclusao: ''
      }
    };
  },
  created: function created() {
    this.loadCompromisso();
    this.loadUnidades();
  },
  mounted: function mounted() {
    this.$refs.periodo.focus();
  },

  computed: {
    isUpdate: function isUpdate() {
      return this.model.hasOwnProperty('codigo');
    },
    isAdd: function isAdd() {
      return !this.isUpdate;
    },
    urlToSave: function urlToSave() {
      return this.isUpdate ? 'planogoverno/update' : 'planogoverno/add';
    },
    selecionaMetas: function selecionaMetas() {
      return this.listas.metas.filter(function (i) {
        return i.selected;
      }).map(function (i) {
        return i.codigo;
      });
    }
  },
  methods: {
    loadCompromisso: function loadCompromisso() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('planogoverno/compromisso/' + _this.id);

              case 2:
                _ref = _context.sent;
                data = _ref.data;

                _this.model = data;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var unidade, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                unidade = _this2.model.unidade;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].put('planogoverno/compromisso', { unidade: unidade });

              case 3:
                response = _context2.sent;

                if (!(response.status != 201)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return', _this2.$toastr.e('Houve uma falha ao tentar salvar o compromisso.'));

              case 6:

                _this2.$toastr.s('O compromisso foi atualizado com sucesso.');
                _this2.$router.push({ name: 'admin_planogoverno' });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    homologar: function homologar() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref2, status;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].put('planogoverno/compromisso', { data_conclusao: new Date() });

              case 2:
                _ref2 = _context3.sent;
                status = _ref2.status;

                if (!(status != 201)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt('return', _this3.$toastr.e('Houve uma falha ao tentar homologar o compromisso.'));

              case 6:

                _this3.$toastr.s('O compromisso foi homologado com sucesso.');
                _this3.$router.push({ name: 'admin_planogoverno' });

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    loadUnidades: function loadUnidades() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref3, secretarias, _ref4, autarquias;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('listar-secretarias');

              case 2:
                _ref3 = _context4.sent;
                secretarias = _ref3.data.data;
                _context4.next = 6;
                return __WEBPACK_IMPORTED_MODULE_2__request__["a" /* request */].get('listar-autarquias');

              case 6:
                _ref4 = _context4.sent;
                autarquias = _ref4.data.data;


                _this4.listas.secretarias = secretarias;
                _this4.listas.autarquias = autarquias;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    statusClass: function statusClass(status) {
      switch (status) {
        case 'Não Iniciado':
          return 'status-n-iniciado';
        case 'Em andamento':
          return 'status-andamento';
        case 'Concluído':
          return 'status-concluido';
        case 'Cancelado':
          return 'status-cancelado';
        default:
          return 'status-n-iniciado';
      }
    }
  }
});

/***/ }),

/***/ "zmb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zqOz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmendasPorVereador_vue__ = __webpack_require__("nP6t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b9ed08a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmendasPorVereador_vue__ = __webpack_require__("d93A");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmendasPorVereador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b9ed08a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmendasPorVereador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zu7y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("/29v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1d3ea9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("zBJv");
function injectStyle (ssrContext) {
  __webpack_require__("tU0y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a1d3ea9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1d3ea9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c848a383f4af5addc05f.js